
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1ohhe", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $10356f2eee2d90cc$export$ffb0004e005737fa; }, function (v) { return $10356f2eee2d90cc$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $10356f2eee2d90cc$export$34b9dba7ce09269b; }, function (v) { return $10356f2eee2d90cc$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $10356f2eee2d90cc$export$25062201e9e25d76; }, function (v) { return $10356f2eee2d90cc$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $10356f2eee2d90cc$export$ffb0004e005737fa;
var $10356f2eee2d90cc$export$34b9dba7ce09269b;
var $10356f2eee2d90cc$export$25062201e9e25d76;
'use strict';

var $aEMJz = parcelRequire("aEMJz");
var $10356f2eee2d90cc$var$k = Symbol.for("react.element"), $10356f2eee2d90cc$var$l = Symbol.for("react.fragment"), $10356f2eee2d90cc$var$m = Object.prototype.hasOwnProperty, $10356f2eee2d90cc$var$n = $aEMJz.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $10356f2eee2d90cc$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $10356f2eee2d90cc$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$10356f2eee2d90cc$var$m.call(a, b) && !$10356f2eee2d90cc$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $10356f2eee2d90cc$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $10356f2eee2d90cc$var$n.current
    };
}
$10356f2eee2d90cc$export$ffb0004e005737fa = $10356f2eee2d90cc$var$l;
$10356f2eee2d90cc$export$34b9dba7ce09269b = $10356f2eee2d90cc$var$q;
$10356f2eee2d90cc$export$25062201e9e25d76 = $10356f2eee2d90cc$var$q;

});
parcelRegister("aEMJz", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gB01t"));

});
parcelRegister("gB01t", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $c1501e8a6a69fb42$export$dca3b0875bd9a954; }, function (v) { return $c1501e8a6a69fb42$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $c1501e8a6a69fb42$export$16fa2f45be04daa8; }, function (v) { return $c1501e8a6a69fb42$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $c1501e8a6a69fb42$export$ffb0004e005737fa; }, function (v) { return $c1501e8a6a69fb42$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $c1501e8a6a69fb42$export$e2c29f18771995cb; }, function (v) { return $c1501e8a6a69fb42$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $c1501e8a6a69fb42$export$221d75b3f55bb0bd; }, function (v) { return $c1501e8a6a69fb42$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c1501e8a6a69fb42$export$5f8d39834fd61797; }, function (v) { return $c1501e8a6a69fb42$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $c1501e8a6a69fb42$export$74bf444e3cd11ea5; }, function (v) { return $c1501e8a6a69fb42$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c1501e8a6a69fb42$export$ae55be85d98224ed; }, function (v) { return $c1501e8a6a69fb42$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $c1501e8a6a69fb42$export$3ba232387fd5d6dd; }, function (v) { return $c1501e8a6a69fb42$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $c1501e8a6a69fb42$export$e530037191fcd5d7; }, function (v) { return $c1501e8a6a69fb42$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $c1501e8a6a69fb42$export$fd42f52fd3ae1109; }, function (v) { return $c1501e8a6a69fb42$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $c1501e8a6a69fb42$export$c8a8987d4410bf2d; }, function (v) { return $c1501e8a6a69fb42$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $c1501e8a6a69fb42$export$d38cd72104c1f0e9; }, function (v) { return $c1501e8a6a69fb42$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $c1501e8a6a69fb42$export$7d1e3a5e95ceca43; }, function (v) { return $c1501e8a6a69fb42$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $c1501e8a6a69fb42$export$257a8862b851cb5b; }, function (v) { return $c1501e8a6a69fb42$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $c1501e8a6a69fb42$export$a8257692ac88316c; }, function (v) { return $c1501e8a6a69fb42$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $c1501e8a6a69fb42$export$488013bae63b21da; }, function (v) { return $c1501e8a6a69fb42$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $c1501e8a6a69fb42$export$7c73462e0d25e514; }, function (v) { return $c1501e8a6a69fb42$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $c1501e8a6a69fb42$export$7568632d0d33d16d; }, function (v) { return $c1501e8a6a69fb42$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $c1501e8a6a69fb42$export$88948ce120ea2619; }, function (v) { return $c1501e8a6a69fb42$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $c1501e8a6a69fb42$export$35808ee640e87ca7; }, function (v) { return $c1501e8a6a69fb42$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $c1501e8a6a69fb42$export$fae74005e78b1a27; }, function (v) { return $c1501e8a6a69fb42$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $c1501e8a6a69fb42$export$dc8fbce3eb94dc1e; }, function (v) { return $c1501e8a6a69fb42$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $c1501e8a6a69fb42$export$6a7bc4e911dc01cf; }, function (v) { return $c1501e8a6a69fb42$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $c1501e8a6a69fb42$export$6d9c69b0de29b591; }, function (v) { return $c1501e8a6a69fb42$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $c1501e8a6a69fb42$export$f680877a34711e37; }, function (v) { return $c1501e8a6a69fb42$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $c1501e8a6a69fb42$export$d5a552a76deda3c2; }, function (v) { return $c1501e8a6a69fb42$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $c1501e8a6a69fb42$export$aaabe4eda9ed9969; }, function (v) { return $c1501e8a6a69fb42$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $c1501e8a6a69fb42$export$e5c5a5f917a5871c; }, function (v) { return $c1501e8a6a69fb42$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $c1501e8a6a69fb42$export$1538c33de8887b59; }, function (v) { return $c1501e8a6a69fb42$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $c1501e8a6a69fb42$export$13e3392192263954; }, function (v) { return $c1501e8a6a69fb42$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $c1501e8a6a69fb42$export$b8f5890fc79d6aca; }, function (v) { return $c1501e8a6a69fb42$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $c1501e8a6a69fb42$export$60241385465d0a34; }, function (v) { return $c1501e8a6a69fb42$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $c1501e8a6a69fb42$export$306c0aa65ff9ec16; }, function (v) { return $c1501e8a6a69fb42$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $c1501e8a6a69fb42$export$7b286972b8d8ccbf; }, function (v) { return $c1501e8a6a69fb42$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $c1501e8a6a69fb42$export$83d89fbfd8236492; }, function (v) { return $c1501e8a6a69fb42$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c1501e8a6a69fb42$export$dca3b0875bd9a954;
var $c1501e8a6a69fb42$export$16fa2f45be04daa8;
var $c1501e8a6a69fb42$export$ffb0004e005737fa;
var $c1501e8a6a69fb42$export$e2c29f18771995cb;
var $c1501e8a6a69fb42$export$221d75b3f55bb0bd;
var $c1501e8a6a69fb42$export$5f8d39834fd61797;
var $c1501e8a6a69fb42$export$74bf444e3cd11ea5;
var $c1501e8a6a69fb42$export$ae55be85d98224ed;
var $c1501e8a6a69fb42$export$3ba232387fd5d6dd;
var $c1501e8a6a69fb42$export$e530037191fcd5d7;
var $c1501e8a6a69fb42$export$fd42f52fd3ae1109;
var $c1501e8a6a69fb42$export$c8a8987d4410bf2d;
var $c1501e8a6a69fb42$export$d38cd72104c1f0e9;
var $c1501e8a6a69fb42$export$7d1e3a5e95ceca43;
var $c1501e8a6a69fb42$export$257a8862b851cb5b;
var $c1501e8a6a69fb42$export$a8257692ac88316c;
var $c1501e8a6a69fb42$export$488013bae63b21da;
var $c1501e8a6a69fb42$export$7c73462e0d25e514;
var $c1501e8a6a69fb42$export$7568632d0d33d16d;
var $c1501e8a6a69fb42$export$88948ce120ea2619;
var $c1501e8a6a69fb42$export$35808ee640e87ca7;
var $c1501e8a6a69fb42$export$fae74005e78b1a27;
var $c1501e8a6a69fb42$export$dc8fbce3eb94dc1e;
var $c1501e8a6a69fb42$export$6a7bc4e911dc01cf;
var $c1501e8a6a69fb42$export$6d9c69b0de29b591;
var $c1501e8a6a69fb42$export$f680877a34711e37;
var $c1501e8a6a69fb42$export$d5a552a76deda3c2;
var $c1501e8a6a69fb42$export$aaabe4eda9ed9969;
var $c1501e8a6a69fb42$export$e5c5a5f917a5871c;
var $c1501e8a6a69fb42$export$1538c33de8887b59;
var $c1501e8a6a69fb42$export$13e3392192263954;
var $c1501e8a6a69fb42$export$b8f5890fc79d6aca;
var $c1501e8a6a69fb42$export$60241385465d0a34;
var $c1501e8a6a69fb42$export$306c0aa65ff9ec16;
var $c1501e8a6a69fb42$export$7b286972b8d8ccbf;
var $c1501e8a6a69fb42$export$83d89fbfd8236492;
'use strict';
var $c1501e8a6a69fb42$var$l = Symbol.for("react.element"), $c1501e8a6a69fb42$var$n = Symbol.for("react.portal"), $c1501e8a6a69fb42$var$p = Symbol.for("react.fragment"), $c1501e8a6a69fb42$var$q = Symbol.for("react.strict_mode"), $c1501e8a6a69fb42$var$r = Symbol.for("react.profiler"), $c1501e8a6a69fb42$var$t = Symbol.for("react.provider"), $c1501e8a6a69fb42$var$u = Symbol.for("react.context"), $c1501e8a6a69fb42$var$v = Symbol.for("react.forward_ref"), $c1501e8a6a69fb42$var$w = Symbol.for("react.suspense"), $c1501e8a6a69fb42$var$x = Symbol.for("react.memo"), $c1501e8a6a69fb42$var$y = Symbol.for("react.lazy"), $c1501e8a6a69fb42$var$z = Symbol.iterator;
function $c1501e8a6a69fb42$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c1501e8a6a69fb42$var$z && a[$c1501e8a6a69fb42$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c1501e8a6a69fb42$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $c1501e8a6a69fb42$var$C = Object.assign, $c1501e8a6a69fb42$var$D = {};
function $c1501e8a6a69fb42$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c1501e8a6a69fb42$var$D;
    this.updater = e || $c1501e8a6a69fb42$var$B;
}
$c1501e8a6a69fb42$var$E.prototype.isReactComponent = {};
$c1501e8a6a69fb42$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$c1501e8a6a69fb42$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $c1501e8a6a69fb42$var$F() {}
$c1501e8a6a69fb42$var$F.prototype = $c1501e8a6a69fb42$var$E.prototype;
function $c1501e8a6a69fb42$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c1501e8a6a69fb42$var$D;
    this.updater = e || $c1501e8a6a69fb42$var$B;
}
var $c1501e8a6a69fb42$var$H = $c1501e8a6a69fb42$var$G.prototype = new $c1501e8a6a69fb42$var$F;
$c1501e8a6a69fb42$var$H.constructor = $c1501e8a6a69fb42$var$G;
$c1501e8a6a69fb42$var$C($c1501e8a6a69fb42$var$H, $c1501e8a6a69fb42$var$E.prototype);
$c1501e8a6a69fb42$var$H.isPureReactComponent = !0;
var $c1501e8a6a69fb42$var$I = Array.isArray, $c1501e8a6a69fb42$var$J = Object.prototype.hasOwnProperty, $c1501e8a6a69fb42$var$K = {
    current: null
}, $c1501e8a6a69fb42$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c1501e8a6a69fb42$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$c1501e8a6a69fb42$var$J.call(b, d) && !$c1501e8a6a69fb42$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $c1501e8a6a69fb42$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $c1501e8a6a69fb42$var$K.current
    };
}
function $c1501e8a6a69fb42$var$N(a, b) {
    return {
        $$typeof: $c1501e8a6a69fb42$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $c1501e8a6a69fb42$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c1501e8a6a69fb42$var$l;
}
function $c1501e8a6a69fb42$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $c1501e8a6a69fb42$var$P = /\/+/g;
function $c1501e8a6a69fb42$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $c1501e8a6a69fb42$var$escape("" + a.key) : b.toString(36);
}
function $c1501e8a6a69fb42$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $c1501e8a6a69fb42$var$l:
                case $c1501e8a6a69fb42$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $c1501e8a6a69fb42$var$Q(h, 0) : d, $c1501e8a6a69fb42$var$I(c) ? (e = "", null != a && (e = a.replace($c1501e8a6a69fb42$var$P, "$&/") + "/"), $c1501e8a6a69fb42$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($c1501e8a6a69fb42$var$O(c) && (c = $c1501e8a6a69fb42$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($c1501e8a6a69fb42$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($c1501e8a6a69fb42$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $c1501e8a6a69fb42$var$Q(k, g);
        h += $c1501e8a6a69fb42$var$R(k, b, e, f, c);
    }
    else if (f = $c1501e8a6a69fb42$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $c1501e8a6a69fb42$var$Q(k, g++), h += $c1501e8a6a69fb42$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $c1501e8a6a69fb42$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $c1501e8a6a69fb42$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $c1501e8a6a69fb42$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $c1501e8a6a69fb42$var$U = {
    current: null
}, $c1501e8a6a69fb42$var$V = {
    transition: null
}, $c1501e8a6a69fb42$var$W = {
    ReactCurrentDispatcher: $c1501e8a6a69fb42$var$U,
    ReactCurrentBatchConfig: $c1501e8a6a69fb42$var$V,
    ReactCurrentOwner: $c1501e8a6a69fb42$var$K
};
function $c1501e8a6a69fb42$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$c1501e8a6a69fb42$export$dca3b0875bd9a954 = {
    map: $c1501e8a6a69fb42$var$S,
    forEach: function(a, b, e) {
        $c1501e8a6a69fb42$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $c1501e8a6a69fb42$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $c1501e8a6a69fb42$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$c1501e8a6a69fb42$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$c1501e8a6a69fb42$export$16fa2f45be04daa8 = $c1501e8a6a69fb42$var$E;
$c1501e8a6a69fb42$export$ffb0004e005737fa = $c1501e8a6a69fb42$var$p;
$c1501e8a6a69fb42$export$e2c29f18771995cb = $c1501e8a6a69fb42$var$r;
$c1501e8a6a69fb42$export$221d75b3f55bb0bd = $c1501e8a6a69fb42$var$G;
$c1501e8a6a69fb42$export$5f8d39834fd61797 = $c1501e8a6a69fb42$var$q;
$c1501e8a6a69fb42$export$74bf444e3cd11ea5 = $c1501e8a6a69fb42$var$w;
$c1501e8a6a69fb42$export$ae55be85d98224ed = $c1501e8a6a69fb42$var$W;
$c1501e8a6a69fb42$export$3ba232387fd5d6dd = $c1501e8a6a69fb42$var$X;
$c1501e8a6a69fb42$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $c1501e8a6a69fb42$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $c1501e8a6a69fb42$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$c1501e8a6a69fb42$var$J.call(b, f) && !$c1501e8a6a69fb42$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $c1501e8a6a69fb42$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$c1501e8a6a69fb42$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $c1501e8a6a69fb42$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $c1501e8a6a69fb42$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$c1501e8a6a69fb42$export$c8a8987d4410bf2d = $c1501e8a6a69fb42$var$M;
$c1501e8a6a69fb42$export$d38cd72104c1f0e9 = function(a) {
    var b = $c1501e8a6a69fb42$var$M.bind(null, a);
    b.type = a;
    return b;
};
$c1501e8a6a69fb42$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$c1501e8a6a69fb42$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $c1501e8a6a69fb42$var$v,
        render: a
    };
};
$c1501e8a6a69fb42$export$a8257692ac88316c = $c1501e8a6a69fb42$var$O;
$c1501e8a6a69fb42$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $c1501e8a6a69fb42$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $c1501e8a6a69fb42$var$T
    };
};
$c1501e8a6a69fb42$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $c1501e8a6a69fb42$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$c1501e8a6a69fb42$export$7568632d0d33d16d = function(a) {
    var b = $c1501e8a6a69fb42$var$V.transition;
    $c1501e8a6a69fb42$var$V.transition = {};
    try {
        a();
    } finally{
        $c1501e8a6a69fb42$var$V.transition = b;
    }
};
$c1501e8a6a69fb42$export$88948ce120ea2619 = $c1501e8a6a69fb42$var$X;
$c1501e8a6a69fb42$export$35808ee640e87ca7 = function(a, b) {
    return $c1501e8a6a69fb42$var$U.current.useCallback(a, b);
};
$c1501e8a6a69fb42$export$fae74005e78b1a27 = function(a) {
    return $c1501e8a6a69fb42$var$U.current.useContext(a);
};
$c1501e8a6a69fb42$export$dc8fbce3eb94dc1e = function() {};
$c1501e8a6a69fb42$export$6a7bc4e911dc01cf = function(a) {
    return $c1501e8a6a69fb42$var$U.current.useDeferredValue(a);
};
$c1501e8a6a69fb42$export$6d9c69b0de29b591 = function(a, b) {
    return $c1501e8a6a69fb42$var$U.current.useEffect(a, b);
};
$c1501e8a6a69fb42$export$f680877a34711e37 = function() {
    return $c1501e8a6a69fb42$var$U.current.useId();
};
$c1501e8a6a69fb42$export$d5a552a76deda3c2 = function(a, b, e) {
    return $c1501e8a6a69fb42$var$U.current.useImperativeHandle(a, b, e);
};
$c1501e8a6a69fb42$export$aaabe4eda9ed9969 = function(a, b) {
    return $c1501e8a6a69fb42$var$U.current.useInsertionEffect(a, b);
};
$c1501e8a6a69fb42$export$e5c5a5f917a5871c = function(a, b) {
    return $c1501e8a6a69fb42$var$U.current.useLayoutEffect(a, b);
};
$c1501e8a6a69fb42$export$1538c33de8887b59 = function(a, b) {
    return $c1501e8a6a69fb42$var$U.current.useMemo(a, b);
};
$c1501e8a6a69fb42$export$13e3392192263954 = function(a, b, e) {
    return $c1501e8a6a69fb42$var$U.current.useReducer(a, b, e);
};
$c1501e8a6a69fb42$export$b8f5890fc79d6aca = function(a) {
    return $c1501e8a6a69fb42$var$U.current.useRef(a);
};
$c1501e8a6a69fb42$export$60241385465d0a34 = function(a) {
    return $c1501e8a6a69fb42$var$U.current.useState(a);
};
$c1501e8a6a69fb42$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $c1501e8a6a69fb42$var$U.current.useSyncExternalStore(a, b, e);
};
$c1501e8a6a69fb42$export$7b286972b8d8ccbf = function() {
    return $c1501e8a6a69fb42$var$U.current.useTransition();
};
$c1501e8a6a69fb42$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("f1oJI", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $aefa23277c986a08$export$ae55be85d98224ed; }, function (v) { return $aefa23277c986a08$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $aefa23277c986a08$export$d39a5bbd09211389; }, function (v) { return $aefa23277c986a08$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $aefa23277c986a08$export$882461b6382ed46c; }, function (v) { return $aefa23277c986a08$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $aefa23277c986a08$export$466bfc07425424d5; }, function (v) { return $aefa23277c986a08$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $aefa23277c986a08$export$cd75ccfd720a3cd4; }, function (v) { return $aefa23277c986a08$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $aefa23277c986a08$export$fa8d919ba61d84db; }, function (v) { return $aefa23277c986a08$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $aefa23277c986a08$export$757ceba2d55c277e; }, function (v) { return $aefa23277c986a08$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $aefa23277c986a08$export$b3890eb0ae9dca99; }, function (v) { return $aefa23277c986a08$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $aefa23277c986a08$export$502457920280e6be; }, function (v) { return $aefa23277c986a08$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $aefa23277c986a08$export$c78a37762a8d58e1; }, function (v) { return $aefa23277c986a08$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $aefa23277c986a08$export$dc54d992c10e8a18; }, function (v) { return $aefa23277c986a08$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $aefa23277c986a08$export$83d89fbfd8236492; }, function (v) { return $aefa23277c986a08$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $aefa23277c986a08$export$ae55be85d98224ed;
var $aefa23277c986a08$export$d39a5bbd09211389;
var $aefa23277c986a08$export$882461b6382ed46c;
var $aefa23277c986a08$export$466bfc07425424d5;
var $aefa23277c986a08$export$cd75ccfd720a3cd4;
var $aefa23277c986a08$export$fa8d919ba61d84db;
var $aefa23277c986a08$export$757ceba2d55c277e;
var $aefa23277c986a08$export$b3890eb0ae9dca99;
var $aefa23277c986a08$export$502457920280e6be;
var $aefa23277c986a08$export$c78a37762a8d58e1;
var $aefa23277c986a08$export$dc54d992c10e8a18;
var $aefa23277c986a08$export$83d89fbfd8236492;
'use strict';

var $aEMJz = parcelRequire("aEMJz");

var $8fzia = parcelRequire("8fzia");
function $aefa23277c986a08$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $aefa23277c986a08$var$da = new Set, $aefa23277c986a08$var$ea = {};
function $aefa23277c986a08$var$fa(a, b) {
    $aefa23277c986a08$var$ha(a, b);
    $aefa23277c986a08$var$ha(a + "Capture", b);
}
function $aefa23277c986a08$var$ha(a, b) {
    $aefa23277c986a08$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$aefa23277c986a08$var$da.add(b[a]);
}
var $aefa23277c986a08$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $aefa23277c986a08$var$ja = Object.prototype.hasOwnProperty, $aefa23277c986a08$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $aefa23277c986a08$var$la = {}, $aefa23277c986a08$var$ma = {};
function $aefa23277c986a08$var$oa(a) {
    if ($aefa23277c986a08$var$ja.call($aefa23277c986a08$var$ma, a)) return !0;
    if ($aefa23277c986a08$var$ja.call($aefa23277c986a08$var$la, a)) return !1;
    if ($aefa23277c986a08$var$ka.test(a)) return $aefa23277c986a08$var$ma[a] = !0;
    $aefa23277c986a08$var$la[a] = !0;
    return !1;
}
function $aefa23277c986a08$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $aefa23277c986a08$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $aefa23277c986a08$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $aefa23277c986a08$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $aefa23277c986a08$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $aefa23277c986a08$var$z[a] = new $aefa23277c986a08$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $aefa23277c986a08$var$z[b] = new $aefa23277c986a08$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $aefa23277c986a08$var$z[a] = new $aefa23277c986a08$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $aefa23277c986a08$var$z[a] = new $aefa23277c986a08$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $aefa23277c986a08$var$z[a] = new $aefa23277c986a08$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $aefa23277c986a08$var$z[a] = new $aefa23277c986a08$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $aefa23277c986a08$var$z[a] = new $aefa23277c986a08$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $aefa23277c986a08$var$z[a] = new $aefa23277c986a08$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $aefa23277c986a08$var$z[a] = new $aefa23277c986a08$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $aefa23277c986a08$var$ra = /[\-:]([a-z])/g;
function $aefa23277c986a08$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($aefa23277c986a08$var$ra, $aefa23277c986a08$var$sa);
    $aefa23277c986a08$var$z[b] = new $aefa23277c986a08$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($aefa23277c986a08$var$ra, $aefa23277c986a08$var$sa);
    $aefa23277c986a08$var$z[b] = new $aefa23277c986a08$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($aefa23277c986a08$var$ra, $aefa23277c986a08$var$sa);
    $aefa23277c986a08$var$z[b] = new $aefa23277c986a08$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $aefa23277c986a08$var$z[a] = new $aefa23277c986a08$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$aefa23277c986a08$var$z.xlinkHref = new $aefa23277c986a08$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $aefa23277c986a08$var$z[a] = new $aefa23277c986a08$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $aefa23277c986a08$var$ta(a, b, c, d) {
    var e = $aefa23277c986a08$var$z.hasOwnProperty(b) ? $aefa23277c986a08$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $aefa23277c986a08$var$qa(b, c, e, d) && (c = null), d || null === e ? $aefa23277c986a08$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $aefa23277c986a08$var$ua = $aEMJz.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $aefa23277c986a08$var$va = Symbol.for("react.element"), $aefa23277c986a08$var$wa = Symbol.for("react.portal"), $aefa23277c986a08$var$ya = Symbol.for("react.fragment"), $aefa23277c986a08$var$za = Symbol.for("react.strict_mode"), $aefa23277c986a08$var$Aa = Symbol.for("react.profiler"), $aefa23277c986a08$var$Ba = Symbol.for("react.provider"), $aefa23277c986a08$var$Ca = Symbol.for("react.context"), $aefa23277c986a08$var$Da = Symbol.for("react.forward_ref"), $aefa23277c986a08$var$Ea = Symbol.for("react.suspense"), $aefa23277c986a08$var$Fa = Symbol.for("react.suspense_list"), $aefa23277c986a08$var$Ga = Symbol.for("react.memo"), $aefa23277c986a08$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $aefa23277c986a08$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $aefa23277c986a08$var$Ja = Symbol.iterator;
function $aefa23277c986a08$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $aefa23277c986a08$var$Ja && a[$aefa23277c986a08$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $aefa23277c986a08$var$A = Object.assign, $aefa23277c986a08$var$La;
function $aefa23277c986a08$var$Ma(a) {
    if (void 0 === $aefa23277c986a08$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $aefa23277c986a08$var$La = b && b[1] || "";
    }
    return "\n" + $aefa23277c986a08$var$La + a;
}
var $aefa23277c986a08$var$Na = !1;
function $aefa23277c986a08$var$Oa(a, b) {
    if (!a || $aefa23277c986a08$var$Na) return "";
    $aefa23277c986a08$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $aefa23277c986a08$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $aefa23277c986a08$var$Ma(a) : "";
}
function $aefa23277c986a08$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $aefa23277c986a08$var$Ma(a.type);
        case 16:
            return $aefa23277c986a08$var$Ma("Lazy");
        case 13:
            return $aefa23277c986a08$var$Ma("Suspense");
        case 19:
            return $aefa23277c986a08$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $aefa23277c986a08$var$Oa(a.type, !1), a;
        case 11:
            return a = $aefa23277c986a08$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $aefa23277c986a08$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $aefa23277c986a08$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $aefa23277c986a08$var$ya:
            return "Fragment";
        case $aefa23277c986a08$var$wa:
            return "Portal";
        case $aefa23277c986a08$var$Aa:
            return "Profiler";
        case $aefa23277c986a08$var$za:
            return "StrictMode";
        case $aefa23277c986a08$var$Ea:
            return "Suspense";
        case $aefa23277c986a08$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $aefa23277c986a08$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $aefa23277c986a08$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $aefa23277c986a08$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $aefa23277c986a08$var$Ga:
            return b = a.displayName || null, null !== b ? b : $aefa23277c986a08$var$Qa(a.type) || "Memo";
        case $aefa23277c986a08$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $aefa23277c986a08$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $aefa23277c986a08$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $aefa23277c986a08$var$Qa(b);
        case 8:
            return b === $aefa23277c986a08$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $aefa23277c986a08$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $aefa23277c986a08$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $aefa23277c986a08$var$Ua(a) {
    var b = $aefa23277c986a08$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $aefa23277c986a08$var$Va(a) {
    a._valueTracker || (a._valueTracker = $aefa23277c986a08$var$Ua(a));
}
function $aefa23277c986a08$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $aefa23277c986a08$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $aefa23277c986a08$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $aefa23277c986a08$var$Ya(a, b) {
    var c = b.checked;
    return $aefa23277c986a08$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $aefa23277c986a08$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $aefa23277c986a08$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $aefa23277c986a08$var$ab(a, b) {
    b = b.checked;
    null != b && $aefa23277c986a08$var$ta(a, "checked", b, !1);
}
function $aefa23277c986a08$var$bb(a, b) {
    $aefa23277c986a08$var$ab(a, b);
    var c = $aefa23277c986a08$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $aefa23277c986a08$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $aefa23277c986a08$var$cb(a, b.type, $aefa23277c986a08$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $aefa23277c986a08$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $aefa23277c986a08$var$cb(a, b, c) {
    if ("number" !== b || $aefa23277c986a08$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $aefa23277c986a08$var$eb = Array.isArray;
function $aefa23277c986a08$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $aefa23277c986a08$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $aefa23277c986a08$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($aefa23277c986a08$var$p(91));
    return $aefa23277c986a08$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $aefa23277c986a08$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($aefa23277c986a08$var$p(92));
            if ($aefa23277c986a08$var$eb(c)) {
                if (1 < c.length) throw Error($aefa23277c986a08$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $aefa23277c986a08$var$Sa(c)
    };
}
function $aefa23277c986a08$var$ib(a, b) {
    var c = $aefa23277c986a08$var$Sa(b.value), d = $aefa23277c986a08$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $aefa23277c986a08$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $aefa23277c986a08$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $aefa23277c986a08$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $aefa23277c986a08$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $aefa23277c986a08$var$mb, $aefa23277c986a08$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $aefa23277c986a08$var$mb = $aefa23277c986a08$var$mb || document.createElement("div");
        $aefa23277c986a08$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $aefa23277c986a08$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $aefa23277c986a08$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $aefa23277c986a08$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $aefa23277c986a08$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($aefa23277c986a08$var$pb).forEach(function(a) {
    $aefa23277c986a08$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $aefa23277c986a08$var$pb[b] = $aefa23277c986a08$var$pb[a];
    });
});
function $aefa23277c986a08$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $aefa23277c986a08$var$pb.hasOwnProperty(a) && $aefa23277c986a08$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $aefa23277c986a08$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $aefa23277c986a08$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $aefa23277c986a08$var$tb = $aefa23277c986a08$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $aefa23277c986a08$var$ub(a, b) {
    if (b) {
        if ($aefa23277c986a08$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($aefa23277c986a08$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($aefa23277c986a08$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($aefa23277c986a08$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($aefa23277c986a08$var$p(62));
    }
}
function $aefa23277c986a08$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $aefa23277c986a08$var$wb = null;
function $aefa23277c986a08$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $aefa23277c986a08$var$yb = null, $aefa23277c986a08$var$zb = null, $aefa23277c986a08$var$Ab = null;
function $aefa23277c986a08$var$Bb(a) {
    if (a = $aefa23277c986a08$var$Cb(a)) {
        if ("function" !== typeof $aefa23277c986a08$var$yb) throw Error($aefa23277c986a08$var$p(280));
        var b = a.stateNode;
        b && (b = $aefa23277c986a08$var$Db(b), $aefa23277c986a08$var$yb(a.stateNode, a.type, b));
    }
}
function $aefa23277c986a08$var$Eb(a) {
    $aefa23277c986a08$var$zb ? $aefa23277c986a08$var$Ab ? $aefa23277c986a08$var$Ab.push(a) : $aefa23277c986a08$var$Ab = [
        a
    ] : $aefa23277c986a08$var$zb = a;
}
function $aefa23277c986a08$var$Fb() {
    if ($aefa23277c986a08$var$zb) {
        var a = $aefa23277c986a08$var$zb, b = $aefa23277c986a08$var$Ab;
        $aefa23277c986a08$var$Ab = $aefa23277c986a08$var$zb = null;
        $aefa23277c986a08$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$aefa23277c986a08$var$Bb(b[a]);
    }
}
function $aefa23277c986a08$var$Gb(a, b) {
    return a(b);
}
function $aefa23277c986a08$var$Hb() {}
var $aefa23277c986a08$var$Ib = !1;
function $aefa23277c986a08$var$Jb(a, b, c) {
    if ($aefa23277c986a08$var$Ib) return a(b, c);
    $aefa23277c986a08$var$Ib = !0;
    try {
        return $aefa23277c986a08$var$Gb(a, b, c);
    } finally{
        if ($aefa23277c986a08$var$Ib = !1, null !== $aefa23277c986a08$var$zb || null !== $aefa23277c986a08$var$Ab) $aefa23277c986a08$var$Hb(), $aefa23277c986a08$var$Fb();
    }
}
function $aefa23277c986a08$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $aefa23277c986a08$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($aefa23277c986a08$var$p(231, b, typeof c));
    return c;
}
var $aefa23277c986a08$var$Lb = !1;
if ($aefa23277c986a08$var$ia) try {
    var $aefa23277c986a08$var$Mb = {};
    Object.defineProperty($aefa23277c986a08$var$Mb, "passive", {
        get: function() {
            $aefa23277c986a08$var$Lb = !0;
        }
    });
    window.addEventListener("test", $aefa23277c986a08$var$Mb, $aefa23277c986a08$var$Mb);
    window.removeEventListener("test", $aefa23277c986a08$var$Mb, $aefa23277c986a08$var$Mb);
} catch (a) {
    $aefa23277c986a08$var$Lb = !1;
}
function $aefa23277c986a08$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $aefa23277c986a08$var$Ob = !1, $aefa23277c986a08$var$Pb = null, $aefa23277c986a08$var$Qb = !1, $aefa23277c986a08$var$Rb = null, $aefa23277c986a08$var$Sb = {
    onError: function(a) {
        $aefa23277c986a08$var$Ob = !0;
        $aefa23277c986a08$var$Pb = a;
    }
};
function $aefa23277c986a08$var$Tb(a, b, c, d, e, f, g, h, k) {
    $aefa23277c986a08$var$Ob = !1;
    $aefa23277c986a08$var$Pb = null;
    $aefa23277c986a08$var$Nb.apply($aefa23277c986a08$var$Sb, arguments);
}
function $aefa23277c986a08$var$Ub(a, b, c, d, e, f, g, h, k) {
    $aefa23277c986a08$var$Tb.apply(this, arguments);
    if ($aefa23277c986a08$var$Ob) {
        if ($aefa23277c986a08$var$Ob) {
            var l = $aefa23277c986a08$var$Pb;
            $aefa23277c986a08$var$Ob = !1;
            $aefa23277c986a08$var$Pb = null;
        } else throw Error($aefa23277c986a08$var$p(198));
        $aefa23277c986a08$var$Qb || ($aefa23277c986a08$var$Qb = !0, $aefa23277c986a08$var$Rb = l);
    }
}
function $aefa23277c986a08$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $aefa23277c986a08$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $aefa23277c986a08$var$Xb(a) {
    if ($aefa23277c986a08$var$Vb(a) !== a) throw Error($aefa23277c986a08$var$p(188));
}
function $aefa23277c986a08$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $aefa23277c986a08$var$Vb(a);
        if (null === b) throw Error($aefa23277c986a08$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $aefa23277c986a08$var$Xb(e), a;
                if (f === d) return $aefa23277c986a08$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($aefa23277c986a08$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($aefa23277c986a08$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($aefa23277c986a08$var$p(190));
    }
    if (3 !== c.tag) throw Error($aefa23277c986a08$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $aefa23277c986a08$var$Zb(a) {
    a = $aefa23277c986a08$var$Yb(a);
    return null !== a ? $aefa23277c986a08$var$$b(a) : null;
}
function $aefa23277c986a08$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $aefa23277c986a08$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $aefa23277c986a08$var$ac = $8fzia.unstable_scheduleCallback, $aefa23277c986a08$var$bc = $8fzia.unstable_cancelCallback, $aefa23277c986a08$var$cc = $8fzia.unstable_shouldYield, $aefa23277c986a08$var$dc = $8fzia.unstable_requestPaint, $aefa23277c986a08$var$B = $8fzia.unstable_now, $aefa23277c986a08$var$ec = $8fzia.unstable_getCurrentPriorityLevel, $aefa23277c986a08$var$fc = $8fzia.unstable_ImmediatePriority, $aefa23277c986a08$var$gc = $8fzia.unstable_UserBlockingPriority, $aefa23277c986a08$var$hc = $8fzia.unstable_NormalPriority, $aefa23277c986a08$var$ic = $8fzia.unstable_LowPriority, $aefa23277c986a08$var$jc = $8fzia.unstable_IdlePriority, $aefa23277c986a08$var$kc = null, $aefa23277c986a08$var$lc = null;
function $aefa23277c986a08$var$mc(a) {
    if ($aefa23277c986a08$var$lc && "function" === typeof $aefa23277c986a08$var$lc.onCommitFiberRoot) try {
        $aefa23277c986a08$var$lc.onCommitFiberRoot($aefa23277c986a08$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $aefa23277c986a08$var$oc = Math.clz32 ? Math.clz32 : $aefa23277c986a08$var$nc, $aefa23277c986a08$var$pc = Math.log, $aefa23277c986a08$var$qc = Math.LN2;
function $aefa23277c986a08$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($aefa23277c986a08$var$pc(a) / $aefa23277c986a08$var$qc | 0) | 0;
}
var $aefa23277c986a08$var$rc = 64, $aefa23277c986a08$var$sc = 4194304;
function $aefa23277c986a08$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $aefa23277c986a08$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $aefa23277c986a08$var$tc(h) : (f &= g, 0 !== f && (d = $aefa23277c986a08$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $aefa23277c986a08$var$tc(g) : 0 !== f && (d = $aefa23277c986a08$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $aefa23277c986a08$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $aefa23277c986a08$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $aefa23277c986a08$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $aefa23277c986a08$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $aefa23277c986a08$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $aefa23277c986a08$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $aefa23277c986a08$var$yc() {
    var a = $aefa23277c986a08$var$rc;
    $aefa23277c986a08$var$rc <<= 1;
    0 === ($aefa23277c986a08$var$rc & 4194240) && ($aefa23277c986a08$var$rc = 64);
    return a;
}
function $aefa23277c986a08$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $aefa23277c986a08$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $aefa23277c986a08$var$oc(b);
    a[b] = c;
}
function $aefa23277c986a08$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $aefa23277c986a08$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $aefa23277c986a08$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $aefa23277c986a08$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $aefa23277c986a08$var$C = 0;
function $aefa23277c986a08$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $aefa23277c986a08$var$Ec, $aefa23277c986a08$var$Fc, $aefa23277c986a08$var$Gc, $aefa23277c986a08$var$Hc, $aefa23277c986a08$var$Ic, $aefa23277c986a08$var$Jc = !1, $aefa23277c986a08$var$Kc = [], $aefa23277c986a08$var$Lc = null, $aefa23277c986a08$var$Mc = null, $aefa23277c986a08$var$Nc = null, $aefa23277c986a08$var$Oc = new Map, $aefa23277c986a08$var$Pc = new Map, $aefa23277c986a08$var$Qc = [], $aefa23277c986a08$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $aefa23277c986a08$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $aefa23277c986a08$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $aefa23277c986a08$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $aefa23277c986a08$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $aefa23277c986a08$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $aefa23277c986a08$var$Pc.delete(b.pointerId);
    }
}
function $aefa23277c986a08$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $aefa23277c986a08$var$Cb(b), null !== b && $aefa23277c986a08$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $aefa23277c986a08$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $aefa23277c986a08$var$Lc = $aefa23277c986a08$var$Tc($aefa23277c986a08$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $aefa23277c986a08$var$Mc = $aefa23277c986a08$var$Tc($aefa23277c986a08$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $aefa23277c986a08$var$Nc = $aefa23277c986a08$var$Tc($aefa23277c986a08$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $aefa23277c986a08$var$Oc.set(f, $aefa23277c986a08$var$Tc($aefa23277c986a08$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $aefa23277c986a08$var$Pc.set(f, $aefa23277c986a08$var$Tc($aefa23277c986a08$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $aefa23277c986a08$var$Vc(a) {
    var b = $aefa23277c986a08$var$Wc(a.target);
    if (null !== b) {
        var c = $aefa23277c986a08$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $aefa23277c986a08$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $aefa23277c986a08$var$Ic(a.priority, function() {
                        $aefa23277c986a08$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $aefa23277c986a08$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $aefa23277c986a08$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $aefa23277c986a08$var$wb = d;
            c.target.dispatchEvent(d);
            $aefa23277c986a08$var$wb = null;
        } else return b = $aefa23277c986a08$var$Cb(c), null !== b && $aefa23277c986a08$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $aefa23277c986a08$var$Zc(a, b, c) {
    $aefa23277c986a08$var$Xc(a) && c.delete(b);
}
function $aefa23277c986a08$var$$c() {
    $aefa23277c986a08$var$Jc = !1;
    null !== $aefa23277c986a08$var$Lc && $aefa23277c986a08$var$Xc($aefa23277c986a08$var$Lc) && ($aefa23277c986a08$var$Lc = null);
    null !== $aefa23277c986a08$var$Mc && $aefa23277c986a08$var$Xc($aefa23277c986a08$var$Mc) && ($aefa23277c986a08$var$Mc = null);
    null !== $aefa23277c986a08$var$Nc && $aefa23277c986a08$var$Xc($aefa23277c986a08$var$Nc) && ($aefa23277c986a08$var$Nc = null);
    $aefa23277c986a08$var$Oc.forEach($aefa23277c986a08$var$Zc);
    $aefa23277c986a08$var$Pc.forEach($aefa23277c986a08$var$Zc);
}
function $aefa23277c986a08$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $aefa23277c986a08$var$Jc || ($aefa23277c986a08$var$Jc = !0, $8fzia.unstable_scheduleCallback($8fzia.unstable_NormalPriority, $aefa23277c986a08$var$$c)));
}
function $aefa23277c986a08$var$bd(a) {
    function b(b) {
        return $aefa23277c986a08$var$ad(b, a);
    }
    if (0 < $aefa23277c986a08$var$Kc.length) {
        $aefa23277c986a08$var$ad($aefa23277c986a08$var$Kc[0], a);
        for(var c = 1; c < $aefa23277c986a08$var$Kc.length; c++){
            var d = $aefa23277c986a08$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $aefa23277c986a08$var$Lc && $aefa23277c986a08$var$ad($aefa23277c986a08$var$Lc, a);
    null !== $aefa23277c986a08$var$Mc && $aefa23277c986a08$var$ad($aefa23277c986a08$var$Mc, a);
    null !== $aefa23277c986a08$var$Nc && $aefa23277c986a08$var$ad($aefa23277c986a08$var$Nc, a);
    $aefa23277c986a08$var$Oc.forEach(b);
    $aefa23277c986a08$var$Pc.forEach(b);
    for(c = 0; c < $aefa23277c986a08$var$Qc.length; c++)d = $aefa23277c986a08$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $aefa23277c986a08$var$Qc.length && (c = $aefa23277c986a08$var$Qc[0], null === c.blockedOn);)$aefa23277c986a08$var$Vc(c), null === c.blockedOn && $aefa23277c986a08$var$Qc.shift();
}
var $aefa23277c986a08$var$cd = $aefa23277c986a08$var$ua.ReactCurrentBatchConfig, $aefa23277c986a08$var$dd = !0;
function $aefa23277c986a08$var$ed(a, b, c, d) {
    var e = $aefa23277c986a08$var$C, f = $aefa23277c986a08$var$cd.transition;
    $aefa23277c986a08$var$cd.transition = null;
    try {
        $aefa23277c986a08$var$C = 1, $aefa23277c986a08$var$fd(a, b, c, d);
    } finally{
        $aefa23277c986a08$var$C = e, $aefa23277c986a08$var$cd.transition = f;
    }
}
function $aefa23277c986a08$var$gd(a, b, c, d) {
    var e = $aefa23277c986a08$var$C, f = $aefa23277c986a08$var$cd.transition;
    $aefa23277c986a08$var$cd.transition = null;
    try {
        $aefa23277c986a08$var$C = 4, $aefa23277c986a08$var$fd(a, b, c, d);
    } finally{
        $aefa23277c986a08$var$C = e, $aefa23277c986a08$var$cd.transition = f;
    }
}
function $aefa23277c986a08$var$fd(a, b, c, d) {
    if ($aefa23277c986a08$var$dd) {
        var e = $aefa23277c986a08$var$Yc(a, b, c, d);
        if (null === e) $aefa23277c986a08$var$hd(a, b, d, $aefa23277c986a08$var$id, c), $aefa23277c986a08$var$Sc(a, d);
        else if ($aefa23277c986a08$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($aefa23277c986a08$var$Sc(a, d), b & 4 && -1 < $aefa23277c986a08$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $aefa23277c986a08$var$Cb(e);
                null !== f && $aefa23277c986a08$var$Ec(f);
                f = $aefa23277c986a08$var$Yc(a, b, c, d);
                null === f && $aefa23277c986a08$var$hd(a, b, d, $aefa23277c986a08$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $aefa23277c986a08$var$hd(a, b, d, null, c);
    }
}
var $aefa23277c986a08$var$id = null;
function $aefa23277c986a08$var$Yc(a, b, c, d) {
    $aefa23277c986a08$var$id = null;
    a = $aefa23277c986a08$var$xb(d);
    a = $aefa23277c986a08$var$Wc(a);
    if (null !== a) {
        if (b = $aefa23277c986a08$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $aefa23277c986a08$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $aefa23277c986a08$var$id = a;
    return null;
}
function $aefa23277c986a08$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($aefa23277c986a08$var$ec()){
                case $aefa23277c986a08$var$fc:
                    return 1;
                case $aefa23277c986a08$var$gc:
                    return 4;
                case $aefa23277c986a08$var$hc:
                case $aefa23277c986a08$var$ic:
                    return 16;
                case $aefa23277c986a08$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $aefa23277c986a08$var$kd = null, $aefa23277c986a08$var$ld = null, $aefa23277c986a08$var$md = null;
function $aefa23277c986a08$var$nd() {
    if ($aefa23277c986a08$var$md) return $aefa23277c986a08$var$md;
    var a, b = $aefa23277c986a08$var$ld, c = b.length, d, e = "value" in $aefa23277c986a08$var$kd ? $aefa23277c986a08$var$kd.value : $aefa23277c986a08$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $aefa23277c986a08$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $aefa23277c986a08$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $aefa23277c986a08$var$pd() {
    return !0;
}
function $aefa23277c986a08$var$qd() {
    return !1;
}
function $aefa23277c986a08$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $aefa23277c986a08$var$pd : $aefa23277c986a08$var$qd;
        this.isPropagationStopped = $aefa23277c986a08$var$qd;
        return this;
    }
    $aefa23277c986a08$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $aefa23277c986a08$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $aefa23277c986a08$var$pd);
        },
        persist: function() {},
        isPersistent: $aefa23277c986a08$var$pd
    });
    return b;
}
var $aefa23277c986a08$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $aefa23277c986a08$var$td = $aefa23277c986a08$var$rd($aefa23277c986a08$var$sd), $aefa23277c986a08$var$ud = $aefa23277c986a08$var$A({}, $aefa23277c986a08$var$sd, {
    view: 0,
    detail: 0
}), $aefa23277c986a08$var$vd = $aefa23277c986a08$var$rd($aefa23277c986a08$var$ud), $aefa23277c986a08$var$wd, $aefa23277c986a08$var$xd, $aefa23277c986a08$var$yd, $aefa23277c986a08$var$Ad = $aefa23277c986a08$var$A({}, $aefa23277c986a08$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $aefa23277c986a08$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $aefa23277c986a08$var$yd && ($aefa23277c986a08$var$yd && "mousemove" === a.type ? ($aefa23277c986a08$var$wd = a.screenX - $aefa23277c986a08$var$yd.screenX, $aefa23277c986a08$var$xd = a.screenY - $aefa23277c986a08$var$yd.screenY) : $aefa23277c986a08$var$xd = $aefa23277c986a08$var$wd = 0, $aefa23277c986a08$var$yd = a);
        return $aefa23277c986a08$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $aefa23277c986a08$var$xd;
    }
}), $aefa23277c986a08$var$Bd = $aefa23277c986a08$var$rd($aefa23277c986a08$var$Ad), $aefa23277c986a08$var$Cd = $aefa23277c986a08$var$A({}, $aefa23277c986a08$var$Ad, {
    dataTransfer: 0
}), $aefa23277c986a08$var$Dd = $aefa23277c986a08$var$rd($aefa23277c986a08$var$Cd), $aefa23277c986a08$var$Ed = $aefa23277c986a08$var$A({}, $aefa23277c986a08$var$ud, {
    relatedTarget: 0
}), $aefa23277c986a08$var$Fd = $aefa23277c986a08$var$rd($aefa23277c986a08$var$Ed), $aefa23277c986a08$var$Gd = $aefa23277c986a08$var$A({}, $aefa23277c986a08$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $aefa23277c986a08$var$Hd = $aefa23277c986a08$var$rd($aefa23277c986a08$var$Gd), $aefa23277c986a08$var$Id = $aefa23277c986a08$var$A({}, $aefa23277c986a08$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $aefa23277c986a08$var$Jd = $aefa23277c986a08$var$rd($aefa23277c986a08$var$Id), $aefa23277c986a08$var$Kd = $aefa23277c986a08$var$A({}, $aefa23277c986a08$var$sd, {
    data: 0
}), $aefa23277c986a08$var$Ld = $aefa23277c986a08$var$rd($aefa23277c986a08$var$Kd), $aefa23277c986a08$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $aefa23277c986a08$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $aefa23277c986a08$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $aefa23277c986a08$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $aefa23277c986a08$var$Od[a]) ? !!b[a] : !1;
}
function $aefa23277c986a08$var$zd() {
    return $aefa23277c986a08$var$Pd;
}
var $aefa23277c986a08$var$Qd = $aefa23277c986a08$var$A({}, $aefa23277c986a08$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $aefa23277c986a08$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $aefa23277c986a08$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $aefa23277c986a08$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $aefa23277c986a08$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $aefa23277c986a08$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $aefa23277c986a08$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $aefa23277c986a08$var$Rd = $aefa23277c986a08$var$rd($aefa23277c986a08$var$Qd), $aefa23277c986a08$var$Sd = $aefa23277c986a08$var$A({}, $aefa23277c986a08$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $aefa23277c986a08$var$Td = $aefa23277c986a08$var$rd($aefa23277c986a08$var$Sd), $aefa23277c986a08$var$Ud = $aefa23277c986a08$var$A({}, $aefa23277c986a08$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $aefa23277c986a08$var$zd
}), $aefa23277c986a08$var$Vd = $aefa23277c986a08$var$rd($aefa23277c986a08$var$Ud), $aefa23277c986a08$var$Wd = $aefa23277c986a08$var$A({}, $aefa23277c986a08$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $aefa23277c986a08$var$Xd = $aefa23277c986a08$var$rd($aefa23277c986a08$var$Wd), $aefa23277c986a08$var$Yd = $aefa23277c986a08$var$A({}, $aefa23277c986a08$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $aefa23277c986a08$var$Zd = $aefa23277c986a08$var$rd($aefa23277c986a08$var$Yd), $aefa23277c986a08$var$$d = [
    9,
    13,
    27,
    32
], $aefa23277c986a08$var$ae = $aefa23277c986a08$var$ia && "CompositionEvent" in window, $aefa23277c986a08$var$be = null;
$aefa23277c986a08$var$ia && "documentMode" in document && ($aefa23277c986a08$var$be = document.documentMode);
var $aefa23277c986a08$var$ce = $aefa23277c986a08$var$ia && "TextEvent" in window && !$aefa23277c986a08$var$be, $aefa23277c986a08$var$de = $aefa23277c986a08$var$ia && (!$aefa23277c986a08$var$ae || $aefa23277c986a08$var$be && 8 < $aefa23277c986a08$var$be && 11 >= $aefa23277c986a08$var$be), $aefa23277c986a08$var$ee = String.fromCharCode(32), $aefa23277c986a08$var$fe = !1;
function $aefa23277c986a08$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $aefa23277c986a08$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $aefa23277c986a08$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $aefa23277c986a08$var$ie = !1;
function $aefa23277c986a08$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $aefa23277c986a08$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $aefa23277c986a08$var$fe = !0;
            return $aefa23277c986a08$var$ee;
        case "textInput":
            return a = b.data, a === $aefa23277c986a08$var$ee && $aefa23277c986a08$var$fe ? null : a;
        default:
            return null;
    }
}
function $aefa23277c986a08$var$ke(a, b) {
    if ($aefa23277c986a08$var$ie) return "compositionend" === a || !$aefa23277c986a08$var$ae && $aefa23277c986a08$var$ge(a, b) ? (a = $aefa23277c986a08$var$nd(), $aefa23277c986a08$var$md = $aefa23277c986a08$var$ld = $aefa23277c986a08$var$kd = null, $aefa23277c986a08$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $aefa23277c986a08$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $aefa23277c986a08$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $aefa23277c986a08$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$aefa23277c986a08$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $aefa23277c986a08$var$ne(a, b, c, d) {
    $aefa23277c986a08$var$Eb(d);
    b = $aefa23277c986a08$var$oe(b, "onChange");
    0 < b.length && (c = new $aefa23277c986a08$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $aefa23277c986a08$var$pe = null, $aefa23277c986a08$var$qe = null;
function $aefa23277c986a08$var$re(a) {
    $aefa23277c986a08$var$se(a, 0);
}
function $aefa23277c986a08$var$te(a) {
    var b = $aefa23277c986a08$var$ue(a);
    if ($aefa23277c986a08$var$Wa(b)) return a;
}
function $aefa23277c986a08$var$ve(a, b) {
    if ("change" === a) return b;
}
var $aefa23277c986a08$var$we = !1;
if ($aefa23277c986a08$var$ia) {
    var $aefa23277c986a08$var$xe;
    if ($aefa23277c986a08$var$ia) {
        var $aefa23277c986a08$var$ye = "oninput" in document;
        if (!$aefa23277c986a08$var$ye) {
            var $aefa23277c986a08$var$ze = document.createElement("div");
            $aefa23277c986a08$var$ze.setAttribute("oninput", "return;");
            $aefa23277c986a08$var$ye = "function" === typeof $aefa23277c986a08$var$ze.oninput;
        }
        $aefa23277c986a08$var$xe = $aefa23277c986a08$var$ye;
    } else $aefa23277c986a08$var$xe = !1;
    $aefa23277c986a08$var$we = $aefa23277c986a08$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $aefa23277c986a08$var$Ae() {
    $aefa23277c986a08$var$pe && ($aefa23277c986a08$var$pe.detachEvent("onpropertychange", $aefa23277c986a08$var$Be), $aefa23277c986a08$var$qe = $aefa23277c986a08$var$pe = null);
}
function $aefa23277c986a08$var$Be(a) {
    if ("value" === a.propertyName && $aefa23277c986a08$var$te($aefa23277c986a08$var$qe)) {
        var b = [];
        $aefa23277c986a08$var$ne(b, $aefa23277c986a08$var$qe, a, $aefa23277c986a08$var$xb(a));
        $aefa23277c986a08$var$Jb($aefa23277c986a08$var$re, b);
    }
}
function $aefa23277c986a08$var$Ce(a, b, c) {
    "focusin" === a ? ($aefa23277c986a08$var$Ae(), $aefa23277c986a08$var$pe = b, $aefa23277c986a08$var$qe = c, $aefa23277c986a08$var$pe.attachEvent("onpropertychange", $aefa23277c986a08$var$Be)) : "focusout" === a && $aefa23277c986a08$var$Ae();
}
function $aefa23277c986a08$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $aefa23277c986a08$var$te($aefa23277c986a08$var$qe);
}
function $aefa23277c986a08$var$Ee(a, b) {
    if ("click" === a) return $aefa23277c986a08$var$te(b);
}
function $aefa23277c986a08$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $aefa23277c986a08$var$te(b);
}
function $aefa23277c986a08$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $aefa23277c986a08$var$He = "function" === typeof Object.is ? Object.is : $aefa23277c986a08$var$Ge;
function $aefa23277c986a08$var$Ie(a, b) {
    if ($aefa23277c986a08$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$aefa23277c986a08$var$ja.call(b, e) || !$aefa23277c986a08$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $aefa23277c986a08$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $aefa23277c986a08$var$Ke(a, b) {
    var c = $aefa23277c986a08$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $aefa23277c986a08$var$Je(c);
    }
}
function $aefa23277c986a08$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $aefa23277c986a08$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $aefa23277c986a08$var$Me() {
    for(var a = window, b = $aefa23277c986a08$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $aefa23277c986a08$var$Xa(a.document);
    }
    return b;
}
function $aefa23277c986a08$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $aefa23277c986a08$var$Oe(a) {
    var b = $aefa23277c986a08$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $aefa23277c986a08$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $aefa23277c986a08$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $aefa23277c986a08$var$Ke(c, f);
                var g = $aefa23277c986a08$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $aefa23277c986a08$var$Pe = $aefa23277c986a08$var$ia && "documentMode" in document && 11 >= document.documentMode, $aefa23277c986a08$var$Qe = null, $aefa23277c986a08$var$Re = null, $aefa23277c986a08$var$Se = null, $aefa23277c986a08$var$Te = !1;
function $aefa23277c986a08$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $aefa23277c986a08$var$Te || null == $aefa23277c986a08$var$Qe || $aefa23277c986a08$var$Qe !== $aefa23277c986a08$var$Xa(d) || (d = $aefa23277c986a08$var$Qe, "selectionStart" in d && $aefa23277c986a08$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $aefa23277c986a08$var$Se && $aefa23277c986a08$var$Ie($aefa23277c986a08$var$Se, d) || ($aefa23277c986a08$var$Se = d, d = $aefa23277c986a08$var$oe($aefa23277c986a08$var$Re, "onSelect"), 0 < d.length && (b = new $aefa23277c986a08$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $aefa23277c986a08$var$Qe)));
}
function $aefa23277c986a08$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $aefa23277c986a08$var$We = {
    animationend: $aefa23277c986a08$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $aefa23277c986a08$var$Ve("Animation", "AnimationIteration"),
    animationstart: $aefa23277c986a08$var$Ve("Animation", "AnimationStart"),
    transitionend: $aefa23277c986a08$var$Ve("Transition", "TransitionEnd")
}, $aefa23277c986a08$var$Xe = {}, $aefa23277c986a08$var$Ye = {};
$aefa23277c986a08$var$ia && ($aefa23277c986a08$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $aefa23277c986a08$var$We.animationend.animation, delete $aefa23277c986a08$var$We.animationiteration.animation, delete $aefa23277c986a08$var$We.animationstart.animation), "TransitionEvent" in window || delete $aefa23277c986a08$var$We.transitionend.transition);
function $aefa23277c986a08$var$Ze(a) {
    if ($aefa23277c986a08$var$Xe[a]) return $aefa23277c986a08$var$Xe[a];
    if (!$aefa23277c986a08$var$We[a]) return a;
    var b = $aefa23277c986a08$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $aefa23277c986a08$var$Ye) return $aefa23277c986a08$var$Xe[a] = b[c];
    return a;
}
var $aefa23277c986a08$var$$e = $aefa23277c986a08$var$Ze("animationend"), $aefa23277c986a08$var$af = $aefa23277c986a08$var$Ze("animationiteration"), $aefa23277c986a08$var$bf = $aefa23277c986a08$var$Ze("animationstart"), $aefa23277c986a08$var$cf = $aefa23277c986a08$var$Ze("transitionend"), $aefa23277c986a08$var$df = new Map, $aefa23277c986a08$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $aefa23277c986a08$var$ff(a, b) {
    $aefa23277c986a08$var$df.set(a, b);
    $aefa23277c986a08$var$fa(b, [
        a
    ]);
}
for(var $aefa23277c986a08$var$gf = 0; $aefa23277c986a08$var$gf < $aefa23277c986a08$var$ef.length; $aefa23277c986a08$var$gf++){
    var $aefa23277c986a08$var$hf = $aefa23277c986a08$var$ef[$aefa23277c986a08$var$gf], $aefa23277c986a08$var$jf = $aefa23277c986a08$var$hf.toLowerCase(), $aefa23277c986a08$var$kf = $aefa23277c986a08$var$hf[0].toUpperCase() + $aefa23277c986a08$var$hf.slice(1);
    $aefa23277c986a08$var$ff($aefa23277c986a08$var$jf, "on" + $aefa23277c986a08$var$kf);
}
$aefa23277c986a08$var$ff($aefa23277c986a08$var$$e, "onAnimationEnd");
$aefa23277c986a08$var$ff($aefa23277c986a08$var$af, "onAnimationIteration");
$aefa23277c986a08$var$ff($aefa23277c986a08$var$bf, "onAnimationStart");
$aefa23277c986a08$var$ff("dblclick", "onDoubleClick");
$aefa23277c986a08$var$ff("focusin", "onFocus");
$aefa23277c986a08$var$ff("focusout", "onBlur");
$aefa23277c986a08$var$ff($aefa23277c986a08$var$cf, "onTransitionEnd");
$aefa23277c986a08$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$aefa23277c986a08$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$aefa23277c986a08$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$aefa23277c986a08$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$aefa23277c986a08$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$aefa23277c986a08$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$aefa23277c986a08$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$aefa23277c986a08$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$aefa23277c986a08$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$aefa23277c986a08$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $aefa23277c986a08$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $aefa23277c986a08$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($aefa23277c986a08$var$lf));
function $aefa23277c986a08$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $aefa23277c986a08$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $aefa23277c986a08$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $aefa23277c986a08$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $aefa23277c986a08$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($aefa23277c986a08$var$Qb) throw a = $aefa23277c986a08$var$Rb, $aefa23277c986a08$var$Qb = !1, $aefa23277c986a08$var$Rb = null, a;
}
function $aefa23277c986a08$var$D(a, b) {
    var c = b[$aefa23277c986a08$var$of];
    void 0 === c && (c = b[$aefa23277c986a08$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($aefa23277c986a08$var$pf(b, a, 2, !1), c.add(d));
}
function $aefa23277c986a08$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $aefa23277c986a08$var$pf(c, a, d, b);
}
var $aefa23277c986a08$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $aefa23277c986a08$var$sf(a) {
    if (!a[$aefa23277c986a08$var$rf]) {
        a[$aefa23277c986a08$var$rf] = !0;
        $aefa23277c986a08$var$da.forEach(function(b) {
            "selectionchange" !== b && ($aefa23277c986a08$var$mf.has(b) || $aefa23277c986a08$var$qf(b, !1, a), $aefa23277c986a08$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$aefa23277c986a08$var$rf] || (b[$aefa23277c986a08$var$rf] = !0, $aefa23277c986a08$var$qf("selectionchange", !1, b));
    }
}
function $aefa23277c986a08$var$pf(a, b, c, d) {
    switch($aefa23277c986a08$var$jd(b)){
        case 1:
            var e = $aefa23277c986a08$var$ed;
            break;
        case 4:
            e = $aefa23277c986a08$var$gd;
            break;
        default:
            e = $aefa23277c986a08$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$aefa23277c986a08$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $aefa23277c986a08$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $aefa23277c986a08$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $aefa23277c986a08$var$Jb(function() {
        var d = f, e = $aefa23277c986a08$var$xb(c), g = [];
        a: {
            var h = $aefa23277c986a08$var$df.get(a);
            if (void 0 !== h) {
                var k = $aefa23277c986a08$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $aefa23277c986a08$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $aefa23277c986a08$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $aefa23277c986a08$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $aefa23277c986a08$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $aefa23277c986a08$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $aefa23277c986a08$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $aefa23277c986a08$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $aefa23277c986a08$var$Vd;
                        break;
                    case $aefa23277c986a08$var$$e:
                    case $aefa23277c986a08$var$af:
                    case $aefa23277c986a08$var$bf:
                        k = $aefa23277c986a08$var$Hd;
                        break;
                    case $aefa23277c986a08$var$cf:
                        k = $aefa23277c986a08$var$Xd;
                        break;
                    case "scroll":
                        k = $aefa23277c986a08$var$vd;
                        break;
                    case "wheel":
                        k = $aefa23277c986a08$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $aefa23277c986a08$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $aefa23277c986a08$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $aefa23277c986a08$var$Kb(w, x), null != F && t.push($aefa23277c986a08$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $aefa23277c986a08$var$wb && (n = c.relatedTarget || c.fromElement) && ($aefa23277c986a08$var$Wc(n) || n[$aefa23277c986a08$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $aefa23277c986a08$var$Wc(n) : null, null !== n && (J = $aefa23277c986a08$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $aefa23277c986a08$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $aefa23277c986a08$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $aefa23277c986a08$var$ue(k);
                        u = null == n ? h : $aefa23277c986a08$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $aefa23277c986a08$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $aefa23277c986a08$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $aefa23277c986a08$var$vf(F))u++;
                            for(; 0 < w - u;)t = $aefa23277c986a08$var$vf(t), w--;
                            for(; 0 < u - w;)x = $aefa23277c986a08$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $aefa23277c986a08$var$vf(t);
                                x = $aefa23277c986a08$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $aefa23277c986a08$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $aefa23277c986a08$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $aefa23277c986a08$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $aefa23277c986a08$var$ve;
                else if ($aefa23277c986a08$var$me(h)) {
                    if ($aefa23277c986a08$var$we) na = $aefa23277c986a08$var$Fe;
                    else {
                        na = $aefa23277c986a08$var$De;
                        var xa = $aefa23277c986a08$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $aefa23277c986a08$var$Ee);
                if (na && (na = na(a, d))) {
                    $aefa23277c986a08$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $aefa23277c986a08$var$cb(h, "number", h.value);
            }
            xa = d ? $aefa23277c986a08$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($aefa23277c986a08$var$me(xa) || "true" === xa.contentEditable) $aefa23277c986a08$var$Qe = xa, $aefa23277c986a08$var$Re = d, $aefa23277c986a08$var$Se = null;
                    break;
                case "focusout":
                    $aefa23277c986a08$var$Se = $aefa23277c986a08$var$Re = $aefa23277c986a08$var$Qe = null;
                    break;
                case "mousedown":
                    $aefa23277c986a08$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $aefa23277c986a08$var$Te = !1;
                    $aefa23277c986a08$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($aefa23277c986a08$var$Pe) break;
                case "keydown":
                case "keyup":
                    $aefa23277c986a08$var$Ue(g, c, e);
            }
            var $a;
            if ($aefa23277c986a08$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $aefa23277c986a08$var$ie ? $aefa23277c986a08$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($aefa23277c986a08$var$de && "ko" !== c.locale && ($aefa23277c986a08$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $aefa23277c986a08$var$ie && ($a = $aefa23277c986a08$var$nd()) : ($aefa23277c986a08$var$kd = e, $aefa23277c986a08$var$ld = "value" in $aefa23277c986a08$var$kd ? $aefa23277c986a08$var$kd.value : $aefa23277c986a08$var$kd.textContent, $aefa23277c986a08$var$ie = !0)), xa = $aefa23277c986a08$var$oe(d, ba), 0 < xa.length && (ba = new $aefa23277c986a08$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $aefa23277c986a08$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $aefa23277c986a08$var$ce ? $aefa23277c986a08$var$je(a, c) : $aefa23277c986a08$var$ke(a, c)) d = $aefa23277c986a08$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $aefa23277c986a08$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $aefa23277c986a08$var$se(g, b);
    });
}
function $aefa23277c986a08$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $aefa23277c986a08$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $aefa23277c986a08$var$Kb(a, c), null != f && d.unshift($aefa23277c986a08$var$tf(a, f, e)), f = $aefa23277c986a08$var$Kb(a, b), null != f && d.push($aefa23277c986a08$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $aefa23277c986a08$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $aefa23277c986a08$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $aefa23277c986a08$var$Kb(c, f), null != k && g.unshift($aefa23277c986a08$var$tf(c, k, h))) : e || (k = $aefa23277c986a08$var$Kb(c, f), null != k && g.push($aefa23277c986a08$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $aefa23277c986a08$var$xf = /\r\n?/g, $aefa23277c986a08$var$yf = /\u0000|\uFFFD/g;
function $aefa23277c986a08$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($aefa23277c986a08$var$xf, "\n").replace($aefa23277c986a08$var$yf, "");
}
function $aefa23277c986a08$var$Af(a, b, c) {
    b = $aefa23277c986a08$var$zf(b);
    if ($aefa23277c986a08$var$zf(a) !== b && c) throw Error($aefa23277c986a08$var$p(425));
}
function $aefa23277c986a08$var$Bf() {}
var $aefa23277c986a08$var$Cf = null, $aefa23277c986a08$var$Df = null;
function $aefa23277c986a08$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $aefa23277c986a08$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $aefa23277c986a08$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $aefa23277c986a08$var$Hf = "function" === typeof Promise ? Promise : void 0, $aefa23277c986a08$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $aefa23277c986a08$var$Hf ? function(a) {
    return $aefa23277c986a08$var$Hf.resolve(null).then(a).catch($aefa23277c986a08$var$If);
} : $aefa23277c986a08$var$Ff;
function $aefa23277c986a08$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $aefa23277c986a08$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $aefa23277c986a08$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $aefa23277c986a08$var$bd(b);
}
function $aefa23277c986a08$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $aefa23277c986a08$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $aefa23277c986a08$var$Nf = Math.random().toString(36).slice(2), $aefa23277c986a08$var$Of = "__reactFiber$" + $aefa23277c986a08$var$Nf, $aefa23277c986a08$var$Pf = "__reactProps$" + $aefa23277c986a08$var$Nf, $aefa23277c986a08$var$uf = "__reactContainer$" + $aefa23277c986a08$var$Nf, $aefa23277c986a08$var$of = "__reactEvents$" + $aefa23277c986a08$var$Nf, $aefa23277c986a08$var$Qf = "__reactListeners$" + $aefa23277c986a08$var$Nf, $aefa23277c986a08$var$Rf = "__reactHandles$" + $aefa23277c986a08$var$Nf;
function $aefa23277c986a08$var$Wc(a) {
    var b = a[$aefa23277c986a08$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$aefa23277c986a08$var$uf] || c[$aefa23277c986a08$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $aefa23277c986a08$var$Mf(a); null !== a;){
                if (c = a[$aefa23277c986a08$var$Of]) return c;
                a = $aefa23277c986a08$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $aefa23277c986a08$var$Cb(a) {
    a = a[$aefa23277c986a08$var$Of] || a[$aefa23277c986a08$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $aefa23277c986a08$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($aefa23277c986a08$var$p(33));
}
function $aefa23277c986a08$var$Db(a) {
    return a[$aefa23277c986a08$var$Pf] || null;
}
var $aefa23277c986a08$var$Sf = [], $aefa23277c986a08$var$Tf = -1;
function $aefa23277c986a08$var$Uf(a) {
    return {
        current: a
    };
}
function $aefa23277c986a08$var$E(a) {
    0 > $aefa23277c986a08$var$Tf || (a.current = $aefa23277c986a08$var$Sf[$aefa23277c986a08$var$Tf], $aefa23277c986a08$var$Sf[$aefa23277c986a08$var$Tf] = null, $aefa23277c986a08$var$Tf--);
}
function $aefa23277c986a08$var$G(a, b) {
    $aefa23277c986a08$var$Tf++;
    $aefa23277c986a08$var$Sf[$aefa23277c986a08$var$Tf] = a.current;
    a.current = b;
}
var $aefa23277c986a08$var$Vf = {}, $aefa23277c986a08$var$H = $aefa23277c986a08$var$Uf($aefa23277c986a08$var$Vf), $aefa23277c986a08$var$Wf = $aefa23277c986a08$var$Uf(!1), $aefa23277c986a08$var$Xf = $aefa23277c986a08$var$Vf;
function $aefa23277c986a08$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $aefa23277c986a08$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $aefa23277c986a08$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $aefa23277c986a08$var$$f() {
    $aefa23277c986a08$var$E($aefa23277c986a08$var$Wf);
    $aefa23277c986a08$var$E($aefa23277c986a08$var$H);
}
function $aefa23277c986a08$var$ag(a, b, c) {
    if ($aefa23277c986a08$var$H.current !== $aefa23277c986a08$var$Vf) throw Error($aefa23277c986a08$var$p(168));
    $aefa23277c986a08$var$G($aefa23277c986a08$var$H, b);
    $aefa23277c986a08$var$G($aefa23277c986a08$var$Wf, c);
}
function $aefa23277c986a08$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($aefa23277c986a08$var$p(108, $aefa23277c986a08$var$Ra(a) || "Unknown", e));
    return $aefa23277c986a08$var$A({}, c, d);
}
function $aefa23277c986a08$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $aefa23277c986a08$var$Vf;
    $aefa23277c986a08$var$Xf = $aefa23277c986a08$var$H.current;
    $aefa23277c986a08$var$G($aefa23277c986a08$var$H, a);
    $aefa23277c986a08$var$G($aefa23277c986a08$var$Wf, $aefa23277c986a08$var$Wf.current);
    return !0;
}
function $aefa23277c986a08$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($aefa23277c986a08$var$p(169));
    c ? (a = $aefa23277c986a08$var$bg(a, b, $aefa23277c986a08$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $aefa23277c986a08$var$E($aefa23277c986a08$var$Wf), $aefa23277c986a08$var$E($aefa23277c986a08$var$H), $aefa23277c986a08$var$G($aefa23277c986a08$var$H, a)) : $aefa23277c986a08$var$E($aefa23277c986a08$var$Wf);
    $aefa23277c986a08$var$G($aefa23277c986a08$var$Wf, c);
}
var $aefa23277c986a08$var$eg = null, $aefa23277c986a08$var$fg = !1, $aefa23277c986a08$var$gg = !1;
function $aefa23277c986a08$var$hg(a) {
    null === $aefa23277c986a08$var$eg ? $aefa23277c986a08$var$eg = [
        a
    ] : $aefa23277c986a08$var$eg.push(a);
}
function $aefa23277c986a08$var$ig(a) {
    $aefa23277c986a08$var$fg = !0;
    $aefa23277c986a08$var$hg(a);
}
function $aefa23277c986a08$var$jg() {
    if (!$aefa23277c986a08$var$gg && null !== $aefa23277c986a08$var$eg) {
        $aefa23277c986a08$var$gg = !0;
        var a = 0, b = $aefa23277c986a08$var$C;
        try {
            var c = $aefa23277c986a08$var$eg;
            for($aefa23277c986a08$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $aefa23277c986a08$var$eg = null;
            $aefa23277c986a08$var$fg = !1;
        } catch (e) {
            throw null !== $aefa23277c986a08$var$eg && ($aefa23277c986a08$var$eg = $aefa23277c986a08$var$eg.slice(a + 1)), $aefa23277c986a08$var$ac($aefa23277c986a08$var$fc, $aefa23277c986a08$var$jg), e;
        } finally{
            $aefa23277c986a08$var$C = b, $aefa23277c986a08$var$gg = !1;
        }
    }
    return null;
}
var $aefa23277c986a08$var$kg = [], $aefa23277c986a08$var$lg = 0, $aefa23277c986a08$var$mg = null, $aefa23277c986a08$var$ng = 0, $aefa23277c986a08$var$og = [], $aefa23277c986a08$var$pg = 0, $aefa23277c986a08$var$qg = null, $aefa23277c986a08$var$rg = 1, $aefa23277c986a08$var$sg = "";
function $aefa23277c986a08$var$tg(a, b) {
    $aefa23277c986a08$var$kg[$aefa23277c986a08$var$lg++] = $aefa23277c986a08$var$ng;
    $aefa23277c986a08$var$kg[$aefa23277c986a08$var$lg++] = $aefa23277c986a08$var$mg;
    $aefa23277c986a08$var$mg = a;
    $aefa23277c986a08$var$ng = b;
}
function $aefa23277c986a08$var$ug(a, b, c) {
    $aefa23277c986a08$var$og[$aefa23277c986a08$var$pg++] = $aefa23277c986a08$var$rg;
    $aefa23277c986a08$var$og[$aefa23277c986a08$var$pg++] = $aefa23277c986a08$var$sg;
    $aefa23277c986a08$var$og[$aefa23277c986a08$var$pg++] = $aefa23277c986a08$var$qg;
    $aefa23277c986a08$var$qg = a;
    var d = $aefa23277c986a08$var$rg;
    a = $aefa23277c986a08$var$sg;
    var e = 32 - $aefa23277c986a08$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $aefa23277c986a08$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $aefa23277c986a08$var$rg = 1 << 32 - $aefa23277c986a08$var$oc(b) + e | c << e | d;
        $aefa23277c986a08$var$sg = f + a;
    } else $aefa23277c986a08$var$rg = 1 << f | c << e | d, $aefa23277c986a08$var$sg = a;
}
function $aefa23277c986a08$var$vg(a) {
    null !== a.return && ($aefa23277c986a08$var$tg(a, 1), $aefa23277c986a08$var$ug(a, 1, 0));
}
function $aefa23277c986a08$var$wg(a) {
    for(; a === $aefa23277c986a08$var$mg;)$aefa23277c986a08$var$mg = $aefa23277c986a08$var$kg[--$aefa23277c986a08$var$lg], $aefa23277c986a08$var$kg[$aefa23277c986a08$var$lg] = null, $aefa23277c986a08$var$ng = $aefa23277c986a08$var$kg[--$aefa23277c986a08$var$lg], $aefa23277c986a08$var$kg[$aefa23277c986a08$var$lg] = null;
    for(; a === $aefa23277c986a08$var$qg;)$aefa23277c986a08$var$qg = $aefa23277c986a08$var$og[--$aefa23277c986a08$var$pg], $aefa23277c986a08$var$og[$aefa23277c986a08$var$pg] = null, $aefa23277c986a08$var$sg = $aefa23277c986a08$var$og[--$aefa23277c986a08$var$pg], $aefa23277c986a08$var$og[$aefa23277c986a08$var$pg] = null, $aefa23277c986a08$var$rg = $aefa23277c986a08$var$og[--$aefa23277c986a08$var$pg], $aefa23277c986a08$var$og[$aefa23277c986a08$var$pg] = null;
}
var $aefa23277c986a08$var$xg = null, $aefa23277c986a08$var$yg = null, $aefa23277c986a08$var$I = !1, $aefa23277c986a08$var$zg = null;
function $aefa23277c986a08$var$Ag(a, b) {
    var c = $aefa23277c986a08$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $aefa23277c986a08$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $aefa23277c986a08$var$xg = a, $aefa23277c986a08$var$yg = $aefa23277c986a08$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $aefa23277c986a08$var$xg = a, $aefa23277c986a08$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $aefa23277c986a08$var$qg ? {
                id: $aefa23277c986a08$var$rg,
                overflow: $aefa23277c986a08$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $aefa23277c986a08$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $aefa23277c986a08$var$xg = a, $aefa23277c986a08$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $aefa23277c986a08$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $aefa23277c986a08$var$Eg(a) {
    if ($aefa23277c986a08$var$I) {
        var b = $aefa23277c986a08$var$yg;
        if (b) {
            var c = b;
            if (!$aefa23277c986a08$var$Cg(a, b)) {
                if ($aefa23277c986a08$var$Dg(a)) throw Error($aefa23277c986a08$var$p(418));
                b = $aefa23277c986a08$var$Lf(c.nextSibling);
                var d = $aefa23277c986a08$var$xg;
                b && $aefa23277c986a08$var$Cg(a, b) ? $aefa23277c986a08$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $aefa23277c986a08$var$I = !1, $aefa23277c986a08$var$xg = a);
            }
        } else {
            if ($aefa23277c986a08$var$Dg(a)) throw Error($aefa23277c986a08$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $aefa23277c986a08$var$I = !1;
            $aefa23277c986a08$var$xg = a;
        }
    }
}
function $aefa23277c986a08$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $aefa23277c986a08$var$xg = a;
}
function $aefa23277c986a08$var$Gg(a) {
    if (a !== $aefa23277c986a08$var$xg) return !1;
    if (!$aefa23277c986a08$var$I) return $aefa23277c986a08$var$Fg(a), $aefa23277c986a08$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$aefa23277c986a08$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $aefa23277c986a08$var$yg)) {
        if ($aefa23277c986a08$var$Dg(a)) throw $aefa23277c986a08$var$Hg(), Error($aefa23277c986a08$var$p(418));
        for(; b;)$aefa23277c986a08$var$Ag(a, b), b = $aefa23277c986a08$var$Lf(b.nextSibling);
    }
    $aefa23277c986a08$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($aefa23277c986a08$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $aefa23277c986a08$var$yg = $aefa23277c986a08$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $aefa23277c986a08$var$yg = null;
        }
    } else $aefa23277c986a08$var$yg = $aefa23277c986a08$var$xg ? $aefa23277c986a08$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $aefa23277c986a08$var$Hg() {
    for(var a = $aefa23277c986a08$var$yg; a;)a = $aefa23277c986a08$var$Lf(a.nextSibling);
}
function $aefa23277c986a08$var$Ig() {
    $aefa23277c986a08$var$yg = $aefa23277c986a08$var$xg = null;
    $aefa23277c986a08$var$I = !1;
}
function $aefa23277c986a08$var$Jg(a) {
    null === $aefa23277c986a08$var$zg ? $aefa23277c986a08$var$zg = [
        a
    ] : $aefa23277c986a08$var$zg.push(a);
}
var $aefa23277c986a08$var$Kg = $aefa23277c986a08$var$ua.ReactCurrentBatchConfig;
function $aefa23277c986a08$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($aefa23277c986a08$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($aefa23277c986a08$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($aefa23277c986a08$var$p(284));
        if (!c._owner) throw Error($aefa23277c986a08$var$p(290, a));
    }
    return a;
}
function $aefa23277c986a08$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($aefa23277c986a08$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $aefa23277c986a08$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $aefa23277c986a08$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $aefa23277c986a08$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $aefa23277c986a08$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $aefa23277c986a08$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $aefa23277c986a08$var$Ha && $aefa23277c986a08$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $aefa23277c986a08$var$Lg(a, b, c), d.return = a, d;
        d = $aefa23277c986a08$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $aefa23277c986a08$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $aefa23277c986a08$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $aefa23277c986a08$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $aefa23277c986a08$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $aefa23277c986a08$var$va:
                    return c = $aefa23277c986a08$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $aefa23277c986a08$var$Lg(a, null, b), c.return = a, c;
                case $aefa23277c986a08$var$wa:
                    return b = $aefa23277c986a08$var$Sg(b, a.mode, c), b.return = a, b;
                case $aefa23277c986a08$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($aefa23277c986a08$var$eb(b) || $aefa23277c986a08$var$Ka(b)) return b = $aefa23277c986a08$var$Tg(b, a.mode, c, null), b.return = a, b;
            $aefa23277c986a08$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $aefa23277c986a08$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $aefa23277c986a08$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $aefa23277c986a08$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($aefa23277c986a08$var$eb(c) || $aefa23277c986a08$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $aefa23277c986a08$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $aefa23277c986a08$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $aefa23277c986a08$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $aefa23277c986a08$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($aefa23277c986a08$var$eb(d) || $aefa23277c986a08$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $aefa23277c986a08$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $aefa23277c986a08$var$I && $aefa23277c986a08$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $aefa23277c986a08$var$I && $aefa23277c986a08$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $aefa23277c986a08$var$I && $aefa23277c986a08$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $aefa23277c986a08$var$Ka(h);
        if ("function" !== typeof l) throw Error($aefa23277c986a08$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($aefa23277c986a08$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $aefa23277c986a08$var$I && $aefa23277c986a08$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $aefa23277c986a08$var$I && $aefa23277c986a08$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $aefa23277c986a08$var$I && $aefa23277c986a08$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $aefa23277c986a08$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $aefa23277c986a08$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $aefa23277c986a08$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $aefa23277c986a08$var$Ha && $aefa23277c986a08$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $aefa23277c986a08$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $aefa23277c986a08$var$ya ? (d = $aefa23277c986a08$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $aefa23277c986a08$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $aefa23277c986a08$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $aefa23277c986a08$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $aefa23277c986a08$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $aefa23277c986a08$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($aefa23277c986a08$var$eb(f)) return n(a, d, f, h);
            if ($aefa23277c986a08$var$Ka(f)) return t(a, d, f, h);
            $aefa23277c986a08$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $aefa23277c986a08$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $aefa23277c986a08$var$Ug = $aefa23277c986a08$var$Og(!0), $aefa23277c986a08$var$Vg = $aefa23277c986a08$var$Og(!1), $aefa23277c986a08$var$Wg = $aefa23277c986a08$var$Uf(null), $aefa23277c986a08$var$Xg = null, $aefa23277c986a08$var$Yg = null, $aefa23277c986a08$var$Zg = null;
function $aefa23277c986a08$var$$g() {
    $aefa23277c986a08$var$Zg = $aefa23277c986a08$var$Yg = $aefa23277c986a08$var$Xg = null;
}
function $aefa23277c986a08$var$ah(a) {
    var b = $aefa23277c986a08$var$Wg.current;
    $aefa23277c986a08$var$E($aefa23277c986a08$var$Wg);
    a._currentValue = b;
}
function $aefa23277c986a08$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $aefa23277c986a08$var$ch(a, b) {
    $aefa23277c986a08$var$Xg = a;
    $aefa23277c986a08$var$Zg = $aefa23277c986a08$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($aefa23277c986a08$var$dh = !0), a.firstContext = null);
}
function $aefa23277c986a08$var$eh(a) {
    var b = a._currentValue;
    if ($aefa23277c986a08$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $aefa23277c986a08$var$Yg) {
            if (null === $aefa23277c986a08$var$Xg) throw Error($aefa23277c986a08$var$p(308));
            $aefa23277c986a08$var$Yg = a;
            $aefa23277c986a08$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $aefa23277c986a08$var$Yg = $aefa23277c986a08$var$Yg.next = a;
    }
    return b;
}
var $aefa23277c986a08$var$fh = null;
function $aefa23277c986a08$var$gh(a) {
    null === $aefa23277c986a08$var$fh ? $aefa23277c986a08$var$fh = [
        a
    ] : $aefa23277c986a08$var$fh.push(a);
}
function $aefa23277c986a08$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $aefa23277c986a08$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $aefa23277c986a08$var$ih(a, d);
}
function $aefa23277c986a08$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $aefa23277c986a08$var$jh = !1;
function $aefa23277c986a08$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $aefa23277c986a08$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $aefa23277c986a08$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $aefa23277c986a08$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($aefa23277c986a08$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $aefa23277c986a08$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $aefa23277c986a08$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $aefa23277c986a08$var$ih(a, c);
}
function $aefa23277c986a08$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $aefa23277c986a08$var$Cc(a, c);
    }
}
function $aefa23277c986a08$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $aefa23277c986a08$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $aefa23277c986a08$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $aefa23277c986a08$var$A({}, q, r);
                            break a;
                        case 2:
                            $aefa23277c986a08$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $aefa23277c986a08$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $aefa23277c986a08$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($aefa23277c986a08$var$p(191, e));
            e.call(d);
        }
    }
}
var $aefa23277c986a08$var$th = {}, $aefa23277c986a08$var$uh = $aefa23277c986a08$var$Uf($aefa23277c986a08$var$th), $aefa23277c986a08$var$vh = $aefa23277c986a08$var$Uf($aefa23277c986a08$var$th), $aefa23277c986a08$var$wh = $aefa23277c986a08$var$Uf($aefa23277c986a08$var$th);
function $aefa23277c986a08$var$xh(a) {
    if (a === $aefa23277c986a08$var$th) throw Error($aefa23277c986a08$var$p(174));
    return a;
}
function $aefa23277c986a08$var$yh(a, b) {
    $aefa23277c986a08$var$G($aefa23277c986a08$var$wh, b);
    $aefa23277c986a08$var$G($aefa23277c986a08$var$vh, a);
    $aefa23277c986a08$var$G($aefa23277c986a08$var$uh, $aefa23277c986a08$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $aefa23277c986a08$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $aefa23277c986a08$var$lb(b, a);
    }
    $aefa23277c986a08$var$E($aefa23277c986a08$var$uh);
    $aefa23277c986a08$var$G($aefa23277c986a08$var$uh, b);
}
function $aefa23277c986a08$var$zh() {
    $aefa23277c986a08$var$E($aefa23277c986a08$var$uh);
    $aefa23277c986a08$var$E($aefa23277c986a08$var$vh);
    $aefa23277c986a08$var$E($aefa23277c986a08$var$wh);
}
function $aefa23277c986a08$var$Ah(a) {
    $aefa23277c986a08$var$xh($aefa23277c986a08$var$wh.current);
    var b = $aefa23277c986a08$var$xh($aefa23277c986a08$var$uh.current);
    var c = $aefa23277c986a08$var$lb(b, a.type);
    b !== c && ($aefa23277c986a08$var$G($aefa23277c986a08$var$vh, a), $aefa23277c986a08$var$G($aefa23277c986a08$var$uh, c));
}
function $aefa23277c986a08$var$Bh(a) {
    $aefa23277c986a08$var$vh.current === a && ($aefa23277c986a08$var$E($aefa23277c986a08$var$uh), $aefa23277c986a08$var$E($aefa23277c986a08$var$vh));
}
var $aefa23277c986a08$var$L = $aefa23277c986a08$var$Uf(0);
function $aefa23277c986a08$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $aefa23277c986a08$var$Dh = [];
function $aefa23277c986a08$var$Eh() {
    for(var a = 0; a < $aefa23277c986a08$var$Dh.length; a++)$aefa23277c986a08$var$Dh[a]._workInProgressVersionPrimary = null;
    $aefa23277c986a08$var$Dh.length = 0;
}
var $aefa23277c986a08$var$Fh = $aefa23277c986a08$var$ua.ReactCurrentDispatcher, $aefa23277c986a08$var$Gh = $aefa23277c986a08$var$ua.ReactCurrentBatchConfig, $aefa23277c986a08$var$Hh = 0, $aefa23277c986a08$var$M = null, $aefa23277c986a08$var$N = null, $aefa23277c986a08$var$O = null, $aefa23277c986a08$var$Ih = !1, $aefa23277c986a08$var$Jh = !1, $aefa23277c986a08$var$Kh = 0, $aefa23277c986a08$var$Lh = 0;
function $aefa23277c986a08$var$P() {
    throw Error($aefa23277c986a08$var$p(321));
}
function $aefa23277c986a08$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$aefa23277c986a08$var$He(a[c], b[c])) return !1;
    return !0;
}
function $aefa23277c986a08$var$Nh(a, b, c, d, e, f) {
    $aefa23277c986a08$var$Hh = f;
    $aefa23277c986a08$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $aefa23277c986a08$var$Fh.current = null === a || null === a.memoizedState ? $aefa23277c986a08$var$Oh : $aefa23277c986a08$var$Ph;
    a = c(d, e);
    if ($aefa23277c986a08$var$Jh) {
        f = 0;
        do {
            $aefa23277c986a08$var$Jh = !1;
            $aefa23277c986a08$var$Kh = 0;
            if (25 <= f) throw Error($aefa23277c986a08$var$p(301));
            f += 1;
            $aefa23277c986a08$var$O = $aefa23277c986a08$var$N = null;
            b.updateQueue = null;
            $aefa23277c986a08$var$Fh.current = $aefa23277c986a08$var$Qh;
            a = c(d, e);
        }while ($aefa23277c986a08$var$Jh);
    }
    $aefa23277c986a08$var$Fh.current = $aefa23277c986a08$var$Rh;
    b = null !== $aefa23277c986a08$var$N && null !== $aefa23277c986a08$var$N.next;
    $aefa23277c986a08$var$Hh = 0;
    $aefa23277c986a08$var$O = $aefa23277c986a08$var$N = $aefa23277c986a08$var$M = null;
    $aefa23277c986a08$var$Ih = !1;
    if (b) throw Error($aefa23277c986a08$var$p(300));
    return a;
}
function $aefa23277c986a08$var$Sh() {
    var a = 0 !== $aefa23277c986a08$var$Kh;
    $aefa23277c986a08$var$Kh = 0;
    return a;
}
function $aefa23277c986a08$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $aefa23277c986a08$var$O ? $aefa23277c986a08$var$M.memoizedState = $aefa23277c986a08$var$O = a : $aefa23277c986a08$var$O = $aefa23277c986a08$var$O.next = a;
    return $aefa23277c986a08$var$O;
}
function $aefa23277c986a08$var$Uh() {
    if (null === $aefa23277c986a08$var$N) {
        var a = $aefa23277c986a08$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $aefa23277c986a08$var$N.next;
    var b = null === $aefa23277c986a08$var$O ? $aefa23277c986a08$var$M.memoizedState : $aefa23277c986a08$var$O.next;
    if (null !== b) $aefa23277c986a08$var$O = b, $aefa23277c986a08$var$N = a;
    else {
        if (null === a) throw Error($aefa23277c986a08$var$p(310));
        $aefa23277c986a08$var$N = a;
        a = {
            memoizedState: $aefa23277c986a08$var$N.memoizedState,
            baseState: $aefa23277c986a08$var$N.baseState,
            baseQueue: $aefa23277c986a08$var$N.baseQueue,
            queue: $aefa23277c986a08$var$N.queue,
            next: null
        };
        null === $aefa23277c986a08$var$O ? $aefa23277c986a08$var$M.memoizedState = $aefa23277c986a08$var$O = a : $aefa23277c986a08$var$O = $aefa23277c986a08$var$O.next = a;
    }
    return $aefa23277c986a08$var$O;
}
function $aefa23277c986a08$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $aefa23277c986a08$var$Wh(a) {
    var b = $aefa23277c986a08$var$Uh(), c = b.queue;
    if (null === c) throw Error($aefa23277c986a08$var$p(311));
    c.lastRenderedReducer = a;
    var d = $aefa23277c986a08$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($aefa23277c986a08$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $aefa23277c986a08$var$M.lanes |= m;
                $aefa23277c986a08$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $aefa23277c986a08$var$He(d, b.memoizedState) || ($aefa23277c986a08$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $aefa23277c986a08$var$M.lanes |= f, $aefa23277c986a08$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $aefa23277c986a08$var$Xh(a) {
    var b = $aefa23277c986a08$var$Uh(), c = b.queue;
    if (null === c) throw Error($aefa23277c986a08$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $aefa23277c986a08$var$He(f, b.memoizedState) || ($aefa23277c986a08$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $aefa23277c986a08$var$Yh() {}
function $aefa23277c986a08$var$Zh(a, b) {
    var c = $aefa23277c986a08$var$M, d = $aefa23277c986a08$var$Uh(), e = b(), f = !$aefa23277c986a08$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $aefa23277c986a08$var$dh = !0);
    d = d.queue;
    $aefa23277c986a08$var$$h($aefa23277c986a08$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $aefa23277c986a08$var$O && $aefa23277c986a08$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $aefa23277c986a08$var$bi(9, $aefa23277c986a08$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $aefa23277c986a08$var$Q) throw Error($aefa23277c986a08$var$p(349));
        0 !== ($aefa23277c986a08$var$Hh & 30) || $aefa23277c986a08$var$di(c, b, e);
    }
    return e;
}
function $aefa23277c986a08$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $aefa23277c986a08$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $aefa23277c986a08$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $aefa23277c986a08$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $aefa23277c986a08$var$ei(b) && $aefa23277c986a08$var$fi(a);
}
function $aefa23277c986a08$var$ai(a, b, c) {
    return c(function() {
        $aefa23277c986a08$var$ei(b) && $aefa23277c986a08$var$fi(a);
    });
}
function $aefa23277c986a08$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$aefa23277c986a08$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $aefa23277c986a08$var$fi(a) {
    var b = $aefa23277c986a08$var$ih(a, 1);
    null !== b && $aefa23277c986a08$var$gi(b, a, 1, -1);
}
function $aefa23277c986a08$var$hi(a) {
    var b = $aefa23277c986a08$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $aefa23277c986a08$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $aefa23277c986a08$var$ii.bind(null, $aefa23277c986a08$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $aefa23277c986a08$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $aefa23277c986a08$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $aefa23277c986a08$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $aefa23277c986a08$var$ji() {
    return $aefa23277c986a08$var$Uh().memoizedState;
}
function $aefa23277c986a08$var$ki(a, b, c, d) {
    var e = $aefa23277c986a08$var$Th();
    $aefa23277c986a08$var$M.flags |= a;
    e.memoizedState = $aefa23277c986a08$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $aefa23277c986a08$var$li(a, b, c, d) {
    var e = $aefa23277c986a08$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $aefa23277c986a08$var$N) {
        var g = $aefa23277c986a08$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $aefa23277c986a08$var$Mh(d, g.deps)) {
            e.memoizedState = $aefa23277c986a08$var$bi(b, c, f, d);
            return;
        }
    }
    $aefa23277c986a08$var$M.flags |= a;
    e.memoizedState = $aefa23277c986a08$var$bi(1 | b, c, f, d);
}
function $aefa23277c986a08$var$mi(a, b) {
    return $aefa23277c986a08$var$ki(8390656, 8, a, b);
}
function $aefa23277c986a08$var$$h(a, b) {
    return $aefa23277c986a08$var$li(2048, 8, a, b);
}
function $aefa23277c986a08$var$ni(a, b) {
    return $aefa23277c986a08$var$li(4, 2, a, b);
}
function $aefa23277c986a08$var$oi(a, b) {
    return $aefa23277c986a08$var$li(4, 4, a, b);
}
function $aefa23277c986a08$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $aefa23277c986a08$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $aefa23277c986a08$var$li(4, 4, $aefa23277c986a08$var$pi.bind(null, b, a), c);
}
function $aefa23277c986a08$var$ri() {}
function $aefa23277c986a08$var$si(a, b) {
    var c = $aefa23277c986a08$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $aefa23277c986a08$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $aefa23277c986a08$var$ti(a, b) {
    var c = $aefa23277c986a08$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $aefa23277c986a08$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $aefa23277c986a08$var$ui(a, b, c) {
    if (0 === ($aefa23277c986a08$var$Hh & 21)) return a.baseState && (a.baseState = !1, $aefa23277c986a08$var$dh = !0), a.memoizedState = c;
    $aefa23277c986a08$var$He(c, b) || (c = $aefa23277c986a08$var$yc(), $aefa23277c986a08$var$M.lanes |= c, $aefa23277c986a08$var$rh |= c, a.baseState = !0);
    return b;
}
function $aefa23277c986a08$var$vi(a, b) {
    var c = $aefa23277c986a08$var$C;
    $aefa23277c986a08$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $aefa23277c986a08$var$Gh.transition;
    $aefa23277c986a08$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $aefa23277c986a08$var$C = c, $aefa23277c986a08$var$Gh.transition = d;
    }
}
function $aefa23277c986a08$var$wi() {
    return $aefa23277c986a08$var$Uh().memoizedState;
}
function $aefa23277c986a08$var$xi(a, b, c) {
    var d = $aefa23277c986a08$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($aefa23277c986a08$var$zi(a)) $aefa23277c986a08$var$Ai(b, c);
    else if (c = $aefa23277c986a08$var$hh(a, b, c, d), null !== c) {
        var e = $aefa23277c986a08$var$R();
        $aefa23277c986a08$var$gi(c, a, d, e);
        $aefa23277c986a08$var$Bi(c, b, d);
    }
}
function $aefa23277c986a08$var$ii(a, b, c) {
    var d = $aefa23277c986a08$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($aefa23277c986a08$var$zi(a)) $aefa23277c986a08$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($aefa23277c986a08$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $aefa23277c986a08$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $aefa23277c986a08$var$hh(a, b, e, d);
        null !== c && (e = $aefa23277c986a08$var$R(), $aefa23277c986a08$var$gi(c, a, d, e), $aefa23277c986a08$var$Bi(c, b, d));
    }
}
function $aefa23277c986a08$var$zi(a) {
    var b = a.alternate;
    return a === $aefa23277c986a08$var$M || null !== b && b === $aefa23277c986a08$var$M;
}
function $aefa23277c986a08$var$Ai(a, b) {
    $aefa23277c986a08$var$Jh = $aefa23277c986a08$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $aefa23277c986a08$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $aefa23277c986a08$var$Cc(a, c);
    }
}
var $aefa23277c986a08$var$Rh = {
    readContext: $aefa23277c986a08$var$eh,
    useCallback: $aefa23277c986a08$var$P,
    useContext: $aefa23277c986a08$var$P,
    useEffect: $aefa23277c986a08$var$P,
    useImperativeHandle: $aefa23277c986a08$var$P,
    useInsertionEffect: $aefa23277c986a08$var$P,
    useLayoutEffect: $aefa23277c986a08$var$P,
    useMemo: $aefa23277c986a08$var$P,
    useReducer: $aefa23277c986a08$var$P,
    useRef: $aefa23277c986a08$var$P,
    useState: $aefa23277c986a08$var$P,
    useDebugValue: $aefa23277c986a08$var$P,
    useDeferredValue: $aefa23277c986a08$var$P,
    useTransition: $aefa23277c986a08$var$P,
    useMutableSource: $aefa23277c986a08$var$P,
    useSyncExternalStore: $aefa23277c986a08$var$P,
    useId: $aefa23277c986a08$var$P,
    unstable_isNewReconciler: !1
}, $aefa23277c986a08$var$Oh = {
    readContext: $aefa23277c986a08$var$eh,
    useCallback: function(a, b) {
        $aefa23277c986a08$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $aefa23277c986a08$var$eh,
    useEffect: $aefa23277c986a08$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $aefa23277c986a08$var$ki(4194308, 4, $aefa23277c986a08$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $aefa23277c986a08$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $aefa23277c986a08$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $aefa23277c986a08$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $aefa23277c986a08$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $aefa23277c986a08$var$xi.bind(null, $aefa23277c986a08$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $aefa23277c986a08$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $aefa23277c986a08$var$hi,
    useDebugValue: $aefa23277c986a08$var$ri,
    useDeferredValue: function(a) {
        return $aefa23277c986a08$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $aefa23277c986a08$var$hi(!1), b = a[0];
        a = $aefa23277c986a08$var$vi.bind(null, a[1]);
        $aefa23277c986a08$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $aefa23277c986a08$var$M, e = $aefa23277c986a08$var$Th();
        if ($aefa23277c986a08$var$I) {
            if (void 0 === c) throw Error($aefa23277c986a08$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $aefa23277c986a08$var$Q) throw Error($aefa23277c986a08$var$p(349));
            0 !== ($aefa23277c986a08$var$Hh & 30) || $aefa23277c986a08$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $aefa23277c986a08$var$mi($aefa23277c986a08$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $aefa23277c986a08$var$bi(9, $aefa23277c986a08$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $aefa23277c986a08$var$Th(), b = $aefa23277c986a08$var$Q.identifierPrefix;
        if ($aefa23277c986a08$var$I) {
            var c = $aefa23277c986a08$var$sg;
            var d = $aefa23277c986a08$var$rg;
            c = (d & ~(1 << 32 - $aefa23277c986a08$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $aefa23277c986a08$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $aefa23277c986a08$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $aefa23277c986a08$var$Ph = {
    readContext: $aefa23277c986a08$var$eh,
    useCallback: $aefa23277c986a08$var$si,
    useContext: $aefa23277c986a08$var$eh,
    useEffect: $aefa23277c986a08$var$$h,
    useImperativeHandle: $aefa23277c986a08$var$qi,
    useInsertionEffect: $aefa23277c986a08$var$ni,
    useLayoutEffect: $aefa23277c986a08$var$oi,
    useMemo: $aefa23277c986a08$var$ti,
    useReducer: $aefa23277c986a08$var$Wh,
    useRef: $aefa23277c986a08$var$ji,
    useState: function() {
        return $aefa23277c986a08$var$Wh($aefa23277c986a08$var$Vh);
    },
    useDebugValue: $aefa23277c986a08$var$ri,
    useDeferredValue: function(a) {
        var b = $aefa23277c986a08$var$Uh();
        return $aefa23277c986a08$var$ui(b, $aefa23277c986a08$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $aefa23277c986a08$var$Wh($aefa23277c986a08$var$Vh)[0], b = $aefa23277c986a08$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $aefa23277c986a08$var$Yh,
    useSyncExternalStore: $aefa23277c986a08$var$Zh,
    useId: $aefa23277c986a08$var$wi,
    unstable_isNewReconciler: !1
}, $aefa23277c986a08$var$Qh = {
    readContext: $aefa23277c986a08$var$eh,
    useCallback: $aefa23277c986a08$var$si,
    useContext: $aefa23277c986a08$var$eh,
    useEffect: $aefa23277c986a08$var$$h,
    useImperativeHandle: $aefa23277c986a08$var$qi,
    useInsertionEffect: $aefa23277c986a08$var$ni,
    useLayoutEffect: $aefa23277c986a08$var$oi,
    useMemo: $aefa23277c986a08$var$ti,
    useReducer: $aefa23277c986a08$var$Xh,
    useRef: $aefa23277c986a08$var$ji,
    useState: function() {
        return $aefa23277c986a08$var$Xh($aefa23277c986a08$var$Vh);
    },
    useDebugValue: $aefa23277c986a08$var$ri,
    useDeferredValue: function(a) {
        var b = $aefa23277c986a08$var$Uh();
        return null === $aefa23277c986a08$var$N ? b.memoizedState = a : $aefa23277c986a08$var$ui(b, $aefa23277c986a08$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $aefa23277c986a08$var$Xh($aefa23277c986a08$var$Vh)[0], b = $aefa23277c986a08$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $aefa23277c986a08$var$Yh,
    useSyncExternalStore: $aefa23277c986a08$var$Zh,
    useId: $aefa23277c986a08$var$wi,
    unstable_isNewReconciler: !1
};
function $aefa23277c986a08$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $aefa23277c986a08$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $aefa23277c986a08$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $aefa23277c986a08$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $aefa23277c986a08$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $aefa23277c986a08$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $aefa23277c986a08$var$R(), e = $aefa23277c986a08$var$yi(a), f = $aefa23277c986a08$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $aefa23277c986a08$var$nh(a, f, e);
        null !== b && ($aefa23277c986a08$var$gi(b, a, e, d), $aefa23277c986a08$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $aefa23277c986a08$var$R(), e = $aefa23277c986a08$var$yi(a), f = $aefa23277c986a08$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $aefa23277c986a08$var$nh(a, f, e);
        null !== b && ($aefa23277c986a08$var$gi(b, a, e, d), $aefa23277c986a08$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $aefa23277c986a08$var$R(), d = $aefa23277c986a08$var$yi(a), e = $aefa23277c986a08$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $aefa23277c986a08$var$nh(a, e, d);
        null !== b && ($aefa23277c986a08$var$gi(b, a, d, c), $aefa23277c986a08$var$oh(b, a, d));
    }
};
function $aefa23277c986a08$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$aefa23277c986a08$var$Ie(c, d) || !$aefa23277c986a08$var$Ie(e, f) : !0;
}
function $aefa23277c986a08$var$Gi(a, b, c) {
    var d = !1, e = $aefa23277c986a08$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $aefa23277c986a08$var$eh(f) : (e = $aefa23277c986a08$var$Zf(b) ? $aefa23277c986a08$var$Xf : $aefa23277c986a08$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $aefa23277c986a08$var$Yf(a, e) : $aefa23277c986a08$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $aefa23277c986a08$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $aefa23277c986a08$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $aefa23277c986a08$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $aefa23277c986a08$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $aefa23277c986a08$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $aefa23277c986a08$var$eh(f) : (f = $aefa23277c986a08$var$Zf(b) ? $aefa23277c986a08$var$Xf : $aefa23277c986a08$var$H.current, e.context = $aefa23277c986a08$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($aefa23277c986a08$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $aefa23277c986a08$var$Ei.enqueueReplaceState(e, e.state, null), $aefa23277c986a08$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $aefa23277c986a08$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $aefa23277c986a08$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $aefa23277c986a08$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $aefa23277c986a08$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $aefa23277c986a08$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $aefa23277c986a08$var$Ni(a, b, c) {
    c = $aefa23277c986a08$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $aefa23277c986a08$var$Oi || ($aefa23277c986a08$var$Oi = !0, $aefa23277c986a08$var$Pi = d);
        $aefa23277c986a08$var$Li(a, b);
    };
    return c;
}
function $aefa23277c986a08$var$Qi(a, b, c) {
    c = $aefa23277c986a08$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $aefa23277c986a08$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $aefa23277c986a08$var$Li(a, b);
        "function" !== typeof d && (null === $aefa23277c986a08$var$Ri ? $aefa23277c986a08$var$Ri = new Set([
            this
        ]) : $aefa23277c986a08$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $aefa23277c986a08$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $aefa23277c986a08$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $aefa23277c986a08$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $aefa23277c986a08$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $aefa23277c986a08$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $aefa23277c986a08$var$mh(-1, 1), b.tag = 2, $aefa23277c986a08$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $aefa23277c986a08$var$Wi = $aefa23277c986a08$var$ua.ReactCurrentOwner, $aefa23277c986a08$var$dh = !1;
function $aefa23277c986a08$var$Xi(a, b, c, d) {
    b.child = null === a ? $aefa23277c986a08$var$Vg(b, null, c, d) : $aefa23277c986a08$var$Ug(b, a.child, c, d);
}
function $aefa23277c986a08$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $aefa23277c986a08$var$ch(b, e);
    d = $aefa23277c986a08$var$Nh(a, b, c, d, f, e);
    c = $aefa23277c986a08$var$Sh();
    if (null !== a && !$aefa23277c986a08$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $aefa23277c986a08$var$Zi(a, b, e);
    $aefa23277c986a08$var$I && c && $aefa23277c986a08$var$vg(b);
    b.flags |= 1;
    $aefa23277c986a08$var$Xi(a, b, d, e);
    return b.child;
}
function $aefa23277c986a08$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$aefa23277c986a08$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $aefa23277c986a08$var$bj(a, b, f, d, e);
        a = $aefa23277c986a08$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $aefa23277c986a08$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $aefa23277c986a08$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $aefa23277c986a08$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $aefa23277c986a08$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($aefa23277c986a08$var$Ie(f, d) && a.ref === b.ref) {
            if ($aefa23277c986a08$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($aefa23277c986a08$var$dh = !0);
            else return b.lanes = a.lanes, $aefa23277c986a08$var$Zi(a, b, e);
        }
    }
    return $aefa23277c986a08$var$cj(a, b, c, d, e);
}
function $aefa23277c986a08$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $aefa23277c986a08$var$G($aefa23277c986a08$var$ej, $aefa23277c986a08$var$fj), $aefa23277c986a08$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $aefa23277c986a08$var$G($aefa23277c986a08$var$ej, $aefa23277c986a08$var$fj), $aefa23277c986a08$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $aefa23277c986a08$var$G($aefa23277c986a08$var$ej, $aefa23277c986a08$var$fj);
            $aefa23277c986a08$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $aefa23277c986a08$var$G($aefa23277c986a08$var$ej, $aefa23277c986a08$var$fj), $aefa23277c986a08$var$fj |= d;
    $aefa23277c986a08$var$Xi(a, b, e, c);
    return b.child;
}
function $aefa23277c986a08$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $aefa23277c986a08$var$cj(a, b, c, d, e) {
    var f = $aefa23277c986a08$var$Zf(c) ? $aefa23277c986a08$var$Xf : $aefa23277c986a08$var$H.current;
    f = $aefa23277c986a08$var$Yf(b, f);
    $aefa23277c986a08$var$ch(b, e);
    c = $aefa23277c986a08$var$Nh(a, b, c, d, f, e);
    d = $aefa23277c986a08$var$Sh();
    if (null !== a && !$aefa23277c986a08$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $aefa23277c986a08$var$Zi(a, b, e);
    $aefa23277c986a08$var$I && d && $aefa23277c986a08$var$vg(b);
    b.flags |= 1;
    $aefa23277c986a08$var$Xi(a, b, c, e);
    return b.child;
}
function $aefa23277c986a08$var$hj(a, b, c, d, e) {
    if ($aefa23277c986a08$var$Zf(c)) {
        var f = !0;
        $aefa23277c986a08$var$cg(b);
    } else f = !1;
    $aefa23277c986a08$var$ch(b, e);
    if (null === b.stateNode) $aefa23277c986a08$var$ij(a, b), $aefa23277c986a08$var$Gi(b, c, d), $aefa23277c986a08$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $aefa23277c986a08$var$eh(l) : (l = $aefa23277c986a08$var$Zf(c) ? $aefa23277c986a08$var$Xf : $aefa23277c986a08$var$H.current, l = $aefa23277c986a08$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $aefa23277c986a08$var$Hi(b, g, d, l);
        $aefa23277c986a08$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $aefa23277c986a08$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $aefa23277c986a08$var$Wf.current || $aefa23277c986a08$var$jh ? ("function" === typeof m && ($aefa23277c986a08$var$Di(b, c, m, d), k = b.memoizedState), (h = $aefa23277c986a08$var$jh || $aefa23277c986a08$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $aefa23277c986a08$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $aefa23277c986a08$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $aefa23277c986a08$var$eh(k) : (k = $aefa23277c986a08$var$Zf(c) ? $aefa23277c986a08$var$Xf : $aefa23277c986a08$var$H.current, k = $aefa23277c986a08$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $aefa23277c986a08$var$Hi(b, g, d, k);
        $aefa23277c986a08$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $aefa23277c986a08$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $aefa23277c986a08$var$Wf.current || $aefa23277c986a08$var$jh ? ("function" === typeof y && ($aefa23277c986a08$var$Di(b, c, y, d), n = b.memoizedState), (l = $aefa23277c986a08$var$jh || $aefa23277c986a08$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $aefa23277c986a08$var$jj(a, b, c, d, f, e);
}
function $aefa23277c986a08$var$jj(a, b, c, d, e, f) {
    $aefa23277c986a08$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $aefa23277c986a08$var$dg(b, c, !1), $aefa23277c986a08$var$Zi(a, b, f);
    d = b.stateNode;
    $aefa23277c986a08$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $aefa23277c986a08$var$Ug(b, a.child, null, f), b.child = $aefa23277c986a08$var$Ug(b, null, h, f)) : $aefa23277c986a08$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $aefa23277c986a08$var$dg(b, c, !0);
    return b.child;
}
function $aefa23277c986a08$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $aefa23277c986a08$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $aefa23277c986a08$var$ag(a, b.context, !1);
    $aefa23277c986a08$var$yh(a, b.containerInfo);
}
function $aefa23277c986a08$var$lj(a, b, c, d, e) {
    $aefa23277c986a08$var$Ig();
    $aefa23277c986a08$var$Jg(e);
    b.flags |= 256;
    $aefa23277c986a08$var$Xi(a, b, c, d);
    return b.child;
}
var $aefa23277c986a08$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $aefa23277c986a08$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $aefa23277c986a08$var$oj(a, b, c) {
    var d = b.pendingProps, e = $aefa23277c986a08$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $aefa23277c986a08$var$G($aefa23277c986a08$var$L, e & 1);
    if (null === a) {
        $aefa23277c986a08$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $aefa23277c986a08$var$pj(g, d, 0, null), a = $aefa23277c986a08$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $aefa23277c986a08$var$nj(c), b.memoizedState = $aefa23277c986a08$var$mj, a) : $aefa23277c986a08$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $aefa23277c986a08$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $aefa23277c986a08$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $aefa23277c986a08$var$Pg(h, f) : (f = $aefa23277c986a08$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $aefa23277c986a08$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $aefa23277c986a08$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $aefa23277c986a08$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $aefa23277c986a08$var$qj(a, b) {
    b = $aefa23277c986a08$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $aefa23277c986a08$var$sj(a, b, c, d) {
    null !== d && $aefa23277c986a08$var$Jg(d);
    $aefa23277c986a08$var$Ug(b, a.child, null, c);
    a = $aefa23277c986a08$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $aefa23277c986a08$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $aefa23277c986a08$var$Ki(Error($aefa23277c986a08$var$p(422))), $aefa23277c986a08$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $aefa23277c986a08$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $aefa23277c986a08$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $aefa23277c986a08$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $aefa23277c986a08$var$nj(g);
        b.memoizedState = $aefa23277c986a08$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $aefa23277c986a08$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($aefa23277c986a08$var$p(419));
        d = $aefa23277c986a08$var$Ki(f, d, void 0);
        return $aefa23277c986a08$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($aefa23277c986a08$var$dh || h) {
        d = $aefa23277c986a08$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $aefa23277c986a08$var$ih(a, e), $aefa23277c986a08$var$gi(d, a, e, -1));
        }
        $aefa23277c986a08$var$tj();
        d = $aefa23277c986a08$var$Ki(Error($aefa23277c986a08$var$p(421)));
        return $aefa23277c986a08$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $aefa23277c986a08$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $aefa23277c986a08$var$yg = $aefa23277c986a08$var$Lf(e.nextSibling);
    $aefa23277c986a08$var$xg = b;
    $aefa23277c986a08$var$I = !0;
    $aefa23277c986a08$var$zg = null;
    null !== a && ($aefa23277c986a08$var$og[$aefa23277c986a08$var$pg++] = $aefa23277c986a08$var$rg, $aefa23277c986a08$var$og[$aefa23277c986a08$var$pg++] = $aefa23277c986a08$var$sg, $aefa23277c986a08$var$og[$aefa23277c986a08$var$pg++] = $aefa23277c986a08$var$qg, $aefa23277c986a08$var$rg = a.id, $aefa23277c986a08$var$sg = a.overflow, $aefa23277c986a08$var$qg = b);
    b = $aefa23277c986a08$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $aefa23277c986a08$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $aefa23277c986a08$var$bh(a.return, b, c);
}
function $aefa23277c986a08$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $aefa23277c986a08$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $aefa23277c986a08$var$Xi(a, b, d.children, c);
    d = $aefa23277c986a08$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $aefa23277c986a08$var$vj(a, c, b);
            else if (19 === a.tag) $aefa23277c986a08$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $aefa23277c986a08$var$G($aefa23277c986a08$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $aefa23277c986a08$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $aefa23277c986a08$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $aefa23277c986a08$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $aefa23277c986a08$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $aefa23277c986a08$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $aefa23277c986a08$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $aefa23277c986a08$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $aefa23277c986a08$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($aefa23277c986a08$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $aefa23277c986a08$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $aefa23277c986a08$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $aefa23277c986a08$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $aefa23277c986a08$var$kj(b);
            $aefa23277c986a08$var$Ig();
            break;
        case 5:
            $aefa23277c986a08$var$Ah(b);
            break;
        case 1:
            $aefa23277c986a08$var$Zf(b.type) && $aefa23277c986a08$var$cg(b);
            break;
        case 4:
            $aefa23277c986a08$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $aefa23277c986a08$var$G($aefa23277c986a08$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $aefa23277c986a08$var$G($aefa23277c986a08$var$L, $aefa23277c986a08$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $aefa23277c986a08$var$oj(a, b, c);
                $aefa23277c986a08$var$G($aefa23277c986a08$var$L, $aefa23277c986a08$var$L.current & 1);
                a = $aefa23277c986a08$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $aefa23277c986a08$var$G($aefa23277c986a08$var$L, $aefa23277c986a08$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $aefa23277c986a08$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $aefa23277c986a08$var$G($aefa23277c986a08$var$L, $aefa23277c986a08$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $aefa23277c986a08$var$dj(a, b, c);
    }
    return $aefa23277c986a08$var$Zi(a, b, c);
}
var $aefa23277c986a08$var$zj, $aefa23277c986a08$var$Aj, $aefa23277c986a08$var$Bj, $aefa23277c986a08$var$Cj;
$aefa23277c986a08$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$aefa23277c986a08$var$Aj = function() {};
$aefa23277c986a08$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $aefa23277c986a08$var$xh($aefa23277c986a08$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $aefa23277c986a08$var$Ya(a, e);
                d = $aefa23277c986a08$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $aefa23277c986a08$var$A({}, e, {
                    value: void 0
                });
                d = $aefa23277c986a08$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $aefa23277c986a08$var$gb(a, e);
                d = $aefa23277c986a08$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $aefa23277c986a08$var$Bf);
        }
        $aefa23277c986a08$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($aefa23277c986a08$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($aefa23277c986a08$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $aefa23277c986a08$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$aefa23277c986a08$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $aefa23277c986a08$var$Dj(a, b) {
    if (!$aefa23277c986a08$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $aefa23277c986a08$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $aefa23277c986a08$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $aefa23277c986a08$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $aefa23277c986a08$var$S(b), null;
        case 1:
            return $aefa23277c986a08$var$Zf(b.type) && $aefa23277c986a08$var$$f(), $aefa23277c986a08$var$S(b), null;
        case 3:
            d = b.stateNode;
            $aefa23277c986a08$var$zh();
            $aefa23277c986a08$var$E($aefa23277c986a08$var$Wf);
            $aefa23277c986a08$var$E($aefa23277c986a08$var$H);
            $aefa23277c986a08$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $aefa23277c986a08$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $aefa23277c986a08$var$zg && ($aefa23277c986a08$var$Fj($aefa23277c986a08$var$zg), $aefa23277c986a08$var$zg = null));
            $aefa23277c986a08$var$Aj(a, b);
            $aefa23277c986a08$var$S(b);
            return null;
        case 5:
            $aefa23277c986a08$var$Bh(b);
            var e = $aefa23277c986a08$var$xh($aefa23277c986a08$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $aefa23277c986a08$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($aefa23277c986a08$var$p(166));
                    $aefa23277c986a08$var$S(b);
                    return null;
                }
                a = $aefa23277c986a08$var$xh($aefa23277c986a08$var$uh.current);
                if ($aefa23277c986a08$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$aefa23277c986a08$var$Of] = b;
                    d[$aefa23277c986a08$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $aefa23277c986a08$var$D("cancel", d);
                            $aefa23277c986a08$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $aefa23277c986a08$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $aefa23277c986a08$var$lf.length; e++)$aefa23277c986a08$var$D($aefa23277c986a08$var$lf[e], d);
                            break;
                        case "source":
                            $aefa23277c986a08$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $aefa23277c986a08$var$D("error", d);
                            $aefa23277c986a08$var$D("load", d);
                            break;
                        case "details":
                            $aefa23277c986a08$var$D("toggle", d);
                            break;
                        case "input":
                            $aefa23277c986a08$var$Za(d, f);
                            $aefa23277c986a08$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $aefa23277c986a08$var$D("invalid", d);
                            break;
                        case "textarea":
                            $aefa23277c986a08$var$hb(d, f), $aefa23277c986a08$var$D("invalid", d);
                    }
                    $aefa23277c986a08$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $aefa23277c986a08$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $aefa23277c986a08$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $aefa23277c986a08$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $aefa23277c986a08$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $aefa23277c986a08$var$Va(d);
                            $aefa23277c986a08$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $aefa23277c986a08$var$Va(d);
                            $aefa23277c986a08$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $aefa23277c986a08$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $aefa23277c986a08$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$aefa23277c986a08$var$Of] = b;
                    a[$aefa23277c986a08$var$Pf] = d;
                    $aefa23277c986a08$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $aefa23277c986a08$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $aefa23277c986a08$var$D("cancel", a);
                                $aefa23277c986a08$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $aefa23277c986a08$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $aefa23277c986a08$var$lf.length; e++)$aefa23277c986a08$var$D($aefa23277c986a08$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $aefa23277c986a08$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $aefa23277c986a08$var$D("error", a);
                                $aefa23277c986a08$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $aefa23277c986a08$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $aefa23277c986a08$var$Za(a, d);
                                e = $aefa23277c986a08$var$Ya(a, d);
                                $aefa23277c986a08$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $aefa23277c986a08$var$A({}, d, {
                                    value: void 0
                                });
                                $aefa23277c986a08$var$D("invalid", a);
                                break;
                            case "textarea":
                                $aefa23277c986a08$var$hb(a, d);
                                e = $aefa23277c986a08$var$gb(a, d);
                                $aefa23277c986a08$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $aefa23277c986a08$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $aefa23277c986a08$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $aefa23277c986a08$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $aefa23277c986a08$var$ob(a, k) : "number" === typeof k && $aefa23277c986a08$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($aefa23277c986a08$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $aefa23277c986a08$var$D("scroll", a) : null != k && $aefa23277c986a08$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $aefa23277c986a08$var$Va(a);
                                $aefa23277c986a08$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $aefa23277c986a08$var$Va(a);
                                $aefa23277c986a08$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $aefa23277c986a08$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $aefa23277c986a08$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $aefa23277c986a08$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $aefa23277c986a08$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $aefa23277c986a08$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $aefa23277c986a08$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($aefa23277c986a08$var$p(166));
                c = $aefa23277c986a08$var$xh($aefa23277c986a08$var$wh.current);
                $aefa23277c986a08$var$xh($aefa23277c986a08$var$uh.current);
                if ($aefa23277c986a08$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$aefa23277c986a08$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $aefa23277c986a08$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $aefa23277c986a08$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $aefa23277c986a08$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$aefa23277c986a08$var$Of] = b, b.stateNode = d;
            }
            $aefa23277c986a08$var$S(b);
            return null;
        case 13:
            $aefa23277c986a08$var$E($aefa23277c986a08$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($aefa23277c986a08$var$I && null !== $aefa23277c986a08$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $aefa23277c986a08$var$Hg(), $aefa23277c986a08$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $aefa23277c986a08$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($aefa23277c986a08$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($aefa23277c986a08$var$p(317));
                        f[$aefa23277c986a08$var$Of] = b;
                    } else $aefa23277c986a08$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $aefa23277c986a08$var$S(b);
                    f = !1;
                } else null !== $aefa23277c986a08$var$zg && ($aefa23277c986a08$var$Fj($aefa23277c986a08$var$zg), $aefa23277c986a08$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($aefa23277c986a08$var$L.current & 1) ? 0 === $aefa23277c986a08$var$T && ($aefa23277c986a08$var$T = 3) : $aefa23277c986a08$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $aefa23277c986a08$var$S(b);
            return null;
        case 4:
            return $aefa23277c986a08$var$zh(), $aefa23277c986a08$var$Aj(a, b), null === a && $aefa23277c986a08$var$sf(b.stateNode.containerInfo), $aefa23277c986a08$var$S(b), null;
        case 10:
            return $aefa23277c986a08$var$ah(b.type._context), $aefa23277c986a08$var$S(b), null;
        case 17:
            return $aefa23277c986a08$var$Zf(b.type) && $aefa23277c986a08$var$$f(), $aefa23277c986a08$var$S(b), null;
        case 19:
            $aefa23277c986a08$var$E($aefa23277c986a08$var$L);
            f = b.memoizedState;
            if (null === f) return $aefa23277c986a08$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $aefa23277c986a08$var$Dj(f, !1);
                else {
                    if (0 !== $aefa23277c986a08$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $aefa23277c986a08$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $aefa23277c986a08$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $aefa23277c986a08$var$G($aefa23277c986a08$var$L, $aefa23277c986a08$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $aefa23277c986a08$var$B() > $aefa23277c986a08$var$Gj && (b.flags |= 128, d = !0, $aefa23277c986a08$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $aefa23277c986a08$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $aefa23277c986a08$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$aefa23277c986a08$var$I) return $aefa23277c986a08$var$S(b), null;
                    } else 2 * $aefa23277c986a08$var$B() - f.renderingStartTime > $aefa23277c986a08$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $aefa23277c986a08$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $aefa23277c986a08$var$B(), b.sibling = null, c = $aefa23277c986a08$var$L.current, $aefa23277c986a08$var$G($aefa23277c986a08$var$L, d ? c & 1 | 2 : c & 1), b;
            $aefa23277c986a08$var$S(b);
            return null;
        case 22:
        case 23:
            return $aefa23277c986a08$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($aefa23277c986a08$var$fj & 1073741824) && ($aefa23277c986a08$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $aefa23277c986a08$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($aefa23277c986a08$var$p(156, b.tag));
}
function $aefa23277c986a08$var$Ij(a, b) {
    $aefa23277c986a08$var$wg(b);
    switch(b.tag){
        case 1:
            return $aefa23277c986a08$var$Zf(b.type) && $aefa23277c986a08$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $aefa23277c986a08$var$zh(), $aefa23277c986a08$var$E($aefa23277c986a08$var$Wf), $aefa23277c986a08$var$E($aefa23277c986a08$var$H), $aefa23277c986a08$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $aefa23277c986a08$var$Bh(b), null;
        case 13:
            $aefa23277c986a08$var$E($aefa23277c986a08$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($aefa23277c986a08$var$p(340));
                $aefa23277c986a08$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $aefa23277c986a08$var$E($aefa23277c986a08$var$L), null;
        case 4:
            return $aefa23277c986a08$var$zh(), null;
        case 10:
            return $aefa23277c986a08$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $aefa23277c986a08$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $aefa23277c986a08$var$Jj = !1, $aefa23277c986a08$var$U = !1, $aefa23277c986a08$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $aefa23277c986a08$var$V = null;
function $aefa23277c986a08$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $aefa23277c986a08$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $aefa23277c986a08$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $aefa23277c986a08$var$W(a, b, d);
    }
}
var $aefa23277c986a08$var$Nj = !1;
function $aefa23277c986a08$var$Oj(a, b) {
    $aefa23277c986a08$var$Cf = $aefa23277c986a08$var$dd;
    a = $aefa23277c986a08$var$Me();
    if ($aefa23277c986a08$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $aefa23277c986a08$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $aefa23277c986a08$var$dd = !1;
    for($aefa23277c986a08$var$V = b; null !== $aefa23277c986a08$var$V;)if (b = $aefa23277c986a08$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $aefa23277c986a08$var$V = a;
    else for(; null !== $aefa23277c986a08$var$V;){
        b = $aefa23277c986a08$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $aefa23277c986a08$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($aefa23277c986a08$var$p(163));
            }
        } catch (F) {
            $aefa23277c986a08$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $aefa23277c986a08$var$V = a;
            break;
        }
        $aefa23277c986a08$var$V = b.return;
    }
    n = $aefa23277c986a08$var$Nj;
    $aefa23277c986a08$var$Nj = !1;
    return n;
}
function $aefa23277c986a08$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $aefa23277c986a08$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $aefa23277c986a08$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $aefa23277c986a08$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $aefa23277c986a08$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $aefa23277c986a08$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$aefa23277c986a08$var$Of], delete b[$aefa23277c986a08$var$Pf], delete b[$aefa23277c986a08$var$of], delete b[$aefa23277c986a08$var$Qf], delete b[$aefa23277c986a08$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $aefa23277c986a08$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $aefa23277c986a08$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $aefa23277c986a08$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $aefa23277c986a08$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $aefa23277c986a08$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($aefa23277c986a08$var$Vj(a, b, c), a = a.sibling; null !== a;)$aefa23277c986a08$var$Vj(a, b, c), a = a.sibling;
}
function $aefa23277c986a08$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($aefa23277c986a08$var$Wj(a, b, c), a = a.sibling; null !== a;)$aefa23277c986a08$var$Wj(a, b, c), a = a.sibling;
}
var $aefa23277c986a08$var$X = null, $aefa23277c986a08$var$Xj = !1;
function $aefa23277c986a08$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$aefa23277c986a08$var$Zj(a, b, c), c = c.sibling;
}
function $aefa23277c986a08$var$Zj(a, b, c) {
    if ($aefa23277c986a08$var$lc && "function" === typeof $aefa23277c986a08$var$lc.onCommitFiberUnmount) try {
        $aefa23277c986a08$var$lc.onCommitFiberUnmount($aefa23277c986a08$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $aefa23277c986a08$var$U || $aefa23277c986a08$var$Lj(c, b);
        case 6:
            var d = $aefa23277c986a08$var$X, e = $aefa23277c986a08$var$Xj;
            $aefa23277c986a08$var$X = null;
            $aefa23277c986a08$var$Yj(a, b, c);
            $aefa23277c986a08$var$X = d;
            $aefa23277c986a08$var$Xj = e;
            null !== $aefa23277c986a08$var$X && ($aefa23277c986a08$var$Xj ? (a = $aefa23277c986a08$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $aefa23277c986a08$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $aefa23277c986a08$var$X && ($aefa23277c986a08$var$Xj ? (a = $aefa23277c986a08$var$X, c = c.stateNode, 8 === a.nodeType ? $aefa23277c986a08$var$Kf(a.parentNode, c) : 1 === a.nodeType && $aefa23277c986a08$var$Kf(a, c), $aefa23277c986a08$var$bd(a)) : $aefa23277c986a08$var$Kf($aefa23277c986a08$var$X, c.stateNode));
            break;
        case 4:
            d = $aefa23277c986a08$var$X;
            e = $aefa23277c986a08$var$Xj;
            $aefa23277c986a08$var$X = c.stateNode.containerInfo;
            $aefa23277c986a08$var$Xj = !0;
            $aefa23277c986a08$var$Yj(a, b, c);
            $aefa23277c986a08$var$X = d;
            $aefa23277c986a08$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$aefa23277c986a08$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $aefa23277c986a08$var$Mj(c, b, g) : 0 !== (f & 4) && $aefa23277c986a08$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $aefa23277c986a08$var$Yj(a, b, c);
            break;
        case 1:
            if (!$aefa23277c986a08$var$U && ($aefa23277c986a08$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $aefa23277c986a08$var$W(c, b, h);
            }
            $aefa23277c986a08$var$Yj(a, b, c);
            break;
        case 21:
            $aefa23277c986a08$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($aefa23277c986a08$var$U = (d = $aefa23277c986a08$var$U) || null !== c.memoizedState, $aefa23277c986a08$var$Yj(a, b, c), $aefa23277c986a08$var$U = d) : $aefa23277c986a08$var$Yj(a, b, c);
            break;
        default:
            $aefa23277c986a08$var$Yj(a, b, c);
    }
}
function $aefa23277c986a08$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $aefa23277c986a08$var$Kj);
        b.forEach(function(b) {
            var d = $aefa23277c986a08$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $aefa23277c986a08$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $aefa23277c986a08$var$X = h.stateNode;
                        $aefa23277c986a08$var$Xj = !1;
                        break a;
                    case 3:
                        $aefa23277c986a08$var$X = h.stateNode.containerInfo;
                        $aefa23277c986a08$var$Xj = !0;
                        break a;
                    case 4:
                        $aefa23277c986a08$var$X = h.stateNode.containerInfo;
                        $aefa23277c986a08$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $aefa23277c986a08$var$X) throw Error($aefa23277c986a08$var$p(160));
            $aefa23277c986a08$var$Zj(f, g, e);
            $aefa23277c986a08$var$X = null;
            $aefa23277c986a08$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $aefa23277c986a08$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$aefa23277c986a08$var$dk(b, a), b = b.sibling;
}
function $aefa23277c986a08$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $aefa23277c986a08$var$ck(b, a);
            $aefa23277c986a08$var$ek(a);
            if (d & 4) {
                try {
                    $aefa23277c986a08$var$Pj(3, a, a.return), $aefa23277c986a08$var$Qj(3, a);
                } catch (t) {
                    $aefa23277c986a08$var$W(a, a.return, t);
                }
                try {
                    $aefa23277c986a08$var$Pj(5, a, a.return);
                } catch (t) {
                    $aefa23277c986a08$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $aefa23277c986a08$var$ck(b, a);
            $aefa23277c986a08$var$ek(a);
            d & 512 && null !== c && $aefa23277c986a08$var$Lj(c, c.return);
            break;
        case 5:
            $aefa23277c986a08$var$ck(b, a);
            $aefa23277c986a08$var$ek(a);
            d & 512 && null !== c && $aefa23277c986a08$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $aefa23277c986a08$var$ob(e, "");
                } catch (t) {
                    $aefa23277c986a08$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $aefa23277c986a08$var$ab(e, f);
                    $aefa23277c986a08$var$vb(h, g);
                    var l = $aefa23277c986a08$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $aefa23277c986a08$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $aefa23277c986a08$var$nb(e, q) : "children" === m ? $aefa23277c986a08$var$ob(e, q) : $aefa23277c986a08$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $aefa23277c986a08$var$bb(e, f);
                            break;
                        case "textarea":
                            $aefa23277c986a08$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $aefa23277c986a08$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $aefa23277c986a08$var$fb(e, !!f.multiple, f.defaultValue, !0) : $aefa23277c986a08$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$aefa23277c986a08$var$Pf] = f;
                } catch (t) {
                    $aefa23277c986a08$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $aefa23277c986a08$var$ck(b, a);
            $aefa23277c986a08$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($aefa23277c986a08$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $aefa23277c986a08$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $aefa23277c986a08$var$ck(b, a);
            $aefa23277c986a08$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $aefa23277c986a08$var$bd(b.containerInfo);
            } catch (t) {
                $aefa23277c986a08$var$W(a, a.return, t);
            }
            break;
        case 4:
            $aefa23277c986a08$var$ck(b, a);
            $aefa23277c986a08$var$ek(a);
            break;
        case 13:
            $aefa23277c986a08$var$ck(b, a);
            $aefa23277c986a08$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($aefa23277c986a08$var$fk = $aefa23277c986a08$var$B()));
            d & 4 && $aefa23277c986a08$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($aefa23277c986a08$var$U = (l = $aefa23277c986a08$var$U) || m, $aefa23277c986a08$var$ck(b, a), $aefa23277c986a08$var$U = l) : $aefa23277c986a08$var$ck(b, a);
            $aefa23277c986a08$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($aefa23277c986a08$var$V = a, m = a.child; null !== m;){
                    for(q = $aefa23277c986a08$var$V = m; null !== $aefa23277c986a08$var$V;){
                        r = $aefa23277c986a08$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $aefa23277c986a08$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $aefa23277c986a08$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $aefa23277c986a08$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $aefa23277c986a08$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $aefa23277c986a08$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $aefa23277c986a08$var$V = y) : $aefa23277c986a08$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $aefa23277c986a08$var$rb("display", g));
                            } catch (t) {
                                $aefa23277c986a08$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $aefa23277c986a08$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $aefa23277c986a08$var$ck(b, a);
            $aefa23277c986a08$var$ek(a);
            d & 4 && $aefa23277c986a08$var$ak(a);
            break;
        case 21:
            break;
        default:
            $aefa23277c986a08$var$ck(b, a), $aefa23277c986a08$var$ek(a);
    }
}
function $aefa23277c986a08$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($aefa23277c986a08$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($aefa23277c986a08$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($aefa23277c986a08$var$ob(e, ""), d.flags &= -33);
                    var f = $aefa23277c986a08$var$Uj(a);
                    $aefa23277c986a08$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $aefa23277c986a08$var$Uj(a);
                    $aefa23277c986a08$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($aefa23277c986a08$var$p(161));
            }
        } catch (k) {
            $aefa23277c986a08$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $aefa23277c986a08$var$hk(a, b, c) {
    $aefa23277c986a08$var$V = a;
    $aefa23277c986a08$var$ik(a, b, c);
}
function $aefa23277c986a08$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $aefa23277c986a08$var$V;){
        var e = $aefa23277c986a08$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $aefa23277c986a08$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $aefa23277c986a08$var$U;
                h = $aefa23277c986a08$var$Jj;
                var l = $aefa23277c986a08$var$U;
                $aefa23277c986a08$var$Jj = g;
                if (($aefa23277c986a08$var$U = k) && !l) for($aefa23277c986a08$var$V = e; null !== $aefa23277c986a08$var$V;)g = $aefa23277c986a08$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $aefa23277c986a08$var$jk(e) : null !== k ? (k.return = g, $aefa23277c986a08$var$V = k) : $aefa23277c986a08$var$jk(e);
                for(; null !== f;)$aefa23277c986a08$var$V = f, $aefa23277c986a08$var$ik(f, b, c), f = f.sibling;
                $aefa23277c986a08$var$V = e;
                $aefa23277c986a08$var$Jj = h;
                $aefa23277c986a08$var$U = l;
            }
            $aefa23277c986a08$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $aefa23277c986a08$var$V = f) : $aefa23277c986a08$var$kk(a, b, c);
    }
}
function $aefa23277c986a08$var$kk(a) {
    for(; null !== $aefa23277c986a08$var$V;){
        var b = $aefa23277c986a08$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $aefa23277c986a08$var$U || $aefa23277c986a08$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$aefa23277c986a08$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $aefa23277c986a08$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $aefa23277c986a08$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $aefa23277c986a08$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $aefa23277c986a08$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($aefa23277c986a08$var$p(163));
                }
                $aefa23277c986a08$var$U || b.flags & 512 && $aefa23277c986a08$var$Rj(b);
            } catch (r) {
                $aefa23277c986a08$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $aefa23277c986a08$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $aefa23277c986a08$var$V = c;
            break;
        }
        $aefa23277c986a08$var$V = b.return;
    }
}
function $aefa23277c986a08$var$gk(a) {
    for(; null !== $aefa23277c986a08$var$V;){
        var b = $aefa23277c986a08$var$V;
        if (b === a) {
            $aefa23277c986a08$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $aefa23277c986a08$var$V = c;
            break;
        }
        $aefa23277c986a08$var$V = b.return;
    }
}
function $aefa23277c986a08$var$jk(a) {
    for(; null !== $aefa23277c986a08$var$V;){
        var b = $aefa23277c986a08$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $aefa23277c986a08$var$Qj(4, b);
                    } catch (k) {
                        $aefa23277c986a08$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $aefa23277c986a08$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $aefa23277c986a08$var$Rj(b);
                    } catch (k) {
                        $aefa23277c986a08$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $aefa23277c986a08$var$Rj(b);
                    } catch (k) {
                        $aefa23277c986a08$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $aefa23277c986a08$var$W(b, b.return, k);
        }
        if (b === a) {
            $aefa23277c986a08$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $aefa23277c986a08$var$V = h;
            break;
        }
        $aefa23277c986a08$var$V = b.return;
    }
}
var $aefa23277c986a08$var$lk = Math.ceil, $aefa23277c986a08$var$mk = $aefa23277c986a08$var$ua.ReactCurrentDispatcher, $aefa23277c986a08$var$nk = $aefa23277c986a08$var$ua.ReactCurrentOwner, $aefa23277c986a08$var$ok = $aefa23277c986a08$var$ua.ReactCurrentBatchConfig, $aefa23277c986a08$var$K = 0, $aefa23277c986a08$var$Q = null, $aefa23277c986a08$var$Y = null, $aefa23277c986a08$var$Z = 0, $aefa23277c986a08$var$fj = 0, $aefa23277c986a08$var$ej = $aefa23277c986a08$var$Uf(0), $aefa23277c986a08$var$T = 0, $aefa23277c986a08$var$pk = null, $aefa23277c986a08$var$rh = 0, $aefa23277c986a08$var$qk = 0, $aefa23277c986a08$var$rk = 0, $aefa23277c986a08$var$sk = null, $aefa23277c986a08$var$tk = null, $aefa23277c986a08$var$fk = 0, $aefa23277c986a08$var$Gj = Infinity, $aefa23277c986a08$var$uk = null, $aefa23277c986a08$var$Oi = !1, $aefa23277c986a08$var$Pi = null, $aefa23277c986a08$var$Ri = null, $aefa23277c986a08$var$vk = !1, $aefa23277c986a08$var$wk = null, $aefa23277c986a08$var$xk = 0, $aefa23277c986a08$var$yk = 0, $aefa23277c986a08$var$zk = null, $aefa23277c986a08$var$Ak = -1, $aefa23277c986a08$var$Bk = 0;
function $aefa23277c986a08$var$R() {
    return 0 !== ($aefa23277c986a08$var$K & 6) ? $aefa23277c986a08$var$B() : -1 !== $aefa23277c986a08$var$Ak ? $aefa23277c986a08$var$Ak : $aefa23277c986a08$var$Ak = $aefa23277c986a08$var$B();
}
function $aefa23277c986a08$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($aefa23277c986a08$var$K & 2) && 0 !== $aefa23277c986a08$var$Z) return $aefa23277c986a08$var$Z & -$aefa23277c986a08$var$Z;
    if (null !== $aefa23277c986a08$var$Kg.transition) return 0 === $aefa23277c986a08$var$Bk && ($aefa23277c986a08$var$Bk = $aefa23277c986a08$var$yc()), $aefa23277c986a08$var$Bk;
    a = $aefa23277c986a08$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $aefa23277c986a08$var$jd(a.type);
    return a;
}
function $aefa23277c986a08$var$gi(a, b, c, d) {
    if (50 < $aefa23277c986a08$var$yk) throw $aefa23277c986a08$var$yk = 0, $aefa23277c986a08$var$zk = null, Error($aefa23277c986a08$var$p(185));
    $aefa23277c986a08$var$Ac(a, c, d);
    if (0 === ($aefa23277c986a08$var$K & 2) || a !== $aefa23277c986a08$var$Q) a === $aefa23277c986a08$var$Q && (0 === ($aefa23277c986a08$var$K & 2) && ($aefa23277c986a08$var$qk |= c), 4 === $aefa23277c986a08$var$T && $aefa23277c986a08$var$Ck(a, $aefa23277c986a08$var$Z)), $aefa23277c986a08$var$Dk(a, d), 1 === c && 0 === $aefa23277c986a08$var$K && 0 === (b.mode & 1) && ($aefa23277c986a08$var$Gj = $aefa23277c986a08$var$B() + 500, $aefa23277c986a08$var$fg && $aefa23277c986a08$var$jg());
}
function $aefa23277c986a08$var$Dk(a, b) {
    var c = a.callbackNode;
    $aefa23277c986a08$var$wc(a, b);
    var d = $aefa23277c986a08$var$uc(a, a === $aefa23277c986a08$var$Q ? $aefa23277c986a08$var$Z : 0);
    if (0 === d) null !== c && $aefa23277c986a08$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $aefa23277c986a08$var$bc(c);
        if (1 === b) 0 === a.tag ? $aefa23277c986a08$var$ig($aefa23277c986a08$var$Ek.bind(null, a)) : $aefa23277c986a08$var$hg($aefa23277c986a08$var$Ek.bind(null, a)), $aefa23277c986a08$var$Jf(function() {
            0 === ($aefa23277c986a08$var$K & 6) && $aefa23277c986a08$var$jg();
        }), c = null;
        else {
            switch($aefa23277c986a08$var$Dc(d)){
                case 1:
                    c = $aefa23277c986a08$var$fc;
                    break;
                case 4:
                    c = $aefa23277c986a08$var$gc;
                    break;
                case 16:
                    c = $aefa23277c986a08$var$hc;
                    break;
                case 536870912:
                    c = $aefa23277c986a08$var$jc;
                    break;
                default:
                    c = $aefa23277c986a08$var$hc;
            }
            c = $aefa23277c986a08$var$Fk(c, $aefa23277c986a08$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $aefa23277c986a08$var$Gk(a, b) {
    $aefa23277c986a08$var$Ak = -1;
    $aefa23277c986a08$var$Bk = 0;
    if (0 !== ($aefa23277c986a08$var$K & 6)) throw Error($aefa23277c986a08$var$p(327));
    var c = a.callbackNode;
    if ($aefa23277c986a08$var$Hk() && a.callbackNode !== c) return null;
    var d = $aefa23277c986a08$var$uc(a, a === $aefa23277c986a08$var$Q ? $aefa23277c986a08$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $aefa23277c986a08$var$Ik(a, d);
    else {
        b = d;
        var e = $aefa23277c986a08$var$K;
        $aefa23277c986a08$var$K |= 2;
        var f = $aefa23277c986a08$var$Jk();
        if ($aefa23277c986a08$var$Q !== a || $aefa23277c986a08$var$Z !== b) $aefa23277c986a08$var$uk = null, $aefa23277c986a08$var$Gj = $aefa23277c986a08$var$B() + 500, $aefa23277c986a08$var$Kk(a, b);
        for(;;)try {
            $aefa23277c986a08$var$Lk();
            break;
        } catch (h) {
            $aefa23277c986a08$var$Mk(a, h);
        }
        $aefa23277c986a08$var$$g();
        $aefa23277c986a08$var$mk.current = f;
        $aefa23277c986a08$var$K = e;
        null !== $aefa23277c986a08$var$Y ? b = 0 : ($aefa23277c986a08$var$Q = null, $aefa23277c986a08$var$Z = 0, b = $aefa23277c986a08$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $aefa23277c986a08$var$xc(a), 0 !== e && (d = e, b = $aefa23277c986a08$var$Nk(a, e)));
        if (1 === b) throw c = $aefa23277c986a08$var$pk, $aefa23277c986a08$var$Kk(a, 0), $aefa23277c986a08$var$Ck(a, d), $aefa23277c986a08$var$Dk(a, $aefa23277c986a08$var$B()), c;
        if (6 === b) $aefa23277c986a08$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$aefa23277c986a08$var$Ok(e) && (b = $aefa23277c986a08$var$Ik(a, d), 2 === b && (f = $aefa23277c986a08$var$xc(a), 0 !== f && (d = f, b = $aefa23277c986a08$var$Nk(a, f))), 1 === b)) throw c = $aefa23277c986a08$var$pk, $aefa23277c986a08$var$Kk(a, 0), $aefa23277c986a08$var$Ck(a, d), $aefa23277c986a08$var$Dk(a, $aefa23277c986a08$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($aefa23277c986a08$var$p(345));
                case 2:
                    $aefa23277c986a08$var$Pk(a, $aefa23277c986a08$var$tk, $aefa23277c986a08$var$uk);
                    break;
                case 3:
                    $aefa23277c986a08$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $aefa23277c986a08$var$fk + 500 - $aefa23277c986a08$var$B(), 10 < b)) {
                        if (0 !== $aefa23277c986a08$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $aefa23277c986a08$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $aefa23277c986a08$var$Ff($aefa23277c986a08$var$Pk.bind(null, a, $aefa23277c986a08$var$tk, $aefa23277c986a08$var$uk), b);
                        break;
                    }
                    $aefa23277c986a08$var$Pk(a, $aefa23277c986a08$var$tk, $aefa23277c986a08$var$uk);
                    break;
                case 4:
                    $aefa23277c986a08$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $aefa23277c986a08$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $aefa23277c986a08$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $aefa23277c986a08$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $aefa23277c986a08$var$Ff($aefa23277c986a08$var$Pk.bind(null, a, $aefa23277c986a08$var$tk, $aefa23277c986a08$var$uk), d);
                        break;
                    }
                    $aefa23277c986a08$var$Pk(a, $aefa23277c986a08$var$tk, $aefa23277c986a08$var$uk);
                    break;
                case 5:
                    $aefa23277c986a08$var$Pk(a, $aefa23277c986a08$var$tk, $aefa23277c986a08$var$uk);
                    break;
                default:
                    throw Error($aefa23277c986a08$var$p(329));
            }
        }
    }
    $aefa23277c986a08$var$Dk(a, $aefa23277c986a08$var$B());
    return a.callbackNode === c ? $aefa23277c986a08$var$Gk.bind(null, a) : null;
}
function $aefa23277c986a08$var$Nk(a, b) {
    var c = $aefa23277c986a08$var$sk;
    a.current.memoizedState.isDehydrated && ($aefa23277c986a08$var$Kk(a, b).flags |= 256);
    a = $aefa23277c986a08$var$Ik(a, b);
    2 !== a && (b = $aefa23277c986a08$var$tk, $aefa23277c986a08$var$tk = c, null !== b && $aefa23277c986a08$var$Fj(b));
    return a;
}
function $aefa23277c986a08$var$Fj(a) {
    null === $aefa23277c986a08$var$tk ? $aefa23277c986a08$var$tk = a : $aefa23277c986a08$var$tk.push.apply($aefa23277c986a08$var$tk, a);
}
function $aefa23277c986a08$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$aefa23277c986a08$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $aefa23277c986a08$var$Ck(a, b) {
    b &= ~$aefa23277c986a08$var$rk;
    b &= ~$aefa23277c986a08$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $aefa23277c986a08$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $aefa23277c986a08$var$Ek(a) {
    if (0 !== ($aefa23277c986a08$var$K & 6)) throw Error($aefa23277c986a08$var$p(327));
    $aefa23277c986a08$var$Hk();
    var b = $aefa23277c986a08$var$uc(a, 0);
    if (0 === (b & 1)) return $aefa23277c986a08$var$Dk(a, $aefa23277c986a08$var$B()), null;
    var c = $aefa23277c986a08$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $aefa23277c986a08$var$xc(a);
        0 !== d && (b = d, c = $aefa23277c986a08$var$Nk(a, d));
    }
    if (1 === c) throw c = $aefa23277c986a08$var$pk, $aefa23277c986a08$var$Kk(a, 0), $aefa23277c986a08$var$Ck(a, b), $aefa23277c986a08$var$Dk(a, $aefa23277c986a08$var$B()), c;
    if (6 === c) throw Error($aefa23277c986a08$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $aefa23277c986a08$var$Pk(a, $aefa23277c986a08$var$tk, $aefa23277c986a08$var$uk);
    $aefa23277c986a08$var$Dk(a, $aefa23277c986a08$var$B());
    return null;
}
function $aefa23277c986a08$var$Qk(a, b) {
    var c = $aefa23277c986a08$var$K;
    $aefa23277c986a08$var$K |= 1;
    try {
        return a(b);
    } finally{
        $aefa23277c986a08$var$K = c, 0 === $aefa23277c986a08$var$K && ($aefa23277c986a08$var$Gj = $aefa23277c986a08$var$B() + 500, $aefa23277c986a08$var$fg && $aefa23277c986a08$var$jg());
    }
}
function $aefa23277c986a08$var$Rk(a) {
    null !== $aefa23277c986a08$var$wk && 0 === $aefa23277c986a08$var$wk.tag && 0 === ($aefa23277c986a08$var$K & 6) && $aefa23277c986a08$var$Hk();
    var b = $aefa23277c986a08$var$K;
    $aefa23277c986a08$var$K |= 1;
    var c = $aefa23277c986a08$var$ok.transition, d = $aefa23277c986a08$var$C;
    try {
        if ($aefa23277c986a08$var$ok.transition = null, $aefa23277c986a08$var$C = 1, a) return a();
    } finally{
        $aefa23277c986a08$var$C = d, $aefa23277c986a08$var$ok.transition = c, $aefa23277c986a08$var$K = b, 0 === ($aefa23277c986a08$var$K & 6) && $aefa23277c986a08$var$jg();
    }
}
function $aefa23277c986a08$var$Hj() {
    $aefa23277c986a08$var$fj = $aefa23277c986a08$var$ej.current;
    $aefa23277c986a08$var$E($aefa23277c986a08$var$ej);
}
function $aefa23277c986a08$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $aefa23277c986a08$var$Gf(c));
    if (null !== $aefa23277c986a08$var$Y) for(c = $aefa23277c986a08$var$Y.return; null !== c;){
        var d = c;
        $aefa23277c986a08$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $aefa23277c986a08$var$$f();
                break;
            case 3:
                $aefa23277c986a08$var$zh();
                $aefa23277c986a08$var$E($aefa23277c986a08$var$Wf);
                $aefa23277c986a08$var$E($aefa23277c986a08$var$H);
                $aefa23277c986a08$var$Eh();
                break;
            case 5:
                $aefa23277c986a08$var$Bh(d);
                break;
            case 4:
                $aefa23277c986a08$var$zh();
                break;
            case 13:
                $aefa23277c986a08$var$E($aefa23277c986a08$var$L);
                break;
            case 19:
                $aefa23277c986a08$var$E($aefa23277c986a08$var$L);
                break;
            case 10:
                $aefa23277c986a08$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $aefa23277c986a08$var$Hj();
        }
        c = c.return;
    }
    $aefa23277c986a08$var$Q = a;
    $aefa23277c986a08$var$Y = a = $aefa23277c986a08$var$Pg(a.current, null);
    $aefa23277c986a08$var$Z = $aefa23277c986a08$var$fj = b;
    $aefa23277c986a08$var$T = 0;
    $aefa23277c986a08$var$pk = null;
    $aefa23277c986a08$var$rk = $aefa23277c986a08$var$qk = $aefa23277c986a08$var$rh = 0;
    $aefa23277c986a08$var$tk = $aefa23277c986a08$var$sk = null;
    if (null !== $aefa23277c986a08$var$fh) {
        for(b = 0; b < $aefa23277c986a08$var$fh.length; b++)if (c = $aefa23277c986a08$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $aefa23277c986a08$var$fh = null;
    }
    return a;
}
function $aefa23277c986a08$var$Mk(a, b) {
    do {
        var c = $aefa23277c986a08$var$Y;
        try {
            $aefa23277c986a08$var$$g();
            $aefa23277c986a08$var$Fh.current = $aefa23277c986a08$var$Rh;
            if ($aefa23277c986a08$var$Ih) {
                for(var d = $aefa23277c986a08$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $aefa23277c986a08$var$Ih = !1;
            }
            $aefa23277c986a08$var$Hh = 0;
            $aefa23277c986a08$var$O = $aefa23277c986a08$var$N = $aefa23277c986a08$var$M = null;
            $aefa23277c986a08$var$Jh = !1;
            $aefa23277c986a08$var$Kh = 0;
            $aefa23277c986a08$var$nk.current = null;
            if (null === c || null === c.return) {
                $aefa23277c986a08$var$T = 1;
                $aefa23277c986a08$var$pk = b;
                $aefa23277c986a08$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $aefa23277c986a08$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $aefa23277c986a08$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $aefa23277c986a08$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $aefa23277c986a08$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $aefa23277c986a08$var$Si(f, l, b);
                            $aefa23277c986a08$var$tj();
                            break a;
                        }
                        k = Error($aefa23277c986a08$var$p(426));
                    }
                } else if ($aefa23277c986a08$var$I && h.mode & 1) {
                    var J = $aefa23277c986a08$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $aefa23277c986a08$var$Vi(J, g, h, f, b);
                        $aefa23277c986a08$var$Jg($aefa23277c986a08$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $aefa23277c986a08$var$Ji(k, h);
                4 !== $aefa23277c986a08$var$T && ($aefa23277c986a08$var$T = 2);
                null === $aefa23277c986a08$var$sk ? $aefa23277c986a08$var$sk = [
                    f
                ] : $aefa23277c986a08$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $aefa23277c986a08$var$Ni(f, k, b);
                            $aefa23277c986a08$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $aefa23277c986a08$var$Ri || !$aefa23277c986a08$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $aefa23277c986a08$var$Qi(f, h, b);
                                $aefa23277c986a08$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $aefa23277c986a08$var$Sk(c);
        } catch (na) {
            b = na;
            $aefa23277c986a08$var$Y === c && null !== c && ($aefa23277c986a08$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $aefa23277c986a08$var$Jk() {
    var a = $aefa23277c986a08$var$mk.current;
    $aefa23277c986a08$var$mk.current = $aefa23277c986a08$var$Rh;
    return null === a ? $aefa23277c986a08$var$Rh : a;
}
function $aefa23277c986a08$var$tj() {
    if (0 === $aefa23277c986a08$var$T || 3 === $aefa23277c986a08$var$T || 2 === $aefa23277c986a08$var$T) $aefa23277c986a08$var$T = 4;
    null === $aefa23277c986a08$var$Q || 0 === ($aefa23277c986a08$var$rh & 268435455) && 0 === ($aefa23277c986a08$var$qk & 268435455) || $aefa23277c986a08$var$Ck($aefa23277c986a08$var$Q, $aefa23277c986a08$var$Z);
}
function $aefa23277c986a08$var$Ik(a, b) {
    var c = $aefa23277c986a08$var$K;
    $aefa23277c986a08$var$K |= 2;
    var d = $aefa23277c986a08$var$Jk();
    if ($aefa23277c986a08$var$Q !== a || $aefa23277c986a08$var$Z !== b) $aefa23277c986a08$var$uk = null, $aefa23277c986a08$var$Kk(a, b);
    for(;;)try {
        $aefa23277c986a08$var$Tk();
        break;
    } catch (e) {
        $aefa23277c986a08$var$Mk(a, e);
    }
    $aefa23277c986a08$var$$g();
    $aefa23277c986a08$var$K = c;
    $aefa23277c986a08$var$mk.current = d;
    if (null !== $aefa23277c986a08$var$Y) throw Error($aefa23277c986a08$var$p(261));
    $aefa23277c986a08$var$Q = null;
    $aefa23277c986a08$var$Z = 0;
    return $aefa23277c986a08$var$T;
}
function $aefa23277c986a08$var$Tk() {
    for(; null !== $aefa23277c986a08$var$Y;)$aefa23277c986a08$var$Uk($aefa23277c986a08$var$Y);
}
function $aefa23277c986a08$var$Lk() {
    for(; null !== $aefa23277c986a08$var$Y && !$aefa23277c986a08$var$cc();)$aefa23277c986a08$var$Uk($aefa23277c986a08$var$Y);
}
function $aefa23277c986a08$var$Uk(a) {
    var b = $aefa23277c986a08$var$Vk(a.alternate, a, $aefa23277c986a08$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $aefa23277c986a08$var$Sk(a) : $aefa23277c986a08$var$Y = b;
    $aefa23277c986a08$var$nk.current = null;
}
function $aefa23277c986a08$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $aefa23277c986a08$var$Ej(c, b, $aefa23277c986a08$var$fj), null !== c) {
                $aefa23277c986a08$var$Y = c;
                return;
            }
        } else {
            c = $aefa23277c986a08$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $aefa23277c986a08$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $aefa23277c986a08$var$T = 6;
                $aefa23277c986a08$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $aefa23277c986a08$var$Y = b;
            return;
        }
        $aefa23277c986a08$var$Y = b = a;
    }while (null !== b);
    0 === $aefa23277c986a08$var$T && ($aefa23277c986a08$var$T = 5);
}
function $aefa23277c986a08$var$Pk(a, b, c) {
    var d = $aefa23277c986a08$var$C, e = $aefa23277c986a08$var$ok.transition;
    try {
        $aefa23277c986a08$var$ok.transition = null, $aefa23277c986a08$var$C = 1, $aefa23277c986a08$var$Wk(a, b, c, d);
    } finally{
        $aefa23277c986a08$var$ok.transition = e, $aefa23277c986a08$var$C = d;
    }
    return null;
}
function $aefa23277c986a08$var$Wk(a, b, c, d) {
    do $aefa23277c986a08$var$Hk();
    while (null !== $aefa23277c986a08$var$wk);
    if (0 !== ($aefa23277c986a08$var$K & 6)) throw Error($aefa23277c986a08$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($aefa23277c986a08$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $aefa23277c986a08$var$Bc(a, f);
    a === $aefa23277c986a08$var$Q && ($aefa23277c986a08$var$Y = $aefa23277c986a08$var$Q = null, $aefa23277c986a08$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $aefa23277c986a08$var$vk || ($aefa23277c986a08$var$vk = !0, $aefa23277c986a08$var$Fk($aefa23277c986a08$var$hc, function() {
        $aefa23277c986a08$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $aefa23277c986a08$var$ok.transition;
        $aefa23277c986a08$var$ok.transition = null;
        var g = $aefa23277c986a08$var$C;
        $aefa23277c986a08$var$C = 1;
        var h = $aefa23277c986a08$var$K;
        $aefa23277c986a08$var$K |= 4;
        $aefa23277c986a08$var$nk.current = null;
        $aefa23277c986a08$var$Oj(a, c);
        $aefa23277c986a08$var$dk(c, a);
        $aefa23277c986a08$var$Oe($aefa23277c986a08$var$Df);
        $aefa23277c986a08$var$dd = !!$aefa23277c986a08$var$Cf;
        $aefa23277c986a08$var$Df = $aefa23277c986a08$var$Cf = null;
        a.current = c;
        $aefa23277c986a08$var$hk(c, a, e);
        $aefa23277c986a08$var$dc();
        $aefa23277c986a08$var$K = h;
        $aefa23277c986a08$var$C = g;
        $aefa23277c986a08$var$ok.transition = f;
    } else a.current = c;
    $aefa23277c986a08$var$vk && ($aefa23277c986a08$var$vk = !1, $aefa23277c986a08$var$wk = a, $aefa23277c986a08$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($aefa23277c986a08$var$Ri = null);
    $aefa23277c986a08$var$mc(c.stateNode, d);
    $aefa23277c986a08$var$Dk(a, $aefa23277c986a08$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($aefa23277c986a08$var$Oi) throw $aefa23277c986a08$var$Oi = !1, a = $aefa23277c986a08$var$Pi, $aefa23277c986a08$var$Pi = null, a;
    0 !== ($aefa23277c986a08$var$xk & 1) && 0 !== a.tag && $aefa23277c986a08$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $aefa23277c986a08$var$zk ? $aefa23277c986a08$var$yk++ : ($aefa23277c986a08$var$yk = 0, $aefa23277c986a08$var$zk = a) : $aefa23277c986a08$var$yk = 0;
    $aefa23277c986a08$var$jg();
    return null;
}
function $aefa23277c986a08$var$Hk() {
    if (null !== $aefa23277c986a08$var$wk) {
        var a = $aefa23277c986a08$var$Dc($aefa23277c986a08$var$xk), b = $aefa23277c986a08$var$ok.transition, c = $aefa23277c986a08$var$C;
        try {
            $aefa23277c986a08$var$ok.transition = null;
            $aefa23277c986a08$var$C = 16 > a ? 16 : a;
            if (null === $aefa23277c986a08$var$wk) var d = !1;
            else {
                a = $aefa23277c986a08$var$wk;
                $aefa23277c986a08$var$wk = null;
                $aefa23277c986a08$var$xk = 0;
                if (0 !== ($aefa23277c986a08$var$K & 6)) throw Error($aefa23277c986a08$var$p(331));
                var e = $aefa23277c986a08$var$K;
                $aefa23277c986a08$var$K |= 4;
                for($aefa23277c986a08$var$V = a.current; null !== $aefa23277c986a08$var$V;){
                    var f = $aefa23277c986a08$var$V, g = f.child;
                    if (0 !== ($aefa23277c986a08$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($aefa23277c986a08$var$V = l; null !== $aefa23277c986a08$var$V;){
                                    var m = $aefa23277c986a08$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $aefa23277c986a08$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $aefa23277c986a08$var$V = q;
                                    else for(; null !== $aefa23277c986a08$var$V;){
                                        m = $aefa23277c986a08$var$V;
                                        var r = m.sibling, y = m.return;
                                        $aefa23277c986a08$var$Sj(m);
                                        if (m === l) {
                                            $aefa23277c986a08$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $aefa23277c986a08$var$V = r;
                                            break;
                                        }
                                        $aefa23277c986a08$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $aefa23277c986a08$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $aefa23277c986a08$var$V = g;
                    else b: for(; null !== $aefa23277c986a08$var$V;){
                        f = $aefa23277c986a08$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $aefa23277c986a08$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $aefa23277c986a08$var$V = x;
                            break b;
                        }
                        $aefa23277c986a08$var$V = f.return;
                    }
                }
                var w = a.current;
                for($aefa23277c986a08$var$V = w; null !== $aefa23277c986a08$var$V;){
                    g = $aefa23277c986a08$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $aefa23277c986a08$var$V = u;
                    else b: for(g = w; null !== $aefa23277c986a08$var$V;){
                        h = $aefa23277c986a08$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $aefa23277c986a08$var$Qj(9, h);
                            }
                        } catch (na) {
                            $aefa23277c986a08$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $aefa23277c986a08$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $aefa23277c986a08$var$V = F;
                            break b;
                        }
                        $aefa23277c986a08$var$V = h.return;
                    }
                }
                $aefa23277c986a08$var$K = e;
                $aefa23277c986a08$var$jg();
                if ($aefa23277c986a08$var$lc && "function" === typeof $aefa23277c986a08$var$lc.onPostCommitFiberRoot) try {
                    $aefa23277c986a08$var$lc.onPostCommitFiberRoot($aefa23277c986a08$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $aefa23277c986a08$var$C = c, $aefa23277c986a08$var$ok.transition = b;
        }
    }
    return !1;
}
function $aefa23277c986a08$var$Xk(a, b, c) {
    b = $aefa23277c986a08$var$Ji(c, b);
    b = $aefa23277c986a08$var$Ni(a, b, 1);
    a = $aefa23277c986a08$var$nh(a, b, 1);
    b = $aefa23277c986a08$var$R();
    null !== a && ($aefa23277c986a08$var$Ac(a, 1, b), $aefa23277c986a08$var$Dk(a, b));
}
function $aefa23277c986a08$var$W(a, b, c) {
    if (3 === a.tag) $aefa23277c986a08$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $aefa23277c986a08$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $aefa23277c986a08$var$Ri || !$aefa23277c986a08$var$Ri.has(d))) {
                a = $aefa23277c986a08$var$Ji(c, a);
                a = $aefa23277c986a08$var$Qi(b, a, 1);
                b = $aefa23277c986a08$var$nh(b, a, 1);
                a = $aefa23277c986a08$var$R();
                null !== b && ($aefa23277c986a08$var$Ac(b, 1, a), $aefa23277c986a08$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $aefa23277c986a08$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $aefa23277c986a08$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $aefa23277c986a08$var$Q === a && ($aefa23277c986a08$var$Z & c) === c && (4 === $aefa23277c986a08$var$T || 3 === $aefa23277c986a08$var$T && ($aefa23277c986a08$var$Z & 130023424) === $aefa23277c986a08$var$Z && 500 > $aefa23277c986a08$var$B() - $aefa23277c986a08$var$fk ? $aefa23277c986a08$var$Kk(a, 0) : $aefa23277c986a08$var$rk |= c);
    $aefa23277c986a08$var$Dk(a, b);
}
function $aefa23277c986a08$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $aefa23277c986a08$var$sc, $aefa23277c986a08$var$sc <<= 1, 0 === ($aefa23277c986a08$var$sc & 130023424) && ($aefa23277c986a08$var$sc = 4194304)));
    var c = $aefa23277c986a08$var$R();
    a = $aefa23277c986a08$var$ih(a, b);
    null !== a && ($aefa23277c986a08$var$Ac(a, b, c), $aefa23277c986a08$var$Dk(a, c));
}
function $aefa23277c986a08$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $aefa23277c986a08$var$Yk(a, c);
}
function $aefa23277c986a08$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($aefa23277c986a08$var$p(314));
    }
    null !== d && d.delete(b);
    $aefa23277c986a08$var$Yk(a, c);
}
var $aefa23277c986a08$var$Vk;
$aefa23277c986a08$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $aefa23277c986a08$var$Wf.current) $aefa23277c986a08$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $aefa23277c986a08$var$dh = !1, $aefa23277c986a08$var$yj(a, b, c);
            $aefa23277c986a08$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $aefa23277c986a08$var$dh = !1, $aefa23277c986a08$var$I && 0 !== (b.flags & 1048576) && $aefa23277c986a08$var$ug(b, $aefa23277c986a08$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $aefa23277c986a08$var$ij(a, b);
            a = b.pendingProps;
            var e = $aefa23277c986a08$var$Yf(b, $aefa23277c986a08$var$H.current);
            $aefa23277c986a08$var$ch(b, c);
            e = $aefa23277c986a08$var$Nh(null, b, d, a, e, c);
            var f = $aefa23277c986a08$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $aefa23277c986a08$var$Zf(d) ? (f = !0, $aefa23277c986a08$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $aefa23277c986a08$var$kh(b), e.updater = $aefa23277c986a08$var$Ei, b.stateNode = e, e._reactInternals = b, $aefa23277c986a08$var$Ii(b, d, a, c), b = $aefa23277c986a08$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $aefa23277c986a08$var$I && f && $aefa23277c986a08$var$vg(b), $aefa23277c986a08$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $aefa23277c986a08$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $aefa23277c986a08$var$Zk(d);
                a = $aefa23277c986a08$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $aefa23277c986a08$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $aefa23277c986a08$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $aefa23277c986a08$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $aefa23277c986a08$var$$i(null, b, d, $aefa23277c986a08$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($aefa23277c986a08$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $aefa23277c986a08$var$Ci(d, e), $aefa23277c986a08$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $aefa23277c986a08$var$Ci(d, e), $aefa23277c986a08$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $aefa23277c986a08$var$kj(b);
                if (null === a) throw Error($aefa23277c986a08$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $aefa23277c986a08$var$lh(a, b);
                $aefa23277c986a08$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $aefa23277c986a08$var$Ji(Error($aefa23277c986a08$var$p(423)), b);
                        b = $aefa23277c986a08$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $aefa23277c986a08$var$Ji(Error($aefa23277c986a08$var$p(424)), b);
                        b = $aefa23277c986a08$var$lj(a, b, d, c, e);
                        break a;
                    } else for($aefa23277c986a08$var$yg = $aefa23277c986a08$var$Lf(b.stateNode.containerInfo.firstChild), $aefa23277c986a08$var$xg = b, $aefa23277c986a08$var$I = !0, $aefa23277c986a08$var$zg = null, c = $aefa23277c986a08$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $aefa23277c986a08$var$Ig();
                    if (d === e) {
                        b = $aefa23277c986a08$var$Zi(a, b, c);
                        break a;
                    }
                    $aefa23277c986a08$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $aefa23277c986a08$var$Ah(b), null === a && $aefa23277c986a08$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $aefa23277c986a08$var$Ef(d, e) ? g = null : null !== f && $aefa23277c986a08$var$Ef(d, f) && (b.flags |= 32), $aefa23277c986a08$var$gj(a, b), $aefa23277c986a08$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $aefa23277c986a08$var$Eg(b), null;
        case 13:
            return $aefa23277c986a08$var$oj(a, b, c);
        case 4:
            return $aefa23277c986a08$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $aefa23277c986a08$var$Ug(b, null, d, c) : $aefa23277c986a08$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $aefa23277c986a08$var$Ci(d, e), $aefa23277c986a08$var$Yi(a, b, d, e, c);
        case 7:
            return $aefa23277c986a08$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $aefa23277c986a08$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $aefa23277c986a08$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $aefa23277c986a08$var$G($aefa23277c986a08$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($aefa23277c986a08$var$He(f.value, g)) {
                        if (f.children === e.children && !$aefa23277c986a08$var$Wf.current) {
                            b = $aefa23277c986a08$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $aefa23277c986a08$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $aefa23277c986a08$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($aefa23277c986a08$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $aefa23277c986a08$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $aefa23277c986a08$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $aefa23277c986a08$var$ch(b, c), e = $aefa23277c986a08$var$eh(e), d = d(e), b.flags |= 1, $aefa23277c986a08$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $aefa23277c986a08$var$Ci(d, b.pendingProps), e = $aefa23277c986a08$var$Ci(d.type, e), $aefa23277c986a08$var$$i(a, b, d, e, c);
        case 15:
            return $aefa23277c986a08$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $aefa23277c986a08$var$Ci(d, e), $aefa23277c986a08$var$ij(a, b), b.tag = 1, $aefa23277c986a08$var$Zf(d) ? (a = !0, $aefa23277c986a08$var$cg(b)) : a = !1, $aefa23277c986a08$var$ch(b, c), $aefa23277c986a08$var$Gi(b, d, e), $aefa23277c986a08$var$Ii(b, d, e, c), $aefa23277c986a08$var$jj(null, b, d, !0, a, c);
        case 19:
            return $aefa23277c986a08$var$xj(a, b, c);
        case 22:
            return $aefa23277c986a08$var$dj(a, b, c);
    }
    throw Error($aefa23277c986a08$var$p(156, b.tag));
};
function $aefa23277c986a08$var$Fk(a, b) {
    return $aefa23277c986a08$var$ac(a, b);
}
function $aefa23277c986a08$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $aefa23277c986a08$var$Bg(a, b, c, d) {
    return new $aefa23277c986a08$var$$k(a, b, c, d);
}
function $aefa23277c986a08$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $aefa23277c986a08$var$Zk(a) {
    if ("function" === typeof a) return $aefa23277c986a08$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $aefa23277c986a08$var$Da) return 11;
        if (a === $aefa23277c986a08$var$Ga) return 14;
    }
    return 2;
}
function $aefa23277c986a08$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $aefa23277c986a08$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $aefa23277c986a08$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $aefa23277c986a08$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $aefa23277c986a08$var$ya:
            return $aefa23277c986a08$var$Tg(c.children, e, f, b);
        case $aefa23277c986a08$var$za:
            g = 8;
            e |= 8;
            break;
        case $aefa23277c986a08$var$Aa:
            return a = $aefa23277c986a08$var$Bg(12, c, b, e | 2), a.elementType = $aefa23277c986a08$var$Aa, a.lanes = f, a;
        case $aefa23277c986a08$var$Ea:
            return a = $aefa23277c986a08$var$Bg(13, c, b, e), a.elementType = $aefa23277c986a08$var$Ea, a.lanes = f, a;
        case $aefa23277c986a08$var$Fa:
            return a = $aefa23277c986a08$var$Bg(19, c, b, e), a.elementType = $aefa23277c986a08$var$Fa, a.lanes = f, a;
        case $aefa23277c986a08$var$Ia:
            return $aefa23277c986a08$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $aefa23277c986a08$var$Ba:
                    g = 10;
                    break a;
                case $aefa23277c986a08$var$Ca:
                    g = 9;
                    break a;
                case $aefa23277c986a08$var$Da:
                    g = 11;
                    break a;
                case $aefa23277c986a08$var$Ga:
                    g = 14;
                    break a;
                case $aefa23277c986a08$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($aefa23277c986a08$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $aefa23277c986a08$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $aefa23277c986a08$var$Tg(a, b, c, d) {
    a = $aefa23277c986a08$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $aefa23277c986a08$var$pj(a, b, c, d) {
    a = $aefa23277c986a08$var$Bg(22, a, d, b);
    a.elementType = $aefa23277c986a08$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $aefa23277c986a08$var$Qg(a, b, c) {
    a = $aefa23277c986a08$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $aefa23277c986a08$var$Sg(a, b, c) {
    b = $aefa23277c986a08$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $aefa23277c986a08$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $aefa23277c986a08$var$zc(0);
    this.expirationTimes = $aefa23277c986a08$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $aefa23277c986a08$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $aefa23277c986a08$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $aefa23277c986a08$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $aefa23277c986a08$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $aefa23277c986a08$var$kh(f);
    return a;
}
function $aefa23277c986a08$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $aefa23277c986a08$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $aefa23277c986a08$var$dl(a) {
    if (!a) return $aefa23277c986a08$var$Vf;
    a = a._reactInternals;
    a: {
        if ($aefa23277c986a08$var$Vb(a) !== a || 1 !== a.tag) throw Error($aefa23277c986a08$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($aefa23277c986a08$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($aefa23277c986a08$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($aefa23277c986a08$var$Zf(c)) return $aefa23277c986a08$var$bg(a, c, b);
    }
    return b;
}
function $aefa23277c986a08$var$el(a, b, c, d, e, f, g, h, k) {
    a = $aefa23277c986a08$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $aefa23277c986a08$var$dl(null);
    c = a.current;
    d = $aefa23277c986a08$var$R();
    e = $aefa23277c986a08$var$yi(c);
    f = $aefa23277c986a08$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $aefa23277c986a08$var$nh(c, f, e);
    a.current.lanes = e;
    $aefa23277c986a08$var$Ac(a, e, d);
    $aefa23277c986a08$var$Dk(a, d);
    return a;
}
function $aefa23277c986a08$var$fl(a, b, c, d) {
    var e = b.current, f = $aefa23277c986a08$var$R(), g = $aefa23277c986a08$var$yi(e);
    c = $aefa23277c986a08$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $aefa23277c986a08$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $aefa23277c986a08$var$nh(e, b, g);
    null !== a && ($aefa23277c986a08$var$gi(a, e, g, f), $aefa23277c986a08$var$oh(a, e, g));
    return g;
}
function $aefa23277c986a08$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $aefa23277c986a08$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $aefa23277c986a08$var$il(a, b) {
    $aefa23277c986a08$var$hl(a, b);
    (a = a.alternate) && $aefa23277c986a08$var$hl(a, b);
}
function $aefa23277c986a08$var$jl() {
    return null;
}
var $aefa23277c986a08$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $aefa23277c986a08$var$ll(a) {
    this._internalRoot = a;
}
$aefa23277c986a08$var$ml.prototype.render = $aefa23277c986a08$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($aefa23277c986a08$var$p(409));
    $aefa23277c986a08$var$fl(a, b, null, null);
};
$aefa23277c986a08$var$ml.prototype.unmount = $aefa23277c986a08$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $aefa23277c986a08$var$Rk(function() {
            $aefa23277c986a08$var$fl(null, a, null, null);
        });
        b[$aefa23277c986a08$var$uf] = null;
    }
};
function $aefa23277c986a08$var$ml(a) {
    this._internalRoot = a;
}
$aefa23277c986a08$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $aefa23277c986a08$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $aefa23277c986a08$var$Qc.length && 0 !== b && b < $aefa23277c986a08$var$Qc[c].priority; c++);
        $aefa23277c986a08$var$Qc.splice(c, 0, a);
        0 === c && $aefa23277c986a08$var$Vc(a);
    }
};
function $aefa23277c986a08$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $aefa23277c986a08$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $aefa23277c986a08$var$pl() {}
function $aefa23277c986a08$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $aefa23277c986a08$var$gl(g);
                f.call(a);
            };
        }
        var g = $aefa23277c986a08$var$el(b, d, a, 0, null, !1, !1, "", $aefa23277c986a08$var$pl);
        a._reactRootContainer = g;
        a[$aefa23277c986a08$var$uf] = g.current;
        $aefa23277c986a08$var$sf(8 === a.nodeType ? a.parentNode : a);
        $aefa23277c986a08$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $aefa23277c986a08$var$gl(k);
            h.call(a);
        };
    }
    var k = $aefa23277c986a08$var$bl(a, 0, !1, null, null, !1, !1, "", $aefa23277c986a08$var$pl);
    a._reactRootContainer = k;
    a[$aefa23277c986a08$var$uf] = k.current;
    $aefa23277c986a08$var$sf(8 === a.nodeType ? a.parentNode : a);
    $aefa23277c986a08$var$Rk(function() {
        $aefa23277c986a08$var$fl(b, k, c, d);
    });
    return k;
}
function $aefa23277c986a08$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $aefa23277c986a08$var$gl(g);
                h.call(a);
            };
        }
        $aefa23277c986a08$var$fl(b, g, a, e);
    } else g = $aefa23277c986a08$var$ql(c, b, a, e, d);
    return $aefa23277c986a08$var$gl(g);
}
$aefa23277c986a08$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $aefa23277c986a08$var$tc(b.pendingLanes);
                0 !== c && ($aefa23277c986a08$var$Cc(b, c | 1), $aefa23277c986a08$var$Dk(b, $aefa23277c986a08$var$B()), 0 === ($aefa23277c986a08$var$K & 6) && ($aefa23277c986a08$var$Gj = $aefa23277c986a08$var$B() + 500, $aefa23277c986a08$var$jg()));
            }
            break;
        case 13:
            $aefa23277c986a08$var$Rk(function() {
                var b = $aefa23277c986a08$var$ih(a, 1);
                if (null !== b) {
                    var c = $aefa23277c986a08$var$R();
                    $aefa23277c986a08$var$gi(b, a, 1, c);
                }
            }), $aefa23277c986a08$var$il(a, 1);
    }
};
$aefa23277c986a08$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $aefa23277c986a08$var$ih(a, 134217728);
        if (null !== b) {
            var c = $aefa23277c986a08$var$R();
            $aefa23277c986a08$var$gi(b, a, 134217728, c);
        }
        $aefa23277c986a08$var$il(a, 134217728);
    }
};
$aefa23277c986a08$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $aefa23277c986a08$var$yi(a), c = $aefa23277c986a08$var$ih(a, b);
        if (null !== c) {
            var d = $aefa23277c986a08$var$R();
            $aefa23277c986a08$var$gi(c, a, b, d);
        }
        $aefa23277c986a08$var$il(a, b);
    }
};
$aefa23277c986a08$var$Hc = function() {
    return $aefa23277c986a08$var$C;
};
$aefa23277c986a08$var$Ic = function(a, b) {
    var c = $aefa23277c986a08$var$C;
    try {
        return $aefa23277c986a08$var$C = a, b();
    } finally{
        $aefa23277c986a08$var$C = c;
    }
};
$aefa23277c986a08$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $aefa23277c986a08$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $aefa23277c986a08$var$Db(d);
                        if (!e) throw Error($aefa23277c986a08$var$p(90));
                        $aefa23277c986a08$var$Wa(d);
                        $aefa23277c986a08$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $aefa23277c986a08$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $aefa23277c986a08$var$fb(a, !!c.multiple, b, !1);
    }
};
$aefa23277c986a08$var$Gb = $aefa23277c986a08$var$Qk;
$aefa23277c986a08$var$Hb = $aefa23277c986a08$var$Rk;
var $aefa23277c986a08$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $aefa23277c986a08$var$Cb,
        $aefa23277c986a08$var$ue,
        $aefa23277c986a08$var$Db,
        $aefa23277c986a08$var$Eb,
        $aefa23277c986a08$var$Fb,
        $aefa23277c986a08$var$Qk
    ]
}, $aefa23277c986a08$var$tl = {
    findFiberByHostInstance: $aefa23277c986a08$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $aefa23277c986a08$var$ul = {
    bundleType: $aefa23277c986a08$var$tl.bundleType,
    version: $aefa23277c986a08$var$tl.version,
    rendererPackageName: $aefa23277c986a08$var$tl.rendererPackageName,
    rendererConfig: $aefa23277c986a08$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $aefa23277c986a08$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $aefa23277c986a08$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $aefa23277c986a08$var$tl.findFiberByHostInstance || $aefa23277c986a08$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $aefa23277c986a08$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$aefa23277c986a08$var$vl.isDisabled && $aefa23277c986a08$var$vl.supportsFiber) try {
        $aefa23277c986a08$var$kc = $aefa23277c986a08$var$vl.inject($aefa23277c986a08$var$ul), $aefa23277c986a08$var$lc = $aefa23277c986a08$var$vl;
    } catch (a) {}
}
$aefa23277c986a08$export$ae55be85d98224ed = $aefa23277c986a08$var$sl;
$aefa23277c986a08$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$aefa23277c986a08$var$nl(b)) throw Error($aefa23277c986a08$var$p(200));
    return $aefa23277c986a08$var$cl(a, b, null, c);
};
$aefa23277c986a08$export$882461b6382ed46c = function(a, b) {
    if (!$aefa23277c986a08$var$nl(a)) throw Error($aefa23277c986a08$var$p(299));
    var c = !1, d = "", e = $aefa23277c986a08$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $aefa23277c986a08$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$aefa23277c986a08$var$uf] = b.current;
    $aefa23277c986a08$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $aefa23277c986a08$var$ll(b);
};
$aefa23277c986a08$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($aefa23277c986a08$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($aefa23277c986a08$var$p(268, a));
    }
    a = $aefa23277c986a08$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$aefa23277c986a08$export$cd75ccfd720a3cd4 = function(a) {
    return $aefa23277c986a08$var$Rk(a);
};
$aefa23277c986a08$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$aefa23277c986a08$var$ol(b)) throw Error($aefa23277c986a08$var$p(200));
    return $aefa23277c986a08$var$rl(null, a, b, !0, c);
};
$aefa23277c986a08$export$757ceba2d55c277e = function(a, b, c) {
    if (!$aefa23277c986a08$var$nl(a)) throw Error($aefa23277c986a08$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $aefa23277c986a08$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $aefa23277c986a08$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$aefa23277c986a08$var$uf] = b.current;
    $aefa23277c986a08$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $aefa23277c986a08$var$ml(b);
};
$aefa23277c986a08$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$aefa23277c986a08$var$ol(b)) throw Error($aefa23277c986a08$var$p(200));
    return $aefa23277c986a08$var$rl(null, a, b, !1, c);
};
$aefa23277c986a08$export$502457920280e6be = function(a) {
    if (!$aefa23277c986a08$var$ol(a)) throw Error($aefa23277c986a08$var$p(40));
    return a._reactRootContainer ? ($aefa23277c986a08$var$Rk(function() {
        $aefa23277c986a08$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$aefa23277c986a08$var$uf] = null;
        });
    }), !0) : !1;
};
$aefa23277c986a08$export$c78a37762a8d58e1 = $aefa23277c986a08$var$Qk;
$aefa23277c986a08$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$aefa23277c986a08$var$ol(c)) throw Error($aefa23277c986a08$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($aefa23277c986a08$var$p(38));
    return $aefa23277c986a08$var$rl(a, b, c, !1, d);
};
$aefa23277c986a08$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("8fzia", function(module, exports) {
'use strict';

module.exports = (parcelRequire("i02ua"));

});
parcelRegister("i02ua", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $d1aa27accd54c53b$export$c4744153514ff05d; }, function (v) { return $d1aa27accd54c53b$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $d1aa27accd54c53b$export$3e506c1ccc9cc1a7; }, function (v) { return $d1aa27accd54c53b$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $d1aa27accd54c53b$export$e26fe2ed2fa76875; }, function (v) { return $d1aa27accd54c53b$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $d1aa27accd54c53b$export$502329bbf4b505b1; }, function (v) { return $d1aa27accd54c53b$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $d1aa27accd54c53b$export$6e3807111c4874c4; }, function (v) { return $d1aa27accd54c53b$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $d1aa27accd54c53b$export$c27134553091fb3a; }, function (v) { return $d1aa27accd54c53b$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $d1aa27accd54c53b$export$33ee1acdc04fd2a2; }, function (v) { return $d1aa27accd54c53b$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $d1aa27accd54c53b$export$b00a404bbd5edef2; }, function (v) { return $d1aa27accd54c53b$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $d1aa27accd54c53b$export$8352ce38b91d0c62; }, function (v) { return $d1aa27accd54c53b$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $d1aa27accd54c53b$export$d66a1c1c77bd778b; }, function (v) { return $d1aa27accd54c53b$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $d1aa27accd54c53b$export$d3dfb8e4810cb555; }, function (v) { return $d1aa27accd54c53b$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $d1aa27accd54c53b$export$839f9183b0465a69; }, function (v) { return $d1aa27accd54c53b$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $d1aa27accd54c53b$export$72fdf0e06517287b; }, function (v) { return $d1aa27accd54c53b$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $d1aa27accd54c53b$export$4b844e58a3e414b4; }, function (v) { return $d1aa27accd54c53b$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $d1aa27accd54c53b$export$816d2913ae6b83b1; }, function (v) { return $d1aa27accd54c53b$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $d1aa27accd54c53b$export$61bcfe829111a1d0; }, function (v) { return $d1aa27accd54c53b$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $d1aa27accd54c53b$export$7ee8c9beb337bc3f; }, function (v) { return $d1aa27accd54c53b$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $d1aa27accd54c53b$export$b5836b71941fa3ed; }, function (v) { return $d1aa27accd54c53b$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $d1aa27accd54c53b$export$cf845f2c119da08a; }, function (v) { return $d1aa27accd54c53b$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d1aa27accd54c53b$export$c4744153514ff05d;
var $d1aa27accd54c53b$export$3e506c1ccc9cc1a7;
var $d1aa27accd54c53b$export$e26fe2ed2fa76875;
var $d1aa27accd54c53b$export$502329bbf4b505b1;
var $d1aa27accd54c53b$export$6e3807111c4874c4;
var $d1aa27accd54c53b$export$c27134553091fb3a;
var $d1aa27accd54c53b$export$33ee1acdc04fd2a2;
var $d1aa27accd54c53b$export$b00a404bbd5edef2;
var $d1aa27accd54c53b$export$8352ce38b91d0c62;
var $d1aa27accd54c53b$export$d66a1c1c77bd778b;
var $d1aa27accd54c53b$export$d3dfb8e4810cb555;
var $d1aa27accd54c53b$export$839f9183b0465a69;
var $d1aa27accd54c53b$export$72fdf0e06517287b;
var $d1aa27accd54c53b$export$4b844e58a3e414b4;
var $d1aa27accd54c53b$export$816d2913ae6b83b1;
var $d1aa27accd54c53b$export$61bcfe829111a1d0;
var $d1aa27accd54c53b$export$7ee8c9beb337bc3f;
var $d1aa27accd54c53b$export$b5836b71941fa3ed;
var $d1aa27accd54c53b$export$cf845f2c119da08a;
'use strict';
function $d1aa27accd54c53b$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $d1aa27accd54c53b$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $d1aa27accd54c53b$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $d1aa27accd54c53b$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $d1aa27accd54c53b$var$g(C, c)) n < e && 0 > $d1aa27accd54c53b$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $d1aa27accd54c53b$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $d1aa27accd54c53b$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $d1aa27accd54c53b$var$l = performance;
    $d1aa27accd54c53b$export$c4744153514ff05d = function() {
        return $d1aa27accd54c53b$var$l.now();
    };
} else {
    var $d1aa27accd54c53b$var$p = Date, $d1aa27accd54c53b$var$q = $d1aa27accd54c53b$var$p.now();
    $d1aa27accd54c53b$export$c4744153514ff05d = function() {
        return $d1aa27accd54c53b$var$p.now() - $d1aa27accd54c53b$var$q;
    };
}
var $d1aa27accd54c53b$var$r = [], $d1aa27accd54c53b$var$t = [], $d1aa27accd54c53b$var$u = 1, $d1aa27accd54c53b$var$v = null, $d1aa27accd54c53b$var$y = 3, $d1aa27accd54c53b$var$z = !1, $d1aa27accd54c53b$var$A = !1, $d1aa27accd54c53b$var$B = !1, $d1aa27accd54c53b$var$D = "function" === typeof setTimeout ? setTimeout : null, $d1aa27accd54c53b$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $d1aa27accd54c53b$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $d1aa27accd54c53b$var$G(a) {
    for(var b = $d1aa27accd54c53b$var$h($d1aa27accd54c53b$var$t); null !== b;){
        if (null === b.callback) $d1aa27accd54c53b$var$k($d1aa27accd54c53b$var$t);
        else if (b.startTime <= a) $d1aa27accd54c53b$var$k($d1aa27accd54c53b$var$t), b.sortIndex = b.expirationTime, $d1aa27accd54c53b$var$f($d1aa27accd54c53b$var$r, b);
        else break;
        b = $d1aa27accd54c53b$var$h($d1aa27accd54c53b$var$t);
    }
}
function $d1aa27accd54c53b$var$H(a) {
    $d1aa27accd54c53b$var$B = !1;
    $d1aa27accd54c53b$var$G(a);
    if (!$d1aa27accd54c53b$var$A) {
        if (null !== $d1aa27accd54c53b$var$h($d1aa27accd54c53b$var$r)) $d1aa27accd54c53b$var$A = !0, $d1aa27accd54c53b$var$I($d1aa27accd54c53b$var$J);
        else {
            var b = $d1aa27accd54c53b$var$h($d1aa27accd54c53b$var$t);
            null !== b && $d1aa27accd54c53b$var$K($d1aa27accd54c53b$var$H, b.startTime - a);
        }
    }
}
function $d1aa27accd54c53b$var$J(a, b) {
    $d1aa27accd54c53b$var$A = !1;
    $d1aa27accd54c53b$var$B && ($d1aa27accd54c53b$var$B = !1, $d1aa27accd54c53b$var$E($d1aa27accd54c53b$var$L), $d1aa27accd54c53b$var$L = -1);
    $d1aa27accd54c53b$var$z = !0;
    var c = $d1aa27accd54c53b$var$y;
    try {
        $d1aa27accd54c53b$var$G(b);
        for($d1aa27accd54c53b$var$v = $d1aa27accd54c53b$var$h($d1aa27accd54c53b$var$r); null !== $d1aa27accd54c53b$var$v && (!($d1aa27accd54c53b$var$v.expirationTime > b) || a && !$d1aa27accd54c53b$var$M());){
            var d = $d1aa27accd54c53b$var$v.callback;
            if ("function" === typeof d) {
                $d1aa27accd54c53b$var$v.callback = null;
                $d1aa27accd54c53b$var$y = $d1aa27accd54c53b$var$v.priorityLevel;
                var e = d($d1aa27accd54c53b$var$v.expirationTime <= b);
                b = $d1aa27accd54c53b$export$c4744153514ff05d();
                "function" === typeof e ? $d1aa27accd54c53b$var$v.callback = e : $d1aa27accd54c53b$var$v === $d1aa27accd54c53b$var$h($d1aa27accd54c53b$var$r) && $d1aa27accd54c53b$var$k($d1aa27accd54c53b$var$r);
                $d1aa27accd54c53b$var$G(b);
            } else $d1aa27accd54c53b$var$k($d1aa27accd54c53b$var$r);
            $d1aa27accd54c53b$var$v = $d1aa27accd54c53b$var$h($d1aa27accd54c53b$var$r);
        }
        if (null !== $d1aa27accd54c53b$var$v) var w = !0;
        else {
            var m = $d1aa27accd54c53b$var$h($d1aa27accd54c53b$var$t);
            null !== m && $d1aa27accd54c53b$var$K($d1aa27accd54c53b$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $d1aa27accd54c53b$var$v = null, $d1aa27accd54c53b$var$y = c, $d1aa27accd54c53b$var$z = !1;
    }
}
var $d1aa27accd54c53b$var$N = !1, $d1aa27accd54c53b$var$O = null, $d1aa27accd54c53b$var$L = -1, $d1aa27accd54c53b$var$P = 5, $d1aa27accd54c53b$var$Q = -1;
function $d1aa27accd54c53b$var$M() {
    return $d1aa27accd54c53b$export$c4744153514ff05d() - $d1aa27accd54c53b$var$Q < $d1aa27accd54c53b$var$P ? !1 : !0;
}
function $d1aa27accd54c53b$var$R() {
    if (null !== $d1aa27accd54c53b$var$O) {
        var a = $d1aa27accd54c53b$export$c4744153514ff05d();
        $d1aa27accd54c53b$var$Q = a;
        var b = !0;
        try {
            b = $d1aa27accd54c53b$var$O(!0, a);
        } finally{
            b ? $d1aa27accd54c53b$var$S() : ($d1aa27accd54c53b$var$N = !1, $d1aa27accd54c53b$var$O = null);
        }
    } else $d1aa27accd54c53b$var$N = !1;
}
var $d1aa27accd54c53b$var$S;
if ("function" === typeof $d1aa27accd54c53b$var$F) $d1aa27accd54c53b$var$S = function() {
    $d1aa27accd54c53b$var$F($d1aa27accd54c53b$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $d1aa27accd54c53b$var$T = new MessageChannel, $d1aa27accd54c53b$var$U = $d1aa27accd54c53b$var$T.port2;
    $d1aa27accd54c53b$var$T.port1.onmessage = $d1aa27accd54c53b$var$R;
    $d1aa27accd54c53b$var$S = function() {
        $d1aa27accd54c53b$var$U.postMessage(null);
    };
} else $d1aa27accd54c53b$var$S = function() {
    $d1aa27accd54c53b$var$D($d1aa27accd54c53b$var$R, 0);
};
function $d1aa27accd54c53b$var$I(a) {
    $d1aa27accd54c53b$var$O = a;
    $d1aa27accd54c53b$var$N || ($d1aa27accd54c53b$var$N = !0, $d1aa27accd54c53b$var$S());
}
function $d1aa27accd54c53b$var$K(a, b) {
    $d1aa27accd54c53b$var$L = $d1aa27accd54c53b$var$D(function() {
        a($d1aa27accd54c53b$export$c4744153514ff05d());
    }, b);
}
$d1aa27accd54c53b$export$3e506c1ccc9cc1a7 = 5;
$d1aa27accd54c53b$export$e26fe2ed2fa76875 = 1;
$d1aa27accd54c53b$export$502329bbf4b505b1 = 4;
$d1aa27accd54c53b$export$6e3807111c4874c4 = 3;
$d1aa27accd54c53b$export$c27134553091fb3a = null;
$d1aa27accd54c53b$export$33ee1acdc04fd2a2 = 2;
$d1aa27accd54c53b$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$d1aa27accd54c53b$export$8352ce38b91d0c62 = function() {
    $d1aa27accd54c53b$var$A || $d1aa27accd54c53b$var$z || ($d1aa27accd54c53b$var$A = !0, $d1aa27accd54c53b$var$I($d1aa27accd54c53b$var$J));
};
$d1aa27accd54c53b$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $d1aa27accd54c53b$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$d1aa27accd54c53b$export$d3dfb8e4810cb555 = function() {
    return $d1aa27accd54c53b$var$y;
};
$d1aa27accd54c53b$export$839f9183b0465a69 = function() {
    return $d1aa27accd54c53b$var$h($d1aa27accd54c53b$var$r);
};
$d1aa27accd54c53b$export$72fdf0e06517287b = function(a) {
    switch($d1aa27accd54c53b$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $d1aa27accd54c53b$var$y;
    }
    var c = $d1aa27accd54c53b$var$y;
    $d1aa27accd54c53b$var$y = b;
    try {
        return a();
    } finally{
        $d1aa27accd54c53b$var$y = c;
    }
};
$d1aa27accd54c53b$export$4b844e58a3e414b4 = function() {};
$d1aa27accd54c53b$export$816d2913ae6b83b1 = function() {};
$d1aa27accd54c53b$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $d1aa27accd54c53b$var$y;
    $d1aa27accd54c53b$var$y = a;
    try {
        return b();
    } finally{
        $d1aa27accd54c53b$var$y = c;
    }
};
$d1aa27accd54c53b$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $d1aa27accd54c53b$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $d1aa27accd54c53b$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $d1aa27accd54c53b$var$f($d1aa27accd54c53b$var$t, a), null === $d1aa27accd54c53b$var$h($d1aa27accd54c53b$var$r) && a === $d1aa27accd54c53b$var$h($d1aa27accd54c53b$var$t) && ($d1aa27accd54c53b$var$B ? ($d1aa27accd54c53b$var$E($d1aa27accd54c53b$var$L), $d1aa27accd54c53b$var$L = -1) : $d1aa27accd54c53b$var$B = !0, $d1aa27accd54c53b$var$K($d1aa27accd54c53b$var$H, c - d))) : (a.sortIndex = e, $d1aa27accd54c53b$var$f($d1aa27accd54c53b$var$r, a), $d1aa27accd54c53b$var$A || $d1aa27accd54c53b$var$z || ($d1aa27accd54c53b$var$A = !0, $d1aa27accd54c53b$var$I($d1aa27accd54c53b$var$J)));
    return a;
};
$d1aa27accd54c53b$export$b5836b71941fa3ed = $d1aa27accd54c53b$var$M;
$d1aa27accd54c53b$export$cf845f2c119da08a = function(a) {
    var b = $d1aa27accd54c53b$var$y;
    return function() {
        var c = $d1aa27accd54c53b$var$y;
        $d1aa27accd54c53b$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $d1aa27accd54c53b$var$y = c;
        }
    };
};

});



parcelRegister("cLQG7", function(module, exports) {
/**
 * Node.js module for Forge.
 *
 * @author Dave Longley
 *
 * Copyright 2011-2016 Digital Bazaar, Inc.
 */ module.exports = {
    // default options
    options: {
        usePureJavaScript: false
    }
};

});

parcelRegister("lbUi1", function(module, exports) {
"use strict";

});

parcelRegister("4pr5e", function(module, exports) {
/**
 * Node.js module for Forge message digests.
 *
 * @author Dave Longley
 *
 * Copyright 2011-2017 Digital Bazaar, Inc.
 */ 
var $cLQG7 = parcelRequire("cLQG7");
module.exports = $cLQG7.md = $cLQG7.md || {};
$cLQG7.md.algorithms = $cLQG7.md.algorithms || {};

});

var $fe3e626085e1e6b8$exports = {};
'use strict';

$fe3e626085e1e6b8$exports = (parcelRequire("1ohhe"));


parcelRequire("aEMJz");
var $8779a10718613263$exports = {};

$parcel$export($8779a10718613263$exports, "createRoot", function () { return $8779a10718613263$export$882461b6382ed46c; }, function (v) { return $8779a10718613263$export$882461b6382ed46c = v; });
$parcel$export($8779a10718613263$exports, "hydrateRoot", function () { return $8779a10718613263$export$757ceba2d55c277e; }, function (v) { return $8779a10718613263$export$757ceba2d55c277e = v; });
var $8779a10718613263$export$882461b6382ed46c;
var $8779a10718613263$export$757ceba2d55c277e;
'use strict';
var $068b8dd51fa92b96$exports = {};
'use strict';
function $068b8dd51fa92b96$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($068b8dd51fa92b96$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$068b8dd51fa92b96$var$checkDCE();

$068b8dd51fa92b96$exports = (parcelRequire("f1oJI"));


var $8779a10718613263$var$i;
$8779a10718613263$export$882461b6382ed46c = $068b8dd51fa92b96$exports.createRoot;
$8779a10718613263$export$757ceba2d55c277e = $068b8dd51fa92b96$exports.hydrateRoot;



function $0aa5c5a93c4e63b8$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $c28f73f96bffd3b9$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $0aa5c5a93c4e63b8$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}




var $aEMJz = parcelRequire("aEMJz");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $10e83365bcd320a7$var$extendStatics = function(d, b) {
    $10e83365bcd320a7$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $10e83365bcd320a7$var$extendStatics(d, b);
};
function $10e83365bcd320a7$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $10e83365bcd320a7$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $10e83365bcd320a7$export$18ce0697a983be9b = function() {
    $10e83365bcd320a7$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $10e83365bcd320a7$export$18ce0697a983be9b.apply(this, arguments);
};
function $10e83365bcd320a7$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $10e83365bcd320a7$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $10e83365bcd320a7$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $10e83365bcd320a7$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $10e83365bcd320a7$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $10e83365bcd320a7$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $10e83365bcd320a7$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $10e83365bcd320a7$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $10e83365bcd320a7$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $10e83365bcd320a7$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $10e83365bcd320a7$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $10e83365bcd320a7$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $10e83365bcd320a7$export$45d3717a4c69092e(o, m, p);
}
function $10e83365bcd320a7$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $10e83365bcd320a7$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $10e83365bcd320a7$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($10e83365bcd320a7$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $10e83365bcd320a7$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $10e83365bcd320a7$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $10e83365bcd320a7$export$10c90e4f7922046c(v) {
    return this instanceof $10e83365bcd320a7$export$10c90e4f7922046c ? (this.v = v, this) : new $10e83365bcd320a7$export$10c90e4f7922046c(v);
}
function $10e83365bcd320a7$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $10e83365bcd320a7$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $10e83365bcd320a7$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $10e83365bcd320a7$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $10e83365bcd320a7$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $10e83365bcd320a7$export$19a8beecd37a4c45 === "function" ? $10e83365bcd320a7$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $10e83365bcd320a7$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $10e83365bcd320a7$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $10e83365bcd320a7$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $10e83365bcd320a7$export$45d3717a4c69092e(result, mod, k);
    }
    $10e83365bcd320a7$var$__setModuleDefault(result, mod);
    return result;
}
function $10e83365bcd320a7$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $10e83365bcd320a7$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $10e83365bcd320a7$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $10e83365bcd320a7$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $10e83365bcd320a7$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $10e83365bcd320a7$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $10e83365bcd320a7$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $10e83365bcd320a7$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $10e83365bcd320a7$export$2e2bcd8739ae039 = {
    __extends: $10e83365bcd320a7$export$a8ba968b8961cb8a,
    __assign: $10e83365bcd320a7$export$18ce0697a983be9b,
    __rest: $10e83365bcd320a7$export$3c9a16f847548506,
    __decorate: $10e83365bcd320a7$export$29e00dfd3077644b,
    __param: $10e83365bcd320a7$export$d5ad3fd78186038f,
    __metadata: $10e83365bcd320a7$export$f1db080c865becb9,
    __awaiter: $10e83365bcd320a7$export$1050f835b63b671e,
    __generator: $10e83365bcd320a7$export$67ebef60e6f28a6,
    __createBinding: $10e83365bcd320a7$export$45d3717a4c69092e,
    __exportStar: $10e83365bcd320a7$export$f33643c0debef087,
    __values: $10e83365bcd320a7$export$19a8beecd37a4c45,
    __read: $10e83365bcd320a7$export$8d051b38c9118094,
    __spread: $10e83365bcd320a7$export$afc72e2116322959,
    __spreadArrays: $10e83365bcd320a7$export$6388937ca91ccae8,
    __spreadArray: $10e83365bcd320a7$export$1216008129fb82ed,
    __await: $10e83365bcd320a7$export$10c90e4f7922046c,
    __asyncGenerator: $10e83365bcd320a7$export$e427f37a30a4de9b,
    __asyncDelegator: $10e83365bcd320a7$export$bbd80228419bb833,
    __asyncValues: $10e83365bcd320a7$export$e3b29a3d6162315f,
    __makeTemplateObject: $10e83365bcd320a7$export$4fb47efe1390b86f,
    __importStar: $10e83365bcd320a7$export$c21735bcef00d192,
    __importDefault: $10e83365bcd320a7$export$da59b14a69baef04,
    __classPrivateFieldGet: $10e83365bcd320a7$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $10e83365bcd320a7$export$d40a35129aaff81f,
    __classPrivateFieldIn: $10e83365bcd320a7$export$81fdc39f203e4e04,
    __addDisposableResource: $10e83365bcd320a7$export$88ac25d8e944e405,
    __disposeResources: $10e83365bcd320a7$export$8f076105dc360e92
};


function $d70e28cd182ca4f6$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $c141231a084a9fb3$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $c141231a084a9fb3$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $d70e28cd182ca4f6$export$2e2bcd8739ae039)(function(prop) {
    return $c141231a084a9fb3$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $aEMJz = parcelRequire("aEMJz");
var $60a79fe7c91658de$exports = {};
//
$60a79fe7c91658de$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $1b3c173596e236b2$export$71ad59f2e432cfe8 = "-ms-";
var $1b3c173596e236b2$export$2c0f367103c8d01c = "-moz-";
var $1b3c173596e236b2$export$39dfd62a25e0fe93 = "-webkit-";
var $1b3c173596e236b2$export$a29989082612d0d9 = "comm";
var $1b3c173596e236b2$export$aa3a2e812ca8570d = "rule";
var $1b3c173596e236b2$export$527d108ccf083c2b = "decl";
var $1b3c173596e236b2$export$d3d35020fa5b54f0 = "@page";
var $1b3c173596e236b2$export$500415a86c544f73 = "@media";
var $1b3c173596e236b2$export$a763edbf796b780a = "@import";
var $1b3c173596e236b2$export$2790aeb8b4e5c826 = "@charset";
var $1b3c173596e236b2$export$1cc683e23b84b133 = "@viewport";
var $1b3c173596e236b2$export$9447a5efea57e862 = "@supports";
var $1b3c173596e236b2$export$ef011b4e114b1fba = "@document";
var $1b3c173596e236b2$export$6aad947bda0f3f46 = "@namespace";
var $1b3c173596e236b2$export$b44a8529a35fcb60 = "@keyframes";
var $1b3c173596e236b2$export$2c16de31893252e6 = "@font-face";
var $1b3c173596e236b2$export$3d846dd52e150c6f = "@counter-style";
var $1b3c173596e236b2$export$22314bfbb57653fe = "@font-feature-values";
var $1b3c173596e236b2$export$d773506282b3cfe6 = "@layer";
var $1b3c173596e236b2$export$1c5a554c78c0cd12 = "@scope";
var $1b3c173596e236b2$export$2335f513bbd82c6d = Math.abs;
var $1b3c173596e236b2$export$6788812c4e6611e6 = String.fromCharCode;
var $1b3c173596e236b2$export$e6e34fd1f2686227 = Object.assign;
function $1b3c173596e236b2$export$d6af199866bfb566(e, r) {
    return $1b3c173596e236b2$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $1b3c173596e236b2$export$a9db5e087081082d(e, 0)) << 2 ^ $1b3c173596e236b2$export$a9db5e087081082d(e, 1)) << 2 ^ $1b3c173596e236b2$export$a9db5e087081082d(e, 2)) << 2 ^ $1b3c173596e236b2$export$a9db5e087081082d(e, 3) : 0;
}
function $1b3c173596e236b2$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $1b3c173596e236b2$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $1b3c173596e236b2$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $1b3c173596e236b2$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $1b3c173596e236b2$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $1b3c173596e236b2$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $1b3c173596e236b2$export$36776f635604f274(e) {
    return e.length;
}
function $1b3c173596e236b2$export$f9084667e487ed46(e) {
    return e.length;
}
function $1b3c173596e236b2$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $1b3c173596e236b2$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $1b3c173596e236b2$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$1b3c173596e236b2$export$4659b591c19bdf3d(e, r);
    });
}
var $1b3c173596e236b2$export$53f1d5ea8de3d7c = 1;
var $1b3c173596e236b2$export$4e0c71f277ca26b3 = 1;
var $1b3c173596e236b2$export$f24224f1c91d8156 = 0;
var $1b3c173596e236b2$export$5880b8b5730aff45 = 0;
var $1b3c173596e236b2$export$c0306caf338ac095 = 0;
var $1b3c173596e236b2$export$30a86d91af8ff6e6 = "";
function $1b3c173596e236b2$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $1b3c173596e236b2$export$53f1d5ea8de3d7c,
        column: $1b3c173596e236b2$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $1b3c173596e236b2$export$784d13d8ee351f07(e, r) {
    return $1b3c173596e236b2$export$e6e34fd1f2686227($1b3c173596e236b2$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $1b3c173596e236b2$export$590e8b2c435046d9(e) {
    while(e.root)e = $1b3c173596e236b2$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $1b3c173596e236b2$export$10d8903dec122b9d(e, e.siblings);
}
function $1b3c173596e236b2$export$eba6f6f03b0a92e7() {
    return $1b3c173596e236b2$export$c0306caf338ac095;
}
function $1b3c173596e236b2$export$232faf9add678146() {
    $1b3c173596e236b2$export$c0306caf338ac095 = $1b3c173596e236b2$export$5880b8b5730aff45 > 0 ? $1b3c173596e236b2$export$a9db5e087081082d($1b3c173596e236b2$export$30a86d91af8ff6e6, --$1b3c173596e236b2$export$5880b8b5730aff45) : 0;
    if ($1b3c173596e236b2$export$4e0c71f277ca26b3--, $1b3c173596e236b2$export$c0306caf338ac095 === 10) $1b3c173596e236b2$export$4e0c71f277ca26b3 = 1, $1b3c173596e236b2$export$53f1d5ea8de3d7c--;
    return $1b3c173596e236b2$export$c0306caf338ac095;
}
function $1b3c173596e236b2$export$48cfd1e771a65c4f() {
    $1b3c173596e236b2$export$c0306caf338ac095 = $1b3c173596e236b2$export$5880b8b5730aff45 < $1b3c173596e236b2$export$f24224f1c91d8156 ? $1b3c173596e236b2$export$a9db5e087081082d($1b3c173596e236b2$export$30a86d91af8ff6e6, $1b3c173596e236b2$export$5880b8b5730aff45++) : 0;
    if ($1b3c173596e236b2$export$4e0c71f277ca26b3++, $1b3c173596e236b2$export$c0306caf338ac095 === 10) $1b3c173596e236b2$export$4e0c71f277ca26b3 = 1, $1b3c173596e236b2$export$53f1d5ea8de3d7c++;
    return $1b3c173596e236b2$export$c0306caf338ac095;
}
function $1b3c173596e236b2$export$4d3fb11e950abb9e() {
    return $1b3c173596e236b2$export$a9db5e087081082d($1b3c173596e236b2$export$30a86d91af8ff6e6, $1b3c173596e236b2$export$5880b8b5730aff45);
}
function $1b3c173596e236b2$export$e88cb2efb12ae807() {
    return $1b3c173596e236b2$export$5880b8b5730aff45;
}
function $1b3c173596e236b2$export$58adb3bec8346d0f(e, r) {
    return $1b3c173596e236b2$export$2f35ab04d2335697($1b3c173596e236b2$export$30a86d91af8ff6e6, e, r);
}
function $1b3c173596e236b2$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $1b3c173596e236b2$export$2de70f21292aac9e(e) {
    return $1b3c173596e236b2$export$53f1d5ea8de3d7c = $1b3c173596e236b2$export$4e0c71f277ca26b3 = 1, $1b3c173596e236b2$export$f24224f1c91d8156 = $1b3c173596e236b2$export$36776f635604f274($1b3c173596e236b2$export$30a86d91af8ff6e6 = e), $1b3c173596e236b2$export$5880b8b5730aff45 = 0, [];
}
function $1b3c173596e236b2$export$45918ac1574455b1(e) {
    return $1b3c173596e236b2$export$30a86d91af8ff6e6 = "", e;
}
function $1b3c173596e236b2$export$410ac95b9ec204b8(e) {
    return $1b3c173596e236b2$export$87c2784dc9fc4ab($1b3c173596e236b2$export$58adb3bec8346d0f($1b3c173596e236b2$export$5880b8b5730aff45 - 1, $1b3c173596e236b2$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $1b3c173596e236b2$export$660b2ee2d4fb4eff(e) {
    return $1b3c173596e236b2$export$45918ac1574455b1($1b3c173596e236b2$export$5f8c09e3ae6f64e1($1b3c173596e236b2$export$2de70f21292aac9e(e)));
}
function $1b3c173596e236b2$export$7af1228ff777d175(e) {
    while($1b3c173596e236b2$export$c0306caf338ac095 = $1b3c173596e236b2$export$4d3fb11e950abb9e())if ($1b3c173596e236b2$export$c0306caf338ac095 < 33) $1b3c173596e236b2$export$48cfd1e771a65c4f();
    else break;
    return $1b3c173596e236b2$export$9e1725a4cfeada27(e) > 2 || $1b3c173596e236b2$export$9e1725a4cfeada27($1b3c173596e236b2$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $1b3c173596e236b2$export$5f8c09e3ae6f64e1(e) {
    while($1b3c173596e236b2$export$48cfd1e771a65c4f())switch($1b3c173596e236b2$export$9e1725a4cfeada27($1b3c173596e236b2$export$c0306caf338ac095)){
        case 0:
            $1b3c173596e236b2$export$10d8903dec122b9d($1b3c173596e236b2$export$c2ab62c7bf24634($1b3c173596e236b2$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $1b3c173596e236b2$export$10d8903dec122b9d($1b3c173596e236b2$export$410ac95b9ec204b8($1b3c173596e236b2$export$c0306caf338ac095), e);
            break;
        default:
            $1b3c173596e236b2$export$10d8903dec122b9d($1b3c173596e236b2$export$6788812c4e6611e6($1b3c173596e236b2$export$c0306caf338ac095), e);
    }
    return e;
}
function $1b3c173596e236b2$export$955ba06d119e085e(e, r) {
    while(--r && $1b3c173596e236b2$export$48cfd1e771a65c4f())if ($1b3c173596e236b2$export$c0306caf338ac095 < 48 || $1b3c173596e236b2$export$c0306caf338ac095 > 102 || $1b3c173596e236b2$export$c0306caf338ac095 > 57 && $1b3c173596e236b2$export$c0306caf338ac095 < 65 || $1b3c173596e236b2$export$c0306caf338ac095 > 70 && $1b3c173596e236b2$export$c0306caf338ac095 < 97) break;
    return $1b3c173596e236b2$export$58adb3bec8346d0f(e, $1b3c173596e236b2$export$e88cb2efb12ae807() + (r < 6 && $1b3c173596e236b2$export$4d3fb11e950abb9e() == 32 && $1b3c173596e236b2$export$48cfd1e771a65c4f() == 32));
}
function $1b3c173596e236b2$export$c889f2fcc19dbf12(e) {
    while($1b3c173596e236b2$export$48cfd1e771a65c4f())switch($1b3c173596e236b2$export$c0306caf338ac095){
        case e:
            return $1b3c173596e236b2$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $1b3c173596e236b2$export$c889f2fcc19dbf12($1b3c173596e236b2$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $1b3c173596e236b2$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $1b3c173596e236b2$export$48cfd1e771a65c4f();
            break;
    }
    return $1b3c173596e236b2$export$5880b8b5730aff45;
}
function $1b3c173596e236b2$export$4254d4e2b3745c4c(e, r) {
    while($1b3c173596e236b2$export$48cfd1e771a65c4f())if (e + $1b3c173596e236b2$export$c0306caf338ac095 === 57) break;
    else if (e + $1b3c173596e236b2$export$c0306caf338ac095 === 84 && $1b3c173596e236b2$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $1b3c173596e236b2$export$58adb3bec8346d0f(r, $1b3c173596e236b2$export$5880b8b5730aff45 - 1) + "*" + $1b3c173596e236b2$export$6788812c4e6611e6(e === 47 ? e : $1b3c173596e236b2$export$48cfd1e771a65c4f());
}
function $1b3c173596e236b2$export$c2ab62c7bf24634(e) {
    while(!$1b3c173596e236b2$export$9e1725a4cfeada27($1b3c173596e236b2$export$4d3fb11e950abb9e()))$1b3c173596e236b2$export$48cfd1e771a65c4f();
    return $1b3c173596e236b2$export$58adb3bec8346d0f(e, $1b3c173596e236b2$export$5880b8b5730aff45);
}
function $1b3c173596e236b2$export$ef7acd7185315e22(e) {
    return $1b3c173596e236b2$export$45918ac1574455b1($1b3c173596e236b2$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $1b3c173596e236b2$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $1b3c173596e236b2$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = c;
    var y = s;
    var j = n;
    var z = k;
    while(w)switch(h = g, g = $1b3c173596e236b2$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $1b3c173596e236b2$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($1b3c173596e236b2$export$f8e21b1e77979a08(z += $1b3c173596e236b2$export$77ad94ebf1c2b9ed($1b3c173596e236b2$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $1b3c173596e236b2$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $1b3c173596e236b2$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $1b3c173596e236b2$export$7af1228ff777d175(h);
            break;
        case 92:
            z += $1b3c173596e236b2$export$955ba06d119e085e($1b3c173596e236b2$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($1b3c173596e236b2$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $1b3c173596e236b2$export$10d8903dec122b9d($1b3c173596e236b2$export$4a34f930e789283c($1b3c173596e236b2$export$4254d4e2b3745c4c($1b3c173596e236b2$export$48cfd1e771a65c4f(), $1b3c173596e236b2$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * b:
            u[f++] = $1b3c173596e236b2$export$36776f635604f274(z) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $1b3c173596e236b2$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (p > 0 && $1b3c173596e236b2$export$36776f635604f274(z) - l) $1b3c173596e236b2$export$10d8903dec122b9d(p > 32 ? $1b3c173596e236b2$export$f8483753829ec8f3(z + ";", n, a, l - 1, i) : $1b3c173596e236b2$export$f8483753829ec8f3($1b3c173596e236b2$export$77ad94ebf1c2b9ed(z, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $1b3c173596e236b2$export$10d8903dec122b9d(j = $1b3c173596e236b2$export$3307ffa7023ede1e(z, r, a, f, o, c, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $1b3c173596e236b2$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else switch(v === 99 && $1b3c173596e236b2$export$a9db5e087081082d(z, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $1b3c173596e236b2$export$98e6a39c04603d36(e, j, j, n && $1b3c173596e236b2$export$10d8903dec122b9d($1b3c173596e236b2$export$3307ffa7023ede1e(e, j, j, 0, 0, c, u, k, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                $1b3c173596e236b2$export$98e6a39c04603d36(z, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $1b3c173596e236b2$export$36776f635604f274(z), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $1b3c173596e236b2$export$232faf9add678146() == 125) continue;
            }
            switch(z += $1b3c173596e236b2$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($1b3c173596e236b2$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($1b3c173596e236b2$export$4d3fb11e950abb9e() === 45) z += $1b3c173596e236b2$export$410ac95b9ec204b8($1b3c173596e236b2$export$48cfd1e771a65c4f());
                    v = $1b3c173596e236b2$export$4d3fb11e950abb9e(), o = l = $1b3c173596e236b2$export$36776f635604f274(k = z += $1b3c173596e236b2$export$c2ab62c7bf24634($1b3c173596e236b2$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $1b3c173596e236b2$export$36776f635604f274(z) == 2) b = 0;
            }
    }
    return s;
}
function $1b3c173596e236b2$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $1b3c173596e236b2$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var k = 0, m = $1b3c173596e236b2$export$2f35ab04d2335697(e, p + 1, p = $1b3c173596e236b2$export$2335f513bbd82c6d(d = u[w])), x = e; k < b; ++k)if (x = $1b3c173596e236b2$export$87c2784dc9fc4ab(d > 0 ? h[k] + " " + m : $1b3c173596e236b2$export$77ad94ebf1c2b9ed(m, /&\f/g, h[k]))) f[g++] = x;
    return $1b3c173596e236b2$export$35059013cd4a06db(e, r, a, s === 0 ? $1b3c173596e236b2$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $1b3c173596e236b2$export$4a34f930e789283c(e, r, a, c) {
    return $1b3c173596e236b2$export$35059013cd4a06db(e, r, a, $1b3c173596e236b2$export$a29989082612d0d9, $1b3c173596e236b2$export$6788812c4e6611e6($1b3c173596e236b2$export$eba6f6f03b0a92e7()), $1b3c173596e236b2$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $1b3c173596e236b2$export$f8483753829ec8f3(e, r, a, n, c) {
    return $1b3c173596e236b2$export$35059013cd4a06db(e, r, a, $1b3c173596e236b2$export$527d108ccf083c2b, $1b3c173596e236b2$export$2f35ab04d2335697(e, 0, n), $1b3c173596e236b2$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $1b3c173596e236b2$export$82e9f45cca5ba907(n, c, s) {
    switch($1b3c173596e236b2$export$d6af199866bfb566(n, c)){
        case 5103:
            return $1b3c173596e236b2$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $1b3c173596e236b2$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $1b3c173596e236b2$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $1b3c173596e236b2$export$39dfd62a25e0fe93 + n + $1b3c173596e236b2$export$2c0f367103c8d01c + n + $1b3c173596e236b2$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($1b3c173596e236b2$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $1b3c173596e236b2$export$39dfd62a25e0fe93 + n + $1b3c173596e236b2$export$71ad59f2e432cfe8 + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $1b3c173596e236b2$export$39dfd62a25e0fe93 + n + $1b3c173596e236b2$export$71ad59f2e432cfe8 + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $1b3c173596e236b2$export$39dfd62a25e0fe93 + n + $1b3c173596e236b2$export$71ad59f2e432cfe8 + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $1b3c173596e236b2$export$39dfd62a25e0fe93 + n + $1b3c173596e236b2$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $1b3c173596e236b2$export$39dfd62a25e0fe93 + n + $1b3c173596e236b2$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $1b3c173596e236b2$export$39dfd62a25e0fe93 + n + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $1b3c173596e236b2$export$39dfd62a25e0fe93 + "box-$1$2" + $1b3c173596e236b2$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $1b3c173596e236b2$export$39dfd62a25e0fe93 + n + $1b3c173596e236b2$export$71ad59f2e432cfe8 + "flex-item-" + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$1b3c173596e236b2$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $1b3c173596e236b2$export$71ad59f2e432cfe8 + "grid-row-" + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $1b3c173596e236b2$export$39dfd62a25e0fe93 + n + $1b3c173596e236b2$export$71ad59f2e432cfe8 + "flex-line-pack" + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $1b3c173596e236b2$export$39dfd62a25e0fe93 + n + $1b3c173596e236b2$export$71ad59f2e432cfe8 + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $1b3c173596e236b2$export$39dfd62a25e0fe93 + n + $1b3c173596e236b2$export$71ad59f2e432cfe8 + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $1b3c173596e236b2$export$39dfd62a25e0fe93 + "box-" + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, "-grow", "") + $1b3c173596e236b2$export$39dfd62a25e0fe93 + n + $1b3c173596e236b2$export$71ad59f2e432cfe8 + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $1b3c173596e236b2$export$39dfd62a25e0fe93 + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $1b3c173596e236b2$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $1b3c173596e236b2$export$77ad94ebf1c2b9ed($1b3c173596e236b2$export$77ad94ebf1c2b9ed($1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $1b3c173596e236b2$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $1b3c173596e236b2$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $1b3c173596e236b2$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $1b3c173596e236b2$export$77ad94ebf1c2b9ed($1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $1b3c173596e236b2$export$39dfd62a25e0fe93 + "box-pack:$3" + $1b3c173596e236b2$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $1b3c173596e236b2$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$1b3c173596e236b2$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $1b3c173596e236b2$export$71ad59f2e432cfe8 + "grid-column-align" + $1b3c173596e236b2$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $1b3c173596e236b2$export$71ad59f2e432cfe8 + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $1b3c173596e236b2$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$1b3c173596e236b2$export$f8e21b1e77979a08(n + (s = s[c].value), "span", 0) ? n : $1b3c173596e236b2$export$71ad59f2e432cfe8 + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $1b3c173596e236b2$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$1b3c173596e236b2$export$f8e21b1e77979a08(s, "span", 0) ? $1b3c173596e236b2$export$4659b591c19bdf3d(s, /\d+/) : +$1b3c173596e236b2$export$4659b591c19bdf3d(s, /\d+/) - +$1b3c173596e236b2$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $1b3c173596e236b2$export$71ad59f2e432cfe8 + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $1b3c173596e236b2$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $1b3c173596e236b2$export$71ad59f2e432cfe8 + $1b3c173596e236b2$export$77ad94ebf1c2b9ed($1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $1b3c173596e236b2$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($1b3c173596e236b2$export$36776f635604f274(n) - 1 - c > 6) switch($1b3c173596e236b2$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($1b3c173596e236b2$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $1b3c173596e236b2$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $1b3c173596e236b2$export$2c0f367103c8d01c + ($1b3c173596e236b2$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$1b3c173596e236b2$export$f8e21b1e77979a08(n, "stretch", 0) ? $1b3c173596e236b2$export$82e9f45cca5ba907($1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $1b3c173596e236b2$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $1b3c173596e236b2$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($1b3c173596e236b2$export$a9db5e087081082d(n, c + 6) === 121) return $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, ":", ":" + $1b3c173596e236b2$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($1b3c173596e236b2$export$a9db5e087081082d(n, $1b3c173596e236b2$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $1b3c173596e236b2$export$39dfd62a25e0fe93 + ($1b3c173596e236b2$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $1b3c173596e236b2$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $1b3c173596e236b2$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, ":", ":" + $1b3c173596e236b2$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $1b3c173596e236b2$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $1b3c173596e236b2$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $1b3c173596e236b2$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $1b3c173596e236b2$export$a763edbf796b780a:
        case $1b3c173596e236b2$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $1b3c173596e236b2$export$a29989082612d0d9:
            return "";
        case $1b3c173596e236b2$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $1b3c173596e236b2$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $1b3c173596e236b2$export$aa3a2e812ca8570d:
            if (!$1b3c173596e236b2$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $1b3c173596e236b2$export$36776f635604f274(a = $1b3c173596e236b2$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $1b3c173596e236b2$export$5a7767152ae0305f(e) {
    var r = $1b3c173596e236b2$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $1b3c173596e236b2$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $1b3c173596e236b2$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $1b3c173596e236b2$export$527d108ccf083c2b:
                n.return = $1b3c173596e236b2$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $1b3c173596e236b2$export$b44a8529a35fcb60:
                return $1b3c173596e236b2$export$dfdc1655ccc5b9cb([
                    $1b3c173596e236b2$export$784d13d8ee351f07(n, {
                        value: $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $1b3c173596e236b2$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $1b3c173596e236b2$export$aa3a2e812ca8570d:
                if (n.length) return $1b3c173596e236b2$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($1b3c173596e236b2$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $1b3c173596e236b2$export$590e8b2c435046d9($1b3c173596e236b2$export$784d13d8ee351f07(n, {
                                props: [
                                    $1b3c173596e236b2$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $1b3c173596e236b2$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $1b3c173596e236b2$export$590e8b2c435046d9($1b3c173596e236b2$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $1b3c173596e236b2$export$e6e34fd1f2686227(n, {
                                props: $1b3c173596e236b2$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $1b3c173596e236b2$export$590e8b2c435046d9($1b3c173596e236b2$export$784d13d8ee351f07(n, {
                                props: [
                                    $1b3c173596e236b2$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $1b3c173596e236b2$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $1b3c173596e236b2$export$590e8b2c435046d9($1b3c173596e236b2$export$784d13d8ee351f07(n, {
                                props: [
                                    $1b3c173596e236b2$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $1b3c173596e236b2$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $1b3c173596e236b2$export$590e8b2c435046d9($1b3c173596e236b2$export$784d13d8ee351f07(n, {
                                props: [
                                    $1b3c173596e236b2$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $1b3c173596e236b2$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $1b3c173596e236b2$export$590e8b2c435046d9($1b3c173596e236b2$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $1b3c173596e236b2$export$e6e34fd1f2686227(n, {
                                props: $1b3c173596e236b2$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $1b3c173596e236b2$export$76a88f7de6507443(e) {
    switch(e.type){
        case $1b3c173596e236b2$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $1b3c173596e236b2$export$1be1fc439b849fdf($1b3c173596e236b2$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($1b3c173596e236b2$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $1b3c173596e236b2$export$2f35ab04d2335697(r, 1, $1b3c173596e236b2$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $1b3c173596e236b2$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $1b3c173596e236b2$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $1b3c173596e236b2$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $542fd23dbf943277$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


var $8368f5385e66edf2$exports = {};
// shim for using process in browser
var $8368f5385e66edf2$var$process = $8368f5385e66edf2$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $8368f5385e66edf2$var$cachedSetTimeout;
var $8368f5385e66edf2$var$cachedClearTimeout;
function $8368f5385e66edf2$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $8368f5385e66edf2$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $8368f5385e66edf2$var$cachedSetTimeout = setTimeout;
        else $8368f5385e66edf2$var$cachedSetTimeout = $8368f5385e66edf2$var$defaultSetTimout;
    } catch (e) {
        $8368f5385e66edf2$var$cachedSetTimeout = $8368f5385e66edf2$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $8368f5385e66edf2$var$cachedClearTimeout = clearTimeout;
        else $8368f5385e66edf2$var$cachedClearTimeout = $8368f5385e66edf2$var$defaultClearTimeout;
    } catch (e) {
        $8368f5385e66edf2$var$cachedClearTimeout = $8368f5385e66edf2$var$defaultClearTimeout;
    }
})();
function $8368f5385e66edf2$var$runTimeout(fun) {
    if ($8368f5385e66edf2$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($8368f5385e66edf2$var$cachedSetTimeout === $8368f5385e66edf2$var$defaultSetTimout || !$8368f5385e66edf2$var$cachedSetTimeout) && setTimeout) {
        $8368f5385e66edf2$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $8368f5385e66edf2$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $8368f5385e66edf2$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $8368f5385e66edf2$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $8368f5385e66edf2$var$runClearTimeout(marker) {
    if ($8368f5385e66edf2$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($8368f5385e66edf2$var$cachedClearTimeout === $8368f5385e66edf2$var$defaultClearTimeout || !$8368f5385e66edf2$var$cachedClearTimeout) && clearTimeout) {
        $8368f5385e66edf2$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $8368f5385e66edf2$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $8368f5385e66edf2$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $8368f5385e66edf2$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $8368f5385e66edf2$var$queue = [];
var $8368f5385e66edf2$var$draining = false;
var $8368f5385e66edf2$var$currentQueue;
var $8368f5385e66edf2$var$queueIndex = -1;
function $8368f5385e66edf2$var$cleanUpNextTick() {
    if (!$8368f5385e66edf2$var$draining || !$8368f5385e66edf2$var$currentQueue) return;
    $8368f5385e66edf2$var$draining = false;
    if ($8368f5385e66edf2$var$currentQueue.length) $8368f5385e66edf2$var$queue = $8368f5385e66edf2$var$currentQueue.concat($8368f5385e66edf2$var$queue);
    else $8368f5385e66edf2$var$queueIndex = -1;
    if ($8368f5385e66edf2$var$queue.length) $8368f5385e66edf2$var$drainQueue();
}
function $8368f5385e66edf2$var$drainQueue() {
    if ($8368f5385e66edf2$var$draining) return;
    var timeout = $8368f5385e66edf2$var$runTimeout($8368f5385e66edf2$var$cleanUpNextTick);
    $8368f5385e66edf2$var$draining = true;
    var len = $8368f5385e66edf2$var$queue.length;
    while(len){
        $8368f5385e66edf2$var$currentQueue = $8368f5385e66edf2$var$queue;
        $8368f5385e66edf2$var$queue = [];
        while(++$8368f5385e66edf2$var$queueIndex < len)if ($8368f5385e66edf2$var$currentQueue) $8368f5385e66edf2$var$currentQueue[$8368f5385e66edf2$var$queueIndex].run();
        $8368f5385e66edf2$var$queueIndex = -1;
        len = $8368f5385e66edf2$var$queue.length;
    }
    $8368f5385e66edf2$var$currentQueue = null;
    $8368f5385e66edf2$var$draining = false;
    $8368f5385e66edf2$var$runClearTimeout(timeout);
}
$8368f5385e66edf2$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $8368f5385e66edf2$var$queue.push(new $8368f5385e66edf2$var$Item(fun, args));
    if ($8368f5385e66edf2$var$queue.length === 1 && !$8368f5385e66edf2$var$draining) $8368f5385e66edf2$var$runTimeout($8368f5385e66edf2$var$drainQueue);
};
// v8 likes predictible objects
function $8368f5385e66edf2$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$8368f5385e66edf2$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$8368f5385e66edf2$var$process.title = 'browser';
$8368f5385e66edf2$var$process.browser = true;
$8368f5385e66edf2$var$process.env = {};
$8368f5385e66edf2$var$process.argv = [];
$8368f5385e66edf2$var$process.version = ''; // empty string to avoid regexp issues
$8368f5385e66edf2$var$process.versions = {};
function $8368f5385e66edf2$var$noop() {}
$8368f5385e66edf2$var$process.on = $8368f5385e66edf2$var$noop;
$8368f5385e66edf2$var$process.addListener = $8368f5385e66edf2$var$noop;
$8368f5385e66edf2$var$process.once = $8368f5385e66edf2$var$noop;
$8368f5385e66edf2$var$process.off = $8368f5385e66edf2$var$noop;
$8368f5385e66edf2$var$process.removeListener = $8368f5385e66edf2$var$noop;
$8368f5385e66edf2$var$process.removeAllListeners = $8368f5385e66edf2$var$noop;
$8368f5385e66edf2$var$process.emit = $8368f5385e66edf2$var$noop;
$8368f5385e66edf2$var$process.prependListener = $8368f5385e66edf2$var$noop;
$8368f5385e66edf2$var$process.prependOnceListener = $8368f5385e66edf2$var$noop;
$8368f5385e66edf2$var$process.listeners = function(name) {
    return [];
};
$8368f5385e66edf2$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$8368f5385e66edf2$var$process.cwd = function() {
    return '/';
};
$8368f5385e66edf2$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$8368f5385e66edf2$var$process.umask = function() {
    return 0;
};


var $4a95c28624d97f2e$var$f = ("undefined" != typeof $8368f5385e66edf2$exports && void 0 !== $8368f5385e66edf2$exports.env && undefined, "data-styled"), $4a95c28624d97f2e$var$m = "active", $4a95c28624d97f2e$var$y = "data-styled-version", $4a95c28624d97f2e$export$83d89fbfd8236492 = "6.1.13", $4a95c28624d97f2e$var$g = "/*!sc*/\n", $4a95c28624d97f2e$var$S = "undefined" != typeof window && "HTMLElement" in window, $4a95c28624d97f2e$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $8368f5385e66edf2$exports && $8368f5385e66edf2$exports.env, "undefined" != typeof $8368f5385e66edf2$exports && $8368f5385e66edf2$exports.env, false)), $4a95c28624d97f2e$var$b = {}, $4a95c28624d97f2e$var$E = /invalid hook call/i, $4a95c28624d97f2e$var$N = new Set, $4a95c28624d97f2e$var$P = function(t, n) {
    var o, s, i, a, e;
}, $4a95c28624d97f2e$var$_ = Object.freeze([]), $4a95c28624d97f2e$var$C = Object.freeze({});
function $4a95c28624d97f2e$var$I(e, t, n) {
    return void 0 === n && (n = $4a95c28624d97f2e$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $4a95c28624d97f2e$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $4a95c28624d97f2e$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $4a95c28624d97f2e$var$D = /(^-|-$)/g;
function $4a95c28624d97f2e$var$R(e) {
    return e.replace($4a95c28624d97f2e$var$O, "-").replace($4a95c28624d97f2e$var$D, "");
}
var $4a95c28624d97f2e$var$T = /(a)(d)/gi, $4a95c28624d97f2e$var$k = 52, $4a95c28624d97f2e$var$j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $4a95c28624d97f2e$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $4a95c28624d97f2e$var$k; t = t / $4a95c28624d97f2e$var$k | 0)n = $4a95c28624d97f2e$var$j(t % $4a95c28624d97f2e$var$k) + n;
    return ($4a95c28624d97f2e$var$j(t % $4a95c28624d97f2e$var$k) + n).replace($4a95c28624d97f2e$var$T, "$1-$2");
}
var $4a95c28624d97f2e$var$V, $4a95c28624d97f2e$var$F = 5381, $4a95c28624d97f2e$var$M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $4a95c28624d97f2e$var$z = function(e) {
    return $4a95c28624d97f2e$var$M($4a95c28624d97f2e$var$F, e);
};
function $4a95c28624d97f2e$var$$(e) {
    return $4a95c28624d97f2e$var$x($4a95c28624d97f2e$var$z(e) >>> 0);
}
function $4a95c28624d97f2e$var$B(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $4a95c28624d97f2e$var$L(e) {
    return "string" == typeof e && true;
}
var $4a95c28624d97f2e$var$G = "function" == typeof Symbol && Symbol.for, $4a95c28624d97f2e$var$Y = $4a95c28624d97f2e$var$G ? Symbol.for("react.memo") : 60115, $4a95c28624d97f2e$var$W = $4a95c28624d97f2e$var$G ? Symbol.for("react.forward_ref") : 60112, $4a95c28624d97f2e$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $4a95c28624d97f2e$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $4a95c28624d97f2e$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $4a95c28624d97f2e$var$J = (($4a95c28624d97f2e$var$V = {})[$4a95c28624d97f2e$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $4a95c28624d97f2e$var$V[$4a95c28624d97f2e$var$Y] = $4a95c28624d97f2e$var$U, $4a95c28624d97f2e$var$V);
function $4a95c28624d97f2e$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $4a95c28624d97f2e$var$Y ? $4a95c28624d97f2e$var$U : "$$typeof" in e ? $4a95c28624d97f2e$var$J[e.$$typeof] : $4a95c28624d97f2e$var$q;
}
var $4a95c28624d97f2e$var$Z = Object.defineProperty, $4a95c28624d97f2e$var$K = Object.getOwnPropertyNames, $4a95c28624d97f2e$var$Q = Object.getOwnPropertySymbols, $4a95c28624d97f2e$var$ee = Object.getOwnPropertyDescriptor, $4a95c28624d97f2e$var$te = Object.getPrototypeOf, $4a95c28624d97f2e$var$ne = Object.prototype;
function $4a95c28624d97f2e$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($4a95c28624d97f2e$var$ne) {
            var o = $4a95c28624d97f2e$var$te(t);
            o && o !== $4a95c28624d97f2e$var$ne && $4a95c28624d97f2e$var$oe(e, o, n);
        }
        var r = $4a95c28624d97f2e$var$K(t);
        $4a95c28624d97f2e$var$Q && (r = r.concat($4a95c28624d97f2e$var$Q(t)));
        for(var s = $4a95c28624d97f2e$var$X(e), i = $4a95c28624d97f2e$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $4a95c28624d97f2e$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $4a95c28624d97f2e$var$ee(t, c);
                try {
                    $4a95c28624d97f2e$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $4a95c28624d97f2e$var$re(e) {
    return "function" == typeof e;
}
function $4a95c28624d97f2e$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $4a95c28624d97f2e$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $4a95c28624d97f2e$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $4a95c28624d97f2e$var$ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $4a95c28624d97f2e$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$4a95c28624d97f2e$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $4a95c28624d97f2e$var$le(e[o], t[o]);
    else if ($4a95c28624d97f2e$var$ce(t)) for(var o in t)e[o] = $4a95c28624d97f2e$var$le(e[o], t[o]);
    return e;
}
function $4a95c28624d97f2e$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $4a95c28624d97f2e$var$pe = {};
function $4a95c28624d97f2e$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $4a95c28624d97f2e$var$he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $4a95c28624d97f2e$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $4a95c28624d97f2e$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($4a95c28624d97f2e$var$g);
        return t;
    }, e;
}(), $4a95c28624d97f2e$var$me = 1073741824, $4a95c28624d97f2e$var$ye = new Map, $4a95c28624d97f2e$var$ve = new Map, $4a95c28624d97f2e$var$ge = 1, $4a95c28624d97f2e$var$Se = function(e) {
    if ($4a95c28624d97f2e$var$ye.has(e)) return $4a95c28624d97f2e$var$ye.get(e);
    for(; $4a95c28624d97f2e$var$ve.has($4a95c28624d97f2e$var$ge);)$4a95c28624d97f2e$var$ge++;
    var t = $4a95c28624d97f2e$var$ge++;
    return $4a95c28624d97f2e$var$ye.set(e, t), $4a95c28624d97f2e$var$ve.set(t, e), t;
}, $4a95c28624d97f2e$var$we = function(e, t) {
    $4a95c28624d97f2e$var$ge = t + 1, $4a95c28624d97f2e$var$ye.set(e, t), $4a95c28624d97f2e$var$ve.set(t, e);
}, $4a95c28624d97f2e$var$be = "style[".concat($4a95c28624d97f2e$var$f, "][").concat($4a95c28624d97f2e$var$y, '="').concat($4a95c28624d97f2e$export$83d89fbfd8236492, '"]'), $4a95c28624d97f2e$var$Ee = new RegExp("^".concat($4a95c28624d97f2e$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $4a95c28624d97f2e$var$Ne = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $4a95c28624d97f2e$var$Pe = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($4a95c28624d97f2e$var$g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($4a95c28624d97f2e$var$Ee);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($4a95c28624d97f2e$var$we(u, l), $4a95c28624d97f2e$var$Ne(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
}, $4a95c28624d97f2e$var$_e = function(e) {
    for(var t = document.querySelectorAll($4a95c28624d97f2e$var$be), n = 0, o = t.length; n < o; n++){
        var r = t[n];
        r && r.getAttribute($4a95c28624d97f2e$var$f) !== $4a95c28624d97f2e$var$m && ($4a95c28624d97f2e$var$Pe(e, r), r.parentNode && r.parentNode.removeChild(r));
    }
};
function $4a95c28624d97f2e$var$Ce() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $4a95c28624d97f2e$var$Ie = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($4a95c28624d97f2e$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($4a95c28624d97f2e$var$f, $4a95c28624d97f2e$var$m), o.setAttribute($4a95c28624d97f2e$var$y, $4a95c28624d97f2e$export$83d89fbfd8236492);
    var i = $4a95c28624d97f2e$var$Ce();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $4a95c28624d97f2e$var$Ae = function() {
    function e(e) {
        this.element = $4a95c28624d97f2e$var$Ie(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $4a95c28624d97f2e$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $4a95c28624d97f2e$var$Oe = function() {
    function e(e) {
        this.element = $4a95c28624d97f2e$var$Ie(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $4a95c28624d97f2e$var$De = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $4a95c28624d97f2e$var$Re = $4a95c28624d97f2e$var$S, $4a95c28624d97f2e$var$Te = {
    isServer: !$4a95c28624d97f2e$var$S,
    useCSSOMInjection: !$4a95c28624d97f2e$var$w
}, $4a95c28624d97f2e$var$ke = function() {
    function e(e, n, o) {
        void 0 === e && (e = $4a95c28624d97f2e$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $10e83365bcd320a7$export$18ce0697a983be9b)((0, $10e83365bcd320a7$export$18ce0697a983be9b)({}, $4a95c28624d97f2e$var$Te), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $4a95c28624d97f2e$var$S && $4a95c28624d97f2e$var$Re && ($4a95c28624d97f2e$var$Re = !1, $4a95c28624d97f2e$var$_e(this)), $4a95c28624d97f2e$var$ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $4a95c28624d97f2e$var$ve.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || !s.size || 0 === i.length) return "continue";
                    var a = "".concat($4a95c28624d97f2e$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($4a95c28624d97f2e$var$g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $4a95c28624d97f2e$var$Se(e);
    }, e.prototype.rehydrate = function() {
        !this.server && $4a95c28624d97f2e$var$S && $4a95c28624d97f2e$var$_e(this);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $10e83365bcd320a7$export$18ce0697a983be9b)((0, $10e83365bcd320a7$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $4a95c28624d97f2e$var$De(n) : t ? new $4a95c28624d97f2e$var$Ae(n) : new $4a95c28624d97f2e$var$Oe(n);
        }(this.options), new $4a95c28624d97f2e$var$fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($4a95c28624d97f2e$var$Se(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($4a95c28624d97f2e$var$Se(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($4a95c28624d97f2e$var$Se(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $4a95c28624d97f2e$var$je = /&/g, $4a95c28624d97f2e$var$xe = /^\s*\/\/.*$/gm;
function $4a95c28624d97f2e$var$Ve(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $4a95c28624d97f2e$var$Ve(e.children, t)), e;
    });
}
function $4a95c28624d97f2e$var$Fe(e) {
    var t, n, o, r = void 0 === e ? $4a95c28624d97f2e$var$C : e, s = r.options, i = void 0 === s ? $4a95c28624d97f2e$var$C : s, a = r.plugins, c = void 0 === a ? $4a95c28624d97f2e$var$_ : a, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $1b3c173596e236b2$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($4a95c28624d97f2e$var$je, n).replace(o, l));
    }), i.prefix && u.push($1b3c173596e236b2$export$e08c7d021b829b7a), u.push($1b3c173596e236b2$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($4a95c28624d97f2e$var$xe, ""), l = $1b3c173596e236b2$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $4a95c28624d97f2e$var$Ve(l, i.namespace));
        var p = [];
        return $1b3c173596e236b2$export$dfdc1655ccc5b9cb(l, $1b3c173596e236b2$export$5a7767152ae0305f(u.concat($1b3c173596e236b2$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $4a95c28624d97f2e$var$he(15), $4a95c28624d97f2e$var$M(e, t.name);
    }, $4a95c28624d97f2e$var$F).toString() : "", p;
}
var $4a95c28624d97f2e$var$Me = new $4a95c28624d97f2e$var$ke, $4a95c28624d97f2e$var$ze = $4a95c28624d97f2e$var$Fe(), $4a95c28624d97f2e$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $4a95c28624d97f2e$var$Me,
    stylis: $4a95c28624d97f2e$var$ze
}), $4a95c28624d97f2e$export$91317688fc694efa = $4a95c28624d97f2e$export$8c190ef828af4c86.Consumer, $4a95c28624d97f2e$var$Le = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).createContext(void 0);
function $4a95c28624d97f2e$var$Ge() {
    return (0, $aEMJz.useContext)($4a95c28624d97f2e$export$8c190ef828af4c86);
}
function $4a95c28624d97f2e$export$a473771da2f0ff7c(e) {
    var t = (0, $aEMJz.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $4a95c28624d97f2e$var$Ge().styleSheet, l = (0, $aEMJz.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $aEMJz.useMemo)(function() {
        return $4a95c28624d97f2e$var$Fe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $aEMJz.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($60a79fe7c91658de$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $aEMJz.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).createElement($4a95c28624d97f2e$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).createElement($4a95c28624d97f2e$var$Le.Provider, {
        value: u
    }, e.children));
}
var $4a95c28624d97f2e$var$We = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $4a95c28624d97f2e$var$ze);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $4a95c28624d97f2e$var$ue(this, function() {
            throw $4a95c28624d97f2e$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $4a95c28624d97f2e$var$ze), this.name + e.hash;
    }, e;
}(), $4a95c28624d97f2e$var$qe = function(e) {
    return e >= "A" && e <= "Z";
};
function $4a95c28624d97f2e$var$He(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $4a95c28624d97f2e$var$qe(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $4a95c28624d97f2e$var$Ue = function(e) {
    return null == e || !1 === e || "" === e;
}, $4a95c28624d97f2e$var$Je = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$4a95c28624d97f2e$var$Ue(i) && (Array.isArray(i) && i.isCss || $4a95c28624d97f2e$var$re(i) ? r.push("".concat($4a95c28624d97f2e$var$He(s), ":"), i, ";") : $4a95c28624d97f2e$var$ce(i) ? r.push.apply(r, (0, $10e83365bcd320a7$export$1216008129fb82ed)((0, $10e83365bcd320a7$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $4a95c28624d97f2e$var$Je(i), !1), [
            "}"
        ], !1)) : r.push("".concat($4a95c28624d97f2e$var$He(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $542fd23dbf943277$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $4a95c28624d97f2e$var$Xe(e, t, n, o) {
    if ($4a95c28624d97f2e$var$Ue(e)) return [];
    if ($4a95c28624d97f2e$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($4a95c28624d97f2e$var$re(e)) {
        if (!$4a95c28624d97f2e$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $4a95c28624d97f2e$var$Xe(r, t, n, o);
    }
    var s;
    return e instanceof $4a95c28624d97f2e$var$We ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $4a95c28624d97f2e$var$ce(e) ? $4a95c28624d97f2e$var$Je(e) : Array.isArray(e) ? Array.prototype.concat.apply($4a95c28624d97f2e$var$_, e.map(function(e) {
        return $4a95c28624d97f2e$var$Xe(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $4a95c28624d97f2e$var$Ze(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($4a95c28624d97f2e$var$re(n) && !$4a95c28624d97f2e$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $4a95c28624d97f2e$var$Ke = $4a95c28624d97f2e$var$z($4a95c28624d97f2e$export$83d89fbfd8236492), $4a95c28624d97f2e$var$Qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $4a95c28624d97f2e$var$Ze(e), this.componentId = t, this.baseHash = $4a95c28624d97f2e$var$M($4a95c28624d97f2e$var$Ke, t), this.baseStyle = n, $4a95c28624d97f2e$var$ke.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $4a95c28624d97f2e$var$ie(o, this.staticRulesId);
            else {
                var r = $4a95c28624d97f2e$var$ae($4a95c28624d97f2e$var$Xe(this.rules, e, t, n)), s = $4a95c28624d97f2e$var$x($4a95c28624d97f2e$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $4a95c28624d97f2e$var$ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $4a95c28624d97f2e$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $4a95c28624d97f2e$var$ae($4a95c28624d97f2e$var$Xe(u, e, t, n));
                    a = $4a95c28624d97f2e$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $4a95c28624d97f2e$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $4a95c28624d97f2e$var$ie(o, d);
            }
        }
        return o;
    }, e;
}(), $4a95c28624d97f2e$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).createContext(void 0), $4a95c28624d97f2e$export$b631efc24e9d5e2f = $4a95c28624d97f2e$export$2c657da244d00bd6.Consumer;
function $4a95c28624d97f2e$export$93d4e7f90805808f() {
    var e = (0, $aEMJz.useContext)($4a95c28624d97f2e$export$2c657da244d00bd6);
    if (!e) throw $4a95c28624d97f2e$var$he(18);
    return e;
}
function $4a95c28624d97f2e$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useContext($4a95c28624d97f2e$export$2c657da244d00bd6), r = (0, $aEMJz.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $4a95c28624d97f2e$var$he(14);
            if ($4a95c28624d97f2e$var$re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $4a95c28624d97f2e$var$he(8);
            return n ? (0, $10e83365bcd320a7$export$18ce0697a983be9b)((0, $10e83365bcd320a7$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).createElement($4a95c28624d97f2e$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $4a95c28624d97f2e$var$rt = {}, $4a95c28624d97f2e$var$st = new Set;
function $4a95c28624d97f2e$var$it(e, r, s) {
    var i = $4a95c28624d97f2e$export$7ba318d8d2f06c76(e), a = e, c = !$4a95c28624d97f2e$var$L(e), p = r.attrs, d = void 0 === p ? $4a95c28624d97f2e$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $4a95c28624d97f2e$var$R(e);
        $4a95c28624d97f2e$var$rt[n] = ($4a95c28624d97f2e$var$rt[n] || 0) + 1;
        var o = "".concat(n, "-").concat($4a95c28624d97f2e$var$$($4a95c28624d97f2e$export$83d89fbfd8236492 + n + $4a95c28624d97f2e$var$rt[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $4a95c28624d97f2e$var$L(e) ? "styled.".concat(e) : "Styled(".concat($4a95c28624d97f2e$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($4a95c28624d97f2e$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $4a95c28624d97f2e$var$Qe(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useContext($4a95c28624d97f2e$export$2c657da244d00bd6), m = $4a95c28624d97f2e$var$Ge(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $4a95c28624d97f2e$var$I(r, f, c) || $4a95c28624d97f2e$var$C, g = function(e, n, o) {
                for(var r, s = (0, $10e83365bcd320a7$export$18ce0697a983be9b)((0, $10e83365bcd320a7$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $4a95c28624d97f2e$var$re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $4a95c28624d97f2e$var$ie(s[c], a[c]) : "style" === c ? (0, $10e83365bcd320a7$export$18ce0697a983be9b)((0, $10e83365bcd320a7$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $4a95c28624d97f2e$var$ie(s.className, n.className)), s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = $4a95c28624d97f2e$var$Ge(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, g);
            var N = $4a95c28624d97f2e$var$ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[$4a95c28624d97f2e$var$L(S) && !$4a95c28624d97f2e$var$A.has(S) ? "class" : "className"] = N, w.ref = s, (0, $aEMJz.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? $4a95c28624d97f2e$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$4a95c28624d97f2e$var$le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $4a95c28624d97f2e$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $4a95c28624d97f2e$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $4a95c28624d97f2e$var$at(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $4a95c28624d97f2e$var$ct = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $4a95c28624d97f2e$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($4a95c28624d97f2e$var$re(t) || $4a95c28624d97f2e$var$ce(t)) return $4a95c28624d97f2e$var$ct($4a95c28624d97f2e$var$Xe($4a95c28624d97f2e$var$at($4a95c28624d97f2e$var$_, (0, $10e83365bcd320a7$export$1216008129fb82ed)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $4a95c28624d97f2e$var$Xe(r) : $4a95c28624d97f2e$var$ct($4a95c28624d97f2e$var$Xe($4a95c28624d97f2e$var$at(r, n)));
}
function $4a95c28624d97f2e$var$ut(n, o, r) {
    if (void 0 === r && (r = $4a95c28624d97f2e$var$C), !o) throw $4a95c28624d97f2e$var$he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $4a95c28624d97f2e$export$dbf350e5966cf602.apply(void 0, (0, $10e83365bcd320a7$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $4a95c28624d97f2e$var$ut(n, o, (0, $10e83365bcd320a7$export$18ce0697a983be9b)((0, $10e83365bcd320a7$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $4a95c28624d97f2e$var$ut(n, o, (0, $10e83365bcd320a7$export$18ce0697a983be9b)((0, $10e83365bcd320a7$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $4a95c28624d97f2e$var$pt = function(e) {
    return $4a95c28624d97f2e$var$ut($4a95c28624d97f2e$var$it, e);
}, $4a95c28624d97f2e$export$2e2bcd8739ae039 = $4a95c28624d97f2e$var$pt;
$4a95c28624d97f2e$var$A.forEach(function(e) {
    $4a95c28624d97f2e$export$2e2bcd8739ae039[e] = $4a95c28624d97f2e$var$pt(e);
});
var $4a95c28624d97f2e$var$ht = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $4a95c28624d97f2e$var$Ze(e), $4a95c28624d97f2e$var$ke.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($4a95c28624d97f2e$var$ae($4a95c28624d97f2e$var$Xe(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $4a95c28624d97f2e$var$ke.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $4a95c28624d97f2e$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $4a95c28624d97f2e$export$dbf350e5966cf602.apply(void 0, (0, $10e83365bcd320a7$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($4a95c28624d97f2e$var$$(JSON.stringify(i))), c = new $4a95c28624d97f2e$var$ht(i, a);
    var l = function(e) {
        var t = $4a95c28624d97f2e$var$Ge(), n = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useContext($4a95c28624d97f2e$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $4a95c28624d97f2e$var$b, o, s);
        else {
            var i = (0, $10e83365bcd320a7$export$18ce0697a983be9b)((0, $10e83365bcd320a7$export$18ce0697a983be9b)({}, n), {
                theme: $4a95c28624d97f2e$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).memo(l);
}
function $4a95c28624d97f2e$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $4a95c28624d97f2e$var$ae($4a95c28624d97f2e$export$dbf350e5966cf602.apply(void 0, (0, $10e83365bcd320a7$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $4a95c28624d97f2e$var$$(r);
    return new $4a95c28624d97f2e$var$We(s, r);
}
function $4a95c28624d97f2e$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).forwardRef(function(n, r) {
        var s = $4a95c28624d97f2e$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useContext($4a95c28624d97f2e$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).createElement(e, (0, $10e83365bcd320a7$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($4a95c28624d97f2e$var$B(e), ")"), $4a95c28624d97f2e$var$oe(n, e);
}
var $4a95c28624d97f2e$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $4a95c28624d97f2e$var$Ce(), o = $4a95c28624d97f2e$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($4a95c28624d97f2e$var$f, '="true"'),
                "".concat($4a95c28624d97f2e$var$y, '="').concat($4a95c28624d97f2e$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $4a95c28624d97f2e$var$he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $4a95c28624d97f2e$var$he(2);
            var r = e.instance.toString();
            if (!r) return [];
            var s = ((n = {})[$4a95c28624d97f2e$var$f] = "", n[$4a95c28624d97f2e$var$y] = $4a95c28624d97f2e$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: r
            }, n), i = $4a95c28624d97f2e$var$Ce();
            return i && (s.nonce = i), [
                (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).createElement("style", (0, $10e83365bcd320a7$export$18ce0697a983be9b)({}, s, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $4a95c28624d97f2e$var$ke({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $4a95c28624d97f2e$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).createElement($4a95c28624d97f2e$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $4a95c28624d97f2e$var$he(3);
    }, e;
}(), $4a95c28624d97f2e$export$5c87cfe6c475f500 = {
    StyleSheet: $4a95c28624d97f2e$var$ke,
    mainSheet: $4a95c28624d97f2e$var$Me
};
var $4a95c28624d97f2e$var$St = "__sc-".concat($4a95c28624d97f2e$var$f, "__");




var $aEMJz = parcelRequire("aEMJz");

const $576749860f83a2d7$export$3ee5d4c6315a6ba5 = 2n ** 122n;
const $576749860f83a2d7$export$83e664a9d119a376 = 768;
const $576749860f83a2d7$export$9a6bb2acef5e644a = 24;
const $576749860f83a2d7$export$cba6217a006ba569 = 24;
const $576749860f83a2d7$export$3d5e80817e1f8611 = `(max-width: ${$576749860f83a2d7$export$83e664a9d119a376}px)`;
const $576749860f83a2d7$export$57b55975112d979e = `(max-width: 550px)`;



parcelRequire("aEMJz");

function $8c0ce35eac81a929$var$WrappedIcon({ style: style, svg: svg }) {
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("div", {
        style: style,
        children: svg
    });
}
function $8c0ce35eac81a929$export$9b80ee7d1e129684({ style: style, fill: fill = "none" }) {
    const icon = /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: fill,
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("path", {
            d: "m18 15-6-6-6 6"
        })
    });
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c0ce35eac81a929$var$WrappedIcon, {
        style: style,
        svg: icon
    });
}
function $8c0ce35eac81a929$export$4e3778eb35f54199({ style: style, fill: fill = "none" }) {
    const icon = /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: fill,
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("path", {
            d: "m6 9 6 6 6-6"
        })
    });
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c0ce35eac81a929$var$WrappedIcon, {
        style: style,
        svg: icon
    });
}
function $8c0ce35eac81a929$export$ea3b71af1761ff40({ style: style, fill: fill = "none" }) {
    const icon = /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: fill,
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("rect", {
                width: "8",
                height: "4",
                x: "8",
                y: "2",
                rx: "1",
                ry: "1"
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("path", {
                d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("path", {
                d: "M16 4h2a2 2 0 0 1 2 2v4"
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("path", {
                d: "M21 14H11"
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("path", {
                d: "m15 10-4 4 4 4"
            })
        ]
    });
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c0ce35eac81a929$var$WrappedIcon, {
        style: style,
        svg: icon
    });
}
function $8c0ce35eac81a929$export$1644ba17714857f1({ style: style, fill: fill = "none" }) {
    const icon = /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: fill,
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("path", {
            d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
        })
    });
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c0ce35eac81a929$var$WrappedIcon, {
        style: style,
        svg: icon
    });
}
function $8c0ce35eac81a929$export$128fdd60f6c96030({ style: style }) {
    const icon = /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 600 530",
        fill: "currentColor",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("path", {
            d: "m135.72 44.03c66.496 49.921 138.02 151.14 164.28 205.46 26.262-54.316 97.782-155.54 164.28-205.46 47.98-36.021 125.72-63.892 125.72 24.795 0 17.712-10.155 148.79-16.111 170.07-20.703 73.984-96.144 92.854-163.25 81.433 117.3 19.964 147.14 86.092 82.697 152.22-122.39 125.59-175.91-31.511-189.63-71.766-2.514-7.3797-3.6904-10.832-3.7077-7.8964-0.0174-2.9357-1.1937 0.51669-3.7077 7.8964-13.714 40.255-67.233 197.36-189.63 71.766-64.444-66.128-34.605-132.26 82.697-152.22-67.108 11.421-142.55-7.4491-163.25-81.433-5.9562-21.282-16.111-152.36-16.111-170.07 0-88.687 77.742-60.816 125.72-24.795z"
        })
    });
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c0ce35eac81a929$var$WrappedIcon, {
        style: style,
        svg: icon
    });
}
const $8c0ce35eac81a929$export$9e389cdad32a5b7a = ({ style: style })=>{
    const icon = /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 24 23",
        width: "100%",
        height: "100%",
        style: style,
        children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("path", {
            d: "M 24 4.300781 C 23.101563 4.699219 22.199219 5 21.199219 5.101563 C 22.199219 4.5 23 3.5 23.398438 2.398438 C 22.398438 3 21.398438 3.398438 20.300781 3.601563 C 19.300781 2.601563 18 2 16.601563 2 C 13.898438 2 11.699219 4.199219 11.699219 6.898438 C 11.699219 7.300781 11.699219 7.699219 11.800781 8 C 7.699219 7.800781 4.101563 5.898438 1.699219 2.898438 C 1.199219 3.601563 1 4.5 1 5.398438 C 1 7.101563 1.898438 8.601563 3.199219 9.5 C 2.398438 9.398438 1.601563 9.199219 1 8.898438 C 1 8.898438 1 8.898438 1 9 C 1 11.398438 2.699219 13.398438 4.898438 13.800781 C 4.5 13.898438 4.101563 14 3.601563 14 C 3.300781 14 3 14 2.699219 13.898438 C 3.300781 15.898438 5.101563 17.300781 7.300781 17.300781 C 5.601563 18.601563 3.5 19.398438 1.199219 19.398438 C 0.800781 19.398438 0.398438 19.398438 0 19.300781 C 2.199219 20.699219 4.800781 21.5 7.5 21.5 C 16.601563 21.5 21.5 14 21.5 7.5 C 21.5 7.300781 21.5 7.101563 21.5 6.898438 C 22.5 6.199219 23.300781 5.300781 24 4.300781"
        })
    });
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c0ce35eac81a929$var$WrappedIcon, {
        style: style,
        svg: icon
    });
};
const $8c0ce35eac81a929$export$52f0f02147b12c03 = ({ style: style, fill: fill = "none" })=>{
    const icon = /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "100%",
        width: "100%",
        viewBox: "0 0 24 24",
        fill: fill,
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("polyline", {
                points: "16 18 22 12 16 6"
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("polyline", {
                points: "8 6 2 12 8 18"
            })
        ]
    });
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c0ce35eac81a929$var$WrappedIcon, {
        style: style,
        svg: icon
    });
};
const $8c0ce35eac81a929$export$1be7516c0280bee8 = ({ style: style, fill: fill = "none" })=>{
    const icon = /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: fill,
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        style: style,
        children: [
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("path", {
                d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("path", {
                d: "M12 17h.01"
            })
        ]
    });
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c0ce35eac81a929$var$WrappedIcon, {
        style: style,
        svg: icon
    });
};
const $8c0ce35eac81a929$export$78acf4525d8a74c4 = ({ style: style, fill: fill = "none" })=>{
    const icon = /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: fill,
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("path", {
                d: "M18 6 6 18"
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("path", {
                d: "m6 6 12 12"
            })
        ]
    });
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c0ce35eac81a929$var$WrappedIcon, {
        style: style,
        svg: icon
    });
};


let $9af4149271f95228$var$_ = (t)=>t, $9af4149271f95228$var$t, $9af4149271f95228$var$t1, $9af4149271f95228$var$t2, $9af4149271f95228$var$t3, $9af4149271f95228$var$t4, $9af4149271f95228$var$t5, $9af4149271f95228$var$t6, $9af4149271f95228$var$t7, $9af4149271f95228$var$t8, $9af4149271f95228$var$t9;
const $9af4149271f95228$var$SUBHEADS = [
    "In case you forgot one",
    "Scroll till you find a good one",
    "Well, only the V4 ones"
];
const $9af4149271f95228$var$Wrapper = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).header($9af4149271f95228$var$t || ($9af4149271f95228$var$t = $9af4149271f95228$var$_`
  padding: 1rem 1rem 16px 24px;
  line-height: 1;
  border-bottom: 1px solid var(--border-color);
  font-family: monospace;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: relative;

  @media ${0} {
    flex-direction: column;
    gap: 1.5rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
`), (0, $576749860f83a2d7$export$3d5e80817e1f8611));
const $9af4149271f95228$var$TitleSubhead = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($9af4149271f95228$var$t1 || ($9af4149271f95228$var$t1 = $9af4149271f95228$var$_`
  display: flex;
  gap: 0.25rem;
  flex-direction: column;

  @media ${0} {
    align-items: center;
  }
`), (0, $576749860f83a2d7$export$3d5e80817e1f8611));
const $9af4149271f95228$var$Subhead = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($9af4149271f95228$var$t2 || ($9af4149271f95228$var$t2 = $9af4149271f95228$var$_`
  font-size: 0.875rem;
  opacity: 0.7;
  transform: translateX(1px);
`));
const $9af4149271f95228$var$Title = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).h1($9af4149271f95228$var$t3 || ($9af4149271f95228$var$t3 = $9af4149271f95228$var$_`
  font-size: 1.5rem;
  margin: 0;
`));
const $9af4149271f95228$var$Link = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).a($9af4149271f95228$var$t4 || ($9af4149271f95228$var$t4 = $9af4149271f95228$var$_`
  color: inherit;
  display: inline;
  transition: color 0.1s ease-in-out;

  @media (hover: hover) {
    &:hover {
      color: var(--neutral-500);
    }
  }
`));
const $9af4149271f95228$var$SelfPromotion = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($9af4149271f95228$var$t5 || ($9af4149271f95228$var$t5 = $9af4149271f95228$var$_`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.5rem;

  @media ${0} {
    flex-direction: row-reverse;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }
`), (0, $576749860f83a2d7$export$3d5e80817e1f8611));
const $9af4149271f95228$var$TitleLink = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).a($9af4149271f95228$var$t6 || ($9af4149271f95228$var$t6 = $9af4149271f95228$var$_`
  text-decoration: none;
  color: inherit;

  @media (hover: hover) {
    &:hover {
      text-decoration: underline;
    }
  }
`));
const $9af4149271f95228$var$SocialLink = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).a($9af4149271f95228$var$t7 || ($9af4149271f95228$var$t7 = $9af4149271f95228$var$_`
  display: inline-flex;
  align-items: center;
  width: 1.5em;
  height: 1.5em;
  color: var(--slate-500);

  transition: color 0.1s ease-in-out;
  @media (hover: hover) {
    &:hover {
      color: var(--slate-700);
    }
  }
`));
const $9af4149271f95228$var$Socials = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($9af4149271f95228$var$t8 || ($9af4149271f95228$var$t8 = $9af4149271f95228$var$_`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  justify-content: flex-end;
  align-items: center;

  @media (max-width: ${0}px) {
    transform: translateY(-1px);
  }
`), (0, $576749860f83a2d7$export$83e664a9d119a376));
const $9af4149271f95228$var$V4Small = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).sup($9af4149271f95228$var$t9 || ($9af4149271f95228$var$t9 = $9af4149271f95228$var$_`
  font-size: 0.75rem;
`));
function $9af4149271f95228$var$Header() {
    const subhead = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useMemo(()=>{
        return $9af4149271f95228$var$SUBHEADS[Math.floor(Math.random() * $9af4149271f95228$var$SUBHEADS.length)];
    }, []);
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)($9af4149271f95228$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)($9af4149271f95228$var$TitleSubhead, {
                children: [
                    /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($9af4149271f95228$var$TitleLink, {
                        href: "/",
                        children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($9af4149271f95228$var$Title, {
                            children: "Every UUID Dot Com"
                        })
                    }),
                    /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($9af4149271f95228$var$Subhead, {
                        children: subhead
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)($9af4149271f95228$var$SelfPromotion, {
                children: [
                    /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)($9af4149271f95228$var$Socials, {
                        children: [
                            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($9af4149271f95228$var$SocialLink, {
                                href: "https://eieio.games/blog/writing-down-every-uuid",
                                children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $8c0ce35eac81a929$export$1be7516c0280bee8), {})
                            }),
                            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($9af4149271f95228$var$SocialLink, {
                                href: "https://github.com/nolenroyalty/every-uuid",
                                children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $8c0ce35eac81a929$export$52f0f02147b12c03), {})
                            }),
                            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($9af4149271f95228$var$SocialLink, {
                                href: "https://twitter.com/itseieio",
                                children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $8c0ce35eac81a929$export$9e389cdad32a5b7a), {})
                            }),
                            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($9af4149271f95228$var$SocialLink, {
                                href: "https://bsky.app/profile/itseieio.bsky.social",
                                children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $8c0ce35eac81a929$export$128fdd60f6c96030), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)("p", {
                        children: [
                            "A website by ",
                            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($9af4149271f95228$var$Link, {
                                href: "https://eieio.games",
                                children: "eieio"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $9af4149271f95228$export$2e2bcd8739ae039 = $9af4149271f95228$var$Header;




var $aEMJz = parcelRequire("aEMJz");



let $8326a0f291697a14$var$_ = (t)=>t, $8326a0f291697a14$var$t;
const $8326a0f291697a14$var$UnstyledButton = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).button($8326a0f291697a14$var$t || ($8326a0f291697a14$var$t = $8326a0f291697a14$var$_`
  border: none;
  background: none;
  padding: 0;
  align-items: center;
  justify-content: center;
`));
var $8326a0f291697a14$export$2e2bcd8739ae039 = $8326a0f291697a14$var$UnstyledButton;



let $bb235d2f1f0411d2$var$_ = (t)=>t, $bb235d2f1f0411d2$var$t, $bb235d2f1f0411d2$var$t1, $bb235d2f1f0411d2$var$t2, $bb235d2f1f0411d2$var$t3;
const $bb235d2f1f0411d2$var$THUMB_HEIGHT = 20;
const $bb235d2f1f0411d2$var$Wrapper = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($bb235d2f1f0411d2$var$t || ($bb235d2f1f0411d2$var$t = $bb235d2f1f0411d2$var$_`
  width: ${0}px;
  background-color: var(--slate-200);
  display: flex;
  flex-direction: column;
  -webkit-tap-highlight-color: transparent;
`), (0, $576749860f83a2d7$export$9a6bb2acef5e644a));
const $bb235d2f1f0411d2$var$Track = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($bb235d2f1f0411d2$var$t1 || ($bb235d2f1f0411d2$var$t1 = $bb235d2f1f0411d2$var$_`
  height: 100%;
  margin: 0 0.5rem;
  cursor: pointer;
  position: relative;
  -webkit-tap-highlight-color: transparent;
`));
const $bb235d2f1f0411d2$var$Thumb = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($bb235d2f1f0411d2$var$t2 || ($bb235d2f1f0411d2$var$t2 = $bb235d2f1f0411d2$var$_`
  position: absolute;
  left: 0;
  right: 0;
  background-color: var(--slate-400);
  top: var(--position);
  height: ${0}px;
  cursor: grab;
  transition: background-color 0.1s ease-in-out;
  -webkit-tap-highlight-color: transparent;

  @media (hover: hover) {
    &:hover {
      background-color: var(--slate-500);
    }
  }

  &:active {
    cursor: grabbing;
  }
`), $bb235d2f1f0411d2$var$THUMB_HEIGHT);
const $bb235d2f1f0411d2$var$NavigationArrow = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039)((0, $8326a0f291697a14$export$2e2bcd8739ae039))($bb235d2f1f0411d2$var$t3 || ($bb235d2f1f0411d2$var$t3 = $bb235d2f1f0411d2$var$_`
  width: ${0}px;
  margin: 0 0 0 auto;
  height: 1.5rem;
  background-color: var(--slate-200);
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    background-color 0.1s ease-in-out,
    border-color 0.5s ease-in-out;

  --border-color: ${0};

  border-bottom: ${0};

  border-top: ${0};

  color: var(--slate-500);
  cursor: pointer;
  @media (hover: hover) {
    &:hover {
      background-color: var(--slate-400);
      border-color: var(--slate-400);
    }
  }
`), (0, $576749860f83a2d7$export$9a6bb2acef5e644a), (props)=>props.$noBorder ? "transparent" : "var(--slate-300)", (props)=>props.$top ? "2px solid var(--border-color)" : "none", (props)=>props.$top ? "none" : props.$noBorder ? "2px solid transparent" : "2px solid var(--border-color)");
function $bb235d2f1f0411d2$var$percentOfMax(percentage, max) {
    percentage = BigInt(Math.floor(Number(percentage) * 1000));
    return max * percentage / 1000n;
}
const $bb235d2f1f0411d2$var$TOP_THRESHOLD = 200000n;
function $bb235d2f1f0411d2$var$Scrollbar({ virtualPosition: virtualPosition, MAX_POSITION: MAX_POSITION, animateToPosition: animateToPosition, setVirtualPosition: setVirtualPosition, setIsAnimating: setIsAnimating }) {
    var _trackRef_current;
    const thumbRef = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useRef(null);
    const trackRef = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useRef(null);
    const [isDragging, setIsDragging] = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useState(false);
    const atTop = virtualPosition < $bb235d2f1f0411d2$var$TOP_THRESHOLD;
    const bottomThreshold = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useMemo(()=>{
        return MAX_POSITION - $bb235d2f1f0411d2$var$TOP_THRESHOLD;
    }, [
        MAX_POSITION
    ]);
    const atBottom = virtualPosition > bottomThreshold;
    const scrollPercentage = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useMemo(()=>{
        if (MAX_POSITION === 0n) return 0;
        return Number(virtualPosition * 100n / MAX_POSITION);
    }, [
        virtualPosition,
        MAX_POSITION
    ]);
    const thumbPosition = Math.min(100 - $bb235d2f1f0411d2$var$THUMB_HEIGHT * 100 / (((_trackRef_current = trackRef.current) === null || _trackRef_current === void 0 ? void 0 : _trackRef_current.clientHeight) || 100), Math.max(0, scrollPercentage));
    const handleTrackClick = (e)=>{
        // Prevent click handling if we're clicking the thumb itself
        if (e.target === thumbRef.current) return;
        if (!trackRef.current) return;
        const rect = trackRef.current.getBoundingClientRect();
        const trackHeight = rect.height - $bb235d2f1f0411d2$var$THUMB_HEIGHT;
        let clickPosition = (e.clientY - rect.top - $bb235d2f1f0411d2$var$THUMB_HEIGHT / 2) / trackHeight;
        clickPosition = Math.max(0, Math.min(1, clickPosition));
        const newPosition = $bb235d2f1f0411d2$var$percentOfMax(clickPosition, MAX_POSITION);
        animateToPosition(newPosition);
    };
    const handleDrag = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useCallback((e)=>{
        if (!isDragging || !trackRef.current) return;
        const rect = trackRef.current.getBoundingClientRect();
        const trackHeight = rect.height - $bb235d2f1f0411d2$var$THUMB_HEIGHT;
        let percentage = (e.clientY - rect.top - $bb235d2f1f0411d2$var$THUMB_HEIGHT / 2) / trackHeight;
        percentage = Math.max(0, Math.min(1, percentage));
        const newPosition = $bb235d2f1f0411d2$var$percentOfMax(percentage, MAX_POSITION);
        setVirtualPosition(newPosition);
    }, [
        isDragging,
        trackRef,
        MAX_POSITION,
        setVirtualPosition
    ]);
    const handleDragStart = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useCallback((e)=>{
        e.preventDefault();
        setIsDragging(true);
        setIsAnimating(false);
    }, [
        setIsDragging,
        setIsAnimating
    ]);
    const handleDragEnd = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useCallback(()=>{
        setIsDragging(false);
    }, [
        setIsDragging
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useEffect(()=>{
        if (isDragging) {
            window.addEventListener("pointermove", handleDrag);
            window.addEventListener("pointerup", handleDragEnd);
            return ()=>{
                window.removeEventListener("pointermove", handleDrag);
                window.removeEventListener("pointerup", handleDragEnd);
            };
        }
    }, [
        isDragging,
        handleDrag,
        handleDragEnd
    ]);
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)($bb235d2f1f0411d2$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($bb235d2f1f0411d2$var$NavigationArrow, {
                $top: true,
                $noBorder: atTop,
                onClick: ()=>animateToPosition(0n),
                children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $8c0ce35eac81a929$export$9b80ee7d1e129684), {})
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($bb235d2f1f0411d2$var$Track, {
                ref: trackRef,
                onClick: handleTrackClick,
                children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($bb235d2f1f0411d2$var$Thumb, {
                    ref: thumbRef,
                    style: {
                        "--position": `${thumbPosition}%`
                    },
                    onPointerDown: handleDragStart
                })
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($bb235d2f1f0411d2$var$NavigationArrow, {
                $bottom: true,
                $noBorder: atBottom,
                onClick: ()=>animateToPosition(MAX_POSITION),
                children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $8c0ce35eac81a929$export$4e3778eb35f54199), {})
            })
        ]
    });
}
var $bb235d2f1f0411d2$export$2e2bcd8739ae039 = $bb235d2f1f0411d2$var$Scrollbar;





var $aEMJz = parcelRequire("aEMJz");


// for demonstration purposes only
function $388d8a595f669ae6$export$cd342bdefe25e359(n) {
    if (typeof n !== "bigint") n = BigInt(n);
    if (n < 0n) throw new Error("Number must be non-negative");
    if (n >= 1n << 122n) throw new Error("Number too large (max 122 bits)");
    // Layout the bits preserving the input value:
    // - 32 bits for time_low
    // - 16 bits for time_mid
    // - 12 bits for time_hi (version will be 4)
    // - 14 bits for clock_seq (variant will be 2)
    // - 48 bits for node
    const timeLow = n & 0xffffffffn;
    const timeMid = n >> 32n & 0xffffn;
    const timeHi = n >> 48n & 0x0fffn; // 12 bits
    const clockSeq = n >> 60n & 0x3fffn; // 14 bits
    const node = n >> 74n & 0xffffffffffffn;
    // Add version 4 and variant 2
    const timeHiAndVersion = timeHi | 0x4000n;
    const clockSeqAndReserved = clockSeq | 0x8000n;
    // Convert to hex strings with padding
    const p1 = timeLow.toString(16).padStart(8, "0");
    const p2 = timeMid.toString(16).padStart(4, "0");
    const p3 = timeHiAndVersion.toString(16).padStart(4, "0");
    const p4 = clockSeqAndReserved.toString(16).padStart(4, "0");
    const p5 = node.toString(16).padStart(12, "0");
    return `${p1}-${p2}-${p3}-${p4}-${p5}`;
}
const $388d8a595f669ae6$var$ROUND_CONSTANTS = [
    BigInt("0x47f5417d6b82b5d1"),
    BigInt("0x90a7c5fe8c345af2"),
    BigInt("0xd8796c3b2a1e4f8d"),
    BigInt("0x6f4a3c8e7d5b9102"),
    BigInt("0xb3f8c7d6e5a49201"),
    BigInt("0x2d9e8b7c6f5a3d4e"),
    BigInt("0xa1b2c3d4e5f6789a"),
    BigInt("0x123456789abcdef0")
];
// N has one bit from left and one from right (2 for variant)
// bits from left          bits from right
// ------------------------------------
// |                  |                |
// xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
// just using 4 rounds seems to produce a good enough distribution to appear
// random
const $388d8a595f669ae6$var$ROUNDS_USED = 4;
function $388d8a595f669ae6$export$d5290bdca115404(index) {
    if (index >= BigInt(2) ** BigInt(122)) throw new Error("Index out of range - must be less than 2^122");
    let left = BigInt(index) >> BigInt(61);
    let right = BigInt(index) & (BigInt(1) << BigInt(61)) - BigInt(1);
    for(let round = 0; round < $388d8a595f669ae6$var$ROUNDS_USED; round++){
        const mixed = $388d8a595f669ae6$var$feistelRound(right, round);
        const newRight = left ^ mixed & (BigInt(1) << BigInt(61)) - BigInt(1); // Ensure 61-bit result
        left = right;
        right = newRight;
    }
    let result = BigInt(0);
    // first 48 bits from the left
    // left: 13 bits remaining; right: 61 bits remaining; total: 48 bits used
    result |= left >> BigInt(13) << BigInt(80);
    // 4 bits for version
    // left: 13 bits remaining; right: 61 bits remaining; total: 52 bits used
    result |= BigInt(4) << BigInt(76);
    // next 12 bits from left
    // left: 1 bit remaining; right: 61 bits remaining; total: 64 bits used
    const next12BitsFromLeft = left >> BigInt(1) & (BigInt(1) << BigInt(12)) - BigInt(1);
    result |= next12BitsFromLeft << BigInt(64);
    // 2 bits for variant
    // left: 1 bit remaining; right: 61 bits remaining; total: 66 bits used
    result |= BigInt(2) << BigInt(62);
    // 1 bit remaining from the left!
    // left: 0 bits remaining; right: 61 bits remaining; total: 67 bits used
    const lastBitFromLeft = left & BigInt(1);
    // good to use all the bits from the right
    result |= lastBitFromLeft << BigInt(61);
    result |= right;
    let hex = result.toString(16).padStart(32, "0");
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
function $388d8a595f669ae6$var$feistelRound(block, round) {
    // Mix using rotations, XORs, and addition, maintaining 61-bit blocks
    let mixed = block;
    mixed ^= $388d8a595f669ae6$var$ROUND_CONSTANTS[round] & (BigInt(1) << BigInt(61)) - BigInt(1);
    mixed = (mixed << BigInt(7) | mixed >> BigInt(54)) & (BigInt(1) << BigInt(61)) - BigInt(1);
    mixed = mixed * BigInt("0x6c8e944d1f5aa3b7") & (BigInt(1) << BigInt(61)) - BigInt(1);
    mixed = (mixed << BigInt(13) | mixed >> BigInt(48)) & (BigInt(1) << BigInt(61)) - BigInt(1);
    return mixed;
}
function $388d8a595f669ae6$var$splitUUID(uuid) {
    const hex = uuid.replace(/-/g, "");
    const value = BigInt("0x" + hex);
    let left = BigInt(0);
    let right = BigInt(0);
    //                    (includes LSB of N)
    //                         grab these
    //                    |               |
    // xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
    // Final bit (0) came from after variant bit
    right = value & (BigInt(1) << BigInt(61)) - BigInt(1);
    //  grab these
    // |           |
    // xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
    // Highest 48 bits (60-13) came from first shift
    left |= value >> BigInt(80) << BigInt(13);
    //             grab these
    //                | |
    // xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
    // Next 12 bits (12-1) came from middle section
    const mid12Bits = value >> BigInt(64) & (BigInt(1) << BigInt(12)) - BigInt(1);
    left |= mid12Bits << BigInt(1);
    //                grab bit 1 of N (0 is for right, 2-3 for variant)
    //                    |
    // xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
    // Final bit (0) came from after variant bit
    const lastBit = value >> BigInt(61) & BigInt(1);
    left |= lastBit;
    return {
        left: left,
        right: right
    };
}
function $388d8a595f669ae6$export$3f2c080de3c2408d(uuid) {
    // First split the UUID back into left and right values
    const { left: left, right: right } = $388d8a595f669ae6$var$splitUUID(uuid);
    // Now reverse the Feistel network
    let current_left = left;
    let current_right = right;
    // Run rounds in reverse
    for(let round = $388d8a595f669ae6$var$ROUNDS_USED - 1; round >= 0; round--){
        const prev_right = current_left;
        const mixed = $388d8a595f669ae6$var$feistelRound(prev_right, round);
        const prev_left = current_right ^ mixed & (BigInt(1) << BigInt(61)) - BigInt(1);
        current_left = prev_left;
        current_right = prev_right;
    }
    // Reconstruct the original index
    return current_left << BigInt(61) | current_right;
}






let $27f2fa6d4ea1c25e$var$_ = (t)=>t, $27f2fa6d4ea1c25e$var$t, $27f2fa6d4ea1c25e$var$t1, $27f2fa6d4ea1c25e$var$t2, $27f2fa6d4ea1c25e$var$t3, $27f2fa6d4ea1c25e$var$t4, $27f2fa6d4ea1c25e$var$t5, $27f2fa6d4ea1c25e$var$t6, $27f2fa6d4ea1c25e$var$t7, $27f2fa6d4ea1c25e$var$t8, $27f2fa6d4ea1c25e$var$t9, $27f2fa6d4ea1c25e$var$t10, $27f2fa6d4ea1c25e$var$t11, $27f2fa6d4ea1c25e$var$t12, $27f2fa6d4ea1c25e$var$t13, $27f2fa6d4ea1c25e$var$t14, $27f2fa6d4ea1c25e$var$t15;
const $27f2fa6d4ea1c25e$var$BaseButton = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039)((0, $8326a0f291697a14$export$2e2bcd8739ae039))($27f2fa6d4ea1c25e$var$t || ($27f2fa6d4ea1c25e$var$t = $27f2fa6d4ea1c25e$var$_`
  height: 100%;
  aspect-ratio: 1;
  cursor: pointer;
  padding: 0;
  transition:
    transform 0.1s ease-in-out,
    color 0.1s ease-in-out;

  @media ${0} {
    height: 60%;
  }

  &:focus {
    outline: none;
    background-color: transparent;
  }

  &:selected {
    background-color: transparent;
  }

  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-tap-highlight-color: transparent;
`), (0, $576749860f83a2d7$export$3d5e80817e1f8611));
const $27f2fa6d4ea1c25e$var$CopyButton = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039)($27f2fa6d4ea1c25e$var$BaseButton)($27f2fa6d4ea1c25e$var$t1 || ($27f2fa6d4ea1c25e$var$t1 = $27f2fa6d4ea1c25e$var$_`
  grid-area: copy;

  color: var(--slate-700);

  @media (hover: hover) {
    &:hover {
      color: var(--slate-900);
    }
  }

  transform: ${0};

  &:active {
    transform: scale(0.8);
  }
`), (props)=>props.$rowMouseDown ? "scale(0.8)" : "none");
const $27f2fa6d4ea1c25e$var$SpinStretch = (0, $4a95c28624d97f2e$export$d25ddfdf17c3ad3e)($27f2fa6d4ea1c25e$var$t2 || ($27f2fa6d4ea1c25e$var$t2 = $27f2fa6d4ea1c25e$var$_`
  0% {
    transform: scale(1) rotate(0deg);
  }

  20% {
    transform: scale(0.8) rotate(-40deg);
  }


  100% {
    transform: scale(1) rotate(360deg);
  }
`));
const $27f2fa6d4ea1c25e$var$FavoriteButton = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039)($27f2fa6d4ea1c25e$var$BaseButton)($27f2fa6d4ea1c25e$var$t3 || ($27f2fa6d4ea1c25e$var$t3 = $27f2fa6d4ea1c25e$var$_`
  grid-area: favorite;

  color: var(--yellow-700);

  --fill-color: ${0};

  &[data-just-faved="true"] {
    animation: ${0} 0.8s cubic-bezier(0.25, 0.8, 0.25, 1) both;
  }

  @media (hover: hover) {
    &:hover {
      color: ${0};
    }
  }
`), (props)=>props.$isFaved ? "var(--yellow-500)" : "transparent", $27f2fa6d4ea1c25e$var$SpinStretch, (props)=>props.$isFaved ? "var(--yellow-100)" : "var(--yellow-500)");
const $27f2fa6d4ea1c25e$var$Wrapper = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($27f2fa6d4ea1c25e$var$t4 || ($27f2fa6d4ea1c25e$var$t4 = $27f2fa6d4ea1c25e$var$_`
  flex: 1;
  min-height: 0;
  position: relative;
  outline: none;

  --text-size: 0.875rem;

  @media ${0} {
    --text-size: 0.75rem;
  }
`), (0, $576749860f83a2d7$export$57b55975112d979e));
const $27f2fa6d4ea1c25e$var$List = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($27f2fa6d4ea1c25e$var$t5 || ($27f2fa6d4ea1c25e$var$t5 = $27f2fa6d4ea1c25e$var$_`
  height: 100%;
  padding-bottom: 2rem;
`));
const $27f2fa6d4ea1c25e$var$RowWrapper = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($27f2fa6d4ea1c25e$var$t6 || ($27f2fa6d4ea1c25e$var$t6 = $27f2fa6d4ea1c25e$var$_`
  display: grid;
  padding: 0.25rem 0;

  grid-template-areas: "index colon uuid copy favorite copied";
  grid-template-rows: 100%;
  grid-template-columns: repeat(5, fit-content(15px));
  gap: 0.25rem 0.5rem;
  align-items: center;

  margin-left: ${0}px;
  font-family: monospace;
  white-space: nowrap;
  font-size: var(--text-size);
  border-bottom: 1px solid var(--border-color);
  height: ${0}px;

  @media (hover: hover) {
    &:hover {
      background-color: var(--slate-400);
    }
  }

  background-color: var(--row-background, transparent);
  transition: background-color 0.1s ease-in-out;

  @media ${0} {
    grid-template-columns: repeat(2, fit-content(0));
    grid-template-areas: "index copy favorite" "uuid copy favorite";
    grid-template-rows: 50% 50%;
    height: ${0}px;
    justify-content: center;
    gap: 0.25rem 0.5rem;
    padding: 0.5rem 0;
    margin-left: 0;
  }
`), (0, $576749860f83a2d7$export$9a6bb2acef5e644a), (0, $576749860f83a2d7$export$cba6217a006ba569), (0, $576749860f83a2d7$export$3d5e80817e1f8611), (0, $576749860f83a2d7$export$cba6217a006ba569) * 2);
const $27f2fa6d4ea1c25e$var$FadeOutDown = (0, $4a95c28624d97f2e$export$d25ddfdf17c3ad3e)($27f2fa6d4ea1c25e$var$t7 || ($27f2fa6d4ea1c25e$var$t7 = $27f2fa6d4ea1c25e$var$_`
  0% {
    opacity: 0;
  }

  15% {
    opacity: 1;
  }

  40% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $27f2fa6d4ea1c25e$var$FadeOutSide = (0, $4a95c28624d97f2e$export$d25ddfdf17c3ad3e)($27f2fa6d4ea1c25e$var$t8 || ($27f2fa6d4ea1c25e$var$t8 = $27f2fa6d4ea1c25e$var$_`
  0% {
    opacity: 0;
    transform: translateX(0);
  }

  30% {
    opacity: 1;
    transform: translateX(-110%);
  }

  50% {
    opacity: 1;
    transform: translateX(-110%);
  }

  100% {
    transform: translateX(0);
  }
`));
const $27f2fa6d4ea1c25e$var$CopiedText = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($27f2fa6d4ea1c25e$var$t9 || ($27f2fa6d4ea1c25e$var$t9 = $27f2fa6d4ea1c25e$var$_`
  grid-area: copied;
  font-size: var(--text-size);
  color: var(--green-900);
  animation: ${0} 0.6s ease-in both;
  user-select: none;

  @media ${0} {
    position: absolute;
    backdrop-filter: blur(10px);
    background-color: var(--slate-100);
    border-radius: 0.5rem;
    padding: 0.5rem;
    left: 100%;
    animation: ${0} 1s ease-out both;
    /* transform: translateX(-50%); */
  }
`), $27f2fa6d4ea1c25e$var$FadeOutDown, (0, $576749860f83a2d7$export$3d5e80817e1f8611), $27f2fa6d4ea1c25e$var$FadeOutSide);
const $27f2fa6d4ea1c25e$var$Index = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).span($27f2fa6d4ea1c25e$var$t10 || ($27f2fa6d4ea1c25e$var$t10 = $27f2fa6d4ea1c25e$var$_`
  opacity: 0.7;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
`));
const $27f2fa6d4ea1c25e$var$Padding = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).span($27f2fa6d4ea1c25e$var$t11 || ($27f2fa6d4ea1c25e$var$t11 = $27f2fa6d4ea1c25e$var$_`
  opacity: 0.3;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
`));
const $27f2fa6d4ea1c25e$var$IndexWithPadding = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($27f2fa6d4ea1c25e$var$t12 || ($27f2fa6d4ea1c25e$var$t12 = $27f2fa6d4ea1c25e$var$_`
  display: inline-block;
`));
const $27f2fa6d4ea1c25e$var$Colon = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).span($27f2fa6d4ea1c25e$var$t13 || ($27f2fa6d4ea1c25e$var$t13 = $27f2fa6d4ea1c25e$var$_`
  grid-area: colon;

  &::after {
    content: "";
  }

  @media ${0} {
    display: none;
  }
`), (0, $576749860f83a2d7$export$3d5e80817e1f8611));
const $27f2fa6d4ea1c25e$var$UUID = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).span($27f2fa6d4ea1c25e$var$t14 || ($27f2fa6d4ea1c25e$var$t14 = $27f2fa6d4ea1c25e$var$_`
  grid-area: uuid;
  color: var(--uuid-color);
  display: block;
  width: fit-content;

  @media ${0} {
    justify-self: end;
  }
`), (0, $576749860f83a2d7$export$3d5e80817e1f8611));
const $27f2fa6d4ea1c25e$var$Highlight = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).span($27f2fa6d4ea1c25e$var$t15 || ($27f2fa6d4ea1c25e$var$t15 = $27f2fa6d4ea1c25e$var$_`
  background-color: yellow;
`));
function $27f2fa6d4ea1c25e$var$Row({ index: index, uuid: uuid, isFaved: isFaved, toggleFavedUUID: toggleFavedUUID, search: search, searchDisplayed: searchDisplayed }) {
    const indexString = index.toString();
    const length = indexString.length;
    const padLength = 37;
    const paddingLength = padLength - length;
    let padding;
    if (paddingLength < 0) {
        console.error("paddingLength < 0", indexString, length, padLength);
        padding = "";
    } else padding = "0".repeat(paddingLength);
    const [justFaved, setJustFaved] = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useState(null);
    const [mouseDown, setMouseDown] = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useState(false);
    const [justCopied, setJustCopied] = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useState(0);
    const timeoutRef = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useRef(null);
    const handleCopy = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useCallback(async ()=>{
        clearTimeout(timeoutRef.current);
        await navigator.clipboard.writeText(uuid).catch((e)=>{
            console.error("error copying to clipboard", e);
            setJustCopied(0);
        }).then(()=>{
            setJustCopied((prev)=>prev + 1);
            timeoutRef.current = setTimeout(()=>{
                setJustCopied(0);
            }, 1000);
        });
    }, [
        uuid
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useEffect(()=>{
        if (justFaved && justFaved !== uuid) setJustFaved(null);
    }, [
        justFaved,
        uuid
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useEffect(()=>{
        const handleMouseUp = ()=>{
            if (mouseDown) {
                setMouseDown(false);
                handleCopy();
            }
        };
        window.addEventListener("mouseup", handleMouseUp);
        return ()=>{
            window.removeEventListener("mouseup", handleMouseUp);
        };
    }, [
        mouseDown,
        handleCopy
    ]);
    const highlight = searchDisplayed && search && uuid.includes(search);
    let UUIDToDisplay = uuid;
    if (highlight) {
        const start = uuid.indexOf(search);
        const end = start + search.length;
        UUIDToDisplay = /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)((0, $fe3e626085e1e6b8$exports.Fragment), {
            children: [
                uuid.slice(0, start),
                /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($27f2fa6d4ea1c25e$var$Highlight, {
                    children: uuid.slice(start, end)
                }),
                uuid.slice(end)
            ]
        });
    }
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)($27f2fa6d4ea1c25e$var$RowWrapper, {
        // this doesn't work well with touch-scrolling (you end up copying on accident)
        // so we just use the mouse
        onMouseDown: (e)=>{
            // only trigger if the click is on the row, not on some text
            if (e.target === e.currentTarget) setMouseDown(true);
        },
        style: {
            backgroundColor: mouseDown ? "var(--slate-500)" : null
        },
        children: [
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)($27f2fa6d4ea1c25e$var$IndexWithPadding, {
                style: {
                    gridArea: "index"
                },
                children: [
                    /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($27f2fa6d4ea1c25e$var$Padding, {
                        children: padding
                    }),
                    /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($27f2fa6d4ea1c25e$var$Index, {
                        children: indexString
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($27f2fa6d4ea1c25e$var$Colon, {}),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($27f2fa6d4ea1c25e$var$UUID, {
                children: UUIDToDisplay
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($27f2fa6d4ea1c25e$var$CopyButton, {
                onClick: handleCopy,
                $rowMouseDown: mouseDown,
                children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $8c0ce35eac81a929$export$ea3b71af1761ff40), {
                    style: {
                        height: "100%",
                        aspectRatio: 1
                    }
                })
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($27f2fa6d4ea1c25e$var$FavoriteButton, {
                $isFaved: isFaved,
                "data-just-faved": isFaved && justFaved === uuid,
                onClick: ()=>{
                    if (!isFaved) setJustFaved(uuid);
                    toggleFavedUUID(uuid);
                },
                children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $8c0ce35eac81a929$export$1644ba17714857f1), {
                    fill: "var(--fill-color)",
                    style: {
                        height: "100%",
                        aspectRatio: 1
                    }
                })
            }),
            justCopied !== 0 && /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($27f2fa6d4ea1c25e$var$CopiedText, {
                children: "copied!"
            }, justCopied)
        ]
    });
}
function $27f2fa6d4ea1c25e$var$UUIDDisplay({ itemsToShow: itemsToShow, setItemsToShow: setItemsToShow, virtualPosition: virtualPosition, setVirtualPosition: setVirtualPosition, favedUUIDs: favedUUIDs, toggleFavedUUID: toggleFavedUUID, isAnimating: isAnimating, MAX_POSITION: MAX_POSITION, animateToPosition: animateToPosition, search: search, searchDisplayed: searchDisplayed, displayedUUIDs: displayedUUIDs }) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useRef(null);
    const movePosition = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useCallback((delta)=>{
        if (isAnimating) return;
        setVirtualPosition((prev)=>{
            const newPos = prev + delta;
            const ret = newPos < 0n ? 0n : newPos > MAX_POSITION ? MAX_POSITION : newPos;
            return ret;
        });
    }, [
        isAnimating,
        MAX_POSITION,
        setVirtualPosition
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useEffect(()=>{
        if (ref.current === null) return;
        const computeItemsToShow = ()=>{
            const rect = ref.current.getBoundingClientRect();
            const height = rect.height;
            const width = rect.width + (0, $576749860f83a2d7$export$9a6bb2acef5e644a);
            const showDoubleHeight = width < (0, $576749860f83a2d7$export$83e664a9d119a376);
            const items = Math.floor(height / (showDoubleHeight ? (0, $576749860f83a2d7$export$cba6217a006ba569) * 2 : (0, $576749860f83a2d7$export$cba6217a006ba569)));
            setItemsToShow(items);
        };
        computeItemsToShow();
        // debounce??
        window.addEventListener("resize", computeItemsToShow);
        return ()=>{
            window.removeEventListener("resize", computeItemsToShow);
        };
    }, [
        setItemsToShow
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useEffect(()=>{
        if (ref.current) ref.current.focus();
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useEffect(()=>{
        if (!ref.current) return;
        const handleWheel = (e)=>{
            if (isAnimating) return;
            e.preventDefault();
            movePosition(BigInt(Math.floor(e.deltaY)));
        };
        ref.current.addEventListener("wheel", handleWheel, {
            passive: false
        });
        let lastTouchY = 0;
        let lastTouchTime = 0;
        let velocity = 0;
        let animationFrame = null;
        const applyMomentum = ()=>{
            if (Math.abs(velocity) > 0.5) {
                movePosition(BigInt(Math.floor(velocity)));
                // Decay the velocity - play with these numbers to adjust the "feel"
                velocity *= 0.95;
                animationFrame = requestAnimationFrame(applyMomentum);
            } else velocity = 0;
        };
        const handleTouchStart = (e)=>{
            lastTouchY = e.touches[0].clientY;
            lastTouchTime = Date.now();
            velocity = 0;
            if (animationFrame) cancelAnimationFrame(animationFrame);
        };
        const handleTouchMove = (e)=>{
            e.preventDefault();
            const touchY = e.touches[0].clientY;
            const deltaY = lastTouchY - touchY;
            const now = Date.now();
            const deltaTime = now - lastTouchTime;
            velocity = deltaY / deltaTime * 16.67;
            lastTouchY = touchY;
            lastTouchTime = now;
            movePosition(BigInt(Math.floor(deltaY * 2)));
        };
        const handleTouchEnd = ()=>{
            // Start momentum scrolling
            if (Math.abs(velocity) > 0.5) animationFrame = requestAnimationFrame(applyMomentum);
        };
        ref.current.addEventListener("touchstart", handleTouchStart, {
            passive: false
        });
        ref.current.addEventListener("touchmove", handleTouchMove, {
            passive: false
        });
        ref.current.addEventListener("touchend", handleTouchEnd, {
            passive: false
        });
        return ()=>{
            if (!ref.current) return;
            ref.current.removeEventListener("wheel", handleWheel);
            ref.current.removeEventListener("touchstart", handleTouchStart);
            ref.current.removeEventListener("touchmove", handleTouchMove);
            ref.current.removeEventListener("touchend", handleTouchEnd);
        };
    }, [
        movePosition
    ]);
    const handleKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useCallback((e)=>{
        if (isAnimating) return;
        const PAGE_SIZE = BigInt(itemsToShow);
        const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
        const cmdKey = isMac ? e.metaKey : e.ctrlKey;
        const shiftKey = e.shiftKey;
        const handleAndPrevent = (action)=>{
            e.preventDefault();
            action();
        };
        const hasKeyAndModifier = (key, modifiers = [])=>{
            return e.key === key && modifiers.every((mod)=>mod);
        };
        const handleKeyAndPrevent = (key, modifiers = [], action)=>{
            if (hasKeyAndModifier(key, modifiers)) {
                handleAndPrevent(action);
                return true;
            }
            return false;
        };
        const animateWithDelta = (delta)=>{
            let target = virtualPosition + delta;
            if (target < 0n) target = 0n;
            else if (target > MAX_POSITION) target = MAX_POSITION;
            animateToPosition(target);
        };
        switch(true){
            case handleKeyAndPrevent("ArrowDown", [
                cmdKey
            ], ()=>{
                animateWithDelta(MAX_POSITION);
            }):
                return;
            case handleKeyAndPrevent("ArrowUp", [
                cmdKey
            ], ()=>animateWithDelta(-MAX_POSITION)):
                return;
            case handleKeyAndPrevent(" ", [
                shiftKey
            ], ()=>{
                animateWithDelta(-PAGE_SIZE);
            }):
                return;
            case handleKeyAndPrevent(" ", [], ()=>{
                animateWithDelta(PAGE_SIZE);
            }):
                return;
            case handleKeyAndPrevent("PageDown", [
                cmdKey
            ], ()=>{
                animateWithDelta(MAX_POSITION);
            }):
                return;
            case handleKeyAndPrevent("PageUp", [
                cmdKey
            ], ()=>{
                animateWithDelta(0n);
            }):
                return;
            case handleKeyAndPrevent("PageDown", [], ()=>{
                animateWithDelta(PAGE_SIZE);
            }):
                return;
            case handleKeyAndPrevent("PageUp", [], ()=>{
                animateWithDelta(-PAGE_SIZE);
            }):
                return;
            case handleKeyAndPrevent("Home", [], ()=>animateWithDelta(0n)):
                return;
            case handleKeyAndPrevent("End", [], ()=>animateWithDelta(MAX_POSITION)):
                return;
            case handleKeyAndPrevent("ArrowDown", [], ()=>movePosition(1n)):
                return;
            case handleKeyAndPrevent("ArrowUp", [], ()=>movePosition(-1n)):
                return;
            case handleKeyAndPrevent("j", [], ()=>movePosition(1n)):
                return;
            case handleKeyAndPrevent("k", [], ()=>movePosition(-1n)):
                return;
            default:
                break;
        }
    }, [
        isAnimating,
        virtualPosition,
        movePosition,
        MAX_POSITION,
        itemsToShow,
        animateToPosition
    ]);
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($27f2fa6d4ea1c25e$var$Wrapper, {
        ref: ref,
        onKeyDown: handleKeyDown,
        tabIndex: 0,
        children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($27f2fa6d4ea1c25e$var$List, {
            children: displayedUUIDs.map(({ index: index, uuid: uuid }, i)=>{
                return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($27f2fa6d4ea1c25e$var$Row, {
                    index: index,
                    uuid: uuid,
                    isFaved: favedUUIDs[uuid],
                    toggleFavedUUID: toggleFavedUUID,
                    search: search,
                    searchDisplayed: searchDisplayed
                }, i);
            })
        })
    });
}
var $27f2fa6d4ea1c25e$export$2e2bcd8739ae039 = $27f2fa6d4ea1c25e$var$UUIDDisplay;




var $aEMJz = parcelRequire("aEMJz");





var $aEMJz = parcelRequire("aEMJz");


const $0ead7998f28d591b$var$PADDING_SENTINEL = "X";
const $0ead7998f28d591b$var$VARIANT_SENTINEL = "V";
const $0ead7998f28d591b$var$VERSION = "4";
const $0ead7998f28d591b$var$VALID_VARIANTS = [
    "8",
    "9",
    "a",
    "b"
];
function $0ead7998f28d591b$var$getPatternWithPadding(search, leftPadding) {
    const uuidTemplate = `${$0ead7998f28d591b$var$PADDING_SENTINEL.repeat(8)}-${$0ead7998f28d591b$var$PADDING_SENTINEL.repeat(4)}-${$0ead7998f28d591b$var$VERSION}${$0ead7998f28d591b$var$PADDING_SENTINEL.repeat(3)}-${$0ead7998f28d591b$var$VARIANT_SENTINEL}${$0ead7998f28d591b$var$PADDING_SENTINEL.repeat(3)}-${$0ead7998f28d591b$var$PADDING_SENTINEL.repeat(12)}`;
    for(let pos = 0; pos < search.length; pos++){
        const patternPos = leftPadding + pos;
        const inputChar = search[pos];
        const templateChar = uuidTemplate[patternPos];
        if (inputChar === "-" && templateChar !== "-" || templateChar === "-" && inputChar !== "-") return null;
        if (patternPos === 14 && inputChar !== $0ead7998f28d591b$var$VERSION) return null;
        if (patternPos === 19 && !$0ead7998f28d591b$var$VALID_VARIANTS.includes(inputChar)) return null;
    }
    const pattern = uuidTemplate.slice(0, leftPadding) + search + uuidTemplate.slice(leftPadding + search.length);
    const sections = pattern.split("-");
    if (sections[0].length === 8 && sections[1].length === 4 && sections[2].length === 4 && sections[3].length === 4 && sections[4].length === 12) return pattern;
    return null;
}
function $0ead7998f28d591b$var$getAllValidPatterns(search) {
    const patterns = [];
    const uuidTemplate = `${$0ead7998f28d591b$var$PADDING_SENTINEL.repeat(8)}-${$0ead7998f28d591b$var$PADDING_SENTINEL.repeat(4)}-${$0ead7998f28d591b$var$VERSION}${$0ead7998f28d591b$var$PADDING_SENTINEL.repeat(3)}-${$0ead7998f28d591b$var$VARIANT_SENTINEL}${$0ead7998f28d591b$var$PADDING_SENTINEL.repeat(3)}-${$0ead7998f28d591b$var$PADDING_SENTINEL.repeat(12)}`;
    for(let leftPadding = 0; leftPadding < uuidTemplate.length - search.length + 1; leftPadding++){
        const pattern = $0ead7998f28d591b$var$getPatternWithPadding(search, leftPadding);
        if (pattern) patterns.push({
            pattern: pattern,
            leftPadding: leftPadding
        });
    }
    return patterns;
}
function $0ead7998f28d591b$var$generateRandomUUID(pattern) {
    return pattern.replace(new RegExp($0ead7998f28d591b$var$VARIANT_SENTINEL, "g"), ()=>$0ead7998f28d591b$var$VALID_VARIANTS[Math.floor(Math.random() * $0ead7998f28d591b$var$VALID_VARIANTS.length)]).replace(new RegExp($0ead7998f28d591b$var$PADDING_SENTINEL, "g"), ()=>"0123456789abcdef"[Math.floor(Math.random() * 16)]);
}
const $0ead7998f28d591b$var$SEARCH_LOOKBACK = 50;
const $0ead7998f28d591b$var$SEARCH_LOOKAHEAD = 25;
const $0ead7998f28d591b$var$RANDOM_SEARCH_ITERATIONS = 100;
function $0ead7998f28d591b$export$a14fc6ef9763a5cb({ virtualPosition: virtualPosition, displayedUUIDs: displayedUUIDs }) {
    const [search, setSearch] = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useState(null);
    const [uuid, setUUID] = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useState(null);
    // Stack of complete states we've seen
    const [nextStates, setNextStates] = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useState([]);
    const previousUUIDs = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useMemo(()=>{
        let hasComputed = false;
        let value = null;
        const getValue = ()=>{
            const compute = ()=>{
                const prev = [];
                for(let i = 1; i <= $0ead7998f28d591b$var$SEARCH_LOOKBACK; i++){
                    i = BigInt(i);
                    let index = BigInt(virtualPosition) - i;
                    if (index < 0n) index = (0, $576749860f83a2d7$export$3ee5d4c6315a6ba5) + index;
                    const uuid = (0, $388d8a595f669ae6$export$d5290bdca115404)(index);
                    prev.push({
                        index: index,
                        uuid: uuid
                    });
                }
                return prev;
            };
            if (!hasComputed) {
                value = compute();
                hasComputed = true;
            }
            return value;
        };
        return getValue;
    }, [
        virtualPosition
    ]);
    const nextUUIDs = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useMemo(()=>{
        let hasComputed = false;
        let value = null;
        const getValue = ()=>{
            const compute = ()=>{
                const next = [];
                for(let i = 1; i <= $0ead7998f28d591b$var$SEARCH_LOOKAHEAD; i++){
                    i = BigInt(i);
                    let index = virtualPosition + i;
                    if (index > (0, $576749860f83a2d7$export$3ee5d4c6315a6ba5)) index = index - (0, $576749860f83a2d7$export$3ee5d4c6315a6ba5);
                    const uuid = (0, $388d8a595f669ae6$export$d5290bdca115404)(index);
                    next.push({
                        index: index,
                        uuid: uuid
                    });
                }
                return next;
            };
            if (!hasComputed) {
                value = compute();
                hasComputed = true;
            }
            return value;
        };
        return getValue;
    }, [
        virtualPosition
    ]);
    const searchAround = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useCallback(({ input: input, wantHigher: wantHigher, canUseCurrentIndex: canUseCurrentIndex })=>{
        if (wantHigher) {
            const startPosition = canUseCurrentIndex ? 0 : 1;
            for(let i = startPosition; i < displayedUUIDs.length; i++){
                const uuid = displayedUUIDs[i].uuid;
                if (uuid.includes(input)) return {
                    uuid: uuid,
                    index: displayedUUIDs[i].index
                };
            }
            const next = nextUUIDs();
            for(let i = 0; i < next.length; i++){
                const uuid = next[i].uuid;
                if (uuid.includes(input)) return {
                    uuid: uuid,
                    index: nextUUIDs[i].index
                };
            }
        } else {
            // canUseCurrentIndex isn't relevant when searching backwards!
            const prev = previousUUIDs();
            for (const { uuid: uuid, index: index } of prev){
                if (uuid.includes(input)) return {
                    uuid: uuid,
                    index: index
                };
            }
        }
        return null;
    }, [
        displayedUUIDs,
        previousUUIDs,
        nextUUIDs
    ]);
    const searchRandomly = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useCallback(({ input: input, wantHigher: wantHigher })=>{
        const patterns = $0ead7998f28d591b$var$getAllValidPatterns(input);
        if (patterns.length === 0) return null;
        let best = null;
        let compareIndex = virtualPosition;
        for(let i = 0; i < $0ead7998f28d591b$var$RANDOM_SEARCH_ITERATIONS; i++){
            const { pattern: pattern, leftPadding: leftPadding } = patterns[Math.floor(Math.random() * patterns.length)];
            const uuid = $0ead7998f28d591b$var$generateRandomUUID(pattern);
            const index = (0, $388d8a595f669ae6$export$3f2c080de3c2408d)(uuid);
            const satisfiesConstraint = wantHigher ? index > compareIndex : index < compareIndex;
            const notInHistory = !nextStates.some(({ uuid: nextUUID })=>nextUUID === uuid);
            if (satisfiesConstraint && notInHistory) {
                const isBetter = best === null ? true : wantHigher ? index < best.index : index > best.index;
                if (isBetter) best = {
                    uuid: uuid,
                    pattern: pattern,
                    leftPadding: leftPadding,
                    index: index
                };
            }
        }
        if (best) return best;
        const { pattern: fallbackPattern, leftPadding: fallbackLeftPadding } = patterns[Math.floor(Math.random() * patterns.length)];
        return {
            uuid: $0ead7998f28d591b$var$generateRandomUUID(fallbackPattern),
            pattern: fallbackPattern,
            leftPadding: fallbackLeftPadding,
            index: (0, $388d8a595f669ae6$export$3f2c080de3c2408d)(uuid)
        };
    }, [
        nextStates,
        uuid,
        virtualPosition
    ]);
    const searchUUID = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useCallback((input)=>{
        const invalid = input.toLowerCase().replace(/[^0-9a-f-]/g, "");
        if (invalid !== input) return null;
        const newSearch = input.toLowerCase().replace(/[^0-9a-f-]/g, "");
        if (!newSearch) return null;
        // Clear next states stack when search changes
        setNextStates([]);
        const inner = ()=>{
            const around = searchAround({
                input: input,
                wantHigher: true,
                canUseCurrentIndex: true
            });
            if (around) return around;
            return searchRandomly({
                input: input,
                wantHigher: true
            });
        };
        const result = inner();
        if (result) {
            setSearch(newSearch);
            setUUID(result.uuid);
            setNextStates((prev)=>[
                    ...prev,
                    result
                ]);
        }
        var _result_uuid;
        return (_result_uuid = result === null || result === void 0 ? void 0 : result.uuid) !== null && _result_uuid !== void 0 ? _result_uuid : null;
    }, [
        searchAround,
        searchRandomly
    ]);
    const nextUUID = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useCallback(()=>{
        if (!uuid || !search) return null;
        const inner = ()=>{
            const around = searchAround({
                input: search,
                wantHigher: true,
                canUseCurrentIndex: false
            });
            if (around) return around;
            return searchRandomly({
                input: search,
                wantHigher: true
            });
        };
        const result = inner();
        if (result) {
            setUUID(result.uuid);
            setNextStates((prev)=>[
                    ...prev,
                    result
                ]);
            return result.uuid;
        }
        return null;
    }, [
        uuid,
        search,
        searchAround,
        searchRandomly
    ]);
    const previousUUID = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useCallback(()=>{
        if (!uuid || !search) return null;
        if (nextStates.length > 1) {
            setNextStates((prev)=>prev.slice(0, -1));
            const prevState = nextStates[nextStates.length - 2];
            setUUID(prevState.uuid);
            return prevState.uuid;
        }
        const inner = ()=>{
            const around = searchAround({
                input: search,
                wantHigher: false,
                canUseCurrentIndex: false
            });
            if (around) return around;
            return searchRandomly({
                input: search,
                wantHigher: false
            });
        };
        const result = inner();
        if (result) {
            setUUID(result.uuid);
            return result.uuid;
        }
        return null;
    }, [
        uuid,
        search,
        nextStates,
        searchAround,
        searchRandomly
    ]);
    return {
        searchUUID: searchUUID,
        nextUUID: nextUUID,
        previousUUID: previousUUID,
        currentUUID: uuid
    };
}



let $8c61e0cf04238a32$var$_ = (t)=>t, $8c61e0cf04238a32$var$t, $8c61e0cf04238a32$var$t1, $8c61e0cf04238a32$var$t2, $8c61e0cf04238a32$var$t3, $8c61e0cf04238a32$var$t4, $8c61e0cf04238a32$var$t5;
const $8c61e0cf04238a32$var$Button = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039)((0, $8326a0f291697a14$export$2e2bcd8739ae039))($8c61e0cf04238a32$var$t || ($8c61e0cf04238a32$var$t = $8c61e0cf04238a32$var$_`
  font-size: 0.875rem;
  aspect-ratio: 1;
  max-height: 80%;
  padding: 4px;
  color: var(--neutral-700);
  flex-shrink: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  @media (hover: hover) {
    &:hover {
      background-color: var(--slate-200);
    }
  }
`));
const $8c61e0cf04238a32$var$Wrapper = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($8c61e0cf04238a32$var$t1 || ($8c61e0cf04238a32$var$t1 = $8c61e0cf04238a32$var$_`
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
  height: 2rem;
  position: fixed;
  top: 0;
  right: 4rem;
  padding: 0 0.5rem;

  /* max-width: max-content; */
  max-width: calc(100vw - ${0}px);

  @media ${0} {
    right: calc(${0}px);
  }

  transform: translateY(var(--y-offset));
  transition: transform 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
  z-index: 1000;
  background-color: var(--slate-50);
  align-items: center;
`), (0, $576749860f83a2d7$export$9a6bb2acef5e644a), (0, $576749860f83a2d7$export$3d5e80817e1f8611), (0, $576749860f83a2d7$export$9a6bb2acef5e644a));
const $8c61e0cf04238a32$var$ShowSearchButton = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039)((0, $8326a0f291697a14$export$2e2bcd8739ae039))($8c61e0cf04238a32$var$t2 || ($8c61e0cf04238a32$var$t2 = $8c61e0cf04238a32$var$_`
  background-color: var(--slate-50);
  border-radius: 0 0 8px 8px;
  font-size: 0.875rem;
  font-family: monospace;
  padding: 0rem 1rem;

  /* transform: translateY(var(--y-offset));
  transition: transform 0.1s cubic-bezier(0.215, 0.61, 0.355, 1); */
  display: flex;
  align-items: center;

  position: absolute;
  z-index: 999;
  right: 10rem;
  color: inherit;
  @media ${0} {
    right: calc(${0}px);
    bottom: 0;
    border-radius: 8px 0 0 8px;
  }

  outline: none;
  &:focus {
    outline: none;
  }
  cursor: pointer;
  transition: background-color 0.1s ease-in-out;
  @media (hover: hover) {
    &:hover {
      background-color: var(--slate-400);
    }
  }
`), (0, $576749860f83a2d7$export$3d5e80817e1f8611), (0, $576749860f83a2d7$export$9a6bb2acef5e644a));
const $8c61e0cf04238a32$var$Input = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).input($8c61e0cf04238a32$var$t3 || ($8c61e0cf04238a32$var$t3 = $8c61e0cf04238a32$var$_`
  font-family: monospace;
  font-size: 1rem;
  width: 100%;
  padding: 0.25rem;
  outline: none;
  border: none;
  background-color: var(--slate-50);

  &:focus {
    outline: none;
  }
`));
const $8c61e0cf04238a32$var$Form = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).form($8c61e0cf04238a32$var$t4 || ($8c61e0cf04238a32$var$t4 = $8c61e0cf04238a32$var$_`
  flex: 1 1 38ch;
  width: 38ch;
  min-width: 6ch;
`));
const $8c61e0cf04238a32$var$Line = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($8c61e0cf04238a32$var$t5 || ($8c61e0cf04238a32$var$t5 = $8c61e0cf04238a32$var$_`
  height: 60%;
  width: 1px;
  background-color: var(--neutral-400);
  margin-right: 0.5rem;
  flex-shrink: 0;
`));
function $8c61e0cf04238a32$var$useShiftIsHeldDown() {
    const [shiftIsHeldDown, setShiftIsHeldDown] = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useEffect(()=>{
        const listener = (e)=>setShiftIsHeldDown(e.shiftKey);
        window.addEventListener("keydown", listener);
        window.addEventListener("keyup", listener);
        return ()=>{
            window.removeEventListener("keydown", listener);
            window.removeEventListener("keyup", listener);
        };
    }, []);
    return shiftIsHeldDown;
}
function $8c61e0cf04238a32$var$SearchWidget({ setVirtualPosition: setVirtualPosition, search: search, setSearch: setSearch, searchDisplayed: searchDisplayed, setSearchDisplayed: setSearchDisplayed, displayedUUIDs: displayedUUIDs, virtualPosition: virtualPosition, MAX_POSITION: MAX_POSITION }) {
    const inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useRef(null);
    const cmdKey = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useMemo(()=>{
        const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
        return isMac ? "metaKey" : "ctrlKey";
    }, []);
    const shiftIsHeldDown = $8c61e0cf04238a32$var$useShiftIsHeldDown();
    const { searchUUID: searchUUID, currentUUID: currentUUID, nextUUID: nextUUID, previousUUID: previousUUID } = (0, $0ead7998f28d591b$export$a14fc6ef9763a5cb)({
        displayedUUIDs: displayedUUIDs,
        virtualPosition: virtualPosition
    });
    const index = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useMemo(()=>{
        if (currentUUID) {
            const index = (0, $388d8a595f669ae6$export$3f2c080de3c2408d)(currentUUID);
            return index;
        }
        return null;
    }, [
        currentUUID
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useEffect(()=>{
        if (index) {
            if (index < 0n) setVirtualPosition(0n);
            else if (index >= MAX_POSITION) setVirtualPosition(MAX_POSITION);
            else setVirtualPosition(index);
        }
    }, [
        setVirtualPosition,
        index
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useEffect(()=>{
        window.addEventListener("keydown", (e)=>{
            if (!inputRef.current) return;
            if (e[cmdKey] && e.key === "f") {
                e.preventDefault();
                if (searchDisplayed) {
                    // check if the input is focused
                    if (document.activeElement === inputRef.current) ;
                    else inputRef.current.focus();
                } else {
                    setSearchDisplayed(true);
                    inputRef.current.focus();
                }
            } else if (e.key === "Escape") {
                e.preventDefault();
                setSearchDisplayed(false);
            }
        });
    }, [
        searchDisplayed,
        cmdKey
    ]);
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)((0, $fe3e626085e1e6b8$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c61e0cf04238a32$var$ShowSearchButton, {
                onClick: ()=>{
                    if (!searchDisplayed && inputRef.current) inputRef.current.focus();
                    setSearchDisplayed((prev)=>!prev);
                },
                children: "search!"
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)($8c61e0cf04238a32$var$Wrapper, {
                style: {
                    "--y-offset": searchDisplayed ? "0" : "-110%"
                },
                children: [
                    /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c61e0cf04238a32$var$Form, {
                        onSubmit: (e)=>{
                            e.preventDefault();
                            if (shiftIsHeldDown) previousUUID();
                            else nextUUID();
                        },
                        children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c61e0cf04238a32$var$Input, {
                            ref: inputRef,
                            type: "text",
                            placeholder: "Search for a UUID",
                            value: search,
                            onChange: (e)=>{
                                setSearch(e.target.value.toLowerCase());
                                searchUUID(e.target.value.toLowerCase());
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c61e0cf04238a32$var$Line, {}),
                    /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c61e0cf04238a32$var$Button, {
                        onClick: ()=>previousUUID(),
                        children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $8c0ce35eac81a929$export$9b80ee7d1e129684), {
                            style: {
                                height: "100%",
                                width: "100%"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c61e0cf04238a32$var$Button, {
                        onClick: ()=>nextUUID(),
                        children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $8c0ce35eac81a929$export$4e3778eb35f54199), {
                            style: {
                                height: "100%",
                                width: "100%"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c61e0cf04238a32$var$Button, {
                        onClick: ()=>setSearchDisplayed(false),
                        children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $8c0ce35eac81a929$export$78acf4525d8a74c4), {
                            style: {
                                height: "100%",
                                width: "100%"
                            }
                        })
                    })
                ]
            })
        ]
    });
}
var $8c61e0cf04238a32$export$2e2bcd8739ae039 = $8c61e0cf04238a32$var$SearchWidget;
/* KEPT FOR THE BLOG */ /* this is just code that didn't work as I tried to figure out how to handle
   searching */ // this isn't perfect, but we'll take it
function $8c61e0cf04238a32$var$isValidSearchString(search) {
    const matchesNonHexDash = search.match(/[^0-9a-f-]/i);
    if (matchesNonHexDash) return false;
    const dashCount = (search.match(/-/g) || []).length;
    if (dashCount > 4) return false;
    if (search.length > 36) return false;
    const chunks = search.split("-");
    if (chunks.some((chunk)=>chunk.length > 12)) return false;
    const greaterThan4 = chunks.filter((chunk)=>chunk.length > 4).length;
    if (greaterThan4 > 2) return false;
    const greaterThan8 = chunks.filter((chunk)=>chunk.length > 8).length;
    if (greaterThan8 > 1) return false;
    if (greaterThan8 > 1 && greaterThan4 > 1 || greaterThan4 > 2) {
        if (chunks.length !== 5) return false;
    }
    return true;
}
// https://stackoverflow.com/questions/521295/seeding-the-random-number-generator-in-javascript
function $8c61e0cf04238a32$var$splitmix32(a) {
    return function() {
        a |= 0;
        a = a + 0x9e3779b9 | 0;
        let t = a ^ a >>> 16;
        t = Math.imul(t, 0x21f0aaad);
        t = t ^ t >>> 15;
        t = Math.imul(t, 0x735a2d97);
        return ((t = t ^ t >>> 15) >>> 0) / 4294967296;
    };
}
const $8c61e0cf04238a32$var$KINDS = {
    twelve: 12,
    eight: 8,
    four: 4
};
function $8c61e0cf04238a32$var$selectableIndices(kind, chunks) {
    const maxBits = $8c61e0cf04238a32$var$KINDS[kind];
    const indices = [];
    for(let i = 0; i < chunks.length; i++)if (chunks[i].length <= maxBits) indices.push(i);
}
const $8c61e0cf04238a32$var$emptySearchIndex = (index, maxChars)=>({
        index: index,
        maxChars: maxChars,
        value: null
    });
function $8c61e0cf04238a32$var$candidatesForSearchString(search, rand) {
    const randInt = (high)=>Math.floor(rand() * high);
    const randHexChar = ()=>{
        const digit = randInt(16);
        return digit.toString(16);
    };
    const chunks = search.split("-");
    const indices = [
        $8c61e0cf04238a32$var$emptySearchIndex(0, 8),
        $8c61e0cf04238a32$var$emptySearchIndex(1, 4),
        $8c61e0cf04238a32$var$emptySearchIndex(2, 4),
        $8c61e0cf04238a32$var$emptySearchIndex(3, 4),
        $8c61e0cf04238a32$var$emptySearchIndex(4, 12)
    ];
    const chunksWithMetadata = chunks.map((chunk, index)=>({
            index: index,
            chunk: chunk,
            greaterThan4: chunk.length > 4,
            greaterThan8: chunk.length > 8
        }));
    // const chunksSortedByLength = [...chunks].map((chunk, i) => {chunk, i}
    //   sort((a, b) => b.length - a.length);
    const greaterThan8 = chunks.filter((chunks)=>chunks.length > 8);
    const greaterThan4 = chunks.filter((chunks)=>chunks.length > 4);
    greaterThan8.length > 0 && greaterThan4.length;
    let minIndex = 0;
    for (const chunk of chunks){
        let found = false;
        for(let i = minIndex; i < indices.length; i++){
            const index = indices[i];
            if (index.maxChars >= chunk.length && index.value === null) {
                found = true;
                minIndex = i;
                index.value = chunk;
                break;
            }
        }
        if (!found) return null;
    }
    // const choices = indices.filter((index, indexIdx) => {
    //   return index.maxChars >= chunk.length && index.value === null;
    // });
    // if (choices.length === 0) {
    //   return null;
    // }
    // // const choice = choices[randInt(choices.length)];
    // const choice = choices[0];
    // choice.value = chunk;
    // chunkIdx++;
    for (const index of indices){
        if (index.value === null) index.value = "0".repeat(index.maxChars);
        else if (index.value.length < index.maxChars) {
            const remaining = index.maxChars - index.value.length;
            index.value += "0".repeat(remaining);
        // index.value = index.value + randHexChar();
        }
    }
    return indices.map((index)=>index.value).join("-");
}
function $8c61e0cf04238a32$var$createUUIDPattern(input) {
    // Clean input to valid hex chars and dashes
    const cleaned = input.toLowerCase().replace(/[^0-9a-f-]/g, "");
    if (!cleaned) return null;
    // Template with version (4) and variant (8) enforced
    const uuidTemplate = `00000000-0000-4000-8000-000000000000`;
    const variantChars = new Set([
        "8",
        "9",
        "a",
        "b",
        "c",
        "d"
    ]);
    // Single chunk case (no dashes)
    if (!cleaned.includes("-")) {
        const len = cleaned.length;
        // Need to handle special cases where input might conflict with version/variant
        if (len <= 4) return `00000000-${cleaned.padEnd(4, "0")}-4000-8000-000000000000`;
        if (len <= 8) return `${cleaned.padEnd(8, "0")}-0000-4000-8000-000000000000`;
        if (len <= 12) return `00000000-0000-4000-8000-${cleaned.padEnd(12, "0")}`;
        return null;
    }
    // Try each possible position in the UUID
    for(let i = 0; i < uuidTemplate.length - cleaned.length + 1; i++){
        // Only try positions where our dashes would align
        if (cleaned.includes("-")) {
            const firstDashInInput = cleaned.indexOf("-");
            const positionInPattern = i + firstDashInInput;
            // Check if this position would align our dashes with pattern dashes
            let dashesAlign = true;
            let wouldConflict = false;
            // Check each character of our input against the template
            for(let pos = 0; pos < cleaned.length; pos++){
                const patternPos = i + pos;
                const inputChar = cleaned[pos];
                const templateChar = uuidTemplate[patternPos];
                if (inputChar === "-") {
                    if (templateChar !== "-") {
                        dashesAlign = false;
                        break;
                    }
                } else if (templateChar === "-") {
                    dashesAlign = false;
                    break;
                } else {
                    // Check for version (4) conflict
                    if (patternPos === 14 && inputChar !== "4") {
                        // Position after second dash
                        wouldConflict = true;
                        break;
                    }
                    // Check for variant conflict
                    if (patternPos === 19) // Position after third dash
                    {
                        if (!variantChars.has(inputChar)) {
                            wouldConflict = true;
                            break;
                        }
                    }
                }
            }
            if (!dashesAlign || wouldConflict) continue;
        }
        // Create the result by overlaying our input at this position
        let result = uuidTemplate.slice(0, i) + cleaned + uuidTemplate.slice(i + cleaned.length);
        // Verify it's a valid UUID pattern (all sections have correct length)
        const sections = result.split("-");
        if (sections[0].length === 8 && sections[1].length === 4 && sections[2].length === 4 && sections[3].length === 4 && sections[4].length === 12) return result;
    }
    return null;
}



parcelRequire("aEMJz");




let $5a79d22fa1db84b7$var$_ = (t)=>t, $5a79d22fa1db84b7$var$t;
const $5a79d22fa1db84b7$var$FavoritesButton = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039)((0, $8326a0f291697a14$export$2e2bcd8739ae039))($5a79d22fa1db84b7$var$t || ($5a79d22fa1db84b7$var$t = $5a79d22fa1db84b7$var$_`
  background-color: var(--slate-50);
  border-radius: 0 0 8px 8px;
  font-size: 0.875rem;
  font-family: monospace;
  padding: .15rem 1rem;
  width: 3rem;
  display: flex;
  align-items: center;
  position: absolute;
  z-index: 999;
  right: 16rem;
  color: inherit;

  --fill-color: ${0};

  @media ${0} {
    right: 8rem;
    bottom: 0;
    border-radius: 8px 8px 0 0;
  }
  outline: none;
  &:focus {
    outline: none;
  }
  cursor: pointer;
  transition: background-color 0.1s ease-in-out;
  @media (hover: hover) {
    &:hover {
      background-color: var(--slate-400);
    }
  }
`), (props)=>props.$isShowingFavorites ? "var(--yellow-500)" : "transparent", (0, $576749860f83a2d7$export$3d5e80817e1f8611));
function $5a79d22fa1db84b7$var$FavoritesWidget({ setShowFavorites: setShowFavorites, isShowingFavorites: isShowingFavorites }) {
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $fe3e626085e1e6b8$exports.Fragment), {
        children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($5a79d22fa1db84b7$var$FavoritesButton, {
            onClick: ()=>{
                setShowFavorites((prev)=>!prev);
            },
            $isShowingFavorites: isShowingFavorites,
            children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $8c0ce35eac81a929$export$1644ba17714857f1), {
                fill: "var(--fill-color)",
                style: {
                    height: "100%",
                    aspectRatio: 1
                }
            })
        })
    });
}
var $5a79d22fa1db84b7$export$2e2bcd8739ae039 = $5a79d22fa1db84b7$var$FavoritesWidget;







var $aEMJz = parcelRequire("aEMJz");

var $0a6ac73f3ed13445$exports = {};
/**
 * Node.js module for Forge.
 *
 * @author Dave Longley
 *
 * Copyright 2011-2016 Digital Bazaar, Inc.
 */ 
$0a6ac73f3ed13445$exports = (parcelRequire("cLQG7"));
var $d3ddbb4b069f5dc9$exports = {};
/**
 * Advanced Encryption Standard (AES) implementation.
 *
 * This implementation is based on the public domain library 'jscrypto' which
 * was written by:
 *
 * Emily Stark (estark@stanford.edu)
 * Mike Hamburg (mhamburg@stanford.edu)
 * Dan Boneh (dabo@cs.stanford.edu)
 *
 * Parts of this code are based on the OpenSSL implementation of AES:
 * http://www.openssl.org
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 */ 
var $cLQG7 = parcelRequire("cLQG7");
var $c1199cb2ce29edaa$exports = {};
/**
 * Cipher base API.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 */ 
var $cLQG7 = parcelRequire("cLQG7");
var $93b7eee9251501ce$exports = {};
/**
 * Utility functions for web applications.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2018 Digital Bazaar, Inc.
 */ 
var $lbUi1 = parcelRequire("lbUi1");

var $lbUi1 = parcelRequire("lbUi1");
var $93b7eee9251501ce$require$Buffer = $lbUi1.Buffer;

var $cLQG7 = parcelRequire("cLQG7");
var $259d915abc4f91bc$exports = {};
/**
 * Base-N/Base-X encoding/decoding functions.
 *
 * Original implementation from base-x:
 * https://github.com/cryptocoinjs/base-x
 *
 * Which is MIT licensed:
 *
 * The MIT License (MIT)
 *
 * Copyright base-x contributors (c) 2016
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */ 
var $lbUi1 = parcelRequire("lbUi1");
var $259d915abc4f91bc$require$Buffer = $lbUi1.Buffer;
var $259d915abc4f91bc$var$api = {};
$259d915abc4f91bc$exports = $259d915abc4f91bc$var$api;
// baseN alphabet indexes
var $259d915abc4f91bc$var$_reverseAlphabets = {};
/**
 * BaseN-encodes a Uint8Array using the given alphabet.
 *
 * @param input the Uint8Array to encode.
 * @param maxline the maximum number of encoded characters per line to use,
 *          defaults to none.
 *
 * @return the baseN-encoded output string.
 */ $259d915abc4f91bc$var$api.encode = function(input, alphabet, maxline) {
    if (typeof alphabet !== 'string') throw new TypeError('"alphabet" must be a string.');
    if (maxline !== undefined && typeof maxline !== 'number') throw new TypeError('"maxline" must be a number.');
    var output = '';
    if (!(input instanceof Uint8Array)) // assume forge byte buffer
    output = $259d915abc4f91bc$var$_encodeWithByteBuffer(input, alphabet);
    else {
        var i = 0;
        var base = alphabet.length;
        var first = alphabet.charAt(0);
        var digits = [
            0
        ];
        for(i = 0; i < input.length; ++i){
            for(var j = 0, carry = input[i]; j < digits.length; ++j){
                carry += digits[j] << 8;
                digits[j] = carry % base;
                carry = carry / base | 0;
            }
            while(carry > 0){
                digits.push(carry % base);
                carry = carry / base | 0;
            }
        }
        // deal with leading zeros
        for(i = 0; input[i] === 0 && i < input.length - 1; ++i)output += first;
        // convert digits to a string
        for(i = digits.length - 1; i >= 0; --i)output += alphabet[digits[i]];
    }
    if (maxline) {
        var regex = new RegExp('.{1,' + maxline + '}', 'g');
        output = output.match(regex).join('\r\n');
    }
    return output;
};
/**
 * Decodes a baseN-encoded (using the given alphabet) string to a
 * Uint8Array.
 *
 * @param input the baseN-encoded input string.
 *
 * @return the Uint8Array.
 */ $259d915abc4f91bc$var$api.decode = function(input, alphabet) {
    if (typeof input !== 'string') throw new TypeError('"input" must be a string.');
    if (typeof alphabet !== 'string') throw new TypeError('"alphabet" must be a string.');
    var table = $259d915abc4f91bc$var$_reverseAlphabets[alphabet];
    if (!table) {
        // compute reverse alphabet
        table = $259d915abc4f91bc$var$_reverseAlphabets[alphabet] = [];
        for(var i = 0; i < alphabet.length; ++i)table[alphabet.charCodeAt(i)] = i;
    }
    // remove whitespace characters
    input = input.replace(/\s/g, '');
    var base = alphabet.length;
    var first = alphabet.charAt(0);
    var bytes = [
        0
    ];
    for(var i = 0; i < input.length; i++){
        var value = table[input.charCodeAt(i)];
        if (value === undefined) return;
        for(var j = 0, carry = value; j < bytes.length; ++j){
            carry += bytes[j] * base;
            bytes[j] = carry & 0xff;
            carry >>= 8;
        }
        while(carry > 0){
            bytes.push(carry & 0xff);
            carry >>= 8;
        }
    }
    // deal with leading zeros
    for(var k = 0; input[k] === first && k < input.length - 1; ++k)bytes.push(0);
    if (typeof $259d915abc4f91bc$require$Buffer !== 'undefined') return $259d915abc4f91bc$require$Buffer.from(bytes.reverse());
    return new Uint8Array(bytes.reverse());
};
function $259d915abc4f91bc$var$_encodeWithByteBuffer(input, alphabet) {
    var i = 0;
    var base = alphabet.length;
    var first = alphabet.charAt(0);
    var digits = [
        0
    ];
    for(i = 0; i < input.length(); ++i){
        for(var j = 0, carry = input.at(i); j < digits.length; ++j){
            carry += digits[j] << 8;
            digits[j] = carry % base;
            carry = carry / base | 0;
        }
        while(carry > 0){
            digits.push(carry % base);
            carry = carry / base | 0;
        }
    }
    var output = '';
    // deal with leading zeros
    for(i = 0; input.at(i) === 0 && i < input.length() - 1; ++i)output += first;
    // convert digits to a string
    for(i = digits.length - 1; i >= 0; --i)output += alphabet[digits[i]];
    return output;
}


/* Utilities API */ var $93b7eee9251501ce$var$util = $93b7eee9251501ce$exports = $cLQG7.util = $cLQG7.util || {};
// define setImmediate and nextTick
(function() {
    // use native nextTick (unless we're in webpack)
    // webpack (or better node-libs-browser polyfill) sets process.browser.
    // this way we can detect webpack properly
    typeof $lbUi1 !== 'undefined' && $lbUi1.nextTick;
    // polyfill nextTick with native setImmediate
    if (typeof setImmediate === 'function') {
        $93b7eee9251501ce$var$util.setImmediate = function() {
            return setImmediate.apply(undefined, arguments);
        };
        $93b7eee9251501ce$var$util.nextTick = function(callback) {
            return setImmediate(callback);
        };
        return;
    }
    /* Note: A polyfill upgrade pattern is used here to allow combining
  polyfills. For example, MutationObserver is fast, but blocks UI updates,
  so it needs to allow UI updates periodically, so it falls back on
  postMessage or setTimeout. */ // polyfill with setTimeout
    $93b7eee9251501ce$var$util.setImmediate = function(callback) {
        setTimeout(callback, 0);
    };
    // upgrade polyfill to use postMessage
    if (typeof window !== 'undefined' && typeof window.postMessage === 'function') {
        var msg = 'forge.setImmediate';
        var callbacks = [];
        $93b7eee9251501ce$var$util.setImmediate = function(callback) {
            callbacks.push(callback);
            // only send message when one hasn't been sent in
            // the current turn of the event loop
            if (callbacks.length === 1) window.postMessage(msg, '*');
        };
        function handler(event) {
            if (event.source === window && event.data === msg) {
                event.stopPropagation();
                var copy = callbacks.slice();
                callbacks.length = 0;
                copy.forEach(function(callback) {
                    callback();
                });
            }
        }
        window.addEventListener('message', handler, true);
    }
    // upgrade polyfill to use MutationObserver
    if (typeof MutationObserver !== 'undefined') {
        // polyfill with MutationObserver
        var now = Date.now();
        var attr = true;
        var div = document.createElement('div');
        var callbacks = [];
        new MutationObserver(function() {
            var copy = callbacks.slice();
            callbacks.length = 0;
            copy.forEach(function(callback) {
                callback();
            });
        }).observe(div, {
            attributes: true
        });
        var oldSetImmediate = $93b7eee9251501ce$var$util.setImmediate;
        $93b7eee9251501ce$var$util.setImmediate = function(callback) {
            if (Date.now() - now > 15) {
                now = Date.now();
                oldSetImmediate(callback);
            } else {
                callbacks.push(callback);
                // only trigger observer when it hasn't been triggered in
                // the current turn of the event loop
                if (callbacks.length === 1) div.setAttribute('a', attr = !attr);
            }
        };
    }
    $93b7eee9251501ce$var$util.nextTick = $93b7eee9251501ce$var$util.setImmediate;
})();
// check if running under Node.js
$93b7eee9251501ce$var$util.isNodejs = typeof $lbUi1 !== 'undefined' && $lbUi1.versions && $lbUi1.versions.node;
// 'self' will also work in Web Workers (instance of WorkerGlobalScope) while
// it will point to `window` in the main thread.
// To remain compatible with older browsers, we fall back to 'window' if 'self'
// is not available.
$93b7eee9251501ce$var$util.globalScope = function() {
    if ($93b7eee9251501ce$var$util.isNodejs) return $parcel$global;
    return typeof self === 'undefined' ? window : self;
}();
// define isArray
$93b7eee9251501ce$var$util.isArray = Array.isArray || function(x) {
    return Object.prototype.toString.call(x) === '[object Array]';
};
// define isArrayBuffer
$93b7eee9251501ce$var$util.isArrayBuffer = function(x) {
    return typeof ArrayBuffer !== 'undefined' && x instanceof ArrayBuffer;
};
// define isArrayBufferView
$93b7eee9251501ce$var$util.isArrayBufferView = function(x) {
    return x && $93b7eee9251501ce$var$util.isArrayBuffer(x.buffer) && x.byteLength !== undefined;
};
/**
 * Ensure a bits param is 8, 16, 24, or 32. Used to validate input for
 * algorithms where bit manipulation, JavaScript limitations, and/or algorithm
 * design only allow for byte operations of a limited size.
 *
 * @param n number of bits.
 *
 * Throw Error if n invalid.
 */ function $93b7eee9251501ce$var$_checkBitsParam(n) {
    if (!(n === 8 || n === 16 || n === 24 || n === 32)) throw new Error('Only 8, 16, 24, or 32 bits supported: ' + n);
}
// TODO: set ByteBuffer to best available backing
$93b7eee9251501ce$var$util.ByteBuffer = $93b7eee9251501ce$var$ByteStringBuffer;
/** Buffer w/BinaryString backing */ /**
 * Constructor for a binary string backed byte buffer.
 *
 * @param [b] the bytes to wrap (either encoded as string, one byte per
 *          character, or as an ArrayBuffer or Typed Array).
 */ function $93b7eee9251501ce$var$ByteStringBuffer(b) {
    // TODO: update to match DataBuffer API
    // the data in this buffer
    this.data = '';
    // the pointer for reading from this buffer
    this.read = 0;
    if (typeof b === 'string') this.data = b;
    else if ($93b7eee9251501ce$var$util.isArrayBuffer(b) || $93b7eee9251501ce$var$util.isArrayBufferView(b)) {
        if (typeof $93b7eee9251501ce$require$Buffer !== 'undefined' && b instanceof $93b7eee9251501ce$require$Buffer) this.data = b.toString('binary');
        else {
            // convert native buffer to forge buffer
            // FIXME: support native buffers internally instead
            var arr = new Uint8Array(b);
            try {
                this.data = String.fromCharCode.apply(null, arr);
            } catch (e) {
                for(var i = 0; i < arr.length; ++i)this.putByte(arr[i]);
            }
        }
    } else if (b instanceof $93b7eee9251501ce$var$ByteStringBuffer || typeof b === 'object' && typeof b.data === 'string' && typeof b.read === 'number') {
        // copy existing buffer
        this.data = b.data;
        this.read = b.read;
    }
    // used for v8 optimization
    this._constructedStringLength = 0;
}
$93b7eee9251501ce$var$util.ByteStringBuffer = $93b7eee9251501ce$var$ByteStringBuffer;
/* Note: This is an optimization for V8-based browsers. When V8 concatenates
  a string, the strings are only joined logically using a "cons string" or
  "constructed/concatenated string". These containers keep references to one
  another and can result in very large memory usage. For example, if a 2MB
  string is constructed by concatenating 4 bytes together at a time, the
  memory usage will be ~44MB; so ~22x increase. The strings are only joined
  together when an operation requiring their joining takes place, such as
  substr(). This function is called when adding data to this buffer to ensure
  these types of strings are periodically joined to reduce the memory
  footprint. */ var $93b7eee9251501ce$var$_MAX_CONSTRUCTED_STRING_LENGTH = 4096;
$93b7eee9251501ce$var$util.ByteStringBuffer.prototype._optimizeConstructedString = function(x) {
    this._constructedStringLength += x;
    if (this._constructedStringLength > $93b7eee9251501ce$var$_MAX_CONSTRUCTED_STRING_LENGTH) {
        // this substr() should cause the constructed string to join
        this.data.substr(0, 1);
        this._constructedStringLength = 0;
    }
};
/**
 * Gets the number of bytes in this buffer.
 *
 * @return the number of bytes in this buffer.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.length = function() {
    return this.data.length - this.read;
};
/**
 * Gets whether or not this buffer is empty.
 *
 * @return true if this buffer is empty, false if not.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.isEmpty = function() {
    return this.length() <= 0;
};
/**
 * Puts a byte in this buffer.
 *
 * @param b the byte to put.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.putByte = function(b) {
    return this.putBytes(String.fromCharCode(b));
};
/**
 * Puts a byte in this buffer N times.
 *
 * @param b the byte to put.
 * @param n the number of bytes of value b to put.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.fillWithByte = function(b, n) {
    b = String.fromCharCode(b);
    var d = this.data;
    while(n > 0){
        if (n & 1) d += b;
        n >>>= 1;
        if (n > 0) b += b;
    }
    this.data = d;
    this._optimizeConstructedString(n);
    return this;
};
/**
 * Puts bytes in this buffer.
 *
 * @param bytes the bytes (as a binary encoded string) to put.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.putBytes = function(bytes) {
    this.data += bytes;
    this._optimizeConstructedString(bytes.length);
    return this;
};
/**
 * Puts a UTF-16 encoded string into this buffer.
 *
 * @param str the string to put.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.putString = function(str) {
    return this.putBytes($93b7eee9251501ce$var$util.encodeUtf8(str));
};
/**
 * Puts a 16-bit integer in this buffer in big-endian order.
 *
 * @param i the 16-bit integer.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.putInt16 = function(i) {
    return this.putBytes(String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i & 0xFF));
};
/**
 * Puts a 24-bit integer in this buffer in big-endian order.
 *
 * @param i the 24-bit integer.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.putInt24 = function(i) {
    return this.putBytes(String.fromCharCode(i >> 16 & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i & 0xFF));
};
/**
 * Puts a 32-bit integer in this buffer in big-endian order.
 *
 * @param i the 32-bit integer.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.putInt32 = function(i) {
    return this.putBytes(String.fromCharCode(i >> 24 & 0xFF) + String.fromCharCode(i >> 16 & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i & 0xFF));
};
/**
 * Puts a 16-bit integer in this buffer in little-endian order.
 *
 * @param i the 16-bit integer.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.putInt16Le = function(i) {
    return this.putBytes(String.fromCharCode(i & 0xFF) + String.fromCharCode(i >> 8 & 0xFF));
};
/**
 * Puts a 24-bit integer in this buffer in little-endian order.
 *
 * @param i the 24-bit integer.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.putInt24Le = function(i) {
    return this.putBytes(String.fromCharCode(i & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i >> 16 & 0xFF));
};
/**
 * Puts a 32-bit integer in this buffer in little-endian order.
 *
 * @param i the 32-bit integer.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.putInt32Le = function(i) {
    return this.putBytes(String.fromCharCode(i & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i >> 16 & 0xFF) + String.fromCharCode(i >> 24 & 0xFF));
};
/**
 * Puts an n-bit integer in this buffer in big-endian order.
 *
 * @param i the n-bit integer.
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.putInt = function(i, n) {
    $93b7eee9251501ce$var$_checkBitsParam(n);
    var bytes = '';
    do {
        n -= 8;
        bytes += String.fromCharCode(i >> n & 0xFF);
    }while (n > 0);
    return this.putBytes(bytes);
};
/**
 * Puts a signed n-bit integer in this buffer in big-endian order. Two's
 * complement representation is used.
 *
 * @param i the n-bit integer.
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.putSignedInt = function(i, n) {
    // putInt checks n
    if (i < 0) i += 2 << n - 1;
    return this.putInt(i, n);
};
/**
 * Puts the given buffer into this buffer.
 *
 * @param buffer the buffer to put into this one.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.putBuffer = function(buffer) {
    return this.putBytes(buffer.getBytes());
};
/**
 * Gets a byte from this buffer and advances the read pointer by 1.
 *
 * @return the byte.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.getByte = function() {
    return this.data.charCodeAt(this.read++);
};
/**
 * Gets a uint16 from this buffer in big-endian order and advances the read
 * pointer by 2.
 *
 * @return the uint16.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.getInt16 = function() {
    var rval = this.data.charCodeAt(this.read) << 8 ^ this.data.charCodeAt(this.read + 1);
    this.read += 2;
    return rval;
};
/**
 * Gets a uint24 from this buffer in big-endian order and advances the read
 * pointer by 3.
 *
 * @return the uint24.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.getInt24 = function() {
    var rval = this.data.charCodeAt(this.read) << 16 ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2);
    this.read += 3;
    return rval;
};
/**
 * Gets a uint32 from this buffer in big-endian order and advances the read
 * pointer by 4.
 *
 * @return the word.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.getInt32 = function() {
    var rval = this.data.charCodeAt(this.read) << 24 ^ this.data.charCodeAt(this.read + 1) << 16 ^ this.data.charCodeAt(this.read + 2) << 8 ^ this.data.charCodeAt(this.read + 3);
    this.read += 4;
    return rval;
};
/**
 * Gets a uint16 from this buffer in little-endian order and advances the read
 * pointer by 2.
 *
 * @return the uint16.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.getInt16Le = function() {
    var rval = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8;
    this.read += 2;
    return rval;
};
/**
 * Gets a uint24 from this buffer in little-endian order and advances the read
 * pointer by 3.
 *
 * @return the uint24.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.getInt24Le = function() {
    var rval = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2) << 16;
    this.read += 3;
    return rval;
};
/**
 * Gets a uint32 from this buffer in little-endian order and advances the read
 * pointer by 4.
 *
 * @return the word.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.getInt32Le = function() {
    var rval = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2) << 16 ^ this.data.charCodeAt(this.read + 3) << 24;
    this.read += 4;
    return rval;
};
/**
 * Gets an n-bit integer from this buffer in big-endian order and advances the
 * read pointer by ceil(n/8).
 *
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return the integer.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.getInt = function(n) {
    $93b7eee9251501ce$var$_checkBitsParam(n);
    var rval = 0;
    do {
        // TODO: Use (rval * 0x100) if adding support for 33 to 53 bits.
        rval = (rval << 8) + this.data.charCodeAt(this.read++);
        n -= 8;
    }while (n > 0);
    return rval;
};
/**
 * Gets a signed n-bit integer from this buffer in big-endian order, using
 * two's complement, and advances the read pointer by n/8.
 *
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return the integer.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.getSignedInt = function(n) {
    // getInt checks n
    var x = this.getInt(n);
    var max = 2 << n - 2;
    if (x >= max) x -= max << 1;
    return x;
};
/**
 * Reads bytes out as a binary encoded string and clears them from the
 * buffer. Note that the resulting string is binary encoded (in node.js this
 * encoding is referred to as `binary`, it is *not* `utf8`).
 *
 * @param count the number of bytes to read, undefined or null for all.
 *
 * @return a binary encoded string of bytes.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.getBytes = function(count) {
    var rval;
    if (count) {
        // read count bytes
        count = Math.min(this.length(), count);
        rval = this.data.slice(this.read, this.read + count);
        this.read += count;
    } else if (count === 0) rval = '';
    else {
        // read all bytes, optimize to only copy when needed
        rval = this.read === 0 ? this.data : this.data.slice(this.read);
        this.clear();
    }
    return rval;
};
/**
 * Gets a binary encoded string of the bytes from this buffer without
 * modifying the read pointer.
 *
 * @param count the number of bytes to get, omit to get all.
 *
 * @return a string full of binary encoded characters.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.bytes = function(count) {
    return typeof count === 'undefined' ? this.data.slice(this.read) : this.data.slice(this.read, this.read + count);
};
/**
 * Gets a byte at the given index without modifying the read pointer.
 *
 * @param i the byte index.
 *
 * @return the byte.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.at = function(i) {
    return this.data.charCodeAt(this.read + i);
};
/**
 * Puts a byte at the given index without modifying the read pointer.
 *
 * @param i the byte index.
 * @param b the byte to put.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.setAt = function(i, b) {
    this.data = this.data.substr(0, this.read + i) + String.fromCharCode(b) + this.data.substr(this.read + i + 1);
    return this;
};
/**
 * Gets the last byte without modifying the read pointer.
 *
 * @return the last byte.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.last = function() {
    return this.data.charCodeAt(this.data.length - 1);
};
/**
 * Creates a copy of this buffer.
 *
 * @return the copy.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.copy = function() {
    var c = $93b7eee9251501ce$var$util.createBuffer(this.data);
    c.read = this.read;
    return c;
};
/**
 * Compacts this buffer.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.compact = function() {
    if (this.read > 0) {
        this.data = this.data.slice(this.read);
        this.read = 0;
    }
    return this;
};
/**
 * Clears this buffer.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.clear = function() {
    this.data = '';
    this.read = 0;
    return this;
};
/**
 * Shortens this buffer by triming bytes off of the end of this buffer.
 *
 * @param count the number of bytes to trim off.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.truncate = function(count) {
    var len = Math.max(0, this.length() - count);
    this.data = this.data.substr(this.read, len);
    this.read = 0;
    return this;
};
/**
 * Converts this buffer to a hexadecimal string.
 *
 * @return a hexadecimal string.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.toHex = function() {
    var rval = '';
    for(var i = this.read; i < this.data.length; ++i){
        var b = this.data.charCodeAt(i);
        if (b < 16) rval += '0';
        rval += b.toString(16);
    }
    return rval;
};
/**
 * Converts this buffer to a UTF-16 string (standard JavaScript string).
 *
 * @return a UTF-16 string.
 */ $93b7eee9251501ce$var$util.ByteStringBuffer.prototype.toString = function() {
    return $93b7eee9251501ce$var$util.decodeUtf8(this.bytes());
};
/** End Buffer w/BinaryString backing */ /** Buffer w/UInt8Array backing */ /**
 * FIXME: Experimental. Do not use yet.
 *
 * Constructor for an ArrayBuffer-backed byte buffer.
 *
 * The buffer may be constructed from a string, an ArrayBuffer, DataView, or a
 * TypedArray.
 *
 * If a string is given, its encoding should be provided as an option,
 * otherwise it will default to 'binary'. A 'binary' string is encoded such
 * that each character is one byte in length and size.
 *
 * If an ArrayBuffer, DataView, or TypedArray is given, it will be used
 * *directly* without any copying. Note that, if a write to the buffer requires
 * more space, the buffer will allocate a new backing ArrayBuffer to
 * accommodate. The starting read and write offsets for the buffer may be
 * given as options.
 *
 * @param [b] the initial bytes for this buffer.
 * @param options the options to use:
 *          [readOffset] the starting read offset to use (default: 0).
 *          [writeOffset] the starting write offset to use (default: the
 *            length of the first parameter).
 *          [growSize] the minimum amount, in bytes, to grow the buffer by to
 *            accommodate writes (default: 1024).
 *          [encoding] the encoding ('binary', 'utf8', 'utf16', 'hex') for the
 *            first parameter, if it is a string (default: 'binary').
 */ function $93b7eee9251501ce$var$DataBuffer(b, options) {
    // default options
    options = options || {};
    // pointers for read from/write to buffer
    this.read = options.readOffset || 0;
    this.growSize = options.growSize || 1024;
    var isArrayBuffer = $93b7eee9251501ce$var$util.isArrayBuffer(b);
    var isArrayBufferView = $93b7eee9251501ce$var$util.isArrayBufferView(b);
    if (isArrayBuffer || isArrayBufferView) {
        // use ArrayBuffer directly
        if (isArrayBuffer) this.data = new DataView(b);
        else // TODO: adjust read/write offset based on the type of view
        // or specify that this must be done in the options ... that the
        // offsets are byte-based
        this.data = new DataView(b.buffer, b.byteOffset, b.byteLength);
        this.write = 'writeOffset' in options ? options.writeOffset : this.data.byteLength;
        return;
    }
    // initialize to empty array buffer and add any given bytes using putBytes
    this.data = new DataView(new ArrayBuffer(0));
    this.write = 0;
    if (b !== null && b !== undefined) this.putBytes(b);
    if ('writeOffset' in options) this.write = options.writeOffset;
}
$93b7eee9251501ce$var$util.DataBuffer = $93b7eee9251501ce$var$DataBuffer;
/**
 * Gets the number of bytes in this buffer.
 *
 * @return the number of bytes in this buffer.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.length = function() {
    return this.write - this.read;
};
/**
 * Gets whether or not this buffer is empty.
 *
 * @return true if this buffer is empty, false if not.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.isEmpty = function() {
    return this.length() <= 0;
};
/**
 * Ensures this buffer has enough empty space to accommodate the given number
 * of bytes. An optional parameter may be given that indicates a minimum
 * amount to grow the buffer if necessary. If the parameter is not given,
 * the buffer will be grown by some previously-specified default amount
 * or heuristic.
 *
 * @param amount the number of bytes to accommodate.
 * @param [growSize] the minimum amount, in bytes, to grow the buffer by if
 *          necessary.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.accommodate = function(amount, growSize) {
    if (this.length() >= amount) return this;
    growSize = Math.max(growSize || this.growSize, amount);
    // grow buffer
    var src = new Uint8Array(this.data.buffer, this.data.byteOffset, this.data.byteLength);
    var dst = new Uint8Array(this.length() + growSize);
    dst.set(src);
    this.data = new DataView(dst.buffer);
    return this;
};
/**
 * Puts a byte in this buffer.
 *
 * @param b the byte to put.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.putByte = function(b) {
    this.accommodate(1);
    this.data.setUint8(this.write++, b);
    return this;
};
/**
 * Puts a byte in this buffer N times.
 *
 * @param b the byte to put.
 * @param n the number of bytes of value b to put.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.fillWithByte = function(b, n) {
    this.accommodate(n);
    for(var i = 0; i < n; ++i)this.data.setUint8(b);
    return this;
};
/**
 * Puts bytes in this buffer. The bytes may be given as a string, an
 * ArrayBuffer, a DataView, or a TypedArray.
 *
 * @param bytes the bytes to put.
 * @param [encoding] the encoding for the first parameter ('binary', 'utf8',
 *          'utf16', 'hex'), if it is a string (default: 'binary').
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.putBytes = function(bytes, encoding) {
    if ($93b7eee9251501ce$var$util.isArrayBufferView(bytes)) {
        var src = new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
        var len = src.byteLength - src.byteOffset;
        this.accommodate(len);
        var dst = new Uint8Array(this.data.buffer, this.write);
        dst.set(src);
        this.write += len;
        return this;
    }
    if ($93b7eee9251501ce$var$util.isArrayBuffer(bytes)) {
        var src = new Uint8Array(bytes);
        this.accommodate(src.byteLength);
        var dst = new Uint8Array(this.data.buffer);
        dst.set(src, this.write);
        this.write += src.byteLength;
        return this;
    }
    // bytes is a util.DataBuffer or equivalent
    if (bytes instanceof $93b7eee9251501ce$var$util.DataBuffer || typeof bytes === 'object' && typeof bytes.read === 'number' && typeof bytes.write === 'number' && $93b7eee9251501ce$var$util.isArrayBufferView(bytes.data)) {
        var src = new Uint8Array(bytes.data.byteLength, bytes.read, bytes.length());
        this.accommodate(src.byteLength);
        var dst = new Uint8Array(bytes.data.byteLength, this.write);
        dst.set(src);
        this.write += src.byteLength;
        return this;
    }
    if (bytes instanceof $93b7eee9251501ce$var$util.ByteStringBuffer) {
        // copy binary string and process as the same as a string parameter below
        bytes = bytes.data;
        encoding = 'binary';
    }
    // string conversion
    encoding = encoding || 'binary';
    if (typeof bytes === 'string') {
        var view;
        // decode from string
        if (encoding === 'hex') {
            this.accommodate(Math.ceil(bytes.length / 2));
            view = new Uint8Array(this.data.buffer, this.write);
            this.write += $93b7eee9251501ce$var$util.binary.hex.decode(bytes, view, this.write);
            return this;
        }
        if (encoding === 'base64') {
            this.accommodate(Math.ceil(bytes.length / 4) * 3);
            view = new Uint8Array(this.data.buffer, this.write);
            this.write += $93b7eee9251501ce$var$util.binary.base64.decode(bytes, view, this.write);
            return this;
        }
        // encode text as UTF-8 bytes
        if (encoding === 'utf8') {
            // encode as UTF-8 then decode string as raw binary
            bytes = $93b7eee9251501ce$var$util.encodeUtf8(bytes);
            encoding = 'binary';
        }
        // decode string as raw binary
        if (encoding === 'binary' || encoding === 'raw') {
            // one byte per character
            this.accommodate(bytes.length);
            view = new Uint8Array(this.data.buffer, this.write);
            this.write += $93b7eee9251501ce$var$util.binary.raw.decode(view);
            return this;
        }
        // encode text as UTF-16 bytes
        if (encoding === 'utf16') {
            // two bytes per character
            this.accommodate(bytes.length * 2);
            view = new Uint16Array(this.data.buffer, this.write);
            this.write += $93b7eee9251501ce$var$util.text.utf16.encode(view);
            return this;
        }
        throw new Error('Invalid encoding: ' + encoding);
    }
    throw Error('Invalid parameter: ' + bytes);
};
/**
 * Puts the given buffer into this buffer.
 *
 * @param buffer the buffer to put into this one.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.putBuffer = function(buffer) {
    this.putBytes(buffer);
    buffer.clear();
    return this;
};
/**
 * Puts a string into this buffer.
 *
 * @param str the string to put.
 * @param [encoding] the encoding for the string (default: 'utf16').
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.putString = function(str) {
    return this.putBytes(str, 'utf16');
};
/**
 * Puts a 16-bit integer in this buffer in big-endian order.
 *
 * @param i the 16-bit integer.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.putInt16 = function(i) {
    this.accommodate(2);
    this.data.setInt16(this.write, i);
    this.write += 2;
    return this;
};
/**
 * Puts a 24-bit integer in this buffer in big-endian order.
 *
 * @param i the 24-bit integer.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.putInt24 = function(i) {
    this.accommodate(3);
    this.data.setInt16(this.write, i >> 8 & 0xFFFF);
    this.data.setInt8(this.write, i >> 16 & 0xFF);
    this.write += 3;
    return this;
};
/**
 * Puts a 32-bit integer in this buffer in big-endian order.
 *
 * @param i the 32-bit integer.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.putInt32 = function(i) {
    this.accommodate(4);
    this.data.setInt32(this.write, i);
    this.write += 4;
    return this;
};
/**
 * Puts a 16-bit integer in this buffer in little-endian order.
 *
 * @param i the 16-bit integer.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.putInt16Le = function(i) {
    this.accommodate(2);
    this.data.setInt16(this.write, i, true);
    this.write += 2;
    return this;
};
/**
 * Puts a 24-bit integer in this buffer in little-endian order.
 *
 * @param i the 24-bit integer.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.putInt24Le = function(i) {
    this.accommodate(3);
    this.data.setInt8(this.write, i >> 16 & 0xFF);
    this.data.setInt16(this.write, i >> 8 & 0xFFFF, true);
    this.write += 3;
    return this;
};
/**
 * Puts a 32-bit integer in this buffer in little-endian order.
 *
 * @param i the 32-bit integer.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.putInt32Le = function(i) {
    this.accommodate(4);
    this.data.setInt32(this.write, i, true);
    this.write += 4;
    return this;
};
/**
 * Puts an n-bit integer in this buffer in big-endian order.
 *
 * @param i the n-bit integer.
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.putInt = function(i, n) {
    $93b7eee9251501ce$var$_checkBitsParam(n);
    this.accommodate(n / 8);
    do {
        n -= 8;
        this.data.setInt8(this.write++, i >> n & 0xFF);
    }while (n > 0);
    return this;
};
/**
 * Puts a signed n-bit integer in this buffer in big-endian order. Two's
 * complement representation is used.
 *
 * @param i the n-bit integer.
 * @param n the number of bits in the integer.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.putSignedInt = function(i, n) {
    $93b7eee9251501ce$var$_checkBitsParam(n);
    this.accommodate(n / 8);
    if (i < 0) i += 2 << n - 1;
    return this.putInt(i, n);
};
/**
 * Gets a byte from this buffer and advances the read pointer by 1.
 *
 * @return the byte.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.getByte = function() {
    return this.data.getInt8(this.read++);
};
/**
 * Gets a uint16 from this buffer in big-endian order and advances the read
 * pointer by 2.
 *
 * @return the uint16.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.getInt16 = function() {
    var rval = this.data.getInt16(this.read);
    this.read += 2;
    return rval;
};
/**
 * Gets a uint24 from this buffer in big-endian order and advances the read
 * pointer by 3.
 *
 * @return the uint24.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.getInt24 = function() {
    var rval = this.data.getInt16(this.read) << 8 ^ this.data.getInt8(this.read + 2);
    this.read += 3;
    return rval;
};
/**
 * Gets a uint32 from this buffer in big-endian order and advances the read
 * pointer by 4.
 *
 * @return the word.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.getInt32 = function() {
    var rval = this.data.getInt32(this.read);
    this.read += 4;
    return rval;
};
/**
 * Gets a uint16 from this buffer in little-endian order and advances the read
 * pointer by 2.
 *
 * @return the uint16.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.getInt16Le = function() {
    var rval = this.data.getInt16(this.read, true);
    this.read += 2;
    return rval;
};
/**
 * Gets a uint24 from this buffer in little-endian order and advances the read
 * pointer by 3.
 *
 * @return the uint24.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.getInt24Le = function() {
    var rval = this.data.getInt8(this.read) ^ this.data.getInt16(this.read + 1, true) << 8;
    this.read += 3;
    return rval;
};
/**
 * Gets a uint32 from this buffer in little-endian order and advances the read
 * pointer by 4.
 *
 * @return the word.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.getInt32Le = function() {
    var rval = this.data.getInt32(this.read, true);
    this.read += 4;
    return rval;
};
/**
 * Gets an n-bit integer from this buffer in big-endian order and advances the
 * read pointer by n/8.
 *
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return the integer.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.getInt = function(n) {
    $93b7eee9251501ce$var$_checkBitsParam(n);
    var rval = 0;
    do {
        // TODO: Use (rval * 0x100) if adding support for 33 to 53 bits.
        rval = (rval << 8) + this.data.getInt8(this.read++);
        n -= 8;
    }while (n > 0);
    return rval;
};
/**
 * Gets a signed n-bit integer from this buffer in big-endian order, using
 * two's complement, and advances the read pointer by n/8.
 *
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return the integer.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.getSignedInt = function(n) {
    // getInt checks n
    var x = this.getInt(n);
    var max = 2 << n - 2;
    if (x >= max) x -= max << 1;
    return x;
};
/**
 * Reads bytes out as a binary encoded string and clears them from the
 * buffer.
 *
 * @param count the number of bytes to read, undefined or null for all.
 *
 * @return a binary encoded string of bytes.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.getBytes = function(count) {
    // TODO: deprecate this method, it is poorly named and
    // this.toString('binary') replaces it
    // add a toTypedArray()/toArrayBuffer() function
    var rval;
    if (count) {
        // read count bytes
        count = Math.min(this.length(), count);
        rval = this.data.slice(this.read, this.read + count);
        this.read += count;
    } else if (count === 0) rval = '';
    else {
        // read all bytes, optimize to only copy when needed
        rval = this.read === 0 ? this.data : this.data.slice(this.read);
        this.clear();
    }
    return rval;
};
/**
 * Gets a binary encoded string of the bytes from this buffer without
 * modifying the read pointer.
 *
 * @param count the number of bytes to get, omit to get all.
 *
 * @return a string full of binary encoded characters.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.bytes = function(count) {
    // TODO: deprecate this method, it is poorly named, add "getString()"
    return typeof count === 'undefined' ? this.data.slice(this.read) : this.data.slice(this.read, this.read + count);
};
/**
 * Gets a byte at the given index without modifying the read pointer.
 *
 * @param i the byte index.
 *
 * @return the byte.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.at = function(i) {
    return this.data.getUint8(this.read + i);
};
/**
 * Puts a byte at the given index without modifying the read pointer.
 *
 * @param i the byte index.
 * @param b the byte to put.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.setAt = function(i, b) {
    this.data.setUint8(i, b);
    return this;
};
/**
 * Gets the last byte without modifying the read pointer.
 *
 * @return the last byte.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.last = function() {
    return this.data.getUint8(this.write - 1);
};
/**
 * Creates a copy of this buffer.
 *
 * @return the copy.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.copy = function() {
    return new $93b7eee9251501ce$var$util.DataBuffer(this);
};
/**
 * Compacts this buffer.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.compact = function() {
    if (this.read > 0) {
        var src = new Uint8Array(this.data.buffer, this.read);
        var dst = new Uint8Array(src.byteLength);
        dst.set(src);
        this.data = new DataView(dst);
        this.write -= this.read;
        this.read = 0;
    }
    return this;
};
/**
 * Clears this buffer.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.clear = function() {
    this.data = new DataView(new ArrayBuffer(0));
    this.read = this.write = 0;
    return this;
};
/**
 * Shortens this buffer by triming bytes off of the end of this buffer.
 *
 * @param count the number of bytes to trim off.
 *
 * @return this buffer.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.truncate = function(count) {
    this.write = Math.max(0, this.length() - count);
    this.read = Math.min(this.read, this.write);
    return this;
};
/**
 * Converts this buffer to a hexadecimal string.
 *
 * @return a hexadecimal string.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.toHex = function() {
    var rval = '';
    for(var i = this.read; i < this.data.byteLength; ++i){
        var b = this.data.getUint8(i);
        if (b < 16) rval += '0';
        rval += b.toString(16);
    }
    return rval;
};
/**
 * Converts this buffer to a string, using the given encoding. If no
 * encoding is given, 'utf8' (UTF-8) is used.
 *
 * @param [encoding] the encoding to use: 'binary', 'utf8', 'utf16', 'hex',
 *          'base64' (default: 'utf8').
 *
 * @return a string representation of the bytes in this buffer.
 */ $93b7eee9251501ce$var$util.DataBuffer.prototype.toString = function(encoding) {
    var view = new Uint8Array(this.data, this.read, this.length());
    encoding = encoding || 'utf8';
    // encode to string
    if (encoding === 'binary' || encoding === 'raw') return $93b7eee9251501ce$var$util.binary.raw.encode(view);
    if (encoding === 'hex') return $93b7eee9251501ce$var$util.binary.hex.encode(view);
    if (encoding === 'base64') return $93b7eee9251501ce$var$util.binary.base64.encode(view);
    // decode to text
    if (encoding === 'utf8') return $93b7eee9251501ce$var$util.text.utf8.decode(view);
    if (encoding === 'utf16') return $93b7eee9251501ce$var$util.text.utf16.decode(view);
    throw new Error('Invalid encoding: ' + encoding);
};
/** End Buffer w/UInt8Array backing */ /**
 * Creates a buffer that stores bytes. A value may be given to populate the
 * buffer with data. This value can either be string of encoded bytes or a
 * regular string of characters. When passing a string of binary encoded
 * bytes, the encoding `raw` should be given. This is also the default. When
 * passing a string of characters, the encoding `utf8` should be given.
 *
 * @param [input] a string with encoded bytes to store in the buffer.
 * @param [encoding] (default: 'raw', other: 'utf8').
 */ $93b7eee9251501ce$var$util.createBuffer = function(input, encoding) {
    // TODO: deprecate, use new ByteBuffer() instead
    encoding = encoding || 'raw';
    if (input !== undefined && encoding === 'utf8') input = $93b7eee9251501ce$var$util.encodeUtf8(input);
    return new $93b7eee9251501ce$var$util.ByteBuffer(input);
};
/**
 * Fills a string with a particular value. If you want the string to be a byte
 * string, pass in String.fromCharCode(theByte).
 *
 * @param c the character to fill the string with, use String.fromCharCode
 *          to fill the string with a byte value.
 * @param n the number of characters of value c to fill with.
 *
 * @return the filled string.
 */ $93b7eee9251501ce$var$util.fillString = function(c, n) {
    var s = '';
    while(n > 0){
        if (n & 1) s += c;
        n >>>= 1;
        if (n > 0) c += c;
    }
    return s;
};
/**
 * Performs a per byte XOR between two byte strings and returns the result as a
 * string of bytes.
 *
 * @param s1 first string of bytes.
 * @param s2 second string of bytes.
 * @param n the number of bytes to XOR.
 *
 * @return the XOR'd result.
 */ $93b7eee9251501ce$var$util.xorBytes = function(s1, s2, n) {
    var s3 = '';
    var b = '';
    var t = '';
    var i = 0;
    var c = 0;
    for(; n > 0; --n, ++i){
        b = s1.charCodeAt(i) ^ s2.charCodeAt(i);
        if (c >= 10) {
            s3 += t;
            t = '';
            c = 0;
        }
        t += String.fromCharCode(b);
        ++c;
    }
    s3 += t;
    return s3;
};
/**
 * Converts a hex string into a 'binary' encoded string of bytes.
 *
 * @param hex the hexadecimal string to convert.
 *
 * @return the binary-encoded string of bytes.
 */ $93b7eee9251501ce$var$util.hexToBytes = function(hex) {
    // TODO: deprecate: "Deprecated. Use util.binary.hex.decode instead."
    var rval = '';
    var i = 0;
    if (hex.length & true) {
        // odd number of characters, convert first character alone
        i = 1;
        rval += String.fromCharCode(parseInt(hex[0], 16));
    }
    // convert 2 characters (1 byte) at a time
    for(; i < hex.length; i += 2)rval += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
    return rval;
};
/**
 * Converts a 'binary' encoded string of bytes to hex.
 *
 * @param bytes the byte string to convert.
 *
 * @return the string of hexadecimal characters.
 */ $93b7eee9251501ce$var$util.bytesToHex = function(bytes) {
    // TODO: deprecate: "Deprecated. Use util.binary.hex.encode instead."
    return $93b7eee9251501ce$var$util.createBuffer(bytes).toHex();
};
/**
 * Converts an 32-bit integer to 4-big-endian byte string.
 *
 * @param i the integer.
 *
 * @return the byte string.
 */ $93b7eee9251501ce$var$util.int32ToBytes = function(i) {
    return String.fromCharCode(i >> 24 & 0xFF) + String.fromCharCode(i >> 16 & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i & 0xFF);
};
// base64 characters, reverse mapping
var $93b7eee9251501ce$var$_base64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
var $93b7eee9251501ce$var$_base64Idx = [
    /*43 -43 = 0*/ /*'+',  1,  2,  3,'/' */ 62,
    -1,
    -1,
    -1,
    63,
    /*'0','1','2','3','4','5','6','7','8','9' */ 52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    /*15, 16, 17,'=', 19, 20, 21 */ -1,
    -1,
    -1,
    64,
    -1,
    -1,
    -1,
    /*65 - 43 = 22*/ /*'A','B','C','D','E','F','G','H','I','J','K','L','M', */ 0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    /*'N','O','P','Q','R','S','T','U','V','W','X','Y','Z' */ 13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    /*91 - 43 = 48 */ /*48, 49, 50, 51, 52, 53 */ -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    /*97 - 43 = 54*/ /*'a','b','c','d','e','f','g','h','i','j','k','l','m' */ 26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    /*'n','o','p','q','r','s','t','u','v','w','x','y','z' */ 39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51
];
// base58 characters (Bitcoin alphabet)
var $93b7eee9251501ce$var$_base58 = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
/**
 * Base64 encodes a 'binary' encoded string of bytes.
 *
 * @param input the binary encoded string of bytes to base64-encode.
 * @param maxline the maximum number of encoded characters per line to use,
 *          defaults to none.
 *
 * @return the base64-encoded output.
 */ $93b7eee9251501ce$var$util.encode64 = function(input, maxline) {
    // TODO: deprecate: "Deprecated. Use util.binary.base64.encode instead."
    var line = '';
    var output = '';
    var chr1, chr2, chr3;
    var i = 0;
    while(i < input.length){
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        // encode 4 character group
        line += $93b7eee9251501ce$var$_base64.charAt(chr1 >> 2);
        line += $93b7eee9251501ce$var$_base64.charAt((chr1 & 3) << 4 | chr2 >> 4);
        if (isNaN(chr2)) line += '==';
        else {
            line += $93b7eee9251501ce$var$_base64.charAt((chr2 & 15) << 2 | chr3 >> 6);
            line += isNaN(chr3) ? '=' : $93b7eee9251501ce$var$_base64.charAt(chr3 & 63);
        }
        if (maxline && line.length > maxline) {
            output += line.substr(0, maxline) + '\r\n';
            line = line.substr(maxline);
        }
    }
    output += line;
    return output;
};
/**
 * Base64 decodes a string into a 'binary' encoded string of bytes.
 *
 * @param input the base64-encoded input.
 *
 * @return the binary encoded string.
 */ $93b7eee9251501ce$var$util.decode64 = function(input) {
    // TODO: deprecate: "Deprecated. Use util.binary.base64.decode instead."
    // remove all non-base64 characters
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
    var output = '';
    var enc1, enc2, enc3, enc4;
    var i = 0;
    while(i < input.length){
        enc1 = $93b7eee9251501ce$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc2 = $93b7eee9251501ce$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc3 = $93b7eee9251501ce$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc4 = $93b7eee9251501ce$var$_base64Idx[input.charCodeAt(i++) - 43];
        output += String.fromCharCode(enc1 << 2 | enc2 >> 4);
        if (enc3 !== 64) {
            // decoded at least 2 bytes
            output += String.fromCharCode((enc2 & 15) << 4 | enc3 >> 2);
            if (enc4 !== 64) // decoded 3 bytes
            output += String.fromCharCode((enc3 & 3) << 6 | enc4);
        }
    }
    return output;
};
/**
 * Encodes the given string of characters (a standard JavaScript
 * string) as a binary encoded string where the bytes represent
 * a UTF-8 encoded string of characters. Non-ASCII characters will be
 * encoded as multiple bytes according to UTF-8.
 *
 * @param str a standard string of characters to encode.
 *
 * @return the binary encoded string.
 */ $93b7eee9251501ce$var$util.encodeUtf8 = function(str) {
    return unescape(encodeURIComponent(str));
};
/**
 * Decodes a binary encoded string that contains bytes that
 * represent a UTF-8 encoded string of characters -- into a
 * string of characters (a standard JavaScript string).
 *
 * @param str the binary encoded string to decode.
 *
 * @return the resulting standard string of characters.
 */ $93b7eee9251501ce$var$util.decodeUtf8 = function(str) {
    return decodeURIComponent(escape(str));
};
// binary encoding/decoding tools
// FIXME: Experimental. Do not use yet.
$93b7eee9251501ce$var$util.binary = {
    raw: {},
    hex: {},
    base64: {},
    base58: {},
    baseN: {
        encode: $259d915abc4f91bc$exports.encode,
        decode: $259d915abc4f91bc$exports.decode
    }
};
/**
 * Encodes a Uint8Array as a binary-encoded string. This encoding uses
 * a value between 0 and 255 for each character.
 *
 * @param bytes the Uint8Array to encode.
 *
 * @return the binary-encoded string.
 */ $93b7eee9251501ce$var$util.binary.raw.encode = function(bytes) {
    return String.fromCharCode.apply(null, bytes);
};
/**
 * Decodes a binary-encoded string to a Uint8Array. This encoding uses
 * a value between 0 and 255 for each character.
 *
 * @param str the binary-encoded string to decode.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */ $93b7eee9251501ce$var$util.binary.raw.decode = function(str, output, offset) {
    var out = output;
    if (!out) out = new Uint8Array(str.length);
    offset = offset || 0;
    var j = offset;
    for(var i = 0; i < str.length; ++i)out[j++] = str.charCodeAt(i);
    return output ? j - offset : out;
};
/**
 * Encodes a 'binary' string, ArrayBuffer, DataView, TypedArray, or
 * ByteBuffer as a string of hexadecimal characters.
 *
 * @param bytes the bytes to convert.
 *
 * @return the string of hexadecimal characters.
 */ $93b7eee9251501ce$var$util.binary.hex.encode = $93b7eee9251501ce$var$util.bytesToHex;
/**
 * Decodes a hex-encoded string to a Uint8Array.
 *
 * @param hex the hexadecimal string to convert.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */ $93b7eee9251501ce$var$util.binary.hex.decode = function(hex, output, offset) {
    var out = output;
    if (!out) out = new Uint8Array(Math.ceil(hex.length / 2));
    offset = offset || 0;
    var i = 0, j = offset;
    if (hex.length & 1) {
        // odd number of characters, convert first character alone
        i = 1;
        out[j++] = parseInt(hex[0], 16);
    }
    // convert 2 characters (1 byte) at a time
    for(; i < hex.length; i += 2)out[j++] = parseInt(hex.substr(i, 2), 16);
    return output ? j - offset : out;
};
/**
 * Base64-encodes a Uint8Array.
 *
 * @param input the Uint8Array to encode.
 * @param maxline the maximum number of encoded characters per line to use,
 *          defaults to none.
 *
 * @return the base64-encoded output string.
 */ $93b7eee9251501ce$var$util.binary.base64.encode = function(input, maxline) {
    var line = '';
    var output = '';
    var chr1, chr2, chr3;
    var i = 0;
    while(i < input.byteLength){
        chr1 = input[i++];
        chr2 = input[i++];
        chr3 = input[i++];
        // encode 4 character group
        line += $93b7eee9251501ce$var$_base64.charAt(chr1 >> 2);
        line += $93b7eee9251501ce$var$_base64.charAt((chr1 & 3) << 4 | chr2 >> 4);
        if (isNaN(chr2)) line += '==';
        else {
            line += $93b7eee9251501ce$var$_base64.charAt((chr2 & 15) << 2 | chr3 >> 6);
            line += isNaN(chr3) ? '=' : $93b7eee9251501ce$var$_base64.charAt(chr3 & 63);
        }
        if (maxline && line.length > maxline) {
            output += line.substr(0, maxline) + '\r\n';
            line = line.substr(maxline);
        }
    }
    output += line;
    return output;
};
/**
 * Decodes a base64-encoded string to a Uint8Array.
 *
 * @param input the base64-encoded input string.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */ $93b7eee9251501ce$var$util.binary.base64.decode = function(input, output, offset) {
    var out = output;
    if (!out) out = new Uint8Array(Math.ceil(input.length / 4) * 3);
    // remove all non-base64 characters
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
    offset = offset || 0;
    var enc1, enc2, enc3, enc4;
    var i = 0, j = offset;
    while(i < input.length){
        enc1 = $93b7eee9251501ce$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc2 = $93b7eee9251501ce$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc3 = $93b7eee9251501ce$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc4 = $93b7eee9251501ce$var$_base64Idx[input.charCodeAt(i++) - 43];
        out[j++] = enc1 << 2 | enc2 >> 4;
        if (enc3 !== 64) {
            // decoded at least 2 bytes
            out[j++] = (enc2 & 15) << 4 | enc3 >> 2;
            if (enc4 !== 64) // decoded 3 bytes
            out[j++] = (enc3 & 3) << 6 | enc4;
        }
    }
    // make sure result is the exact decoded length
    return output ? j - offset : out.subarray(0, j);
};
// add support for base58 encoding/decoding with Bitcoin alphabet
$93b7eee9251501ce$var$util.binary.base58.encode = function(input, maxline) {
    return $93b7eee9251501ce$var$util.binary.baseN.encode(input, $93b7eee9251501ce$var$_base58, maxline);
};
$93b7eee9251501ce$var$util.binary.base58.decode = function(input, maxline) {
    return $93b7eee9251501ce$var$util.binary.baseN.decode(input, $93b7eee9251501ce$var$_base58, maxline);
};
// text encoding/decoding tools
// FIXME: Experimental. Do not use yet.
$93b7eee9251501ce$var$util.text = {
    utf8: {},
    utf16: {}
};
/**
 * Encodes the given string as UTF-8 in a Uint8Array.
 *
 * @param str the string to encode.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */ $93b7eee9251501ce$var$util.text.utf8.encode = function(str, output, offset) {
    str = $93b7eee9251501ce$var$util.encodeUtf8(str);
    var out = output;
    if (!out) out = new Uint8Array(str.length);
    offset = offset || 0;
    var j = offset;
    for(var i = 0; i < str.length; ++i)out[j++] = str.charCodeAt(i);
    return output ? j - offset : out;
};
/**
 * Decodes the UTF-8 contents from a Uint8Array.
 *
 * @param bytes the Uint8Array to decode.
 *
 * @return the resulting string.
 */ $93b7eee9251501ce$var$util.text.utf8.decode = function(bytes) {
    return $93b7eee9251501ce$var$util.decodeUtf8(String.fromCharCode.apply(null, bytes));
};
/**
 * Encodes the given string as UTF-16 in a Uint8Array.
 *
 * @param str the string to encode.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */ $93b7eee9251501ce$var$util.text.utf16.encode = function(str, output, offset) {
    var out = output;
    if (!out) out = new Uint8Array(str.length * 2);
    var view = new Uint16Array(out.buffer);
    offset = offset || 0;
    var j = offset;
    var k = offset;
    for(var i = 0; i < str.length; ++i){
        view[k++] = str.charCodeAt(i);
        j += 2;
    }
    return output ? j - offset : out;
};
/**
 * Decodes the UTF-16 contents from a Uint8Array.
 *
 * @param bytes the Uint8Array to decode.
 *
 * @return the resulting string.
 */ $93b7eee9251501ce$var$util.text.utf16.decode = function(bytes) {
    return String.fromCharCode.apply(null, new Uint16Array(bytes.buffer));
};
/**
 * Deflates the given data using a flash interface.
 *
 * @param api the flash interface.
 * @param bytes the data.
 * @param raw true to return only raw deflate data, false to include zlib
 *          header and trailer.
 *
 * @return the deflated data as a string.
 */ $93b7eee9251501ce$var$util.deflate = function(api, bytes, raw) {
    bytes = $93b7eee9251501ce$var$util.decode64(api.deflate($93b7eee9251501ce$var$util.encode64(bytes)).rval);
    // strip zlib header and trailer if necessary
    if (raw) {
        // zlib header is 2 bytes (CMF,FLG) where FLG indicates that
        // there is a 4-byte DICT (alder-32) block before the data if
        // its 5th bit is set
        var start = 2;
        var flg = bytes.charCodeAt(1);
        if (flg & 0x20) start = 6;
        // zlib trailer is 4 bytes of adler-32
        bytes = bytes.substring(start, bytes.length - 4);
    }
    return bytes;
};
/**
 * Inflates the given data using a flash interface.
 *
 * @param api the flash interface.
 * @param bytes the data.
 * @param raw true if the incoming data has no zlib header or trailer and is
 *          raw DEFLATE data.
 *
 * @return the inflated data as a string, null on error.
 */ $93b7eee9251501ce$var$util.inflate = function(api, bytes, raw) {
    // TODO: add zlib header and trailer if necessary/possible
    var rval = api.inflate($93b7eee9251501ce$var$util.encode64(bytes)).rval;
    return rval === null ? null : $93b7eee9251501ce$var$util.decode64(rval);
};
/**
 * Sets a storage object.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 * @param obj the storage object, null to remove.
 */ var $93b7eee9251501ce$var$_setStorageObject = function(api, id, obj) {
    if (!api) throw new Error('WebStorage not available.');
    var rval;
    if (obj === null) rval = api.removeItem(id);
    else {
        // json-encode and base64-encode object
        obj = $93b7eee9251501ce$var$util.encode64(JSON.stringify(obj));
        rval = api.setItem(id, obj);
    }
    // handle potential flash error
    if (typeof rval !== 'undefined' && rval.rval !== true) {
        var error = new Error(rval.error.message);
        error.id = rval.error.id;
        error.name = rval.error.name;
        throw error;
    }
};
/**
 * Gets a storage object.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 *
 * @return the storage object entry or null if none exists.
 */ var $93b7eee9251501ce$var$_getStorageObject = function(api, id) {
    if (!api) throw new Error('WebStorage not available.');
    // get the existing entry
    var rval = api.getItem(id);
    /* Note: We check api.init because we can't do (api == localStorage)
    on IE because of "Class doesn't support Automation" exception. Only
    the flash api has an init method so this works too, but we need a
    better solution in the future. */ // flash returns item wrapped in an object, handle special case
    if (api.init) {
        if (rval.rval === null) {
            if (rval.error) {
                var error = new Error(rval.error.message);
                error.id = rval.error.id;
                error.name = rval.error.name;
                throw error;
            }
            // no error, but also no item
            rval = null;
        } else rval = rval.rval;
    }
    // handle decoding
    if (rval !== null) // base64-decode and json-decode data
    rval = JSON.parse($93b7eee9251501ce$var$util.decode64(rval));
    return rval;
};
/**
 * Stores an item in local storage.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 * @param key the key for the item.
 * @param data the data for the item (any javascript object/primitive).
 */ var $93b7eee9251501ce$var$_setItem = function(api, id, key, data) {
    // get storage object
    var obj = $93b7eee9251501ce$var$_getStorageObject(api, id);
    if (obj === null) // create a new storage object
    obj = {};
    // update key
    obj[key] = data;
    // set storage object
    $93b7eee9251501ce$var$_setStorageObject(api, id, obj);
};
/**
 * Gets an item from local storage.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 * @param key the key for the item.
 *
 * @return the item.
 */ var $93b7eee9251501ce$var$_getItem = function(api, id, key) {
    // get storage object
    var rval = $93b7eee9251501ce$var$_getStorageObject(api, id);
    if (rval !== null) // return data at key
    rval = key in rval ? rval[key] : null;
    return rval;
};
/**
 * Removes an item from local storage.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 * @param key the key for the item.
 */ var $93b7eee9251501ce$var$_removeItem = function(api, id, key) {
    // get storage object
    var obj = $93b7eee9251501ce$var$_getStorageObject(api, id);
    if (obj !== null && key in obj) {
        // remove key
        delete obj[key];
        // see if entry has no keys remaining
        var empty = true;
        for(var prop in obj){
            empty = false;
            break;
        }
        if (empty) // remove entry entirely if no keys are left
        obj = null;
        // set storage object
        $93b7eee9251501ce$var$_setStorageObject(api, id, obj);
    }
};
/**
 * Clears the local disk storage identified by the given ID.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 */ var $93b7eee9251501ce$var$_clearItems = function(api, id) {
    $93b7eee9251501ce$var$_setStorageObject(api, id, null);
};
/**
 * Calls a storage function.
 *
 * @param func the function to call.
 * @param args the arguments for the function.
 * @param location the location argument.
 *
 * @return the return value from the function.
 */ var $93b7eee9251501ce$var$_callStorageFunction = function(func, args, location) {
    var rval = null;
    // default storage types
    if (typeof location === 'undefined') location = [
        'web',
        'flash'
    ];
    // apply storage types in order of preference
    var type;
    var done = false;
    var exception = null;
    for(var idx in location){
        type = location[idx];
        try {
            if (type === 'flash' || type === 'both') {
                if (args[0] === null) throw new Error('Flash local storage not available.');
                rval = func.apply(this, args);
                done = type === 'flash';
            }
            if (type === 'web' || type === 'both') {
                args[0] = localStorage;
                rval = func.apply(this, args);
                done = true;
            }
        } catch (ex) {
            exception = ex;
        }
        if (done) break;
    }
    if (!done) throw exception;
    return rval;
};
/**
 * Stores an item on local disk.
 *
 * The available types of local storage include 'flash', 'web', and 'both'.
 *
 * The type 'flash' refers to flash local storage (SharedObject). In order
 * to use flash local storage, the 'api' parameter must be valid. The type
 * 'web' refers to WebStorage, if supported by the browser. The type 'both'
 * refers to storing using both 'flash' and 'web', not just one or the
 * other.
 *
 * The location array should list the storage types to use in order of
 * preference:
 *
 * ['flash']: flash only storage
 * ['web']: web only storage
 * ['both']: try to store in both
 * ['flash','web']: store in flash first, but if not available, 'web'
 * ['web','flash']: store in web first, but if not available, 'flash'
 *
 * The location array defaults to: ['web', 'flash']
 *
 * @param api the flash interface, null to use only WebStorage.
 * @param id the storage ID to use.
 * @param key the key for the item.
 * @param data the data for the item (any javascript object/primitive).
 * @param location an array with the preferred types of storage to use.
 */ $93b7eee9251501ce$var$util.setItem = function(api, id, key, data, location) {
    $93b7eee9251501ce$var$_callStorageFunction($93b7eee9251501ce$var$_setItem, arguments, location);
};
/**
 * Gets an item on local disk.
 *
 * Set setItem() for details on storage types.
 *
 * @param api the flash interface, null to use only WebStorage.
 * @param id the storage ID to use.
 * @param key the key for the item.
 * @param location an array with the preferred types of storage to use.
 *
 * @return the item.
 */ $93b7eee9251501ce$var$util.getItem = function(api, id, key, location) {
    return $93b7eee9251501ce$var$_callStorageFunction($93b7eee9251501ce$var$_getItem, arguments, location);
};
/**
 * Removes an item on local disk.
 *
 * Set setItem() for details on storage types.
 *
 * @param api the flash interface.
 * @param id the storage ID to use.
 * @param key the key for the item.
 * @param location an array with the preferred types of storage to use.
 */ $93b7eee9251501ce$var$util.removeItem = function(api, id, key, location) {
    $93b7eee9251501ce$var$_callStorageFunction($93b7eee9251501ce$var$_removeItem, arguments, location);
};
/**
 * Clears the local disk storage identified by the given ID.
 *
 * Set setItem() for details on storage types.
 *
 * @param api the flash interface if flash is available.
 * @param id the storage ID to use.
 * @param location an array with the preferred types of storage to use.
 */ $93b7eee9251501ce$var$util.clearItems = function(api, id, location) {
    $93b7eee9251501ce$var$_callStorageFunction($93b7eee9251501ce$var$_clearItems, arguments, location);
};
/**
 * Check if an object is empty.
 *
 * Taken from:
 * http://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object-from-json/679937#679937
 *
 * @param object the object to check.
 */ $93b7eee9251501ce$var$util.isEmpty = function(obj) {
    for(var prop in obj){
        if (obj.hasOwnProperty(prop)) return false;
    }
    return true;
};
/**
 * Format with simple printf-style interpolation.
 *
 * %%: literal '%'
 * %s,%o: convert next argument into a string.
 *
 * @param format the string to format.
 * @param ... arguments to interpolate into the format string.
 */ $93b7eee9251501ce$var$util.format = function(format) {
    var re = /%./g;
    // current match
    var match;
    // current part
    var part;
    // current arg index
    var argi = 0;
    // collected parts to recombine later
    var parts = [];
    // last index found
    var last = 0;
    // loop while matches remain
    while(match = re.exec(format)){
        part = format.substring(last, re.lastIndex - 2);
        // don't add empty strings (ie, parts between %s%s)
        if (part.length > 0) parts.push(part);
        last = re.lastIndex;
        // switch on % code
        var code = match[0][1];
        switch(code){
            case 's':
            case 'o':
                // check if enough arguments were given
                if (argi < arguments.length) parts.push(arguments[argi++ + 1]);
                else parts.push('<?>');
                break;
            // FIXME: do proper formating for numbers, etc
            //case 'f':
            //case 'd':
            case '%':
                parts.push('%');
                break;
            default:
                parts.push('<%' + code + '?>');
        }
    }
    // add trailing part of format string
    parts.push(format.substring(last));
    return parts.join('');
};
/**
 * Formats a number.
 *
 * http://snipplr.com/view/5945/javascript-numberformat--ported-from-php/
 */ $93b7eee9251501ce$var$util.formatNumber = function(number, decimals, dec_point, thousands_sep) {
    // http://kevin.vanzonneveld.net
    // +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +     bugfix by: Michael White (http://crestidg.com)
    // +     bugfix by: Benjamin Lupton
    // +     bugfix by: Allan Jensen (http://www.winternet.no)
    // +    revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // *     example 1: number_format(1234.5678, 2, '.', '');
    // *     returns 1: 1234.57
    var n = number, c = isNaN(decimals = Math.abs(decimals)) ? 2 : decimals;
    var d = dec_point === undefined ? ',' : dec_point;
    var t = thousands_sep === undefined ? '.' : thousands_sep, s = n < 0 ? '-' : '';
    var i = parseInt(n = Math.abs(+n || 0).toFixed(c), 10) + '';
    var j = i.length > 3 ? i.length % 3 : 0;
    return s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '');
};
/**
 * Formats a byte size.
 *
 * http://snipplr.com/view/5949/format-humanize-file-byte-size-presentation-in-javascript/
 */ $93b7eee9251501ce$var$util.formatSize = function(size) {
    if (size >= 1073741824) size = $93b7eee9251501ce$var$util.formatNumber(size / 1073741824, 2, '.', '') + ' GiB';
    else if (size >= 1048576) size = $93b7eee9251501ce$var$util.formatNumber(size / 1048576, 2, '.', '') + ' MiB';
    else if (size >= 1024) size = $93b7eee9251501ce$var$util.formatNumber(size / 1024, 0) + ' KiB';
    else size = $93b7eee9251501ce$var$util.formatNumber(size, 0) + ' bytes';
    return size;
};
/**
 * Converts an IPv4 or IPv6 string representation into bytes (in network order).
 *
 * @param ip the IPv4 or IPv6 address to convert.
 *
 * @return the 4-byte IPv6 or 16-byte IPv6 address or null if the address can't
 *         be parsed.
 */ $93b7eee9251501ce$var$util.bytesFromIP = function(ip) {
    if (ip.indexOf('.') !== -1) return $93b7eee9251501ce$var$util.bytesFromIPv4(ip);
    if (ip.indexOf(':') !== -1) return $93b7eee9251501ce$var$util.bytesFromIPv6(ip);
    return null;
};
/**
 * Converts an IPv4 string representation into bytes (in network order).
 *
 * @param ip the IPv4 address to convert.
 *
 * @return the 4-byte address or null if the address can't be parsed.
 */ $93b7eee9251501ce$var$util.bytesFromIPv4 = function(ip) {
    ip = ip.split('.');
    if (ip.length !== 4) return null;
    var b = $93b7eee9251501ce$var$util.createBuffer();
    for(var i = 0; i < ip.length; ++i){
        var num = parseInt(ip[i], 10);
        if (isNaN(num)) return null;
        b.putByte(num);
    }
    return b.getBytes();
};
/**
 * Converts an IPv6 string representation into bytes (in network order).
 *
 * @param ip the IPv6 address to convert.
 *
 * @return the 16-byte address or null if the address can't be parsed.
 */ $93b7eee9251501ce$var$util.bytesFromIPv6 = function(ip) {
    var blanks = 0;
    ip = ip.split(':').filter(function(e) {
        if (e.length === 0) ++blanks;
        return true;
    });
    var zeros = (8 - ip.length + blanks) * 2;
    var b = $93b7eee9251501ce$var$util.createBuffer();
    for(var i = 0; i < 8; ++i){
        if (!ip[i] || ip[i].length === 0) {
            b.fillWithByte(0, zeros);
            zeros = 0;
            continue;
        }
        var bytes = $93b7eee9251501ce$var$util.hexToBytes(ip[i]);
        if (bytes.length < 2) b.putByte(0);
        b.putBytes(bytes);
    }
    return b.getBytes();
};
/**
 * Converts 4-bytes into an IPv4 string representation or 16-bytes into
 * an IPv6 string representation. The bytes must be in network order.
 *
 * @param bytes the bytes to convert.
 *
 * @return the IPv4 or IPv6 string representation if 4 or 16 bytes,
 *         respectively, are given, otherwise null.
 */ $93b7eee9251501ce$var$util.bytesToIP = function(bytes) {
    if (bytes.length === 4) return $93b7eee9251501ce$var$util.bytesToIPv4(bytes);
    if (bytes.length === 16) return $93b7eee9251501ce$var$util.bytesToIPv6(bytes);
    return null;
};
/**
 * Converts 4-bytes into an IPv4 string representation. The bytes must be
 * in network order.
 *
 * @param bytes the bytes to convert.
 *
 * @return the IPv4 string representation or null for an invalid # of bytes.
 */ $93b7eee9251501ce$var$util.bytesToIPv4 = function(bytes) {
    if (bytes.length !== 4) return null;
    var ip = [];
    for(var i = 0; i < bytes.length; ++i)ip.push(bytes.charCodeAt(i));
    return ip.join('.');
};
/**
 * Converts 16-bytes into an IPv16 string representation. The bytes must be
 * in network order.
 *
 * @param bytes the bytes to convert.
 *
 * @return the IPv16 string representation or null for an invalid # of bytes.
 */ $93b7eee9251501ce$var$util.bytesToIPv6 = function(bytes) {
    if (bytes.length !== 16) return null;
    var ip = [];
    var zeroGroups = [];
    var zeroMaxGroup = 0;
    for(var i = 0; i < bytes.length; i += 2){
        var hex = $93b7eee9251501ce$var$util.bytesToHex(bytes[i] + bytes[i + 1]);
        // canonicalize zero representation
        while(hex[0] === '0' && hex !== '0')hex = hex.substr(1);
        if (hex === '0') {
            var last = zeroGroups[zeroGroups.length - 1];
            var idx = ip.length;
            if (!last || idx !== last.end + 1) zeroGroups.push({
                start: idx,
                end: idx
            });
            else {
                last.end = idx;
                if (last.end - last.start > zeroGroups[zeroMaxGroup].end - zeroGroups[zeroMaxGroup].start) zeroMaxGroup = zeroGroups.length - 1;
            }
        }
        ip.push(hex);
    }
    if (zeroGroups.length > 0) {
        var group = zeroGroups[zeroMaxGroup];
        // only shorten group of length > 0
        if (group.end - group.start > 0) {
            ip.splice(group.start, group.end - group.start + 1, '');
            if (group.start === 0) ip.unshift('');
            if (group.end === 7) ip.push('');
        }
    }
    return ip.join(':');
};
/**
 * Estimates the number of processes that can be run concurrently. If
 * creating Web Workers, keep in mind that the main JavaScript process needs
 * its own core.
 *
 * @param options the options to use:
 *          update true to force an update (not use the cached value).
 * @param callback(err, max) called once the operation completes.
 */ $93b7eee9251501ce$var$util.estimateCores = function(options, callback) {
    if (typeof options === 'function') {
        callback = options;
        options = {};
    }
    options = options || {};
    if ('cores' in $93b7eee9251501ce$var$util && !options.update) return callback(null, $93b7eee9251501ce$var$util.cores);
    if (typeof navigator !== 'undefined' && 'hardwareConcurrency' in navigator && navigator.hardwareConcurrency > 0) {
        $93b7eee9251501ce$var$util.cores = navigator.hardwareConcurrency;
        return callback(null, $93b7eee9251501ce$var$util.cores);
    }
    if (typeof Worker === 'undefined') {
        // workers not available
        $93b7eee9251501ce$var$util.cores = 1;
        return callback(null, $93b7eee9251501ce$var$util.cores);
    }
    if (typeof Blob === 'undefined') {
        // can't estimate, default to 2
        $93b7eee9251501ce$var$util.cores = 2;
        return callback(null, $93b7eee9251501ce$var$util.cores);
    }
    // create worker concurrency estimation code as blob
    var blobUrl = URL.createObjectURL(new Blob([
        '(',
        (function() {
            self.addEventListener('message', function(e) {
                // run worker for 4 ms
                var st = Date.now();
                var et = st + 4;
                while(Date.now() < et);
                self.postMessage({
                    st: st,
                    et: et
                });
            });
        }).toString(),
        ')()'
    ], {
        type: 'application/javascript'
    }));
    // take 5 samples using 16 workers
    sample([], 5, 16);
    function sample(max, samples, numWorkers) {
        if (samples === 0) {
            // get overlap average
            var avg = Math.floor(max.reduce(function(avg, x) {
                return avg + x;
            }, 0) / max.length);
            $93b7eee9251501ce$var$util.cores = Math.max(1, avg);
            URL.revokeObjectURL(blobUrl);
            return callback(null, $93b7eee9251501ce$var$util.cores);
        }
        map(numWorkers, function(err, results) {
            max.push(reduce(numWorkers, results));
            sample(max, samples - 1, numWorkers);
        });
    }
    function map(numWorkers, callback) {
        var workers = [];
        var results = [];
        for(var i = 0; i < numWorkers; ++i){
            var worker = new Worker(blobUrl);
            worker.addEventListener('message', function(e) {
                results.push(e.data);
                if (results.length === numWorkers) {
                    for(var i = 0; i < numWorkers; ++i)workers[i].terminate();
                    callback(null, results);
                }
            });
            workers.push(worker);
        }
        for(var i = 0; i < numWorkers; ++i)workers[i].postMessage(i);
    }
    function reduce(numWorkers, results) {
        // find overlapping time windows
        var overlaps = [];
        for(var n = 0; n < numWorkers; ++n){
            var r1 = results[n];
            var overlap = overlaps[n] = [];
            for(var i = 0; i < numWorkers; ++i){
                if (n === i) continue;
                var r2 = results[i];
                if (r1.st > r2.st && r1.st < r2.et || r2.st > r1.st && r2.st < r1.et) overlap.push(i);
            }
        }
        // get maximum overlaps ... don't include overlapping worker itself
        // as the main JS process was also being scheduled during the work and
        // would have to be subtracted from the estimate anyway
        return overlaps.reduce(function(max, overlap) {
            return Math.max(max, overlap.length);
        }, 0);
    }
};


$c1199cb2ce29edaa$exports = $cLQG7.cipher = $cLQG7.cipher || {};
// registered algorithms
$cLQG7.cipher.algorithms = $cLQG7.cipher.algorithms || {};
/**
 * Creates a cipher object that can be used to encrypt data using the given
 * algorithm and key. The algorithm may be provided as a string value for a
 * previously registered algorithm or it may be given as a cipher algorithm
 * API object.
 *
 * @param algorithm the algorithm to use, either a string or an algorithm API
 *          object.
 * @param key the key to use, as a binary-encoded string of bytes or a
 *          byte buffer.
 *
 * @return the cipher.
 */ $cLQG7.cipher.createCipher = function(algorithm, key) {
    var api = algorithm;
    if (typeof api === 'string') {
        api = $cLQG7.cipher.getAlgorithm(api);
        if (api) api = api();
    }
    if (!api) throw new Error('Unsupported algorithm: ' + algorithm);
    // assume block cipher
    return new $cLQG7.cipher.BlockCipher({
        algorithm: api,
        key: key,
        decrypt: false
    });
};
/**
 * Creates a decipher object that can be used to decrypt data using the given
 * algorithm and key. The algorithm may be provided as a string value for a
 * previously registered algorithm or it may be given as a cipher algorithm
 * API object.
 *
 * @param algorithm the algorithm to use, either a string or an algorithm API
 *          object.
 * @param key the key to use, as a binary-encoded string of bytes or a
 *          byte buffer.
 *
 * @return the cipher.
 */ $cLQG7.cipher.createDecipher = function(algorithm, key) {
    var api = algorithm;
    if (typeof api === 'string') {
        api = $cLQG7.cipher.getAlgorithm(api);
        if (api) api = api();
    }
    if (!api) throw new Error('Unsupported algorithm: ' + algorithm);
    // assume block cipher
    return new $cLQG7.cipher.BlockCipher({
        algorithm: api,
        key: key,
        decrypt: true
    });
};
/**
 * Registers an algorithm by name. If the name was already registered, the
 * algorithm API object will be overwritten.
 *
 * @param name the name of the algorithm.
 * @param algorithm the algorithm API object.
 */ $cLQG7.cipher.registerAlgorithm = function(name, algorithm) {
    name = name.toUpperCase();
    $cLQG7.cipher.algorithms[name] = algorithm;
};
/**
 * Gets a registered algorithm by name.
 *
 * @param name the name of the algorithm.
 *
 * @return the algorithm, if found, null if not.
 */ $cLQG7.cipher.getAlgorithm = function(name) {
    name = name.toUpperCase();
    if (name in $cLQG7.cipher.algorithms) return $cLQG7.cipher.algorithms[name];
    return null;
};
var $c1199cb2ce29edaa$var$BlockCipher = $cLQG7.cipher.BlockCipher = function(options) {
    this.algorithm = options.algorithm;
    this.mode = this.algorithm.mode;
    this.blockSize = this.mode.blockSize;
    this._finish = false;
    this._input = null;
    this.output = null;
    this._op = options.decrypt ? this.mode.decrypt : this.mode.encrypt;
    this._decrypt = options.decrypt;
    this.algorithm.initialize(options);
};
/**
 * Starts or restarts the encryption or decryption process, whichever
 * was previously configured.
 *
 * For non-GCM mode, the IV may be a binary-encoded string of bytes, an array
 * of bytes, a byte buffer, or an array of 32-bit integers. If the IV is in
 * bytes, then it must be Nb (16) bytes in length. If the IV is given in as
 * 32-bit integers, then it must be 4 integers long.
 *
 * Note: an IV is not required or used in ECB mode.
 *
 * For GCM-mode, the IV must be given as a binary-encoded string of bytes or
 * a byte buffer. The number of bytes should be 12 (96 bits) as recommended
 * by NIST SP-800-38D but another length may be given.
 *
 * @param options the options to use:
 *          iv the initialization vector to use as a binary-encoded string of
 *            bytes, null to reuse the last ciphered block from a previous
 *            update() (this "residue" method is for legacy support only).
 *          additionalData additional authentication data as a binary-encoded
 *            string of bytes, for 'GCM' mode, (default: none).
 *          tagLength desired length of authentication tag, in bits, for
 *            'GCM' mode (0-128, default: 128).
 *          tag the authentication tag to check if decrypting, as a
 *             binary-encoded string of bytes.
 *          output the output the buffer to write to, null to create one.
 */ $c1199cb2ce29edaa$var$BlockCipher.prototype.start = function(options) {
    options = options || {};
    var opts = {};
    for(var key in options)opts[key] = options[key];
    opts.decrypt = this._decrypt;
    this._finish = false;
    this._input = $cLQG7.util.createBuffer();
    this.output = options.output || $cLQG7.util.createBuffer();
    this.mode.start(opts);
};
/**
 * Updates the next block according to the cipher mode.
 *
 * @param input the buffer to read from.
 */ $c1199cb2ce29edaa$var$BlockCipher.prototype.update = function(input) {
    if (input) // input given, so empty it into the input buffer
    this._input.putBuffer(input);
    // do cipher operation until it needs more input and not finished
    while(!this._op.call(this.mode, this._input, this.output, this._finish) && !this._finish);
    // free consumed memory from input buffer
    this._input.compact();
};
/**
 * Finishes encrypting or decrypting.
 *
 * @param pad a padding function to use in CBC mode, null for default,
 *          signature(blockSize, buffer, decrypt).
 *
 * @return true if successful, false on error.
 */ $c1199cb2ce29edaa$var$BlockCipher.prototype.finish = function(pad) {
    // backwards-compatibility w/deprecated padding API
    // Note: will overwrite padding functions even after another start() call
    if (pad && (this.mode.name === 'ECB' || this.mode.name === 'CBC')) {
        this.mode.pad = function(input) {
            return pad(this.blockSize, input, false);
        };
        this.mode.unpad = function(output) {
            return pad(this.blockSize, output, true);
        };
    }
    // build options for padding and afterFinish functions
    var options = {};
    options.decrypt = this._decrypt;
    // get # of bytes that won't fill a block
    options.overflow = this._input.length() % this.blockSize;
    if (!this._decrypt && this.mode.pad) {
        if (!this.mode.pad(this._input, options)) return false;
    }
    // do final update
    this._finish = true;
    this.update();
    if (this._decrypt && this.mode.unpad) {
        if (!this.mode.unpad(this.output, options)) return false;
    }
    if (this.mode.afterFinish) {
        if (!this.mode.afterFinish(this.output, options)) return false;
    }
    return true;
};


var $ba49eab70e932126$exports = {};
/**
 * Supported cipher modes.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 */ 
var $cLQG7 = parcelRequire("cLQG7");

$cLQG7.cipher = $cLQG7.cipher || {};
// supported cipher modes
var $ba49eab70e932126$var$modes = $ba49eab70e932126$exports = $cLQG7.cipher.modes = $cLQG7.cipher.modes || {};
/** Electronic codebook (ECB) (Don't use this; it's not secure) **/ $ba49eab70e932126$var$modes.ecb = function(options) {
    options = options || {};
    this.name = 'ECB';
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = new Array(this._ints);
    this._outBlock = new Array(this._ints);
};
$ba49eab70e932126$var$modes.ecb.prototype.start = function(options) {};
$ba49eab70e932126$var$modes.ecb.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    if (input.length() < this.blockSize && !(finish && input.length() > 0)) return true;
    // get next block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = input.getInt32();
    // encrypt block
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // write output
    for(var i = 0; i < this._ints; ++i)output.putInt32(this._outBlock[i]);
};
$ba49eab70e932126$var$modes.ecb.prototype.decrypt = function(input, output, finish) {
    // not enough input to decrypt
    if (input.length() < this.blockSize && !(finish && input.length() > 0)) return true;
    // get next block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = input.getInt32();
    // decrypt block
    this.cipher.decrypt(this._inBlock, this._outBlock);
    // write output
    for(var i = 0; i < this._ints; ++i)output.putInt32(this._outBlock[i]);
};
$ba49eab70e932126$var$modes.ecb.prototype.pad = function(input, options) {
    // add PKCS#7 padding to block (each pad byte is the
    // value of the number of pad bytes)
    var padding = input.length() === this.blockSize ? this.blockSize : this.blockSize - input.length();
    input.fillWithByte(padding, padding);
    return true;
};
$ba49eab70e932126$var$modes.ecb.prototype.unpad = function(output, options) {
    // check for error: input data not a multiple of blockSize
    if (options.overflow > 0) return false;
    // ensure padding byte count is valid
    var len = output.length();
    var count = output.at(len - 1);
    if (count > this.blockSize << 2) return false;
    // trim off padding bytes
    output.truncate(count);
    return true;
};
/** Cipher-block Chaining (CBC) **/ $ba49eab70e932126$var$modes.cbc = function(options) {
    options = options || {};
    this.name = 'CBC';
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = new Array(this._ints);
    this._outBlock = new Array(this._ints);
};
$ba49eab70e932126$var$modes.cbc.prototype.start = function(options) {
    // Note: legacy support for using IV residue (has security flaws)
    // if IV is null, reuse block from previous processing
    if (options.iv === null) {
        // must have a previous block
        if (!this._prev) throw new Error('Invalid IV parameter.');
        this._iv = this._prev.slice(0);
    } else if (!('iv' in options)) throw new Error('Invalid IV parameter.');
    else {
        // save IV as "previous" block
        this._iv = $ba49eab70e932126$var$transformIV(options.iv, this.blockSize);
        this._prev = this._iv.slice(0);
    }
};
$ba49eab70e932126$var$modes.cbc.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    if (input.length() < this.blockSize && !(finish && input.length() > 0)) return true;
    // get next block
    // CBC XOR's IV (or previous block) with plaintext
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = this._prev[i] ^ input.getInt32();
    // encrypt block
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // write output, save previous block
    for(var i = 0; i < this._ints; ++i)output.putInt32(this._outBlock[i]);
    this._prev = this._outBlock;
};
$ba49eab70e932126$var$modes.cbc.prototype.decrypt = function(input, output, finish) {
    // not enough input to decrypt
    if (input.length() < this.blockSize && !(finish && input.length() > 0)) return true;
    // get next block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = input.getInt32();
    // decrypt block
    this.cipher.decrypt(this._inBlock, this._outBlock);
    // write output, save previous ciphered block
    // CBC XOR's IV (or previous block) with ciphertext
    for(var i = 0; i < this._ints; ++i)output.putInt32(this._prev[i] ^ this._outBlock[i]);
    this._prev = this._inBlock.slice(0);
};
$ba49eab70e932126$var$modes.cbc.prototype.pad = function(input, options) {
    // add PKCS#7 padding to block (each pad byte is the
    // value of the number of pad bytes)
    var padding = input.length() === this.blockSize ? this.blockSize : this.blockSize - input.length();
    input.fillWithByte(padding, padding);
    return true;
};
$ba49eab70e932126$var$modes.cbc.prototype.unpad = function(output, options) {
    // check for error: input data not a multiple of blockSize
    if (options.overflow > 0) return false;
    // ensure padding byte count is valid
    var len = output.length();
    var count = output.at(len - 1);
    if (count > this.blockSize << 2) return false;
    // trim off padding bytes
    output.truncate(count);
    return true;
};
/** Cipher feedback (CFB) **/ $ba49eab70e932126$var$modes.cfb = function(options) {
    options = options || {};
    this.name = 'CFB';
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = null;
    this._outBlock = new Array(this._ints);
    this._partialBlock = new Array(this._ints);
    this._partialOutput = $cLQG7.util.createBuffer();
    this._partialBytes = 0;
};
$ba49eab70e932126$var$modes.cfb.prototype.start = function(options) {
    if (!('iv' in options)) throw new Error('Invalid IV parameter.');
    // use IV as first input
    this._iv = $ba49eab70e932126$var$transformIV(options.iv, this.blockSize);
    this._inBlock = this._iv.slice(0);
    this._partialBytes = 0;
};
$ba49eab70e932126$var$modes.cfb.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    var inputLength = input.length();
    if (inputLength === 0) return true;
    // encrypt block
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // handle full block
    if (this._partialBytes === 0 && inputLength >= this.blockSize) {
        // XOR input with output, write input as output
        for(var i = 0; i < this._ints; ++i){
            this._inBlock[i] = input.getInt32() ^ this._outBlock[i];
            output.putInt32(this._inBlock[i]);
        }
        return;
    }
    // handle partial block
    var partialBytes = (this.blockSize - inputLength) % this.blockSize;
    if (partialBytes > 0) partialBytes = this.blockSize - partialBytes;
    // XOR input with output, write input as partial output
    this._partialOutput.clear();
    for(var i = 0; i < this._ints; ++i){
        this._partialBlock[i] = input.getInt32() ^ this._outBlock[i];
        this._partialOutput.putInt32(this._partialBlock[i]);
    }
    if (partialBytes > 0) // block still incomplete, restore input buffer
    input.read -= this.blockSize;
    else // block complete, update input block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = this._partialBlock[i];
    // skip any previous partial bytes
    if (this._partialBytes > 0) this._partialOutput.getBytes(this._partialBytes);
    if (partialBytes > 0 && !finish) {
        output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
        this._partialBytes = partialBytes;
        return true;
    }
    output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
    this._partialBytes = 0;
};
$ba49eab70e932126$var$modes.cfb.prototype.decrypt = function(input, output, finish) {
    // not enough input to decrypt
    var inputLength = input.length();
    if (inputLength === 0) return true;
    // encrypt block (CFB always uses encryption mode)
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // handle full block
    if (this._partialBytes === 0 && inputLength >= this.blockSize) {
        // XOR input with output, write input as output
        for(var i = 0; i < this._ints; ++i){
            this._inBlock[i] = input.getInt32();
            output.putInt32(this._inBlock[i] ^ this._outBlock[i]);
        }
        return;
    }
    // handle partial block
    var partialBytes = (this.blockSize - inputLength) % this.blockSize;
    if (partialBytes > 0) partialBytes = this.blockSize - partialBytes;
    // XOR input with output, write input as partial output
    this._partialOutput.clear();
    for(var i = 0; i < this._ints; ++i){
        this._partialBlock[i] = input.getInt32();
        this._partialOutput.putInt32(this._partialBlock[i] ^ this._outBlock[i]);
    }
    if (partialBytes > 0) // block still incomplete, restore input buffer
    input.read -= this.blockSize;
    else // block complete, update input block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = this._partialBlock[i];
    // skip any previous partial bytes
    if (this._partialBytes > 0) this._partialOutput.getBytes(this._partialBytes);
    if (partialBytes > 0 && !finish) {
        output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
        this._partialBytes = partialBytes;
        return true;
    }
    output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
    this._partialBytes = 0;
};
/** Output feedback (OFB) **/ $ba49eab70e932126$var$modes.ofb = function(options) {
    options = options || {};
    this.name = 'OFB';
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = null;
    this._outBlock = new Array(this._ints);
    this._partialOutput = $cLQG7.util.createBuffer();
    this._partialBytes = 0;
};
$ba49eab70e932126$var$modes.ofb.prototype.start = function(options) {
    if (!('iv' in options)) throw new Error('Invalid IV parameter.');
    // use IV as first input
    this._iv = $ba49eab70e932126$var$transformIV(options.iv, this.blockSize);
    this._inBlock = this._iv.slice(0);
    this._partialBytes = 0;
};
$ba49eab70e932126$var$modes.ofb.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    var inputLength = input.length();
    if (input.length() === 0) return true;
    // encrypt block (OFB always uses encryption mode)
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // handle full block
    if (this._partialBytes === 0 && inputLength >= this.blockSize) {
        // XOR input with output and update next input
        for(var i = 0; i < this._ints; ++i){
            output.putInt32(input.getInt32() ^ this._outBlock[i]);
            this._inBlock[i] = this._outBlock[i];
        }
        return;
    }
    // handle partial block
    var partialBytes = (this.blockSize - inputLength) % this.blockSize;
    if (partialBytes > 0) partialBytes = this.blockSize - partialBytes;
    // XOR input with output
    this._partialOutput.clear();
    for(var i = 0; i < this._ints; ++i)this._partialOutput.putInt32(input.getInt32() ^ this._outBlock[i]);
    if (partialBytes > 0) // block still incomplete, restore input buffer
    input.read -= this.blockSize;
    else // block complete, update input block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = this._outBlock[i];
    // skip any previous partial bytes
    if (this._partialBytes > 0) this._partialOutput.getBytes(this._partialBytes);
    if (partialBytes > 0 && !finish) {
        output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
        this._partialBytes = partialBytes;
        return true;
    }
    output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
    this._partialBytes = 0;
};
$ba49eab70e932126$var$modes.ofb.prototype.decrypt = $ba49eab70e932126$var$modes.ofb.prototype.encrypt;
/** Counter (CTR) **/ $ba49eab70e932126$var$modes.ctr = function(options) {
    options = options || {};
    this.name = 'CTR';
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = null;
    this._outBlock = new Array(this._ints);
    this._partialOutput = $cLQG7.util.createBuffer();
    this._partialBytes = 0;
};
$ba49eab70e932126$var$modes.ctr.prototype.start = function(options) {
    if (!('iv' in options)) throw new Error('Invalid IV parameter.');
    // use IV as first input
    this._iv = $ba49eab70e932126$var$transformIV(options.iv, this.blockSize);
    this._inBlock = this._iv.slice(0);
    this._partialBytes = 0;
};
$ba49eab70e932126$var$modes.ctr.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    var inputLength = input.length();
    if (inputLength === 0) return true;
    // encrypt block (CTR always uses encryption mode)
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // handle full block
    if (this._partialBytes === 0 && inputLength >= this.blockSize) // XOR input with output
    for(var i = 0; i < this._ints; ++i)output.putInt32(input.getInt32() ^ this._outBlock[i]);
    else {
        // handle partial block
        var partialBytes = (this.blockSize - inputLength) % this.blockSize;
        if (partialBytes > 0) partialBytes = this.blockSize - partialBytes;
        // XOR input with output
        this._partialOutput.clear();
        for(var i = 0; i < this._ints; ++i)this._partialOutput.putInt32(input.getInt32() ^ this._outBlock[i]);
        if (partialBytes > 0) // block still incomplete, restore input buffer
        input.read -= this.blockSize;
        // skip any previous partial bytes
        if (this._partialBytes > 0) this._partialOutput.getBytes(this._partialBytes);
        if (partialBytes > 0 && !finish) {
            output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
            this._partialBytes = partialBytes;
            return true;
        }
        output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
        this._partialBytes = 0;
    }
    // block complete, increment counter (input block)
    $ba49eab70e932126$var$inc32(this._inBlock);
};
$ba49eab70e932126$var$modes.ctr.prototype.decrypt = $ba49eab70e932126$var$modes.ctr.prototype.encrypt;
/** Galois/Counter Mode (GCM) **/ $ba49eab70e932126$var$modes.gcm = function(options) {
    options = options || {};
    this.name = 'GCM';
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = new Array(this._ints);
    this._outBlock = new Array(this._ints);
    this._partialOutput = $cLQG7.util.createBuffer();
    this._partialBytes = 0;
    // R is actually this value concatenated with 120 more zero bits, but
    // we only XOR against R so the other zeros have no effect -- we just
    // apply this value to the first integer in a block
    this._R = 0xE1000000;
};
$ba49eab70e932126$var$modes.gcm.prototype.start = function(options) {
    if (!('iv' in options)) throw new Error('Invalid IV parameter.');
    // ensure IV is a byte buffer
    var iv = $cLQG7.util.createBuffer(options.iv);
    // no ciphered data processed yet
    this._cipherLength = 0;
    // default additional data is none
    var additionalData;
    if ('additionalData' in options) additionalData = $cLQG7.util.createBuffer(options.additionalData);
    else additionalData = $cLQG7.util.createBuffer();
    // default tag length is 128 bits
    if ('tagLength' in options) this._tagLength = options.tagLength;
    else this._tagLength = 128;
    // if tag is given, ensure tag matches tag length
    this._tag = null;
    if (options.decrypt) {
        // save tag to check later
        this._tag = $cLQG7.util.createBuffer(options.tag).getBytes();
        if (this._tag.length !== this._tagLength / 8) throw new Error('Authentication tag does not match tag length.');
    }
    // create tmp storage for hash calculation
    this._hashBlock = new Array(this._ints);
    // no tag generated yet
    this.tag = null;
    // generate hash subkey
    // (apply block cipher to "zero" block)
    this._hashSubkey = new Array(this._ints);
    this.cipher.encrypt([
        0,
        0,
        0,
        0
    ], this._hashSubkey);
    // generate table M
    // use 4-bit tables (32 component decomposition of a 16 byte value)
    // 8-bit tables take more space and are known to have security
    // vulnerabilities (in native implementations)
    this.componentBits = 4;
    this._m = this.generateHashTable(this._hashSubkey, this.componentBits);
    // Note: support IV length different from 96 bits? (only supporting
    // 96 bits is recommended by NIST SP-800-38D)
    // generate J_0
    var ivLength = iv.length();
    if (ivLength === 12) // 96-bit IV
    this._j0 = [
        iv.getInt32(),
        iv.getInt32(),
        iv.getInt32(),
        1
    ];
    else {
        // IV is NOT 96-bits
        this._j0 = [
            0,
            0,
            0,
            0
        ];
        while(iv.length() > 0)this._j0 = this.ghash(this._hashSubkey, this._j0, [
            iv.getInt32(),
            iv.getInt32(),
            iv.getInt32(),
            iv.getInt32()
        ]);
        this._j0 = this.ghash(this._hashSubkey, this._j0, [
            0,
            0
        ].concat($ba49eab70e932126$var$from64To32(ivLength * 8)));
    }
    // generate ICB (initial counter block)
    this._inBlock = this._j0.slice(0);
    $ba49eab70e932126$var$inc32(this._inBlock);
    this._partialBytes = 0;
    // consume authentication data
    additionalData = $cLQG7.util.createBuffer(additionalData);
    // save additional data length as a BE 64-bit number
    this._aDataLength = $ba49eab70e932126$var$from64To32(additionalData.length() * 8);
    // pad additional data to 128 bit (16 byte) block size
    var overflow = additionalData.length() % this.blockSize;
    if (overflow) additionalData.fillWithByte(0, this.blockSize - overflow);
    this._s = [
        0,
        0,
        0,
        0
    ];
    while(additionalData.length() > 0)this._s = this.ghash(this._hashSubkey, this._s, [
        additionalData.getInt32(),
        additionalData.getInt32(),
        additionalData.getInt32(),
        additionalData.getInt32()
    ]);
};
$ba49eab70e932126$var$modes.gcm.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    var inputLength = input.length();
    if (inputLength === 0) return true;
    // encrypt block
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // handle full block
    if (this._partialBytes === 0 && inputLength >= this.blockSize) {
        // XOR input with output
        for(var i = 0; i < this._ints; ++i)output.putInt32(this._outBlock[i] ^= input.getInt32());
        this._cipherLength += this.blockSize;
    } else {
        // handle partial block
        var partialBytes = (this.blockSize - inputLength) % this.blockSize;
        if (partialBytes > 0) partialBytes = this.blockSize - partialBytes;
        // XOR input with output
        this._partialOutput.clear();
        for(var i = 0; i < this._ints; ++i)this._partialOutput.putInt32(input.getInt32() ^ this._outBlock[i]);
        if (partialBytes <= 0 || finish) {
            // handle overflow prior to hashing
            if (finish) {
                // get block overflow
                var overflow = inputLength % this.blockSize;
                this._cipherLength += overflow;
                // truncate for hash function
                this._partialOutput.truncate(this.blockSize - overflow);
            } else this._cipherLength += this.blockSize;
            // get output block for hashing
            for(var i = 0; i < this._ints; ++i)this._outBlock[i] = this._partialOutput.getInt32();
            this._partialOutput.read -= this.blockSize;
        }
        // skip any previous partial bytes
        if (this._partialBytes > 0) this._partialOutput.getBytes(this._partialBytes);
        if (partialBytes > 0 && !finish) {
            // block still incomplete, restore input buffer, get partial output,
            // and return early
            input.read -= this.blockSize;
            output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
            this._partialBytes = partialBytes;
            return true;
        }
        output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
        this._partialBytes = 0;
    }
    // update hash block S
    this._s = this.ghash(this._hashSubkey, this._s, this._outBlock);
    // increment counter (input block)
    $ba49eab70e932126$var$inc32(this._inBlock);
};
$ba49eab70e932126$var$modes.gcm.prototype.decrypt = function(input, output, finish) {
    // not enough input to decrypt
    var inputLength = input.length();
    if (inputLength < this.blockSize && !(finish && inputLength > 0)) return true;
    // encrypt block (GCM always uses encryption mode)
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // increment counter (input block)
    $ba49eab70e932126$var$inc32(this._inBlock);
    // update hash block S
    this._hashBlock[0] = input.getInt32();
    this._hashBlock[1] = input.getInt32();
    this._hashBlock[2] = input.getInt32();
    this._hashBlock[3] = input.getInt32();
    this._s = this.ghash(this._hashSubkey, this._s, this._hashBlock);
    // XOR hash input with output
    for(var i = 0; i < this._ints; ++i)output.putInt32(this._outBlock[i] ^ this._hashBlock[i]);
    // increment cipher data length
    if (inputLength < this.blockSize) this._cipherLength += inputLength % this.blockSize;
    else this._cipherLength += this.blockSize;
};
$ba49eab70e932126$var$modes.gcm.prototype.afterFinish = function(output, options) {
    var rval = true;
    // handle overflow
    if (options.decrypt && options.overflow) output.truncate(this.blockSize - options.overflow);
    // handle authentication tag
    this.tag = $cLQG7.util.createBuffer();
    // concatenate additional data length with cipher length
    var lengths = this._aDataLength.concat($ba49eab70e932126$var$from64To32(this._cipherLength * 8));
    // include lengths in hash
    this._s = this.ghash(this._hashSubkey, this._s, lengths);
    // do GCTR(J_0, S)
    var tag = [];
    this.cipher.encrypt(this._j0, tag);
    for(var i = 0; i < this._ints; ++i)this.tag.putInt32(this._s[i] ^ tag[i]);
    // trim tag to length
    this.tag.truncate(this.tag.length() % (this._tagLength / 8));
    // check authentication tag
    if (options.decrypt && this.tag.bytes() !== this._tag) rval = false;
    return rval;
};
/**
 * See NIST SP-800-38D 6.3 (Algorithm 1). This function performs Galois
 * field multiplication. The field, GF(2^128), is defined by the polynomial:
 *
 * x^128 + x^7 + x^2 + x + 1
 *
 * Which is represented in little-endian binary form as: 11100001 (0xe1). When
 * the value of a coefficient is 1, a bit is set. The value R, is the
 * concatenation of this value and 120 zero bits, yielding a 128-bit value
 * which matches the block size.
 *
 * This function will multiply two elements (vectors of bytes), X and Y, in
 * the field GF(2^128). The result is initialized to zero. For each bit of
 * X (out of 128), x_i, if x_i is set, then the result is multiplied (XOR'd)
 * by the current value of Y. For each bit, the value of Y will be raised by
 * a power of x (multiplied by the polynomial x). This can be achieved by
 * shifting Y once to the right. If the current value of Y, prior to being
 * multiplied by x, has 0 as its LSB, then it is a 127th degree polynomial.
 * Otherwise, we must divide by R after shifting to find the remainder.
 *
 * @param x the first block to multiply by the second.
 * @param y the second block to multiply by the first.
 *
 * @return the block result of the multiplication.
 */ $ba49eab70e932126$var$modes.gcm.prototype.multiply = function(x, y) {
    var z_i = [
        0,
        0,
        0,
        0
    ];
    var v_i = y.slice(0);
    // calculate Z_128 (block has 128 bits)
    for(var i = 0; i < 128; ++i){
        // if x_i is 0, Z_{i+1} = Z_i (unchanged)
        // else Z_{i+1} = Z_i ^ V_i
        // get x_i by finding 32-bit int position, then left shift 1 by remainder
        var x_i = x[i / 32 | 0] & 1 << 31 - i % 32;
        if (x_i) {
            z_i[0] ^= v_i[0];
            z_i[1] ^= v_i[1];
            z_i[2] ^= v_i[2];
            z_i[3] ^= v_i[3];
        }
        // if LSB(V_i) is 1, V_i = V_i >> 1
        // else V_i = (V_i >> 1) ^ R
        this.pow(v_i, v_i);
    }
    return z_i;
};
$ba49eab70e932126$var$modes.gcm.prototype.pow = function(x, out) {
    // if LSB(x) is 1, x = x >>> 1
    // else x = (x >>> 1) ^ R
    var lsb = x[3] & 1;
    // always do x >>> 1:
    // starting with the rightmost integer, shift each integer to the right
    // one bit, pulling in the bit from the integer to the left as its top
    // most bit (do this for the last 3 integers)
    for(var i = 3; i > 0; --i)out[i] = x[i] >>> 1 | (x[i - 1] & 1) << 31;
    // shift the first integer normally
    out[0] = x[0] >>> 1;
    // if lsb was not set, then polynomial had a degree of 127 and doesn't
    // need to divided; otherwise, XOR with R to find the remainder; we only
    // need to XOR the first integer since R technically ends w/120 zero bits
    if (lsb) out[0] ^= this._R;
};
$ba49eab70e932126$var$modes.gcm.prototype.tableMultiply = function(x) {
    // assumes 4-bit tables are used
    var z = [
        0,
        0,
        0,
        0
    ];
    for(var i = 0; i < 32; ++i){
        var idx = i / 8 | 0;
        var x_i = x[idx] >>> (7 - i % 8) * 4 & 0xF;
        var ah = this._m[i][x_i];
        z[0] ^= ah[0];
        z[1] ^= ah[1];
        z[2] ^= ah[2];
        z[3] ^= ah[3];
    }
    return z;
};
/**
 * A continuing version of the GHASH algorithm that operates on a single
 * block. The hash block, last hash value (Ym) and the new block to hash
 * are given.
 *
 * @param h the hash block.
 * @param y the previous value for Ym, use [0, 0, 0, 0] for a new hash.
 * @param x the block to hash.
 *
 * @return the hashed value (Ym).
 */ $ba49eab70e932126$var$modes.gcm.prototype.ghash = function(h, y, x) {
    y[0] ^= x[0];
    y[1] ^= x[1];
    y[2] ^= x[2];
    y[3] ^= x[3];
    return this.tableMultiply(y);
//return this.multiply(y, h);
};
/**
 * Precomputes a table for multiplying against the hash subkey. This
 * mechanism provides a substantial speed increase over multiplication
 * performed without a table. The table-based multiplication this table is
 * for solves X * H by multiplying each component of X by H and then
 * composing the results together using XOR.
 *
 * This function can be used to generate tables with different bit sizes
 * for the components, however, this implementation assumes there are
 * 32 components of X (which is a 16 byte vector), therefore each component
 * takes 4-bits (so the table is constructed with bits=4).
 *
 * @param h the hash subkey.
 * @param bits the bit size for a component.
 */ $ba49eab70e932126$var$modes.gcm.prototype.generateHashTable = function(h, bits) {
    // TODO: There are further optimizations that would use only the
    // first table M_0 (or some variant) along with a remainder table;
    // this can be explored in the future
    var multiplier = 8 / bits;
    var perInt = 4 * multiplier;
    var size = 16 * multiplier;
    var m = new Array(size);
    for(var i = 0; i < size; ++i){
        var tmp = [
            0,
            0,
            0,
            0
        ];
        var idx = i / perInt | 0;
        var shft = (perInt - 1 - i % perInt) * bits;
        tmp[idx] = 1 << bits - 1 << shft;
        m[i] = this.generateSubHashTable(this.multiply(tmp, h), bits);
    }
    return m;
};
/**
 * Generates a table for multiplying against the hash subkey for one
 * particular component (out of all possible component values).
 *
 * @param mid the pre-multiplied value for the middle key of the table.
 * @param bits the bit size for a component.
 */ $ba49eab70e932126$var$modes.gcm.prototype.generateSubHashTable = function(mid, bits) {
    // compute the table quickly by minimizing the number of
    // POW operations -- they only need to be performed for powers of 2,
    // all other entries can be composed from those powers using XOR
    var size = 1 << bits;
    var half = size >>> 1;
    var m = new Array(size);
    m[half] = mid.slice(0);
    var i = half >>> 1;
    while(i > 0){
        // raise m0[2 * i] and store in m0[i]
        this.pow(m[2 * i], m[i] = []);
        i >>= 1;
    }
    i = 2;
    while(i < half){
        for(var j = 1; j < i; ++j){
            var m_i = m[i];
            var m_j = m[j];
            m[i + j] = [
                m_i[0] ^ m_j[0],
                m_i[1] ^ m_j[1],
                m_i[2] ^ m_j[2],
                m_i[3] ^ m_j[3]
            ];
        }
        i *= 2;
    }
    m[0] = [
        0,
        0,
        0,
        0
    ];
    /* Note: We could avoid storing these by doing composition during multiply
  calculate top half using composition by speed is preferred. */ for(i = half + 1; i < size; ++i){
        var c = m[i ^ half];
        m[i] = [
            mid[0] ^ c[0],
            mid[1] ^ c[1],
            mid[2] ^ c[2],
            mid[3] ^ c[3]
        ];
    }
    return m;
};
/** Utility functions */ function $ba49eab70e932126$var$transformIV(iv, blockSize) {
    if (typeof iv === 'string') // convert iv string into byte buffer
    iv = $cLQG7.util.createBuffer(iv);
    if ($cLQG7.util.isArray(iv) && iv.length > 4) {
        // convert iv byte array into byte buffer
        var tmp = iv;
        iv = $cLQG7.util.createBuffer();
        for(var i = 0; i < tmp.length; ++i)iv.putByte(tmp[i]);
    }
    if (iv.length() < blockSize) throw new Error('Invalid IV length; got ' + iv.length() + ' bytes and expected ' + blockSize + ' bytes.');
    if (!$cLQG7.util.isArray(iv)) {
        // convert iv byte buffer into 32-bit integer array
        var ints = [];
        var blocks = blockSize / 4;
        for(var i = 0; i < blocks; ++i)ints.push(iv.getInt32());
        iv = ints;
    }
    return iv;
}
function $ba49eab70e932126$var$inc32(block) {
    // increment last 32 bits of block only
    block[block.length - 1] = block[block.length - 1] + 1 & 0xFFFFFFFF;
}
function $ba49eab70e932126$var$from64To32(num) {
    // convert 64-bit number to two BE Int32s
    return [
        num / 0x100000000 | 0,
        num & 0xFFFFFFFF
    ];
}



/* AES API */ $d3ddbb4b069f5dc9$exports = $cLQG7.aes = $cLQG7.aes || {};
/**
 * Deprecated. Instead, use:
 *
 * var cipher = forge.cipher.createCipher('AES-<mode>', key);
 * cipher.start({iv: iv});
 *
 * Creates an AES cipher object to encrypt data using the given symmetric key.
 * The output will be stored in the 'output' member of the returned cipher.
 *
 * The key and iv may be given as a string of bytes, an array of bytes,
 * a byte buffer, or an array of 32-bit words.
 *
 * @param key the symmetric key to use.
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $cLQG7.aes.startEncrypting = function(key, iv, output, mode) {
    var cipher = $d3ddbb4b069f5dc9$var$_createCipher({
        key: key,
        output: output,
        decrypt: false,
        mode: mode
    });
    cipher.start(iv);
    return cipher;
};
/**
 * Deprecated. Instead, use:
 *
 * var cipher = forge.cipher.createCipher('AES-<mode>', key);
 *
 * Creates an AES cipher object to encrypt data using the given symmetric key.
 *
 * The key may be given as a string of bytes, an array of bytes, a
 * byte buffer, or an array of 32-bit words.
 *
 * @param key the symmetric key to use.
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $cLQG7.aes.createEncryptionCipher = function(key, mode) {
    return $d3ddbb4b069f5dc9$var$_createCipher({
        key: key,
        output: null,
        decrypt: false,
        mode: mode
    });
};
/**
 * Deprecated. Instead, use:
 *
 * var decipher = forge.cipher.createDecipher('AES-<mode>', key);
 * decipher.start({iv: iv});
 *
 * Creates an AES cipher object to decrypt data using the given symmetric key.
 * The output will be stored in the 'output' member of the returned cipher.
 *
 * The key and iv may be given as a string of bytes, an array of bytes,
 * a byte buffer, or an array of 32-bit words.
 *
 * @param key the symmetric key to use.
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $cLQG7.aes.startDecrypting = function(key, iv, output, mode) {
    var cipher = $d3ddbb4b069f5dc9$var$_createCipher({
        key: key,
        output: output,
        decrypt: true,
        mode: mode
    });
    cipher.start(iv);
    return cipher;
};
/**
 * Deprecated. Instead, use:
 *
 * var decipher = forge.cipher.createDecipher('AES-<mode>', key);
 *
 * Creates an AES cipher object to decrypt data using the given symmetric key.
 *
 * The key may be given as a string of bytes, an array of bytes, a
 * byte buffer, or an array of 32-bit words.
 *
 * @param key the symmetric key to use.
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $cLQG7.aes.createDecryptionCipher = function(key, mode) {
    return $d3ddbb4b069f5dc9$var$_createCipher({
        key: key,
        output: null,
        decrypt: true,
        mode: mode
    });
};
/**
 * Creates a new AES cipher algorithm object.
 *
 * @param name the name of the algorithm.
 * @param mode the mode factory function.
 *
 * @return the AES algorithm object.
 */ $cLQG7.aes.Algorithm = function(name, mode) {
    if (!$d3ddbb4b069f5dc9$var$init) $d3ddbb4b069f5dc9$var$initialize();
    var self = this;
    self.name = name;
    self.mode = new mode({
        blockSize: 16,
        cipher: {
            encrypt: function(inBlock, outBlock) {
                return $d3ddbb4b069f5dc9$var$_updateBlock(self._w, inBlock, outBlock, false);
            },
            decrypt: function(inBlock, outBlock) {
                return $d3ddbb4b069f5dc9$var$_updateBlock(self._w, inBlock, outBlock, true);
            }
        }
    });
    self._init = false;
};
/**
 * Initializes this AES algorithm by expanding its key.
 *
 * @param options the options to use.
 *          key the key to use with this algorithm.
 *          decrypt true if the algorithm should be initialized for decryption,
 *            false for encryption.
 */ $cLQG7.aes.Algorithm.prototype.initialize = function(options) {
    if (this._init) return;
    var key = options.key;
    var tmp;
    /* Note: The key may be a string of bytes, an array of bytes, a byte
    buffer, or an array of 32-bit integers. If the key is in bytes, then
    it must be 16, 24, or 32 bytes in length. If it is in 32-bit
    integers, it must be 4, 6, or 8 integers long. */ if (typeof key === 'string' && (key.length === 16 || key.length === 24 || key.length === 32)) // convert key string into byte buffer
    key = $cLQG7.util.createBuffer(key);
    else if ($cLQG7.util.isArray(key) && (key.length === 16 || key.length === 24 || key.length === 32)) {
        // convert key integer array into byte buffer
        tmp = key;
        key = $cLQG7.util.createBuffer();
        for(var i = 0; i < tmp.length; ++i)key.putByte(tmp[i]);
    }
    // convert key byte buffer into 32-bit integer array
    if (!$cLQG7.util.isArray(key)) {
        tmp = key;
        key = [];
        // key lengths of 16, 24, 32 bytes allowed
        var len = tmp.length();
        if (len === 16 || len === 24 || len === 32) {
            len = len >>> 2;
            for(var i = 0; i < len; ++i)key.push(tmp.getInt32());
        }
    }
    // key must be an array of 32-bit integers by now
    if (!$cLQG7.util.isArray(key) || !(key.length === 4 || key.length === 6 || key.length === 8)) throw new Error('Invalid key parameter.');
    // encryption operation is always used for these modes
    var mode = this.mode.name;
    var encryptOp = [
        'CFB',
        'OFB',
        'CTR',
        'GCM'
    ].indexOf(mode) !== -1;
    // do key expansion
    this._w = $d3ddbb4b069f5dc9$var$_expandKey(key, options.decrypt && !encryptOp);
    this._init = true;
};
/**
 * Expands a key. Typically only used for testing.
 *
 * @param key the symmetric key to expand, as an array of 32-bit words.
 * @param decrypt true to expand for decryption, false for encryption.
 *
 * @return the expanded key.
 */ $cLQG7.aes._expandKey = function(key, decrypt) {
    if (!$d3ddbb4b069f5dc9$var$init) $d3ddbb4b069f5dc9$var$initialize();
    return $d3ddbb4b069f5dc9$var$_expandKey(key, decrypt);
};
/**
 * Updates a single block. Typically only used for testing.
 *
 * @param w the expanded key to use.
 * @param input an array of block-size 32-bit words.
 * @param output an array of block-size 32-bit words.
 * @param decrypt true to decrypt, false to encrypt.
 */ $cLQG7.aes._updateBlock = $d3ddbb4b069f5dc9$var$_updateBlock;
/** Register AES algorithms **/ $d3ddbb4b069f5dc9$var$registerAlgorithm('AES-ECB', $cLQG7.cipher.modes.ecb);
$d3ddbb4b069f5dc9$var$registerAlgorithm('AES-CBC', $cLQG7.cipher.modes.cbc);
$d3ddbb4b069f5dc9$var$registerAlgorithm('AES-CFB', $cLQG7.cipher.modes.cfb);
$d3ddbb4b069f5dc9$var$registerAlgorithm('AES-OFB', $cLQG7.cipher.modes.ofb);
$d3ddbb4b069f5dc9$var$registerAlgorithm('AES-CTR', $cLQG7.cipher.modes.ctr);
$d3ddbb4b069f5dc9$var$registerAlgorithm('AES-GCM', $cLQG7.cipher.modes.gcm);
function $d3ddbb4b069f5dc9$var$registerAlgorithm(name, mode) {
    var factory = function() {
        return new $cLQG7.aes.Algorithm(name, mode);
    };
    $cLQG7.cipher.registerAlgorithm(name, factory);
}
/** AES implementation **/ var $d3ddbb4b069f5dc9$var$init = false; // not yet initialized
var $d3ddbb4b069f5dc9$var$Nb = 4; // number of words comprising the state (AES = 4)
var $d3ddbb4b069f5dc9$var$sbox; // non-linear substitution table used in key expansion
var $d3ddbb4b069f5dc9$var$isbox; // inversion of sbox
var $d3ddbb4b069f5dc9$var$rcon; // round constant word array
var $d3ddbb4b069f5dc9$var$mix; // mix-columns table
var $d3ddbb4b069f5dc9$var$imix; // inverse mix-columns table
/**
 * Performs initialization, ie: precomputes tables to optimize for speed.
 *
 * One way to understand how AES works is to imagine that 'addition' and
 * 'multiplication' are interfaces that require certain mathematical
 * properties to hold true (ie: they are associative) but they might have
 * different implementations and produce different kinds of results ...
 * provided that their mathematical properties remain true. AES defines
 * its own methods of addition and multiplication but keeps some important
 * properties the same, ie: associativity and distributivity. The
 * explanation below tries to shed some light on how AES defines addition
 * and multiplication of bytes and 32-bit words in order to perform its
 * encryption and decryption algorithms.
 *
 * The basics:
 *
 * The AES algorithm views bytes as binary representations of polynomials
 * that have either 1 or 0 as the coefficients. It defines the addition
 * or subtraction of two bytes as the XOR operation. It also defines the
 * multiplication of two bytes as a finite field referred to as GF(2^8)
 * (Note: 'GF' means "Galois Field" which is a field that contains a finite
 * number of elements so GF(2^8) has 256 elements).
 *
 * This means that any two bytes can be represented as binary polynomials;
 * when they multiplied together and modularly reduced by an irreducible
 * polynomial of the 8th degree, the results are the field GF(2^8). The
 * specific irreducible polynomial that AES uses in hexadecimal is 0x11b.
 * This multiplication is associative with 0x01 as the identity:
 *
 * (b * 0x01 = GF(b, 0x01) = b).
 *
 * The operation GF(b, 0x02) can be performed at the byte level by left
 * shifting b once and then XOR'ing it (to perform the modular reduction)
 * with 0x11b if b is >= 128. Repeated application of the multiplication
 * of 0x02 can be used to implement the multiplication of any two bytes.
 *
 * For instance, multiplying 0x57 and 0x13, denoted as GF(0x57, 0x13), can
 * be performed by factoring 0x13 into 0x01, 0x02, and 0x10. Then these
 * factors can each be multiplied by 0x57 and then added together. To do
 * the multiplication, values for 0x57 multiplied by each of these 3 factors
 * can be precomputed and stored in a table. To add them, the values from
 * the table are XOR'd together.
 *
 * AES also defines addition and multiplication of words, that is 4-byte
 * numbers represented as polynomials of 3 degrees where the coefficients
 * are the values of the bytes.
 *
 * The word [a0, a1, a2, a3] is a polynomial a3x^3 + a2x^2 + a1x + a0.
 *
 * Addition is performed by XOR'ing like powers of x. Multiplication
 * is performed in two steps, the first is an algebriac expansion as
 * you would do normally (where addition is XOR). But the result is
 * a polynomial larger than 3 degrees and thus it cannot fit in a word. So
 * next the result is modularly reduced by an AES-specific polynomial of
 * degree 4 which will always produce a polynomial of less than 4 degrees
 * such that it will fit in a word. In AES, this polynomial is x^4 + 1.
 *
 * The modular product of two polynomials 'a' and 'b' is thus:
 *
 * d(x) = d3x^3 + d2x^2 + d1x + d0
 * with
 * d0 = GF(a0, b0) ^ GF(a3, b1) ^ GF(a2, b2) ^ GF(a1, b3)
 * d1 = GF(a1, b0) ^ GF(a0, b1) ^ GF(a3, b2) ^ GF(a2, b3)
 * d2 = GF(a2, b0) ^ GF(a1, b1) ^ GF(a0, b2) ^ GF(a3, b3)
 * d3 = GF(a3, b0) ^ GF(a2, b1) ^ GF(a1, b2) ^ GF(a0, b3)
 *
 * As a matrix:
 *
 * [d0] = [a0 a3 a2 a1][b0]
 * [d1]   [a1 a0 a3 a2][b1]
 * [d2]   [a2 a1 a0 a3][b2]
 * [d3]   [a3 a2 a1 a0][b3]
 *
 * Special polynomials defined by AES (0x02 == {02}):
 * a(x)    = {03}x^3 + {01}x^2 + {01}x + {02}
 * a^-1(x) = {0b}x^3 + {0d}x^2 + {09}x + {0e}.
 *
 * These polynomials are used in the MixColumns() and InverseMixColumns()
 * operations, respectively, to cause each element in the state to affect
 * the output (referred to as diffusing).
 *
 * RotWord() uses: a0 = a1 = a2 = {00} and a3 = {01}, which is the
 * polynomial x3.
 *
 * The ShiftRows() method modifies the last 3 rows in the state (where
 * the state is 4 words with 4 bytes per word) by shifting bytes cyclically.
 * The 1st byte in the second row is moved to the end of the row. The 1st
 * and 2nd bytes in the third row are moved to the end of the row. The 1st,
 * 2nd, and 3rd bytes are moved in the fourth row.
 *
 * More details on how AES arithmetic works:
 *
 * In the polynomial representation of binary numbers, XOR performs addition
 * and subtraction and multiplication in GF(2^8) denoted as GF(a, b)
 * corresponds with the multiplication of polynomials modulo an irreducible
 * polynomial of degree 8. In other words, for AES, GF(a, b) will multiply
 * polynomial 'a' with polynomial 'b' and then do a modular reduction by
 * an AES-specific irreducible polynomial of degree 8.
 *
 * A polynomial is irreducible if its only divisors are one and itself. For
 * the AES algorithm, this irreducible polynomial is:
 *
 * m(x) = x^8 + x^4 + x^3 + x + 1,
 *
 * or {01}{1b} in hexadecimal notation, where each coefficient is a bit:
 * 100011011 = 283 = 0x11b.
 *
 * For example, GF(0x57, 0x83) = 0xc1 because
 *
 * 0x57 = 87  = 01010111 = x^6 + x^4 + x^2 + x + 1
 * 0x85 = 131 = 10000101 = x^7 + x + 1
 *
 * (x^6 + x^4 + x^2 + x + 1) * (x^7 + x + 1)
 * =  x^13 + x^11 + x^9 + x^8 + x^7 +
 *    x^7 + x^5 + x^3 + x^2 + x +
 *    x^6 + x^4 + x^2 + x + 1
 * =  x^13 + x^11 + x^9 + x^8 + x^6 + x^5 + x^4 + x^3 + 1 = y
 *    y modulo (x^8 + x^4 + x^3 + x + 1)
 * =  x^7 + x^6 + 1.
 *
 * The modular reduction by m(x) guarantees the result will be a binary
 * polynomial of less than degree 8, so that it can fit in a byte.
 *
 * The operation to multiply a binary polynomial b with x (the polynomial
 * x in binary representation is 00000010) is:
 *
 * b_7x^8 + b_6x^7 + b_5x^6 + b_4x^5 + b_3x^4 + b_2x^3 + b_1x^2 + b_0x^1
 *
 * To get GF(b, x) we must reduce that by m(x). If b_7 is 0 (that is the
 * most significant bit is 0 in b) then the result is already reduced. If
 * it is 1, then we can reduce it by subtracting m(x) via an XOR.
 *
 * It follows that multiplication by x (00000010 or 0x02) can be implemented
 * by performing a left shift followed by a conditional bitwise XOR with
 * 0x1b. This operation on bytes is denoted by xtime(). Multiplication by
 * higher powers of x can be implemented by repeated application of xtime().
 *
 * By adding intermediate results, multiplication by any constant can be
 * implemented. For instance:
 *
 * GF(0x57, 0x13) = 0xfe because:
 *
 * xtime(b) = (b & 128) ? (b << 1 ^ 0x11b) : (b << 1)
 *
 * Note: We XOR with 0x11b instead of 0x1b because in javascript our
 * datatype for b can be larger than 1 byte, so a left shift will not
 * automatically eliminate bits that overflow a byte ... by XOR'ing the
 * overflow bit with 1 (the extra one from 0x11b) we zero it out.
 *
 * GF(0x57, 0x02) = xtime(0x57) = 0xae
 * GF(0x57, 0x04) = xtime(0xae) = 0x47
 * GF(0x57, 0x08) = xtime(0x47) = 0x8e
 * GF(0x57, 0x10) = xtime(0x8e) = 0x07
 *
 * GF(0x57, 0x13) = GF(0x57, (0x01 ^ 0x02 ^ 0x10))
 *
 * And by the distributive property (since XOR is addition and GF() is
 * multiplication):
 *
 * = GF(0x57, 0x01) ^ GF(0x57, 0x02) ^ GF(0x57, 0x10)
 * = 0x57 ^ 0xae ^ 0x07
 * = 0xfe.
 */ function $d3ddbb4b069f5dc9$var$initialize() {
    $d3ddbb4b069f5dc9$var$init = true;
    /* Populate the Rcon table. These are the values given by
    [x^(i-1),{00},{00},{00}] where x^(i-1) are powers of x (and x = 0x02)
    in the field of GF(2^8), where i starts at 1.

    rcon[0] = [0x00, 0x00, 0x00, 0x00]
    rcon[1] = [0x01, 0x00, 0x00, 0x00] 2^(1-1) = 2^0 = 1
    rcon[2] = [0x02, 0x00, 0x00, 0x00] 2^(2-1) = 2^1 = 2
    ...
    rcon[9]  = [0x1B, 0x00, 0x00, 0x00] 2^(9-1)  = 2^8 = 0x1B
    rcon[10] = [0x36, 0x00, 0x00, 0x00] 2^(10-1) = 2^9 = 0x36

    We only store the first byte because it is the only one used.
  */ $d3ddbb4b069f5dc9$var$rcon = [
        0x00,
        0x01,
        0x02,
        0x04,
        0x08,
        0x10,
        0x20,
        0x40,
        0x80,
        0x1B,
        0x36
    ];
    // compute xtime table which maps i onto GF(i, 0x02)
    var xtime = new Array(256);
    for(var i = 0; i < 128; ++i){
        xtime[i] = i << 1;
        xtime[i + 128] = i + 128 << 1 ^ 0x11B;
    }
    // compute all other tables
    $d3ddbb4b069f5dc9$var$sbox = new Array(256);
    $d3ddbb4b069f5dc9$var$isbox = new Array(256);
    $d3ddbb4b069f5dc9$var$mix = new Array(4);
    $d3ddbb4b069f5dc9$var$imix = new Array(4);
    for(var i = 0; i < 4; ++i){
        $d3ddbb4b069f5dc9$var$mix[i] = new Array(256);
        $d3ddbb4b069f5dc9$var$imix[i] = new Array(256);
    }
    var e = 0, ei = 0, e2, e4, e8, sx, sx2, me, ime;
    for(var i = 0; i < 256; ++i){
        /* We need to generate the SubBytes() sbox and isbox tables so that
      we can perform byte substitutions. This requires us to traverse
      all of the elements in GF, find their multiplicative inverses,
      and apply to each the following affine transformation:

      bi' = bi ^ b(i + 4) mod 8 ^ b(i + 5) mod 8 ^ b(i + 6) mod 8 ^
            b(i + 7) mod 8 ^ ci
      for 0 <= i < 8, where bi is the ith bit of the byte, and ci is the
      ith bit of a byte c with the value {63} or {01100011}.

      It is possible to traverse every possible value in a Galois field
      using what is referred to as a 'generator'. There are many
      generators (128 out of 256): 3,5,6,9,11,82 to name a few. To fully
      traverse GF we iterate 255 times, multiplying by our generator
      each time.

      On each iteration we can determine the multiplicative inverse for
      the current element.

      Suppose there is an element in GF 'e'. For a given generator 'g',
      e = g^x. The multiplicative inverse of e is g^(255 - x). It turns
      out that if use the inverse of a generator as another generator
      it will produce all of the corresponding multiplicative inverses
      at the same time. For this reason, we choose 5 as our inverse
      generator because it only requires 2 multiplies and 1 add and its
      inverse, 82, requires relatively few operations as well.

      In order to apply the affine transformation, the multiplicative
      inverse 'ei' of 'e' can be repeatedly XOR'd (4 times) with a
      bit-cycling of 'ei'. To do this 'ei' is first stored in 's' and
      'x'. Then 's' is left shifted and the high bit of 's' is made the
      low bit. The resulting value is stored in 's'. Then 'x' is XOR'd
      with 's' and stored in 'x'. On each subsequent iteration the same
      operation is performed. When 4 iterations are complete, 'x' is
      XOR'd with 'c' (0x63) and the transformed value is stored in 'x'.
      For example:

      s = 01000001
      x = 01000001

      iteration 1: s = 10000010, x ^= s
      iteration 2: s = 00000101, x ^= s
      iteration 3: s = 00001010, x ^= s
      iteration 4: s = 00010100, x ^= s
      x ^= 0x63

      This can be done with a loop where s = (s << 1) | (s >> 7). However,
      it can also be done by using a single 16-bit (in this case 32-bit)
      number 'sx'. Since XOR is an associative operation, we can set 'sx'
      to 'ei' and then XOR it with 'sx' left-shifted 1,2,3, and 4 times.
      The most significant bits will flow into the high 8 bit positions
      and be correctly XOR'd with one another. All that remains will be
      to cycle the high 8 bits by XOR'ing them all with the lower 8 bits
      afterwards.

      At the same time we're populating sbox and isbox we can precompute
      the multiplication we'll need to do to do MixColumns() later.
    */ // apply affine transformation
        sx = ei ^ ei << 1 ^ ei << 2 ^ ei << 3 ^ ei << 4;
        sx = sx >> 8 ^ sx & 255 ^ 0x63;
        // update tables
        $d3ddbb4b069f5dc9$var$sbox[e] = sx;
        $d3ddbb4b069f5dc9$var$isbox[sx] = e;
        /* Mixing columns is done using matrix multiplication. The columns
      that are to be mixed are each a single word in the current state.
      The state has Nb columns (4 columns). Therefore each column is a
      4 byte word. So to mix the columns in a single column 'c' where
      its rows are r0, r1, r2, and r3, we use the following matrix
      multiplication:

      [2 3 1 1]*[r0,c]=[r'0,c]
      [1 2 3 1] [r1,c] [r'1,c]
      [1 1 2 3] [r2,c] [r'2,c]
      [3 1 1 2] [r3,c] [r'3,c]

      r0, r1, r2, and r3 are each 1 byte of one of the words in the
      state (a column). To do matrix multiplication for each mixed
      column c' we multiply the corresponding row from the left matrix
      with the corresponding column from the right matrix. In total, we
      get 4 equations:

      r0,c' = 2*r0,c + 3*r1,c + 1*r2,c + 1*r3,c
      r1,c' = 1*r0,c + 2*r1,c + 3*r2,c + 1*r3,c
      r2,c' = 1*r0,c + 1*r1,c + 2*r2,c + 3*r3,c
      r3,c' = 3*r0,c + 1*r1,c + 1*r2,c + 2*r3,c

      As usual, the multiplication is as previously defined and the
      addition is XOR. In order to optimize mixing columns we can store
      the multiplication results in tables. If you think of the whole
      column as a word (it might help to visualize by mentally rotating
      the equations above by counterclockwise 90 degrees) then you can
      see that it would be useful to map the multiplications performed on
      each byte (r0, r1, r2, r3) onto a word as well. For instance, we
      could map 2*r0,1*r0,1*r0,3*r0 onto a word by storing 2*r0 in the
      highest 8 bits and 3*r0 in the lowest 8 bits (with the other two
      respectively in the middle). This means that a table can be
      constructed that uses r0 as an index to the word. We can do the
      same with r1, r2, and r3, creating a total of 4 tables.

      To construct a full c', we can just look up each byte of c in
      their respective tables and XOR the results together.

      Also, to build each table we only have to calculate the word
      for 2,1,1,3 for every byte ... which we can do on each iteration
      of this loop since we will iterate over every byte. After we have
      calculated 2,1,1,3 we can get the results for the other tables
      by cycling the byte at the end to the beginning. For instance
      we can take the result of table 2,1,1,3 and produce table 3,2,1,1
      by moving the right most byte to the left most position just like
      how you can imagine the 3 moved out of 2,1,1,3 and to the front
      to produce 3,2,1,1.

      There is another optimization in that the same multiples of
      the current element we need in order to advance our generator
      to the next iteration can be reused in performing the 2,1,1,3
      calculation. We also calculate the inverse mix column tables,
      with e,9,d,b being the inverse of 2,1,1,3.

      When we're done, and we need to actually mix columns, the first
      byte of each state word should be put through mix[0] (2,1,1,3),
      the second through mix[1] (3,2,1,1) and so forth. Then they should
      be XOR'd together to produce the fully mixed column.
    */ // calculate mix and imix table values
        sx2 = xtime[sx];
        e2 = xtime[e];
        e4 = xtime[e2];
        e8 = xtime[e4];
        me = sx2 << 24 ^ // 2
        sx << 16 ^ // 1
        sx << 8 ^ // 1
        (sx ^ sx2); // 3
        ime = (e2 ^ e4 ^ e8) << 24 ^ // E (14)
        (e ^ e8) << 16 ^ // 9
        (e ^ e4 ^ e8) << 8 ^ // D (13)
        (e ^ e2 ^ e8); // B (11)
        // produce each of the mix tables by rotating the 2,1,1,3 value
        for(var n = 0; n < 4; ++n){
            $d3ddbb4b069f5dc9$var$mix[n][e] = me;
            $d3ddbb4b069f5dc9$var$imix[n][sx] = ime;
            // cycle the right most byte to the left most position
            // ie: 2,1,1,3 becomes 3,2,1,1
            me = me << 24 | me >>> 8;
            ime = ime << 24 | ime >>> 8;
        }
        // get next element and inverse
        if (e === 0) // 1 is the inverse of 1
        e = ei = 1;
        else {
            // e = 2e + 2*2*2*(10e)) = multiply e by 82 (chosen generator)
            // ei = ei + 2*2*ei = multiply ei by 5 (inverse generator)
            e = e2 ^ xtime[xtime[xtime[e2 ^ e8]]];
            ei ^= xtime[xtime[ei]];
        }
    }
}
/**
 * Generates a key schedule using the AES key expansion algorithm.
 *
 * The AES algorithm takes the Cipher Key, K, and performs a Key Expansion
 * routine to generate a key schedule. The Key Expansion generates a total
 * of Nb*(Nr + 1) words: the algorithm requires an initial set of Nb words,
 * and each of the Nr rounds requires Nb words of key data. The resulting
 * key schedule consists of a linear array of 4-byte words, denoted [wi ],
 * with i in the range 0 <= i < Nb(Nr + 1).
 *
 * KeyExpansion(byte key[4*Nk], word w[Nb*(Nr+1)], Nk)
 * AES-128 (Nb=4, Nk=4, Nr=10)
 * AES-192 (Nb=4, Nk=6, Nr=12)
 * AES-256 (Nb=4, Nk=8, Nr=14)
 * Note: Nr=Nk+6.
 *
 * Nb is the number of columns (32-bit words) comprising the State (or
 * number of bytes in a block). For AES, Nb=4.
 *
 * @param key the key to schedule (as an array of 32-bit words).
 * @param decrypt true to modify the key schedule to decrypt, false not to.
 *
 * @return the generated key schedule.
 */ function $d3ddbb4b069f5dc9$var$_expandKey(key, decrypt) {
    // copy the key's words to initialize the key schedule
    var w = key.slice(0);
    /* RotWord() will rotate a word, moving the first byte to the last
    byte's position (shifting the other bytes left).

    We will be getting the value of Rcon at i / Nk. 'i' will iterate
    from Nk to (Nb * Nr+1). Nk = 4 (4 byte key), Nb = 4 (4 words in
    a block), Nr = Nk + 6 (10). Therefore 'i' will iterate from
    4 to 44 (exclusive). Each time we iterate 4 times, i / Nk will
    increase by 1. We use a counter iNk to keep track of this.
   */ // go through the rounds expanding the key
    var temp, iNk = 1;
    var Nk = w.length;
    var Nr1 = Nk + 6 + 1;
    var end = $d3ddbb4b069f5dc9$var$Nb * Nr1;
    for(var i = Nk; i < end; ++i){
        temp = w[i - 1];
        if (i % Nk === 0) {
            // temp = SubWord(RotWord(temp)) ^ Rcon[i / Nk]
            temp = $d3ddbb4b069f5dc9$var$sbox[temp >>> 16 & 255] << 24 ^ $d3ddbb4b069f5dc9$var$sbox[temp >>> 8 & 255] << 16 ^ $d3ddbb4b069f5dc9$var$sbox[temp & 255] << 8 ^ $d3ddbb4b069f5dc9$var$sbox[temp >>> 24] ^ $d3ddbb4b069f5dc9$var$rcon[iNk] << 24;
            iNk++;
        } else if (Nk > 6 && i % Nk === 4) // temp = SubWord(temp)
        temp = $d3ddbb4b069f5dc9$var$sbox[temp >>> 24] << 24 ^ $d3ddbb4b069f5dc9$var$sbox[temp >>> 16 & 255] << 16 ^ $d3ddbb4b069f5dc9$var$sbox[temp >>> 8 & 255] << 8 ^ $d3ddbb4b069f5dc9$var$sbox[temp & 255];
        w[i] = w[i - Nk] ^ temp;
    }
    /* When we are updating a cipher block we always use the code path for
     encryption whether we are decrypting or not (to shorten code and
     simplify the generation of look up tables). However, because there
     are differences in the decryption algorithm, other than just swapping
     in different look up tables, we must transform our key schedule to
     account for these changes:

     1. The decryption algorithm gets its key rounds in reverse order.
     2. The decryption algorithm adds the round key before mixing columns
       instead of afterwards.

     We don't need to modify our key schedule to handle the first case,
     we can just traverse the key schedule in reverse order when decrypting.

     The second case requires a little work.

     The tables we built for performing rounds will take an input and then
     perform SubBytes() and MixColumns() or, for the decrypt version,
     InvSubBytes() and InvMixColumns(). But the decrypt algorithm requires
     us to AddRoundKey() before InvMixColumns(). This means we'll need to
     apply some transformations to the round key to inverse-mix its columns
     so they'll be correct for moving AddRoundKey() to after the state has
     had its columns inverse-mixed.

     To inverse-mix the columns of the state when we're decrypting we use a
     lookup table that will apply InvSubBytes() and InvMixColumns() at the
     same time. However, the round key's bytes are not inverse-substituted
     in the decryption algorithm. To get around this problem, we can first
     substitute the bytes in the round key so that when we apply the
     transformation via the InvSubBytes()+InvMixColumns() table, it will
     undo our substitution leaving us with the original value that we
     want -- and then inverse-mix that value.

     This change will correctly alter our key schedule so that we can XOR
     each round key with our already transformed decryption state. This
     allows us to use the same code path as the encryption algorithm.

     We make one more change to the decryption key. Since the decryption
     algorithm runs in reverse from the encryption algorithm, we reverse
     the order of the round keys to avoid having to iterate over the key
     schedule backwards when running the encryption algorithm later in
     decryption mode. In addition to reversing the order of the round keys,
     we also swap each round key's 2nd and 4th rows. See the comments
     section where rounds are performed for more details about why this is
     done. These changes are done inline with the other substitution
     described above.
  */ if (decrypt) {
        var tmp;
        var m0 = $d3ddbb4b069f5dc9$var$imix[0];
        var m1 = $d3ddbb4b069f5dc9$var$imix[1];
        var m2 = $d3ddbb4b069f5dc9$var$imix[2];
        var m3 = $d3ddbb4b069f5dc9$var$imix[3];
        var wnew = w.slice(0);
        end = w.length;
        for(var i = 0, wi = end - $d3ddbb4b069f5dc9$var$Nb; i < end; i += $d3ddbb4b069f5dc9$var$Nb, wi -= $d3ddbb4b069f5dc9$var$Nb){
            // do not sub the first or last round key (round keys are Nb
            // words) as no column mixing is performed before they are added,
            // but do change the key order
            if (i === 0 || i === end - $d3ddbb4b069f5dc9$var$Nb) {
                wnew[i] = w[wi];
                wnew[i + 1] = w[wi + 3];
                wnew[i + 2] = w[wi + 2];
                wnew[i + 3] = w[wi + 1];
            } else // substitute each round key byte because the inverse-mix
            // table will inverse-substitute it (effectively cancel the
            // substitution because round key bytes aren't sub'd in
            // decryption mode) and swap indexes 3 and 1
            for(var n = 0; n < $d3ddbb4b069f5dc9$var$Nb; ++n){
                tmp = w[wi + n];
                wnew[i + (3 & -n)] = m0[$d3ddbb4b069f5dc9$var$sbox[tmp >>> 24]] ^ m1[$d3ddbb4b069f5dc9$var$sbox[tmp >>> 16 & 255]] ^ m2[$d3ddbb4b069f5dc9$var$sbox[tmp >>> 8 & 255]] ^ m3[$d3ddbb4b069f5dc9$var$sbox[tmp & 255]];
            }
        }
        w = wnew;
    }
    return w;
}
/**
 * Updates a single block (16 bytes) using AES. The update will either
 * encrypt or decrypt the block.
 *
 * @param w the key schedule.
 * @param input the input block (an array of 32-bit words).
 * @param output the updated output block.
 * @param decrypt true to decrypt the block, false to encrypt it.
 */ function $d3ddbb4b069f5dc9$var$_updateBlock(w, input, output, decrypt) {
    /*
  Cipher(byte in[4*Nb], byte out[4*Nb], word w[Nb*(Nr+1)])
  begin
    byte state[4,Nb]
    state = in
    AddRoundKey(state, w[0, Nb-1])
    for round = 1 step 1 to Nr-1
      SubBytes(state)
      ShiftRows(state)
      MixColumns(state)
      AddRoundKey(state, w[round*Nb, (round+1)*Nb-1])
    end for
    SubBytes(state)
    ShiftRows(state)
    AddRoundKey(state, w[Nr*Nb, (Nr+1)*Nb-1])
    out = state
  end

  InvCipher(byte in[4*Nb], byte out[4*Nb], word w[Nb*(Nr+1)])
  begin
    byte state[4,Nb]
    state = in
    AddRoundKey(state, w[Nr*Nb, (Nr+1)*Nb-1])
    for round = Nr-1 step -1 downto 1
      InvShiftRows(state)
      InvSubBytes(state)
      AddRoundKey(state, w[round*Nb, (round+1)*Nb-1])
      InvMixColumns(state)
    end for
    InvShiftRows(state)
    InvSubBytes(state)
    AddRoundKey(state, w[0, Nb-1])
    out = state
  end
  */ // Encrypt: AddRoundKey(state, w[0, Nb-1])
    // Decrypt: AddRoundKey(state, w[Nr*Nb, (Nr+1)*Nb-1])
    var Nr = w.length / 4 - 1;
    var m0, m1, m2, m3, sub;
    if (decrypt) {
        m0 = $d3ddbb4b069f5dc9$var$imix[0];
        m1 = $d3ddbb4b069f5dc9$var$imix[1];
        m2 = $d3ddbb4b069f5dc9$var$imix[2];
        m3 = $d3ddbb4b069f5dc9$var$imix[3];
        sub = $d3ddbb4b069f5dc9$var$isbox;
    } else {
        m0 = $d3ddbb4b069f5dc9$var$mix[0];
        m1 = $d3ddbb4b069f5dc9$var$mix[1];
        m2 = $d3ddbb4b069f5dc9$var$mix[2];
        m3 = $d3ddbb4b069f5dc9$var$mix[3];
        sub = $d3ddbb4b069f5dc9$var$sbox;
    }
    var a, b, c, d, a2, b2, c2;
    a = input[0] ^ w[0];
    b = input[decrypt ? 3 : 1] ^ w[1];
    c = input[2] ^ w[2];
    d = input[decrypt ? 1 : 3] ^ w[3];
    var i = 3;
    /* In order to share code we follow the encryption algorithm when both
    encrypting and decrypting. To account for the changes required in the
    decryption algorithm, we use different lookup tables when decrypting
    and use a modified key schedule to account for the difference in the
    order of transformations applied when performing rounds. We also get
    key rounds in reverse order (relative to encryption). */ for(var round = 1; round < Nr; ++round){
        /* As described above, we'll be using table lookups to perform the
      column mixing. Each column is stored as a word in the state (the
      array 'input' has one column as a word at each index). In order to
      mix a column, we perform these transformations on each row in c,
      which is 1 byte in each word. The new column for c0 is c'0:

               m0      m1      m2      m3
      r0,c'0 = 2*r0,c0 + 3*r1,c0 + 1*r2,c0 + 1*r3,c0
      r1,c'0 = 1*r0,c0 + 2*r1,c0 + 3*r2,c0 + 1*r3,c0
      r2,c'0 = 1*r0,c0 + 1*r1,c0 + 2*r2,c0 + 3*r3,c0
      r3,c'0 = 3*r0,c0 + 1*r1,c0 + 1*r2,c0 + 2*r3,c0

      So using mix tables where c0 is a word with r0 being its upper
      8 bits and r3 being its lower 8 bits:

      m0[c0 >> 24] will yield this word: [2*r0,1*r0,1*r0,3*r0]
      ...
      m3[c0 & 255] will yield this word: [1*r3,1*r3,3*r3,2*r3]

      Therefore to mix the columns in each word in the state we
      do the following (& 255 omitted for brevity):
      c'0,r0 = m0[c0 >> 24] ^ m1[c1 >> 16] ^ m2[c2 >> 8] ^ m3[c3]
      c'0,r1 = m0[c0 >> 24] ^ m1[c1 >> 16] ^ m2[c2 >> 8] ^ m3[c3]
      c'0,r2 = m0[c0 >> 24] ^ m1[c1 >> 16] ^ m2[c2 >> 8] ^ m3[c3]
      c'0,r3 = m0[c0 >> 24] ^ m1[c1 >> 16] ^ m2[c2 >> 8] ^ m3[c3]

      However, before mixing, the algorithm requires us to perform
      ShiftRows(). The ShiftRows() transformation cyclically shifts the
      last 3 rows of the state over different offsets. The first row
      (r = 0) is not shifted.

      s'_r,c = s_r,(c + shift(r, Nb) mod Nb
      for 0 < r < 4 and 0 <= c < Nb and
      shift(1, 4) = 1
      shift(2, 4) = 2
      shift(3, 4) = 3.

      This causes the first byte in r = 1 to be moved to the end of
      the row, the first 2 bytes in r = 2 to be moved to the end of
      the row, the first 3 bytes in r = 3 to be moved to the end of
      the row:

      r1: [c0 c1 c2 c3] => [c1 c2 c3 c0]
      r2: [c0 c1 c2 c3]    [c2 c3 c0 c1]
      r3: [c0 c1 c2 c3]    [c3 c0 c1 c2]

      We can make these substitutions inline with our column mixing to
      generate an updated set of equations to produce each word in the
      state (note the columns have changed positions):

      c0 c1 c2 c3 => c0 c1 c2 c3
      c0 c1 c2 c3    c1 c2 c3 c0  (cycled 1 byte)
      c0 c1 c2 c3    c2 c3 c0 c1  (cycled 2 bytes)
      c0 c1 c2 c3    c3 c0 c1 c2  (cycled 3 bytes)

      Therefore:

      c'0 = 2*r0,c0 + 3*r1,c1 + 1*r2,c2 + 1*r3,c3
      c'0 = 1*r0,c0 + 2*r1,c1 + 3*r2,c2 + 1*r3,c3
      c'0 = 1*r0,c0 + 1*r1,c1 + 2*r2,c2 + 3*r3,c3
      c'0 = 3*r0,c0 + 1*r1,c1 + 1*r2,c2 + 2*r3,c3

      c'1 = 2*r0,c1 + 3*r1,c2 + 1*r2,c3 + 1*r3,c0
      c'1 = 1*r0,c1 + 2*r1,c2 + 3*r2,c3 + 1*r3,c0
      c'1 = 1*r0,c1 + 1*r1,c2 + 2*r2,c3 + 3*r3,c0
      c'1 = 3*r0,c1 + 1*r1,c2 + 1*r2,c3 + 2*r3,c0

      ... and so forth for c'2 and c'3. The important distinction is
      that the columns are cycling, with c0 being used with the m0
      map when calculating c0, but c1 being used with the m0 map when
      calculating c1 ... and so forth.

      When performing the inverse we transform the mirror image and
      skip the bottom row, instead of the top one, and move upwards:

      c3 c2 c1 c0 => c0 c3 c2 c1  (cycled 3 bytes) *same as encryption
      c3 c2 c1 c0    c1 c0 c3 c2  (cycled 2 bytes)
      c3 c2 c1 c0    c2 c1 c0 c3  (cycled 1 byte)  *same as encryption
      c3 c2 c1 c0    c3 c2 c1 c0

      If you compare the resulting matrices for ShiftRows()+MixColumns()
      and for InvShiftRows()+InvMixColumns() the 2nd and 4th columns are
      different (in encrypt mode vs. decrypt mode). So in order to use
      the same code to handle both encryption and decryption, we will
      need to do some mapping.

      If in encryption mode we let a=c0, b=c1, c=c2, d=c3, and r<N> be
      a row number in the state, then the resulting matrix in encryption
      mode for applying the above transformations would be:

      r1: a b c d
      r2: b c d a
      r3: c d a b
      r4: d a b c

      If we did the same in decryption mode we would get:

      r1: a d c b
      r2: b a d c
      r3: c b a d
      r4: d c b a

      If instead we swap d and b (set b=c3 and d=c1), then we get:

      r1: a b c d
      r2: d a b c
      r3: c d a b
      r4: b c d a

      Now the 1st and 3rd rows are the same as the encryption matrix. All
      we need to do then to make the mapping exactly the same is to swap
      the 2nd and 4th rows when in decryption mode. To do this without
      having to do it on each iteration, we swapped the 2nd and 4th rows
      in the decryption key schedule. We also have to do the swap above
      when we first pull in the input and when we set the final output. */ a2 = m0[a >>> 24] ^ m1[b >>> 16 & 255] ^ m2[c >>> 8 & 255] ^ m3[d & 255] ^ w[++i];
        b2 = m0[b >>> 24] ^ m1[c >>> 16 & 255] ^ m2[d >>> 8 & 255] ^ m3[a & 255] ^ w[++i];
        c2 = m0[c >>> 24] ^ m1[d >>> 16 & 255] ^ m2[a >>> 8 & 255] ^ m3[b & 255] ^ w[++i];
        d = m0[d >>> 24] ^ m1[a >>> 16 & 255] ^ m2[b >>> 8 & 255] ^ m3[c & 255] ^ w[++i];
        a = a2;
        b = b2;
        c = c2;
    }
    /*
    Encrypt:
    SubBytes(state)
    ShiftRows(state)
    AddRoundKey(state, w[Nr*Nb, (Nr+1)*Nb-1])

    Decrypt:
    InvShiftRows(state)
    InvSubBytes(state)
    AddRoundKey(state, w[0, Nb-1])
   */ // Note: rows are shifted inline
    output[0] = sub[a >>> 24] << 24 ^ sub[b >>> 16 & 255] << 16 ^ sub[c >>> 8 & 255] << 8 ^ sub[d & 255] ^ w[++i];
    output[decrypt ? 3 : 1] = sub[b >>> 24] << 24 ^ sub[c >>> 16 & 255] << 16 ^ sub[d >>> 8 & 255] << 8 ^ sub[a & 255] ^ w[++i];
    output[2] = sub[c >>> 24] << 24 ^ sub[d >>> 16 & 255] << 16 ^ sub[a >>> 8 & 255] << 8 ^ sub[b & 255] ^ w[++i];
    output[decrypt ? 1 : 3] = sub[d >>> 24] << 24 ^ sub[a >>> 16 & 255] << 16 ^ sub[b >>> 8 & 255] << 8 ^ sub[c & 255] ^ w[++i];
}
/**
 * Deprecated. Instead, use:
 *
 * forge.cipher.createCipher('AES-<mode>', key);
 * forge.cipher.createDecipher('AES-<mode>', key);
 *
 * Creates a deprecated AES cipher object. This object's mode will default to
 * CBC (cipher-block-chaining).
 *
 * The key and iv may be given as a string of bytes, an array of bytes, a
 * byte buffer, or an array of 32-bit words.
 *
 * @param options the options to use.
 *          key the symmetric key to use.
 *          output the buffer to write to.
 *          decrypt true for decryption, false for encryption.
 *          mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ function $d3ddbb4b069f5dc9$var$_createCipher(options) {
    options = options || {};
    var mode = (options.mode || 'CBC').toUpperCase();
    var algorithm = 'AES-' + mode;
    var cipher;
    if (options.decrypt) cipher = $cLQG7.cipher.createDecipher(algorithm, options.key);
    else cipher = $cLQG7.cipher.createCipher(algorithm, options.key);
    // backwards compatible start API
    var start = cipher.start;
    cipher.start = function(iv, options) {
        // backwards compatibility: support second arg as output buffer
        var output = null;
        if (options instanceof $cLQG7.util.ByteBuffer) {
            output = options;
            options = {};
        }
        options = options || {};
        options.output = output;
        options.iv = iv;
        start.call(cipher, options);
    };
    return cipher;
}


var $437b300329bdbf9c$exports = {};
/**
 * A Javascript implementation of AES Cipher Suites for TLS.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2009-2015 Digital Bazaar, Inc.
 *
 */ 
var $cLQG7 = parcelRequire("cLQG7");

var $087e807083257150$exports = {};
/**
 * A Javascript implementation of Transport Layer Security (TLS).
 *
 * @author Dave Longley
 *
 * Copyright (c) 2009-2014 Digital Bazaar, Inc.
 *
 * The TLS Handshake Protocol involves the following steps:
 *
 * - Exchange hello messages to agree on algorithms, exchange random values,
 * and check for session resumption.
 *
 * - Exchange the necessary cryptographic parameters to allow the client and
 * server to agree on a premaster secret.
 *
 * - Exchange certificates and cryptographic information to allow the client
 * and server to authenticate themselves.
 *
 * - Generate a master secret from the premaster secret and exchanged random
 * values.
 *
 * - Provide security parameters to the record layer.
 *
 * - Allow the client and server to verify that their peer has calculated the
 * same security parameters and that the handshake occurred without tampering
 * by an attacker.
 *
 * Up to 4 different messages may be sent during a key exchange. The server
 * certificate, the server key exchange, the client certificate, and the
 * client key exchange.
 *
 * A typical handshake (from the client's perspective).
 *
 * 1. Client sends ClientHello.
 * 2. Client receives ServerHello.
 * 3. Client receives optional Certificate.
 * 4. Client receives optional ServerKeyExchange.
 * 5. Client receives ServerHelloDone.
 * 6. Client sends optional Certificate.
 * 7. Client sends ClientKeyExchange.
 * 8. Client sends optional CertificateVerify.
 * 9. Client sends ChangeCipherSpec.
 * 10. Client sends Finished.
 * 11. Client receives ChangeCipherSpec.
 * 12. Client receives Finished.
 * 13. Client sends/receives application data.
 *
 * To reuse an existing session:
 *
 * 1. Client sends ClientHello with session ID for reuse.
 * 2. Client receives ServerHello with same session ID if reusing.
 * 3. Client receives ChangeCipherSpec message if reusing.
 * 4. Client receives Finished.
 * 5. Client sends ChangeCipherSpec.
 * 6. Client sends Finished.
 *
 * Note: Client ignores HelloRequest if in the middle of a handshake.
 *
 * Record Layer:
 *
 * The record layer fragments information blocks into TLSPlaintext records
 * carrying data in chunks of 2^14 bytes or less. Client message boundaries are
 * not preserved in the record layer (i.e., multiple client messages of the
 * same ContentType MAY be coalesced into a single TLSPlaintext record, or a
 * single message MAY be fragmented across several records).
 *
 * struct {
 *   uint8 major;
 *   uint8 minor;
 * } ProtocolVersion;
 *
 * struct {
 *   ContentType type;
 *   ProtocolVersion version;
 *   uint16 length;
 *   opaque fragment[TLSPlaintext.length];
 * } TLSPlaintext;
 *
 * type:
 *   The higher-level protocol used to process the enclosed fragment.
 *
 * version:
 *   The version of the protocol being employed. TLS Version 1.2 uses version
 *   {3, 3}. TLS Version 1.0 uses version {3, 1}. Note that a client that
 *   supports multiple versions of TLS may not know what version will be
 *   employed before it receives the ServerHello.
 *
 * length:
 *   The length (in bytes) of the following TLSPlaintext.fragment. The length
 *   MUST NOT exceed 2^14 = 16384 bytes.
 *
 * fragment:
 *   The application data. This data is transparent and treated as an
 *   independent block to be dealt with by the higher-level protocol specified
 *   by the type field.
 *
 * Implementations MUST NOT send zero-length fragments of Handshake, Alert, or
 * ChangeCipherSpec content types. Zero-length fragments of Application data
 * MAY be sent as they are potentially useful as a traffic analysis
 * countermeasure.
 *
 * Note: Data of different TLS record layer content types MAY be interleaved.
 * Application data is generally of lower precedence for transmission than
 * other content types. However, records MUST be delivered to the network in
 * the same order as they are protected by the record layer. Recipients MUST
 * receive and process interleaved application layer traffic during handshakes
 * subsequent to the first one on a connection.
 *
 * struct {
 *   ContentType type;       // same as TLSPlaintext.type
 *   ProtocolVersion version;// same as TLSPlaintext.version
 *   uint16 length;
 *   opaque fragment[TLSCompressed.length];
 * } TLSCompressed;
 *
 * length:
 *   The length (in bytes) of the following TLSCompressed.fragment.
 *   The length MUST NOT exceed 2^14 + 1024.
 *
 * fragment:
 *   The compressed form of TLSPlaintext.fragment.
 *
 * Note: A CompressionMethod.null operation is an identity operation; no fields
 * are altered. In this implementation, since no compression is supported,
 * uncompressed records are always the same as compressed records.
 *
 * Encryption Information:
 *
 * The encryption and MAC functions translate a TLSCompressed structure into a
 * TLSCiphertext. The decryption functions reverse the process. The MAC of the
 * record also includes a sequence number so that missing, extra, or repeated
 * messages are detectable.
 *
 * struct {
 *   ContentType type;
 *   ProtocolVersion version;
 *   uint16 length;
 *   select (SecurityParameters.cipher_type) {
 *     case stream: GenericStreamCipher;
 *     case block:  GenericBlockCipher;
 *     case aead:   GenericAEADCipher;
 *   } fragment;
 * } TLSCiphertext;
 *
 * type:
 *   The type field is identical to TLSCompressed.type.
 *
 * version:
 *   The version field is identical to TLSCompressed.version.
 *
 * length:
 *   The length (in bytes) of the following TLSCiphertext.fragment.
 *   The length MUST NOT exceed 2^14 + 2048.
 *
 * fragment:
 *   The encrypted form of TLSCompressed.fragment, with the MAC.
 *
 * Note: Only CBC Block Ciphers are supported by this implementation.
 *
 * The TLSCompressed.fragment structures are converted to/from block
 * TLSCiphertext.fragment structures.
 *
 * struct {
 *   opaque IV[SecurityParameters.record_iv_length];
 *   block-ciphered struct {
 *     opaque content[TLSCompressed.length];
 *     opaque MAC[SecurityParameters.mac_length];
 *     uint8 padding[GenericBlockCipher.padding_length];
 *     uint8 padding_length;
 *   };
 * } GenericBlockCipher;
 *
 * The MAC is generated as described in Section 6.2.3.1.
 *
 * IV:
 *   The Initialization Vector (IV) SHOULD be chosen at random, and MUST be
 *   unpredictable. Note that in versions of TLS prior to 1.1, there was no
 *   IV field, and the last ciphertext block of the previous record (the "CBC
 *   residue") was used as the IV. This was changed to prevent the attacks
 *   described in [CBCATT]. For block ciphers, the IV length is of length
 *   SecurityParameters.record_iv_length, which is equal to the
 *   SecurityParameters.block_size.
 *
 * padding:
 *   Padding that is added to force the length of the plaintext to be an
 *   integral multiple of the block cipher's block length. The padding MAY be
 *   any length up to 255 bytes, as long as it results in the
 *   TLSCiphertext.length being an integral multiple of the block length.
 *   Lengths longer than necessary might be desirable to frustrate attacks on
 *   a protocol that are based on analysis of the lengths of exchanged
 *   messages. Each uint8 in the padding data vector MUST be filled with the
 *   padding length value. The receiver MUST check this padding and MUST use
 *   the bad_record_mac alert to indicate padding errors.
 *
 * padding_length:
 *   The padding length MUST be such that the total size of the
 *   GenericBlockCipher structure is a multiple of the cipher's block length.
 *   Legal values range from zero to 255, inclusive. This length specifies the
 *   length of the padding field exclusive of the padding_length field itself.
 *
 * The encrypted data length (TLSCiphertext.length) is one more than the sum of
 * SecurityParameters.block_length, TLSCompressed.length,
 * SecurityParameters.mac_length, and padding_length.
 *
 * Example: If the block length is 8 bytes, the content length
 * (TLSCompressed.length) is 61 bytes, and the MAC length is 20 bytes, then the
 * length before padding is 82 bytes (this does not include the IV. Thus, the
 * padding length modulo 8 must be equal to 6 in order to make the total length
 * an even multiple of 8 bytes (the block length). The padding length can be
 * 6, 14, 22, and so on, through 254. If the padding length were the minimum
 * necessary, 6, the padding would be 6 bytes, each containing the value 6.
 * Thus, the last 8 octets of the GenericBlockCipher before block encryption
 * would be xx 06 06 06 06 06 06 06, where xx is the last octet of the MAC.
 *
 * Note: With block ciphers in CBC mode (Cipher Block Chaining), it is critical
 * that the entire plaintext of the record be known before any ciphertext is
 * transmitted. Otherwise, it is possible for the attacker to mount the attack
 * described in [CBCATT].
 *
 * Implementation note: Canvel et al. [CBCTIME] have demonstrated a timing
 * attack on CBC padding based on the time required to compute the MAC. In
 * order to defend against this attack, implementations MUST ensure that
 * record processing time is essentially the same whether or not the padding
 * is correct. In general, the best way to do this is to compute the MAC even
 * if the padding is incorrect, and only then reject the packet. For instance,
 * if the pad appears to be incorrect, the implementation might assume a
 * zero-length pad and then compute the MAC. This leaves a small timing
 * channel, since MAC performance depends, to some extent, on the size of the
 * data fragment, but it is not believed to be large enough to be exploitable,
 * due to the large block size of existing MACs and the small size of the
 * timing signal.
 */ 
var $cLQG7 = parcelRequire("cLQG7");
var $d72beefffe7b6a51$exports = {};
/**
 * Javascript implementation of Abstract Syntax Notation Number One.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2015 Digital Bazaar, Inc.
 *
 * An API for storing data using the Abstract Syntax Notation Number One
 * format using DER (Distinguished Encoding Rules) encoding. This encoding is
 * commonly used to store data for PKI, i.e. X.509 Certificates, and this
 * implementation exists for that purpose.
 *
 * Abstract Syntax Notation Number One (ASN.1) is used to define the abstract
 * syntax of information without restricting the way the information is encoded
 * for transmission. It provides a standard that allows for open systems
 * communication. ASN.1 defines the syntax of information data and a number of
 * simple data types as well as a notation for describing them and specifying
 * values for them.
 *
 * The RSA algorithm creates public and private keys that are often stored in
 * X.509 or PKCS#X formats -- which use ASN.1 (encoded in DER format). This
 * class provides the most basic functionality required to store and load DSA
 * keys that are encoded according to ASN.1.
 *
 * The most common binary encodings for ASN.1 are BER (Basic Encoding Rules)
 * and DER (Distinguished Encoding Rules). DER is just a subset of BER that
 * has stricter requirements for how data must be encoded.
 *
 * Each ASN.1 structure has a tag (a byte identifying the ASN.1 structure type)
 * and a byte array for the value of this ASN1 structure which may be data or a
 * list of ASN.1 structures.
 *
 * Each ASN.1 structure using BER is (Tag-Length-Value):
 *
 * | byte 0 | bytes X | bytes Y |
 * |--------|---------|----------
 * |  tag   | length  |  value  |
 *
 * ASN.1 allows for tags to be of "High-tag-number form" which allows a tag to
 * be two or more octets, but that is not supported by this class. A tag is
 * only 1 byte. Bits 1-5 give the tag number (ie the data type within a
 * particular 'class'), 6 indicates whether or not the ASN.1 value is
 * constructed from other ASN.1 values, and bits 7 and 8 give the 'class'. If
 * bits 7 and 8 are both zero, the class is UNIVERSAL. If only bit 7 is set,
 * then the class is APPLICATION. If only bit 8 is set, then the class is
 * CONTEXT_SPECIFIC. If both bits 7 and 8 are set, then the class is PRIVATE.
 * The tag numbers for the data types for the class UNIVERSAL are listed below:
 *
 * UNIVERSAL 0 Reserved for use by the encoding rules
 * UNIVERSAL 1 Boolean type
 * UNIVERSAL 2 Integer type
 * UNIVERSAL 3 Bitstring type
 * UNIVERSAL 4 Octetstring type
 * UNIVERSAL 5 Null type
 * UNIVERSAL 6 Object identifier type
 * UNIVERSAL 7 Object descriptor type
 * UNIVERSAL 8 External type and Instance-of type
 * UNIVERSAL 9 Real type
 * UNIVERSAL 10 Enumerated type
 * UNIVERSAL 11 Embedded-pdv type
 * UNIVERSAL 12 UTF8String type
 * UNIVERSAL 13 Relative object identifier type
 * UNIVERSAL 14-15 Reserved for future editions
 * UNIVERSAL 16 Sequence and Sequence-of types
 * UNIVERSAL 17 Set and Set-of types
 * UNIVERSAL 18-22, 25-30 Character string types
 * UNIVERSAL 23-24 Time types
 *
 * The length of an ASN.1 structure is specified after the tag identifier.
 * There is a definite form and an indefinite form. The indefinite form may
 * be used if the encoding is constructed and not all immediately available.
 * The indefinite form is encoded using a length byte with only the 8th bit
 * set. The end of the constructed object is marked using end-of-contents
 * octets (two zero bytes).
 *
 * The definite form looks like this:
 *
 * The length may take up 1 or more bytes, it depends on the length of the
 * value of the ASN.1 structure. DER encoding requires that if the ASN.1
 * structure has a value that has a length greater than 127, more than 1 byte
 * will be used to store its length, otherwise just one byte will be used.
 * This is strict.
 *
 * In the case that the length of the ASN.1 value is less than 127, 1 octet
 * (byte) is used to store the "short form" length. The 8th bit has a value of
 * 0 indicating the length is "short form" and not "long form" and bits 7-1
 * give the length of the data. (The 8th bit is the left-most, most significant
 * bit: also known as big endian or network format).
 *
 * In the case that the length of the ASN.1 value is greater than 127, 2 to
 * 127 octets (bytes) are used to store the "long form" length. The first
 * byte's 8th bit is set to 1 to indicate the length is "long form." Bits 7-1
 * give the number of additional octets. All following octets are in base 256
 * with the most significant digit first (typical big-endian binary unsigned
 * integer storage). So, for instance, if the length of a value was 257, the
 * first byte would be set to:
 *
 * 10000010 = 130 = 0x82.
 *
 * This indicates there are 2 octets (base 256) for the length. The second and
 * third bytes (the octets just mentioned) would store the length in base 256:
 *
 * octet 2: 00000001 = 1 * 256^1 = 256
 * octet 3: 00000001 = 1 * 256^0 = 1
 * total = 257
 *
 * The algorithm for converting a js integer value of 257 to base-256 is:
 *
 * var value = 257;
 * var bytes = [];
 * bytes[0] = (value >>> 8) & 0xFF; // most significant byte first
 * bytes[1] = value & 0xFF;        // least significant byte last
 *
 * On the ASN.1 UNIVERSAL Object Identifier (OID) type:
 *
 * An OID can be written like: "value1.value2.value3...valueN"
 *
 * The DER encoding rules:
 *
 * The first byte has the value 40 * value1 + value2.
 * The following bytes, if any, encode the remaining values. Each value is
 * encoded in base 128, most significant digit first (big endian), with as
 * few digits as possible, and the most significant bit of each byte set
 * to 1 except the last in each value's encoding. For example: Given the
 * OID "1.2.840.113549", its DER encoding is (remember each byte except the
 * last one in each encoding is OR'd with 0x80):
 *
 * byte 1: 40 * 1 + 2 = 42 = 0x2A.
 * bytes 2-3: 128 * 6 + 72 = 840 = 6 72 = 6 72 = 0x0648 = 0x8648
 * bytes 4-6: 16384 * 6 + 128 * 119 + 13 = 6 119 13 = 0x06770D = 0x86F70D
 *
 * The final value is: 0x2A864886F70D.
 * The full OID (including ASN.1 tag and length of 6 bytes) is:
 * 0x06062A864886F70D
 */ 
var $cLQG7 = parcelRequire("cLQG7");

var $34c808d2181f1715$exports = {};
/**
 * Object IDs for ASN.1.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2013 Digital Bazaar, Inc.
 */ 
var $cLQG7 = parcelRequire("cLQG7");
$cLQG7.pki = $cLQG7.pki || {};
var $34c808d2181f1715$var$oids = $34c808d2181f1715$exports = $cLQG7.pki.oids = $cLQG7.oids = $cLQG7.oids || {};
// set id to name mapping and name to id mapping
function $34c808d2181f1715$var$_IN(id, name) {
    $34c808d2181f1715$var$oids[id] = name;
    $34c808d2181f1715$var$oids[name] = id;
}
// set id to name mapping only
function $34c808d2181f1715$var$_I_(id, name) {
    $34c808d2181f1715$var$oids[id] = name;
}
// algorithm OIDs
$34c808d2181f1715$var$_IN('1.2.840.113549.1.1.1', 'rsaEncryption');
// Note: md2 & md4 not implemented
//_IN('1.2.840.113549.1.1.2', 'md2WithRSAEncryption');
//_IN('1.2.840.113549.1.1.3', 'md4WithRSAEncryption');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.1.4', 'md5WithRSAEncryption');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.1.5', 'sha1WithRSAEncryption');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.1.7', 'RSAES-OAEP');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.1.8', 'mgf1');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.1.9', 'pSpecified');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.1.10', 'RSASSA-PSS');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.1.11', 'sha256WithRSAEncryption');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.1.12', 'sha384WithRSAEncryption');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.1.13', 'sha512WithRSAEncryption');
// Edwards-curve Digital Signature Algorithm (EdDSA) Ed25519
$34c808d2181f1715$var$_IN('1.3.101.112', 'EdDSA25519');
$34c808d2181f1715$var$_IN('1.2.840.10040.4.3', 'dsa-with-sha1');
$34c808d2181f1715$var$_IN('1.3.14.3.2.7', 'desCBC');
$34c808d2181f1715$var$_IN('1.3.14.3.2.26', 'sha1');
// Deprecated equivalent of sha1WithRSAEncryption
$34c808d2181f1715$var$_IN('1.3.14.3.2.29', 'sha1WithRSASignature');
$34c808d2181f1715$var$_IN('2.16.840.1.101.3.4.2.1', 'sha256');
$34c808d2181f1715$var$_IN('2.16.840.1.101.3.4.2.2', 'sha384');
$34c808d2181f1715$var$_IN('2.16.840.1.101.3.4.2.3', 'sha512');
$34c808d2181f1715$var$_IN('2.16.840.1.101.3.4.2.4', 'sha224');
$34c808d2181f1715$var$_IN('2.16.840.1.101.3.4.2.5', 'sha512-224');
$34c808d2181f1715$var$_IN('2.16.840.1.101.3.4.2.6', 'sha512-256');
$34c808d2181f1715$var$_IN('1.2.840.113549.2.2', 'md2');
$34c808d2181f1715$var$_IN('1.2.840.113549.2.5', 'md5');
// pkcs#7 content types
$34c808d2181f1715$var$_IN('1.2.840.113549.1.7.1', 'data');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.7.2', 'signedData');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.7.3', 'envelopedData');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.7.4', 'signedAndEnvelopedData');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.7.5', 'digestedData');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.7.6', 'encryptedData');
// pkcs#9 oids
$34c808d2181f1715$var$_IN('1.2.840.113549.1.9.1', 'emailAddress');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.9.2', 'unstructuredName');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.9.3', 'contentType');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.9.4', 'messageDigest');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.9.5', 'signingTime');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.9.6', 'counterSignature');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.9.7', 'challengePassword');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.9.8', 'unstructuredAddress');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.9.14', 'extensionRequest');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.9.20', 'friendlyName');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.9.21', 'localKeyId');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.9.22.1', 'x509Certificate');
// pkcs#12 safe bags
$34c808d2181f1715$var$_IN('1.2.840.113549.1.12.10.1.1', 'keyBag');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.12.10.1.2', 'pkcs8ShroudedKeyBag');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.12.10.1.3', 'certBag');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.12.10.1.4', 'crlBag');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.12.10.1.5', 'secretBag');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.12.10.1.6', 'safeContentsBag');
// password-based-encryption for pkcs#12
$34c808d2181f1715$var$_IN('1.2.840.113549.1.5.13', 'pkcs5PBES2');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.5.12', 'pkcs5PBKDF2');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.12.1.1', 'pbeWithSHAAnd128BitRC4');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.12.1.2', 'pbeWithSHAAnd40BitRC4');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.12.1.3', 'pbeWithSHAAnd3-KeyTripleDES-CBC');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.12.1.4', 'pbeWithSHAAnd2-KeyTripleDES-CBC');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.12.1.5', 'pbeWithSHAAnd128BitRC2-CBC');
$34c808d2181f1715$var$_IN('1.2.840.113549.1.12.1.6', 'pbewithSHAAnd40BitRC2-CBC');
// hmac OIDs
$34c808d2181f1715$var$_IN('1.2.840.113549.2.7', 'hmacWithSHA1');
$34c808d2181f1715$var$_IN('1.2.840.113549.2.8', 'hmacWithSHA224');
$34c808d2181f1715$var$_IN('1.2.840.113549.2.9', 'hmacWithSHA256');
$34c808d2181f1715$var$_IN('1.2.840.113549.2.10', 'hmacWithSHA384');
$34c808d2181f1715$var$_IN('1.2.840.113549.2.11', 'hmacWithSHA512');
// symmetric key algorithm oids
$34c808d2181f1715$var$_IN('1.2.840.113549.3.7', 'des-EDE3-CBC');
$34c808d2181f1715$var$_IN('2.16.840.1.101.3.4.1.2', 'aes128-CBC');
$34c808d2181f1715$var$_IN('2.16.840.1.101.3.4.1.22', 'aes192-CBC');
$34c808d2181f1715$var$_IN('2.16.840.1.101.3.4.1.42', 'aes256-CBC');
// certificate issuer/subject OIDs
$34c808d2181f1715$var$_IN('2.5.4.3', 'commonName');
$34c808d2181f1715$var$_IN('2.5.4.4', 'surname');
$34c808d2181f1715$var$_IN('2.5.4.5', 'serialNumber');
$34c808d2181f1715$var$_IN('2.5.4.6', 'countryName');
$34c808d2181f1715$var$_IN('2.5.4.7', 'localityName');
$34c808d2181f1715$var$_IN('2.5.4.8', 'stateOrProvinceName');
$34c808d2181f1715$var$_IN('2.5.4.9', 'streetAddress');
$34c808d2181f1715$var$_IN('2.5.4.10', 'organizationName');
$34c808d2181f1715$var$_IN('2.5.4.11', 'organizationalUnitName');
$34c808d2181f1715$var$_IN('2.5.4.12', 'title');
$34c808d2181f1715$var$_IN('2.5.4.13', 'description');
$34c808d2181f1715$var$_IN('2.5.4.15', 'businessCategory');
$34c808d2181f1715$var$_IN('2.5.4.17', 'postalCode');
$34c808d2181f1715$var$_IN('2.5.4.42', 'givenName');
$34c808d2181f1715$var$_IN('1.3.6.1.4.1.311.60.2.1.2', 'jurisdictionOfIncorporationStateOrProvinceName');
$34c808d2181f1715$var$_IN('1.3.6.1.4.1.311.60.2.1.3', 'jurisdictionOfIncorporationCountryName');
// X.509 extension OIDs
$34c808d2181f1715$var$_IN('2.16.840.1.113730.1.1', 'nsCertType');
$34c808d2181f1715$var$_IN('2.16.840.1.113730.1.13', 'nsComment'); // deprecated in theory; still widely used
$34c808d2181f1715$var$_I_('2.5.29.1', 'authorityKeyIdentifier'); // deprecated, use .35
$34c808d2181f1715$var$_I_('2.5.29.2', 'keyAttributes'); // obsolete use .37 or .15
$34c808d2181f1715$var$_I_('2.5.29.3', 'certificatePolicies'); // deprecated, use .32
$34c808d2181f1715$var$_I_('2.5.29.4', 'keyUsageRestriction'); // obsolete use .37 or .15
$34c808d2181f1715$var$_I_('2.5.29.5', 'policyMapping'); // deprecated use .33
$34c808d2181f1715$var$_I_('2.5.29.6', 'subtreesConstraint'); // obsolete use .30
$34c808d2181f1715$var$_I_('2.5.29.7', 'subjectAltName'); // deprecated use .17
$34c808d2181f1715$var$_I_('2.5.29.8', 'issuerAltName'); // deprecated use .18
$34c808d2181f1715$var$_I_('2.5.29.9', 'subjectDirectoryAttributes');
$34c808d2181f1715$var$_I_('2.5.29.10', 'basicConstraints'); // deprecated use .19
$34c808d2181f1715$var$_I_('2.5.29.11', 'nameConstraints'); // deprecated use .30
$34c808d2181f1715$var$_I_('2.5.29.12', 'policyConstraints'); // deprecated use .36
$34c808d2181f1715$var$_I_('2.5.29.13', 'basicConstraints'); // deprecated use .19
$34c808d2181f1715$var$_IN('2.5.29.14', 'subjectKeyIdentifier');
$34c808d2181f1715$var$_IN('2.5.29.15', 'keyUsage');
$34c808d2181f1715$var$_I_('2.5.29.16', 'privateKeyUsagePeriod');
$34c808d2181f1715$var$_IN('2.5.29.17', 'subjectAltName');
$34c808d2181f1715$var$_IN('2.5.29.18', 'issuerAltName');
$34c808d2181f1715$var$_IN('2.5.29.19', 'basicConstraints');
$34c808d2181f1715$var$_I_('2.5.29.20', 'cRLNumber');
$34c808d2181f1715$var$_I_('2.5.29.21', 'cRLReason');
$34c808d2181f1715$var$_I_('2.5.29.22', 'expirationDate');
$34c808d2181f1715$var$_I_('2.5.29.23', 'instructionCode');
$34c808d2181f1715$var$_I_('2.5.29.24', 'invalidityDate');
$34c808d2181f1715$var$_I_('2.5.29.25', 'cRLDistributionPoints'); // deprecated use .31
$34c808d2181f1715$var$_I_('2.5.29.26', 'issuingDistributionPoint'); // deprecated use .28
$34c808d2181f1715$var$_I_('2.5.29.27', 'deltaCRLIndicator');
$34c808d2181f1715$var$_I_('2.5.29.28', 'issuingDistributionPoint');
$34c808d2181f1715$var$_I_('2.5.29.29', 'certificateIssuer');
$34c808d2181f1715$var$_I_('2.5.29.30', 'nameConstraints');
$34c808d2181f1715$var$_IN('2.5.29.31', 'cRLDistributionPoints');
$34c808d2181f1715$var$_IN('2.5.29.32', 'certificatePolicies');
$34c808d2181f1715$var$_I_('2.5.29.33', 'policyMappings');
$34c808d2181f1715$var$_I_('2.5.29.34', 'policyConstraints'); // deprecated use .36
$34c808d2181f1715$var$_IN('2.5.29.35', 'authorityKeyIdentifier');
$34c808d2181f1715$var$_I_('2.5.29.36', 'policyConstraints');
$34c808d2181f1715$var$_IN('2.5.29.37', 'extKeyUsage');
$34c808d2181f1715$var$_I_('2.5.29.46', 'freshestCRL');
$34c808d2181f1715$var$_I_('2.5.29.54', 'inhibitAnyPolicy');
// extKeyUsage purposes
$34c808d2181f1715$var$_IN('1.3.6.1.4.1.11129.2.4.2', 'timestampList');
$34c808d2181f1715$var$_IN('1.3.6.1.5.5.7.1.1', 'authorityInfoAccess');
$34c808d2181f1715$var$_IN('1.3.6.1.5.5.7.3.1', 'serverAuth');
$34c808d2181f1715$var$_IN('1.3.6.1.5.5.7.3.2', 'clientAuth');
$34c808d2181f1715$var$_IN('1.3.6.1.5.5.7.3.3', 'codeSigning');
$34c808d2181f1715$var$_IN('1.3.6.1.5.5.7.3.4', 'emailProtection');
$34c808d2181f1715$var$_IN('1.3.6.1.5.5.7.3.8', 'timeStamping');


/* ASN.1 API */ var $d72beefffe7b6a51$var$asn1 = $d72beefffe7b6a51$exports = $cLQG7.asn1 = $cLQG7.asn1 || {};
/**
 * ASN.1 classes.
 */ $d72beefffe7b6a51$var$asn1.Class = {
    UNIVERSAL: 0x00,
    APPLICATION: 0x40,
    CONTEXT_SPECIFIC: 0x80,
    PRIVATE: 0xC0
};
/**
 * ASN.1 types. Not all types are supported by this implementation, only
 * those necessary to implement a simple PKI are implemented.
 */ $d72beefffe7b6a51$var$asn1.Type = {
    NONE: 0,
    BOOLEAN: 1,
    INTEGER: 2,
    BITSTRING: 3,
    OCTETSTRING: 4,
    NULL: 5,
    OID: 6,
    ODESC: 7,
    EXTERNAL: 8,
    REAL: 9,
    ENUMERATED: 10,
    EMBEDDED: 11,
    UTF8: 12,
    ROID: 13,
    SEQUENCE: 16,
    SET: 17,
    PRINTABLESTRING: 19,
    IA5STRING: 22,
    UTCTIME: 23,
    GENERALIZEDTIME: 24,
    BMPSTRING: 30
};
/**
 * Creates a new asn1 object.
 *
 * @param tagClass the tag class for the object.
 * @param type the data type (tag number) for the object.
 * @param constructed true if the asn1 object is in constructed form.
 * @param value the value for the object, if it is not constructed.
 * @param [options] the options to use:
 *          [bitStringContents] the plain BIT STRING content including padding
 *            byte.
 *
 * @return the asn1 object.
 */ $d72beefffe7b6a51$var$asn1.create = function(tagClass, type, constructed, value, options) {
    /* An asn1 object has a tagClass, a type, a constructed flag, and a
    value. The value's type depends on the constructed flag. If
    constructed, it will contain a list of other asn1 objects. If not,
    it will contain the ASN.1 value as an array of bytes formatted
    according to the ASN.1 data type. */ // remove undefined values
    if ($cLQG7.util.isArray(value)) {
        var tmp = [];
        for(var i = 0; i < value.length; ++i)if (value[i] !== undefined) tmp.push(value[i]);
        value = tmp;
    }
    var obj = {
        tagClass: tagClass,
        type: type,
        constructed: constructed,
        composed: constructed || $cLQG7.util.isArray(value),
        value: value
    };
    if (options && 'bitStringContents' in options) {
        // TODO: copy byte buffer if it's a buffer not a string
        obj.bitStringContents = options.bitStringContents;
        // TODO: add readonly flag to avoid this overhead
        // save copy to detect changes
        obj.original = $d72beefffe7b6a51$var$asn1.copy(obj);
    }
    return obj;
};
/**
 * Copies an asn1 object.
 *
 * @param obj the asn1 object.
 * @param [options] copy options:
 *          [excludeBitStringContents] true to not copy bitStringContents
 *
 * @return the a copy of the asn1 object.
 */ $d72beefffe7b6a51$var$asn1.copy = function(obj, options) {
    var copy;
    if ($cLQG7.util.isArray(obj)) {
        copy = [];
        for(var i = 0; i < obj.length; ++i)copy.push($d72beefffe7b6a51$var$asn1.copy(obj[i], options));
        return copy;
    }
    if (typeof obj === 'string') // TODO: copy byte buffer if it's a buffer not a string
    return obj;
    copy = {
        tagClass: obj.tagClass,
        type: obj.type,
        constructed: obj.constructed,
        composed: obj.composed,
        value: $d72beefffe7b6a51$var$asn1.copy(obj.value, options)
    };
    if (options && !options.excludeBitStringContents) // TODO: copy byte buffer if it's a buffer not a string
    copy.bitStringContents = obj.bitStringContents;
    return copy;
};
/**
 * Compares asn1 objects for equality.
 *
 * Note this function does not run in constant time.
 *
 * @param obj1 the first asn1 object.
 * @param obj2 the second asn1 object.
 * @param [options] compare options:
 *          [includeBitStringContents] true to compare bitStringContents
 *
 * @return true if the asn1 objects are equal.
 */ $d72beefffe7b6a51$var$asn1.equals = function(obj1, obj2, options) {
    if ($cLQG7.util.isArray(obj1)) {
        if (!$cLQG7.util.isArray(obj2)) return false;
        if (obj1.length !== obj2.length) return false;
        for(var i = 0; i < obj1.length; ++i){
            if (!$d72beefffe7b6a51$var$asn1.equals(obj1[i], obj2[i])) return false;
        }
        return true;
    }
    if (typeof obj1 !== typeof obj2) return false;
    if (typeof obj1 === 'string') return obj1 === obj2;
    var equal = obj1.tagClass === obj2.tagClass && obj1.type === obj2.type && obj1.constructed === obj2.constructed && obj1.composed === obj2.composed && $d72beefffe7b6a51$var$asn1.equals(obj1.value, obj2.value);
    if (options && options.includeBitStringContents) equal = equal && obj1.bitStringContents === obj2.bitStringContents;
    return equal;
};
/**
 * Gets the length of a BER-encoded ASN.1 value.
 *
 * In case the length is not specified, undefined is returned.
 *
 * @param b the BER-encoded ASN.1 byte buffer, starting with the first
 *          length byte.
 *
 * @return the length of the BER-encoded ASN.1 value or undefined.
 */ $d72beefffe7b6a51$var$asn1.getBerValueLength = function(b) {
    // TODO: move this function and related DER/BER functions to a der.js
    // file; better abstract ASN.1 away from der/ber.
    var b2 = b.getByte();
    if (b2 === 0x80) return undefined;
    // see if the length is "short form" or "long form" (bit 8 set)
    var length;
    var longForm = b2 & 0x80;
    if (!longForm) // length is just the first byte
    length = b2;
    else // the number of bytes the length is specified in bits 7 through 1
    // and each length byte is in big-endian base-256
    length = b.getInt((b2 & 0x7F) << 3);
    return length;
};
/**
 * Check if the byte buffer has enough bytes. Throws an Error if not.
 *
 * @param bytes the byte buffer to parse from.
 * @param remaining the bytes remaining in the current parsing state.
 * @param n the number of bytes the buffer must have.
 */ function $d72beefffe7b6a51$var$_checkBufferLength(bytes, remaining, n) {
    if (n > remaining) {
        var error = new Error('Too few bytes to parse DER.');
        error.available = bytes.length();
        error.remaining = remaining;
        error.requested = n;
        throw error;
    }
}
/**
 * Gets the length of a BER-encoded ASN.1 value.
 *
 * In case the length is not specified, undefined is returned.
 *
 * @param bytes the byte buffer to parse from.
 * @param remaining the bytes remaining in the current parsing state.
 *
 * @return the length of the BER-encoded ASN.1 value or undefined.
 */ var $d72beefffe7b6a51$var$_getValueLength = function(bytes, remaining) {
    // TODO: move this function and related DER/BER functions to a der.js
    // file; better abstract ASN.1 away from der/ber.
    // fromDer already checked that this byte exists
    var b2 = bytes.getByte();
    remaining--;
    if (b2 === 0x80) return undefined;
    // see if the length is "short form" or "long form" (bit 8 set)
    var length;
    var longForm = b2 & 0x80;
    if (!longForm) // length is just the first byte
    length = b2;
    else {
        // the number of bytes the length is specified in bits 7 through 1
        // and each length byte is in big-endian base-256
        var longFormBytes = b2 & 0x7F;
        $d72beefffe7b6a51$var$_checkBufferLength(bytes, remaining, longFormBytes);
        length = bytes.getInt(longFormBytes << 3);
    }
    // FIXME: this will only happen for 32 bit getInt with high bit set
    if (length < 0) throw new Error('Negative length: ' + length);
    return length;
};
/**
 * Parses an asn1 object from a byte buffer in DER format.
 *
 * @param bytes the byte buffer to parse from.
 * @param [strict] true to be strict when checking value lengths, false to
 *          allow truncated values (default: true).
 * @param [options] object with options or boolean strict flag
 *          [strict] true to be strict when checking value lengths, false to
 *            allow truncated values (default: true).
 *          [parseAllBytes] true to ensure all bytes are parsed
 *            (default: true)
 *          [decodeBitStrings] true to attempt to decode the content of
 *            BIT STRINGs (not OCTET STRINGs) using strict mode. Note that
 *            without schema support to understand the data context this can
 *            erroneously decode values that happen to be valid ASN.1. This
 *            flag will be deprecated or removed as soon as schema support is
 *            available. (default: true)
 *
 * @throws Will throw an error for various malformed input conditions.
 *
 * @return the parsed asn1 object.
 */ $d72beefffe7b6a51$var$asn1.fromDer = function(bytes, options) {
    if (options === undefined) options = {
        strict: true,
        parseAllBytes: true,
        decodeBitStrings: true
    };
    if (typeof options === 'boolean') options = {
        strict: options,
        parseAllBytes: true,
        decodeBitStrings: true
    };
    if (!('strict' in options)) options.strict = true;
    if (!('parseAllBytes' in options)) options.parseAllBytes = true;
    if (!('decodeBitStrings' in options)) options.decodeBitStrings = true;
    // wrap in buffer if needed
    if (typeof bytes === 'string') bytes = $cLQG7.util.createBuffer(bytes);
    var byteCount = bytes.length();
    var value = $d72beefffe7b6a51$var$_fromDer(bytes, bytes.length(), 0, options);
    if (options.parseAllBytes && bytes.length() !== 0) {
        var error = new Error('Unparsed DER bytes remain after ASN.1 parsing.');
        error.byteCount = byteCount;
        error.remaining = bytes.length();
        throw error;
    }
    return value;
};
/**
 * Internal function to parse an asn1 object from a byte buffer in DER format.
 *
 * @param bytes the byte buffer to parse from.
 * @param remaining the number of bytes remaining for this chunk.
 * @param depth the current parsing depth.
 * @param options object with same options as fromDer().
 *
 * @return the parsed asn1 object.
 */ function $d72beefffe7b6a51$var$_fromDer(bytes, remaining, depth, options) {
    // temporary storage for consumption calculations
    var start;
    // minimum length for ASN.1 DER structure is 2
    $d72beefffe7b6a51$var$_checkBufferLength(bytes, remaining, 2);
    // get the first byte
    var b1 = bytes.getByte();
    // consumed one byte
    remaining--;
    // get the tag class
    var tagClass = b1 & 0xC0;
    // get the type (bits 1-5)
    var type = b1 & 0x1F;
    // get the variable value length and adjust remaining bytes
    start = bytes.length();
    var length = $d72beefffe7b6a51$var$_getValueLength(bytes, remaining);
    remaining -= start - bytes.length();
    // ensure there are enough bytes to get the value
    if (length !== undefined && length > remaining) {
        if (options.strict) {
            var error = new Error('Too few bytes to read ASN.1 value.');
            error.available = bytes.length();
            error.remaining = remaining;
            error.requested = length;
            throw error;
        }
        // Note: be lenient with truncated values and use remaining state bytes
        length = remaining;
    }
    // value storage
    var value;
    // possible BIT STRING contents storage
    var bitStringContents;
    // constructed flag is bit 6 (32 = 0x20) of the first byte
    var constructed = (b1 & 0x20) === 0x20;
    if (constructed) {
        // parse child asn1 objects from the value
        value = [];
        if (length === undefined) // asn1 object of indefinite length, read until end tag
        for(;;){
            $d72beefffe7b6a51$var$_checkBufferLength(bytes, remaining, 2);
            if (bytes.bytes(2) === String.fromCharCode(0, 0)) {
                bytes.getBytes(2);
                remaining -= 2;
                break;
            }
            start = bytes.length();
            value.push($d72beefffe7b6a51$var$_fromDer(bytes, remaining, depth + 1, options));
            remaining -= start - bytes.length();
        }
        else // parsing asn1 object of definite length
        while(length > 0){
            start = bytes.length();
            value.push($d72beefffe7b6a51$var$_fromDer(bytes, length, depth + 1, options));
            remaining -= start - bytes.length();
            length -= start - bytes.length();
        }
    }
    // if a BIT STRING, save the contents including padding
    if (value === undefined && tagClass === $d72beefffe7b6a51$var$asn1.Class.UNIVERSAL && type === $d72beefffe7b6a51$var$asn1.Type.BITSTRING) bitStringContents = bytes.bytes(length);
    // determine if a non-constructed value should be decoded as a composed
    // value that contains other ASN.1 objects. BIT STRINGs (and OCTET STRINGs)
    // can be used this way.
    if (value === undefined && options.decodeBitStrings && tagClass === $d72beefffe7b6a51$var$asn1.Class.UNIVERSAL && // FIXME: OCTET STRINGs not yet supported here
    // .. other parts of forge expect to decode OCTET STRINGs manually
    type === $d72beefffe7b6a51$var$asn1.Type.BITSTRING /*|| type === asn1.Type.OCTETSTRING*/  && length > 1) {
        // save read position
        var savedRead = bytes.read;
        var savedRemaining = remaining;
        var unused = 0;
        if (type === $d72beefffe7b6a51$var$asn1.Type.BITSTRING) {
            /* The first octet gives the number of bits by which the length of the
        bit string is less than the next multiple of eight (this is called
        the "number of unused bits").

        The second and following octets give the value of the bit string
        converted to an octet string. */ $d72beefffe7b6a51$var$_checkBufferLength(bytes, remaining, 1);
            unused = bytes.getByte();
            remaining--;
        }
        // if all bits are used, maybe the BIT/OCTET STRING holds ASN.1 objs
        if (unused === 0) try {
            // attempt to parse child asn1 object from the value
            // (stored in array to signal composed value)
            start = bytes.length();
            var subOptions = {
                // enforce strict mode to avoid parsing ASN.1 from plain data
                strict: true,
                decodeBitStrings: true
            };
            var composed = $d72beefffe7b6a51$var$_fromDer(bytes, remaining, depth + 1, subOptions);
            var used = start - bytes.length();
            remaining -= used;
            if (type == $d72beefffe7b6a51$var$asn1.Type.BITSTRING) used++;
            // if the data all decoded and the class indicates UNIVERSAL or
            // CONTEXT_SPECIFIC then assume we've got an encapsulated ASN.1 object
            var tc = composed.tagClass;
            if (used === length && (tc === $d72beefffe7b6a51$var$asn1.Class.UNIVERSAL || tc === $d72beefffe7b6a51$var$asn1.Class.CONTEXT_SPECIFIC)) value = [
                composed
            ];
        } catch (ex) {}
        if (value === undefined) {
            // restore read position
            bytes.read = savedRead;
            remaining = savedRemaining;
        }
    }
    if (value === undefined) {
        // asn1 not constructed or composed, get raw value
        // TODO: do DER to OID conversion and vice-versa in .toDer?
        if (length === undefined) {
            if (options.strict) throw new Error('Non-constructed ASN.1 object of indefinite length.');
            // be lenient and use remaining state bytes
            length = remaining;
        }
        if (type === $d72beefffe7b6a51$var$asn1.Type.BMPSTRING) {
            value = '';
            for(; length > 0; length -= 2){
                $d72beefffe7b6a51$var$_checkBufferLength(bytes, remaining, 2);
                value += String.fromCharCode(bytes.getInt16());
                remaining -= 2;
            }
        } else {
            value = bytes.getBytes(length);
            remaining -= length;
        }
    }
    // add BIT STRING contents if available
    var asn1Options = bitStringContents === undefined ? null : {
        bitStringContents: bitStringContents
    };
    // create and return asn1 object
    return $d72beefffe7b6a51$var$asn1.create(tagClass, type, constructed, value, asn1Options);
}
/**
 * Converts the given asn1 object to a buffer of bytes in DER format.
 *
 * @param asn1 the asn1 object to convert to bytes.
 *
 * @return the buffer of bytes.
 */ $d72beefffe7b6a51$var$asn1.toDer = function(obj) {
    var bytes = $cLQG7.util.createBuffer();
    // build the first byte
    var b1 = obj.tagClass | obj.type;
    // for storing the ASN.1 value
    var value = $cLQG7.util.createBuffer();
    // use BIT STRING contents if available and data not changed
    var useBitStringContents = false;
    if ('bitStringContents' in obj) {
        useBitStringContents = true;
        if (obj.original) useBitStringContents = $d72beefffe7b6a51$var$asn1.equals(obj, obj.original);
    }
    if (useBitStringContents) value.putBytes(obj.bitStringContents);
    else if (obj.composed) {
        // if composed, use each child asn1 object's DER bytes as value
        // turn on 6th bit (0x20 = 32) to indicate asn1 is constructed
        // from other asn1 objects
        if (obj.constructed) b1 |= 0x20;
        else // type is a bit string, add unused bits of 0x00
        value.putByte(0x00);
        // add all of the child DER bytes together
        for(var i = 0; i < obj.value.length; ++i)if (obj.value[i] !== undefined) value.putBuffer($d72beefffe7b6a51$var$asn1.toDer(obj.value[i]));
    } else {
        // use asn1.value directly
        if (obj.type === $d72beefffe7b6a51$var$asn1.Type.BMPSTRING) for(var i = 0; i < obj.value.length; ++i)value.putInt16(obj.value.charCodeAt(i));
        else // ensure integer is minimally-encoded
        // TODO: should all leading bytes be stripped vs just one?
        // .. ex '00 00 01' => '01'?
        if (obj.type === $d72beefffe7b6a51$var$asn1.Type.INTEGER && obj.value.length > 1 && // leading 0x00 for positive integer
        (obj.value.charCodeAt(0) === 0 && (obj.value.charCodeAt(1) & 0x80) === 0 || // leading 0xFF for negative integer
        obj.value.charCodeAt(0) === 0xFF && (obj.value.charCodeAt(1) & 0x80) === 0x80)) value.putBytes(obj.value.substr(1));
        else value.putBytes(obj.value);
    }
    // add tag byte
    bytes.putByte(b1);
    // use "short form" encoding
    if (value.length() <= 127) // one byte describes the length
    // bit 8 = 0 and bits 7-1 = length
    bytes.putByte(value.length() & 0x7F);
    else {
        // use "long form" encoding
        // 2 to 127 bytes describe the length
        // first byte: bit 8 = 1 and bits 7-1 = # of additional bytes
        // other bytes: length in base 256, big-endian
        var len = value.length();
        var lenBytes = '';
        do {
            lenBytes += String.fromCharCode(len & 0xFF);
            len = len >>> 8;
        }while (len > 0);
        // set first byte to # bytes used to store the length and turn on
        // bit 8 to indicate long-form length is used
        bytes.putByte(lenBytes.length | 0x80);
        // concatenate length bytes in reverse since they were generated
        // little endian and we need big endian
        for(var i = lenBytes.length - 1; i >= 0; --i)bytes.putByte(lenBytes.charCodeAt(i));
    }
    // concatenate value bytes
    bytes.putBuffer(value);
    return bytes;
};
/**
 * Converts an OID dot-separated string to a byte buffer. The byte buffer
 * contains only the DER-encoded value, not any tag or length bytes.
 *
 * @param oid the OID dot-separated string.
 *
 * @return the byte buffer.
 */ $d72beefffe7b6a51$var$asn1.oidToDer = function(oid) {
    // split OID into individual values
    var values = oid.split('.');
    var bytes = $cLQG7.util.createBuffer();
    // first byte is 40 * value1 + value2
    bytes.putByte(40 * parseInt(values[0], 10) + parseInt(values[1], 10));
    // other bytes are each value in base 128 with 8th bit set except for
    // the last byte for each value
    var last, valueBytes, value, b;
    for(var i = 2; i < values.length; ++i){
        // produce value bytes in reverse because we don't know how many
        // bytes it will take to store the value
        last = true;
        valueBytes = [];
        value = parseInt(values[i], 10);
        do {
            b = value & 0x7F;
            value = value >>> 7;
            // if value is not last, then turn on 8th bit
            if (!last) b |= 0x80;
            valueBytes.push(b);
            last = false;
        }while (value > 0);
        // add value bytes in reverse (needs to be in big endian)
        for(var n = valueBytes.length - 1; n >= 0; --n)bytes.putByte(valueBytes[n]);
    }
    return bytes;
};
/**
 * Converts a DER-encoded byte buffer to an OID dot-separated string. The
 * byte buffer should contain only the DER-encoded value, not any tag or
 * length bytes.
 *
 * @param bytes the byte buffer.
 *
 * @return the OID dot-separated string.
 */ $d72beefffe7b6a51$var$asn1.derToOid = function(bytes) {
    var oid;
    // wrap in buffer if needed
    if (typeof bytes === 'string') bytes = $cLQG7.util.createBuffer(bytes);
    // first byte is 40 * value1 + value2
    var b = bytes.getByte();
    oid = Math.floor(b / 40) + '.' + b % 40;
    // other bytes are each value in base 128 with 8th bit set except for
    // the last byte for each value
    var value = 0;
    while(bytes.length() > 0){
        b = bytes.getByte();
        value = value << 7;
        // not the last byte for the value
        if (b & 0x80) value += b & 0x7F;
        else {
            // last byte
            oid += '.' + (value + b);
            value = 0;
        }
    }
    return oid;
};
/**
 * Converts a UTCTime value to a date.
 *
 * Note: GeneralizedTime has 4 digits for the year and is used for X.509
 * dates past 2049. Parsing that structure hasn't been implemented yet.
 *
 * @param utc the UTCTime value to convert.
 *
 * @return the date.
 */ $d72beefffe7b6a51$var$asn1.utcTimeToDate = function(utc) {
    /* The following formats can be used:

    YYMMDDhhmmZ
    YYMMDDhhmm+hh'mm'
    YYMMDDhhmm-hh'mm'
    YYMMDDhhmmssZ
    YYMMDDhhmmss+hh'mm'
    YYMMDDhhmmss-hh'mm'

    Where:

    YY is the least significant two digits of the year
    MM is the month (01 to 12)
    DD is the day (01 to 31)
    hh is the hour (00 to 23)
    mm are the minutes (00 to 59)
    ss are the seconds (00 to 59)
    Z indicates that local time is GMT, + indicates that local time is
    later than GMT, and - indicates that local time is earlier than GMT
    hh' is the absolute value of the offset from GMT in hours
    mm' is the absolute value of the offset from GMT in minutes */ var date = new Date();
    // if YY >= 50 use 19xx, if YY < 50 use 20xx
    var year = parseInt(utc.substr(0, 2), 10);
    year = year >= 50 ? 1900 + year : 2000 + year;
    var MM = parseInt(utc.substr(2, 2), 10) - 1; // use 0-11 for month
    var DD = parseInt(utc.substr(4, 2), 10);
    var hh = parseInt(utc.substr(6, 2), 10);
    var mm = parseInt(utc.substr(8, 2), 10);
    var ss = 0;
    // not just YYMMDDhhmmZ
    if (utc.length > 11) {
        // get character after minutes
        var c = utc.charAt(10);
        var end = 10;
        // see if seconds are present
        if (c !== '+' && c !== '-') {
            // get seconds
            ss = parseInt(utc.substr(10, 2), 10);
            end += 2;
        }
    }
    // update date
    date.setUTCFullYear(year, MM, DD);
    date.setUTCHours(hh, mm, ss, 0);
    if (end) {
        // get +/- after end of time
        c = utc.charAt(end);
        if (c === '+' || c === '-') {
            // get hours+minutes offset
            var hhoffset = parseInt(utc.substr(end + 1, 2), 10);
            var mmoffset = parseInt(utc.substr(end + 4, 2), 10);
            // calculate offset in milliseconds
            var offset = hhoffset * 60 + mmoffset;
            offset *= 60000;
            // apply offset
            if (c === '+') date.setTime(+date - offset);
            else date.setTime(+date + offset);
        }
    }
    return date;
};
/**
 * Converts a GeneralizedTime value to a date.
 *
 * @param gentime the GeneralizedTime value to convert.
 *
 * @return the date.
 */ $d72beefffe7b6a51$var$asn1.generalizedTimeToDate = function(gentime) {
    /* The following formats can be used:

    YYYYMMDDHHMMSS
    YYYYMMDDHHMMSS.fff
    YYYYMMDDHHMMSSZ
    YYYYMMDDHHMMSS.fffZ
    YYYYMMDDHHMMSS+hh'mm'
    YYYYMMDDHHMMSS.fff+hh'mm'
    YYYYMMDDHHMMSS-hh'mm'
    YYYYMMDDHHMMSS.fff-hh'mm'

    Where:

    YYYY is the year
    MM is the month (01 to 12)
    DD is the day (01 to 31)
    hh is the hour (00 to 23)
    mm are the minutes (00 to 59)
    ss are the seconds (00 to 59)
    .fff is the second fraction, accurate to three decimal places
    Z indicates that local time is GMT, + indicates that local time is
    later than GMT, and - indicates that local time is earlier than GMT
    hh' is the absolute value of the offset from GMT in hours
    mm' is the absolute value of the offset from GMT in minutes */ var date = new Date();
    var YYYY = parseInt(gentime.substr(0, 4), 10);
    var MM = parseInt(gentime.substr(4, 2), 10) - 1; // use 0-11 for month
    var DD = parseInt(gentime.substr(6, 2), 10);
    var hh = parseInt(gentime.substr(8, 2), 10);
    var mm = parseInt(gentime.substr(10, 2), 10);
    var ss = parseInt(gentime.substr(12, 2), 10);
    var fff = 0;
    var offset = 0;
    var isUTC = false;
    if (gentime.charAt(gentime.length - 1) === 'Z') isUTC = true;
    var end = gentime.length - 5, c = gentime.charAt(end);
    if (c === '+' || c === '-') {
        // get hours+minutes offset
        var hhoffset = parseInt(gentime.substr(end + 1, 2), 10);
        var mmoffset = parseInt(gentime.substr(end + 4, 2), 10);
        // calculate offset in milliseconds
        offset = hhoffset * 60 + mmoffset;
        offset *= 60000;
        // apply offset
        if (c === '+') offset *= -1;
        isUTC = true;
    }
    // check for second fraction
    if (gentime.charAt(14) === '.') fff = parseFloat(gentime.substr(14), 10) * 1000;
    if (isUTC) {
        date.setUTCFullYear(YYYY, MM, DD);
        date.setUTCHours(hh, mm, ss, fff);
        // apply offset
        date.setTime(+date + offset);
    } else {
        date.setFullYear(YYYY, MM, DD);
        date.setHours(hh, mm, ss, fff);
    }
    return date;
};
/**
 * Converts a date to a UTCTime value.
 *
 * Note: GeneralizedTime has 4 digits for the year and is used for X.509
 * dates past 2049. Converting to a GeneralizedTime hasn't been
 * implemented yet.
 *
 * @param date the date to convert.
 *
 * @return the UTCTime value.
 */ $d72beefffe7b6a51$var$asn1.dateToUtcTime = function(date) {
    // TODO: validate; currently assumes proper format
    if (typeof date === 'string') return date;
    var rval = '';
    // create format YYMMDDhhmmssZ
    var format = [];
    format.push(('' + date.getUTCFullYear()).substr(2));
    format.push('' + (date.getUTCMonth() + 1));
    format.push('' + date.getUTCDate());
    format.push('' + date.getUTCHours());
    format.push('' + date.getUTCMinutes());
    format.push('' + date.getUTCSeconds());
    // ensure 2 digits are used for each format entry
    for(var i = 0; i < format.length; ++i){
        if (format[i].length < 2) rval += '0';
        rval += format[i];
    }
    rval += 'Z';
    return rval;
};
/**
 * Converts a date to a GeneralizedTime value.
 *
 * @param date the date to convert.
 *
 * @return the GeneralizedTime value as a string.
 */ $d72beefffe7b6a51$var$asn1.dateToGeneralizedTime = function(date) {
    // TODO: validate; currently assumes proper format
    if (typeof date === 'string') return date;
    var rval = '';
    // create format YYYYMMDDHHMMSSZ
    var format = [];
    format.push('' + date.getUTCFullYear());
    format.push('' + (date.getUTCMonth() + 1));
    format.push('' + date.getUTCDate());
    format.push('' + date.getUTCHours());
    format.push('' + date.getUTCMinutes());
    format.push('' + date.getUTCSeconds());
    // ensure 2 digits are used for each format entry
    for(var i = 0; i < format.length; ++i){
        if (format[i].length < 2) rval += '0';
        rval += format[i];
    }
    rval += 'Z';
    return rval;
};
/**
 * Converts a javascript integer to a DER-encoded byte buffer to be used
 * as the value for an INTEGER type.
 *
 * @param x the integer.
 *
 * @return the byte buffer.
 */ $d72beefffe7b6a51$var$asn1.integerToDer = function(x) {
    var rval = $cLQG7.util.createBuffer();
    if (x >= -128 && x < 0x80) return rval.putSignedInt(x, 8);
    if (x >= -32768 && x < 0x8000) return rval.putSignedInt(x, 16);
    if (x >= -8388608 && x < 0x800000) return rval.putSignedInt(x, 24);
    if (x >= -2147483648 && x < 0x80000000) return rval.putSignedInt(x, 32);
    var error = new Error('Integer too large; max is 32-bits.');
    error.integer = x;
    throw error;
};
/**
 * Converts a DER-encoded byte buffer to a javascript integer. This is
 * typically used to decode the value of an INTEGER type.
 *
 * @param bytes the byte buffer.
 *
 * @return the integer.
 */ $d72beefffe7b6a51$var$asn1.derToInteger = function(bytes) {
    // wrap in buffer if needed
    if (typeof bytes === 'string') bytes = $cLQG7.util.createBuffer(bytes);
    var n = bytes.length() * 8;
    if (n > 32) throw new Error('Integer too large; max is 32-bits.');
    return bytes.getSignedInt(n);
};
/**
 * Validates that the given ASN.1 object is at least a super set of the
 * given ASN.1 structure. Only tag classes and types are checked. An
 * optional map may also be provided to capture ASN.1 values while the
 * structure is checked.
 *
 * To capture an ASN.1 value, set an object in the validator's 'capture'
 * parameter to the key to use in the capture map. To capture the full
 * ASN.1 object, specify 'captureAsn1'. To capture BIT STRING bytes, including
 * the leading unused bits counter byte, specify 'captureBitStringContents'.
 * To capture BIT STRING bytes, without the leading unused bits counter byte,
 * specify 'captureBitStringValue'.
 *
 * Objects in the validator may set a field 'optional' to true to indicate
 * that it isn't necessary to pass validation.
 *
 * @param obj the ASN.1 object to validate.
 * @param v the ASN.1 structure validator.
 * @param capture an optional map to capture values in.
 * @param errors an optional array for storing validation errors.
 *
 * @return true on success, false on failure.
 */ $d72beefffe7b6a51$var$asn1.validate = function(obj, v, capture, errors) {
    var rval = false;
    // ensure tag class and type are the same if specified
    if ((obj.tagClass === v.tagClass || typeof v.tagClass === 'undefined') && (obj.type === v.type || typeof v.type === 'undefined')) {
        // ensure constructed flag is the same if specified
        if (obj.constructed === v.constructed || typeof v.constructed === 'undefined') {
            rval = true;
            // handle sub values
            if (v.value && $cLQG7.util.isArray(v.value)) {
                var j = 0;
                for(var i = 0; rval && i < v.value.length; ++i){
                    rval = v.value[i].optional || false;
                    if (obj.value[j]) {
                        rval = $d72beefffe7b6a51$var$asn1.validate(obj.value[j], v.value[i], capture, errors);
                        if (rval) ++j;
                        else if (v.value[i].optional) rval = true;
                    }
                    if (!rval && errors) errors.push('[' + v.name + '] ' + 'Tag class "' + v.tagClass + '", type "' + v.type + '" expected value length "' + v.value.length + '", got "' + obj.value.length + '"');
                }
            }
            if (rval && capture) {
                if (v.capture) capture[v.capture] = obj.value;
                if (v.captureAsn1) capture[v.captureAsn1] = obj;
                if (v.captureBitStringContents && 'bitStringContents' in obj) capture[v.captureBitStringContents] = obj.bitStringContents;
                if (v.captureBitStringValue && 'bitStringContents' in obj) {
                    var value;
                    if (obj.bitStringContents.length < 2) capture[v.captureBitStringValue] = '';
                    else {
                        // FIXME: support unused bits with data shifting
                        var unused = obj.bitStringContents.charCodeAt(0);
                        if (unused !== 0) throw new Error('captureBitStringValue only supported for zero unused bits');
                        capture[v.captureBitStringValue] = obj.bitStringContents.slice(1);
                    }
                }
            }
        } else if (errors) errors.push('[' + v.name + '] ' + 'Expected constructed "' + v.constructed + '", got "' + obj.constructed + '"');
    } else if (errors) {
        if (obj.tagClass !== v.tagClass) errors.push('[' + v.name + '] ' + 'Expected tag class "' + v.tagClass + '", got "' + obj.tagClass + '"');
        if (obj.type !== v.type) errors.push('[' + v.name + '] ' + 'Expected type "' + v.type + '", got "' + obj.type + '"');
    }
    return rval;
};
// regex for testing for non-latin characters
var $d72beefffe7b6a51$var$_nonLatinRegex = /[^\\u0000-\\u00ff]/;
/**
 * Pretty prints an ASN.1 object to a string.
 *
 * @param obj the object to write out.
 * @param level the level in the tree.
 * @param indentation the indentation to use.
 *
 * @return the string.
 */ $d72beefffe7b6a51$var$asn1.prettyPrint = function(obj, level, indentation) {
    var rval = '';
    // set default level and indentation
    level = level || 0;
    indentation = indentation || 2;
    // start new line for deep levels
    if (level > 0) rval += '\n';
    // create indent
    var indent = '';
    for(var i = 0; i < level * indentation; ++i)indent += ' ';
    // print class:type
    rval += indent + 'Tag: ';
    switch(obj.tagClass){
        case $d72beefffe7b6a51$var$asn1.Class.UNIVERSAL:
            rval += 'Universal:';
            break;
        case $d72beefffe7b6a51$var$asn1.Class.APPLICATION:
            rval += 'Application:';
            break;
        case $d72beefffe7b6a51$var$asn1.Class.CONTEXT_SPECIFIC:
            rval += 'Context-Specific:';
            break;
        case $d72beefffe7b6a51$var$asn1.Class.PRIVATE:
            rval += 'Private:';
            break;
    }
    if (obj.tagClass === $d72beefffe7b6a51$var$asn1.Class.UNIVERSAL) {
        rval += obj.type;
        // known types
        switch(obj.type){
            case $d72beefffe7b6a51$var$asn1.Type.NONE:
                rval += ' (None)';
                break;
            case $d72beefffe7b6a51$var$asn1.Type.BOOLEAN:
                rval += ' (Boolean)';
                break;
            case $d72beefffe7b6a51$var$asn1.Type.INTEGER:
                rval += ' (Integer)';
                break;
            case $d72beefffe7b6a51$var$asn1.Type.BITSTRING:
                rval += ' (Bit string)';
                break;
            case $d72beefffe7b6a51$var$asn1.Type.OCTETSTRING:
                rval += ' (Octet string)';
                break;
            case $d72beefffe7b6a51$var$asn1.Type.NULL:
                rval += ' (Null)';
                break;
            case $d72beefffe7b6a51$var$asn1.Type.OID:
                rval += ' (Object Identifier)';
                break;
            case $d72beefffe7b6a51$var$asn1.Type.ODESC:
                rval += ' (Object Descriptor)';
                break;
            case $d72beefffe7b6a51$var$asn1.Type.EXTERNAL:
                rval += ' (External or Instance of)';
                break;
            case $d72beefffe7b6a51$var$asn1.Type.REAL:
                rval += ' (Real)';
                break;
            case $d72beefffe7b6a51$var$asn1.Type.ENUMERATED:
                rval += ' (Enumerated)';
                break;
            case $d72beefffe7b6a51$var$asn1.Type.EMBEDDED:
                rval += ' (Embedded PDV)';
                break;
            case $d72beefffe7b6a51$var$asn1.Type.UTF8:
                rval += ' (UTF8)';
                break;
            case $d72beefffe7b6a51$var$asn1.Type.ROID:
                rval += ' (Relative Object Identifier)';
                break;
            case $d72beefffe7b6a51$var$asn1.Type.SEQUENCE:
                rval += ' (Sequence)';
                break;
            case $d72beefffe7b6a51$var$asn1.Type.SET:
                rval += ' (Set)';
                break;
            case $d72beefffe7b6a51$var$asn1.Type.PRINTABLESTRING:
                rval += ' (Printable String)';
                break;
            case $d72beefffe7b6a51$var$asn1.Type.IA5String:
                rval += ' (IA5String (ASCII))';
                break;
            case $d72beefffe7b6a51$var$asn1.Type.UTCTIME:
                rval += ' (UTC time)';
                break;
            case $d72beefffe7b6a51$var$asn1.Type.GENERALIZEDTIME:
                rval += ' (Generalized time)';
                break;
            case $d72beefffe7b6a51$var$asn1.Type.BMPSTRING:
                rval += ' (BMP String)';
                break;
        }
    } else rval += obj.type;
    rval += '\n';
    rval += indent + 'Constructed: ' + obj.constructed + '\n';
    if (obj.composed) {
        var subvalues = 0;
        var sub = '';
        for(var i = 0; i < obj.value.length; ++i)if (obj.value[i] !== undefined) {
            subvalues += 1;
            sub += $d72beefffe7b6a51$var$asn1.prettyPrint(obj.value[i], level + 1, indentation);
            if (i + 1 < obj.value.length) sub += ',';
        }
        rval += indent + 'Sub values: ' + subvalues + sub;
    } else {
        rval += indent + 'Value: ';
        if (obj.type === $d72beefffe7b6a51$var$asn1.Type.OID) {
            var oid = $d72beefffe7b6a51$var$asn1.derToOid(obj.value);
            rval += oid;
            if ($cLQG7.pki && $cLQG7.pki.oids) {
                if (oid in $cLQG7.pki.oids) rval += ' (' + $cLQG7.pki.oids[oid] + ') ';
            }
        }
        if (obj.type === $d72beefffe7b6a51$var$asn1.Type.INTEGER) try {
            rval += $d72beefffe7b6a51$var$asn1.derToInteger(obj.value);
        } catch (ex) {
            rval += '0x' + $cLQG7.util.bytesToHex(obj.value);
        }
        else if (obj.type === $d72beefffe7b6a51$var$asn1.Type.BITSTRING) {
            // TODO: shift bits as needed to display without padding
            if (obj.value.length > 1) // remove unused bits field
            rval += '0x' + $cLQG7.util.bytesToHex(obj.value.slice(1));
            else rval += '(none)';
            // show unused bit count
            if (obj.value.length > 0) {
                var unused = obj.value.charCodeAt(0);
                if (unused == 1) rval += ' (1 unused bit shown)';
                else if (unused > 1) rval += ' (' + unused + ' unused bits shown)';
            }
        } else if (obj.type === $d72beefffe7b6a51$var$asn1.Type.OCTETSTRING) {
            if (!$d72beefffe7b6a51$var$_nonLatinRegex.test(obj.value)) rval += '(' + obj.value + ') ';
            rval += '0x' + $cLQG7.util.bytesToHex(obj.value);
        } else if (obj.type === $d72beefffe7b6a51$var$asn1.Type.UTF8) try {
            rval += $cLQG7.util.decodeUtf8(obj.value);
        } catch (e) {
            if (e.message === 'URI malformed') rval += '0x' + $cLQG7.util.bytesToHex(obj.value) + ' (malformed UTF8)';
            else throw e;
        }
        else if (obj.type === $d72beefffe7b6a51$var$asn1.Type.PRINTABLESTRING || obj.type === $d72beefffe7b6a51$var$asn1.Type.IA5String) rval += obj.value;
        else if ($d72beefffe7b6a51$var$_nonLatinRegex.test(obj.value)) rval += '0x' + $cLQG7.util.bytesToHex(obj.value);
        else if (obj.value.length === 0) rval += '[null]';
        else rval += obj.value;
    }
    return rval;
};


var $8011c98e0db2e24f$exports = {};
/**
 * Hash-based Message Authentication Code implementation. Requires a message
 * digest object that can be obtained, for example, from forge.md.sha1 or
 * forge.md.md5.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2012 Digital Bazaar, Inc. All rights reserved.
 */ 
var $cLQG7 = parcelRequire("cLQG7");
parcelRequire("4pr5e");

/* HMAC API */ var $8011c98e0db2e24f$var$hmac = $8011c98e0db2e24f$exports = $cLQG7.hmac = $cLQG7.hmac || {};
/**
 * Creates an HMAC object that uses the given message digest object.
 *
 * @return an HMAC object.
 */ $8011c98e0db2e24f$var$hmac.create = function() {
    // the hmac key to use
    var _key = null;
    // the message digest to use
    var _md = null;
    // the inner padding
    var _ipadding = null;
    // the outer padding
    var _opadding = null;
    // hmac context
    var ctx = {};
    /**
   * Starts or restarts the HMAC with the given key and message digest.
   *
   * @param md the message digest to use, null to reuse the previous one,
   *           a string to use builtin 'sha1', 'md5', 'sha256'.
   * @param key the key to use as a string, array of bytes, byte buffer,
   *           or null to reuse the previous key.
   */ ctx.start = function(md, key) {
        if (md !== null) {
            if (typeof md === 'string') {
                // create builtin message digest
                md = md.toLowerCase();
                if (md in $cLQG7.md.algorithms) _md = $cLQG7.md.algorithms[md].create();
                else throw new Error('Unknown hash algorithm "' + md + '"');
            } else // store message digest
            _md = md;
        }
        if (key === null) // reuse previous key
        key = _key;
        else {
            if (typeof key === 'string') // convert string into byte buffer
            key = $cLQG7.util.createBuffer(key);
            else if ($cLQG7.util.isArray(key)) {
                // convert byte array into byte buffer
                var tmp = key;
                key = $cLQG7.util.createBuffer();
                for(var i = 0; i < tmp.length; ++i)key.putByte(tmp[i]);
            }
            // if key is longer than blocksize, hash it
            var keylen = key.length();
            if (keylen > _md.blockLength) {
                _md.start();
                _md.update(key.bytes());
                key = _md.digest();
            }
            // mix key into inner and outer padding
            // ipadding = [0x36 * blocksize] ^ key
            // opadding = [0x5C * blocksize] ^ key
            _ipadding = $cLQG7.util.createBuffer();
            _opadding = $cLQG7.util.createBuffer();
            keylen = key.length();
            for(var i = 0; i < keylen; ++i){
                var tmp = key.at(i);
                _ipadding.putByte(0x36 ^ tmp);
                _opadding.putByte(0x5C ^ tmp);
            }
            // if key is shorter than blocksize, add additional padding
            if (keylen < _md.blockLength) {
                var tmp = _md.blockLength - keylen;
                for(var i = 0; i < tmp; ++i){
                    _ipadding.putByte(0x36);
                    _opadding.putByte(0x5C);
                }
            }
            _key = key;
            _ipadding = _ipadding.bytes();
            _opadding = _opadding.bytes();
        }
        // digest is done like so: hash(opadding | hash(ipadding | message))
        // prepare to do inner hash
        // hash(ipadding | message)
        _md.start();
        _md.update(_ipadding);
    };
    /**
   * Updates the HMAC with the given message bytes.
   *
   * @param bytes the bytes to update with.
   */ ctx.update = function(bytes) {
        _md.update(bytes);
    };
    /**
   * Produces the Message Authentication Code (MAC).
   *
   * @return a byte buffer containing the digest value.
   */ ctx.getMac = function() {
        // digest is done like so: hash(opadding | hash(ipadding | message))
        // here we do the outer hashing
        var inner = _md.digest().bytes();
        _md.start();
        _md.update(_opadding);
        _md.update(inner);
        return _md.digest();
    };
    // alias for getMac
    ctx.digest = ctx.getMac;
    return ctx;
};


var $9cfab45a4362002b$exports = {};
/**
 * Message Digest Algorithm 5 with 128-bit digest (MD5) implementation.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 */ 
var $cLQG7 = parcelRequire("cLQG7");
parcelRequire("4pr5e");

var $9cfab45a4362002b$var$md5 = $9cfab45a4362002b$exports = $cLQG7.md5 = $cLQG7.md5 || {};
$cLQG7.md.md5 = $cLQG7.md.algorithms.md5 = $9cfab45a4362002b$var$md5;
/**
 * Creates an MD5 message digest object.
 *
 * @return a message digest object.
 */ $9cfab45a4362002b$var$md5.create = function() {
    // do initialization as necessary
    if (!$9cfab45a4362002b$var$_initialized) $9cfab45a4362002b$var$_init();
    // MD5 state contains four 32-bit integers
    var _state = null;
    // input buffer
    var _input = $cLQG7.util.createBuffer();
    // used for word storage
    var _w = new Array(16);
    // message digest object
    var md = {
        algorithm: 'md5',
        blockLength: 64,
        digestLength: 16,
        // 56-bit length of message so far (does not including padding)
        messageLength: 0,
        // true message length
        fullMessageLength: null,
        // size of message length in bytes
        messageLengthSize: 8
    };
    /**
   * Starts the digest.
   *
   * @return this digest object.
   */ md.start = function() {
        // up to 56-bit message length for convenience
        md.messageLength = 0;
        // full message length (set md.messageLength64 for backwards-compatibility)
        md.fullMessageLength = md.messageLength64 = [];
        var int32s = md.messageLengthSize / 4;
        for(var i = 0; i < int32s; ++i)md.fullMessageLength.push(0);
        _input = $cLQG7.util.createBuffer();
        _state = {
            h0: 0x67452301,
            h1: 0xEFCDAB89,
            h2: 0x98BADCFE,
            h3: 0x10325476
        };
        return md;
    };
    // start digest automatically for first time
    md.start();
    /**
   * Updates the digest with the given message input. The given input can
   * treated as raw input (no encoding will be applied) or an encoding of
   * 'utf8' maybe given to encode the input using UTF-8.
   *
   * @param msg the message input to update with.
   * @param encoding the encoding to use (default: 'raw', other: 'utf8').
   *
   * @return this digest object.
   */ md.update = function(msg, encoding) {
        if (encoding === 'utf8') msg = $cLQG7.util.encodeUtf8(msg);
        // update message length
        var len = msg.length;
        md.messageLength += len;
        len = [
            len / 0x100000000 >>> 0,
            len >>> 0
        ];
        for(var i = md.fullMessageLength.length - 1; i >= 0; --i){
            md.fullMessageLength[i] += len[1];
            len[1] = len[0] + (md.fullMessageLength[i] / 0x100000000 >>> 0);
            md.fullMessageLength[i] = md.fullMessageLength[i] >>> 0;
            len[0] = len[1] / 0x100000000 >>> 0;
        }
        // add bytes to input buffer
        _input.putBytes(msg);
        // process bytes
        $9cfab45a4362002b$var$_update(_state, _w, _input);
        // compact input buffer every 2K or if empty
        if (_input.read > 2048 || _input.length() === 0) _input.compact();
        return md;
    };
    /**
   * Produces the digest.
   *
   * @return a byte buffer containing the digest value.
   */ md.digest = function() {
        /* Note: Here we copy the remaining bytes in the input buffer and
    add the appropriate MD5 padding. Then we do the final update
    on a copy of the state so that if the user wants to get
    intermediate digests they can do so. */ /* Determine the number of bytes that must be added to the message
    to ensure its length is congruent to 448 mod 512. In other words,
    the data to be digested must be a multiple of 512 bits (or 128 bytes).
    This data includes the message, some padding, and the length of the
    message. Since the length of the message will be encoded as 8 bytes (64
    bits), that means that the last segment of the data must have 56 bytes
    (448 bits) of message and padding. Therefore, the length of the message
    plus the padding must be congruent to 448 mod 512 because
    512 - 128 = 448.

    In order to fill up the message length it must be filled with
    padding that begins with 1 bit followed by all 0 bits. Padding
    must *always* be present, so if the message length is already
    congruent to 448 mod 512, then 512 padding bits must be added. */ var finalBlock = $cLQG7.util.createBuffer();
        finalBlock.putBytes(_input.bytes());
        // compute remaining size to be digested (include message length size)
        var remaining = md.fullMessageLength[md.fullMessageLength.length - 1] + md.messageLengthSize;
        // add padding for overflow blockSize - overflow
        // _padding starts with 1 byte with first bit is set (byte value 128), then
        // there may be up to (blockSize - 1) other pad bytes
        var overflow = remaining & md.blockLength - 1;
        finalBlock.putBytes($9cfab45a4362002b$var$_padding.substr(0, md.blockLength - overflow));
        // serialize message length in bits in little-endian order; since length
        // is stored in bytes we multiply by 8 and add carry
        var bits, carry = 0;
        for(var i = md.fullMessageLength.length - 1; i >= 0; --i){
            bits = md.fullMessageLength[i] * 8 + carry;
            carry = bits / 0x100000000 >>> 0;
            finalBlock.putInt32Le(bits >>> 0);
        }
        var s2 = {
            h0: _state.h0,
            h1: _state.h1,
            h2: _state.h2,
            h3: _state.h3
        };
        $9cfab45a4362002b$var$_update(s2, _w, finalBlock);
        var rval = $cLQG7.util.createBuffer();
        rval.putInt32Le(s2.h0);
        rval.putInt32Le(s2.h1);
        rval.putInt32Le(s2.h2);
        rval.putInt32Le(s2.h3);
        return rval;
    };
    return md;
};
// padding, constant tables for calculating md5
var $9cfab45a4362002b$var$_padding = null;
var $9cfab45a4362002b$var$_g = null;
var $9cfab45a4362002b$var$_r = null;
var $9cfab45a4362002b$var$_k = null;
var $9cfab45a4362002b$var$_initialized = false;
/**
 * Initializes the constant tables.
 */ function $9cfab45a4362002b$var$_init() {
    // create padding
    $9cfab45a4362002b$var$_padding = String.fromCharCode(128);
    $9cfab45a4362002b$var$_padding += $cLQG7.util.fillString(String.fromCharCode(0x00), 64);
    // g values
    $9cfab45a4362002b$var$_g = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        1,
        6,
        11,
        0,
        5,
        10,
        15,
        4,
        9,
        14,
        3,
        8,
        13,
        2,
        7,
        12,
        5,
        8,
        11,
        14,
        1,
        4,
        7,
        10,
        13,
        0,
        3,
        6,
        9,
        12,
        15,
        2,
        0,
        7,
        14,
        5,
        12,
        3,
        10,
        1,
        8,
        15,
        6,
        13,
        4,
        11,
        2,
        9
    ];
    // rounds table
    $9cfab45a4362002b$var$_r = [
        7,
        12,
        17,
        22,
        7,
        12,
        17,
        22,
        7,
        12,
        17,
        22,
        7,
        12,
        17,
        22,
        5,
        9,
        14,
        20,
        5,
        9,
        14,
        20,
        5,
        9,
        14,
        20,
        5,
        9,
        14,
        20,
        4,
        11,
        16,
        23,
        4,
        11,
        16,
        23,
        4,
        11,
        16,
        23,
        4,
        11,
        16,
        23,
        6,
        10,
        15,
        21,
        6,
        10,
        15,
        21,
        6,
        10,
        15,
        21,
        6,
        10,
        15,
        21
    ];
    // get the result of abs(sin(i + 1)) as a 32-bit integer
    $9cfab45a4362002b$var$_k = new Array(64);
    for(var i = 0; i < 64; ++i)$9cfab45a4362002b$var$_k[i] = Math.floor(Math.abs(Math.sin(i + 1)) * 0x100000000);
    // now initialized
    $9cfab45a4362002b$var$_initialized = true;
}
/**
 * Updates an MD5 state with the given byte buffer.
 *
 * @param s the MD5 state to update.
 * @param w the array to use to store words.
 * @param bytes the byte buffer to update with.
 */ function $9cfab45a4362002b$var$_update(s, w, bytes) {
    // consume 512 bit (64 byte) chunks
    var t, a, b, c, d, f, r, i;
    var len = bytes.length();
    while(len >= 64){
        // initialize hash value for this chunk
        a = s.h0;
        b = s.h1;
        c = s.h2;
        d = s.h3;
        // round 1
        for(i = 0; i < 16; ++i){
            w[i] = bytes.getInt32Le();
            f = d ^ b & (c ^ d);
            t = a + f + $9cfab45a4362002b$var$_k[i] + w[i];
            r = $9cfab45a4362002b$var$_r[i];
            a = d;
            d = c;
            c = b;
            b += t << r | t >>> 32 - r;
        }
        // round 2
        for(; i < 32; ++i){
            f = c ^ d & (b ^ c);
            t = a + f + $9cfab45a4362002b$var$_k[i] + w[$9cfab45a4362002b$var$_g[i]];
            r = $9cfab45a4362002b$var$_r[i];
            a = d;
            d = c;
            c = b;
            b += t << r | t >>> 32 - r;
        }
        // round 3
        for(; i < 48; ++i){
            f = b ^ c ^ d;
            t = a + f + $9cfab45a4362002b$var$_k[i] + w[$9cfab45a4362002b$var$_g[i]];
            r = $9cfab45a4362002b$var$_r[i];
            a = d;
            d = c;
            c = b;
            b += t << r | t >>> 32 - r;
        }
        // round 4
        for(; i < 64; ++i){
            f = c ^ (b | ~d);
            t = a + f + $9cfab45a4362002b$var$_k[i] + w[$9cfab45a4362002b$var$_g[i]];
            r = $9cfab45a4362002b$var$_r[i];
            a = d;
            d = c;
            c = b;
            b += t << r | t >>> 32 - r;
        }
        // update hash state
        s.h0 = s.h0 + a | 0;
        s.h1 = s.h1 + b | 0;
        s.h2 = s.h2 + c | 0;
        s.h3 = s.h3 + d | 0;
        len -= 64;
    }
}


var $ad43954579839d68$exports = {};
/**
 * Javascript implementation of basic PEM (Privacy Enhanced Mail) algorithms.
 *
 * See: RFC 1421.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2013-2014 Digital Bazaar, Inc.
 *
 * A Forge PEM object has the following fields:
 *
 * type: identifies the type of message (eg: "RSA PRIVATE KEY").
 *
 * procType: identifies the type of processing performed on the message,
 *   it has two subfields: version and type, eg: 4,ENCRYPTED.
 *
 * contentDomain: identifies the type of content in the message, typically
 *   only uses the value: "RFC822".
 *
 * dekInfo: identifies the message encryption algorithm and mode and includes
 *   any parameters for the algorithm, it has two subfields: algorithm and
 *   parameters, eg: DES-CBC,F8143EDE5960C597.
 *
 * headers: contains all other PEM encapsulated headers -- where order is
 *   significant (for pairing data like recipient ID + key info).
 *
 * body: the binary-encoded body.
 */ 
var $cLQG7 = parcelRequire("cLQG7");

// shortcut for pem API
var $ad43954579839d68$var$pem = $ad43954579839d68$exports = $cLQG7.pem = $cLQG7.pem || {};
/**
 * Encodes (serializes) the given PEM object.
 *
 * @param msg the PEM message object to encode.
 * @param options the options to use:
 *          maxline the maximum characters per line for the body, (default: 64).
 *
 * @return the PEM-formatted string.
 */ $ad43954579839d68$var$pem.encode = function(msg, options) {
    options = options || {};
    var rval = '-----BEGIN ' + msg.type + '-----\r\n';
    // encode special headers
    var header;
    if (msg.procType) {
        header = {
            name: 'Proc-Type',
            values: [
                String(msg.procType.version),
                msg.procType.type
            ]
        };
        rval += $ad43954579839d68$var$foldHeader(header);
    }
    if (msg.contentDomain) {
        header = {
            name: 'Content-Domain',
            values: [
                msg.contentDomain
            ]
        };
        rval += $ad43954579839d68$var$foldHeader(header);
    }
    if (msg.dekInfo) {
        header = {
            name: 'DEK-Info',
            values: [
                msg.dekInfo.algorithm
            ]
        };
        if (msg.dekInfo.parameters) header.values.push(msg.dekInfo.parameters);
        rval += $ad43954579839d68$var$foldHeader(header);
    }
    if (msg.headers) // encode all other headers
    for(var i = 0; i < msg.headers.length; ++i)rval += $ad43954579839d68$var$foldHeader(msg.headers[i]);
    // terminate header
    if (msg.procType) rval += '\r\n';
    // add body
    rval += $cLQG7.util.encode64(msg.body, options.maxline || 64) + '\r\n';
    rval += '-----END ' + msg.type + '-----\r\n';
    return rval;
};
/**
 * Decodes (deserializes) all PEM messages found in the given string.
 *
 * @param str the PEM-formatted string to decode.
 *
 * @return the PEM message objects in an array.
 */ $ad43954579839d68$var$pem.decode = function(str) {
    var rval = [];
    // split string into PEM messages (be lenient w/EOF on BEGIN line)
    var rMessage = /\s*-----BEGIN ([A-Z0-9- ]+)-----\r?\n?([\x21-\x7e\s]+?(?:\r?\n\r?\n))?([:A-Za-z0-9+\/=\s]+?)-----END \1-----/g;
    var rHeader = /([\x21-\x7e]+):\s*([\x21-\x7e\s^:]+)/;
    var rCRLF = /\r?\n/;
    var match;
    while(true){
        match = rMessage.exec(str);
        if (!match) break;
        // accept "NEW CERTIFICATE REQUEST" as "CERTIFICATE REQUEST"
        // https://datatracker.ietf.org/doc/html/rfc7468#section-7
        var type = match[1];
        if (type === 'NEW CERTIFICATE REQUEST') type = 'CERTIFICATE REQUEST';
        var msg = {
            type: type,
            procType: null,
            contentDomain: null,
            dekInfo: null,
            headers: [],
            body: $cLQG7.util.decode64(match[3])
        };
        rval.push(msg);
        // no headers
        if (!match[2]) continue;
        // parse headers
        var lines = match[2].split(rCRLF);
        var li = 0;
        while(match && li < lines.length){
            // get line, trim any rhs whitespace
            var line = lines[li].replace(/\s+$/, '');
            // RFC2822 unfold any following folded lines
            for(var nl = li + 1; nl < lines.length; ++nl){
                var next = lines[nl];
                if (!/\s/.test(next[0])) break;
                line += next;
                li = nl;
            }
            // parse header
            match = line.match(rHeader);
            if (match) {
                var header = {
                    name: match[1],
                    values: []
                };
                var values = match[2].split(',');
                for(var vi = 0; vi < values.length; ++vi)header.values.push($ad43954579839d68$var$ltrim(values[vi]));
                // Proc-Type must be the first header
                if (!msg.procType) {
                    if (header.name !== 'Proc-Type') throw new Error('Invalid PEM formatted message. The first encapsulated header must be "Proc-Type".');
                    else if (header.values.length !== 2) throw new Error('Invalid PEM formatted message. The "Proc-Type" header must have two subfields.');
                    msg.procType = {
                        version: values[0],
                        type: values[1]
                    };
                } else if (!msg.contentDomain && header.name === 'Content-Domain') // special-case Content-Domain
                msg.contentDomain = values[0] || '';
                else if (!msg.dekInfo && header.name === 'DEK-Info') {
                    // special-case DEK-Info
                    if (header.values.length === 0) throw new Error('Invalid PEM formatted message. The "DEK-Info" header must have at least one subfield.');
                    msg.dekInfo = {
                        algorithm: values[0],
                        parameters: values[1] || null
                    };
                } else msg.headers.push(header);
            }
            ++li;
        }
        if (msg.procType === 'ENCRYPTED' && !msg.dekInfo) throw new Error('Invalid PEM formatted message. The "DEK-Info" header must be present if "Proc-Type" is "ENCRYPTED".');
    }
    if (rval.length === 0) throw new Error('Invalid PEM formatted message.');
    return rval;
};
function $ad43954579839d68$var$foldHeader(header) {
    var rval = header.name + ': ';
    // ensure values with CRLF are folded
    var values = [];
    var insertSpace = function(match, $1) {
        return ' ' + $1;
    };
    for(var i = 0; i < header.values.length; ++i)values.push(header.values[i].replace(/^(\S+\r\n)/, insertSpace));
    rval += values.join(',') + '\r\n';
    // do folding
    var length = 0;
    var candidate = -1;
    for(var i = 0; i < rval.length; ++i, ++length){
        if (length > 65 && candidate !== -1) {
            var insert = rval[candidate];
            if (insert === ',') {
                ++candidate;
                rval = rval.substr(0, candidate) + '\r\n ' + rval.substr(candidate);
            } else rval = rval.substr(0, candidate) + '\r\n' + insert + rval.substr(candidate + 1);
            length = i - candidate - 1;
            candidate = -1;
            ++i;
        } else if (rval[i] === ' ' || rval[i] === '\t' || rval[i] === ',') candidate = i;
    }
    return rval;
}
function $ad43954579839d68$var$ltrim(str) {
    return str.replace(/^\s+/, '');
}


var $6bd7e8fcd58ea02f$exports = {};
/**
 * Javascript implementation of a basic Public Key Infrastructure, including
 * support for RSA public and private keys.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2013 Digital Bazaar, Inc.
 */ 
var $cLQG7 = parcelRequire("cLQG7");


var $3d7fb12bbd6a187a$exports = {};
/**
 * Password-based encryption functions.
 *
 * @author Dave Longley
 * @author Stefan Siegl <stesie@brokenpipe.de>
 *
 * Copyright (c) 2010-2013 Digital Bazaar, Inc.
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 *
 * An EncryptedPrivateKeyInfo:
 *
 * EncryptedPrivateKeyInfo ::= SEQUENCE {
 *   encryptionAlgorithm  EncryptionAlgorithmIdentifier,
 *   encryptedData        EncryptedData }
 *
 * EncryptionAlgorithmIdentifier ::= AlgorithmIdentifier
 *
 * EncryptedData ::= OCTET STRING
 */ 
var $cLQG7 = parcelRequire("cLQG7");


var $b0ec43ec638f67d5$exports = {};
/**
 * DES (Data Encryption Standard) implementation.
 *
 * This implementation supports DES as well as 3DES-EDE in ECB and CBC mode.
 * It is based on the BSD-licensed implementation by Paul Tero:
 *
 * Paul Tero, July 2001
 * http://www.tero.co.uk/des/
 *
 * Optimised for performance with large blocks by
 * Michael Hayworth, November 2001
 * http://www.netdealing.com
 *
 * THIS SOFTWARE IS PROVIDED "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED.  IN NO EVENT SHALL THE AUTHOR OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS
 * OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
 * HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF
 * SUCH DAMAGE.
 *
 * @author Stefan Siegl
 * @author Dave Longley
 *
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 * Copyright (c) 2012-2014 Digital Bazaar, Inc.
 */ 
var $cLQG7 = parcelRequire("cLQG7");



/* DES API */ $b0ec43ec638f67d5$exports = $cLQG7.des = $cLQG7.des || {};
/**
 * Deprecated. Instead, use:
 *
 * var cipher = forge.cipher.createCipher('DES-<mode>', key);
 * cipher.start({iv: iv});
 *
 * Creates an DES cipher object to encrypt data using the given symmetric key.
 * The output will be stored in the 'output' member of the returned cipher.
 *
 * The key and iv may be given as binary-encoded strings of bytes or
 * byte buffers.
 *
 * @param key the symmetric key to use (64 or 192 bits).
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 * @param mode the cipher mode to use (default: 'CBC' if IV is
 *          given, 'ECB' if null).
 *
 * @return the cipher.
 */ $cLQG7.des.startEncrypting = function(key, iv, output, mode) {
    var cipher = $b0ec43ec638f67d5$var$_createCipher({
        key: key,
        output: output,
        decrypt: false,
        mode: mode || (iv === null ? 'ECB' : 'CBC')
    });
    cipher.start(iv);
    return cipher;
};
/**
 * Deprecated. Instead, use:
 *
 * var cipher = forge.cipher.createCipher('DES-<mode>', key);
 *
 * Creates an DES cipher object to encrypt data using the given symmetric key.
 *
 * The key may be given as a binary-encoded string of bytes or a byte buffer.
 *
 * @param key the symmetric key to use (64 or 192 bits).
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $cLQG7.des.createEncryptionCipher = function(key, mode) {
    return $b0ec43ec638f67d5$var$_createCipher({
        key: key,
        output: null,
        decrypt: false,
        mode: mode
    });
};
/**
 * Deprecated. Instead, use:
 *
 * var decipher = forge.cipher.createDecipher('DES-<mode>', key);
 * decipher.start({iv: iv});
 *
 * Creates an DES cipher object to decrypt data using the given symmetric key.
 * The output will be stored in the 'output' member of the returned cipher.
 *
 * The key and iv may be given as binary-encoded strings of bytes or
 * byte buffers.
 *
 * @param key the symmetric key to use (64 or 192 bits).
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 * @param mode the cipher mode to use (default: 'CBC' if IV is
 *          given, 'ECB' if null).
 *
 * @return the cipher.
 */ $cLQG7.des.startDecrypting = function(key, iv, output, mode) {
    var cipher = $b0ec43ec638f67d5$var$_createCipher({
        key: key,
        output: output,
        decrypt: true,
        mode: mode || (iv === null ? 'ECB' : 'CBC')
    });
    cipher.start(iv);
    return cipher;
};
/**
 * Deprecated. Instead, use:
 *
 * var decipher = forge.cipher.createDecipher('DES-<mode>', key);
 *
 * Creates an DES cipher object to decrypt data using the given symmetric key.
 *
 * The key may be given as a binary-encoded string of bytes or a byte buffer.
 *
 * @param key the symmetric key to use (64 or 192 bits).
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $cLQG7.des.createDecryptionCipher = function(key, mode) {
    return $b0ec43ec638f67d5$var$_createCipher({
        key: key,
        output: null,
        decrypt: true,
        mode: mode
    });
};
/**
 * Creates a new DES cipher algorithm object.
 *
 * @param name the name of the algorithm.
 * @param mode the mode factory function.
 *
 * @return the DES algorithm object.
 */ $cLQG7.des.Algorithm = function(name, mode) {
    var self = this;
    self.name = name;
    self.mode = new mode({
        blockSize: 8,
        cipher: {
            encrypt: function(inBlock, outBlock) {
                return $b0ec43ec638f67d5$var$_updateBlock(self._keys, inBlock, outBlock, false);
            },
            decrypt: function(inBlock, outBlock) {
                return $b0ec43ec638f67d5$var$_updateBlock(self._keys, inBlock, outBlock, true);
            }
        }
    });
    self._init = false;
};
/**
 * Initializes this DES algorithm by expanding its key.
 *
 * @param options the options to use.
 *          key the key to use with this algorithm.
 *          decrypt true if the algorithm should be initialized for decryption,
 *            false for encryption.
 */ $cLQG7.des.Algorithm.prototype.initialize = function(options) {
    if (this._init) return;
    var key = $cLQG7.util.createBuffer(options.key);
    if (this.name.indexOf('3DES') === 0) {
        if (key.length() !== 24) throw new Error('Invalid Triple-DES key size: ' + key.length() * 8);
    }
    // do key expansion to 16 or 48 subkeys (single or triple DES)
    this._keys = $b0ec43ec638f67d5$var$_createKeys(key);
    this._init = true;
};
/** Register DES algorithms **/ $b0ec43ec638f67d5$var$registerAlgorithm('DES-ECB', $cLQG7.cipher.modes.ecb);
$b0ec43ec638f67d5$var$registerAlgorithm('DES-CBC', $cLQG7.cipher.modes.cbc);
$b0ec43ec638f67d5$var$registerAlgorithm('DES-CFB', $cLQG7.cipher.modes.cfb);
$b0ec43ec638f67d5$var$registerAlgorithm('DES-OFB', $cLQG7.cipher.modes.ofb);
$b0ec43ec638f67d5$var$registerAlgorithm('DES-CTR', $cLQG7.cipher.modes.ctr);
$b0ec43ec638f67d5$var$registerAlgorithm('3DES-ECB', $cLQG7.cipher.modes.ecb);
$b0ec43ec638f67d5$var$registerAlgorithm('3DES-CBC', $cLQG7.cipher.modes.cbc);
$b0ec43ec638f67d5$var$registerAlgorithm('3DES-CFB', $cLQG7.cipher.modes.cfb);
$b0ec43ec638f67d5$var$registerAlgorithm('3DES-OFB', $cLQG7.cipher.modes.ofb);
$b0ec43ec638f67d5$var$registerAlgorithm('3DES-CTR', $cLQG7.cipher.modes.ctr);
function $b0ec43ec638f67d5$var$registerAlgorithm(name, mode) {
    var factory = function() {
        return new $cLQG7.des.Algorithm(name, mode);
    };
    $cLQG7.cipher.registerAlgorithm(name, factory);
}
/** DES implementation **/ var $b0ec43ec638f67d5$var$spfunction1 = [
    0x1010400,
    0,
    0x10000,
    0x1010404,
    0x1010004,
    0x10404,
    0x4,
    0x10000,
    0x400,
    0x1010400,
    0x1010404,
    0x400,
    0x1000404,
    0x1010004,
    0x1000000,
    0x4,
    0x404,
    0x1000400,
    0x1000400,
    0x10400,
    0x10400,
    0x1010000,
    0x1010000,
    0x1000404,
    0x10004,
    0x1000004,
    0x1000004,
    0x10004,
    0,
    0x404,
    0x10404,
    0x1000000,
    0x10000,
    0x1010404,
    0x4,
    0x1010000,
    0x1010400,
    0x1000000,
    0x1000000,
    0x400,
    0x1010004,
    0x10000,
    0x10400,
    0x1000004,
    0x400,
    0x4,
    0x1000404,
    0x10404,
    0x1010404,
    0x10004,
    0x1010000,
    0x1000404,
    0x1000004,
    0x404,
    0x10404,
    0x1010400,
    0x404,
    0x1000400,
    0x1000400,
    0,
    0x10004,
    0x10400,
    0,
    0x1010004
];
var $b0ec43ec638f67d5$var$spfunction2 = [
    -2146402272,
    -2147450880,
    0x8000,
    0x108020,
    0x100000,
    0x20,
    -2146435040,
    -2147450848,
    -2147483616,
    -2146402272,
    -2146402304,
    -2147483648,
    -2147450880,
    0x100000,
    0x20,
    -2146435040,
    0x108000,
    0x100020,
    -2147450848,
    0,
    -2147483648,
    0x8000,
    0x108020,
    -2146435072,
    0x100020,
    -2147483616,
    0,
    0x108000,
    0x8020,
    -2146402304,
    -2146435072,
    0x8020,
    0,
    0x108020,
    -2146435040,
    0x100000,
    -2147450848,
    -2146435072,
    -2146402304,
    0x8000,
    -2146435072,
    -2147450880,
    0x20,
    -2146402272,
    0x108020,
    0x20,
    0x8000,
    -2147483648,
    0x8020,
    -2146402304,
    0x100000,
    -2147483616,
    0x100020,
    -2147450848,
    -2147483616,
    0x100020,
    0x108000,
    0,
    -2147450880,
    0x8020,
    -2147483648,
    -2146435040,
    -2146402272,
    0x108000
];
var $b0ec43ec638f67d5$var$spfunction3 = [
    0x208,
    0x8020200,
    0,
    0x8020008,
    0x8000200,
    0,
    0x20208,
    0x8000200,
    0x20008,
    0x8000008,
    0x8000008,
    0x20000,
    0x8020208,
    0x20008,
    0x8020000,
    0x208,
    0x8000000,
    0x8,
    0x8020200,
    0x200,
    0x20200,
    0x8020000,
    0x8020008,
    0x20208,
    0x8000208,
    0x20200,
    0x20000,
    0x8000208,
    0x8,
    0x8020208,
    0x200,
    0x8000000,
    0x8020200,
    0x8000000,
    0x20008,
    0x208,
    0x20000,
    0x8020200,
    0x8000200,
    0,
    0x200,
    0x20008,
    0x8020208,
    0x8000200,
    0x8000008,
    0x200,
    0,
    0x8020008,
    0x8000208,
    0x20000,
    0x8000000,
    0x8020208,
    0x8,
    0x20208,
    0x20200,
    0x8000008,
    0x8020000,
    0x8000208,
    0x208,
    0x8020000,
    0x20208,
    0x8,
    0x8020008,
    0x20200
];
var $b0ec43ec638f67d5$var$spfunction4 = [
    0x802001,
    0x2081,
    0x2081,
    0x80,
    0x802080,
    0x800081,
    0x800001,
    0x2001,
    0,
    0x802000,
    0x802000,
    0x802081,
    0x81,
    0,
    0x800080,
    0x800001,
    0x1,
    0x2000,
    0x800000,
    0x802001,
    0x80,
    0x800000,
    0x2001,
    0x2080,
    0x800081,
    0x1,
    0x2080,
    0x800080,
    0x2000,
    0x802080,
    0x802081,
    0x81,
    0x800080,
    0x800001,
    0x802000,
    0x802081,
    0x81,
    0,
    0,
    0x802000,
    0x2080,
    0x800080,
    0x800081,
    0x1,
    0x802001,
    0x2081,
    0x2081,
    0x80,
    0x802081,
    0x81,
    0x1,
    0x2000,
    0x800001,
    0x2001,
    0x802080,
    0x800081,
    0x2001,
    0x2080,
    0x800000,
    0x802001,
    0x80,
    0x800000,
    0x2000,
    0x802080
];
var $b0ec43ec638f67d5$var$spfunction5 = [
    0x100,
    0x2080100,
    0x2080000,
    0x42000100,
    0x80000,
    0x100,
    0x40000000,
    0x2080000,
    0x40080100,
    0x80000,
    0x2000100,
    0x40080100,
    0x42000100,
    0x42080000,
    0x80100,
    0x40000000,
    0x2000000,
    0x40080000,
    0x40080000,
    0,
    0x40000100,
    0x42080100,
    0x42080100,
    0x2000100,
    0x42080000,
    0x40000100,
    0,
    0x42000000,
    0x2080100,
    0x2000000,
    0x42000000,
    0x80100,
    0x80000,
    0x42000100,
    0x100,
    0x2000000,
    0x40000000,
    0x2080000,
    0x42000100,
    0x40080100,
    0x2000100,
    0x40000000,
    0x42080000,
    0x2080100,
    0x40080100,
    0x100,
    0x2000000,
    0x42080000,
    0x42080100,
    0x80100,
    0x42000000,
    0x42080100,
    0x2080000,
    0,
    0x40080000,
    0x42000000,
    0x80100,
    0x2000100,
    0x40000100,
    0x80000,
    0,
    0x40080000,
    0x2080100,
    0x40000100
];
var $b0ec43ec638f67d5$var$spfunction6 = [
    0x20000010,
    0x20400000,
    0x4000,
    0x20404010,
    0x20400000,
    0x10,
    0x20404010,
    0x400000,
    0x20004000,
    0x404010,
    0x400000,
    0x20000010,
    0x400010,
    0x20004000,
    0x20000000,
    0x4010,
    0,
    0x400010,
    0x20004010,
    0x4000,
    0x404000,
    0x20004010,
    0x10,
    0x20400010,
    0x20400010,
    0,
    0x404010,
    0x20404000,
    0x4010,
    0x404000,
    0x20404000,
    0x20000000,
    0x20004000,
    0x10,
    0x20400010,
    0x404000,
    0x20404010,
    0x400000,
    0x4010,
    0x20000010,
    0x400000,
    0x20004000,
    0x20000000,
    0x4010,
    0x20000010,
    0x20404010,
    0x404000,
    0x20400000,
    0x404010,
    0x20404000,
    0,
    0x20400010,
    0x10,
    0x4000,
    0x20400000,
    0x404010,
    0x4000,
    0x400010,
    0x20004010,
    0,
    0x20404000,
    0x20000000,
    0x400010,
    0x20004010
];
var $b0ec43ec638f67d5$var$spfunction7 = [
    0x200000,
    0x4200002,
    0x4000802,
    0,
    0x800,
    0x4000802,
    0x200802,
    0x4200800,
    0x4200802,
    0x200000,
    0,
    0x4000002,
    0x2,
    0x4000000,
    0x4200002,
    0x802,
    0x4000800,
    0x200802,
    0x200002,
    0x4000800,
    0x4000002,
    0x4200000,
    0x4200800,
    0x200002,
    0x4200000,
    0x800,
    0x802,
    0x4200802,
    0x200800,
    0x2,
    0x4000000,
    0x200800,
    0x4000000,
    0x200800,
    0x200000,
    0x4000802,
    0x4000802,
    0x4200002,
    0x4200002,
    0x2,
    0x200002,
    0x4000000,
    0x4000800,
    0x200000,
    0x4200800,
    0x802,
    0x200802,
    0x4200800,
    0x802,
    0x4000002,
    0x4200802,
    0x4200000,
    0x200800,
    0,
    0x2,
    0x4200802,
    0,
    0x200802,
    0x4200000,
    0x800,
    0x4000002,
    0x4000800,
    0x800,
    0x200002
];
var $b0ec43ec638f67d5$var$spfunction8 = [
    0x10001040,
    0x1000,
    0x40000,
    0x10041040,
    0x10000000,
    0x10001040,
    0x40,
    0x10000000,
    0x40040,
    0x10040000,
    0x10041040,
    0x41000,
    0x10041000,
    0x41040,
    0x1000,
    0x40,
    0x10040000,
    0x10000040,
    0x10001000,
    0x1040,
    0x41000,
    0x40040,
    0x10040040,
    0x10041000,
    0x1040,
    0,
    0,
    0x10040040,
    0x10000040,
    0x10001000,
    0x41040,
    0x40000,
    0x41040,
    0x40000,
    0x10041000,
    0x1000,
    0x40,
    0x10040040,
    0x1000,
    0x41040,
    0x10001000,
    0x40,
    0x10000040,
    0x10040000,
    0x10040040,
    0x10000000,
    0x40000,
    0x10001040,
    0,
    0x10041040,
    0x40040,
    0x10000040,
    0x10040000,
    0x10001000,
    0x10001040,
    0,
    0x10041040,
    0x41000,
    0x41000,
    0x1040,
    0x1040,
    0x40040,
    0x10000000,
    0x10041000
];
/**
 * Create necessary sub keys.
 *
 * @param key the 64-bit or 192-bit key.
 *
 * @return the expanded keys.
 */ function $b0ec43ec638f67d5$var$_createKeys(key) {
    var pc2bytes0 = [
        0,
        0x4,
        0x20000000,
        0x20000004,
        0x10000,
        0x10004,
        0x20010000,
        0x20010004,
        0x200,
        0x204,
        0x20000200,
        0x20000204,
        0x10200,
        0x10204,
        0x20010200,
        0x20010204
    ], pc2bytes1 = [
        0,
        0x1,
        0x100000,
        0x100001,
        0x4000000,
        0x4000001,
        0x4100000,
        0x4100001,
        0x100,
        0x101,
        0x100100,
        0x100101,
        0x4000100,
        0x4000101,
        0x4100100,
        0x4100101
    ], pc2bytes2 = [
        0,
        0x8,
        0x800,
        0x808,
        0x1000000,
        0x1000008,
        0x1000800,
        0x1000808,
        0,
        0x8,
        0x800,
        0x808,
        0x1000000,
        0x1000008,
        0x1000800,
        0x1000808
    ], pc2bytes3 = [
        0,
        0x200000,
        0x8000000,
        0x8200000,
        0x2000,
        0x202000,
        0x8002000,
        0x8202000,
        0x20000,
        0x220000,
        0x8020000,
        0x8220000,
        0x22000,
        0x222000,
        0x8022000,
        0x8222000
    ], pc2bytes4 = [
        0,
        0x40000,
        0x10,
        0x40010,
        0,
        0x40000,
        0x10,
        0x40010,
        0x1000,
        0x41000,
        0x1010,
        0x41010,
        0x1000,
        0x41000,
        0x1010,
        0x41010
    ], pc2bytes5 = [
        0,
        0x400,
        0x20,
        0x420,
        0,
        0x400,
        0x20,
        0x420,
        0x2000000,
        0x2000400,
        0x2000020,
        0x2000420,
        0x2000000,
        0x2000400,
        0x2000020,
        0x2000420
    ], pc2bytes6 = [
        0,
        0x10000000,
        0x80000,
        0x10080000,
        0x2,
        0x10000002,
        0x80002,
        0x10080002,
        0,
        0x10000000,
        0x80000,
        0x10080000,
        0x2,
        0x10000002,
        0x80002,
        0x10080002
    ], pc2bytes7 = [
        0,
        0x10000,
        0x800,
        0x10800,
        0x20000000,
        0x20010000,
        0x20000800,
        0x20010800,
        0x20000,
        0x30000,
        0x20800,
        0x30800,
        0x20020000,
        0x20030000,
        0x20020800,
        0x20030800
    ], pc2bytes8 = [
        0,
        0x40000,
        0,
        0x40000,
        0x2,
        0x40002,
        0x2,
        0x40002,
        0x2000000,
        0x2040000,
        0x2000000,
        0x2040000,
        0x2000002,
        0x2040002,
        0x2000002,
        0x2040002
    ], pc2bytes9 = [
        0,
        0x10000000,
        0x8,
        0x10000008,
        0,
        0x10000000,
        0x8,
        0x10000008,
        0x400,
        0x10000400,
        0x408,
        0x10000408,
        0x400,
        0x10000400,
        0x408,
        0x10000408
    ], pc2bytes10 = [
        0,
        0x20,
        0,
        0x20,
        0x100000,
        0x100020,
        0x100000,
        0x100020,
        0x2000,
        0x2020,
        0x2000,
        0x2020,
        0x102000,
        0x102020,
        0x102000,
        0x102020
    ], pc2bytes11 = [
        0,
        0x1000000,
        0x200,
        0x1000200,
        0x200000,
        0x1200000,
        0x200200,
        0x1200200,
        0x4000000,
        0x5000000,
        0x4000200,
        0x5000200,
        0x4200000,
        0x5200000,
        0x4200200,
        0x5200200
    ], pc2bytes12 = [
        0,
        0x1000,
        0x8000000,
        0x8001000,
        0x80000,
        0x81000,
        0x8080000,
        0x8081000,
        0x10,
        0x1010,
        0x8000010,
        0x8001010,
        0x80010,
        0x81010,
        0x8080010,
        0x8081010
    ], pc2bytes13 = [
        0,
        0x4,
        0x100,
        0x104,
        0,
        0x4,
        0x100,
        0x104,
        0x1,
        0x5,
        0x101,
        0x105,
        0x1,
        0x5,
        0x101,
        0x105
    ];
    // how many iterations (1 for des, 3 for triple des)
    // changed by Paul 16/6/2007 to use Triple DES for 9+ byte keys
    var iterations = key.length() > 8 ? 3 : 1;
    // stores the return keys
    var keys = [];
    // now define the left shifts which need to be done
    var shifts = [
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0
    ];
    var n = 0, tmp;
    for(var j = 0; j < iterations; j++){
        var left = key.getInt32();
        var right = key.getInt32();
        tmp = (left >>> 4 ^ right) & 0x0f0f0f0f;
        right ^= tmp;
        left ^= tmp << 4;
        tmp = (right >>> -16 ^ left) & 0x0000ffff;
        left ^= tmp;
        right ^= tmp << -16;
        tmp = (left >>> 2 ^ right) & 0x33333333;
        right ^= tmp;
        left ^= tmp << 2;
        tmp = (right >>> -16 ^ left) & 0x0000ffff;
        left ^= tmp;
        right ^= tmp << -16;
        tmp = (left >>> 1 ^ right) & 0x55555555;
        right ^= tmp;
        left ^= tmp << 1;
        tmp = (right >>> 8 ^ left) & 0x00ff00ff;
        left ^= tmp;
        right ^= tmp << 8;
        tmp = (left >>> 1 ^ right) & 0x55555555;
        right ^= tmp;
        left ^= tmp << 1;
        // right needs to be shifted and OR'd with last four bits of left
        tmp = left << 8 | right >>> 20 & 0x000000f0;
        // left needs to be put upside down
        left = right << 24 | right << 8 & 0xff0000 | right >>> 8 & 0xff00 | right >>> 24 & 0xf0;
        right = tmp;
        // now go through and perform these shifts on the left and right keys
        for(var i = 0; i < shifts.length; ++i){
            //shift the keys either one or two bits to the left
            if (shifts[i]) {
                left = left << 2 | left >>> 26;
                right = right << 2 | right >>> 26;
            } else {
                left = left << 1 | left >>> 27;
                right = right << 1 | right >>> 27;
            }
            left &= -15;
            right &= -15;
            // now apply PC-2, in such a way that E is easier when encrypting or
            // decrypting this conversion will look like PC-2 except only the last 6
            // bits of each byte are used rather than 48 consecutive bits and the
            // order of lines will be according to how the S selection functions will
            // be applied: S2, S4, S6, S8, S1, S3, S5, S7
            var lefttmp = pc2bytes0[left >>> 28] | pc2bytes1[left >>> 24 & 0xf] | pc2bytes2[left >>> 20 & 0xf] | pc2bytes3[left >>> 16 & 0xf] | pc2bytes4[left >>> 12 & 0xf] | pc2bytes5[left >>> 8 & 0xf] | pc2bytes6[left >>> 4 & 0xf];
            var righttmp = pc2bytes7[right >>> 28] | pc2bytes8[right >>> 24 & 0xf] | pc2bytes9[right >>> 20 & 0xf] | pc2bytes10[right >>> 16 & 0xf] | pc2bytes11[right >>> 12 & 0xf] | pc2bytes12[right >>> 8 & 0xf] | pc2bytes13[right >>> 4 & 0xf];
            tmp = (righttmp >>> 16 ^ lefttmp) & 0x0000ffff;
            keys[n++] = lefttmp ^ tmp;
            keys[n++] = righttmp ^ tmp << 16;
        }
    }
    return keys;
}
/**
 * Updates a single block (1 byte) using DES. The update will either
 * encrypt or decrypt the block.
 *
 * @param keys the expanded keys.
 * @param input the input block (an array of 32-bit words).
 * @param output the updated output block.
 * @param decrypt true to decrypt the block, false to encrypt it.
 */ function $b0ec43ec638f67d5$var$_updateBlock(keys, input, output, decrypt) {
    // set up loops for single or triple DES
    var iterations = keys.length === 32 ? 3 : 9;
    var looping;
    if (iterations === 3) looping = decrypt ? [
        30,
        -2,
        -2
    ] : [
        0,
        32,
        2
    ];
    else looping = decrypt ? [
        94,
        62,
        -2,
        32,
        64,
        2,
        30,
        -2,
        -2
    ] : [
        0,
        32,
        2,
        62,
        30,
        -2,
        64,
        96,
        2
    ];
    var tmp;
    var left = input[0];
    var right = input[1];
    // first each 64 bit chunk of the message must be permuted according to IP
    tmp = (left >>> 4 ^ right) & 0x0f0f0f0f;
    right ^= tmp;
    left ^= tmp << 4;
    tmp = (left >>> 16 ^ right) & 0x0000ffff;
    right ^= tmp;
    left ^= tmp << 16;
    tmp = (right >>> 2 ^ left) & 0x33333333;
    left ^= tmp;
    right ^= tmp << 2;
    tmp = (right >>> 8 ^ left) & 0x00ff00ff;
    left ^= tmp;
    right ^= tmp << 8;
    tmp = (left >>> 1 ^ right) & 0x55555555;
    right ^= tmp;
    left ^= tmp << 1;
    // rotate left 1 bit
    left = left << 1 | left >>> 31;
    right = right << 1 | right >>> 31;
    for(var j = 0; j < iterations; j += 3){
        var endloop = looping[j + 1];
        var loopinc = looping[j + 2];
        // now go through and perform the encryption or decryption
        for(var i = looping[j]; i != endloop; i += loopinc){
            var right1 = right ^ keys[i];
            var right2 = (right >>> 4 | right << 28) ^ keys[i + 1];
            // passing these bytes through the S selection functions
            tmp = left;
            left = right;
            right = tmp ^ ($b0ec43ec638f67d5$var$spfunction2[right1 >>> 24 & 0x3f] | $b0ec43ec638f67d5$var$spfunction4[right1 >>> 16 & 0x3f] | $b0ec43ec638f67d5$var$spfunction6[right1 >>> 8 & 0x3f] | $b0ec43ec638f67d5$var$spfunction8[right1 & 0x3f] | $b0ec43ec638f67d5$var$spfunction1[right2 >>> 24 & 0x3f] | $b0ec43ec638f67d5$var$spfunction3[right2 >>> 16 & 0x3f] | $b0ec43ec638f67d5$var$spfunction5[right2 >>> 8 & 0x3f] | $b0ec43ec638f67d5$var$spfunction7[right2 & 0x3f]);
        }
        // unreverse left and right
        tmp = left;
        left = right;
        right = tmp;
    }
    // rotate right 1 bit
    left = left >>> 1 | left << 31;
    right = right >>> 1 | right << 31;
    // now perform IP-1, which is IP in the opposite direction
    tmp = (left >>> 1 ^ right) & 0x55555555;
    right ^= tmp;
    left ^= tmp << 1;
    tmp = (right >>> 8 ^ left) & 0x00ff00ff;
    left ^= tmp;
    right ^= tmp << 8;
    tmp = (right >>> 2 ^ left) & 0x33333333;
    left ^= tmp;
    right ^= tmp << 2;
    tmp = (left >>> 16 ^ right) & 0x0000ffff;
    right ^= tmp;
    left ^= tmp << 16;
    tmp = (left >>> 4 ^ right) & 0x0f0f0f0f;
    right ^= tmp;
    left ^= tmp << 4;
    output[0] = left;
    output[1] = right;
}
/**
 * Deprecated. Instead, use:
 *
 * forge.cipher.createCipher('DES-<mode>', key);
 * forge.cipher.createDecipher('DES-<mode>', key);
 *
 * Creates a deprecated DES cipher object. This object's mode will default to
 * CBC (cipher-block-chaining).
 *
 * The key may be given as a binary-encoded string of bytes or a byte buffer.
 *
 * @param options the options to use.
 *          key the symmetric key to use (64 or 192 bits).
 *          output the buffer to write to.
 *          decrypt true for decryption, false for encryption.
 *          mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ function $b0ec43ec638f67d5$var$_createCipher(options) {
    options = options || {};
    var mode = (options.mode || 'CBC').toUpperCase();
    var algorithm = 'DES-' + mode;
    var cipher;
    if (options.decrypt) cipher = $cLQG7.cipher.createDecipher(algorithm, options.key);
    else cipher = $cLQG7.cipher.createCipher(algorithm, options.key);
    // backwards compatible start API
    var start = cipher.start;
    cipher.start = function(iv, options) {
        // backwards compatibility: support second arg as output buffer
        var output = null;
        if (options instanceof $cLQG7.util.ByteBuffer) {
            output = options;
            options = {};
        }
        options = options || {};
        options.output = output;
        options.iv = iv;
        start.call(cipher, options);
    };
    return cipher;
}


parcelRequire("4pr5e");

var $82ed5bbd033e4c05$exports = {};
/**
 * Password-Based Key-Derivation Function #2 implementation.
 *
 * See RFC 2898 for details.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2013 Digital Bazaar, Inc.
 */ 
var $lbUi1 = parcelRequire("lbUi1");
var $82ed5bbd033e4c05$require$Buffer = $lbUi1.Buffer;

var $cLQG7 = parcelRequire("cLQG7");

parcelRequire("4pr5e");

var $82ed5bbd033e4c05$var$pkcs5 = $cLQG7.pkcs5 = $cLQG7.pkcs5 || {};
var $82ed5bbd033e4c05$var$crypto;

if ($cLQG7.util.isNodejs && !$cLQG7.options.usePureJavaScript) $82ed5bbd033e4c05$var$crypto = (parcelRequire("lbUi1"));
/**
 * Derives a key from a password.
 *
 * @param p the password as a binary-encoded string of bytes.
 * @param s the salt as a binary-encoded string of bytes.
 * @param c the iteration count, a positive integer.
 * @param dkLen the intended length, in bytes, of the derived key,
 *          (max: 2^32 - 1) * hash length of the PRF.
 * @param [md] the message digest (or algorithm identifier as a string) to use
 *          in the PRF, defaults to SHA-1.
 * @param [callback(err, key)] presence triggers asynchronous version, called
 *          once the operation completes.
 *
 * @return the derived key, as a binary-encoded string of bytes, for the
 *           synchronous version (if no callback is specified).
 */ $82ed5bbd033e4c05$exports = $cLQG7.pbkdf2 = $82ed5bbd033e4c05$var$pkcs5.pbkdf2 = function(p, s, c, dkLen, md, callback) {
    if (typeof md === 'function') {
        callback = md;
        md = null;
    }
    // use native implementation if possible and not disabled, note that
    // some node versions only support SHA-1, others allow digest to be changed
    if ($cLQG7.util.isNodejs && !$cLQG7.options.usePureJavaScript && $82ed5bbd033e4c05$var$crypto.pbkdf2 && (md === null || typeof md !== 'object') && ($82ed5bbd033e4c05$var$crypto.pbkdf2Sync.length > 4 || !md || md === 'sha1')) {
        if (typeof md !== 'string') // default prf to SHA-1
        md = 'sha1';
        p = $82ed5bbd033e4c05$require$Buffer.from(p, 'binary');
        s = $82ed5bbd033e4c05$require$Buffer.from(s, 'binary');
        if (!callback) {
            if ($82ed5bbd033e4c05$var$crypto.pbkdf2Sync.length === 4) return $82ed5bbd033e4c05$var$crypto.pbkdf2Sync(p, s, c, dkLen).toString('binary');
            return $82ed5bbd033e4c05$var$crypto.pbkdf2Sync(p, s, c, dkLen, md).toString('binary');
        }
        if ($82ed5bbd033e4c05$var$crypto.pbkdf2Sync.length === 4) return $82ed5bbd033e4c05$var$crypto.pbkdf2(p, s, c, dkLen, function(err, key) {
            if (err) return callback(err);
            callback(null, key.toString('binary'));
        });
        return $82ed5bbd033e4c05$var$crypto.pbkdf2(p, s, c, dkLen, md, function(err, key) {
            if (err) return callback(err);
            callback(null, key.toString('binary'));
        });
    }
    if (typeof md === 'undefined' || md === null) // default prf to SHA-1
    md = 'sha1';
    if (typeof md === 'string') {
        if (!(md in $cLQG7.md.algorithms)) throw new Error('Unknown hash algorithm: ' + md);
        md = $cLQG7.md[md].create();
    }
    var hLen = md.digestLength;
    /* 1. If dkLen > (2^32 - 1) * hLen, output "derived key too long" and
    stop. */ if (dkLen > 0xFFFFFFFF * hLen) {
        var err = new Error('Derived key is too long.');
        if (callback) return callback(err);
        throw err;
    }
    /* 2. Let len be the number of hLen-octet blocks in the derived key,
    rounding up, and let r be the number of octets in the last
    block:

    len = CEIL(dkLen / hLen),
    r = dkLen - (len - 1) * hLen. */ var len = Math.ceil(dkLen / hLen);
    var r = dkLen - (len - 1) * hLen;
    /* 3. For each block of the derived key apply the function F defined
    below to the password P, the salt S, the iteration count c, and
    the block index to compute the block:

    T_1 = F(P, S, c, 1),
    T_2 = F(P, S, c, 2),
    ...
    T_len = F(P, S, c, len),

    where the function F is defined as the exclusive-or sum of the
    first c iterates of the underlying pseudorandom function PRF
    applied to the password P and the concatenation of the salt S
    and the block index i:

    F(P, S, c, i) = u_1 XOR u_2 XOR ... XOR u_c

    where

    u_1 = PRF(P, S || INT(i)),
    u_2 = PRF(P, u_1),
    ...
    u_c = PRF(P, u_{c-1}).

    Here, INT(i) is a four-octet encoding of the integer i, most
    significant octet first. */ var prf = $cLQG7.hmac.create();
    prf.start(md, p);
    var dk = '';
    var xor, u_c, u_c1;
    // sync version
    if (!callback) {
        for(var i = 1; i <= len; ++i){
            // PRF(P, S || INT(i)) (first iteration)
            prf.start(null, null);
            prf.update(s);
            prf.update($cLQG7.util.int32ToBytes(i));
            xor = u_c1 = prf.digest().getBytes();
            // PRF(P, u_{c-1}) (other iterations)
            for(var j = 2; j <= c; ++j){
                prf.start(null, null);
                prf.update(u_c1);
                u_c = prf.digest().getBytes();
                // F(p, s, c, i)
                xor = $cLQG7.util.xorBytes(xor, u_c, hLen);
                u_c1 = u_c;
            }
            /* 4. Concatenate the blocks and extract the first dkLen octets to
        produce a derived key DK:

        DK = T_1 || T_2 ||  ...  || T_len<0..r-1> */ dk += i < len ? xor : xor.substr(0, r);
        }
        /* 5. Output the derived key DK. */ return dk;
    }
    // async version
    var i = 1, j;
    function outer() {
        if (i > len) // done
        return callback(null, dk);
        // PRF(P, S || INT(i)) (first iteration)
        prf.start(null, null);
        prf.update(s);
        prf.update($cLQG7.util.int32ToBytes(i));
        xor = u_c1 = prf.digest().getBytes();
        // PRF(P, u_{c-1}) (other iterations)
        j = 2;
        inner();
    }
    function inner() {
        if (j <= c) {
            prf.start(null, null);
            prf.update(u_c1);
            u_c = prf.digest().getBytes();
            // F(p, s, c, i)
            xor = $cLQG7.util.xorBytes(xor, u_c, hLen);
            u_c1 = u_c;
            ++j;
            return $cLQG7.util.setImmediate(inner);
        }
        /* 4. Concatenate the blocks and extract the first dkLen octets to
      produce a derived key DK:

      DK = T_1 || T_2 ||  ...  || T_len<0..r-1> */ dk += i < len ? xor : xor.substr(0, r);
        ++i;
        outer();
    }
    outer();
};



var $7e4bb768b1414dc0$exports = {};
/**
 * An API for getting cryptographically-secure random bytes. The bytes are
 * generated using the Fortuna algorithm devised by Bruce Schneier and
 * Niels Ferguson.
 *
 * Getting strong random bytes is not yet easy to do in javascript. The only
 * truish random entropy that can be collected is from the mouse, keyboard, or
 * from timing with respect to page loads, etc. This generator makes a poor
 * attempt at providing random bytes when those sources haven't yet provided
 * enough entropy to initially seed or to reseed the PRNG.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2009-2014 Digital Bazaar, Inc.
 */ 
var $cLQG7 = parcelRequire("cLQG7");

var $a0dfe457c68dde04$exports = {};
/**
 * Secure Hash Algorithm with 256-bit digest (SHA-256) implementation.
 *
 * See FIPS 180-2 for details.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2015 Digital Bazaar, Inc.
 */ 
var $cLQG7 = parcelRequire("cLQG7");
parcelRequire("4pr5e");

var $a0dfe457c68dde04$var$sha256 = $a0dfe457c68dde04$exports = $cLQG7.sha256 = $cLQG7.sha256 || {};
$cLQG7.md.sha256 = $cLQG7.md.algorithms.sha256 = $a0dfe457c68dde04$var$sha256;
/**
 * Creates a SHA-256 message digest object.
 *
 * @return a message digest object.
 */ $a0dfe457c68dde04$var$sha256.create = function() {
    // do initialization as necessary
    if (!$a0dfe457c68dde04$var$_initialized) $a0dfe457c68dde04$var$_init();
    // SHA-256 state contains eight 32-bit integers
    var _state = null;
    // input buffer
    var _input = $cLQG7.util.createBuffer();
    // used for word storage
    var _w = new Array(64);
    // message digest object
    var md = {
        algorithm: 'sha256',
        blockLength: 64,
        digestLength: 32,
        // 56-bit length of message so far (does not including padding)
        messageLength: 0,
        // true message length
        fullMessageLength: null,
        // size of message length in bytes
        messageLengthSize: 8
    };
    /**
   * Starts the digest.
   *
   * @return this digest object.
   */ md.start = function() {
        // up to 56-bit message length for convenience
        md.messageLength = 0;
        // full message length (set md.messageLength64 for backwards-compatibility)
        md.fullMessageLength = md.messageLength64 = [];
        var int32s = md.messageLengthSize / 4;
        for(var i = 0; i < int32s; ++i)md.fullMessageLength.push(0);
        _input = $cLQG7.util.createBuffer();
        _state = {
            h0: 0x6A09E667,
            h1: 0xBB67AE85,
            h2: 0x3C6EF372,
            h3: 0xA54FF53A,
            h4: 0x510E527F,
            h5: 0x9B05688C,
            h6: 0x1F83D9AB,
            h7: 0x5BE0CD19
        };
        return md;
    };
    // start digest automatically for first time
    md.start();
    /**
   * Updates the digest with the given message input. The given input can
   * treated as raw input (no encoding will be applied) or an encoding of
   * 'utf8' maybe given to encode the input using UTF-8.
   *
   * @param msg the message input to update with.
   * @param encoding the encoding to use (default: 'raw', other: 'utf8').
   *
   * @return this digest object.
   */ md.update = function(msg, encoding) {
        if (encoding === 'utf8') msg = $cLQG7.util.encodeUtf8(msg);
        // update message length
        var len = msg.length;
        md.messageLength += len;
        len = [
            len / 0x100000000 >>> 0,
            len >>> 0
        ];
        for(var i = md.fullMessageLength.length - 1; i >= 0; --i){
            md.fullMessageLength[i] += len[1];
            len[1] = len[0] + (md.fullMessageLength[i] / 0x100000000 >>> 0);
            md.fullMessageLength[i] = md.fullMessageLength[i] >>> 0;
            len[0] = len[1] / 0x100000000 >>> 0;
        }
        // add bytes to input buffer
        _input.putBytes(msg);
        // process bytes
        $a0dfe457c68dde04$var$_update(_state, _w, _input);
        // compact input buffer every 2K or if empty
        if (_input.read > 2048 || _input.length() === 0) _input.compact();
        return md;
    };
    /**
   * Produces the digest.
   *
   * @return a byte buffer containing the digest value.
   */ md.digest = function() {
        /* Note: Here we copy the remaining bytes in the input buffer and
    add the appropriate SHA-256 padding. Then we do the final update
    on a copy of the state so that if the user wants to get
    intermediate digests they can do so. */ /* Determine the number of bytes that must be added to the message
    to ensure its length is congruent to 448 mod 512. In other words,
    the data to be digested must be a multiple of 512 bits (or 128 bytes).
    This data includes the message, some padding, and the length of the
    message. Since the length of the message will be encoded as 8 bytes (64
    bits), that means that the last segment of the data must have 56 bytes
    (448 bits) of message and padding. Therefore, the length of the message
    plus the padding must be congruent to 448 mod 512 because
    512 - 128 = 448.

    In order to fill up the message length it must be filled with
    padding that begins with 1 bit followed by all 0 bits. Padding
    must *always* be present, so if the message length is already
    congruent to 448 mod 512, then 512 padding bits must be added. */ var finalBlock = $cLQG7.util.createBuffer();
        finalBlock.putBytes(_input.bytes());
        // compute remaining size to be digested (include message length size)
        var remaining = md.fullMessageLength[md.fullMessageLength.length - 1] + md.messageLengthSize;
        // add padding for overflow blockSize - overflow
        // _padding starts with 1 byte with first bit is set (byte value 128), then
        // there may be up to (blockSize - 1) other pad bytes
        var overflow = remaining & md.blockLength - 1;
        finalBlock.putBytes($a0dfe457c68dde04$var$_padding.substr(0, md.blockLength - overflow));
        // serialize message length in bits in big-endian order; since length
        // is stored in bytes we multiply by 8 and add carry from next int
        var next, carry;
        var bits = md.fullMessageLength[0] * 8;
        for(var i = 0; i < md.fullMessageLength.length - 1; ++i){
            next = md.fullMessageLength[i + 1] * 8;
            carry = next / 0x100000000 >>> 0;
            bits += carry;
            finalBlock.putInt32(bits >>> 0);
            bits = next >>> 0;
        }
        finalBlock.putInt32(bits);
        var s2 = {
            h0: _state.h0,
            h1: _state.h1,
            h2: _state.h2,
            h3: _state.h3,
            h4: _state.h4,
            h5: _state.h5,
            h6: _state.h6,
            h7: _state.h7
        };
        $a0dfe457c68dde04$var$_update(s2, _w, finalBlock);
        var rval = $cLQG7.util.createBuffer();
        rval.putInt32(s2.h0);
        rval.putInt32(s2.h1);
        rval.putInt32(s2.h2);
        rval.putInt32(s2.h3);
        rval.putInt32(s2.h4);
        rval.putInt32(s2.h5);
        rval.putInt32(s2.h6);
        rval.putInt32(s2.h7);
        return rval;
    };
    return md;
};
// sha-256 padding bytes not initialized yet
var $a0dfe457c68dde04$var$_padding = null;
var $a0dfe457c68dde04$var$_initialized = false;
// table of constants
var $a0dfe457c68dde04$var$_k = null;
/**
 * Initializes the constant tables.
 */ function $a0dfe457c68dde04$var$_init() {
    // create padding
    $a0dfe457c68dde04$var$_padding = String.fromCharCode(128);
    $a0dfe457c68dde04$var$_padding += $cLQG7.util.fillString(String.fromCharCode(0x00), 64);
    // create K table for SHA-256
    $a0dfe457c68dde04$var$_k = [
        0x428a2f98,
        0x71374491,
        0xb5c0fbcf,
        0xe9b5dba5,
        0x3956c25b,
        0x59f111f1,
        0x923f82a4,
        0xab1c5ed5,
        0xd807aa98,
        0x12835b01,
        0x243185be,
        0x550c7dc3,
        0x72be5d74,
        0x80deb1fe,
        0x9bdc06a7,
        0xc19bf174,
        0xe49b69c1,
        0xefbe4786,
        0x0fc19dc6,
        0x240ca1cc,
        0x2de92c6f,
        0x4a7484aa,
        0x5cb0a9dc,
        0x76f988da,
        0x983e5152,
        0xa831c66d,
        0xb00327c8,
        0xbf597fc7,
        0xc6e00bf3,
        0xd5a79147,
        0x06ca6351,
        0x14292967,
        0x27b70a85,
        0x2e1b2138,
        0x4d2c6dfc,
        0x53380d13,
        0x650a7354,
        0x766a0abb,
        0x81c2c92e,
        0x92722c85,
        0xa2bfe8a1,
        0xa81a664b,
        0xc24b8b70,
        0xc76c51a3,
        0xd192e819,
        0xd6990624,
        0xf40e3585,
        0x106aa070,
        0x19a4c116,
        0x1e376c08,
        0x2748774c,
        0x34b0bcb5,
        0x391c0cb3,
        0x4ed8aa4a,
        0x5b9cca4f,
        0x682e6ff3,
        0x748f82ee,
        0x78a5636f,
        0x84c87814,
        0x8cc70208,
        0x90befffa,
        0xa4506ceb,
        0xbef9a3f7,
        0xc67178f2
    ];
    // now initialized
    $a0dfe457c68dde04$var$_initialized = true;
}
/**
 * Updates a SHA-256 state with the given byte buffer.
 *
 * @param s the SHA-256 state to update.
 * @param w the array to use to store words.
 * @param bytes the byte buffer to update with.
 */ function $a0dfe457c68dde04$var$_update(s, w, bytes) {
    // consume 512 bit (64 byte) chunks
    var t1, t2, s0, s1, ch, maj, i, a, b, c, d, e, f, g, h;
    var len = bytes.length();
    while(len >= 64){
        // the w array will be populated with sixteen 32-bit big-endian words
        // and then extended into 64 32-bit words according to SHA-256
        for(i = 0; i < 16; ++i)w[i] = bytes.getInt32();
        for(; i < 64; ++i){
            // XOR word 2 words ago rot right 17, rot right 19, shft right 10
            t1 = w[i - 2];
            t1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10;
            // XOR word 15 words ago rot right 7, rot right 18, shft right 3
            t2 = w[i - 15];
            t2 = (t2 >>> 7 | t2 << 25) ^ (t2 >>> 18 | t2 << 14) ^ t2 >>> 3;
            // sum(t1, word 7 ago, t2, word 16 ago) modulo 2^32
            w[i] = t1 + w[i - 7] + t2 + w[i - 16] | 0;
        }
        // initialize hash value for this chunk
        a = s.h0;
        b = s.h1;
        c = s.h2;
        d = s.h3;
        e = s.h4;
        f = s.h5;
        g = s.h6;
        h = s.h7;
        // round function
        for(i = 0; i < 64; ++i){
            // Sum1(e)
            s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
            // Ch(e, f, g) (optimized the same way as SHA-1)
            ch = g ^ e & (f ^ g);
            // Sum0(a)
            s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
            // Maj(a, b, c) (optimized the same way as SHA-1)
            maj = a & b | c & (a ^ b);
            // main algorithm
            t1 = h + s1 + ch + $a0dfe457c68dde04$var$_k[i] + w[i];
            t2 = s0 + maj;
            h = g;
            g = f;
            f = e;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            // can't truncate with `| 0`
            e = d + t1 >>> 0;
            d = c;
            c = b;
            b = a;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            // can't truncate with `| 0`
            a = t1 + t2 >>> 0;
        }
        // update hash state
        s.h0 = s.h0 + a | 0;
        s.h1 = s.h1 + b | 0;
        s.h2 = s.h2 + c | 0;
        s.h3 = s.h3 + d | 0;
        s.h4 = s.h4 + e | 0;
        s.h5 = s.h5 + f | 0;
        s.h6 = s.h6 + g | 0;
        s.h7 = s.h7 + h | 0;
        len -= 64;
    }
}


var $29a6d7f4275a236f$exports = {};
/**
 * A javascript implementation of a cryptographically-secure
 * Pseudo Random Number Generator (PRNG). The Fortuna algorithm is followed
 * here though the use of SHA-256 is not enforced; when generating an
 * a PRNG context, the hashing algorithm and block cipher used for
 * the generator are specified via a plugin.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 */ 
var $lbUi1 = parcelRequire("lbUi1");

var $cLQG7 = parcelRequire("cLQG7");

var $29a6d7f4275a236f$var$_crypto = null;

if ($cLQG7.util.isNodejs && !$cLQG7.options.usePureJavaScript && !$lbUi1.versions['node-webkit']) $29a6d7f4275a236f$var$_crypto = (parcelRequire("lbUi1"));
/* PRNG API */ var $29a6d7f4275a236f$var$prng = $29a6d7f4275a236f$exports = $cLQG7.prng = $cLQG7.prng || {};
/**
 * Creates a new PRNG context.
 *
 * A PRNG plugin must be passed in that will provide:
 *
 * 1. A function that initializes the key and seed of a PRNG context. It
 *   will be given a 16 byte key and a 16 byte seed. Any key expansion
 *   or transformation of the seed from a byte string into an array of
 *   integers (or similar) should be performed.
 * 2. The cryptographic function used by the generator. It takes a key and
 *   a seed.
 * 3. A seed increment function. It takes the seed and returns seed + 1.
 * 4. An api to create a message digest.
 *
 * For an example, see random.js.
 *
 * @param plugin the PRNG plugin to use.
 */ $29a6d7f4275a236f$var$prng.create = function(plugin) {
    var ctx = {
        plugin: plugin,
        key: null,
        seed: null,
        time: null,
        // number of reseeds so far
        reseeds: 0,
        // amount of data generated so far
        generated: 0,
        // no initial key bytes
        keyBytes: ''
    };
    // create 32 entropy pools (each is a message digest)
    var md = plugin.md;
    var pools = new Array(32);
    for(var i = 0; i < 32; ++i)pools[i] = md.create();
    ctx.pools = pools;
    // entropy pools are written to cyclically, starting at index 0
    ctx.pool = 0;
    /**
   * Generates random bytes. The bytes may be generated synchronously or
   * asynchronously. Web workers must use the asynchronous interface or
   * else the behavior is undefined.
   *
   * @param count the number of random bytes to generate.
   * @param [callback(err, bytes)] called once the operation completes.
   *
   * @return count random bytes as a string.
   */ ctx.generate = function(count, callback) {
        // do synchronously
        if (!callback) return ctx.generateSync(count);
        // simple generator using counter-based CBC
        var cipher = ctx.plugin.cipher;
        var increment = ctx.plugin.increment;
        var formatKey = ctx.plugin.formatKey;
        var formatSeed = ctx.plugin.formatSeed;
        var b = $cLQG7.util.createBuffer();
        // paranoid deviation from Fortuna:
        // reset key for every request to protect previously
        // generated random bytes should the key be discovered;
        // there is no 100ms based reseeding because of this
        // forced reseed for every `generate` call
        ctx.key = null;
        generate();
        function generate(err) {
            if (err) return callback(err);
            // sufficient bytes generated
            if (b.length() >= count) return callback(null, b.getBytes(count));
            // if amount of data generated is greater than 1 MiB, trigger reseed
            if (ctx.generated > 0xfffff) ctx.key = null;
            if (ctx.key === null) // prevent stack overflow
            return $cLQG7.util.nextTick(function() {
                _reseed(generate);
            });
            // generate the random bytes
            var bytes = cipher(ctx.key, ctx.seed);
            ctx.generated += bytes.length;
            b.putBytes(bytes);
            // generate bytes for a new key and seed
            ctx.key = formatKey(cipher(ctx.key, increment(ctx.seed)));
            ctx.seed = formatSeed(cipher(ctx.key, ctx.seed));
            $cLQG7.util.setImmediate(generate);
        }
    };
    /**
   * Generates random bytes synchronously.
   *
   * @param count the number of random bytes to generate.
   *
   * @return count random bytes as a string.
   */ ctx.generateSync = function(count) {
        // simple generator using counter-based CBC
        var cipher = ctx.plugin.cipher;
        var increment = ctx.plugin.increment;
        var formatKey = ctx.plugin.formatKey;
        var formatSeed = ctx.plugin.formatSeed;
        // paranoid deviation from Fortuna:
        // reset key for every request to protect previously
        // generated random bytes should the key be discovered;
        // there is no 100ms based reseeding because of this
        // forced reseed for every `generateSync` call
        ctx.key = null;
        var b = $cLQG7.util.createBuffer();
        while(b.length() < count){
            // if amount of data generated is greater than 1 MiB, trigger reseed
            if (ctx.generated > 0xfffff) ctx.key = null;
            if (ctx.key === null) _reseedSync();
            // generate the random bytes
            var bytes = cipher(ctx.key, ctx.seed);
            ctx.generated += bytes.length;
            b.putBytes(bytes);
            // generate bytes for a new key and seed
            ctx.key = formatKey(cipher(ctx.key, increment(ctx.seed)));
            ctx.seed = formatSeed(cipher(ctx.key, ctx.seed));
        }
        return b.getBytes(count);
    };
    /**
   * Private function that asynchronously reseeds a generator.
   *
   * @param callback(err) called once the operation completes.
   */ function _reseed(callback) {
        if (ctx.pools[0].messageLength >= 32) {
            _seed();
            return callback();
        }
        // not enough seed data...
        var needed = 32 - ctx.pools[0].messageLength << 5;
        ctx.seedFile(needed, function(err, bytes) {
            if (err) return callback(err);
            ctx.collect(bytes);
            _seed();
            callback();
        });
    }
    /**
   * Private function that synchronously reseeds a generator.
   */ function _reseedSync() {
        if (ctx.pools[0].messageLength >= 32) return _seed();
        // not enough seed data...
        var needed = 32 - ctx.pools[0].messageLength << 5;
        ctx.collect(ctx.seedFileSync(needed));
        _seed();
    }
    /**
   * Private function that seeds a generator once enough bytes are available.
   */ function _seed() {
        // update reseed count
        ctx.reseeds = ctx.reseeds === 0xffffffff ? 0 : ctx.reseeds + 1;
        // goal is to update `key` via:
        // key = hash(key + s)
        //   where 's' is all collected entropy from selected pools, then...
        // create a plugin-based message digest
        var md = ctx.plugin.md.create();
        // consume current key bytes
        md.update(ctx.keyBytes);
        // digest the entropy of pools whose index k meet the
        // condition 'n mod 2^k == 0' where n is the number of reseeds
        var _2powK = 1;
        for(var k = 0; k < 32; ++k){
            if (ctx.reseeds % _2powK === 0) {
                md.update(ctx.pools[k].digest().getBytes());
                ctx.pools[k].start();
            }
            _2powK = _2powK << 1;
        }
        // get digest for key bytes
        ctx.keyBytes = md.digest().getBytes();
        // paranoid deviation from Fortuna:
        // update `seed` via `seed = hash(key)`
        // instead of initializing to zero once and only
        // ever incrementing it
        md.start();
        md.update(ctx.keyBytes);
        var seedBytes = md.digest().getBytes();
        // update state
        ctx.key = ctx.plugin.formatKey(ctx.keyBytes);
        ctx.seed = ctx.plugin.formatSeed(seedBytes);
        ctx.generated = 0;
    }
    /**
   * The built-in default seedFile. This seedFile is used when entropy
   * is needed immediately.
   *
   * @param needed the number of bytes that are needed.
   *
   * @return the random bytes.
   */ function defaultSeedFile(needed) {
        // use window.crypto.getRandomValues strong source of entropy if available
        var getRandomValues = null;
        var globalScope = $cLQG7.util.globalScope;
        var _crypto = globalScope.crypto || globalScope.msCrypto;
        if (_crypto && _crypto.getRandomValues) getRandomValues = function(arr) {
            return _crypto.getRandomValues(arr);
        };
        var b = $cLQG7.util.createBuffer();
        if (getRandomValues) while(b.length() < needed){
            // max byte length is 65536 before QuotaExceededError is thrown
            // http://www.w3.org/TR/WebCryptoAPI/#RandomSource-method-getRandomValues
            var count = Math.max(1, Math.min(needed - b.length(), 65536) / 4);
            var entropy = new Uint32Array(Math.floor(count));
            try {
                getRandomValues(entropy);
                for(var i = 0; i < entropy.length; ++i)b.putInt32(entropy[i]);
            } catch (e) {
                /* only ignore QuotaExceededError */ if (!(typeof QuotaExceededError !== 'undefined' && e instanceof QuotaExceededError)) throw e;
            }
        }
        // be sad and add some weak random data
        if (b.length() < needed) {
            /* Draws from Park-Miller "minimal standard" 31 bit PRNG,
      implemented with David G. Carta's optimization: with 32 bit math
      and without division (Public Domain). */ var hi, lo, next;
            var seed = Math.floor(Math.random() * 0x010000);
            while(b.length() < needed){
                lo = 16807 * (seed & 0xFFFF);
                hi = 16807 * (seed >> 16);
                lo += (hi & 0x7FFF) << 16;
                lo += hi >> 15;
                lo = (lo & 0x7FFFFFFF) + (lo >> 31);
                seed = lo & 0xFFFFFFFF;
                // consume lower 3 bytes of seed
                for(var i = 0; i < 3; ++i){
                    // throw in more pseudo random
                    next = seed >>> (i << 3);
                    next ^= Math.floor(Math.random() * 0x0100);
                    b.putByte(next & 0xFF);
                }
            }
        }
        return b.getBytes(needed);
    }
    // initialize seed file APIs
    if ($29a6d7f4275a236f$var$_crypto) {
        // use nodejs async API
        ctx.seedFile = function(needed, callback) {
            $29a6d7f4275a236f$var$_crypto.randomBytes(needed, function(err, bytes) {
                if (err) return callback(err);
                callback(null, bytes.toString());
            });
        };
        // use nodejs sync API
        ctx.seedFileSync = function(needed) {
            return $29a6d7f4275a236f$var$_crypto.randomBytes(needed).toString();
        };
    } else {
        ctx.seedFile = function(needed, callback) {
            try {
                callback(null, defaultSeedFile(needed));
            } catch (e) {
                callback(e);
            }
        };
        ctx.seedFileSync = defaultSeedFile;
    }
    /**
   * Adds entropy to a prng ctx's accumulator.
   *
   * @param bytes the bytes of entropy as a string.
   */ ctx.collect = function(bytes) {
        // iterate over pools distributing entropy cyclically
        var count = bytes.length;
        for(var i = 0; i < count; ++i){
            ctx.pools[ctx.pool].update(bytes.substr(i, 1));
            ctx.pool = ctx.pool === 31 ? 0 : ctx.pool + 1;
        }
    };
    /**
   * Collects an integer of n bits.
   *
   * @param i the integer entropy.
   * @param n the number of bits in the integer.
   */ ctx.collectInt = function(i, n) {
        var bytes = '';
        for(var x = 0; x < n; x += 8)bytes += String.fromCharCode(i >> x & 0xFF);
        ctx.collect(bytes);
    };
    /**
   * Registers a Web Worker to receive immediate entropy from the main thread.
   * This method is required until Web Workers can access the native crypto
   * API. This method should be called twice for each created worker, once in
   * the main thread, and once in the worker itself.
   *
   * @param worker the worker to register.
   */ ctx.registerWorker = function(worker) {
        // worker receives random bytes
        if (worker === self) ctx.seedFile = function(needed, callback) {
            function listener(e) {
                var data = e.data;
                if (data.forge && data.forge.prng) {
                    self.removeEventListener('message', listener);
                    callback(data.forge.prng.err, data.forge.prng.bytes);
                }
            }
            self.addEventListener('message', listener);
            self.postMessage({
                forge: {
                    prng: {
                        needed: needed
                    }
                }
            });
        };
        else {
            // main thread sends random bytes upon request
            var listener = function(e) {
                var data = e.data;
                if (data.forge && data.forge.prng) ctx.seedFile(data.forge.prng.needed, function(err, bytes) {
                    worker.postMessage({
                        forge: {
                            prng: {
                                err: err,
                                bytes: bytes
                            }
                        }
                    });
                });
            };
            // TODO: do we need to remove the event listener when the worker dies?
            worker.addEventListener('message', listener);
        }
    };
    return ctx;
};



(function() {
    // forge.random already defined
    if ($cLQG7.random && $cLQG7.random.getBytes) {
        $7e4bb768b1414dc0$exports = $cLQG7.random;
        return;
    }
    (function(jQuery1) {
        // the default prng plugin, uses AES-128
        var prng_aes = {};
        var _prng_aes_output = new Array(4);
        var _prng_aes_buffer = $cLQG7.util.createBuffer();
        prng_aes.formatKey = function(key) {
            // convert the key into 32-bit integers
            var tmp = $cLQG7.util.createBuffer(key);
            key = new Array(4);
            key[0] = tmp.getInt32();
            key[1] = tmp.getInt32();
            key[2] = tmp.getInt32();
            key[3] = tmp.getInt32();
            // return the expanded key
            return $cLQG7.aes._expandKey(key, false);
        };
        prng_aes.formatSeed = function(seed) {
            // convert seed into 32-bit integers
            var tmp = $cLQG7.util.createBuffer(seed);
            seed = new Array(4);
            seed[0] = tmp.getInt32();
            seed[1] = tmp.getInt32();
            seed[2] = tmp.getInt32();
            seed[3] = tmp.getInt32();
            return seed;
        };
        prng_aes.cipher = function(key, seed) {
            $cLQG7.aes._updateBlock(key, seed, _prng_aes_output, false);
            _prng_aes_buffer.putInt32(_prng_aes_output[0]);
            _prng_aes_buffer.putInt32(_prng_aes_output[1]);
            _prng_aes_buffer.putInt32(_prng_aes_output[2]);
            _prng_aes_buffer.putInt32(_prng_aes_output[3]);
            return _prng_aes_buffer.getBytes();
        };
        prng_aes.increment = function(seed) {
            // FIXME: do we care about carry or signed issues?
            ++seed[3];
            return seed;
        };
        prng_aes.md = $cLQG7.md.sha256;
        /**
 * Creates a new PRNG.
 */ function spawnPrng() {
            var ctx = $cLQG7.prng.create(prng_aes);
            /**
   * Gets random bytes. If a native secure crypto API is unavailable, this
   * method tries to make the bytes more unpredictable by drawing from data that
   * can be collected from the user of the browser, eg: mouse movement.
   *
   * If a callback is given, this method will be called asynchronously.
   *
   * @param count the number of random bytes to get.
   * @param [callback(err, bytes)] called once the operation completes.
   *
   * @return the random bytes in a string.
   */ ctx.getBytes = function(count, callback) {
                return ctx.generate(count, callback);
            };
            /**
   * Gets random bytes asynchronously. If a native secure crypto API is
   * unavailable, this method tries to make the bytes more unpredictable by
   * drawing from data that can be collected from the user of the browser,
   * eg: mouse movement.
   *
   * @param count the number of random bytes to get.
   *
   * @return the random bytes in a string.
   */ ctx.getBytesSync = function(count) {
                return ctx.generate(count);
            };
            return ctx;
        }
        // create default prng context
        var _ctx = spawnPrng();
        // add other sources of entropy only if window.crypto.getRandomValues is not
        // available -- otherwise this source will be automatically used by the prng
        var getRandomValues = null;
        var globalScope = $cLQG7.util.globalScope;
        var _crypto = globalScope.crypto || globalScope.msCrypto;
        if (_crypto && _crypto.getRandomValues) getRandomValues = function(arr) {
            return _crypto.getRandomValues(arr);
        };
        if ($cLQG7.options.usePureJavaScript || !$cLQG7.util.isNodejs && !getRandomValues) {
            // if this is a web worker, do not use weak entropy, instead register to
            // receive strong entropy asynchronously from the main thread
            typeof window === 'undefined' || window.document;
            // get load time entropy
            _ctx.collectInt(+new Date(), 32);
            // add some entropy from navigator object
            if (typeof navigator !== 'undefined') {
                var _navBytes = '';
                for(var key in navigator)try {
                    if (typeof navigator[key] == 'string') _navBytes += navigator[key];
                } catch (e) {
                /* Some navigator keys might not be accessible, e.g. the geolocation
          attribute throws an exception if touched in Mozilla chrome://
          context.

          Silently ignore this and just don't use this as a source of
          entropy. */ }
                _ctx.collect(_navBytes);
                _navBytes = null;
            }
            // add mouse and keyboard collectors if jquery is available
            if (jQuery1) {
                // set up mouse entropy capture
                jQuery1().mousemove(function(e) {
                    // add mouse coords
                    _ctx.collectInt(e.clientX, 16);
                    _ctx.collectInt(e.clientY, 16);
                });
                // set up keyboard entropy capture
                jQuery1().keypress(function(e) {
                    _ctx.collectInt(e.charCode, 8);
                });
            }
        }
        /* Random API */ if (!$cLQG7.random) $cLQG7.random = _ctx;
        else // extend forge.random with _ctx
        for(var key in _ctx)$cLQG7.random[key] = _ctx[key];
        // expose spawn PRNG
        $cLQG7.random.createInstance = spawnPrng;
        $7e4bb768b1414dc0$exports = $cLQG7.random;
    })(typeof jQuery !== 'undefined' ? jQuery : null);
})();


var $fc043d6d85ff565a$exports = {};
/**
 * RC2 implementation.
 *
 * @author Stefan Siegl
 *
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 *
 * Information on the RC2 cipher is available from RFC #2268,
 * http://www.ietf.org/rfc/rfc2268.txt
 */ 
var $cLQG7 = parcelRequire("cLQG7");

var $fc043d6d85ff565a$var$piTable = [
    0xd9,
    0x78,
    0xf9,
    0xc4,
    0x19,
    0xdd,
    0xb5,
    0xed,
    0x28,
    0xe9,
    0xfd,
    0x79,
    0x4a,
    0xa0,
    0xd8,
    0x9d,
    0xc6,
    0x7e,
    0x37,
    0x83,
    0x2b,
    0x76,
    0x53,
    0x8e,
    0x62,
    0x4c,
    0x64,
    0x88,
    0x44,
    0x8b,
    0xfb,
    0xa2,
    0x17,
    0x9a,
    0x59,
    0xf5,
    0x87,
    0xb3,
    0x4f,
    0x13,
    0x61,
    0x45,
    0x6d,
    0x8d,
    0x09,
    0x81,
    0x7d,
    0x32,
    0xbd,
    0x8f,
    0x40,
    0xeb,
    0x86,
    0xb7,
    0x7b,
    0x0b,
    0xf0,
    0x95,
    0x21,
    0x22,
    0x5c,
    0x6b,
    0x4e,
    0x82,
    0x54,
    0xd6,
    0x65,
    0x93,
    0xce,
    0x60,
    0xb2,
    0x1c,
    0x73,
    0x56,
    0xc0,
    0x14,
    0xa7,
    0x8c,
    0xf1,
    0xdc,
    0x12,
    0x75,
    0xca,
    0x1f,
    0x3b,
    0xbe,
    0xe4,
    0xd1,
    0x42,
    0x3d,
    0xd4,
    0x30,
    0xa3,
    0x3c,
    0xb6,
    0x26,
    0x6f,
    0xbf,
    0x0e,
    0xda,
    0x46,
    0x69,
    0x07,
    0x57,
    0x27,
    0xf2,
    0x1d,
    0x9b,
    0xbc,
    0x94,
    0x43,
    0x03,
    0xf8,
    0x11,
    0xc7,
    0xf6,
    0x90,
    0xef,
    0x3e,
    0xe7,
    0x06,
    0xc3,
    0xd5,
    0x2f,
    0xc8,
    0x66,
    0x1e,
    0xd7,
    0x08,
    0xe8,
    0xea,
    0xde,
    0x80,
    0x52,
    0xee,
    0xf7,
    0x84,
    0xaa,
    0x72,
    0xac,
    0x35,
    0x4d,
    0x6a,
    0x2a,
    0x96,
    0x1a,
    0xd2,
    0x71,
    0x5a,
    0x15,
    0x49,
    0x74,
    0x4b,
    0x9f,
    0xd0,
    0x5e,
    0x04,
    0x18,
    0xa4,
    0xec,
    0xc2,
    0xe0,
    0x41,
    0x6e,
    0x0f,
    0x51,
    0xcb,
    0xcc,
    0x24,
    0x91,
    0xaf,
    0x50,
    0xa1,
    0xf4,
    0x70,
    0x39,
    0x99,
    0x7c,
    0x3a,
    0x85,
    0x23,
    0xb8,
    0xb4,
    0x7a,
    0xfc,
    0x02,
    0x36,
    0x5b,
    0x25,
    0x55,
    0x97,
    0x31,
    0x2d,
    0x5d,
    0xfa,
    0x98,
    0xe3,
    0x8a,
    0x92,
    0xae,
    0x05,
    0xdf,
    0x29,
    0x10,
    0x67,
    0x6c,
    0xba,
    0xc9,
    0xd3,
    0x00,
    0xe6,
    0xcf,
    0xe1,
    0x9e,
    0xa8,
    0x2c,
    0x63,
    0x16,
    0x01,
    0x3f,
    0x58,
    0xe2,
    0x89,
    0xa9,
    0x0d,
    0x38,
    0x34,
    0x1b,
    0xab,
    0x33,
    0xff,
    0xb0,
    0xbb,
    0x48,
    0x0c,
    0x5f,
    0xb9,
    0xb1,
    0xcd,
    0x2e,
    0xc5,
    0xf3,
    0xdb,
    0x47,
    0xe5,
    0xa5,
    0x9c,
    0x77,
    0x0a,
    0xa6,
    0x20,
    0x68,
    0xfe,
    0x7f,
    0xc1,
    0xad
];
var $fc043d6d85ff565a$var$s = [
    1,
    2,
    3,
    5
];
/**
 * Rotate a word left by given number of bits.
 *
 * Bits that are shifted out on the left are put back in on the right
 * hand side.
 *
 * @param word The word to shift left.
 * @param bits The number of bits to shift by.
 * @return The rotated word.
 */ var $fc043d6d85ff565a$var$rol = function(word, bits) {
    return word << bits & 0xffff | (word & 0xffff) >> 16 - bits;
};
/**
 * Rotate a word right by given number of bits.
 *
 * Bits that are shifted out on the right are put back in on the left
 * hand side.
 *
 * @param word The word to shift right.
 * @param bits The number of bits to shift by.
 * @return The rotated word.
 */ var $fc043d6d85ff565a$var$ror = function(word, bits) {
    return (word & 0xffff) >> bits | word << 16 - bits & 0xffff;
};
/* RC2 API */ $fc043d6d85ff565a$exports = $cLQG7.rc2 = $cLQG7.rc2 || {};
/**
 * Perform RC2 key expansion as per RFC #2268, section 2.
 *
 * @param key variable-length user key (between 1 and 128 bytes)
 * @param effKeyBits number of effective key bits (default: 128)
 * @return the expanded RC2 key (ByteBuffer of 128 bytes)
 */ $cLQG7.rc2.expandKey = function(key, effKeyBits) {
    if (typeof key === 'string') key = $cLQG7.util.createBuffer(key);
    effKeyBits = effKeyBits || 128;
    /* introduce variables that match the names used in RFC #2268 */ var L = key;
    var T = key.length();
    var T1 = effKeyBits;
    var T8 = Math.ceil(T1 / 8);
    var TM = 0xff >> (T1 & 0x07);
    var i;
    for(i = T; i < 128; i++)L.putByte($fc043d6d85ff565a$var$piTable[L.at(i - 1) + L.at(i - T) & 0xff]);
    L.setAt(128 - T8, $fc043d6d85ff565a$var$piTable[L.at(128 - T8) & TM]);
    for(i = 127 - T8; i >= 0; i--)L.setAt(i, $fc043d6d85ff565a$var$piTable[L.at(i + 1) ^ L.at(i + T8)]);
    return L;
};
/**
 * Creates a RC2 cipher object.
 *
 * @param key the symmetric key to use (as base for key generation).
 * @param bits the number of effective key bits.
 * @param encrypt false for decryption, true for encryption.
 *
 * @return the cipher.
 */ var $fc043d6d85ff565a$var$createCipher = function(key, bits, encrypt) {
    var _finish = false, _input = null, _output = null, _iv = null;
    var mixRound, mashRound;
    var i, j, K = [];
    /* Expand key and fill into K[] Array */ key = $cLQG7.rc2.expandKey(key, bits);
    for(i = 0; i < 64; i++)K.push(key.getInt16Le());
    if (encrypt) {
        /**
     * Perform one mixing round "in place".
     *
     * @param R Array of four words to perform mixing on.
     */ mixRound = function(R) {
            for(i = 0; i < 4; i++){
                R[i] += K[j] + (R[(i + 3) % 4] & R[(i + 2) % 4]) + (~R[(i + 3) % 4] & R[(i + 1) % 4]);
                R[i] = $fc043d6d85ff565a$var$rol(R[i], $fc043d6d85ff565a$var$s[i]);
                j++;
            }
        };
        /**
     * Perform one mashing round "in place".
     *
     * @param R Array of four words to perform mashing on.
     */ mashRound = function(R) {
            for(i = 0; i < 4; i++)R[i] += K[R[(i + 3) % 4] & 63];
        };
    } else {
        /**
     * Perform one r-mixing round "in place".
     *
     * @param R Array of four words to perform mixing on.
     */ mixRound = function(R) {
            for(i = 3; i >= 0; i--){
                R[i] = $fc043d6d85ff565a$var$ror(R[i], $fc043d6d85ff565a$var$s[i]);
                R[i] -= K[j] + (R[(i + 3) % 4] & R[(i + 2) % 4]) + (~R[(i + 3) % 4] & R[(i + 1) % 4]);
                j--;
            }
        };
        /**
     * Perform one r-mashing round "in place".
     *
     * @param R Array of four words to perform mashing on.
     */ mashRound = function(R) {
            for(i = 3; i >= 0; i--)R[i] -= K[R[(i + 3) % 4] & 63];
        };
    }
    /**
   * Run the specified cipher execution plan.
   *
   * This function takes four words from the input buffer, applies the IV on
   * it (if requested) and runs the provided execution plan.
   *
   * The plan must be put together in form of a array of arrays.  Where the
   * outer one is simply a list of steps to perform and the inner one needs
   * to have two elements: the first one telling how many rounds to perform,
   * the second one telling what to do (i.e. the function to call).
   *
   * @param {Array} plan The plan to execute.
   */ var runPlan = function(plan) {
        var R = [];
        /* Get data from input buffer and fill the four words into R */ for(i = 0; i < 4; i++){
            var val = _input.getInt16Le();
            if (_iv !== null) {
                if (encrypt) /* We're encrypting, apply the IV first. */ val ^= _iv.getInt16Le();
                else /* We're decryption, keep cipher text for next block. */ _iv.putInt16Le(val);
            }
            R.push(val & 0xffff);
        }
        /* Reset global "j" variable as per spec. */ j = encrypt ? 0 : 63;
        /* Run execution plan. */ for(var ptr = 0; ptr < plan.length; ptr++)for(var ctr = 0; ctr < plan[ptr][0]; ctr++)plan[ptr][1](R);
        /* Write back result to output buffer. */ for(i = 0; i < 4; i++){
            if (_iv !== null) {
                if (encrypt) /* We're encrypting in CBC-mode, feed back encrypted bytes into
             IV buffer to carry it forward to next block. */ _iv.putInt16Le(R[i]);
                else R[i] ^= _iv.getInt16Le();
            }
            _output.putInt16Le(R[i]);
        }
    };
    /* Create cipher object */ var cipher = null;
    cipher = {
        /**
     * Starts or restarts the encryption or decryption process, whichever
     * was previously configured.
     *
     * To use the cipher in CBC mode, iv may be given either as a string
     * of bytes, or as a byte buffer.  For ECB mode, give null as iv.
     *
     * @param iv the initialization vector to use, null for ECB mode.
     * @param output the output the buffer to write to, null to create one.
     */ start: function(iv, output) {
            if (iv) /* CBC mode */ {
                if (typeof iv === 'string') iv = $cLQG7.util.createBuffer(iv);
            }
            _finish = false;
            _input = $cLQG7.util.createBuffer();
            _output = output || new $cLQG7.util.createBuffer();
            _iv = iv;
            cipher.output = _output;
        },
        /**
     * Updates the next block.
     *
     * @param input the buffer to read from.
     */ update: function(input) {
            if (!_finish) // not finishing, so fill the input buffer with more input
            _input.putBuffer(input);
            while(_input.length() >= 8)runPlan([
                [
                    5,
                    mixRound
                ],
                [
                    1,
                    mashRound
                ],
                [
                    6,
                    mixRound
                ],
                [
                    1,
                    mashRound
                ],
                [
                    5,
                    mixRound
                ]
            ]);
        },
        /**
     * Finishes encrypting or decrypting.
     *
     * @param pad a padding function to use, null for PKCS#7 padding,
     *           signature(blockSize, buffer, decrypt).
     *
     * @return true if successful, false on error.
     */ finish: function(pad) {
            var rval = true;
            if (encrypt) {
                if (pad) rval = pad(8, _input, !encrypt);
                else {
                    // add PKCS#7 padding to block (each pad byte is the
                    // value of the number of pad bytes)
                    var padding = _input.length() === 8 ? 8 : 8 - _input.length();
                    _input.fillWithByte(padding, padding);
                }
            }
            if (rval) {
                // do final update
                _finish = true;
                cipher.update();
            }
            if (!encrypt) {
                // check for error: input data not a multiple of block size
                rval = _input.length() === 0;
                if (rval) {
                    if (pad) rval = pad(8, _output, !encrypt);
                    else {
                        // ensure padding byte count is valid
                        var len = _output.length();
                        var count = _output.at(len - 1);
                        if (count > len) rval = false;
                        else // trim off padding bytes
                        _output.truncate(count);
                    }
                }
            }
            return rval;
        }
    };
    return cipher;
};
/**
 * Creates an RC2 cipher object to encrypt data in ECB or CBC mode using the
 * given symmetric key. The output will be stored in the 'output' member
 * of the returned cipher.
 *
 * The key and iv may be given as a string of bytes or a byte buffer.
 * The cipher is initialized to use 128 effective key bits.
 *
 * @param key the symmetric key to use.
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 *
 * @return the cipher.
 */ $cLQG7.rc2.startEncrypting = function(key, iv, output) {
    var cipher = $cLQG7.rc2.createEncryptionCipher(key, 128);
    cipher.start(iv, output);
    return cipher;
};
/**
 * Creates an RC2 cipher object to encrypt data in ECB or CBC mode using the
 * given symmetric key.
 *
 * The key may be given as a string of bytes or a byte buffer.
 *
 * To start encrypting call start() on the cipher with an iv and optional
 * output buffer.
 *
 * @param key the symmetric key to use.
 *
 * @return the cipher.
 */ $cLQG7.rc2.createEncryptionCipher = function(key, bits) {
    return $fc043d6d85ff565a$var$createCipher(key, bits, true);
};
/**
 * Creates an RC2 cipher object to decrypt data in ECB or CBC mode using the
 * given symmetric key. The output will be stored in the 'output' member
 * of the returned cipher.
 *
 * The key and iv may be given as a string of bytes or a byte buffer.
 * The cipher is initialized to use 128 effective key bits.
 *
 * @param key the symmetric key to use.
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 *
 * @return the cipher.
 */ $cLQG7.rc2.startDecrypting = function(key, iv, output) {
    var cipher = $cLQG7.rc2.createDecryptionCipher(key, 128);
    cipher.start(iv, output);
    return cipher;
};
/**
 * Creates an RC2 cipher object to decrypt data in ECB or CBC mode using the
 * given symmetric key.
 *
 * The key may be given as a string of bytes or a byte buffer.
 *
 * To start decrypting call start() on the cipher with an iv and optional
 * output buffer.
 *
 * @param key the symmetric key to use.
 *
 * @return the cipher.
 */ $cLQG7.rc2.createDecryptionCipher = function(key, bits) {
    return $fc043d6d85ff565a$var$createCipher(key, bits, false);
};


var $ef3f2aff9b40d381$exports = {};
/**
 * Javascript implementation of basic RSA algorithms.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 *
 * The only algorithm currently supported for PKI is RSA.
 *
 * An RSA key is often stored in ASN.1 DER format. The SubjectPublicKeyInfo
 * ASN.1 structure is composed of an algorithm of type AlgorithmIdentifier
 * and a subjectPublicKey of type bit string.
 *
 * The AlgorithmIdentifier contains an Object Identifier (OID) and parameters
 * for the algorithm, if any. In the case of RSA, there aren't any.
 *
 * SubjectPublicKeyInfo ::= SEQUENCE {
 *   algorithm AlgorithmIdentifier,
 *   subjectPublicKey BIT STRING
 * }
 *
 * AlgorithmIdentifer ::= SEQUENCE {
 *   algorithm OBJECT IDENTIFIER,
 *   parameters ANY DEFINED BY algorithm OPTIONAL
 * }
 *
 * For an RSA public key, the subjectPublicKey is:
 *
 * RSAPublicKey ::= SEQUENCE {
 *   modulus            INTEGER,    -- n
 *   publicExponent     INTEGER     -- e
 * }
 *
 * PrivateKeyInfo ::= SEQUENCE {
 *   version                   Version,
 *   privateKeyAlgorithm       PrivateKeyAlgorithmIdentifier,
 *   privateKey                PrivateKey,
 *   attributes           [0]  IMPLICIT Attributes OPTIONAL
 * }
 *
 * Version ::= INTEGER
 * PrivateKeyAlgorithmIdentifier ::= AlgorithmIdentifier
 * PrivateKey ::= OCTET STRING
 * Attributes ::= SET OF Attribute
 *
 * An RSA private key as the following structure:
 *
 * RSAPrivateKey ::= SEQUENCE {
 *   version Version,
 *   modulus INTEGER, -- n
 *   publicExponent INTEGER, -- e
 *   privateExponent INTEGER, -- d
 *   prime1 INTEGER, -- p
 *   prime2 INTEGER, -- q
 *   exponent1 INTEGER, -- d mod (p-1)
 *   exponent2 INTEGER, -- d mod (q-1)
 *   coefficient INTEGER -- (inverse of q) mod p
 * }
 *
 * Version ::= INTEGER
 *
 * The OID for the RSA key algorithm is: 1.2.840.113549.1.1.1
 */ 
var $cLQG7 = parcelRequire("cLQG7");

var $650b58be26a54349$exports = {};
// Copyright (c) 2005  Tom Wu
// All Rights Reserved.
// See "LICENSE" for details.
// Basic JavaScript BN library - subset useful for RSA encryption.
/*
Licensing (LICENSE)
-------------------

This software is covered under the following copyright:
*/ /*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ /*
Address all questions regarding this license to:

  Tom Wu
  tjw@cs.Stanford.EDU
*/ 
var $cLQG7 = parcelRequire("cLQG7");
$650b58be26a54349$exports = $cLQG7.jsbn = $cLQG7.jsbn || {};
// Bits per digit
var $650b58be26a54349$var$dbits;
// JavaScript engine analysis
var $650b58be26a54349$var$canary = 0xdeadbeefcafe;
var $650b58be26a54349$var$j_lm = ($650b58be26a54349$var$canary & 0xffffff) == 0xefcafe;
// (public) Constructor
function $650b58be26a54349$var$BigInteger(a, b, c) {
    this.data = [];
    if (a != null) {
        if ("number" == typeof a) this.fromNumber(a, b, c);
        else if (b == null && "string" != typeof a) this.fromString(a, 256);
        else this.fromString(a, b);
    }
}
$cLQG7.jsbn.BigInteger = $650b58be26a54349$var$BigInteger;
// return new, unset BigInteger
function $650b58be26a54349$var$nbi() {
    return new $650b58be26a54349$var$BigInteger(null);
}
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $650b58be26a54349$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        var v = x * this.data[i++] + w.data[j] + c;
        c = Math.floor(v / 0x4000000);
        w.data[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $650b58be26a54349$var$am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff, xh = x >> 15;
    while(--n >= 0){
        var l = this.data[i] & 0x7fff;
        var h = this.data[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w.data[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w.data[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $650b58be26a54349$var$am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff, xh = x >> 14;
    while(--n >= 0){
        var l = this.data[i] & 0x3fff;
        var h = this.data[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w.data[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w.data[j++] = l & 0xfffffff;
    }
    return c;
}
// node.js (no browser)
if (typeof navigator === 'undefined') {
    $650b58be26a54349$var$BigInteger.prototype.am = $650b58be26a54349$var$am3;
    $650b58be26a54349$var$dbits = 28;
} else if ($650b58be26a54349$var$j_lm && navigator.appName == "Microsoft Internet Explorer") {
    $650b58be26a54349$var$BigInteger.prototype.am = $650b58be26a54349$var$am2;
    $650b58be26a54349$var$dbits = 30;
} else if ($650b58be26a54349$var$j_lm && navigator.appName != "Netscape") {
    $650b58be26a54349$var$BigInteger.prototype.am = $650b58be26a54349$var$am1;
    $650b58be26a54349$var$dbits = 26;
} else {
    $650b58be26a54349$var$BigInteger.prototype.am = $650b58be26a54349$var$am3;
    $650b58be26a54349$var$dbits = 28;
}
$650b58be26a54349$var$BigInteger.prototype.DB = $650b58be26a54349$var$dbits;
$650b58be26a54349$var$BigInteger.prototype.DM = (1 << $650b58be26a54349$var$dbits) - 1;
$650b58be26a54349$var$BigInteger.prototype.DV = 1 << $650b58be26a54349$var$dbits;
var $650b58be26a54349$var$BI_FP = 52;
$650b58be26a54349$var$BigInteger.prototype.FV = Math.pow(2, $650b58be26a54349$var$BI_FP);
$650b58be26a54349$var$BigInteger.prototype.F1 = $650b58be26a54349$var$BI_FP - $650b58be26a54349$var$dbits;
$650b58be26a54349$var$BigInteger.prototype.F2 = 2 * $650b58be26a54349$var$dbits - $650b58be26a54349$var$BI_FP;
// Digit conversions
var $650b58be26a54349$var$BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
var $650b58be26a54349$var$BI_RC = new Array();
var $650b58be26a54349$var$rr, $650b58be26a54349$var$vv;
$650b58be26a54349$var$rr = "0".charCodeAt(0);
for($650b58be26a54349$var$vv = 0; $650b58be26a54349$var$vv <= 9; ++$650b58be26a54349$var$vv)$650b58be26a54349$var$BI_RC[$650b58be26a54349$var$rr++] = $650b58be26a54349$var$vv;
$650b58be26a54349$var$rr = "a".charCodeAt(0);
for($650b58be26a54349$var$vv = 10; $650b58be26a54349$var$vv < 36; ++$650b58be26a54349$var$vv)$650b58be26a54349$var$BI_RC[$650b58be26a54349$var$rr++] = $650b58be26a54349$var$vv;
$650b58be26a54349$var$rr = "A".charCodeAt(0);
for($650b58be26a54349$var$vv = 10; $650b58be26a54349$var$vv < 36; ++$650b58be26a54349$var$vv)$650b58be26a54349$var$BI_RC[$650b58be26a54349$var$rr++] = $650b58be26a54349$var$vv;
function $650b58be26a54349$var$int2char(n) {
    return $650b58be26a54349$var$BI_RM.charAt(n);
}
function $650b58be26a54349$var$intAt(s, i) {
    var c = $650b58be26a54349$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function $650b58be26a54349$var$bnpCopyTo(r) {
    for(var i = this.t - 1; i >= 0; --i)r.data[i] = this.data[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function $650b58be26a54349$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this.data[0] = x;
    else if (x < -1) this.data[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function $650b58be26a54349$var$nbv(i) {
    var r = $650b58be26a54349$var$nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function $650b58be26a54349$var$bnpFromString(s, b) {
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 256) k = 8; // byte array
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else {
        this.fromRadix(s, b);
        return;
    }
    this.t = 0;
    this.s = 0;
    var i = s.length, mi = false, sh = 0;
    while(--i >= 0){
        var x = k == 8 ? s[i] & 0xff : $650b58be26a54349$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == "-") mi = true;
            continue;
        }
        mi = false;
        if (sh == 0) this.data[this.t++] = x;
        else if (sh + k > this.DB) {
            this.data[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this.data[this.t++] = x >> this.DB - sh;
        } else this.data[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    if (k == 8 && (s[0] & 0x80) != 0) {
        this.s = -1;
        if (sh > 0) this.data[this.t - 1] |= (1 << this.DB - sh) - 1 << sh;
    }
    this.clamp();
    if (mi) $650b58be26a54349$var$BigInteger.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function $650b58be26a54349$var$bnpClamp() {
    var c = this.s & this.DM;
    while(this.t > 0 && this.data[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function $650b58be26a54349$var$bnToString(b) {
    if (this.s < 0) return "-" + this.negate().toString(b);
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else return this.toRadix(b);
    var km = (1 << k) - 1, d, m = false, r = "", i = this.t;
    var p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this.data[i] >> p) > 0) {
            m = true;
            r = $650b58be26a54349$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this.data[i] & (1 << p) - 1) << k - p;
                d |= this.data[--i] >> (p += this.DB - k);
            } else {
                d = this.data[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $650b58be26a54349$var$int2char(d);
        }
    }
    return m ? r : "0";
}
// (public) -this
function $650b58be26a54349$var$bnNegate() {
    var r = $650b58be26a54349$var$nbi();
    $650b58be26a54349$var$BigInteger.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function $650b58be26a54349$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function $650b58be26a54349$var$bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this.data[i] - a.data[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function $650b58be26a54349$var$nbits(x) {
    var r = 1, t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function $650b58be26a54349$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $650b58be26a54349$var$nbits(this.data[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function $650b58be26a54349$var$bnpDLShiftTo(n, r) {
    var i;
    for(i = this.t - 1; i >= 0; --i)r.data[i + n] = this.data[i];
    for(i = n - 1; i >= 0; --i)r.data[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function $650b58be26a54349$var$bnpDRShiftTo(n, r) {
    for(var i = n; i < this.t; ++i)r.data[i - n] = this.data[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function $650b58be26a54349$var$bnpLShiftTo(n, r) {
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
    for(i = this.t - 1; i >= 0; --i){
        r.data[i + ds + 1] = this.data[i] >> cbs | c;
        c = (this.data[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r.data[i] = 0;
    r.data[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function $650b58be26a54349$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << bs) - 1;
    r.data[0] = this.data[ds] >> bs;
    for(var i = ds + 1; i < this.t; ++i){
        r.data[i - ds - 1] |= (this.data[i] & bm) << cbs;
        r.data[i - ds] = this.data[i] >> bs;
    }
    if (bs > 0) r.data[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function $650b58be26a54349$var$bnpSubTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this.data[i] - a.data[i];
        r.data[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this.data[i];
            r.data[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a.data[i];
            r.data[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r.data[i++] = this.DV + c;
    else if (c > 0) r.data[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $650b58be26a54349$var$bnpMultiplyTo(a, r) {
    var x = this.abs(), y = a.abs();
    var i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r.data[i] = 0;
    for(i = 0; i < y.t; ++i)r.data[i + x.t] = x.am(0, y.data[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s != a.s) $650b58be26a54349$var$BigInteger.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function $650b58be26a54349$var$bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while(--i >= 0)r.data[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        var c = x.am(i, x.data[i], r, 2 * i, 0, 1);
        if ((r.data[i + x.t] += x.am(i + 1, 2 * x.data[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r.data[i + x.t] -= x.DV;
            r.data[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r.data[r.t - 1] += x.am(i, x.data[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $650b58be26a54349$var$bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r == null) r = $650b58be26a54349$var$nbi();
    var y = $650b58be26a54349$var$nbi(), ts = this.s, ms = m.s;
    var nsh = this.DB - $650b58be26a54349$var$nbits(pm.data[pm.t - 1]); // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    var ys = y.t;
    var y0 = y.data[ys - 1];
    if (y0 == 0) return;
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y.data[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
    var i = r.t, j = i - ys, t = q == null ? $650b58be26a54349$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r.data[r.t++] = 1;
        r.subTo(t, r);
    }
    $650b58be26a54349$var$BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y); // "negative" y so we can replace sub with am later
    while(y.t < ys)y.data[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        var qd = r.data[--i] == y0 ? this.DM : Math.floor(r.data[i] * d1 + (r.data[i - 1] + e) * d2);
        if ((r.data[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r.data[i] < --qd)r.subTo(t, r);
        }
    }
    if (q != null) {
        r.drShiftTo(ys, q);
        if (ts != ms) $650b58be26a54349$var$BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r); // Denormalize remainder
    if (ts < 0) $650b58be26a54349$var$BigInteger.ZERO.subTo(r, r);
}
// (public) this mod a
function $650b58be26a54349$var$bnMod(a) {
    var r = $650b58be26a54349$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($650b58be26a54349$var$BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
}
// Modular reduction using "classic" algorithm
function $650b58be26a54349$var$Classic(m) {
    this.m = m;
}
function $650b58be26a54349$var$cConvert(x) {
    if (x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);
    else return x;
}
function $650b58be26a54349$var$cRevert(x) {
    return x;
}
function $650b58be26a54349$var$cReduce(x) {
    x.divRemTo(this.m, null, x);
}
function $650b58be26a54349$var$cMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
function $650b58be26a54349$var$cSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
$650b58be26a54349$var$Classic.prototype.convert = $650b58be26a54349$var$cConvert;
$650b58be26a54349$var$Classic.prototype.revert = $650b58be26a54349$var$cRevert;
$650b58be26a54349$var$Classic.prototype.reduce = $650b58be26a54349$var$cReduce;
$650b58be26a54349$var$Classic.prototype.mulTo = $650b58be26a54349$var$cMulTo;
$650b58be26a54349$var$Classic.prototype.sqrTo = $650b58be26a54349$var$cSqrTo;
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $650b58be26a54349$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this.data[0];
    if ((x & 1) == 0) return 0;
    var y = x & 3; // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf; // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff; // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff; // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV; // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
// Montgomery reduction
function $650b58be26a54349$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function $650b58be26a54349$var$montConvert(x) {
    var r = $650b58be26a54349$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($650b58be26a54349$var$BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function $650b58be26a54349$var$montRevert(x) {
    var r = $650b58be26a54349$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function $650b58be26a54349$var$montReduce(x) {
    while(x.t <= this.mt2)x.data[x.t++] = 0;
    for(var i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x.data[i]*mp mod DV
        var j = x.data[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x.data[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x.data[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x.data[j] >= x.DV){
            x.data[j] -= x.DV;
            x.data[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function $650b58be26a54349$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function $650b58be26a54349$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$650b58be26a54349$var$Montgomery.prototype.convert = $650b58be26a54349$var$montConvert;
$650b58be26a54349$var$Montgomery.prototype.revert = $650b58be26a54349$var$montRevert;
$650b58be26a54349$var$Montgomery.prototype.reduce = $650b58be26a54349$var$montReduce;
$650b58be26a54349$var$Montgomery.prototype.mulTo = $650b58be26a54349$var$montMulTo;
$650b58be26a54349$var$Montgomery.prototype.sqrTo = $650b58be26a54349$var$montSqrTo;
// (protected) true iff this is even
function $650b58be26a54349$var$bnpIsEven() {
    return (this.t > 0 ? this.data[0] & 1 : this.s) == 0;
}
// (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
function $650b58be26a54349$var$bnpExp(e, z) {
    if (e > 0xffffffff || e < 1) return $650b58be26a54349$var$BigInteger.ONE;
    var r = $650b58be26a54349$var$nbi(), r2 = $650b58be26a54349$var$nbi(), g = z.convert(this), i = $650b58be26a54349$var$nbits(e) - 1;
    g.copyTo(r);
    while(--i >= 0){
        z.sqrTo(r, r2);
        if ((e & 1 << i) > 0) z.mulTo(r2, g, r);
        else {
            var t = r;
            r = r2;
            r2 = t;
        }
    }
    return z.revert(r);
}
// (public) this^e % m, 0 <= e < 2^32
function $650b58be26a54349$var$bnModPowInt(e, m) {
    var z;
    if (e < 256 || m.isEven()) z = new $650b58be26a54349$var$Classic(m);
    else z = new $650b58be26a54349$var$Montgomery(m);
    return this.exp(e, z);
}
// protected
$650b58be26a54349$var$BigInteger.prototype.copyTo = $650b58be26a54349$var$bnpCopyTo;
$650b58be26a54349$var$BigInteger.prototype.fromInt = $650b58be26a54349$var$bnpFromInt;
$650b58be26a54349$var$BigInteger.prototype.fromString = $650b58be26a54349$var$bnpFromString;
$650b58be26a54349$var$BigInteger.prototype.clamp = $650b58be26a54349$var$bnpClamp;
$650b58be26a54349$var$BigInteger.prototype.dlShiftTo = $650b58be26a54349$var$bnpDLShiftTo;
$650b58be26a54349$var$BigInteger.prototype.drShiftTo = $650b58be26a54349$var$bnpDRShiftTo;
$650b58be26a54349$var$BigInteger.prototype.lShiftTo = $650b58be26a54349$var$bnpLShiftTo;
$650b58be26a54349$var$BigInteger.prototype.rShiftTo = $650b58be26a54349$var$bnpRShiftTo;
$650b58be26a54349$var$BigInteger.prototype.subTo = $650b58be26a54349$var$bnpSubTo;
$650b58be26a54349$var$BigInteger.prototype.multiplyTo = $650b58be26a54349$var$bnpMultiplyTo;
$650b58be26a54349$var$BigInteger.prototype.squareTo = $650b58be26a54349$var$bnpSquareTo;
$650b58be26a54349$var$BigInteger.prototype.divRemTo = $650b58be26a54349$var$bnpDivRemTo;
$650b58be26a54349$var$BigInteger.prototype.invDigit = $650b58be26a54349$var$bnpInvDigit;
$650b58be26a54349$var$BigInteger.prototype.isEven = $650b58be26a54349$var$bnpIsEven;
$650b58be26a54349$var$BigInteger.prototype.exp = $650b58be26a54349$var$bnpExp;
// public
$650b58be26a54349$var$BigInteger.prototype.toString = $650b58be26a54349$var$bnToString;
$650b58be26a54349$var$BigInteger.prototype.negate = $650b58be26a54349$var$bnNegate;
$650b58be26a54349$var$BigInteger.prototype.abs = $650b58be26a54349$var$bnAbs;
$650b58be26a54349$var$BigInteger.prototype.compareTo = $650b58be26a54349$var$bnCompareTo;
$650b58be26a54349$var$BigInteger.prototype.bitLength = $650b58be26a54349$var$bnBitLength;
$650b58be26a54349$var$BigInteger.prototype.mod = $650b58be26a54349$var$bnMod;
$650b58be26a54349$var$BigInteger.prototype.modPowInt = $650b58be26a54349$var$bnModPowInt;
// "constants"
$650b58be26a54349$var$BigInteger.ZERO = $650b58be26a54349$var$nbv(0);
$650b58be26a54349$var$BigInteger.ONE = $650b58be26a54349$var$nbv(1);
// jsbn2 lib
//Copyright (c) 2005-2009  Tom Wu
//All Rights Reserved.
//See "LICENSE" for details (See jsbn.js for LICENSE).
//Extended JavaScript BN functions, required for RSA private ops.
//Version 1.1: new BigInteger("0", 10) returns "proper" zero
//(public)
function $650b58be26a54349$var$bnClone() {
    var r = $650b58be26a54349$var$nbi();
    this.copyTo(r);
    return r;
}
//(public) return value as integer
function $650b58be26a54349$var$bnIntValue() {
    if (this.s < 0) {
        if (this.t == 1) return this.data[0] - this.DV;
        else if (this.t == 0) return -1;
    } else if (this.t == 1) return this.data[0];
    else if (this.t == 0) return 0;
    // assumes 16 < DB < 32
    return (this.data[1] & (1 << 32 - this.DB) - 1) << this.DB | this.data[0];
}
//(public) return value as byte
function $650b58be26a54349$var$bnByteValue() {
    return this.t == 0 ? this.s : this.data[0] << 24 >> 24;
}
//(public) return value as short (assumes DB>=16)
function $650b58be26a54349$var$bnShortValue() {
    return this.t == 0 ? this.s : this.data[0] << 16 >> 16;
}
//(protected) return x s.t. r^x < DV
function $650b58be26a54349$var$bnpChunkSize(r) {
    return Math.floor(Math.LN2 * this.DB / Math.log(r));
}
//(public) 0 if this == 0, 1 if this > 0
function $650b58be26a54349$var$bnSigNum() {
    if (this.s < 0) return -1;
    else if (this.t <= 0 || this.t == 1 && this.data[0] <= 0) return 0;
    else return 1;
}
//(protected) convert to radix string
function $650b58be26a54349$var$bnpToRadix(b) {
    if (b == null) b = 10;
    if (this.signum() == 0 || b < 2 || b > 36) return "0";
    var cs = this.chunkSize(b);
    var a = Math.pow(b, cs);
    var d = $650b58be26a54349$var$nbv(a), y = $650b58be26a54349$var$nbi(), z = $650b58be26a54349$var$nbi(), r = "";
    this.divRemTo(d, y, z);
    while(y.signum() > 0){
        r = (a + z.intValue()).toString(b).substr(1) + r;
        y.divRemTo(d, y, z);
    }
    return z.intValue().toString(b) + r;
}
//(protected) convert from radix string
function $650b58be26a54349$var$bnpFromRadix(s, b) {
    this.fromInt(0);
    if (b == null) b = 10;
    var cs = this.chunkSize(b);
    var d = Math.pow(b, cs), mi = false, j = 0, w = 0;
    for(var i = 0; i < s.length; ++i){
        var x = $650b58be26a54349$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == "-" && this.signum() == 0) mi = true;
            continue;
        }
        w = b * w + x;
        if (++j >= cs) {
            this.dMultiply(d);
            this.dAddOffset(w, 0);
            j = 0;
            w = 0;
        }
    }
    if (j > 0) {
        this.dMultiply(Math.pow(b, j));
        this.dAddOffset(w, 0);
    }
    if (mi) $650b58be26a54349$var$BigInteger.ZERO.subTo(this, this);
}
//(protected) alternate constructor
function $650b58be26a54349$var$bnpFromNumber(a, b, c) {
    if ("number" == typeof b) {
        // new BigInteger(int,int,RNG)
        if (a < 2) this.fromInt(1);
        else {
            this.fromNumber(a, c);
            if (!this.testBit(a - 1)) this.bitwiseTo($650b58be26a54349$var$BigInteger.ONE.shiftLeft(a - 1), $650b58be26a54349$var$op_or, this);
            if (this.isEven()) this.dAddOffset(1, 0); // force odd
            while(!this.isProbablePrime(b)){
                this.dAddOffset(2, 0);
                if (this.bitLength() > a) this.subTo($650b58be26a54349$var$BigInteger.ONE.shiftLeft(a - 1), this);
            }
        }
    } else {
        // new BigInteger(int,RNG)
        var x = new Array(), t = a & 7;
        x.length = (a >> 3) + 1;
        b.nextBytes(x);
        if (t > 0) x[0] &= (1 << t) - 1;
        else x[0] = 0;
        this.fromString(x, 256);
    }
}
//(public) convert to bigendian byte array
function $650b58be26a54349$var$bnToByteArray() {
    var i = this.t, r = new Array();
    r[0] = this.s;
    var p = this.DB - i * this.DB % 8, d, k = 0;
    if (i-- > 0) {
        if (p < this.DB && (d = this.data[i] >> p) != (this.s & this.DM) >> p) r[k++] = d | this.s << this.DB - p;
        while(i >= 0){
            if (p < 8) {
                d = (this.data[i] & (1 << p) - 1) << 8 - p;
                d |= this.data[--i] >> (p += this.DB - 8);
            } else {
                d = this.data[i] >> (p -= 8) & 0xff;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if ((d & 0x80) != 0) d |= -256;
            if (k == 0 && (this.s & 0x80) != (d & 0x80)) ++k;
            if (k > 0 || d != this.s) r[k++] = d;
        }
    }
    return r;
}
function $650b58be26a54349$var$bnEquals(a) {
    return this.compareTo(a) == 0;
}
function $650b58be26a54349$var$bnMin(a) {
    return this.compareTo(a) < 0 ? this : a;
}
function $650b58be26a54349$var$bnMax(a) {
    return this.compareTo(a) > 0 ? this : a;
}
//(protected) r = this op a (bitwise)
function $650b58be26a54349$var$bnpBitwiseTo(a, op, r) {
    var i, f, m = Math.min(a.t, this.t);
    for(i = 0; i < m; ++i)r.data[i] = op(this.data[i], a.data[i]);
    if (a.t < this.t) {
        f = a.s & this.DM;
        for(i = m; i < this.t; ++i)r.data[i] = op(this.data[i], f);
        r.t = this.t;
    } else {
        f = this.s & this.DM;
        for(i = m; i < a.t; ++i)r.data[i] = op(f, a.data[i]);
        r.t = a.t;
    }
    r.s = op(this.s, a.s);
    r.clamp();
}
//(public) this & a
function $650b58be26a54349$var$op_and(x, y) {
    return x & y;
}
function $650b58be26a54349$var$bnAnd(a) {
    var r = $650b58be26a54349$var$nbi();
    this.bitwiseTo(a, $650b58be26a54349$var$op_and, r);
    return r;
}
//(public) this | a
function $650b58be26a54349$var$op_or(x, y) {
    return x | y;
}
function $650b58be26a54349$var$bnOr(a) {
    var r = $650b58be26a54349$var$nbi();
    this.bitwiseTo(a, $650b58be26a54349$var$op_or, r);
    return r;
}
//(public) this ^ a
function $650b58be26a54349$var$op_xor(x, y) {
    return x ^ y;
}
function $650b58be26a54349$var$bnXor(a) {
    var r = $650b58be26a54349$var$nbi();
    this.bitwiseTo(a, $650b58be26a54349$var$op_xor, r);
    return r;
}
//(public) this & ~a
function $650b58be26a54349$var$op_andnot(x, y) {
    return x & ~y;
}
function $650b58be26a54349$var$bnAndNot(a) {
    var r = $650b58be26a54349$var$nbi();
    this.bitwiseTo(a, $650b58be26a54349$var$op_andnot, r);
    return r;
}
//(public) ~this
function $650b58be26a54349$var$bnNot() {
    var r = $650b58be26a54349$var$nbi();
    for(var i = 0; i < this.t; ++i)r.data[i] = this.DM & ~this.data[i];
    r.t = this.t;
    r.s = ~this.s;
    return r;
}
//(public) this << n
function $650b58be26a54349$var$bnShiftLeft(n) {
    var r = $650b58be26a54349$var$nbi();
    if (n < 0) this.rShiftTo(-n, r);
    else this.lShiftTo(n, r);
    return r;
}
//(public) this >> n
function $650b58be26a54349$var$bnShiftRight(n) {
    var r = $650b58be26a54349$var$nbi();
    if (n < 0) this.lShiftTo(-n, r);
    else this.rShiftTo(n, r);
    return r;
}
//return index of lowest 1-bit in x, x < 2^31
function $650b58be26a54349$var$lbit(x) {
    if (x == 0) return -1;
    var r = 0;
    if ((x & 0xffff) == 0) {
        x >>= 16;
        r += 16;
    }
    if ((x & 0xff) == 0) {
        x >>= 8;
        r += 8;
    }
    if ((x & 0xf) == 0) {
        x >>= 4;
        r += 4;
    }
    if ((x & 3) == 0) {
        x >>= 2;
        r += 2;
    }
    if ((x & 1) == 0) ++r;
    return r;
}
//(public) returns index of lowest 1-bit (or -1 if none)
function $650b58be26a54349$var$bnGetLowestSetBit() {
    for(var i = 0; i < this.t; ++i)if (this.data[i] != 0) return i * this.DB + $650b58be26a54349$var$lbit(this.data[i]);
    if (this.s < 0) return this.t * this.DB;
    return -1;
}
//return number of 1 bits in x
function $650b58be26a54349$var$cbit(x) {
    var r = 0;
    while(x != 0){
        x &= x - 1;
        ++r;
    }
    return r;
}
//(public) return number of set bits
function $650b58be26a54349$var$bnBitCount() {
    var r = 0, x = this.s & this.DM;
    for(var i = 0; i < this.t; ++i)r += $650b58be26a54349$var$cbit(this.data[i] ^ x);
    return r;
}
//(public) true iff nth bit is set
function $650b58be26a54349$var$bnTestBit(n) {
    var j = Math.floor(n / this.DB);
    if (j >= this.t) return this.s != 0;
    return (this.data[j] & 1 << n % this.DB) != 0;
}
//(protected) this op (1<<n)
function $650b58be26a54349$var$bnpChangeBit(n, op) {
    var r = $650b58be26a54349$var$BigInteger.ONE.shiftLeft(n);
    this.bitwiseTo(r, op, r);
    return r;
}
//(public) this | (1<<n)
function $650b58be26a54349$var$bnSetBit(n) {
    return this.changeBit(n, $650b58be26a54349$var$op_or);
}
//(public) this & ~(1<<n)
function $650b58be26a54349$var$bnClearBit(n) {
    return this.changeBit(n, $650b58be26a54349$var$op_andnot);
}
//(public) this ^ (1<<n)
function $650b58be26a54349$var$bnFlipBit(n) {
    return this.changeBit(n, $650b58be26a54349$var$op_xor);
}
//(protected) r = this + a
function $650b58be26a54349$var$bnpAddTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this.data[i] + a.data[i];
        r.data[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this.data[i];
            r.data[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a.data[i];
            r.data[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r.data[i++] = c;
    else if (c < -1) r.data[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
//(public) this + a
function $650b58be26a54349$var$bnAdd(a) {
    var r = $650b58be26a54349$var$nbi();
    this.addTo(a, r);
    return r;
}
//(public) this - a
function $650b58be26a54349$var$bnSubtract(a) {
    var r = $650b58be26a54349$var$nbi();
    this.subTo(a, r);
    return r;
}
//(public) this * a
function $650b58be26a54349$var$bnMultiply(a) {
    var r = $650b58be26a54349$var$nbi();
    this.multiplyTo(a, r);
    return r;
}
//(public) this / a
function $650b58be26a54349$var$bnDivide(a) {
    var r = $650b58be26a54349$var$nbi();
    this.divRemTo(a, r, null);
    return r;
}
//(public) this % a
function $650b58be26a54349$var$bnRemainder(a) {
    var r = $650b58be26a54349$var$nbi();
    this.divRemTo(a, null, r);
    return r;
}
//(public) [this/a,this%a]
function $650b58be26a54349$var$bnDivideAndRemainder(a) {
    var q = $650b58be26a54349$var$nbi(), r = $650b58be26a54349$var$nbi();
    this.divRemTo(a, q, r);
    return new Array(q, r);
}
//(protected) this *= n, this >= 0, 1 < n < DV
function $650b58be26a54349$var$bnpDMultiply(n) {
    this.data[this.t] = this.am(0, n - 1, this, 0, 0, this.t);
    ++this.t;
    this.clamp();
}
//(protected) this += n << w words, this >= 0
function $650b58be26a54349$var$bnpDAddOffset(n, w) {
    if (n == 0) return;
    while(this.t <= w)this.data[this.t++] = 0;
    this.data[w] += n;
    while(this.data[w] >= this.DV){
        this.data[w] -= this.DV;
        if (++w >= this.t) this.data[this.t++] = 0;
        ++this.data[w];
    }
}
//A "null" reducer
function $650b58be26a54349$var$NullExp() {}
function $650b58be26a54349$var$nNop(x) {
    return x;
}
function $650b58be26a54349$var$nMulTo(x, y, r) {
    x.multiplyTo(y, r);
}
function $650b58be26a54349$var$nSqrTo(x, r) {
    x.squareTo(r);
}
$650b58be26a54349$var$NullExp.prototype.convert = $650b58be26a54349$var$nNop;
$650b58be26a54349$var$NullExp.prototype.revert = $650b58be26a54349$var$nNop;
$650b58be26a54349$var$NullExp.prototype.mulTo = $650b58be26a54349$var$nMulTo;
$650b58be26a54349$var$NullExp.prototype.sqrTo = $650b58be26a54349$var$nSqrTo;
//(public) this^e
function $650b58be26a54349$var$bnPow(e) {
    return this.exp(e, new $650b58be26a54349$var$NullExp());
}
//(protected) r = lower n words of "this * a", a.t <= n
//"this" should be the larger one if appropriate.
function $650b58be26a54349$var$bnpMultiplyLowerTo(a, n, r) {
    var i = Math.min(this.t + a.t, n);
    r.s = 0; // assumes a,this >= 0
    r.t = i;
    while(i > 0)r.data[--i] = 0;
    var j;
    for(j = r.t - this.t; i < j; ++i)r.data[i + this.t] = this.am(0, a.data[i], r, i, 0, this.t);
    for(j = Math.min(a.t, n); i < j; ++i)this.am(0, a.data[i], r, i, 0, n - i);
    r.clamp();
}
//(protected) r = "this * a" without lower n words, n > 0
//"this" should be the larger one if appropriate.
function $650b58be26a54349$var$bnpMultiplyUpperTo(a, n, r) {
    --n;
    var i = r.t = this.t + a.t - n;
    r.s = 0; // assumes a,this >= 0
    while(--i >= 0)r.data[i] = 0;
    for(i = Math.max(n - this.t, 0); i < a.t; ++i)r.data[this.t + i - n] = this.am(n - i, a.data[i], r, 0, 0, this.t + i - n);
    r.clamp();
    r.drShiftTo(1, r);
}
//Barrett modular reduction
function $650b58be26a54349$var$Barrett(m) {
    // setup Barrett
    this.r2 = $650b58be26a54349$var$nbi();
    this.q3 = $650b58be26a54349$var$nbi();
    $650b58be26a54349$var$BigInteger.ONE.dlShiftTo(2 * m.t, this.r2);
    this.mu = this.r2.divide(m);
    this.m = m;
}
function $650b58be26a54349$var$barrettConvert(x) {
    if (x.s < 0 || x.t > 2 * this.m.t) return x.mod(this.m);
    else if (x.compareTo(this.m) < 0) return x;
    else {
        var r = $650b58be26a54349$var$nbi();
        x.copyTo(r);
        this.reduce(r);
        return r;
    }
}
function $650b58be26a54349$var$barrettRevert(x) {
    return x;
}
//x = x mod m (HAC 14.42)
function $650b58be26a54349$var$barrettReduce(x) {
    x.drShiftTo(this.m.t - 1, this.r2);
    if (x.t > this.m.t + 1) {
        x.t = this.m.t + 1;
        x.clamp();
    }
    this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
    this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);
    while(x.compareTo(this.r2) < 0)x.dAddOffset(1, this.m.t + 1);
    x.subTo(this.r2, x);
    while(x.compareTo(this.m) >= 0)x.subTo(this.m, x);
}
//r = x^2 mod m; x != r
function $650b58be26a54349$var$barrettSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
//r = x*y mod m; x,y != r
function $650b58be26a54349$var$barrettMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$650b58be26a54349$var$Barrett.prototype.convert = $650b58be26a54349$var$barrettConvert;
$650b58be26a54349$var$Barrett.prototype.revert = $650b58be26a54349$var$barrettRevert;
$650b58be26a54349$var$Barrett.prototype.reduce = $650b58be26a54349$var$barrettReduce;
$650b58be26a54349$var$Barrett.prototype.mulTo = $650b58be26a54349$var$barrettMulTo;
$650b58be26a54349$var$Barrett.prototype.sqrTo = $650b58be26a54349$var$barrettSqrTo;
//(public) this^e % m (HAC 14.85)
function $650b58be26a54349$var$bnModPow(e, m) {
    var i = e.bitLength(), k, r = $650b58be26a54349$var$nbv(1), z;
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    if (i < 8) z = new $650b58be26a54349$var$Classic(m);
    else if (m.isEven()) z = new $650b58be26a54349$var$Barrett(m);
    else z = new $650b58be26a54349$var$Montgomery(m);
    // precomputation
    var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        var g2 = $650b58be26a54349$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $650b58be26a54349$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    var j = e.t - 1, w, is1 = true, r2 = $650b58be26a54349$var$nbi(), t;
    i = $650b58be26a54349$var$nbits(e.data[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e.data[j] >> i - k1 & km;
        else {
            w = (e.data[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e.data[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) == 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e.data[j] & 1 << i) == 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    return z.revert(r);
}
//(public) gcd(this,a) (HAC 14.54)
function $650b58be26a54349$var$bnGCD(a) {
    var x = this.s < 0 ? this.negate() : this.clone();
    var y = a.s < 0 ? a.negate() : a.clone();
    if (x.compareTo(y) < 0) {
        var t = x;
        x = y;
        y = t;
    }
    var i = x.getLowestSetBit(), g = y.getLowestSetBit();
    if (g < 0) return x;
    if (i < g) g = i;
    if (g > 0) {
        x.rShiftTo(g, x);
        y.rShiftTo(g, y);
    }
    while(x.signum() > 0){
        if ((i = x.getLowestSetBit()) > 0) x.rShiftTo(i, x);
        if ((i = y.getLowestSetBit()) > 0) y.rShiftTo(i, y);
        if (x.compareTo(y) >= 0) {
            x.subTo(y, x);
            x.rShiftTo(1, x);
        } else {
            y.subTo(x, y);
            y.rShiftTo(1, y);
        }
    }
    if (g > 0) y.lShiftTo(g, y);
    return y;
}
//(protected) this % n, n < 2^26
function $650b58be26a54349$var$bnpModInt(n) {
    if (n <= 0) return 0;
    var d = this.DV % n, r = this.s < 0 ? n - 1 : 0;
    if (this.t > 0) {
        if (d == 0) r = this.data[0] % n;
        else for(var i = this.t - 1; i >= 0; --i)r = (d * r + this.data[i]) % n;
    }
    return r;
}
//(public) 1/this % m (HAC 14.61)
function $650b58be26a54349$var$bnModInverse(m) {
    var ac = m.isEven();
    if (this.isEven() && ac || m.signum() == 0) return $650b58be26a54349$var$BigInteger.ZERO;
    var u = m.clone(), v = this.clone();
    var a = $650b58be26a54349$var$nbv(1), b = $650b58be26a54349$var$nbv(0), c = $650b58be26a54349$var$nbv(0), d = $650b58be26a54349$var$nbv(1);
    while(u.signum() != 0){
        while(u.isEven()){
            u.rShiftTo(1, u);
            if (ac) {
                if (!a.isEven() || !b.isEven()) {
                    a.addTo(this, a);
                    b.subTo(m, b);
                }
                a.rShiftTo(1, a);
            } else if (!b.isEven()) b.subTo(m, b);
            b.rShiftTo(1, b);
        }
        while(v.isEven()){
            v.rShiftTo(1, v);
            if (ac) {
                if (!c.isEven() || !d.isEven()) {
                    c.addTo(this, c);
                    d.subTo(m, d);
                }
                c.rShiftTo(1, c);
            } else if (!d.isEven()) d.subTo(m, d);
            d.rShiftTo(1, d);
        }
        if (u.compareTo(v) >= 0) {
            u.subTo(v, u);
            if (ac) a.subTo(c, a);
            b.subTo(d, b);
        } else {
            v.subTo(u, v);
            if (ac) c.subTo(a, c);
            d.subTo(b, d);
        }
    }
    if (v.compareTo($650b58be26a54349$var$BigInteger.ONE) != 0) return $650b58be26a54349$var$BigInteger.ZERO;
    if (d.compareTo(m) >= 0) return d.subtract(m);
    if (d.signum() < 0) d.addTo(m, d);
    else return d;
    if (d.signum() < 0) return d.add(m);
    else return d;
}
var $650b58be26a54349$var$lowprimes = [
    2,
    3,
    5,
    7,
    11,
    13,
    17,
    19,
    23,
    29,
    31,
    37,
    41,
    43,
    47,
    53,
    59,
    61,
    67,
    71,
    73,
    79,
    83,
    89,
    97,
    101,
    103,
    107,
    109,
    113,
    127,
    131,
    137,
    139,
    149,
    151,
    157,
    163,
    167,
    173,
    179,
    181,
    191,
    193,
    197,
    199,
    211,
    223,
    227,
    229,
    233,
    239,
    241,
    251,
    257,
    263,
    269,
    271,
    277,
    281,
    283,
    293,
    307,
    311,
    313,
    317,
    331,
    337,
    347,
    349,
    353,
    359,
    367,
    373,
    379,
    383,
    389,
    397,
    401,
    409,
    419,
    421,
    431,
    433,
    439,
    443,
    449,
    457,
    461,
    463,
    467,
    479,
    487,
    491,
    499,
    503,
    509
];
var $650b58be26a54349$var$lplim = 67108864 / $650b58be26a54349$var$lowprimes[$650b58be26a54349$var$lowprimes.length - 1];
//(public) test primality with certainty >= 1-.5^t
function $650b58be26a54349$var$bnIsProbablePrime(t) {
    var i, x = this.abs();
    if (x.t == 1 && x.data[0] <= $650b58be26a54349$var$lowprimes[$650b58be26a54349$var$lowprimes.length - 1]) {
        for(i = 0; i < $650b58be26a54349$var$lowprimes.length; ++i)if (x.data[0] == $650b58be26a54349$var$lowprimes[i]) return true;
        return false;
    }
    if (x.isEven()) return false;
    i = 1;
    while(i < $650b58be26a54349$var$lowprimes.length){
        var m = $650b58be26a54349$var$lowprimes[i], j = i + 1;
        while(j < $650b58be26a54349$var$lowprimes.length && m < $650b58be26a54349$var$lplim)m *= $650b58be26a54349$var$lowprimes[j++];
        m = x.modInt(m);
        while(i < j)if (m % $650b58be26a54349$var$lowprimes[i++] == 0) return false;
    }
    return x.millerRabin(t);
}
//(protected) true if probably prime (HAC 4.24, Miller-Rabin)
function $650b58be26a54349$var$bnpMillerRabin(t) {
    var n1 = this.subtract($650b58be26a54349$var$BigInteger.ONE);
    var k = n1.getLowestSetBit();
    if (k <= 0) return false;
    var r = n1.shiftRight(k);
    var prng = $650b58be26a54349$var$bnGetPrng();
    var a;
    for(var i = 0; i < t; ++i){
        // select witness 'a' at random from between 1 and n1
        do a = new $650b58be26a54349$var$BigInteger(this.bitLength(), prng);
        while (a.compareTo($650b58be26a54349$var$BigInteger.ONE) <= 0 || a.compareTo(n1) >= 0);
        var y = a.modPow(r, this);
        if (y.compareTo($650b58be26a54349$var$BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
            var j = 1;
            while(j++ < k && y.compareTo(n1) != 0){
                y = y.modPowInt(2, this);
                if (y.compareTo($650b58be26a54349$var$BigInteger.ONE) == 0) return false;
            }
            if (y.compareTo(n1) != 0) return false;
        }
    }
    return true;
}
// get pseudo random number generator
function $650b58be26a54349$var$bnGetPrng() {
    // create prng with api that matches BigInteger secure random
    return {
        // x is an array to fill with bytes
        nextBytes: function(x) {
            for(var i = 0; i < x.length; ++i)x[i] = Math.floor(Math.random() * 0x0100);
        }
    };
}
//protected
$650b58be26a54349$var$BigInteger.prototype.chunkSize = $650b58be26a54349$var$bnpChunkSize;
$650b58be26a54349$var$BigInteger.prototype.toRadix = $650b58be26a54349$var$bnpToRadix;
$650b58be26a54349$var$BigInteger.prototype.fromRadix = $650b58be26a54349$var$bnpFromRadix;
$650b58be26a54349$var$BigInteger.prototype.fromNumber = $650b58be26a54349$var$bnpFromNumber;
$650b58be26a54349$var$BigInteger.prototype.bitwiseTo = $650b58be26a54349$var$bnpBitwiseTo;
$650b58be26a54349$var$BigInteger.prototype.changeBit = $650b58be26a54349$var$bnpChangeBit;
$650b58be26a54349$var$BigInteger.prototype.addTo = $650b58be26a54349$var$bnpAddTo;
$650b58be26a54349$var$BigInteger.prototype.dMultiply = $650b58be26a54349$var$bnpDMultiply;
$650b58be26a54349$var$BigInteger.prototype.dAddOffset = $650b58be26a54349$var$bnpDAddOffset;
$650b58be26a54349$var$BigInteger.prototype.multiplyLowerTo = $650b58be26a54349$var$bnpMultiplyLowerTo;
$650b58be26a54349$var$BigInteger.prototype.multiplyUpperTo = $650b58be26a54349$var$bnpMultiplyUpperTo;
$650b58be26a54349$var$BigInteger.prototype.modInt = $650b58be26a54349$var$bnpModInt;
$650b58be26a54349$var$BigInteger.prototype.millerRabin = $650b58be26a54349$var$bnpMillerRabin;
//public
$650b58be26a54349$var$BigInteger.prototype.clone = $650b58be26a54349$var$bnClone;
$650b58be26a54349$var$BigInteger.prototype.intValue = $650b58be26a54349$var$bnIntValue;
$650b58be26a54349$var$BigInteger.prototype.byteValue = $650b58be26a54349$var$bnByteValue;
$650b58be26a54349$var$BigInteger.prototype.shortValue = $650b58be26a54349$var$bnShortValue;
$650b58be26a54349$var$BigInteger.prototype.signum = $650b58be26a54349$var$bnSigNum;
$650b58be26a54349$var$BigInteger.prototype.toByteArray = $650b58be26a54349$var$bnToByteArray;
$650b58be26a54349$var$BigInteger.prototype.equals = $650b58be26a54349$var$bnEquals;
$650b58be26a54349$var$BigInteger.prototype.min = $650b58be26a54349$var$bnMin;
$650b58be26a54349$var$BigInteger.prototype.max = $650b58be26a54349$var$bnMax;
$650b58be26a54349$var$BigInteger.prototype.and = $650b58be26a54349$var$bnAnd;
$650b58be26a54349$var$BigInteger.prototype.or = $650b58be26a54349$var$bnOr;
$650b58be26a54349$var$BigInteger.prototype.xor = $650b58be26a54349$var$bnXor;
$650b58be26a54349$var$BigInteger.prototype.andNot = $650b58be26a54349$var$bnAndNot;
$650b58be26a54349$var$BigInteger.prototype.not = $650b58be26a54349$var$bnNot;
$650b58be26a54349$var$BigInteger.prototype.shiftLeft = $650b58be26a54349$var$bnShiftLeft;
$650b58be26a54349$var$BigInteger.prototype.shiftRight = $650b58be26a54349$var$bnShiftRight;
$650b58be26a54349$var$BigInteger.prototype.getLowestSetBit = $650b58be26a54349$var$bnGetLowestSetBit;
$650b58be26a54349$var$BigInteger.prototype.bitCount = $650b58be26a54349$var$bnBitCount;
$650b58be26a54349$var$BigInteger.prototype.testBit = $650b58be26a54349$var$bnTestBit;
$650b58be26a54349$var$BigInteger.prototype.setBit = $650b58be26a54349$var$bnSetBit;
$650b58be26a54349$var$BigInteger.prototype.clearBit = $650b58be26a54349$var$bnClearBit;
$650b58be26a54349$var$BigInteger.prototype.flipBit = $650b58be26a54349$var$bnFlipBit;
$650b58be26a54349$var$BigInteger.prototype.add = $650b58be26a54349$var$bnAdd;
$650b58be26a54349$var$BigInteger.prototype.subtract = $650b58be26a54349$var$bnSubtract;
$650b58be26a54349$var$BigInteger.prototype.multiply = $650b58be26a54349$var$bnMultiply;
$650b58be26a54349$var$BigInteger.prototype.divide = $650b58be26a54349$var$bnDivide;
$650b58be26a54349$var$BigInteger.prototype.remainder = $650b58be26a54349$var$bnRemainder;
$650b58be26a54349$var$BigInteger.prototype.divideAndRemainder = $650b58be26a54349$var$bnDivideAndRemainder;
$650b58be26a54349$var$BigInteger.prototype.modPow = $650b58be26a54349$var$bnModPow;
$650b58be26a54349$var$BigInteger.prototype.modInverse = $650b58be26a54349$var$bnModInverse;
$650b58be26a54349$var$BigInteger.prototype.pow = $650b58be26a54349$var$bnPow;
$650b58be26a54349$var$BigInteger.prototype.gcd = $650b58be26a54349$var$bnGCD;
$650b58be26a54349$var$BigInteger.prototype.isProbablePrime = $650b58be26a54349$var$bnIsProbablePrime; //BigInteger interfaces not implemented in jsbn:
 //BigInteger(int signum, byte[] magnitude)
 //double doubleValue()
 //float floatValue()
 //int hashCode()
 //long longValue()
 //static BigInteger valueOf(long val)



var $4562c29e3a09053a$exports = {};
/**
 * Partial implementation of PKCS#1 v2.2: RSA-OEAP
 *
 * Modified but based on the following MIT and BSD licensed code:
 *
 * https://github.com/kjur/jsjws/blob/master/rsa.js:
 *
 * The 'jsjws'(JSON Web Signature JavaScript Library) License
 *
 * Copyright (c) 2012 Kenji Urushima
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 * http://webrsa.cvs.sourceforge.net/viewvc/webrsa/Client/RSAES-OAEP.js?content-type=text%2Fplain:
 *
 * RSAES-OAEP.js
 * $Id: RSAES-OAEP.js,v 1.1.1.1 2003/03/19 15:37:20 ellispritchard Exp $
 * JavaScript Implementation of PKCS #1 v2.1 RSA CRYPTOGRAPHY STANDARD (RSA Laboratories, June 14, 2002)
 * Copyright (C) Ellis Pritchard, Guardian Unlimited 2003.
 * Contact: ellis@nukinetics.com
 * Distributed under the BSD License.
 *
 * Official documentation: http://www.rsa.com/rsalabs/node.asp?id=2125
 *
 * @author Evan Jones (http://evanjones.ca/)
 * @author Dave Longley
 *
 * Copyright (c) 2013-2014 Digital Bazaar, Inc.
 */ 
var $cLQG7 = parcelRequire("cLQG7");


var $3fb3b72cb4a56fa5$exports = {};
/**
 * Secure Hash Algorithm with 160-bit digest (SHA-1) implementation.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2015 Digital Bazaar, Inc.
 */ 
var $cLQG7 = parcelRequire("cLQG7");
parcelRequire("4pr5e");

var $3fb3b72cb4a56fa5$var$sha1 = $3fb3b72cb4a56fa5$exports = $cLQG7.sha1 = $cLQG7.sha1 || {};
$cLQG7.md.sha1 = $cLQG7.md.algorithms.sha1 = $3fb3b72cb4a56fa5$var$sha1;
/**
 * Creates a SHA-1 message digest object.
 *
 * @return a message digest object.
 */ $3fb3b72cb4a56fa5$var$sha1.create = function() {
    // do initialization as necessary
    if (!$3fb3b72cb4a56fa5$var$_initialized) $3fb3b72cb4a56fa5$var$_init();
    // SHA-1 state contains five 32-bit integers
    var _state = null;
    // input buffer
    var _input = $cLQG7.util.createBuffer();
    // used for word storage
    var _w = new Array(80);
    // message digest object
    var md = {
        algorithm: 'sha1',
        blockLength: 64,
        digestLength: 20,
        // 56-bit length of message so far (does not including padding)
        messageLength: 0,
        // true message length
        fullMessageLength: null,
        // size of message length in bytes
        messageLengthSize: 8
    };
    /**
   * Starts the digest.
   *
   * @return this digest object.
   */ md.start = function() {
        // up to 56-bit message length for convenience
        md.messageLength = 0;
        // full message length (set md.messageLength64 for backwards-compatibility)
        md.fullMessageLength = md.messageLength64 = [];
        var int32s = md.messageLengthSize / 4;
        for(var i = 0; i < int32s; ++i)md.fullMessageLength.push(0);
        _input = $cLQG7.util.createBuffer();
        _state = {
            h0: 0x67452301,
            h1: 0xEFCDAB89,
            h2: 0x98BADCFE,
            h3: 0x10325476,
            h4: 0xC3D2E1F0
        };
        return md;
    };
    // start digest automatically for first time
    md.start();
    /**
   * Updates the digest with the given message input. The given input can
   * treated as raw input (no encoding will be applied) or an encoding of
   * 'utf8' maybe given to encode the input using UTF-8.
   *
   * @param msg the message input to update with.
   * @param encoding the encoding to use (default: 'raw', other: 'utf8').
   *
   * @return this digest object.
   */ md.update = function(msg, encoding) {
        if (encoding === 'utf8') msg = $cLQG7.util.encodeUtf8(msg);
        // update message length
        var len = msg.length;
        md.messageLength += len;
        len = [
            len / 0x100000000 >>> 0,
            len >>> 0
        ];
        for(var i = md.fullMessageLength.length - 1; i >= 0; --i){
            md.fullMessageLength[i] += len[1];
            len[1] = len[0] + (md.fullMessageLength[i] / 0x100000000 >>> 0);
            md.fullMessageLength[i] = md.fullMessageLength[i] >>> 0;
            len[0] = len[1] / 0x100000000 >>> 0;
        }
        // add bytes to input buffer
        _input.putBytes(msg);
        // process bytes
        $3fb3b72cb4a56fa5$var$_update(_state, _w, _input);
        // compact input buffer every 2K or if empty
        if (_input.read > 2048 || _input.length() === 0) _input.compact();
        return md;
    };
    /**
   * Produces the digest.
   *
   * @return a byte buffer containing the digest value.
   */ md.digest = function() {
        /* Note: Here we copy the remaining bytes in the input buffer and
    add the appropriate SHA-1 padding. Then we do the final update
    on a copy of the state so that if the user wants to get
    intermediate digests they can do so. */ /* Determine the number of bytes that must be added to the message
    to ensure its length is congruent to 448 mod 512. In other words,
    the data to be digested must be a multiple of 512 bits (or 128 bytes).
    This data includes the message, some padding, and the length of the
    message. Since the length of the message will be encoded as 8 bytes (64
    bits), that means that the last segment of the data must have 56 bytes
    (448 bits) of message and padding. Therefore, the length of the message
    plus the padding must be congruent to 448 mod 512 because
    512 - 128 = 448.

    In order to fill up the message length it must be filled with
    padding that begins with 1 bit followed by all 0 bits. Padding
    must *always* be present, so if the message length is already
    congruent to 448 mod 512, then 512 padding bits must be added. */ var finalBlock = $cLQG7.util.createBuffer();
        finalBlock.putBytes(_input.bytes());
        // compute remaining size to be digested (include message length size)
        var remaining = md.fullMessageLength[md.fullMessageLength.length - 1] + md.messageLengthSize;
        // add padding for overflow blockSize - overflow
        // _padding starts with 1 byte with first bit is set (byte value 128), then
        // there may be up to (blockSize - 1) other pad bytes
        var overflow = remaining & md.blockLength - 1;
        finalBlock.putBytes($3fb3b72cb4a56fa5$var$_padding.substr(0, md.blockLength - overflow));
        // serialize message length in bits in big-endian order; since length
        // is stored in bytes we multiply by 8 and add carry from next int
        var next, carry;
        var bits = md.fullMessageLength[0] * 8;
        for(var i = 0; i < md.fullMessageLength.length - 1; ++i){
            next = md.fullMessageLength[i + 1] * 8;
            carry = next / 0x100000000 >>> 0;
            bits += carry;
            finalBlock.putInt32(bits >>> 0);
            bits = next >>> 0;
        }
        finalBlock.putInt32(bits);
        var s2 = {
            h0: _state.h0,
            h1: _state.h1,
            h2: _state.h2,
            h3: _state.h3,
            h4: _state.h4
        };
        $3fb3b72cb4a56fa5$var$_update(s2, _w, finalBlock);
        var rval = $cLQG7.util.createBuffer();
        rval.putInt32(s2.h0);
        rval.putInt32(s2.h1);
        rval.putInt32(s2.h2);
        rval.putInt32(s2.h3);
        rval.putInt32(s2.h4);
        return rval;
    };
    return md;
};
// sha-1 padding bytes not initialized yet
var $3fb3b72cb4a56fa5$var$_padding = null;
var $3fb3b72cb4a56fa5$var$_initialized = false;
/**
 * Initializes the constant tables.
 */ function $3fb3b72cb4a56fa5$var$_init() {
    // create padding
    $3fb3b72cb4a56fa5$var$_padding = String.fromCharCode(128);
    $3fb3b72cb4a56fa5$var$_padding += $cLQG7.util.fillString(String.fromCharCode(0x00), 64);
    // now initialized
    $3fb3b72cb4a56fa5$var$_initialized = true;
}
/**
 * Updates a SHA-1 state with the given byte buffer.
 *
 * @param s the SHA-1 state to update.
 * @param w the array to use to store words.
 * @param bytes the byte buffer to update with.
 */ function $3fb3b72cb4a56fa5$var$_update(s, w, bytes) {
    // consume 512 bit (64 byte) chunks
    var t, a, b, c, d, e, f, i;
    var len = bytes.length();
    while(len >= 64){
        // the w array will be populated with sixteen 32-bit big-endian words
        // and then extended into 80 32-bit words according to SHA-1 algorithm
        // and for 32-79 using Max Locktyukhin's optimization
        // initialize hash value for this chunk
        a = s.h0;
        b = s.h1;
        c = s.h2;
        d = s.h3;
        e = s.h4;
        // round 1
        for(i = 0; i < 16; ++i){
            t = bytes.getInt32();
            w[i] = t;
            f = d ^ b & (c ^ d);
            t = (a << 5 | a >>> 27) + f + e + 0x5A827999 + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        for(; i < 20; ++i){
            t = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
            t = t << 1 | t >>> 31;
            w[i] = t;
            f = d ^ b & (c ^ d);
            t = (a << 5 | a >>> 27) + f + e + 0x5A827999 + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        // round 2
        for(; i < 32; ++i){
            t = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
            t = t << 1 | t >>> 31;
            w[i] = t;
            f = b ^ c ^ d;
            t = (a << 5 | a >>> 27) + f + e + 0x6ED9EBA1 + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        for(; i < 40; ++i){
            t = w[i - 6] ^ w[i - 16] ^ w[i - 28] ^ w[i - 32];
            t = t << 2 | t >>> 30;
            w[i] = t;
            f = b ^ c ^ d;
            t = (a << 5 | a >>> 27) + f + e + 0x6ED9EBA1 + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        // round 3
        for(; i < 60; ++i){
            t = w[i - 6] ^ w[i - 16] ^ w[i - 28] ^ w[i - 32];
            t = t << 2 | t >>> 30;
            w[i] = t;
            f = b & c | d & (b ^ c);
            t = (a << 5 | a >>> 27) + f + e + 0x8F1BBCDC + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        // round 4
        for(; i < 80; ++i){
            t = w[i - 6] ^ w[i - 16] ^ w[i - 28] ^ w[i - 32];
            t = t << 2 | t >>> 30;
            w[i] = t;
            f = b ^ c ^ d;
            t = (a << 5 | a >>> 27) + f + e + 0xCA62C1D6 + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        // update hash state
        s.h0 = s.h0 + a | 0;
        s.h1 = s.h1 + b | 0;
        s.h2 = s.h2 + c | 0;
        s.h3 = s.h3 + d | 0;
        s.h4 = s.h4 + e | 0;
        len -= 64;
    }
}


// shortcut for PKCS#1 API
var $4562c29e3a09053a$var$pkcs1 = $4562c29e3a09053a$exports = $cLQG7.pkcs1 = $cLQG7.pkcs1 || {};
/**
 * Encode the given RSAES-OAEP message (M) using key, with optional label (L)
 * and seed.
 *
 * This method does not perform RSA encryption, it only encodes the message
 * using RSAES-OAEP.
 *
 * @param key the RSA key to use.
 * @param message the message to encode.
 * @param options the options to use:
 *          label an optional label to use.
 *          seed the seed to use.
 *          md the message digest object to use, undefined for SHA-1.
 *          mgf1 optional mgf1 parameters:
 *            md the message digest object to use for MGF1.
 *
 * @return the encoded message bytes.
 */ $4562c29e3a09053a$var$pkcs1.encode_rsa_oaep = function(key, message, options) {
    // parse arguments
    var label;
    var seed;
    var md;
    var mgf1Md;
    // legacy args (label, seed, md)
    if (typeof options === 'string') {
        label = options;
        seed = arguments[3] || undefined;
        md = arguments[4] || undefined;
    } else if (options) {
        label = options.label || undefined;
        seed = options.seed || undefined;
        md = options.md || undefined;
        if (options.mgf1 && options.mgf1.md) mgf1Md = options.mgf1.md;
    }
    // default OAEP to SHA-1 message digest
    if (!md) md = $cLQG7.md.sha1.create();
    else md.start();
    // default MGF-1 to same as OAEP
    if (!mgf1Md) mgf1Md = md;
    // compute length in bytes and check output
    var keyLength = Math.ceil(key.n.bitLength() / 8);
    var maxLength = keyLength - 2 * md.digestLength - 2;
    if (message.length > maxLength) {
        var error = new Error('RSAES-OAEP input message length is too long.');
        error.length = message.length;
        error.maxLength = maxLength;
        throw error;
    }
    if (!label) label = '';
    md.update(label, 'raw');
    var lHash = md.digest();
    var PS = '';
    var PS_length = maxLength - message.length;
    for(var i = 0; i < PS_length; i++)PS += '\x00';
    var DB = lHash.getBytes() + PS + '\x01' + message;
    if (!seed) seed = $cLQG7.random.getBytes(md.digestLength);
    else if (seed.length !== md.digestLength) {
        var error = new Error("Invalid RSAES-OAEP seed. The seed length must match the digest length.");
        error.seedLength = seed.length;
        error.digestLength = md.digestLength;
        throw error;
    }
    var dbMask = $4562c29e3a09053a$var$rsa_mgf1(seed, keyLength - md.digestLength - 1, mgf1Md);
    var maskedDB = $cLQG7.util.xorBytes(DB, dbMask, DB.length);
    var seedMask = $4562c29e3a09053a$var$rsa_mgf1(maskedDB, md.digestLength, mgf1Md);
    var maskedSeed = $cLQG7.util.xorBytes(seed, seedMask, seed.length);
    // return encoded message
    return '\x00' + maskedSeed + maskedDB;
};
/**
 * Decode the given RSAES-OAEP encoded message (EM) using key, with optional
 * label (L).
 *
 * This method does not perform RSA decryption, it only decodes the message
 * using RSAES-OAEP.
 *
 * @param key the RSA key to use.
 * @param em the encoded message to decode.
 * @param options the options to use:
 *          label an optional label to use.
 *          md the message digest object to use for OAEP, undefined for SHA-1.
 *          mgf1 optional mgf1 parameters:
 *            md the message digest object to use for MGF1.
 *
 * @return the decoded message bytes.
 */ $4562c29e3a09053a$var$pkcs1.decode_rsa_oaep = function(key, em, options) {
    // parse args
    var label;
    var md;
    var mgf1Md;
    // legacy args
    if (typeof options === 'string') {
        label = options;
        md = arguments[3] || undefined;
    } else if (options) {
        label = options.label || undefined;
        md = options.md || undefined;
        if (options.mgf1 && options.mgf1.md) mgf1Md = options.mgf1.md;
    }
    // compute length in bytes
    var keyLength = Math.ceil(key.n.bitLength() / 8);
    if (em.length !== keyLength) {
        var error = new Error('RSAES-OAEP encoded message length is invalid.');
        error.length = em.length;
        error.expectedLength = keyLength;
        throw error;
    }
    // default OAEP to SHA-1 message digest
    if (md === undefined) md = $cLQG7.md.sha1.create();
    else md.start();
    // default MGF-1 to same as OAEP
    if (!mgf1Md) mgf1Md = md;
    if (keyLength < 2 * md.digestLength + 2) throw new Error('RSAES-OAEP key is too short for the hash function.');
    if (!label) label = '';
    md.update(label, 'raw');
    var lHash = md.digest().getBytes();
    // split the message into its parts
    var y = em.charAt(0);
    var maskedSeed = em.substring(1, md.digestLength + 1);
    var maskedDB = em.substring(1 + md.digestLength);
    var seedMask = $4562c29e3a09053a$var$rsa_mgf1(maskedDB, md.digestLength, mgf1Md);
    var seed = $cLQG7.util.xorBytes(maskedSeed, seedMask, maskedSeed.length);
    var dbMask = $4562c29e3a09053a$var$rsa_mgf1(seed, keyLength - md.digestLength - 1, mgf1Md);
    var db = $cLQG7.util.xorBytes(maskedDB, dbMask, maskedDB.length);
    var lHashPrime = db.substring(0, md.digestLength);
    // constant time check that all values match what is expected
    var error = y !== '\x00';
    // constant time check lHash vs lHashPrime
    for(var i = 0; i < md.digestLength; ++i)error |= lHash.charAt(i) !== lHashPrime.charAt(i);
    // "constant time" find the 0x1 byte separating the padding (zeros) from the
    // message
    // TODO: It must be possible to do this in a better/smarter way?
    var in_ps = 1;
    var index = md.digestLength;
    for(var j = md.digestLength; j < db.length; j++){
        var code = db.charCodeAt(j);
        var is_0 = code & 0x1 ^ 0x1;
        // non-zero if not 0 or 1 in the ps section
        var error_mask = in_ps ? 0xfffe : 0x0000;
        error |= code & error_mask;
        // latch in_ps to zero after we find 0x1
        in_ps = in_ps & is_0;
        index += in_ps;
    }
    if (error || db.charCodeAt(index) !== 0x1) throw new Error('Invalid RSAES-OAEP padding.');
    return db.substring(index + 1);
};
function $4562c29e3a09053a$var$rsa_mgf1(seed, maskLength, hash) {
    // default to SHA-1 message digest
    if (!hash) hash = $cLQG7.md.sha1.create();
    var t = '';
    var count = Math.ceil(maskLength / hash.digestLength);
    for(var i = 0; i < count; ++i){
        var c = String.fromCharCode(i >> 24 & 0xFF, i >> 16 & 0xFF, i >> 8 & 0xFF, i & 0xFF);
        hash.start();
        hash.update(seed + c);
        t += hash.digest().getBytes();
    }
    return t.substring(0, maskLength);
}


var $0c6714584e0bbbcd$exports = {};
/**
 * Prime number generation API.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2014 Digital Bazaar, Inc.
 */ 
var $cLQG7 = parcelRequire("cLQG7");



(function() {
    // forge.prime already defined
    if ($cLQG7.prime) {
        $0c6714584e0bbbcd$exports = $cLQG7.prime;
        return;
    }
    /* PRIME API */ var prime = $0c6714584e0bbbcd$exports = $cLQG7.prime = $cLQG7.prime || {};
    var BigInteger = $cLQG7.jsbn.BigInteger;
    // primes are 30k+i for i = 1, 7, 11, 13, 17, 19, 23, 29
    var GCD_30_DELTA = [
        6,
        4,
        2,
        4,
        2,
        4,
        6,
        2
    ];
    var THIRTY = new BigInteger(null);
    THIRTY.fromInt(30);
    var op_or = function(x, y) {
        return x | y;
    };
    /**
 * Generates a random probable prime with the given number of bits.
 *
 * Alternative algorithms can be specified by name as a string or as an
 * object with custom options like so:
 *
 * {
 *   name: 'PRIMEINC',
 *   options: {
 *     maxBlockTime: <the maximum amount of time to block the main
 *       thread before allowing I/O other JS to run>,
 *     millerRabinTests: <the number of miller-rabin tests to run>,
 *     workerScript: <the worker script URL>,
 *     workers: <the number of web workers (if supported) to use,
 *       -1 to use estimated cores minus one>.
 *     workLoad: the size of the work load, ie: number of possible prime
 *       numbers for each web worker to check per work assignment,
 *       (default: 100).
 *   }
 * }
 *
 * @param bits the number of bits for the prime number.
 * @param options the options to use.
 *          [algorithm] the algorithm to use (default: 'PRIMEINC').
 *          [prng] a custom crypto-secure pseudo-random number generator to use,
 *            that must define "getBytesSync".
 *
 * @return callback(err, num) called once the operation completes.
 */ prime.generateProbablePrime = function(bits, options, callback) {
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        options = options || {};
        // default to PRIMEINC algorithm
        var algorithm = options.algorithm || 'PRIMEINC';
        if (typeof algorithm === 'string') algorithm = {
            name: algorithm
        };
        algorithm.options = algorithm.options || {};
        // create prng with api that matches BigInteger secure random
        var prng = options.prng || $cLQG7.random;
        var rng = {
            // x is an array to fill with bytes
            nextBytes: function(x) {
                var b = prng.getBytesSync(x.length);
                for(var i = 0; i < x.length; ++i)x[i] = b.charCodeAt(i);
            }
        };
        if (algorithm.name === 'PRIMEINC') return primeincFindPrime(bits, rng, algorithm.options, callback);
        throw new Error('Invalid prime generation algorithm: ' + algorithm.name);
    };
    function primeincFindPrime(bits, rng, options, callback) {
        if ('workers' in options) return primeincFindPrimeWithWorkers(bits, rng, options, callback);
        return primeincFindPrimeWithoutWorkers(bits, rng, options, callback);
    }
    function primeincFindPrimeWithoutWorkers(bits, rng, options, callback) {
        // initialize random number
        var num = generateRandom(bits, rng);
        /* Note: All primes are of the form 30k+i for i < 30 and gcd(30, i)=1. The
  number we are given is always aligned at 30k + 1. Each time the number is
  determined not to be prime we add to get to the next 'i', eg: if the number
  was at 30k + 1 we add 6. */ var deltaIdx = 0;
        // get required number of MR tests
        var mrTests = getMillerRabinTests(num.bitLength());
        if ('millerRabinTests' in options) mrTests = options.millerRabinTests;
        // find prime nearest to 'num' for maxBlockTime ms
        // 10 ms gives 5ms of leeway for other calculations before dropping
        // below 60fps (1000/60 == 16.67), but in reality, the number will
        // likely be higher due to an 'atomic' big int modPow
        var maxBlockTime = 10;
        if ('maxBlockTime' in options) maxBlockTime = options.maxBlockTime;
        _primeinc(num, bits, rng, deltaIdx, mrTests, maxBlockTime, callback);
    }
    function _primeinc(num, bits, rng, deltaIdx, mrTests, maxBlockTime, callback) {
        var start = +new Date();
        do {
            // overflow, regenerate random number
            if (num.bitLength() > bits) num = generateRandom(bits, rng);
            // do primality test
            if (num.isProbablePrime(mrTests)) return callback(null, num);
            // get next potential prime
            num.dAddOffset(GCD_30_DELTA[deltaIdx++ % 8], 0);
        }while (maxBlockTime < 0 || +new Date() - start < maxBlockTime);
        // keep trying later
        $cLQG7.util.setImmediate(function() {
            _primeinc(num, bits, rng, deltaIdx, mrTests, maxBlockTime, callback);
        });
    }
    // NOTE: This algorithm is indeterminate in nature because workers
    // run in parallel looking at different segments of numbers. Even if this
    // algorithm is run twice with the same input from a predictable RNG, it
    // may produce different outputs.
    function primeincFindPrimeWithWorkers(bits, rng, options, callback) {
        // web workers unavailable
        if (typeof Worker === 'undefined') return primeincFindPrimeWithoutWorkers(bits, rng, options, callback);
        // initialize random number
        var num = generateRandom(bits, rng);
        // use web workers to generate keys
        var numWorkers = options.workers;
        var workLoad = options.workLoad || 100;
        var range = workLoad * 30 / 8;
        var workerScript = options.workerScript || 'forge/prime.worker.js';
        if (numWorkers === -1) return $cLQG7.util.estimateCores(function(err, cores) {
            if (err) // default to 2
            cores = 2;
            numWorkers = cores - 1;
            generate();
        });
        generate();
        function generate() {
            // require at least 1 worker
            numWorkers = Math.max(1, numWorkers);
            // TODO: consider optimizing by starting workers outside getPrime() ...
            // note that in order to clean up they will have to be made internally
            // asynchronous which may actually be slower
            // start workers immediately
            var workers = [];
            for(var i = 0; i < numWorkers; ++i)// FIXME: fix path or use blob URLs
            workers[i] = new Worker(workerScript);
            var running = numWorkers;
            // listen for requests from workers and assign ranges to find prime
            for(var i = 0; i < numWorkers; ++i)workers[i].addEventListener('message', workerMessage);
            /* Note: The distribution of random numbers is unknown. Therefore, each
    web worker is continuously allocated a range of numbers to check for a
    random number until one is found.

    Every 30 numbers will be checked just 8 times, because prime numbers
    have the form:

    30k+i, for i < 30 and gcd(30, i)=1 (there are 8 values of i for this)

    Therefore, if we want a web worker to run N checks before asking for
    a new range of numbers, each range must contain N*30/8 numbers.

    For 100 checks (workLoad), this is a range of 375. */ var found = false;
            function workerMessage(e) {
                // ignore message, prime already found
                if (found) return;
                --running;
                var data = e.data;
                if (data.found) {
                    // terminate all workers
                    for(var i = 0; i < workers.length; ++i)workers[i].terminate();
                    found = true;
                    return callback(null, new BigInteger(data.prime, 16));
                }
                // overflow, regenerate random number
                if (num.bitLength() > bits) num = generateRandom(bits, rng);
                // assign new range to check
                var hex = num.toString(16);
                // start prime search
                e.target.postMessage({
                    hex: hex,
                    workLoad: workLoad
                });
                num.dAddOffset(range, 0);
            }
        }
    }
    /**
 * Generates a random number using the given number of bits and RNG.
 *
 * @param bits the number of bits for the number.
 * @param rng the random number generator to use.
 *
 * @return the random number.
 */ function generateRandom(bits, rng) {
        var num = new BigInteger(bits, rng);
        // force MSB set
        var bits1 = bits - 1;
        if (!num.testBit(bits1)) num.bitwiseTo(BigInteger.ONE.shiftLeft(bits1), op_or, num);
        // align number on 30k+1 boundary
        num.dAddOffset(31 - num.mod(THIRTY).byteValue(), 0);
        return num;
    }
    /**
 * Returns the required number of Miller-Rabin tests to generate a
 * prime with an error probability of (1/2)^80.
 *
 * See Handbook of Applied Cryptography Chapter 4, Table 4.4.
 *
 * @param bits the bit size.
 *
 * @return the required number of iterations.
 */ function getMillerRabinTests(bits) {
        if (bits <= 100) return 27;
        if (bits <= 150) return 18;
        if (bits <= 200) return 15;
        if (bits <= 250) return 12;
        if (bits <= 300) return 9;
        if (bits <= 350) return 8;
        if (bits <= 400) return 7;
        if (bits <= 500) return 6;
        if (bits <= 600) return 5;
        if (bits <= 800) return 4;
        if (bits <= 1250) return 3;
        return 2;
    }
})();




if (typeof $ef3f2aff9b40d381$var$BigInteger === 'undefined') var $ef3f2aff9b40d381$var$BigInteger = $cLQG7.jsbn.BigInteger;

var $ef3f2aff9b40d381$var$_crypto = $cLQG7.util.isNodejs ? (parcelRequire("lbUi1")) : null;
// shortcut for asn.1 API
var $ef3f2aff9b40d381$var$asn1 = $cLQG7.asn1;
// shortcut for util API
var $ef3f2aff9b40d381$var$util = $cLQG7.util;
/*
 * RSA encryption and decryption, see RFC 2313.
 */ $cLQG7.pki = $cLQG7.pki || {};
$ef3f2aff9b40d381$exports = $cLQG7.pki.rsa = $cLQG7.rsa = $cLQG7.rsa || {};
var $ef3f2aff9b40d381$var$pki = $cLQG7.pki;
// for finding primes, which are 30k+i for i = 1, 7, 11, 13, 17, 19, 23, 29
var $ef3f2aff9b40d381$var$GCD_30_DELTA = [
    6,
    4,
    2,
    4,
    2,
    4,
    6,
    2
];
// validator for a PrivateKeyInfo structure
var $ef3f2aff9b40d381$var$privateKeyValidator = {
    // PrivateKeyInfo
    name: 'PrivateKeyInfo',
    tagClass: $ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL,
    type: $ef3f2aff9b40d381$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            // Version (INTEGER)
            name: 'PrivateKeyInfo.version',
            tagClass: $ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL,
            type: $ef3f2aff9b40d381$var$asn1.Type.INTEGER,
            constructed: false,
            capture: 'privateKeyVersion'
        },
        {
            // privateKeyAlgorithm
            name: 'PrivateKeyInfo.privateKeyAlgorithm',
            tagClass: $ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL,
            type: $ef3f2aff9b40d381$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: 'AlgorithmIdentifier.algorithm',
                    tagClass: $ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL,
                    type: $ef3f2aff9b40d381$var$asn1.Type.OID,
                    constructed: false,
                    capture: 'privateKeyOid'
                }
            ]
        },
        {
            // PrivateKey
            name: 'PrivateKeyInfo',
            tagClass: $ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL,
            type: $ef3f2aff9b40d381$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: 'privateKey'
        }
    ]
};
// validator for an RSA private key
var $ef3f2aff9b40d381$var$rsaPrivateKeyValidator = {
    // RSAPrivateKey
    name: 'RSAPrivateKey',
    tagClass: $ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL,
    type: $ef3f2aff9b40d381$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            // Version (INTEGER)
            name: 'RSAPrivateKey.version',
            tagClass: $ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL,
            type: $ef3f2aff9b40d381$var$asn1.Type.INTEGER,
            constructed: false,
            capture: 'privateKeyVersion'
        },
        {
            // modulus (n)
            name: 'RSAPrivateKey.modulus',
            tagClass: $ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL,
            type: $ef3f2aff9b40d381$var$asn1.Type.INTEGER,
            constructed: false,
            capture: 'privateKeyModulus'
        },
        {
            // publicExponent (e)
            name: 'RSAPrivateKey.publicExponent',
            tagClass: $ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL,
            type: $ef3f2aff9b40d381$var$asn1.Type.INTEGER,
            constructed: false,
            capture: 'privateKeyPublicExponent'
        },
        {
            // privateExponent (d)
            name: 'RSAPrivateKey.privateExponent',
            tagClass: $ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL,
            type: $ef3f2aff9b40d381$var$asn1.Type.INTEGER,
            constructed: false,
            capture: 'privateKeyPrivateExponent'
        },
        {
            // prime1 (p)
            name: 'RSAPrivateKey.prime1',
            tagClass: $ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL,
            type: $ef3f2aff9b40d381$var$asn1.Type.INTEGER,
            constructed: false,
            capture: 'privateKeyPrime1'
        },
        {
            // prime2 (q)
            name: 'RSAPrivateKey.prime2',
            tagClass: $ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL,
            type: $ef3f2aff9b40d381$var$asn1.Type.INTEGER,
            constructed: false,
            capture: 'privateKeyPrime2'
        },
        {
            // exponent1 (d mod (p-1))
            name: 'RSAPrivateKey.exponent1',
            tagClass: $ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL,
            type: $ef3f2aff9b40d381$var$asn1.Type.INTEGER,
            constructed: false,
            capture: 'privateKeyExponent1'
        },
        {
            // exponent2 (d mod (q-1))
            name: 'RSAPrivateKey.exponent2',
            tagClass: $ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL,
            type: $ef3f2aff9b40d381$var$asn1.Type.INTEGER,
            constructed: false,
            capture: 'privateKeyExponent2'
        },
        {
            // coefficient ((inverse of q) mod p)
            name: 'RSAPrivateKey.coefficient',
            tagClass: $ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL,
            type: $ef3f2aff9b40d381$var$asn1.Type.INTEGER,
            constructed: false,
            capture: 'privateKeyCoefficient'
        }
    ]
};
// validator for an RSA public key
var $ef3f2aff9b40d381$var$rsaPublicKeyValidator = {
    // RSAPublicKey
    name: 'RSAPublicKey',
    tagClass: $ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL,
    type: $ef3f2aff9b40d381$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            // modulus (n)
            name: 'RSAPublicKey.modulus',
            tagClass: $ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL,
            type: $ef3f2aff9b40d381$var$asn1.Type.INTEGER,
            constructed: false,
            capture: 'publicKeyModulus'
        },
        {
            // publicExponent (e)
            name: 'RSAPublicKey.exponent',
            tagClass: $ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL,
            type: $ef3f2aff9b40d381$var$asn1.Type.INTEGER,
            constructed: false,
            capture: 'publicKeyExponent'
        }
    ]
};
// validator for an SubjectPublicKeyInfo structure
// Note: Currently only works with an RSA public key
var $ef3f2aff9b40d381$var$publicKeyValidator = $cLQG7.pki.rsa.publicKeyValidator = {
    name: 'SubjectPublicKeyInfo',
    tagClass: $ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL,
    type: $ef3f2aff9b40d381$var$asn1.Type.SEQUENCE,
    constructed: true,
    captureAsn1: 'subjectPublicKeyInfo',
    value: [
        {
            name: 'SubjectPublicKeyInfo.AlgorithmIdentifier',
            tagClass: $ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL,
            type: $ef3f2aff9b40d381$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: 'AlgorithmIdentifier.algorithm',
                    tagClass: $ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL,
                    type: $ef3f2aff9b40d381$var$asn1.Type.OID,
                    constructed: false,
                    capture: 'publicKeyOid'
                }
            ]
        },
        {
            // subjectPublicKey
            name: 'SubjectPublicKeyInfo.subjectPublicKey',
            tagClass: $ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL,
            type: $ef3f2aff9b40d381$var$asn1.Type.BITSTRING,
            constructed: false,
            value: [
                {
                    // RSAPublicKey
                    name: 'SubjectPublicKeyInfo.subjectPublicKey.RSAPublicKey',
                    tagClass: $ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL,
                    type: $ef3f2aff9b40d381$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    optional: true,
                    captureAsn1: 'rsaPublicKey'
                }
            ]
        }
    ]
};
// validator for a DigestInfo structure
var $ef3f2aff9b40d381$var$digestInfoValidator = {
    name: 'DigestInfo',
    tagClass: $ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL,
    type: $ef3f2aff9b40d381$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: 'DigestInfo.DigestAlgorithm',
            tagClass: $ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL,
            type: $ef3f2aff9b40d381$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: 'DigestInfo.DigestAlgorithm.algorithmIdentifier',
                    tagClass: $ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL,
                    type: $ef3f2aff9b40d381$var$asn1.Type.OID,
                    constructed: false,
                    capture: 'algorithmIdentifier'
                },
                {
                    // NULL paramters
                    name: 'DigestInfo.DigestAlgorithm.parameters',
                    tagClass: $ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL,
                    type: $ef3f2aff9b40d381$var$asn1.Type.NULL,
                    // captured only to check existence for md2 and md5
                    capture: 'parameters',
                    optional: true,
                    constructed: false
                }
            ]
        },
        {
            // digest
            name: 'DigestInfo.digest',
            tagClass: $ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL,
            type: $ef3f2aff9b40d381$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: 'digest'
        }
    ]
};
/**
 * Wrap digest in DigestInfo object.
 *
 * This function implements EMSA-PKCS1-v1_5-ENCODE as per RFC 3447.
 *
 * DigestInfo ::= SEQUENCE {
 *   digestAlgorithm DigestAlgorithmIdentifier,
 *   digest Digest
 * }
 *
 * DigestAlgorithmIdentifier ::= AlgorithmIdentifier
 * Digest ::= OCTET STRING
 *
 * @param md the message digest object with the hash to sign.
 *
 * @return the encoded message (ready for RSA encrytion)
 */ var $ef3f2aff9b40d381$var$emsaPkcs1v15encode = function(md) {
    // get the oid for the algorithm
    var oid;
    if (md.algorithm in $ef3f2aff9b40d381$var$pki.oids) oid = $ef3f2aff9b40d381$var$pki.oids[md.algorithm];
    else {
        var error = new Error('Unknown message digest algorithm.');
        error.algorithm = md.algorithm;
        throw error;
    }
    var oidBytes = $ef3f2aff9b40d381$var$asn1.oidToDer(oid).getBytes();
    // create the digest info
    var digestInfo = $ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.SEQUENCE, true, []);
    var digestAlgorithm = $ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.SEQUENCE, true, []);
    digestAlgorithm.value.push($ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.OID, false, oidBytes));
    digestAlgorithm.value.push($ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.NULL, false, ''));
    var digest = $ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.OCTETSTRING, false, md.digest().getBytes());
    digestInfo.value.push(digestAlgorithm);
    digestInfo.value.push(digest);
    // encode digest info
    return $ef3f2aff9b40d381$var$asn1.toDer(digestInfo).getBytes();
};
/**
 * Performs x^c mod n (RSA encryption or decryption operation).
 *
 * @param x the number to raise and mod.
 * @param key the key to use.
 * @param pub true if the key is public, false if private.
 *
 * @return the result of x^c mod n.
 */ var $ef3f2aff9b40d381$var$_modPow = function(x, key, pub) {
    if (pub) return x.modPow(key.e, key.n);
    if (!key.p || !key.q) // allow calculation without CRT params (slow)
    return x.modPow(key.d, key.n);
    // pre-compute dP, dQ, and qInv if necessary
    if (!key.dP) key.dP = key.d.mod(key.p.subtract($ef3f2aff9b40d381$var$BigInteger.ONE));
    if (!key.dQ) key.dQ = key.d.mod(key.q.subtract($ef3f2aff9b40d381$var$BigInteger.ONE));
    if (!key.qInv) key.qInv = key.q.modInverse(key.p);
    /* Chinese remainder theorem (CRT) states:

    Suppose n1, n2, ..., nk are positive integers which are pairwise
    coprime (n1 and n2 have no common factors other than 1). For any
    integers x1, x2, ..., xk there exists an integer x solving the
    system of simultaneous congruences (where ~= means modularly
    congruent so a ~= b mod n means a mod n = b mod n):

    x ~= x1 mod n1
    x ~= x2 mod n2
    ...
    x ~= xk mod nk

    This system of congruences has a single simultaneous solution x
    between 0 and n - 1. Furthermore, each xk solution and x itself
    is congruent modulo the product n = n1*n2*...*nk.
    So x1 mod n = x2 mod n = xk mod n = x mod n.

    The single simultaneous solution x can be solved with the following
    equation:

    x = sum(xi*ri*si) mod n where ri = n/ni and si = ri^-1 mod ni.

    Where x is less than n, xi = x mod ni.

    For RSA we are only concerned with k = 2. The modulus n = pq, where
    p and q are coprime. The RSA decryption algorithm is:

    y = x^d mod n

    Given the above:

    x1 = x^d mod p
    r1 = n/p = q
    s1 = q^-1 mod p
    x2 = x^d mod q
    r2 = n/q = p
    s2 = p^-1 mod q

    So y = (x1r1s1 + x2r2s2) mod n
         = ((x^d mod p)q(q^-1 mod p) + (x^d mod q)p(p^-1 mod q)) mod n

    According to Fermat's Little Theorem, if the modulus P is prime,
    for any integer A not evenly divisible by P, A^(P-1) ~= 1 mod P.
    Since A is not divisible by P it follows that if:
    N ~= M mod (P - 1), then A^N mod P = A^M mod P. Therefore:

    A^N mod P = A^(M mod (P - 1)) mod P. (The latter takes less effort
    to calculate). In order to calculate x^d mod p more quickly the
    exponent d mod (p - 1) is stored in the RSA private key (the same
    is done for x^d mod q). These values are referred to as dP and dQ
    respectively. Therefore we now have:

    y = ((x^dP mod p)q(q^-1 mod p) + (x^dQ mod q)p(p^-1 mod q)) mod n

    Since we'll be reducing x^dP by modulo p (same for q) we can also
    reduce x by p (and q respectively) before hand. Therefore, let

    xp = ((x mod p)^dP mod p), and
    xq = ((x mod q)^dQ mod q), yielding:

    y = (xp*q*(q^-1 mod p) + xq*p*(p^-1 mod q)) mod n

    This can be further reduced to a simple algorithm that only
    requires 1 inverse (the q inverse is used) to be used and stored.
    The algorithm is called Garner's algorithm. If qInv is the
    inverse of q, we simply calculate:

    y = (qInv*(xp - xq) mod p) * q + xq

    However, there are two further complications. First, we need to
    ensure that xp > xq to prevent signed BigIntegers from being used
    so we add p until this is true (since we will be mod'ing with
    p anyway). Then, there is a known timing attack on algorithms
    using the CRT. To mitigate this risk, "cryptographic blinding"
    should be used. This requires simply generating a random number r
    between 0 and n-1 and its inverse and multiplying x by r^e before
    calculating y and then multiplying y by r^-1 afterwards. Note that
    r must be coprime with n (gcd(r, n) === 1) in order to have an
    inverse.
  */ // cryptographic blinding
    var r;
    do r = new $ef3f2aff9b40d381$var$BigInteger($cLQG7.util.bytesToHex($cLQG7.random.getBytes(key.n.bitLength() / 8)), 16);
    while (r.compareTo(key.n) >= 0 || !r.gcd(key.n).equals($ef3f2aff9b40d381$var$BigInteger.ONE));
    x = x.multiply(r.modPow(key.e, key.n)).mod(key.n);
    // calculate xp and xq
    var xp = x.mod(key.p).modPow(key.dP, key.p);
    var xq = x.mod(key.q).modPow(key.dQ, key.q);
    // xp must be larger than xq to avoid signed bit usage
    while(xp.compareTo(xq) < 0)xp = xp.add(key.p);
    // do last step
    var y = xp.subtract(xq).multiply(key.qInv).mod(key.p).multiply(key.q).add(xq);
    // remove effect of random for cryptographic blinding
    y = y.multiply(r.modInverse(key.n)).mod(key.n);
    return y;
};
/**
 * NOTE: THIS METHOD IS DEPRECATED, use 'sign' on a private key object or
 * 'encrypt' on a public key object instead.
 *
 * Performs RSA encryption.
 *
 * The parameter bt controls whether to put padding bytes before the
 * message passed in. Set bt to either true or false to disable padding
 * completely (in order to handle e.g. EMSA-PSS encoding seperately before),
 * signaling whether the encryption operation is a public key operation
 * (i.e. encrypting data) or not, i.e. private key operation (data signing).
 *
 * For PKCS#1 v1.5 padding pass in the block type to use, i.e. either 0x01
 * (for signing) or 0x02 (for encryption). The key operation mode (private
 * or public) is derived from this flag in that case).
 *
 * @param m the message to encrypt as a byte string.
 * @param key the RSA key to use.
 * @param bt for PKCS#1 v1.5 padding, the block type to use
 *   (0x01 for private key, 0x02 for public),
 *   to disable padding: true = public key, false = private key.
 *
 * @return the encrypted bytes as a string.
 */ $ef3f2aff9b40d381$var$pki.rsa.encrypt = function(m, key, bt) {
    var pub = bt;
    var eb;
    // get the length of the modulus in bytes
    var k = Math.ceil(key.n.bitLength() / 8);
    if (bt !== false && bt !== true) {
        // legacy, default to PKCS#1 v1.5 padding
        pub = bt === 0x02;
        eb = $ef3f2aff9b40d381$var$_encodePkcs1_v1_5(m, key, bt);
    } else {
        eb = $cLQG7.util.createBuffer();
        eb.putBytes(m);
    }
    // load encryption block as big integer 'x'
    // FIXME: hex conversion inefficient, get BigInteger w/byte strings
    var x = new $ef3f2aff9b40d381$var$BigInteger(eb.toHex(), 16);
    // do RSA encryption
    var y = $ef3f2aff9b40d381$var$_modPow(x, key, pub);
    // convert y into the encrypted data byte string, if y is shorter in
    // bytes than k, then prepend zero bytes to fill up ed
    // FIXME: hex conversion inefficient, get BigInteger w/byte strings
    var yhex = y.toString(16);
    var ed = $cLQG7.util.createBuffer();
    var zeros = k - Math.ceil(yhex.length / 2);
    while(zeros > 0){
        ed.putByte(0x00);
        --zeros;
    }
    ed.putBytes($cLQG7.util.hexToBytes(yhex));
    return ed.getBytes();
};
/**
 * NOTE: THIS METHOD IS DEPRECATED, use 'decrypt' on a private key object or
 * 'verify' on a public key object instead.
 *
 * Performs RSA decryption.
 *
 * The parameter ml controls whether to apply PKCS#1 v1.5 padding
 * or not.  Set ml = false to disable padding removal completely
 * (in order to handle e.g. EMSA-PSS later on) and simply pass back
 * the RSA encryption block.
 *
 * @param ed the encrypted data to decrypt in as a byte string.
 * @param key the RSA key to use.
 * @param pub true for a public key operation, false for private.
 * @param ml the message length, if known, false to disable padding.
 *
 * @return the decrypted message as a byte string.
 */ $ef3f2aff9b40d381$var$pki.rsa.decrypt = function(ed, key, pub, ml) {
    // get the length of the modulus in bytes
    var k = Math.ceil(key.n.bitLength() / 8);
    // error if the length of the encrypted data ED is not k
    if (ed.length !== k) {
        var error = new Error('Encrypted message length is invalid.');
        error.length = ed.length;
        error.expected = k;
        throw error;
    }
    // convert encrypted data into a big integer
    // FIXME: hex conversion inefficient, get BigInteger w/byte strings
    var y = new $ef3f2aff9b40d381$var$BigInteger($cLQG7.util.createBuffer(ed).toHex(), 16);
    // y must be less than the modulus or it wasn't the result of
    // a previous mod operation (encryption) using that modulus
    if (y.compareTo(key.n) >= 0) throw new Error('Encrypted message is invalid.');
    // do RSA decryption
    var x = $ef3f2aff9b40d381$var$_modPow(y, key, pub);
    // create the encryption block, if x is shorter in bytes than k, then
    // prepend zero bytes to fill up eb
    // FIXME: hex conversion inefficient, get BigInteger w/byte strings
    var xhex = x.toString(16);
    var eb = $cLQG7.util.createBuffer();
    var zeros = k - Math.ceil(xhex.length / 2);
    while(zeros > 0){
        eb.putByte(0x00);
        --zeros;
    }
    eb.putBytes($cLQG7.util.hexToBytes(xhex));
    if (ml !== false) // legacy, default to PKCS#1 v1.5 padding
    return $ef3f2aff9b40d381$var$_decodePkcs1_v1_5(eb.getBytes(), key, pub);
    // return message
    return eb.getBytes();
};
/**
 * Creates an RSA key-pair generation state object. It is used to allow
 * key-generation to be performed in steps. It also allows for a UI to
 * display progress updates.
 *
 * @param bits the size for the private key in bits, defaults to 2048.
 * @param e the public exponent to use, defaults to 65537 (0x10001).
 * @param [options] the options to use.
 *          prng a custom crypto-secure pseudo-random number generator to use,
 *            that must define "getBytesSync".
 *          algorithm the algorithm to use (default: 'PRIMEINC').
 *
 * @return the state object to use to generate the key-pair.
 */ $ef3f2aff9b40d381$var$pki.rsa.createKeyPairGenerationState = function(bits, e, options) {
    // TODO: migrate step-based prime generation code to forge.prime
    // set default bits
    if (typeof bits === 'string') bits = parseInt(bits, 10);
    bits = bits || 2048;
    // create prng with api that matches BigInteger secure random
    options = options || {};
    var prng = options.prng || $cLQG7.random;
    var rng = {
        // x is an array to fill with bytes
        nextBytes: function(x) {
            var b = prng.getBytesSync(x.length);
            for(var i = 0; i < x.length; ++i)x[i] = b.charCodeAt(i);
        }
    };
    var algorithm = options.algorithm || 'PRIMEINC';
    // create PRIMEINC algorithm state
    var rval;
    if (algorithm === 'PRIMEINC') {
        rval = {
            algorithm: algorithm,
            state: 0,
            bits: bits,
            rng: rng,
            eInt: e || 65537,
            e: new $ef3f2aff9b40d381$var$BigInteger(null),
            p: null,
            q: null,
            qBits: bits >> 1,
            pBits: bits - (bits >> 1),
            pqState: 0,
            num: null,
            keys: null
        };
        rval.e.fromInt(rval.eInt);
    } else throw new Error('Invalid key generation algorithm: ' + algorithm);
    return rval;
};
/**
 * Attempts to runs the key-generation algorithm for at most n seconds
 * (approximately) using the given state. When key-generation has completed,
 * the keys will be stored in state.keys.
 *
 * To use this function to update a UI while generating a key or to prevent
 * causing browser lockups/warnings, set "n" to a value other than 0. A
 * simple pattern for generating a key and showing a progress indicator is:
 *
 * var state = pki.rsa.createKeyPairGenerationState(2048);
 * var step = function() {
 *   // step key-generation, run algorithm for 100 ms, repeat
 *   if(!forge.pki.rsa.stepKeyPairGenerationState(state, 100)) {
 *     setTimeout(step, 1);
 *   } else {
 *     // key-generation complete
 *     // TODO: turn off progress indicator here
 *     // TODO: use the generated key-pair in "state.keys"
 *   }
 * };
 * // TODO: turn on progress indicator here
 * setTimeout(step, 0);
 *
 * @param state the state to use.
 * @param n the maximum number of milliseconds to run the algorithm for, 0
 *          to run the algorithm to completion.
 *
 * @return true if the key-generation completed, false if not.
 */ $ef3f2aff9b40d381$var$pki.rsa.stepKeyPairGenerationState = function(state, n) {
    // set default algorithm if not set
    if (!('algorithm' in state)) state.algorithm = 'PRIMEINC';
    // TODO: migrate step-based prime generation code to forge.prime
    // TODO: abstract as PRIMEINC algorithm
    // do key generation (based on Tom Wu's rsa.js, see jsbn.js license)
    // with some minor optimizations and designed to run in steps
    // local state vars
    var THIRTY = new $ef3f2aff9b40d381$var$BigInteger(null);
    THIRTY.fromInt(30);
    var deltaIdx = 0;
    var op_or = function(x, y) {
        return x | y;
    };
    // keep stepping until time limit is reached or done
    var t1 = +new Date();
    var t2;
    var total = 0;
    while(state.keys === null && (n <= 0 || total < n)){
        // generate p or q
        if (state.state === 0) {
            /* Note: All primes are of the form:

        30k+i, for i < 30 and gcd(30, i)=1, where there are 8 values for i

        When we generate a random number, we always align it at 30k + 1. Each
        time the number is determined not to be prime we add to get to the
        next 'i', eg: if the number was at 30k + 1 we add 6. */ var bits = state.p === null ? state.pBits : state.qBits;
            var bits1 = bits - 1;
            // get a random number
            if (state.pqState === 0) {
                state.num = new $ef3f2aff9b40d381$var$BigInteger(bits, state.rng);
                // force MSB set
                if (!state.num.testBit(bits1)) state.num.bitwiseTo($ef3f2aff9b40d381$var$BigInteger.ONE.shiftLeft(bits1), op_or, state.num);
                // align number on 30k+1 boundary
                state.num.dAddOffset(31 - state.num.mod(THIRTY).byteValue(), 0);
                deltaIdx = 0;
                ++state.pqState;
            } else if (state.pqState === 1) {
                // try to make the number a prime
                if (state.num.bitLength() > bits) // overflow, try again
                state.pqState = 0;
                else if (state.num.isProbablePrime($ef3f2aff9b40d381$var$_getMillerRabinTests(state.num.bitLength()))) ++state.pqState;
                else // get next potential prime
                state.num.dAddOffset($ef3f2aff9b40d381$var$GCD_30_DELTA[deltaIdx++ % 8], 0);
            } else if (state.pqState === 2) // ensure number is coprime with e
            state.pqState = state.num.subtract($ef3f2aff9b40d381$var$BigInteger.ONE).gcd(state.e).compareTo($ef3f2aff9b40d381$var$BigInteger.ONE) === 0 ? 3 : 0;
            else if (state.pqState === 3) {
                // store p or q
                state.pqState = 0;
                if (state.p === null) state.p = state.num;
                else state.q = state.num;
                // advance state if both p and q are ready
                if (state.p !== null && state.q !== null) ++state.state;
                state.num = null;
            }
        } else if (state.state === 1) {
            // ensure p is larger than q (swap them if not)
            if (state.p.compareTo(state.q) < 0) {
                state.num = state.p;
                state.p = state.q;
                state.q = state.num;
            }
            ++state.state;
        } else if (state.state === 2) {
            // compute phi: (p - 1)(q - 1) (Euler's totient function)
            state.p1 = state.p.subtract($ef3f2aff9b40d381$var$BigInteger.ONE);
            state.q1 = state.q.subtract($ef3f2aff9b40d381$var$BigInteger.ONE);
            state.phi = state.p1.multiply(state.q1);
            ++state.state;
        } else if (state.state === 3) {
            // ensure e and phi are coprime
            if (state.phi.gcd(state.e).compareTo($ef3f2aff9b40d381$var$BigInteger.ONE) === 0) // phi and e are coprime, advance
            ++state.state;
            else {
                // phi and e aren't coprime, so generate a new p and q
                state.p = null;
                state.q = null;
                state.state = 0;
            }
        } else if (state.state === 4) {
            // create n, ensure n is has the right number of bits
            state.n = state.p.multiply(state.q);
            // ensure n is right number of bits
            if (state.n.bitLength() === state.bits) // success, advance
            ++state.state;
            else {
                // failed, get new q
                state.q = null;
                state.state = 0;
            }
        } else if (state.state === 5) {
            // set keys
            var d = state.e.modInverse(state.phi);
            state.keys = {
                privateKey: $ef3f2aff9b40d381$var$pki.rsa.setPrivateKey(state.n, state.e, d, state.p, state.q, d.mod(state.p1), d.mod(state.q1), state.q.modInverse(state.p)),
                publicKey: $ef3f2aff9b40d381$var$pki.rsa.setPublicKey(state.n, state.e)
            };
        }
        // update timing
        t2 = +new Date();
        total += t2 - t1;
        t1 = t2;
    }
    return state.keys !== null;
};
/**
 * Generates an RSA public-private key pair in a single call.
 *
 * To generate a key-pair in steps (to allow for progress updates and to
 * prevent blocking or warnings in slow browsers) then use the key-pair
 * generation state functions.
 *
 * To generate a key-pair asynchronously (either through web-workers, if
 * available, or by breaking up the work on the main thread), pass a
 * callback function.
 *
 * @param [bits] the size for the private key in bits, defaults to 2048.
 * @param [e] the public exponent to use, defaults to 65537.
 * @param [options] options for key-pair generation, if given then 'bits'
 *            and 'e' must *not* be given:
 *          bits the size for the private key in bits, (default: 2048).
 *          e the public exponent to use, (default: 65537 (0x10001)).
 *          workerScript the worker script URL.
 *          workers the number of web workers (if supported) to use,
 *            (default: 2).
 *          workLoad the size of the work load, ie: number of possible prime
 *            numbers for each web worker to check per work assignment,
 *            (default: 100).
 *          prng a custom crypto-secure pseudo-random number generator to use,
 *            that must define "getBytesSync". Disables use of native APIs.
 *          algorithm the algorithm to use (default: 'PRIMEINC').
 * @param [callback(err, keypair)] called once the operation completes.
 *
 * @return an object with privateKey and publicKey properties.
 */ $ef3f2aff9b40d381$var$pki.rsa.generateKeyPair = function(bits, e, options, callback) {
    // (bits), (options), (callback)
    if (arguments.length === 1) {
        if (typeof bits === 'object') {
            options = bits;
            bits = undefined;
        } else if (typeof bits === 'function') {
            callback = bits;
            bits = undefined;
        }
    } else if (arguments.length === 2) {
        // (bits, e), (bits, options), (bits, callback), (options, callback)
        if (typeof bits === 'number') {
            if (typeof e === 'function') {
                callback = e;
                e = undefined;
            } else if (typeof e !== 'number') {
                options = e;
                e = undefined;
            }
        } else {
            options = bits;
            callback = e;
            bits = undefined;
            e = undefined;
        }
    } else if (arguments.length === 3) {
        // (bits, e, options), (bits, e, callback), (bits, options, callback)
        if (typeof e === 'number') {
            if (typeof options === 'function') {
                callback = options;
                options = undefined;
            }
        } else {
            callback = options;
            options = e;
            e = undefined;
        }
    }
    options = options || {};
    if (bits === undefined) bits = options.bits || 2048;
    if (e === undefined) e = options.e || 0x10001;
    // use native code if permitted, available, and parameters are acceptable
    if (!$cLQG7.options.usePureJavaScript && !options.prng && bits >= 256 && bits <= 16384 && (e === 0x10001 || e === 3)) {
        if (callback) {
            // try native async
            if ($ef3f2aff9b40d381$var$_detectNodeCrypto('generateKeyPair')) return $ef3f2aff9b40d381$var$_crypto.generateKeyPair('rsa', {
                modulusLength: bits,
                publicExponent: e,
                publicKeyEncoding: {
                    type: 'spki',
                    format: 'pem'
                },
                privateKeyEncoding: {
                    type: 'pkcs8',
                    format: 'pem'
                }
            }, function(err, pub, priv) {
                if (err) return callback(err);
                callback(null, {
                    privateKey: $ef3f2aff9b40d381$var$pki.privateKeyFromPem(priv),
                    publicKey: $ef3f2aff9b40d381$var$pki.publicKeyFromPem(pub)
                });
            });
            if ($ef3f2aff9b40d381$var$_detectSubtleCrypto('generateKey') && $ef3f2aff9b40d381$var$_detectSubtleCrypto('exportKey')) // use standard native generateKey
            return $ef3f2aff9b40d381$var$util.globalScope.crypto.subtle.generateKey({
                name: 'RSASSA-PKCS1-v1_5',
                modulusLength: bits,
                publicExponent: $ef3f2aff9b40d381$var$_intToUint8Array(e),
                hash: {
                    name: 'SHA-256'
                }
            }, true, [
                'sign',
                'verify'
            ]).then(function(pair) {
                return $ef3f2aff9b40d381$var$util.globalScope.crypto.subtle.exportKey('pkcs8', pair.privateKey);
            // avoiding catch(function(err) {...}) to support IE <= 8
            }).then(undefined, function(err) {
                callback(err);
            }).then(function(pkcs8) {
                if (pkcs8) {
                    var privateKey = $ef3f2aff9b40d381$var$pki.privateKeyFromAsn1($ef3f2aff9b40d381$var$asn1.fromDer($cLQG7.util.createBuffer(pkcs8)));
                    callback(null, {
                        privateKey: privateKey,
                        publicKey: $ef3f2aff9b40d381$var$pki.setRsaPublicKey(privateKey.n, privateKey.e)
                    });
                }
            });
            if ($ef3f2aff9b40d381$var$_detectSubtleMsCrypto('generateKey') && $ef3f2aff9b40d381$var$_detectSubtleMsCrypto('exportKey')) {
                var genOp = $ef3f2aff9b40d381$var$util.globalScope.msCrypto.subtle.generateKey({
                    name: 'RSASSA-PKCS1-v1_5',
                    modulusLength: bits,
                    publicExponent: $ef3f2aff9b40d381$var$_intToUint8Array(e),
                    hash: {
                        name: 'SHA-256'
                    }
                }, true, [
                    'sign',
                    'verify'
                ]);
                genOp.oncomplete = function(e) {
                    var pair = e.target.result;
                    var exportOp = $ef3f2aff9b40d381$var$util.globalScope.msCrypto.subtle.exportKey('pkcs8', pair.privateKey);
                    exportOp.oncomplete = function(e) {
                        var pkcs8 = e.target.result;
                        var privateKey = $ef3f2aff9b40d381$var$pki.privateKeyFromAsn1($ef3f2aff9b40d381$var$asn1.fromDer($cLQG7.util.createBuffer(pkcs8)));
                        callback(null, {
                            privateKey: privateKey,
                            publicKey: $ef3f2aff9b40d381$var$pki.setRsaPublicKey(privateKey.n, privateKey.e)
                        });
                    };
                    exportOp.onerror = function(err) {
                        callback(err);
                    };
                };
                genOp.onerror = function(err) {
                    callback(err);
                };
                return;
            }
        } else // try native sync
        if ($ef3f2aff9b40d381$var$_detectNodeCrypto('generateKeyPairSync')) {
            var keypair = $ef3f2aff9b40d381$var$_crypto.generateKeyPairSync('rsa', {
                modulusLength: bits,
                publicExponent: e,
                publicKeyEncoding: {
                    type: 'spki',
                    format: 'pem'
                },
                privateKeyEncoding: {
                    type: 'pkcs8',
                    format: 'pem'
                }
            });
            return {
                privateKey: $ef3f2aff9b40d381$var$pki.privateKeyFromPem(keypair.privateKey),
                publicKey: $ef3f2aff9b40d381$var$pki.publicKeyFromPem(keypair.publicKey)
            };
        }
    }
    // use JavaScript implementation
    var state = $ef3f2aff9b40d381$var$pki.rsa.createKeyPairGenerationState(bits, e, options);
    if (!callback) {
        $ef3f2aff9b40d381$var$pki.rsa.stepKeyPairGenerationState(state, 0);
        return state.keys;
    }
    $ef3f2aff9b40d381$var$_generateKeyPair(state, options, callback);
};
/**
 * Sets an RSA public key from BigIntegers modulus and exponent.
 *
 * @param n the modulus.
 * @param e the exponent.
 *
 * @return the public key.
 */ $ef3f2aff9b40d381$var$pki.setRsaPublicKey = $ef3f2aff9b40d381$var$pki.rsa.setPublicKey = function(n, e) {
    var key = {
        n: n,
        e: e
    };
    /**
   * Encrypts the given data with this public key. Newer applications
   * should use the 'RSA-OAEP' decryption scheme, 'RSAES-PKCS1-V1_5' is for
   * legacy applications.
   *
   * @param data the byte string to encrypt.
   * @param scheme the encryption scheme to use:
   *          'RSAES-PKCS1-V1_5' (default),
   *          'RSA-OAEP',
   *          'RAW', 'NONE', or null to perform raw RSA encryption,
   *          an object with an 'encode' property set to a function
   *          with the signature 'function(data, key)' that returns
   *          a binary-encoded string representing the encoded data.
   * @param schemeOptions any scheme-specific options.
   *
   * @return the encrypted byte string.
   */ key.encrypt = function(data, scheme, schemeOptions) {
        if (typeof scheme === 'string') scheme = scheme.toUpperCase();
        else if (scheme === undefined) scheme = 'RSAES-PKCS1-V1_5';
        if (scheme === 'RSAES-PKCS1-V1_5') scheme = {
            encode: function(m, key, pub) {
                return $ef3f2aff9b40d381$var$_encodePkcs1_v1_5(m, key, 0x02).getBytes();
            }
        };
        else if (scheme === 'RSA-OAEP' || scheme === 'RSAES-OAEP') scheme = {
            encode: function(m, key) {
                return $cLQG7.pkcs1.encode_rsa_oaep(key, m, schemeOptions);
            }
        };
        else if ([
            'RAW',
            'NONE',
            'NULL',
            null
        ].indexOf(scheme) !== -1) scheme = {
            encode: function(e) {
                return e;
            }
        };
        else if (typeof scheme === 'string') throw new Error('Unsupported encryption scheme: "' + scheme + '".');
        // do scheme-based encoding then rsa encryption
        var e = scheme.encode(data, key, true);
        return $ef3f2aff9b40d381$var$pki.rsa.encrypt(e, key, true);
    };
    /**
   * Verifies the given signature against the given digest.
   *
   * PKCS#1 supports multiple (currently two) signature schemes:
   * RSASSA-PKCS1-V1_5 and RSASSA-PSS.
   *
   * By default this implementation uses the "old scheme", i.e.
   * RSASSA-PKCS1-V1_5, in which case once RSA-decrypted, the
   * signature is an OCTET STRING that holds a DigestInfo.
   *
   * DigestInfo ::= SEQUENCE {
   *   digestAlgorithm DigestAlgorithmIdentifier,
   *   digest Digest
   * }
   * DigestAlgorithmIdentifier ::= AlgorithmIdentifier
   * Digest ::= OCTET STRING
   *
   * To perform PSS signature verification, provide an instance
   * of Forge PSS object as the scheme parameter.
   *
   * @param digest the message digest hash to compare against the signature,
   *          as a binary-encoded string.
   * @param signature the signature to verify, as a binary-encoded string.
   * @param scheme signature verification scheme to use:
   *          'RSASSA-PKCS1-V1_5' or undefined for RSASSA PKCS#1 v1.5,
   *          a Forge PSS object for RSASSA-PSS,
   *          'NONE' or null for none, DigestInfo will not be expected, but
   *            PKCS#1 v1.5 padding will still be used.
   * @param options optional verify options
   *          _parseAllDigestBytes testing flag to control parsing of all
   *            digest bytes. Unsupported and not for general usage.
   *            (default: true)
   *
   * @return true if the signature was verified, false if not.
   */ key.verify = function(digest, signature, scheme, options) {
        if (typeof scheme === 'string') scheme = scheme.toUpperCase();
        else if (scheme === undefined) scheme = 'RSASSA-PKCS1-V1_5';
        if (options === undefined) options = {
            _parseAllDigestBytes: true
        };
        if (!('_parseAllDigestBytes' in options)) options._parseAllDigestBytes = true;
        if (scheme === 'RSASSA-PKCS1-V1_5') scheme = {
            verify: function(digest, d) {
                // remove padding
                d = $ef3f2aff9b40d381$var$_decodePkcs1_v1_5(d, key, true);
                // d is ASN.1 BER-encoded DigestInfo
                var obj = $ef3f2aff9b40d381$var$asn1.fromDer(d, {
                    parseAllBytes: options._parseAllDigestBytes
                });
                // validate DigestInfo
                var capture = {};
                var errors = [];
                if (!$ef3f2aff9b40d381$var$asn1.validate(obj, $ef3f2aff9b40d381$var$digestInfoValidator, capture, errors)) {
                    var error = new Error("ASN.1 object does not contain a valid RSASSA-PKCS1-v1_5 DigestInfo value.");
                    error.errors = errors;
                    throw error;
                }
                // check hash algorithm identifier
                // see PKCS1-v1-5DigestAlgorithms in RFC 8017
                // FIXME: add support to vaidator for strict value choices
                var oid = $ef3f2aff9b40d381$var$asn1.derToOid(capture.algorithmIdentifier);
                if (!(oid === $cLQG7.oids.md2 || oid === $cLQG7.oids.md5 || oid === $cLQG7.oids.sha1 || oid === $cLQG7.oids.sha224 || oid === $cLQG7.oids.sha256 || oid === $cLQG7.oids.sha384 || oid === $cLQG7.oids.sha512 || oid === $cLQG7.oids['sha512-224'] || oid === $cLQG7.oids['sha512-256'])) {
                    var error = new Error('Unknown RSASSA-PKCS1-v1_5 DigestAlgorithm identifier.');
                    error.oid = oid;
                    throw error;
                }
                // special check for md2 and md5 that NULL parameters exist
                if (oid === $cLQG7.oids.md2 || oid === $cLQG7.oids.md5) {
                    if (!('parameters' in capture)) throw new Error("ASN.1 object does not contain a valid RSASSA-PKCS1-v1_5 DigestInfo value. Missing algorithm identifer NULL parameters.");
                }
                // compare the given digest to the decrypted one
                return digest === capture.digest;
            }
        };
        else if (scheme === 'NONE' || scheme === 'NULL' || scheme === null) scheme = {
            verify: function(digest, d) {
                // remove padding
                d = $ef3f2aff9b40d381$var$_decodePkcs1_v1_5(d, key, true);
                return digest === d;
            }
        };
        // do rsa decryption w/o any decoding, then verify -- which does decoding
        var d = $ef3f2aff9b40d381$var$pki.rsa.decrypt(signature, key, true, false);
        return scheme.verify(digest, d, key.n.bitLength());
    };
    return key;
};
/**
 * Sets an RSA private key from BigIntegers modulus, exponent, primes,
 * prime exponents, and modular multiplicative inverse.
 *
 * @param n the modulus.
 * @param e the public exponent.
 * @param d the private exponent ((inverse of e) mod n).
 * @param p the first prime.
 * @param q the second prime.
 * @param dP exponent1 (d mod (p-1)).
 * @param dQ exponent2 (d mod (q-1)).
 * @param qInv ((inverse of q) mod p)
 *
 * @return the private key.
 */ $ef3f2aff9b40d381$var$pki.setRsaPrivateKey = $ef3f2aff9b40d381$var$pki.rsa.setPrivateKey = function(n, e, d, p, q, dP, dQ, qInv) {
    var key = {
        n: n,
        e: e,
        d: d,
        p: p,
        q: q,
        dP: dP,
        dQ: dQ,
        qInv: qInv
    };
    /**
   * Decrypts the given data with this private key. The decryption scheme
   * must match the one used to encrypt the data.
   *
   * @param data the byte string to decrypt.
   * @param scheme the decryption scheme to use:
   *          'RSAES-PKCS1-V1_5' (default),
   *          'RSA-OAEP',
   *          'RAW', 'NONE', or null to perform raw RSA decryption.
   * @param schemeOptions any scheme-specific options.
   *
   * @return the decrypted byte string.
   */ key.decrypt = function(data, scheme, schemeOptions) {
        if (typeof scheme === 'string') scheme = scheme.toUpperCase();
        else if (scheme === undefined) scheme = 'RSAES-PKCS1-V1_5';
        // do rsa decryption w/o any decoding
        var d = $ef3f2aff9b40d381$var$pki.rsa.decrypt(data, key, false, false);
        if (scheme === 'RSAES-PKCS1-V1_5') scheme = {
            decode: $ef3f2aff9b40d381$var$_decodePkcs1_v1_5
        };
        else if (scheme === 'RSA-OAEP' || scheme === 'RSAES-OAEP') scheme = {
            decode: function(d, key) {
                return $cLQG7.pkcs1.decode_rsa_oaep(key, d, schemeOptions);
            }
        };
        else if ([
            'RAW',
            'NONE',
            'NULL',
            null
        ].indexOf(scheme) !== -1) scheme = {
            decode: function(d) {
                return d;
            }
        };
        else throw new Error('Unsupported encryption scheme: "' + scheme + '".');
        // decode according to scheme
        return scheme.decode(d, key, false);
    };
    /**
   * Signs the given digest, producing a signature.
   *
   * PKCS#1 supports multiple (currently two) signature schemes:
   * RSASSA-PKCS1-V1_5 and RSASSA-PSS.
   *
   * By default this implementation uses the "old scheme", i.e.
   * RSASSA-PKCS1-V1_5. In order to generate a PSS signature, provide
   * an instance of Forge PSS object as the scheme parameter.
   *
   * @param md the message digest object with the hash to sign.
   * @param scheme the signature scheme to use:
   *          'RSASSA-PKCS1-V1_5' or undefined for RSASSA PKCS#1 v1.5,
   *          a Forge PSS object for RSASSA-PSS,
   *          'NONE' or null for none, DigestInfo will not be used but
   *            PKCS#1 v1.5 padding will still be used.
   *
   * @return the signature as a byte string.
   */ key.sign = function(md, scheme) {
        /* Note: The internal implementation of RSA operations is being
      transitioned away from a PKCS#1 v1.5 hard-coded scheme. Some legacy
      code like the use of an encoding block identifier 'bt' will eventually
      be removed. */ // private key operation
        var bt = false;
        if (typeof scheme === 'string') scheme = scheme.toUpperCase();
        if (scheme === undefined || scheme === 'RSASSA-PKCS1-V1_5') {
            scheme = {
                encode: $ef3f2aff9b40d381$var$emsaPkcs1v15encode
            };
            bt = 0x01;
        } else if (scheme === 'NONE' || scheme === 'NULL' || scheme === null) {
            scheme = {
                encode: function() {
                    return md;
                }
            };
            bt = 0x01;
        }
        // encode and then encrypt
        var d = scheme.encode(md, key.n.bitLength());
        return $ef3f2aff9b40d381$var$pki.rsa.encrypt(d, key, bt);
    };
    return key;
};
/**
 * Wraps an RSAPrivateKey ASN.1 object in an ASN.1 PrivateKeyInfo object.
 *
 * @param rsaKey the ASN.1 RSAPrivateKey.
 *
 * @return the ASN.1 PrivateKeyInfo.
 */ $ef3f2aff9b40d381$var$pki.wrapRsaPrivateKey = function(rsaKey) {
    // PrivateKeyInfo
    return $ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.SEQUENCE, true, [
        // version (0)
        $ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.INTEGER, false, $ef3f2aff9b40d381$var$asn1.integerToDer(0).getBytes()),
        // privateKeyAlgorithm
        $ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.SEQUENCE, true, [
            $ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.OID, false, $ef3f2aff9b40d381$var$asn1.oidToDer($ef3f2aff9b40d381$var$pki.oids.rsaEncryption).getBytes()),
            $ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.NULL, false, '')
        ]),
        // PrivateKey
        $ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.OCTETSTRING, false, $ef3f2aff9b40d381$var$asn1.toDer(rsaKey).getBytes())
    ]);
};
/**
 * Converts a private key from an ASN.1 object.
 *
 * @param obj the ASN.1 representation of a PrivateKeyInfo containing an
 *          RSAPrivateKey or an RSAPrivateKey.
 *
 * @return the private key.
 */ $ef3f2aff9b40d381$var$pki.privateKeyFromAsn1 = function(obj) {
    // get PrivateKeyInfo
    var capture = {};
    var errors = [];
    if ($ef3f2aff9b40d381$var$asn1.validate(obj, $ef3f2aff9b40d381$var$privateKeyValidator, capture, errors)) obj = $ef3f2aff9b40d381$var$asn1.fromDer($cLQG7.util.createBuffer(capture.privateKey));
    // get RSAPrivateKey
    capture = {};
    errors = [];
    if (!$ef3f2aff9b40d381$var$asn1.validate(obj, $ef3f2aff9b40d381$var$rsaPrivateKeyValidator, capture, errors)) {
        var error = new Error("Cannot read private key. ASN.1 object does not contain an RSAPrivateKey.");
        error.errors = errors;
        throw error;
    }
    // Note: Version is currently ignored.
    // capture.privateKeyVersion
    // FIXME: inefficient, get a BigInteger that uses byte strings
    var n, e, d, p, q, dP, dQ, qInv;
    n = $cLQG7.util.createBuffer(capture.privateKeyModulus).toHex();
    e = $cLQG7.util.createBuffer(capture.privateKeyPublicExponent).toHex();
    d = $cLQG7.util.createBuffer(capture.privateKeyPrivateExponent).toHex();
    p = $cLQG7.util.createBuffer(capture.privateKeyPrime1).toHex();
    q = $cLQG7.util.createBuffer(capture.privateKeyPrime2).toHex();
    dP = $cLQG7.util.createBuffer(capture.privateKeyExponent1).toHex();
    dQ = $cLQG7.util.createBuffer(capture.privateKeyExponent2).toHex();
    qInv = $cLQG7.util.createBuffer(capture.privateKeyCoefficient).toHex();
    // set private key
    return $ef3f2aff9b40d381$var$pki.setRsaPrivateKey(new $ef3f2aff9b40d381$var$BigInteger(n, 16), new $ef3f2aff9b40d381$var$BigInteger(e, 16), new $ef3f2aff9b40d381$var$BigInteger(d, 16), new $ef3f2aff9b40d381$var$BigInteger(p, 16), new $ef3f2aff9b40d381$var$BigInteger(q, 16), new $ef3f2aff9b40d381$var$BigInteger(dP, 16), new $ef3f2aff9b40d381$var$BigInteger(dQ, 16), new $ef3f2aff9b40d381$var$BigInteger(qInv, 16));
};
/**
 * Converts a private key to an ASN.1 RSAPrivateKey.
 *
 * @param key the private key.
 *
 * @return the ASN.1 representation of an RSAPrivateKey.
 */ $ef3f2aff9b40d381$var$pki.privateKeyToAsn1 = $ef3f2aff9b40d381$var$pki.privateKeyToRSAPrivateKey = function(key) {
    // RSAPrivateKey
    return $ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.SEQUENCE, true, [
        // version (0 = only 2 primes, 1 multiple primes)
        $ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.INTEGER, false, $ef3f2aff9b40d381$var$asn1.integerToDer(0).getBytes()),
        // modulus (n)
        $ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.INTEGER, false, $ef3f2aff9b40d381$var$_bnToBytes(key.n)),
        // publicExponent (e)
        $ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.INTEGER, false, $ef3f2aff9b40d381$var$_bnToBytes(key.e)),
        // privateExponent (d)
        $ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.INTEGER, false, $ef3f2aff9b40d381$var$_bnToBytes(key.d)),
        // privateKeyPrime1 (p)
        $ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.INTEGER, false, $ef3f2aff9b40d381$var$_bnToBytes(key.p)),
        // privateKeyPrime2 (q)
        $ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.INTEGER, false, $ef3f2aff9b40d381$var$_bnToBytes(key.q)),
        // privateKeyExponent1 (dP)
        $ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.INTEGER, false, $ef3f2aff9b40d381$var$_bnToBytes(key.dP)),
        // privateKeyExponent2 (dQ)
        $ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.INTEGER, false, $ef3f2aff9b40d381$var$_bnToBytes(key.dQ)),
        // coefficient (qInv)
        $ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.INTEGER, false, $ef3f2aff9b40d381$var$_bnToBytes(key.qInv))
    ]);
};
/**
 * Converts a public key from an ASN.1 SubjectPublicKeyInfo or RSAPublicKey.
 *
 * @param obj the asn1 representation of a SubjectPublicKeyInfo or RSAPublicKey.
 *
 * @return the public key.
 */ $ef3f2aff9b40d381$var$pki.publicKeyFromAsn1 = function(obj) {
    // get SubjectPublicKeyInfo
    var capture = {};
    var errors = [];
    if ($ef3f2aff9b40d381$var$asn1.validate(obj, $ef3f2aff9b40d381$var$publicKeyValidator, capture, errors)) {
        // get oid
        var oid = $ef3f2aff9b40d381$var$asn1.derToOid(capture.publicKeyOid);
        if (oid !== $ef3f2aff9b40d381$var$pki.oids.rsaEncryption) {
            var error = new Error('Cannot read public key. Unknown OID.');
            error.oid = oid;
            throw error;
        }
        obj = capture.rsaPublicKey;
    }
    // get RSA params
    errors = [];
    if (!$ef3f2aff9b40d381$var$asn1.validate(obj, $ef3f2aff9b40d381$var$rsaPublicKeyValidator, capture, errors)) {
        var error = new Error("Cannot read public key. ASN.1 object does not contain an RSAPublicKey.");
        error.errors = errors;
        throw error;
    }
    // FIXME: inefficient, get a BigInteger that uses byte strings
    var n = $cLQG7.util.createBuffer(capture.publicKeyModulus).toHex();
    var e = $cLQG7.util.createBuffer(capture.publicKeyExponent).toHex();
    // set public key
    return $ef3f2aff9b40d381$var$pki.setRsaPublicKey(new $ef3f2aff9b40d381$var$BigInteger(n, 16), new $ef3f2aff9b40d381$var$BigInteger(e, 16));
};
/**
 * Converts a public key to an ASN.1 SubjectPublicKeyInfo.
 *
 * @param key the public key.
 *
 * @return the asn1 representation of a SubjectPublicKeyInfo.
 */ $ef3f2aff9b40d381$var$pki.publicKeyToAsn1 = $ef3f2aff9b40d381$var$pki.publicKeyToSubjectPublicKeyInfo = function(key) {
    // SubjectPublicKeyInfo
    return $ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.SEQUENCE, true, [
        // AlgorithmIdentifier
        $ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.SEQUENCE, true, [
            // algorithm
            $ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.OID, false, $ef3f2aff9b40d381$var$asn1.oidToDer($ef3f2aff9b40d381$var$pki.oids.rsaEncryption).getBytes()),
            // parameters (null)
            $ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.NULL, false, '')
        ]),
        // subjectPublicKey
        $ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.BITSTRING, false, [
            $ef3f2aff9b40d381$var$pki.publicKeyToRSAPublicKey(key)
        ])
    ]);
};
/**
 * Converts a public key to an ASN.1 RSAPublicKey.
 *
 * @param key the public key.
 *
 * @return the asn1 representation of a RSAPublicKey.
 */ $ef3f2aff9b40d381$var$pki.publicKeyToRSAPublicKey = function(key) {
    // RSAPublicKey
    return $ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.SEQUENCE, true, [
        // modulus (n)
        $ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.INTEGER, false, $ef3f2aff9b40d381$var$_bnToBytes(key.n)),
        // publicExponent (e)
        $ef3f2aff9b40d381$var$asn1.create($ef3f2aff9b40d381$var$asn1.Class.UNIVERSAL, $ef3f2aff9b40d381$var$asn1.Type.INTEGER, false, $ef3f2aff9b40d381$var$_bnToBytes(key.e))
    ]);
};
/**
 * Encodes a message using PKCS#1 v1.5 padding.
 *
 * @param m the message to encode.
 * @param key the RSA key to use.
 * @param bt the block type to use, i.e. either 0x01 (for signing) or 0x02
 *          (for encryption).
 *
 * @return the padded byte buffer.
 */ function $ef3f2aff9b40d381$var$_encodePkcs1_v1_5(m, key, bt) {
    var eb = $cLQG7.util.createBuffer();
    // get the length of the modulus in bytes
    var k = Math.ceil(key.n.bitLength() / 8);
    /* use PKCS#1 v1.5 padding */ if (m.length > k - 11) {
        var error = new Error('Message is too long for PKCS#1 v1.5 padding.');
        error.length = m.length;
        error.max = k - 11;
        throw error;
    }
    /* A block type BT, a padding string PS, and the data D shall be
    formatted into an octet string EB, the encryption block:

    EB = 00 || BT || PS || 00 || D

    The block type BT shall be a single octet indicating the structure of
    the encryption block. For this version of the document it shall have
    value 00, 01, or 02. For a private-key operation, the block type
    shall be 00 or 01. For a public-key operation, it shall be 02.

    The padding string PS shall consist of k-3-||D|| octets. For block
    type 00, the octets shall have value 00; for block type 01, they
    shall have value FF; and for block type 02, they shall be
    pseudorandomly generated and nonzero. This makes the length of the
    encryption block EB equal to k. */ // build the encryption block
    eb.putByte(0x00);
    eb.putByte(bt);
    // create the padding
    var padNum = k - 3 - m.length;
    var padByte;
    // private key op
    if (bt === 0x00 || bt === 0x01) {
        padByte = bt === 0x00 ? 0x00 : 0xFF;
        for(var i = 0; i < padNum; ++i)eb.putByte(padByte);
    } else // public key op
    // pad with random non-zero values
    while(padNum > 0){
        var numZeros = 0;
        var padBytes = $cLQG7.random.getBytes(padNum);
        for(var i = 0; i < padNum; ++i){
            padByte = padBytes.charCodeAt(i);
            if (padByte === 0) ++numZeros;
            else eb.putByte(padByte);
        }
        padNum = numZeros;
    }
    // zero followed by message
    eb.putByte(0x00);
    eb.putBytes(m);
    return eb;
}
/**
 * Decodes a message using PKCS#1 v1.5 padding.
 *
 * @param em the message to decode.
 * @param key the RSA key to use.
 * @param pub true if the key is a public key, false if it is private.
 * @param ml the message length, if specified.
 *
 * @return the decoded bytes.
 */ function $ef3f2aff9b40d381$var$_decodePkcs1_v1_5(em, key, pub, ml) {
    // get the length of the modulus in bytes
    var k = Math.ceil(key.n.bitLength() / 8);
    /* It is an error if any of the following conditions occurs:

    1. The encryption block EB cannot be parsed unambiguously.
    2. The padding string PS consists of fewer than eight octets
      or is inconsisent with the block type BT.
    3. The decryption process is a public-key operation and the block
      type BT is not 00 or 01, or the decryption process is a
      private-key operation and the block type is not 02.
   */ // parse the encryption block
    var eb = $cLQG7.util.createBuffer(em);
    var first = eb.getByte();
    var bt = eb.getByte();
    if (first !== 0x00 || pub && bt !== 0x00 && bt !== 0x01 || !pub && bt != 0x02 || pub && bt === 0x00 && typeof ml === 'undefined') throw new Error('Encryption block is invalid.');
    var padNum = 0;
    if (bt === 0x00) {
        // check all padding bytes for 0x00
        padNum = k - 3 - ml;
        for(var i = 0; i < padNum; ++i){
            if (eb.getByte() !== 0x00) throw new Error('Encryption block is invalid.');
        }
    } else if (bt === 0x01) {
        // find the first byte that isn't 0xFF, should be after all padding
        padNum = 0;
        while(eb.length() > 1){
            if (eb.getByte() !== 0xFF) {
                --eb.read;
                break;
            }
            ++padNum;
        }
    } else if (bt === 0x02) {
        // look for 0x00 byte
        padNum = 0;
        while(eb.length() > 1){
            if (eb.getByte() === 0x00) {
                --eb.read;
                break;
            }
            ++padNum;
        }
    }
    // zero must be 0x00 and padNum must be (k - 3 - message length)
    var zero = eb.getByte();
    if (zero !== 0x00 || padNum !== k - 3 - eb.length()) throw new Error('Encryption block is invalid.');
    return eb.getBytes();
}
/**
 * Runs the key-generation algorithm asynchronously, either in the background
 * via Web Workers, or using the main thread and setImmediate.
 *
 * @param state the key-pair generation state.
 * @param [options] options for key-pair generation:
 *          workerScript the worker script URL.
 *          workers the number of web workers (if supported) to use,
 *            (default: 2, -1 to use estimated cores minus one).
 *          workLoad the size of the work load, ie: number of possible prime
 *            numbers for each web worker to check per work assignment,
 *            (default: 100).
 * @param callback(err, keypair) called once the operation completes.
 */ function $ef3f2aff9b40d381$var$_generateKeyPair(state, options, callback) {
    if (typeof options === 'function') {
        callback = options;
        options = {};
    }
    options = options || {};
    var opts = {
        algorithm: {
            name: options.algorithm || 'PRIMEINC',
            options: {
                workers: options.workers || 2,
                workLoad: options.workLoad || 100,
                workerScript: options.workerScript
            }
        }
    };
    if ('prng' in options) opts.prng = options.prng;
    generate();
    function generate() {
        // find p and then q (done in series to simplify)
        getPrime(state.pBits, function(err, num) {
            if (err) return callback(err);
            state.p = num;
            if (state.q !== null) return finish(err, state.q);
            getPrime(state.qBits, finish);
        });
    }
    function getPrime(bits, callback) {
        $cLQG7.prime.generateProbablePrime(bits, opts, callback);
    }
    function finish(err, num) {
        if (err) return callback(err);
        // set q
        state.q = num;
        // ensure p is larger than q (swap them if not)
        if (state.p.compareTo(state.q) < 0) {
            var tmp = state.p;
            state.p = state.q;
            state.q = tmp;
        }
        // ensure p is coprime with e
        if (state.p.subtract($ef3f2aff9b40d381$var$BigInteger.ONE).gcd(state.e).compareTo($ef3f2aff9b40d381$var$BigInteger.ONE) !== 0) {
            state.p = null;
            generate();
            return;
        }
        // ensure q is coprime with e
        if (state.q.subtract($ef3f2aff9b40d381$var$BigInteger.ONE).gcd(state.e).compareTo($ef3f2aff9b40d381$var$BigInteger.ONE) !== 0) {
            state.q = null;
            getPrime(state.qBits, finish);
            return;
        }
        // compute phi: (p - 1)(q - 1) (Euler's totient function)
        state.p1 = state.p.subtract($ef3f2aff9b40d381$var$BigInteger.ONE);
        state.q1 = state.q.subtract($ef3f2aff9b40d381$var$BigInteger.ONE);
        state.phi = state.p1.multiply(state.q1);
        // ensure e and phi are coprime
        if (state.phi.gcd(state.e).compareTo($ef3f2aff9b40d381$var$BigInteger.ONE) !== 0) {
            // phi and e aren't coprime, so generate a new p and q
            state.p = state.q = null;
            generate();
            return;
        }
        // create n, ensure n is has the right number of bits
        state.n = state.p.multiply(state.q);
        if (state.n.bitLength() !== state.bits) {
            // failed, get new q
            state.q = null;
            getPrime(state.qBits, finish);
            return;
        }
        // set keys
        var d = state.e.modInverse(state.phi);
        state.keys = {
            privateKey: $ef3f2aff9b40d381$var$pki.rsa.setPrivateKey(state.n, state.e, d, state.p, state.q, d.mod(state.p1), d.mod(state.q1), state.q.modInverse(state.p)),
            publicKey: $ef3f2aff9b40d381$var$pki.rsa.setPublicKey(state.n, state.e)
        };
        callback(null, state.keys);
    }
}
/**
 * Converts a positive BigInteger into 2's-complement big-endian bytes.
 *
 * @param b the big integer to convert.
 *
 * @return the bytes.
 */ function $ef3f2aff9b40d381$var$_bnToBytes(b) {
    // prepend 0x00 if first byte >= 0x80
    var hex = b.toString(16);
    if (hex[0] >= '8') hex = '00' + hex;
    var bytes = $cLQG7.util.hexToBytes(hex);
    // ensure integer is minimally-encoded
    if (bytes.length > 1 && // leading 0x00 for positive integer
    (bytes.charCodeAt(0) === 0 && (bytes.charCodeAt(1) & 0x80) === 0 || // leading 0xFF for negative integer
    bytes.charCodeAt(0) === 0xFF && (bytes.charCodeAt(1) & 0x80) === 0x80)) return bytes.substr(1);
    return bytes;
}
/**
 * Returns the required number of Miller-Rabin tests to generate a
 * prime with an error probability of (1/2)^80.
 *
 * See Handbook of Applied Cryptography Chapter 4, Table 4.4.
 *
 * @param bits the bit size.
 *
 * @return the required number of iterations.
 */ function $ef3f2aff9b40d381$var$_getMillerRabinTests(bits) {
    if (bits <= 100) return 27;
    if (bits <= 150) return 18;
    if (bits <= 200) return 15;
    if (bits <= 250) return 12;
    if (bits <= 300) return 9;
    if (bits <= 350) return 8;
    if (bits <= 400) return 7;
    if (bits <= 500) return 6;
    if (bits <= 600) return 5;
    if (bits <= 800) return 4;
    if (bits <= 1250) return 3;
    return 2;
}
/**
 * Performs feature detection on the Node crypto interface.
 *
 * @param fn the feature (function) to detect.
 *
 * @return true if detected, false if not.
 */ function $ef3f2aff9b40d381$var$_detectNodeCrypto(fn) {
    return $cLQG7.util.isNodejs && typeof $ef3f2aff9b40d381$var$_crypto[fn] === 'function';
}
/**
 * Performs feature detection on the SubtleCrypto interface.
 *
 * @param fn the feature (function) to detect.
 *
 * @return true if detected, false if not.
 */ function $ef3f2aff9b40d381$var$_detectSubtleCrypto(fn) {
    return typeof $ef3f2aff9b40d381$var$util.globalScope !== 'undefined' && typeof $ef3f2aff9b40d381$var$util.globalScope.crypto === 'object' && typeof $ef3f2aff9b40d381$var$util.globalScope.crypto.subtle === 'object' && typeof $ef3f2aff9b40d381$var$util.globalScope.crypto.subtle[fn] === 'function';
}
/**
 * Performs feature detection on the deprecated Microsoft Internet Explorer
 * outdated SubtleCrypto interface. This function should only be used after
 * checking for the modern, standard SubtleCrypto interface.
 *
 * @param fn the feature (function) to detect.
 *
 * @return true if detected, false if not.
 */ function $ef3f2aff9b40d381$var$_detectSubtleMsCrypto(fn) {
    return typeof $ef3f2aff9b40d381$var$util.globalScope !== 'undefined' && typeof $ef3f2aff9b40d381$var$util.globalScope.msCrypto === 'object' && typeof $ef3f2aff9b40d381$var$util.globalScope.msCrypto.subtle === 'object' && typeof $ef3f2aff9b40d381$var$util.globalScope.msCrypto.subtle[fn] === 'function';
}
function $ef3f2aff9b40d381$var$_intToUint8Array(x) {
    var bytes = $cLQG7.util.hexToBytes(x.toString(16));
    var buffer = new Uint8Array(bytes.length);
    for(var i = 0; i < bytes.length; ++i)buffer[i] = bytes.charCodeAt(i);
    return buffer;
}
function $ef3f2aff9b40d381$var$_privateKeyFromJwk(jwk) {
    if (jwk.kty !== 'RSA') throw new Error('Unsupported key algorithm "' + jwk.kty + '"; algorithm must be "RSA".');
    return $ef3f2aff9b40d381$var$pki.setRsaPrivateKey($ef3f2aff9b40d381$var$_base64ToBigInt(jwk.n), $ef3f2aff9b40d381$var$_base64ToBigInt(jwk.e), $ef3f2aff9b40d381$var$_base64ToBigInt(jwk.d), $ef3f2aff9b40d381$var$_base64ToBigInt(jwk.p), $ef3f2aff9b40d381$var$_base64ToBigInt(jwk.q), $ef3f2aff9b40d381$var$_base64ToBigInt(jwk.dp), $ef3f2aff9b40d381$var$_base64ToBigInt(jwk.dq), $ef3f2aff9b40d381$var$_base64ToBigInt(jwk.qi));
}
function $ef3f2aff9b40d381$var$_publicKeyFromJwk(jwk) {
    if (jwk.kty !== 'RSA') throw new Error('Key algorithm must be "RSA".');
    return $ef3f2aff9b40d381$var$pki.setRsaPublicKey($ef3f2aff9b40d381$var$_base64ToBigInt(jwk.n), $ef3f2aff9b40d381$var$_base64ToBigInt(jwk.e));
}
function $ef3f2aff9b40d381$var$_base64ToBigInt(b64) {
    return new $ef3f2aff9b40d381$var$BigInteger($cLQG7.util.bytesToHex($cLQG7.util.decode64(b64)), 16);
}



if (typeof $3d7fb12bbd6a187a$var$BigInteger === 'undefined') var $3d7fb12bbd6a187a$var$BigInteger = $cLQG7.jsbn.BigInteger;
// shortcut for asn.1 API
var $3d7fb12bbd6a187a$var$asn1 = $cLQG7.asn1;
/* Password-based encryption implementation. */ var $3d7fb12bbd6a187a$var$pki = $cLQG7.pki = $cLQG7.pki || {};
$3d7fb12bbd6a187a$exports = $3d7fb12bbd6a187a$var$pki.pbe = $cLQG7.pbe = $cLQG7.pbe || {};
var $3d7fb12bbd6a187a$var$oids = $3d7fb12bbd6a187a$var$pki.oids;
// validator for an EncryptedPrivateKeyInfo structure
// Note: Currently only works w/algorithm params
var $3d7fb12bbd6a187a$var$encryptedPrivateKeyValidator = {
    name: 'EncryptedPrivateKeyInfo',
    tagClass: $3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL,
    type: $3d7fb12bbd6a187a$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: 'EncryptedPrivateKeyInfo.encryptionAlgorithm',
            tagClass: $3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL,
            type: $3d7fb12bbd6a187a$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: 'AlgorithmIdentifier.algorithm',
                    tagClass: $3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL,
                    type: $3d7fb12bbd6a187a$var$asn1.Type.OID,
                    constructed: false,
                    capture: 'encryptionOid'
                },
                {
                    name: 'AlgorithmIdentifier.parameters',
                    tagClass: $3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL,
                    type: $3d7fb12bbd6a187a$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    captureAsn1: 'encryptionParams'
                }
            ]
        },
        {
            // encryptedData
            name: 'EncryptedPrivateKeyInfo.encryptedData',
            tagClass: $3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL,
            type: $3d7fb12bbd6a187a$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: 'encryptedData'
        }
    ]
};
// validator for a PBES2Algorithms structure
// Note: Currently only works w/PBKDF2 + AES encryption schemes
var $3d7fb12bbd6a187a$var$PBES2AlgorithmsValidator = {
    name: 'PBES2Algorithms',
    tagClass: $3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL,
    type: $3d7fb12bbd6a187a$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: 'PBES2Algorithms.keyDerivationFunc',
            tagClass: $3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL,
            type: $3d7fb12bbd6a187a$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: 'PBES2Algorithms.keyDerivationFunc.oid',
                    tagClass: $3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL,
                    type: $3d7fb12bbd6a187a$var$asn1.Type.OID,
                    constructed: false,
                    capture: 'kdfOid'
                },
                {
                    name: 'PBES2Algorithms.params',
                    tagClass: $3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL,
                    type: $3d7fb12bbd6a187a$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    value: [
                        {
                            name: 'PBES2Algorithms.params.salt',
                            tagClass: $3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL,
                            type: $3d7fb12bbd6a187a$var$asn1.Type.OCTETSTRING,
                            constructed: false,
                            capture: 'kdfSalt'
                        },
                        {
                            name: 'PBES2Algorithms.params.iterationCount',
                            tagClass: $3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL,
                            type: $3d7fb12bbd6a187a$var$asn1.Type.INTEGER,
                            constructed: false,
                            capture: 'kdfIterationCount'
                        },
                        {
                            name: 'PBES2Algorithms.params.keyLength',
                            tagClass: $3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL,
                            type: $3d7fb12bbd6a187a$var$asn1.Type.INTEGER,
                            constructed: false,
                            optional: true,
                            capture: 'keyLength'
                        },
                        {
                            // prf
                            name: 'PBES2Algorithms.params.prf',
                            tagClass: $3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL,
                            type: $3d7fb12bbd6a187a$var$asn1.Type.SEQUENCE,
                            constructed: true,
                            optional: true,
                            value: [
                                {
                                    name: 'PBES2Algorithms.params.prf.algorithm',
                                    tagClass: $3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL,
                                    type: $3d7fb12bbd6a187a$var$asn1.Type.OID,
                                    constructed: false,
                                    capture: 'prfOid'
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            name: 'PBES2Algorithms.encryptionScheme',
            tagClass: $3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL,
            type: $3d7fb12bbd6a187a$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: 'PBES2Algorithms.encryptionScheme.oid',
                    tagClass: $3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL,
                    type: $3d7fb12bbd6a187a$var$asn1.Type.OID,
                    constructed: false,
                    capture: 'encOid'
                },
                {
                    name: 'PBES2Algorithms.encryptionScheme.iv',
                    tagClass: $3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL,
                    type: $3d7fb12bbd6a187a$var$asn1.Type.OCTETSTRING,
                    constructed: false,
                    capture: 'encIv'
                }
            ]
        }
    ]
};
var $3d7fb12bbd6a187a$var$pkcs12PbeParamsValidator = {
    name: 'pkcs-12PbeParams',
    tagClass: $3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL,
    type: $3d7fb12bbd6a187a$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: 'pkcs-12PbeParams.salt',
            tagClass: $3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL,
            type: $3d7fb12bbd6a187a$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: 'salt'
        },
        {
            name: 'pkcs-12PbeParams.iterations',
            tagClass: $3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL,
            type: $3d7fb12bbd6a187a$var$asn1.Type.INTEGER,
            constructed: false,
            capture: 'iterations'
        }
    ]
};
/**
 * Encrypts a ASN.1 PrivateKeyInfo object, producing an EncryptedPrivateKeyInfo.
 *
 * PBES2Algorithms ALGORITHM-IDENTIFIER ::=
 *   { {PBES2-params IDENTIFIED BY id-PBES2}, ...}
 *
 * id-PBES2 OBJECT IDENTIFIER ::= {pkcs-5 13}
 *
 * PBES2-params ::= SEQUENCE {
 *   keyDerivationFunc AlgorithmIdentifier {{PBES2-KDFs}},
 *   encryptionScheme AlgorithmIdentifier {{PBES2-Encs}}
 * }
 *
 * PBES2-KDFs ALGORITHM-IDENTIFIER ::=
 *   { {PBKDF2-params IDENTIFIED BY id-PBKDF2}, ... }
 *
 * PBES2-Encs ALGORITHM-IDENTIFIER ::= { ... }
 *
 * PBKDF2-params ::= SEQUENCE {
 *   salt CHOICE {
 *     specified OCTET STRING,
 *     otherSource AlgorithmIdentifier {{PBKDF2-SaltSources}}
 *   },
 *   iterationCount INTEGER (1..MAX),
 *   keyLength INTEGER (1..MAX) OPTIONAL,
 *   prf AlgorithmIdentifier {{PBKDF2-PRFs}} DEFAULT algid-hmacWithSHA1
 * }
 *
 * @param obj the ASN.1 PrivateKeyInfo object.
 * @param password the password to encrypt with.
 * @param options:
 *          algorithm the encryption algorithm to use
 *            ('aes128', 'aes192', 'aes256', '3des'), defaults to 'aes128'.
 *          count the iteration count to use.
 *          saltSize the salt size to use.
 *          prfAlgorithm the PRF message digest algorithm to use
 *            ('sha1', 'sha224', 'sha256', 'sha384', 'sha512')
 *
 * @return the ASN.1 EncryptedPrivateKeyInfo.
 */ $3d7fb12bbd6a187a$var$pki.encryptPrivateKeyInfo = function(obj, password, options) {
    // set default options
    options = options || {};
    options.saltSize = options.saltSize || 8;
    options.count = options.count || 2048;
    options.algorithm = options.algorithm || 'aes128';
    options.prfAlgorithm = options.prfAlgorithm || 'sha1';
    // generate PBE params
    var salt = $cLQG7.random.getBytesSync(options.saltSize);
    var count = options.count;
    var countBytes = $3d7fb12bbd6a187a$var$asn1.integerToDer(count);
    var dkLen;
    var encryptionAlgorithm;
    var encryptedData;
    if (options.algorithm.indexOf('aes') === 0 || options.algorithm === 'des') {
        // do PBES2
        var ivLen, encOid, cipherFn;
        switch(options.algorithm){
            case 'aes128':
                dkLen = 16;
                ivLen = 16;
                encOid = $3d7fb12bbd6a187a$var$oids['aes128-CBC'];
                cipherFn = $cLQG7.aes.createEncryptionCipher;
                break;
            case 'aes192':
                dkLen = 24;
                ivLen = 16;
                encOid = $3d7fb12bbd6a187a$var$oids['aes192-CBC'];
                cipherFn = $cLQG7.aes.createEncryptionCipher;
                break;
            case 'aes256':
                dkLen = 32;
                ivLen = 16;
                encOid = $3d7fb12bbd6a187a$var$oids['aes256-CBC'];
                cipherFn = $cLQG7.aes.createEncryptionCipher;
                break;
            case 'des':
                dkLen = 8;
                ivLen = 8;
                encOid = $3d7fb12bbd6a187a$var$oids['desCBC'];
                cipherFn = $cLQG7.des.createEncryptionCipher;
                break;
            default:
                var error = new Error('Cannot encrypt private key. Unknown encryption algorithm.');
                error.algorithm = options.algorithm;
                throw error;
        }
        // get PRF message digest
        var prfAlgorithm = 'hmacWith' + options.prfAlgorithm.toUpperCase();
        var md = $3d7fb12bbd6a187a$var$prfAlgorithmToMessageDigest(prfAlgorithm);
        // encrypt private key using pbe SHA-1 and AES/DES
        var dk = $cLQG7.pkcs5.pbkdf2(password, salt, count, dkLen, md);
        var iv = $cLQG7.random.getBytesSync(ivLen);
        var cipher = cipherFn(dk);
        cipher.start(iv);
        cipher.update($3d7fb12bbd6a187a$var$asn1.toDer(obj));
        cipher.finish();
        encryptedData = cipher.output.getBytes();
        // get PBKDF2-params
        var params = $3d7fb12bbd6a187a$var$createPbkdf2Params(salt, countBytes, dkLen, prfAlgorithm);
        encryptionAlgorithm = $3d7fb12bbd6a187a$var$asn1.create($3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL, $3d7fb12bbd6a187a$var$asn1.Type.SEQUENCE, true, [
            $3d7fb12bbd6a187a$var$asn1.create($3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL, $3d7fb12bbd6a187a$var$asn1.Type.OID, false, $3d7fb12bbd6a187a$var$asn1.oidToDer($3d7fb12bbd6a187a$var$oids['pkcs5PBES2']).getBytes()),
            $3d7fb12bbd6a187a$var$asn1.create($3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL, $3d7fb12bbd6a187a$var$asn1.Type.SEQUENCE, true, [
                // keyDerivationFunc
                $3d7fb12bbd6a187a$var$asn1.create($3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL, $3d7fb12bbd6a187a$var$asn1.Type.SEQUENCE, true, [
                    $3d7fb12bbd6a187a$var$asn1.create($3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL, $3d7fb12bbd6a187a$var$asn1.Type.OID, false, $3d7fb12bbd6a187a$var$asn1.oidToDer($3d7fb12bbd6a187a$var$oids['pkcs5PBKDF2']).getBytes()),
                    // PBKDF2-params
                    params
                ]),
                // encryptionScheme
                $3d7fb12bbd6a187a$var$asn1.create($3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL, $3d7fb12bbd6a187a$var$asn1.Type.SEQUENCE, true, [
                    $3d7fb12bbd6a187a$var$asn1.create($3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL, $3d7fb12bbd6a187a$var$asn1.Type.OID, false, $3d7fb12bbd6a187a$var$asn1.oidToDer(encOid).getBytes()),
                    // iv
                    $3d7fb12bbd6a187a$var$asn1.create($3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL, $3d7fb12bbd6a187a$var$asn1.Type.OCTETSTRING, false, iv)
                ])
            ])
        ]);
    } else if (options.algorithm === '3des') {
        // Do PKCS12 PBE
        dkLen = 24;
        var saltBytes = new $cLQG7.util.ByteBuffer(salt);
        var dk = $3d7fb12bbd6a187a$var$pki.pbe.generatePkcs12Key(password, saltBytes, 1, count, dkLen);
        var iv = $3d7fb12bbd6a187a$var$pki.pbe.generatePkcs12Key(password, saltBytes, 2, count, dkLen);
        var cipher = $cLQG7.des.createEncryptionCipher(dk);
        cipher.start(iv);
        cipher.update($3d7fb12bbd6a187a$var$asn1.toDer(obj));
        cipher.finish();
        encryptedData = cipher.output.getBytes();
        encryptionAlgorithm = $3d7fb12bbd6a187a$var$asn1.create($3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL, $3d7fb12bbd6a187a$var$asn1.Type.SEQUENCE, true, [
            $3d7fb12bbd6a187a$var$asn1.create($3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL, $3d7fb12bbd6a187a$var$asn1.Type.OID, false, $3d7fb12bbd6a187a$var$asn1.oidToDer($3d7fb12bbd6a187a$var$oids['pbeWithSHAAnd3-KeyTripleDES-CBC']).getBytes()),
            // pkcs-12PbeParams
            $3d7fb12bbd6a187a$var$asn1.create($3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL, $3d7fb12bbd6a187a$var$asn1.Type.SEQUENCE, true, [
                // salt
                $3d7fb12bbd6a187a$var$asn1.create($3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL, $3d7fb12bbd6a187a$var$asn1.Type.OCTETSTRING, false, salt),
                // iteration count
                $3d7fb12bbd6a187a$var$asn1.create($3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL, $3d7fb12bbd6a187a$var$asn1.Type.INTEGER, false, countBytes.getBytes())
            ])
        ]);
    } else {
        var error = new Error('Cannot encrypt private key. Unknown encryption algorithm.');
        error.algorithm = options.algorithm;
        throw error;
    }
    // EncryptedPrivateKeyInfo
    var rval = $3d7fb12bbd6a187a$var$asn1.create($3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL, $3d7fb12bbd6a187a$var$asn1.Type.SEQUENCE, true, [
        // encryptionAlgorithm
        encryptionAlgorithm,
        // encryptedData
        $3d7fb12bbd6a187a$var$asn1.create($3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL, $3d7fb12bbd6a187a$var$asn1.Type.OCTETSTRING, false, encryptedData)
    ]);
    return rval;
};
/**
 * Decrypts a ASN.1 PrivateKeyInfo object.
 *
 * @param obj the ASN.1 EncryptedPrivateKeyInfo object.
 * @param password the password to decrypt with.
 *
 * @return the ASN.1 PrivateKeyInfo on success, null on failure.
 */ $3d7fb12bbd6a187a$var$pki.decryptPrivateKeyInfo = function(obj, password) {
    var rval = null;
    // get PBE params
    var capture = {};
    var errors = [];
    if (!$3d7fb12bbd6a187a$var$asn1.validate(obj, $3d7fb12bbd6a187a$var$encryptedPrivateKeyValidator, capture, errors)) {
        var error = new Error("Cannot read encrypted private key. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
        error.errors = errors;
        throw error;
    }
    // get cipher
    var oid = $3d7fb12bbd6a187a$var$asn1.derToOid(capture.encryptionOid);
    var cipher = $3d7fb12bbd6a187a$var$pki.pbe.getCipher(oid, capture.encryptionParams, password);
    // get encrypted data
    var encrypted = $cLQG7.util.createBuffer(capture.encryptedData);
    cipher.update(encrypted);
    if (cipher.finish()) rval = $3d7fb12bbd6a187a$var$asn1.fromDer(cipher.output);
    return rval;
};
/**
 * Converts a EncryptedPrivateKeyInfo to PEM format.
 *
 * @param epki the EncryptedPrivateKeyInfo.
 * @param maxline the maximum characters per line, defaults to 64.
 *
 * @return the PEM-formatted encrypted private key.
 */ $3d7fb12bbd6a187a$var$pki.encryptedPrivateKeyToPem = function(epki, maxline) {
    // convert to DER, then PEM-encode
    var msg = {
        type: 'ENCRYPTED PRIVATE KEY',
        body: $3d7fb12bbd6a187a$var$asn1.toDer(epki).getBytes()
    };
    return $cLQG7.pem.encode(msg, {
        maxline: maxline
    });
};
/**
 * Converts a PEM-encoded EncryptedPrivateKeyInfo to ASN.1 format. Decryption
 * is not performed.
 *
 * @param pem the EncryptedPrivateKeyInfo in PEM-format.
 *
 * @return the ASN.1 EncryptedPrivateKeyInfo.
 */ $3d7fb12bbd6a187a$var$pki.encryptedPrivateKeyFromPem = function(pem) {
    var msg = $cLQG7.pem.decode(pem)[0];
    if (msg.type !== 'ENCRYPTED PRIVATE KEY') {
        var error = new Error('Could not convert encrypted private key from PEM; PEM header type is "ENCRYPTED PRIVATE KEY".');
        error.headerType = msg.type;
        throw error;
    }
    if (msg.procType && msg.procType.type === 'ENCRYPTED') throw new Error("Could not convert encrypted private key from PEM; PEM is encrypted.");
    // convert DER to ASN.1 object
    return $3d7fb12bbd6a187a$var$asn1.fromDer(msg.body);
};
/**
 * Encrypts an RSA private key. By default, the key will be wrapped in
 * a PrivateKeyInfo and encrypted to produce a PKCS#8 EncryptedPrivateKeyInfo.
 * This is the standard, preferred way to encrypt a private key.
 *
 * To produce a non-standard PEM-encrypted private key that uses encapsulated
 * headers to indicate the encryption algorithm (old-style non-PKCS#8 OpenSSL
 * private key encryption), set the 'legacy' option to true. Note: Using this
 * option will cause the iteration count to be forced to 1.
 *
 * Note: The 'des' algorithm is supported, but it is not considered to be
 * secure because it only uses a single 56-bit key. If possible, it is highly
 * recommended that a different algorithm be used.
 *
 * @param rsaKey the RSA key to encrypt.
 * @param password the password to use.
 * @param options:
 *          algorithm: the encryption algorithm to use
 *            ('aes128', 'aes192', 'aes256', '3des', 'des').
 *          count: the iteration count to use.
 *          saltSize: the salt size to use.
 *          legacy: output an old non-PKCS#8 PEM-encrypted+encapsulated
 *            headers (DEK-Info) private key.
 *
 * @return the PEM-encoded ASN.1 EncryptedPrivateKeyInfo.
 */ $3d7fb12bbd6a187a$var$pki.encryptRsaPrivateKey = function(rsaKey, password, options) {
    // standard PKCS#8
    options = options || {};
    if (!options.legacy) {
        // encrypt PrivateKeyInfo
        var rval = $3d7fb12bbd6a187a$var$pki.wrapRsaPrivateKey($3d7fb12bbd6a187a$var$pki.privateKeyToAsn1(rsaKey));
        rval = $3d7fb12bbd6a187a$var$pki.encryptPrivateKeyInfo(rval, password, options);
        return $3d7fb12bbd6a187a$var$pki.encryptedPrivateKeyToPem(rval);
    }
    // legacy non-PKCS#8
    var algorithm;
    var iv;
    var dkLen;
    var cipherFn;
    switch(options.algorithm){
        case 'aes128':
            algorithm = 'AES-128-CBC';
            dkLen = 16;
            iv = $cLQG7.random.getBytesSync(16);
            cipherFn = $cLQG7.aes.createEncryptionCipher;
            break;
        case 'aes192':
            algorithm = 'AES-192-CBC';
            dkLen = 24;
            iv = $cLQG7.random.getBytesSync(16);
            cipherFn = $cLQG7.aes.createEncryptionCipher;
            break;
        case 'aes256':
            algorithm = 'AES-256-CBC';
            dkLen = 32;
            iv = $cLQG7.random.getBytesSync(16);
            cipherFn = $cLQG7.aes.createEncryptionCipher;
            break;
        case '3des':
            algorithm = 'DES-EDE3-CBC';
            dkLen = 24;
            iv = $cLQG7.random.getBytesSync(8);
            cipherFn = $cLQG7.des.createEncryptionCipher;
            break;
        case 'des':
            algorithm = 'DES-CBC';
            dkLen = 8;
            iv = $cLQG7.random.getBytesSync(8);
            cipherFn = $cLQG7.des.createEncryptionCipher;
            break;
        default:
            var error = new Error('Could not encrypt RSA private key; unsupported encryption algorithm "' + options.algorithm + '".');
            error.algorithm = options.algorithm;
            throw error;
    }
    // encrypt private key using OpenSSL legacy key derivation
    var dk = $cLQG7.pbe.opensslDeriveBytes(password, iv.substr(0, 8), dkLen);
    var cipher = cipherFn(dk);
    cipher.start(iv);
    cipher.update($3d7fb12bbd6a187a$var$asn1.toDer($3d7fb12bbd6a187a$var$pki.privateKeyToAsn1(rsaKey)));
    cipher.finish();
    var msg = {
        type: 'RSA PRIVATE KEY',
        procType: {
            version: '4',
            type: 'ENCRYPTED'
        },
        dekInfo: {
            algorithm: algorithm,
            parameters: $cLQG7.util.bytesToHex(iv).toUpperCase()
        },
        body: cipher.output.getBytes()
    };
    return $cLQG7.pem.encode(msg);
};
/**
 * Decrypts an RSA private key.
 *
 * @param pem the PEM-formatted EncryptedPrivateKeyInfo to decrypt.
 * @param password the password to use.
 *
 * @return the RSA key on success, null on failure.
 */ $3d7fb12bbd6a187a$var$pki.decryptRsaPrivateKey = function(pem, password) {
    var rval = null;
    var msg = $cLQG7.pem.decode(pem)[0];
    if (msg.type !== 'ENCRYPTED PRIVATE KEY' && msg.type !== 'PRIVATE KEY' && msg.type !== 'RSA PRIVATE KEY') {
        var error = new Error('Could not convert private key from PEM; PEM header type is not "ENCRYPTED PRIVATE KEY", "PRIVATE KEY", or "RSA PRIVATE KEY".');
        error.headerType = error;
        throw error;
    }
    if (msg.procType && msg.procType.type === 'ENCRYPTED') {
        var dkLen;
        var cipherFn;
        switch(msg.dekInfo.algorithm){
            case 'DES-CBC':
                dkLen = 8;
                cipherFn = $cLQG7.des.createDecryptionCipher;
                break;
            case 'DES-EDE3-CBC':
                dkLen = 24;
                cipherFn = $cLQG7.des.createDecryptionCipher;
                break;
            case 'AES-128-CBC':
                dkLen = 16;
                cipherFn = $cLQG7.aes.createDecryptionCipher;
                break;
            case 'AES-192-CBC':
                dkLen = 24;
                cipherFn = $cLQG7.aes.createDecryptionCipher;
                break;
            case 'AES-256-CBC':
                dkLen = 32;
                cipherFn = $cLQG7.aes.createDecryptionCipher;
                break;
            case 'RC2-40-CBC':
                dkLen = 5;
                cipherFn = function(key) {
                    return $cLQG7.rc2.createDecryptionCipher(key, 40);
                };
                break;
            case 'RC2-64-CBC':
                dkLen = 8;
                cipherFn = function(key) {
                    return $cLQG7.rc2.createDecryptionCipher(key, 64);
                };
                break;
            case 'RC2-128-CBC':
                dkLen = 16;
                cipherFn = function(key) {
                    return $cLQG7.rc2.createDecryptionCipher(key, 128);
                };
                break;
            default:
                var error = new Error('Could not decrypt private key; unsupported encryption algorithm "' + msg.dekInfo.algorithm + '".');
                error.algorithm = msg.dekInfo.algorithm;
                throw error;
        }
        // use OpenSSL legacy key derivation
        var iv = $cLQG7.util.hexToBytes(msg.dekInfo.parameters);
        var dk = $cLQG7.pbe.opensslDeriveBytes(password, iv.substr(0, 8), dkLen);
        var cipher = cipherFn(dk);
        cipher.start(iv);
        cipher.update($cLQG7.util.createBuffer(msg.body));
        if (cipher.finish()) rval = cipher.output.getBytes();
        else return rval;
    } else rval = msg.body;
    if (msg.type === 'ENCRYPTED PRIVATE KEY') rval = $3d7fb12bbd6a187a$var$pki.decryptPrivateKeyInfo($3d7fb12bbd6a187a$var$asn1.fromDer(rval), password);
    else // decryption already performed above
    rval = $3d7fb12bbd6a187a$var$asn1.fromDer(rval);
    if (rval !== null) rval = $3d7fb12bbd6a187a$var$pki.privateKeyFromAsn1(rval);
    return rval;
};
/**
 * Derives a PKCS#12 key.
 *
 * @param password the password to derive the key material from, null or
 *          undefined for none.
 * @param salt the salt, as a ByteBuffer, to use.
 * @param id the PKCS#12 ID byte (1 = key material, 2 = IV, 3 = MAC).
 * @param iter the iteration count.
 * @param n the number of bytes to derive from the password.
 * @param md the message digest to use, defaults to SHA-1.
 *
 * @return a ByteBuffer with the bytes derived from the password.
 */ $3d7fb12bbd6a187a$var$pki.pbe.generatePkcs12Key = function(password, salt, id, iter, n, md) {
    var j, l;
    if (typeof md === 'undefined' || md === null) {
        if (!('sha1' in $cLQG7.md)) throw new Error('"sha1" hash algorithm unavailable.');
        md = $cLQG7.md.sha1.create();
    }
    var u = md.digestLength;
    var v = md.blockLength;
    var result = new $cLQG7.util.ByteBuffer();
    /* Convert password to Unicode byte buffer + trailing 0-byte. */ var passBuf = new $cLQG7.util.ByteBuffer();
    if (password !== null && password !== undefined) {
        for(l = 0; l < password.length; l++)passBuf.putInt16(password.charCodeAt(l));
        passBuf.putInt16(0);
    }
    /* Length of salt and password in BYTES. */ var p = passBuf.length();
    var s = salt.length();
    /* 1. Construct a string, D (the "diversifier"), by concatenating
        v copies of ID. */ var D = new $cLQG7.util.ByteBuffer();
    D.fillWithByte(id, v);
    /* 2. Concatenate copies of the salt together to create a string S of length
        v * ceil(s / v) bytes (the final copy of the salt may be trunacted
        to create S).
        Note that if the salt is the empty string, then so is S. */ var Slen = v * Math.ceil(s / v);
    var S = new $cLQG7.util.ByteBuffer();
    for(l = 0; l < Slen; l++)S.putByte(salt.at(l % s));
    /* 3. Concatenate copies of the password together to create a string P of
        length v * ceil(p / v) bytes (the final copy of the password may be
        truncated to create P).
        Note that if the password is the empty string, then so is P. */ var Plen = v * Math.ceil(p / v);
    var P = new $cLQG7.util.ByteBuffer();
    for(l = 0; l < Plen; l++)P.putByte(passBuf.at(l % p));
    /* 4. Set I=S||P to be the concatenation of S and P. */ var I = S;
    I.putBuffer(P);
    /* 5. Set c=ceil(n / u). */ var c = Math.ceil(n / u);
    /* 6. For i=1, 2, ..., c, do the following: */ for(var i = 1; i <= c; i++){
        /* a) Set Ai=H^r(D||I). (l.e. the rth hash of D||I, H(H(H(...H(D||I)))) */ var buf = new $cLQG7.util.ByteBuffer();
        buf.putBytes(D.bytes());
        buf.putBytes(I.bytes());
        for(var round = 0; round < iter; round++){
            md.start();
            md.update(buf.getBytes());
            buf = md.digest();
        }
        /* b) Concatenate copies of Ai to create a string B of length v bytes (the
          final copy of Ai may be truncated to create B). */ var B = new $cLQG7.util.ByteBuffer();
        for(l = 0; l < v; l++)B.putByte(buf.at(l % u));
        /* c) Treating I as a concatenation I0, I1, ..., Ik-1 of v-byte blocks,
          where k=ceil(s / v) + ceil(p / v), modify I by setting
          Ij=(Ij+B+1) mod 2v for each j.  */ var k = Math.ceil(s / v) + Math.ceil(p / v);
        var Inew = new $cLQG7.util.ByteBuffer();
        for(j = 0; j < k; j++){
            var chunk = new $cLQG7.util.ByteBuffer(I.getBytes(v));
            var x = 0x1ff;
            for(l = B.length() - 1; l >= 0; l--){
                x = x >> 8;
                x += B.at(l) + chunk.at(l);
                chunk.setAt(l, x & 0xff);
            }
            Inew.putBuffer(chunk);
        }
        I = Inew;
        /* Add Ai to A. */ result.putBuffer(buf);
    }
    result.truncate(result.length() - n);
    return result;
};
/**
 * Get new Forge cipher object instance.
 *
 * @param oid the OID (in string notation).
 * @param params the ASN.1 params object.
 * @param password the password to decrypt with.
 *
 * @return new cipher object instance.
 */ $3d7fb12bbd6a187a$var$pki.pbe.getCipher = function(oid, params, password) {
    switch(oid){
        case $3d7fb12bbd6a187a$var$pki.oids['pkcs5PBES2']:
            return $3d7fb12bbd6a187a$var$pki.pbe.getCipherForPBES2(oid, params, password);
        case $3d7fb12bbd6a187a$var$pki.oids['pbeWithSHAAnd3-KeyTripleDES-CBC']:
        case $3d7fb12bbd6a187a$var$pki.oids['pbewithSHAAnd40BitRC2-CBC']:
            return $3d7fb12bbd6a187a$var$pki.pbe.getCipherForPKCS12PBE(oid, params, password);
        default:
            var error = new Error('Cannot read encrypted PBE data block. Unsupported OID.');
            error.oid = oid;
            error.supportedOids = [
                'pkcs5PBES2',
                'pbeWithSHAAnd3-KeyTripleDES-CBC',
                'pbewithSHAAnd40BitRC2-CBC'
            ];
            throw error;
    }
};
/**
 * Get new Forge cipher object instance according to PBES2 params block.
 *
 * The returned cipher instance is already started using the IV
 * from PBES2 parameter block.
 *
 * @param oid the PKCS#5 PBKDF2 OID (in string notation).
 * @param params the ASN.1 PBES2-params object.
 * @param password the password to decrypt with.
 *
 * @return new cipher object instance.
 */ $3d7fb12bbd6a187a$var$pki.pbe.getCipherForPBES2 = function(oid, params, password) {
    // get PBE params
    var capture = {};
    var errors = [];
    if (!$3d7fb12bbd6a187a$var$asn1.validate(params, $3d7fb12bbd6a187a$var$PBES2AlgorithmsValidator, capture, errors)) {
        var error = new Error("Cannot read password-based-encryption algorithm parameters. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
        error.errors = errors;
        throw error;
    }
    // check oids
    oid = $3d7fb12bbd6a187a$var$asn1.derToOid(capture.kdfOid);
    if (oid !== $3d7fb12bbd6a187a$var$pki.oids['pkcs5PBKDF2']) {
        var error = new Error("Cannot read encrypted private key. Unsupported key derivation function OID.");
        error.oid = oid;
        error.supportedOids = [
            'pkcs5PBKDF2'
        ];
        throw error;
    }
    oid = $3d7fb12bbd6a187a$var$asn1.derToOid(capture.encOid);
    if (oid !== $3d7fb12bbd6a187a$var$pki.oids['aes128-CBC'] && oid !== $3d7fb12bbd6a187a$var$pki.oids['aes192-CBC'] && oid !== $3d7fb12bbd6a187a$var$pki.oids['aes256-CBC'] && oid !== $3d7fb12bbd6a187a$var$pki.oids['des-EDE3-CBC'] && oid !== $3d7fb12bbd6a187a$var$pki.oids['desCBC']) {
        var error = new Error("Cannot read encrypted private key. Unsupported encryption scheme OID.");
        error.oid = oid;
        error.supportedOids = [
            'aes128-CBC',
            'aes192-CBC',
            'aes256-CBC',
            'des-EDE3-CBC',
            'desCBC'
        ];
        throw error;
    }
    // set PBE params
    var salt = capture.kdfSalt;
    var count = $cLQG7.util.createBuffer(capture.kdfIterationCount);
    count = count.getInt(count.length() << 3);
    var dkLen;
    var cipherFn;
    switch($3d7fb12bbd6a187a$var$pki.oids[oid]){
        case 'aes128-CBC':
            dkLen = 16;
            cipherFn = $cLQG7.aes.createDecryptionCipher;
            break;
        case 'aes192-CBC':
            dkLen = 24;
            cipherFn = $cLQG7.aes.createDecryptionCipher;
            break;
        case 'aes256-CBC':
            dkLen = 32;
            cipherFn = $cLQG7.aes.createDecryptionCipher;
            break;
        case 'des-EDE3-CBC':
            dkLen = 24;
            cipherFn = $cLQG7.des.createDecryptionCipher;
            break;
        case 'desCBC':
            dkLen = 8;
            cipherFn = $cLQG7.des.createDecryptionCipher;
            break;
    }
    // get PRF message digest
    var md = $3d7fb12bbd6a187a$var$prfOidToMessageDigest(capture.prfOid);
    // decrypt private key using pbe with chosen PRF and AES/DES
    var dk = $cLQG7.pkcs5.pbkdf2(password, salt, count, dkLen, md);
    var iv = capture.encIv;
    var cipher = cipherFn(dk);
    cipher.start(iv);
    return cipher;
};
/**
 * Get new Forge cipher object instance for PKCS#12 PBE.
 *
 * The returned cipher instance is already started using the key & IV
 * derived from the provided password and PKCS#12 PBE salt.
 *
 * @param oid The PKCS#12 PBE OID (in string notation).
 * @param params The ASN.1 PKCS#12 PBE-params object.
 * @param password The password to decrypt with.
 *
 * @return the new cipher object instance.
 */ $3d7fb12bbd6a187a$var$pki.pbe.getCipherForPKCS12PBE = function(oid, params, password) {
    // get PBE params
    var capture = {};
    var errors = [];
    if (!$3d7fb12bbd6a187a$var$asn1.validate(params, $3d7fb12bbd6a187a$var$pkcs12PbeParamsValidator, capture, errors)) {
        var error = new Error("Cannot read password-based-encryption algorithm parameters. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
        error.errors = errors;
        throw error;
    }
    var salt = $cLQG7.util.createBuffer(capture.salt);
    var count = $cLQG7.util.createBuffer(capture.iterations);
    count = count.getInt(count.length() << 3);
    var dkLen, dIvLen, cipherFn;
    switch(oid){
        case $3d7fb12bbd6a187a$var$pki.oids['pbeWithSHAAnd3-KeyTripleDES-CBC']:
            dkLen = 24;
            dIvLen = 8;
            cipherFn = $cLQG7.des.startDecrypting;
            break;
        case $3d7fb12bbd6a187a$var$pki.oids['pbewithSHAAnd40BitRC2-CBC']:
            dkLen = 5;
            dIvLen = 8;
            cipherFn = function(key, iv) {
                var cipher = $cLQG7.rc2.createDecryptionCipher(key, 40);
                cipher.start(iv, null);
                return cipher;
            };
            break;
        default:
            var error = new Error('Cannot read PKCS #12 PBE data block. Unsupported OID.');
            error.oid = oid;
            throw error;
    }
    // get PRF message digest
    var md = $3d7fb12bbd6a187a$var$prfOidToMessageDigest(capture.prfOid);
    var key = $3d7fb12bbd6a187a$var$pki.pbe.generatePkcs12Key(password, salt, 1, count, dkLen, md);
    md.start();
    var iv = $3d7fb12bbd6a187a$var$pki.pbe.generatePkcs12Key(password, salt, 2, count, dIvLen, md);
    return cipherFn(key, iv);
};
/**
 * OpenSSL's legacy key derivation function.
 *
 * See: http://www.openssl.org/docs/crypto/EVP_BytesToKey.html
 *
 * @param password the password to derive the key from.
 * @param salt the salt to use, null for none.
 * @param dkLen the number of bytes needed for the derived key.
 * @param [options] the options to use:
 *          [md] an optional message digest object to use.
 */ $3d7fb12bbd6a187a$var$pki.pbe.opensslDeriveBytes = function(password, salt, dkLen, md) {
    if (typeof md === 'undefined' || md === null) {
        if (!('md5' in $cLQG7.md)) throw new Error('"md5" hash algorithm unavailable.');
        md = $cLQG7.md.md5.create();
    }
    if (salt === null) salt = '';
    var digests = [
        $3d7fb12bbd6a187a$var$hash(md, password + salt)
    ];
    for(var length = 16, i = 1; length < dkLen; ++i, length += 16)digests.push($3d7fb12bbd6a187a$var$hash(md, digests[i - 1] + password + salt));
    return digests.join('').substr(0, dkLen);
};
function $3d7fb12bbd6a187a$var$hash(md, bytes) {
    return md.start().update(bytes).digest().getBytes();
}
function $3d7fb12bbd6a187a$var$prfOidToMessageDigest(prfOid) {
    // get PRF algorithm, default to SHA-1
    var prfAlgorithm;
    if (!prfOid) prfAlgorithm = 'hmacWithSHA1';
    else {
        prfAlgorithm = $3d7fb12bbd6a187a$var$pki.oids[$3d7fb12bbd6a187a$var$asn1.derToOid(prfOid)];
        if (!prfAlgorithm) {
            var error = new Error('Unsupported PRF OID.');
            error.oid = prfOid;
            error.supported = [
                'hmacWithSHA1',
                'hmacWithSHA224',
                'hmacWithSHA256',
                'hmacWithSHA384',
                'hmacWithSHA512'
            ];
            throw error;
        }
    }
    return $3d7fb12bbd6a187a$var$prfAlgorithmToMessageDigest(prfAlgorithm);
}
function $3d7fb12bbd6a187a$var$prfAlgorithmToMessageDigest(prfAlgorithm) {
    var factory = $cLQG7.md;
    switch(prfAlgorithm){
        case 'hmacWithSHA224':
            factory = $cLQG7.md.sha512;
        case 'hmacWithSHA1':
        case 'hmacWithSHA256':
        case 'hmacWithSHA384':
        case 'hmacWithSHA512':
            prfAlgorithm = prfAlgorithm.substr(8).toLowerCase();
            break;
        default:
            var error = new Error('Unsupported PRF algorithm.');
            error.algorithm = prfAlgorithm;
            error.supported = [
                'hmacWithSHA1',
                'hmacWithSHA224',
                'hmacWithSHA256',
                'hmacWithSHA384',
                'hmacWithSHA512'
            ];
            throw error;
    }
    if (!factory || !(prfAlgorithm in factory)) throw new Error('Unknown hash algorithm: ' + prfAlgorithm);
    return factory[prfAlgorithm].create();
}
function $3d7fb12bbd6a187a$var$createPbkdf2Params(salt, countBytes, dkLen, prfAlgorithm) {
    var params = $3d7fb12bbd6a187a$var$asn1.create($3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL, $3d7fb12bbd6a187a$var$asn1.Type.SEQUENCE, true, [
        // salt
        $3d7fb12bbd6a187a$var$asn1.create($3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL, $3d7fb12bbd6a187a$var$asn1.Type.OCTETSTRING, false, salt),
        // iteration count
        $3d7fb12bbd6a187a$var$asn1.create($3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL, $3d7fb12bbd6a187a$var$asn1.Type.INTEGER, false, countBytes.getBytes())
    ]);
    // when PRF algorithm is not SHA-1 default, add key length and PRF algorithm
    if (prfAlgorithm !== 'hmacWithSHA1') params.value.push(// key length
    $3d7fb12bbd6a187a$var$asn1.create($3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL, $3d7fb12bbd6a187a$var$asn1.Type.INTEGER, false, $cLQG7.util.hexToBytes(dkLen.toString(16))), // AlgorithmIdentifier
    $3d7fb12bbd6a187a$var$asn1.create($3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL, $3d7fb12bbd6a187a$var$asn1.Type.SEQUENCE, true, [
        // algorithm
        $3d7fb12bbd6a187a$var$asn1.create($3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL, $3d7fb12bbd6a187a$var$asn1.Type.OID, false, $3d7fb12bbd6a187a$var$asn1.oidToDer($3d7fb12bbd6a187a$var$pki.oids[prfAlgorithm]).getBytes()),
        // parameters (null)
        $3d7fb12bbd6a187a$var$asn1.create($3d7fb12bbd6a187a$var$asn1.Class.UNIVERSAL, $3d7fb12bbd6a187a$var$asn1.Type.NULL, false, '')
    ]));
    return params;
}




var $655e13cc55a41c6e$exports = {};
/**
 * Javascript implementation of PKCS#12.
 *
 * @author Dave Longley
 * @author Stefan Siegl <stesie@brokenpipe.de>
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 *
 * The ASN.1 representation of PKCS#12 is as follows
 * (see ftp://ftp.rsasecurity.com/pub/pkcs/pkcs-12/pkcs-12-tc1.pdf for details)
 *
 * PFX ::= SEQUENCE {
 *   version  INTEGER {v3(3)}(v3,...),
 *   authSafe ContentInfo,
 *   macData  MacData OPTIONAL
 * }
 *
 * MacData ::= SEQUENCE {
 *   mac DigestInfo,
 *   macSalt OCTET STRING,
 *   iterations INTEGER DEFAULT 1
 * }
 * Note: The iterations default is for historical reasons and its use is
 * deprecated. A higher value, like 1024, is recommended.
 *
 * DigestInfo is defined in PKCS#7 as follows:
 *
 * DigestInfo ::= SEQUENCE {
 *   digestAlgorithm DigestAlgorithmIdentifier,
 *   digest Digest
 * }
 *
 * DigestAlgorithmIdentifier ::= AlgorithmIdentifier
 *
 * The AlgorithmIdentifier contains an Object Identifier (OID) and parameters
 * for the algorithm, if any. In the case of SHA1 there is none.
 *
 * AlgorithmIdentifer ::= SEQUENCE {
 *    algorithm OBJECT IDENTIFIER,
 *    parameters ANY DEFINED BY algorithm OPTIONAL
 * }
 *
 * Digest ::= OCTET STRING
 *
 *
 * ContentInfo ::= SEQUENCE {
 *   contentType ContentType,
 *   content     [0] EXPLICIT ANY DEFINED BY contentType OPTIONAL
 * }
 *
 * ContentType ::= OBJECT IDENTIFIER
 *
 * AuthenticatedSafe ::= SEQUENCE OF ContentInfo
 * -- Data if unencrypted
 * -- EncryptedData if password-encrypted
 * -- EnvelopedData if public key-encrypted
 *
 *
 * SafeContents ::= SEQUENCE OF SafeBag
 *
 * SafeBag ::= SEQUENCE {
 *   bagId     BAG-TYPE.&id ({PKCS12BagSet})
 *   bagValue  [0] EXPLICIT BAG-TYPE.&Type({PKCS12BagSet}{@bagId}),
 *   bagAttributes SET OF PKCS12Attribute OPTIONAL
 * }
 *
 * PKCS12Attribute ::= SEQUENCE {
 *   attrId ATTRIBUTE.&id ({PKCS12AttrSet}),
 *   attrValues SET OF ATTRIBUTE.&Type ({PKCS12AttrSet}{@attrId})
 * } -- This type is compatible with the X.500 type 'Attribute'
 *
 * PKCS12AttrSet ATTRIBUTE ::= {
 *   friendlyName | -- from PKCS #9
 *   localKeyId, -- from PKCS #9
 *   ... -- Other attributes are allowed
 * }
 *
 * CertBag ::= SEQUENCE {
 *   certId    BAG-TYPE.&id   ({CertTypes}),
 *   certValue [0] EXPLICIT BAG-TYPE.&Type ({CertTypes}{@certId})
 * }
 *
 * x509Certificate BAG-TYPE ::= {OCTET STRING IDENTIFIED BY {certTypes 1}}
 *   -- DER-encoded X.509 certificate stored in OCTET STRING
 *
 * sdsiCertificate BAG-TYPE ::= {IA5String IDENTIFIED BY {certTypes 2}}
 * -- Base64-encoded SDSI certificate stored in IA5String
 *
 * CertTypes BAG-TYPE ::= {
 *   x509Certificate |
 *   sdsiCertificate,
 *   ... -- For future extensions
 * }
 */ 
var $cLQG7 = parcelRequire("cLQG7");



var $5e73ddb53d480466$exports = {};
/**
 * Javascript implementation of ASN.1 validators for PKCS#7 v1.5.
 *
 * @author Dave Longley
 * @author Stefan Siegl
 *
 * Copyright (c) 2012-2015 Digital Bazaar, Inc.
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 *
 * The ASN.1 representation of PKCS#7 is as follows
 * (see RFC #2315 for details, http://www.ietf.org/rfc/rfc2315.txt):
 *
 * A PKCS#7 message consists of a ContentInfo on root level, which may
 * contain any number of further ContentInfo nested into it.
 *
 * ContentInfo ::= SEQUENCE {
 *   contentType                ContentType,
 *   content               [0]  EXPLICIT ANY DEFINED BY contentType OPTIONAL
 * }
 *
 * ContentType ::= OBJECT IDENTIFIER
 *
 * EnvelopedData ::= SEQUENCE {
 *   version                    Version,
 *   recipientInfos             RecipientInfos,
 *   encryptedContentInfo       EncryptedContentInfo
 * }
 *
 * EncryptedData ::= SEQUENCE {
 *   version                    Version,
 *   encryptedContentInfo       EncryptedContentInfo
 * }
 *
 * id-signedData OBJECT IDENTIFIER ::= { iso(1) member-body(2)
 *   us(840) rsadsi(113549) pkcs(1) pkcs7(7) 2 }
 *
 * SignedData ::= SEQUENCE {
 *   version           INTEGER,
 *   digestAlgorithms  DigestAlgorithmIdentifiers,
 *   contentInfo       ContentInfo,
 *   certificates      [0] IMPLICIT Certificates OPTIONAL,
 *   crls              [1] IMPLICIT CertificateRevocationLists OPTIONAL,
 *   signerInfos       SignerInfos
 * }
 *
 * SignerInfos ::= SET OF SignerInfo
 *
 * SignerInfo ::= SEQUENCE {
 *   version                    Version,
 *   issuerAndSerialNumber      IssuerAndSerialNumber,
 *   digestAlgorithm            DigestAlgorithmIdentifier,
 *   authenticatedAttributes    [0] IMPLICIT Attributes OPTIONAL,
 *   digestEncryptionAlgorithm  DigestEncryptionAlgorithmIdentifier,
 *   encryptedDigest            EncryptedDigest,
 *   unauthenticatedAttributes  [1] IMPLICIT Attributes OPTIONAL
 * }
 *
 * EncryptedDigest ::= OCTET STRING
 *
 * Attributes ::= SET OF Attribute
 *
 * Attribute ::= SEQUENCE {
 *   attrType    OBJECT IDENTIFIER,
 *   attrValues  SET OF AttributeValue
 * }
 *
 * AttributeValue ::= ANY
 *
 * Version ::= INTEGER
 *
 * RecipientInfos ::= SET OF RecipientInfo
 *
 * EncryptedContentInfo ::= SEQUENCE {
 *   contentType                 ContentType,
 *   contentEncryptionAlgorithm  ContentEncryptionAlgorithmIdentifier,
 *   encryptedContent       [0]  IMPLICIT EncryptedContent OPTIONAL
 * }
 *
 * ContentEncryptionAlgorithmIdentifier ::= AlgorithmIdentifier
 *
 * The AlgorithmIdentifier contains an Object Identifier (OID) and parameters
 * for the algorithm, if any. In the case of AES and DES3, there is only one,
 * the IV.
 *
 * AlgorithmIdentifer ::= SEQUENCE {
 *    algorithm OBJECT IDENTIFIER,
 *    parameters ANY DEFINED BY algorithm OPTIONAL
 * }
 *
 * EncryptedContent ::= OCTET STRING
 *
 * RecipientInfo ::= SEQUENCE {
 *   version                     Version,
 *   issuerAndSerialNumber       IssuerAndSerialNumber,
 *   keyEncryptionAlgorithm      KeyEncryptionAlgorithmIdentifier,
 *   encryptedKey                EncryptedKey
 * }
 *
 * IssuerAndSerialNumber ::= SEQUENCE {
 *   issuer                      Name,
 *   serialNumber                CertificateSerialNumber
 * }
 *
 * CertificateSerialNumber ::= INTEGER
 *
 * KeyEncryptionAlgorithmIdentifier ::= AlgorithmIdentifier
 *
 * EncryptedKey ::= OCTET STRING
 */ 
var $cLQG7 = parcelRequire("cLQG7");


// shortcut for ASN.1 API
var $5e73ddb53d480466$var$asn1 = $cLQG7.asn1;
// shortcut for PKCS#7 API
var $5e73ddb53d480466$var$p7v = $5e73ddb53d480466$exports = $cLQG7.pkcs7asn1 = $cLQG7.pkcs7asn1 || {};
$cLQG7.pkcs7 = $cLQG7.pkcs7 || {};
$cLQG7.pkcs7.asn1 = $5e73ddb53d480466$var$p7v;
var $5e73ddb53d480466$var$contentInfoValidator = {
    name: 'ContentInfo',
    tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
    type: $5e73ddb53d480466$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: 'ContentInfo.ContentType',
            tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
            type: $5e73ddb53d480466$var$asn1.Type.OID,
            constructed: false,
            capture: 'contentType'
        },
        {
            name: 'ContentInfo.content',
            tagClass: $5e73ddb53d480466$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 0,
            constructed: true,
            optional: true,
            captureAsn1: 'content'
        }
    ]
};
$5e73ddb53d480466$var$p7v.contentInfoValidator = $5e73ddb53d480466$var$contentInfoValidator;
var $5e73ddb53d480466$var$encryptedContentInfoValidator = {
    name: 'EncryptedContentInfo',
    tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
    type: $5e73ddb53d480466$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: 'EncryptedContentInfo.contentType',
            tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
            type: $5e73ddb53d480466$var$asn1.Type.OID,
            constructed: false,
            capture: 'contentType'
        },
        {
            name: 'EncryptedContentInfo.contentEncryptionAlgorithm',
            tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
            type: $5e73ddb53d480466$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: 'EncryptedContentInfo.contentEncryptionAlgorithm.algorithm',
                    tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
                    type: $5e73ddb53d480466$var$asn1.Type.OID,
                    constructed: false,
                    capture: 'encAlgorithm'
                },
                {
                    name: 'EncryptedContentInfo.contentEncryptionAlgorithm.parameter',
                    tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
                    captureAsn1: 'encParameter'
                }
            ]
        },
        {
            name: 'EncryptedContentInfo.encryptedContent',
            tagClass: $5e73ddb53d480466$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 0,
            /* The PKCS#7 structure output by OpenSSL somewhat differs from what
     * other implementations do generate.
     *
     * OpenSSL generates a structure like this:
     * SEQUENCE {
     *    ...
     *    [0]
     *       26 DA 67 D2 17 9C 45 3C B1 2A A8 59 2F 29 33 38
     *       C3 C3 DF 86 71 74 7A 19 9F 40 D0 29 BE 85 90 45
     *       ...
     * }
     *
     * Whereas other implementations (and this PKCS#7 module) generate:
     * SEQUENCE {
     *    ...
     *    [0] {
     *       OCTET STRING
     *          26 DA 67 D2 17 9C 45 3C B1 2A A8 59 2F 29 33 38
     *          C3 C3 DF 86 71 74 7A 19 9F 40 D0 29 BE 85 90 45
     *          ...
     *    }
     * }
     *
     * In order to support both, we just capture the context specific
     * field here.  The OCTET STRING bit is removed below.
     */ capture: 'encryptedContent',
            captureAsn1: 'encryptedContentAsn1'
        }
    ]
};
$5e73ddb53d480466$var$p7v.envelopedDataValidator = {
    name: 'EnvelopedData',
    tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
    type: $5e73ddb53d480466$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: 'EnvelopedData.Version',
            tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
            type: $5e73ddb53d480466$var$asn1.Type.INTEGER,
            constructed: false,
            capture: 'version'
        },
        {
            name: 'EnvelopedData.RecipientInfos',
            tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
            type: $5e73ddb53d480466$var$asn1.Type.SET,
            constructed: true,
            captureAsn1: 'recipientInfos'
        }
    ].concat($5e73ddb53d480466$var$encryptedContentInfoValidator)
};
$5e73ddb53d480466$var$p7v.encryptedDataValidator = {
    name: 'EncryptedData',
    tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
    type: $5e73ddb53d480466$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: 'EncryptedData.Version',
            tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
            type: $5e73ddb53d480466$var$asn1.Type.INTEGER,
            constructed: false,
            capture: 'version'
        }
    ].concat($5e73ddb53d480466$var$encryptedContentInfoValidator)
};
var $5e73ddb53d480466$var$signerValidator = {
    name: 'SignerInfo',
    tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
    type: $5e73ddb53d480466$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: 'SignerInfo.version',
            tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
            type: $5e73ddb53d480466$var$asn1.Type.INTEGER,
            constructed: false
        },
        {
            name: 'SignerInfo.issuerAndSerialNumber',
            tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
            type: $5e73ddb53d480466$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: 'SignerInfo.issuerAndSerialNumber.issuer',
                    tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
                    type: $5e73ddb53d480466$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    captureAsn1: 'issuer'
                },
                {
                    name: 'SignerInfo.issuerAndSerialNumber.serialNumber',
                    tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
                    type: $5e73ddb53d480466$var$asn1.Type.INTEGER,
                    constructed: false,
                    capture: 'serial'
                }
            ]
        },
        {
            name: 'SignerInfo.digestAlgorithm',
            tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
            type: $5e73ddb53d480466$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: 'SignerInfo.digestAlgorithm.algorithm',
                    tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
                    type: $5e73ddb53d480466$var$asn1.Type.OID,
                    constructed: false,
                    capture: 'digestAlgorithm'
                },
                {
                    name: 'SignerInfo.digestAlgorithm.parameter',
                    tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
                    constructed: false,
                    captureAsn1: 'digestParameter',
                    optional: true
                }
            ]
        },
        {
            name: 'SignerInfo.authenticatedAttributes',
            tagClass: $5e73ddb53d480466$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 0,
            constructed: true,
            optional: true,
            capture: 'authenticatedAttributes'
        },
        {
            name: 'SignerInfo.digestEncryptionAlgorithm',
            tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
            type: $5e73ddb53d480466$var$asn1.Type.SEQUENCE,
            constructed: true,
            capture: 'signatureAlgorithm'
        },
        {
            name: 'SignerInfo.encryptedDigest',
            tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
            type: $5e73ddb53d480466$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: 'signature'
        },
        {
            name: 'SignerInfo.unauthenticatedAttributes',
            tagClass: $5e73ddb53d480466$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 1,
            constructed: true,
            optional: true,
            capture: 'unauthenticatedAttributes'
        }
    ]
};
$5e73ddb53d480466$var$p7v.signedDataValidator = {
    name: 'SignedData',
    tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
    type: $5e73ddb53d480466$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: 'SignedData.Version',
            tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
            type: $5e73ddb53d480466$var$asn1.Type.INTEGER,
            constructed: false,
            capture: 'version'
        },
        {
            name: 'SignedData.DigestAlgorithms',
            tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
            type: $5e73ddb53d480466$var$asn1.Type.SET,
            constructed: true,
            captureAsn1: 'digestAlgorithms'
        },
        $5e73ddb53d480466$var$contentInfoValidator,
        {
            name: 'SignedData.Certificates',
            tagClass: $5e73ddb53d480466$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 0,
            optional: true,
            captureAsn1: 'certificates'
        },
        {
            name: 'SignedData.CertificateRevocationLists',
            tagClass: $5e73ddb53d480466$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 1,
            optional: true,
            captureAsn1: 'crls'
        },
        {
            name: 'SignedData.SignerInfos',
            tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
            type: $5e73ddb53d480466$var$asn1.Type.SET,
            capture: 'signerInfos',
            optional: true,
            value: [
                $5e73ddb53d480466$var$signerValidator
            ]
        }
    ]
};
$5e73ddb53d480466$var$p7v.recipientInfoValidator = {
    name: 'RecipientInfo',
    tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
    type: $5e73ddb53d480466$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: 'RecipientInfo.version',
            tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
            type: $5e73ddb53d480466$var$asn1.Type.INTEGER,
            constructed: false,
            capture: 'version'
        },
        {
            name: 'RecipientInfo.issuerAndSerial',
            tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
            type: $5e73ddb53d480466$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: 'RecipientInfo.issuerAndSerial.issuer',
                    tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
                    type: $5e73ddb53d480466$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    captureAsn1: 'issuer'
                },
                {
                    name: 'RecipientInfo.issuerAndSerial.serialNumber',
                    tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
                    type: $5e73ddb53d480466$var$asn1.Type.INTEGER,
                    constructed: false,
                    capture: 'serial'
                }
            ]
        },
        {
            name: 'RecipientInfo.keyEncryptionAlgorithm',
            tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
            type: $5e73ddb53d480466$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: 'RecipientInfo.keyEncryptionAlgorithm.algorithm',
                    tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
                    type: $5e73ddb53d480466$var$asn1.Type.OID,
                    constructed: false,
                    capture: 'encAlgorithm'
                },
                {
                    name: 'RecipientInfo.keyEncryptionAlgorithm.parameter',
                    tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
                    constructed: false,
                    captureAsn1: 'encParameter',
                    optional: true
                }
            ]
        },
        {
            name: 'RecipientInfo.encryptedKey',
            tagClass: $5e73ddb53d480466$var$asn1.Class.UNIVERSAL,
            type: $5e73ddb53d480466$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: 'encKey'
        }
    ]
};







var $928e625c51185ebc$exports = {};
/**
 * Javascript implementation of X.509 and related components (such as
 * Certification Signing Requests) of a Public Key Infrastructure.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 *
 * The ASN.1 representation of an X.509v3 certificate is as follows
 * (see RFC 2459):
 *
 * Certificate ::= SEQUENCE {
 *   tbsCertificate       TBSCertificate,
 *   signatureAlgorithm   AlgorithmIdentifier,
 *   signatureValue       BIT STRING
 * }
 *
 * TBSCertificate ::= SEQUENCE {
 *   version         [0]  EXPLICIT Version DEFAULT v1,
 *   serialNumber         CertificateSerialNumber,
 *   signature            AlgorithmIdentifier,
 *   issuer               Name,
 *   validity             Validity,
 *   subject              Name,
 *   subjectPublicKeyInfo SubjectPublicKeyInfo,
 *   issuerUniqueID  [1]  IMPLICIT UniqueIdentifier OPTIONAL,
 *                        -- If present, version shall be v2 or v3
 *   subjectUniqueID [2]  IMPLICIT UniqueIdentifier OPTIONAL,
 *                        -- If present, version shall be v2 or v3
 *   extensions      [3]  EXPLICIT Extensions OPTIONAL
 *                        -- If present, version shall be v3
 * }
 *
 * Version ::= INTEGER  { v1(0), v2(1), v3(2) }
 *
 * CertificateSerialNumber ::= INTEGER
 *
 * Name ::= CHOICE {
 *   // only one possible choice for now
 *   RDNSequence
 * }
 *
 * RDNSequence ::= SEQUENCE OF RelativeDistinguishedName
 *
 * RelativeDistinguishedName ::= SET OF AttributeTypeAndValue
 *
 * AttributeTypeAndValue ::= SEQUENCE {
 *   type     AttributeType,
 *   value    AttributeValue
 * }
 * AttributeType ::= OBJECT IDENTIFIER
 * AttributeValue ::= ANY DEFINED BY AttributeType
 *
 * Validity ::= SEQUENCE {
 *   notBefore      Time,
 *   notAfter       Time
 * }
 *
 * Time ::= CHOICE {
 *   utcTime        UTCTime,
 *   generalTime    GeneralizedTime
 * }
 *
 * UniqueIdentifier ::= BIT STRING
 *
 * SubjectPublicKeyInfo ::= SEQUENCE {
 *   algorithm            AlgorithmIdentifier,
 *   subjectPublicKey     BIT STRING
 * }
 *
 * Extensions ::= SEQUENCE SIZE (1..MAX) OF Extension
 *
 * Extension ::= SEQUENCE {
 *   extnID      OBJECT IDENTIFIER,
 *   critical    BOOLEAN DEFAULT FALSE,
 *   extnValue   OCTET STRING
 * }
 *
 * The only key algorithm currently supported for PKI is RSA.
 *
 * RSASSA-PSS signatures are described in RFC 3447 and RFC 4055.
 *
 * PKCS#10 v1.7 describes certificate signing requests:
 *
 * CertificationRequestInfo:
 *
 * CertificationRequestInfo ::= SEQUENCE {
 *   version       INTEGER { v1(0) } (v1,...),
 *   subject       Name,
 *   subjectPKInfo SubjectPublicKeyInfo{{ PKInfoAlgorithms }},
 *   attributes    [0] Attributes{{ CRIAttributes }}
 * }
 *
 * Attributes { ATTRIBUTE:IOSet } ::= SET OF Attribute{{ IOSet }}
 *
 * CRIAttributes  ATTRIBUTE  ::= {
 *   ... -- add any locally defined attributes here -- }
 *
 * Attribute { ATTRIBUTE:IOSet } ::= SEQUENCE {
 *   type   ATTRIBUTE.&id({IOSet}),
 *   values SET SIZE(1..MAX) OF ATTRIBUTE.&Type({IOSet}{@type})
 * }
 *
 * CertificationRequest ::= SEQUENCE {
 *   certificationRequestInfo CertificationRequestInfo,
 *   signatureAlgorithm AlgorithmIdentifier{{ SignatureAlgorithms }},
 *   signature          BIT STRING
 * }
 */ 
var $cLQG7 = parcelRequire("cLQG7");



parcelRequire("4pr5e");
var $d40dfc88150ec8f5$exports = {};
/**
 * Node.js module for Forge mask generation functions.
 *
 * @author Stefan Siegl
 *
 * Copyright 2012 Stefan Siegl <stesie@brokenpipe.de>
 */ 
var $cLQG7 = parcelRequire("cLQG7");
var $8002186775489052$exports = {};
/**
 * Javascript implementation of mask generation function MGF1.
 *
 * @author Stefan Siegl
 * @author Dave Longley
 *
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 * Copyright (c) 2014 Digital Bazaar, Inc.
 */ 
var $cLQG7 = parcelRequire("cLQG7");

$cLQG7.mgf = $cLQG7.mgf || {};
var $8002186775489052$var$mgf1 = $8002186775489052$exports = $cLQG7.mgf.mgf1 = $cLQG7.mgf1 = $cLQG7.mgf1 || {};
/**
 * Creates a MGF1 mask generation function object.
 *
 * @param md the message digest API to use (eg: forge.md.sha1.create()).
 *
 * @return a mask generation function object.
 */ $8002186775489052$var$mgf1.create = function(md) {
    var mgf = {
        /**
     * Generate mask of specified length.
     *
     * @param {String} seed The seed for mask generation.
     * @param maskLen Number of bytes to generate.
     * @return {String} The generated mask.
     */ generate: function(seed, maskLen) {
            /* 2. Let T be the empty octet string. */ var t = new $cLQG7.util.ByteBuffer();
            /* 3. For counter from 0 to ceil(maskLen / hLen), do the following: */ var len = Math.ceil(maskLen / md.digestLength);
            for(var i = 0; i < len; i++){
                /* a. Convert counter to an octet string C of length 4 octets */ var c = new $cLQG7.util.ByteBuffer();
                c.putInt32(i);
                /* b. Concatenate the hash of the seed mgfSeed and C to the octet
         * string T: */ md.start();
                md.update(seed + c.getBytes());
                t.putBuffer(md.digest());
            }
            /* Output the leading maskLen octets of T as the octet string mask. */ t.truncate(t.length() - maskLen);
            return t.getBytes();
        }
    };
    return mgf;
};


$d40dfc88150ec8f5$exports = $cLQG7.mgf = $cLQG7.mgf || {};
$cLQG7.mgf.mgf1 = $cLQG7.mgf1;




var $bb846fd6d4bab93b$exports = {};
/**
 * Javascript implementation of PKCS#1 PSS signature padding.
 *
 * @author Stefan Siegl
 *
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 */ 
var $cLQG7 = parcelRequire("cLQG7");


// shortcut for PSS API
var $bb846fd6d4bab93b$var$pss = $bb846fd6d4bab93b$exports = $cLQG7.pss = $cLQG7.pss || {};
/**
 * Creates a PSS signature scheme object.
 *
 * There are several ways to provide a salt for encoding:
 *
 * 1. Specify the saltLength only and the built-in PRNG will generate it.
 * 2. Specify the saltLength and a custom PRNG with 'getBytesSync' defined that
 *   will be used.
 * 3. Specify the salt itself as a forge.util.ByteBuffer.
 *
 * @param options the options to use:
 *          md the message digest object to use, a forge md instance.
 *          mgf the mask generation function to use, a forge mgf instance.
 *          [saltLength] the length of the salt in octets.
 *          [prng] the pseudo-random number generator to use to produce a salt.
 *          [salt] the salt to use when encoding.
 *
 * @return a signature scheme object.
 */ $bb846fd6d4bab93b$var$pss.create = function(options) {
    // backwards compatibility w/legacy args: hash, mgf, sLen
    if (arguments.length === 3) options = {
        md: arguments[0],
        mgf: arguments[1],
        saltLength: arguments[2]
    };
    var hash = options.md;
    var mgf = options.mgf;
    var hLen = hash.digestLength;
    var salt_ = options.salt || null;
    if (typeof salt_ === 'string') // assume binary-encoded string
    salt_ = $cLQG7.util.createBuffer(salt_);
    var sLen;
    if ('saltLength' in options) sLen = options.saltLength;
    else if (salt_ !== null) sLen = salt_.length();
    else throw new Error('Salt length not specified or specific salt not given.');
    if (salt_ !== null && salt_.length() !== sLen) throw new Error('Given salt length does not match length of given salt.');
    var prng = options.prng || $cLQG7.random;
    var pssobj = {};
    /**
   * Encodes a PSS signature.
   *
   * This function implements EMSA-PSS-ENCODE as per RFC 3447, section 9.1.1.
   *
   * @param md the message digest object with the hash to sign.
   * @param modsBits the length of the RSA modulus in bits.
   *
   * @return the encoded message as a binary-encoded string of length
   *           ceil((modBits - 1) / 8).
   */ pssobj.encode = function(md, modBits) {
        var i;
        var emBits = modBits - 1;
        var emLen = Math.ceil(emBits / 8);
        /* 2. Let mHash = Hash(M), an octet string of length hLen. */ var mHash = md.digest().getBytes();
        /* 3. If emLen < hLen + sLen + 2, output "encoding error" and stop. */ if (emLen < hLen + sLen + 2) throw new Error('Message is too long to encrypt.');
        /* 4. Generate a random octet string salt of length sLen; if sLen = 0,
     *    then salt is the empty string. */ var salt;
        if (salt_ === null) salt = prng.getBytesSync(sLen);
        else salt = salt_.bytes();
        /* 5. Let M' = (0x)00 00 00 00 00 00 00 00 || mHash || salt; */ var m_ = new $cLQG7.util.ByteBuffer();
        m_.fillWithByte(0, 8);
        m_.putBytes(mHash);
        m_.putBytes(salt);
        /* 6. Let H = Hash(M'), an octet string of length hLen. */ hash.start();
        hash.update(m_.getBytes());
        var h = hash.digest().getBytes();
        /* 7. Generate an octet string PS consisting of emLen - sLen - hLen - 2
     *    zero octets.  The length of PS may be 0. */ var ps = new $cLQG7.util.ByteBuffer();
        ps.fillWithByte(0, emLen - sLen - hLen - 2);
        /* 8. Let DB = PS || 0x01 || salt; DB is an octet string of length
     *    emLen - hLen - 1. */ ps.putByte(0x01);
        ps.putBytes(salt);
        var db = ps.getBytes();
        /* 9. Let dbMask = MGF(H, emLen - hLen - 1). */ var maskLen = emLen - hLen - 1;
        var dbMask = mgf.generate(h, maskLen);
        /* 10. Let maskedDB = DB \xor dbMask. */ var maskedDB = '';
        for(i = 0; i < maskLen; i++)maskedDB += String.fromCharCode(db.charCodeAt(i) ^ dbMask.charCodeAt(i));
        /* 11. Set the leftmost 8emLen - emBits bits of the leftmost octet in
     *     maskedDB to zero. */ var mask = 0xFF00 >> 8 * emLen - emBits & 0xFF;
        maskedDB = String.fromCharCode(maskedDB.charCodeAt(0) & ~mask) + maskedDB.substr(1);
        /* 12. Let EM = maskedDB || H || 0xbc.
     * 13. Output EM. */ return maskedDB + h + String.fromCharCode(0xbc);
    };
    /**
   * Verifies a PSS signature.
   *
   * This function implements EMSA-PSS-VERIFY as per RFC 3447, section 9.1.2.
   *
   * @param mHash the message digest hash, as a binary-encoded string, to
   *         compare against the signature.
   * @param em the encoded message, as a binary-encoded string
   *          (RSA decryption result).
   * @param modsBits the length of the RSA modulus in bits.
   *
   * @return true if the signature was verified, false if not.
   */ pssobj.verify = function(mHash, em, modBits) {
        var i;
        var emBits = modBits - 1;
        var emLen = Math.ceil(emBits / 8);
        /* c. Convert the message representative m to an encoded message EM
     *    of length emLen = ceil((modBits - 1) / 8) octets, where modBits
     *    is the length in bits of the RSA modulus n */ em = em.substr(-emLen);
        /* 3. If emLen < hLen + sLen + 2, output "inconsistent" and stop. */ if (emLen < hLen + sLen + 2) throw new Error('Inconsistent parameters to PSS signature verification.');
        /* 4. If the rightmost octet of EM does not have hexadecimal value
     *    0xbc, output "inconsistent" and stop. */ if (em.charCodeAt(emLen - 1) !== 0xbc) throw new Error('Encoded message does not end in 0xBC.');
        /* 5. Let maskedDB be the leftmost emLen - hLen - 1 octets of EM, and
     *    let H be the next hLen octets. */ var maskLen = emLen - hLen - 1;
        var maskedDB = em.substr(0, maskLen);
        var h = em.substr(maskLen, hLen);
        /* 6. If the leftmost 8emLen - emBits bits of the leftmost octet in
     *    maskedDB are not all equal to zero, output "inconsistent" and stop. */ var mask = 0xFF00 >> 8 * emLen - emBits & 0xFF;
        if ((maskedDB.charCodeAt(0) & mask) !== 0) throw new Error('Bits beyond keysize not zero as expected.');
        /* 7. Let dbMask = MGF(H, emLen - hLen - 1). */ var dbMask = mgf.generate(h, maskLen);
        /* 8. Let DB = maskedDB \xor dbMask. */ var db = '';
        for(i = 0; i < maskLen; i++)db += String.fromCharCode(maskedDB.charCodeAt(i) ^ dbMask.charCodeAt(i));
        /* 9. Set the leftmost 8emLen - emBits bits of the leftmost octet
     * in DB to zero. */ db = String.fromCharCode(db.charCodeAt(0) & ~mask) + db.substr(1);
        /* 10. If the emLen - hLen - sLen - 2 leftmost octets of DB are not zero
     * or if the octet at position emLen - hLen - sLen - 1 (the leftmost
     * position is "position 1") does not have hexadecimal value 0x01,
     * output "inconsistent" and stop. */ var checkLen = emLen - hLen - sLen - 2;
        for(i = 0; i < checkLen; i++){
            if (db.charCodeAt(i) !== 0x00) throw new Error('Leftmost octets not zero as expected');
        }
        if (db.charCodeAt(checkLen) !== 0x01) throw new Error('Inconsistent PSS signature, 0x01 marker not found');
        /* 11. Let salt be the last sLen octets of DB. */ var salt = db.substr(-sLen);
        /* 12.  Let M' = (0x)00 00 00 00 00 00 00 00 || mHash || salt */ var m_ = new $cLQG7.util.ByteBuffer();
        m_.fillWithByte(0, 8);
        m_.putBytes(mHash);
        m_.putBytes(salt);
        /* 13. Let H' = Hash(M'), an octet string of length hLen. */ hash.start();
        hash.update(m_.getBytes());
        var h_ = hash.digest().getBytes();
        /* 14. If H = H', output "consistent." Otherwise, output "inconsistent." */ return h === h_;
    };
    return pssobj;
};




// shortcut for asn.1 API
var $928e625c51185ebc$var$asn1 = $cLQG7.asn1;
/* Public Key Infrastructure (PKI) implementation. */ var $928e625c51185ebc$var$pki = $928e625c51185ebc$exports = $cLQG7.pki = $cLQG7.pki || {};
var $928e625c51185ebc$var$oids = $928e625c51185ebc$var$pki.oids;
// short name OID mappings
var $928e625c51185ebc$var$_shortNames = {};
$928e625c51185ebc$var$_shortNames['CN'] = $928e625c51185ebc$var$oids['commonName'];
$928e625c51185ebc$var$_shortNames['commonName'] = 'CN';
$928e625c51185ebc$var$_shortNames['C'] = $928e625c51185ebc$var$oids['countryName'];
$928e625c51185ebc$var$_shortNames['countryName'] = 'C';
$928e625c51185ebc$var$_shortNames['L'] = $928e625c51185ebc$var$oids['localityName'];
$928e625c51185ebc$var$_shortNames['localityName'] = 'L';
$928e625c51185ebc$var$_shortNames['ST'] = $928e625c51185ebc$var$oids['stateOrProvinceName'];
$928e625c51185ebc$var$_shortNames['stateOrProvinceName'] = 'ST';
$928e625c51185ebc$var$_shortNames['O'] = $928e625c51185ebc$var$oids['organizationName'];
$928e625c51185ebc$var$_shortNames['organizationName'] = 'O';
$928e625c51185ebc$var$_shortNames['OU'] = $928e625c51185ebc$var$oids['organizationalUnitName'];
$928e625c51185ebc$var$_shortNames['organizationalUnitName'] = 'OU';
$928e625c51185ebc$var$_shortNames['E'] = $928e625c51185ebc$var$oids['emailAddress'];
$928e625c51185ebc$var$_shortNames['emailAddress'] = 'E';
// validator for an SubjectPublicKeyInfo structure
// Note: Currently only works with an RSA public key
var $928e625c51185ebc$var$publicKeyValidator = $cLQG7.pki.rsa.publicKeyValidator;
// validator for an X.509v3 certificate
var $928e625c51185ebc$var$x509CertificateValidator = {
    name: 'Certificate',
    tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
    type: $928e625c51185ebc$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: 'Certificate.TBSCertificate',
            tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
            type: $928e625c51185ebc$var$asn1.Type.SEQUENCE,
            constructed: true,
            captureAsn1: 'tbsCertificate',
            value: [
                {
                    name: 'Certificate.TBSCertificate.version',
                    tagClass: $928e625c51185ebc$var$asn1.Class.CONTEXT_SPECIFIC,
                    type: 0,
                    constructed: true,
                    optional: true,
                    value: [
                        {
                            name: 'Certificate.TBSCertificate.version.integer',
                            tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                            type: $928e625c51185ebc$var$asn1.Type.INTEGER,
                            constructed: false,
                            capture: 'certVersion'
                        }
                    ]
                },
                {
                    name: 'Certificate.TBSCertificate.serialNumber',
                    tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                    type: $928e625c51185ebc$var$asn1.Type.INTEGER,
                    constructed: false,
                    capture: 'certSerialNumber'
                },
                {
                    name: 'Certificate.TBSCertificate.signature',
                    tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                    type: $928e625c51185ebc$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    value: [
                        {
                            name: 'Certificate.TBSCertificate.signature.algorithm',
                            tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                            type: $928e625c51185ebc$var$asn1.Type.OID,
                            constructed: false,
                            capture: 'certinfoSignatureOid'
                        },
                        {
                            name: 'Certificate.TBSCertificate.signature.parameters',
                            tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                            optional: true,
                            captureAsn1: 'certinfoSignatureParams'
                        }
                    ]
                },
                {
                    name: 'Certificate.TBSCertificate.issuer',
                    tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                    type: $928e625c51185ebc$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    captureAsn1: 'certIssuer'
                },
                {
                    name: 'Certificate.TBSCertificate.validity',
                    tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                    type: $928e625c51185ebc$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    // Note: UTC and generalized times may both appear so the capture
                    // names are based on their detected order, the names used below
                    // are only for the common case, which validity time really means
                    // "notBefore" and which means "notAfter" will be determined by order
                    value: [
                        {
                            // notBefore (Time) (UTC time case)
                            name: 'Certificate.TBSCertificate.validity.notBefore (utc)',
                            tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                            type: $928e625c51185ebc$var$asn1.Type.UTCTIME,
                            constructed: false,
                            optional: true,
                            capture: 'certValidity1UTCTime'
                        },
                        {
                            // notBefore (Time) (generalized time case)
                            name: 'Certificate.TBSCertificate.validity.notBefore (generalized)',
                            tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                            type: $928e625c51185ebc$var$asn1.Type.GENERALIZEDTIME,
                            constructed: false,
                            optional: true,
                            capture: 'certValidity2GeneralizedTime'
                        },
                        {
                            // notAfter (Time) (only UTC time is supported)
                            name: 'Certificate.TBSCertificate.validity.notAfter (utc)',
                            tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                            type: $928e625c51185ebc$var$asn1.Type.UTCTIME,
                            constructed: false,
                            optional: true,
                            capture: 'certValidity3UTCTime'
                        },
                        {
                            // notAfter (Time) (only UTC time is supported)
                            name: 'Certificate.TBSCertificate.validity.notAfter (generalized)',
                            tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                            type: $928e625c51185ebc$var$asn1.Type.GENERALIZEDTIME,
                            constructed: false,
                            optional: true,
                            capture: 'certValidity4GeneralizedTime'
                        }
                    ]
                },
                {
                    // Name (subject) (RDNSequence)
                    name: 'Certificate.TBSCertificate.subject',
                    tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                    type: $928e625c51185ebc$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    captureAsn1: 'certSubject'
                },
                // SubjectPublicKeyInfo
                $928e625c51185ebc$var$publicKeyValidator,
                {
                    // issuerUniqueID (optional)
                    name: 'Certificate.TBSCertificate.issuerUniqueID',
                    tagClass: $928e625c51185ebc$var$asn1.Class.CONTEXT_SPECIFIC,
                    type: 1,
                    constructed: true,
                    optional: true,
                    value: [
                        {
                            name: 'Certificate.TBSCertificate.issuerUniqueID.id',
                            tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                            type: $928e625c51185ebc$var$asn1.Type.BITSTRING,
                            constructed: false,
                            // TODO: support arbitrary bit length ids
                            captureBitStringValue: 'certIssuerUniqueId'
                        }
                    ]
                },
                {
                    // subjectUniqueID (optional)
                    name: 'Certificate.TBSCertificate.subjectUniqueID',
                    tagClass: $928e625c51185ebc$var$asn1.Class.CONTEXT_SPECIFIC,
                    type: 2,
                    constructed: true,
                    optional: true,
                    value: [
                        {
                            name: 'Certificate.TBSCertificate.subjectUniqueID.id',
                            tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                            type: $928e625c51185ebc$var$asn1.Type.BITSTRING,
                            constructed: false,
                            // TODO: support arbitrary bit length ids
                            captureBitStringValue: 'certSubjectUniqueId'
                        }
                    ]
                },
                {
                    // Extensions (optional)
                    name: 'Certificate.TBSCertificate.extensions',
                    tagClass: $928e625c51185ebc$var$asn1.Class.CONTEXT_SPECIFIC,
                    type: 3,
                    constructed: true,
                    captureAsn1: 'certExtensions',
                    optional: true
                }
            ]
        },
        {
            // AlgorithmIdentifier (signature algorithm)
            name: 'Certificate.signatureAlgorithm',
            tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
            type: $928e625c51185ebc$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    // algorithm
                    name: 'Certificate.signatureAlgorithm.algorithm',
                    tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                    type: $928e625c51185ebc$var$asn1.Type.OID,
                    constructed: false,
                    capture: 'certSignatureOid'
                },
                {
                    name: 'Certificate.TBSCertificate.signature.parameters',
                    tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                    optional: true,
                    captureAsn1: 'certSignatureParams'
                }
            ]
        },
        {
            // SignatureValue
            name: 'Certificate.signatureValue',
            tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
            type: $928e625c51185ebc$var$asn1.Type.BITSTRING,
            constructed: false,
            captureBitStringValue: 'certSignature'
        }
    ]
};
var $928e625c51185ebc$var$rsassaPssParameterValidator = {
    name: 'rsapss',
    tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
    type: $928e625c51185ebc$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: 'rsapss.hashAlgorithm',
            tagClass: $928e625c51185ebc$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 0,
            constructed: true,
            value: [
                {
                    name: 'rsapss.hashAlgorithm.AlgorithmIdentifier',
                    tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                    type: $928e625c51185ebc$var$asn1.Class.SEQUENCE,
                    constructed: true,
                    optional: true,
                    value: [
                        {
                            name: 'rsapss.hashAlgorithm.AlgorithmIdentifier.algorithm',
                            tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                            type: $928e625c51185ebc$var$asn1.Type.OID,
                            constructed: false,
                            capture: 'hashOid'
                        }
                    ]
                }
            ]
        },
        {
            name: 'rsapss.maskGenAlgorithm',
            tagClass: $928e625c51185ebc$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 1,
            constructed: true,
            value: [
                {
                    name: 'rsapss.maskGenAlgorithm.AlgorithmIdentifier',
                    tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                    type: $928e625c51185ebc$var$asn1.Class.SEQUENCE,
                    constructed: true,
                    optional: true,
                    value: [
                        {
                            name: 'rsapss.maskGenAlgorithm.AlgorithmIdentifier.algorithm',
                            tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                            type: $928e625c51185ebc$var$asn1.Type.OID,
                            constructed: false,
                            capture: 'maskGenOid'
                        },
                        {
                            name: 'rsapss.maskGenAlgorithm.AlgorithmIdentifier.params',
                            tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                            type: $928e625c51185ebc$var$asn1.Type.SEQUENCE,
                            constructed: true,
                            value: [
                                {
                                    name: 'rsapss.maskGenAlgorithm.AlgorithmIdentifier.params.algorithm',
                                    tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                                    type: $928e625c51185ebc$var$asn1.Type.OID,
                                    constructed: false,
                                    capture: 'maskGenHashOid'
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            name: 'rsapss.saltLength',
            tagClass: $928e625c51185ebc$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 2,
            optional: true,
            value: [
                {
                    name: 'rsapss.saltLength.saltLength',
                    tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                    type: $928e625c51185ebc$var$asn1.Class.INTEGER,
                    constructed: false,
                    capture: 'saltLength'
                }
            ]
        },
        {
            name: 'rsapss.trailerField',
            tagClass: $928e625c51185ebc$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 3,
            optional: true,
            value: [
                {
                    name: 'rsapss.trailer.trailer',
                    tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                    type: $928e625c51185ebc$var$asn1.Class.INTEGER,
                    constructed: false,
                    capture: 'trailer'
                }
            ]
        }
    ]
};
// validator for a CertificationRequestInfo structure
var $928e625c51185ebc$var$certificationRequestInfoValidator = {
    name: 'CertificationRequestInfo',
    tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
    type: $928e625c51185ebc$var$asn1.Type.SEQUENCE,
    constructed: true,
    captureAsn1: 'certificationRequestInfo',
    value: [
        {
            name: 'CertificationRequestInfo.integer',
            tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
            type: $928e625c51185ebc$var$asn1.Type.INTEGER,
            constructed: false,
            capture: 'certificationRequestInfoVersion'
        },
        {
            // Name (subject) (RDNSequence)
            name: 'CertificationRequestInfo.subject',
            tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
            type: $928e625c51185ebc$var$asn1.Type.SEQUENCE,
            constructed: true,
            captureAsn1: 'certificationRequestInfoSubject'
        },
        // SubjectPublicKeyInfo
        $928e625c51185ebc$var$publicKeyValidator,
        {
            name: 'CertificationRequestInfo.attributes',
            tagClass: $928e625c51185ebc$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 0,
            constructed: true,
            optional: true,
            capture: 'certificationRequestInfoAttributes',
            value: [
                {
                    name: 'CertificationRequestInfo.attributes',
                    tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                    type: $928e625c51185ebc$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    value: [
                        {
                            name: 'CertificationRequestInfo.attributes.type',
                            tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                            type: $928e625c51185ebc$var$asn1.Type.OID,
                            constructed: false
                        },
                        {
                            name: 'CertificationRequestInfo.attributes.value',
                            tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                            type: $928e625c51185ebc$var$asn1.Type.SET,
                            constructed: true
                        }
                    ]
                }
            ]
        }
    ]
};
// validator for a CertificationRequest structure
var $928e625c51185ebc$var$certificationRequestValidator = {
    name: 'CertificationRequest',
    tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
    type: $928e625c51185ebc$var$asn1.Type.SEQUENCE,
    constructed: true,
    captureAsn1: 'csr',
    value: [
        $928e625c51185ebc$var$certificationRequestInfoValidator,
        {
            // AlgorithmIdentifier (signature algorithm)
            name: 'CertificationRequest.signatureAlgorithm',
            tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
            type: $928e625c51185ebc$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    // algorithm
                    name: 'CertificationRequest.signatureAlgorithm.algorithm',
                    tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                    type: $928e625c51185ebc$var$asn1.Type.OID,
                    constructed: false,
                    capture: 'csrSignatureOid'
                },
                {
                    name: 'CertificationRequest.signatureAlgorithm.parameters',
                    tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
                    optional: true,
                    captureAsn1: 'csrSignatureParams'
                }
            ]
        },
        {
            // signature
            name: 'CertificationRequest.signature',
            tagClass: $928e625c51185ebc$var$asn1.Class.UNIVERSAL,
            type: $928e625c51185ebc$var$asn1.Type.BITSTRING,
            constructed: false,
            captureBitStringValue: 'csrSignature'
        }
    ]
};
/**
 * Converts an RDNSequence of ASN.1 DER-encoded RelativeDistinguishedName
 * sets into an array with objects that have type and value properties.
 *
 * @param rdn the RDNSequence to convert.
 * @param md a message digest to append type and value to if provided.
 */ $928e625c51185ebc$var$pki.RDNAttributesAsArray = function(rdn, md) {
    var rval = [];
    // each value in 'rdn' in is a SET of RelativeDistinguishedName
    var set, attr, obj;
    for(var si = 0; si < rdn.value.length; ++si){
        // get the RelativeDistinguishedName set
        set = rdn.value[si];
        // each value in the SET is an AttributeTypeAndValue sequence
        // containing first a type (an OID) and second a value (defined by
        // the OID)
        for(var i = 0; i < set.value.length; ++i){
            obj = {};
            attr = set.value[i];
            obj.type = $928e625c51185ebc$var$asn1.derToOid(attr.value[0].value);
            obj.value = attr.value[1].value;
            obj.valueTagClass = attr.value[1].type;
            // if the OID is known, get its name and short name
            if (obj.type in $928e625c51185ebc$var$oids) {
                obj.name = $928e625c51185ebc$var$oids[obj.type];
                if (obj.name in $928e625c51185ebc$var$_shortNames) obj.shortName = $928e625c51185ebc$var$_shortNames[obj.name];
            }
            if (md) {
                md.update(obj.type);
                md.update(obj.value);
            }
            rval.push(obj);
        }
    }
    return rval;
};
/**
 * Converts ASN.1 CRIAttributes into an array with objects that have type and
 * value properties.
 *
 * @param attributes the CRIAttributes to convert.
 */ $928e625c51185ebc$var$pki.CRIAttributesAsArray = function(attributes) {
    var rval = [];
    // each value in 'attributes' in is a SEQUENCE with an OID and a SET
    for(var si = 0; si < attributes.length; ++si){
        // get the attribute sequence
        var seq = attributes[si];
        // each value in the SEQUENCE containing first a type (an OID) and
        // second a set of values (defined by the OID)
        var type = $928e625c51185ebc$var$asn1.derToOid(seq.value[0].value);
        var values = seq.value[1].value;
        for(var vi = 0; vi < values.length; ++vi){
            var obj = {};
            obj.type = type;
            obj.value = values[vi].value;
            obj.valueTagClass = values[vi].type;
            // if the OID is known, get its name and short name
            if (obj.type in $928e625c51185ebc$var$oids) {
                obj.name = $928e625c51185ebc$var$oids[obj.type];
                if (obj.name in $928e625c51185ebc$var$_shortNames) obj.shortName = $928e625c51185ebc$var$_shortNames[obj.name];
            }
            // parse extensions
            if (obj.type === $928e625c51185ebc$var$oids.extensionRequest) {
                obj.extensions = [];
                for(var ei = 0; ei < obj.value.length; ++ei)obj.extensions.push($928e625c51185ebc$var$pki.certificateExtensionFromAsn1(obj.value[ei]));
            }
            rval.push(obj);
        }
    }
    return rval;
};
/**
 * Gets an issuer or subject attribute from its name, type, or short name.
 *
 * @param obj the issuer or subject object.
 * @param options a short name string or an object with:
 *          shortName the short name for the attribute.
 *          name the name for the attribute.
 *          type the type for the attribute.
 *
 * @return the attribute.
 */ function $928e625c51185ebc$var$_getAttribute(obj, options) {
    if (typeof options === 'string') options = {
        shortName: options
    };
    var rval = null;
    var attr;
    for(var i = 0; rval === null && i < obj.attributes.length; ++i){
        attr = obj.attributes[i];
        if (options.type && options.type === attr.type) rval = attr;
        else if (options.name && options.name === attr.name) rval = attr;
        else if (options.shortName && options.shortName === attr.shortName) rval = attr;
    }
    return rval;
}
/**
 * Converts signature parameters from ASN.1 structure.
 *
 * Currently only RSASSA-PSS supported.  The PKCS#1 v1.5 signature scheme had
 * no parameters.
 *
 * RSASSA-PSS-params  ::=  SEQUENCE  {
 *   hashAlgorithm      [0] HashAlgorithm DEFAULT
 *                             sha1Identifier,
 *   maskGenAlgorithm   [1] MaskGenAlgorithm DEFAULT
 *                             mgf1SHA1Identifier,
 *   saltLength         [2] INTEGER DEFAULT 20,
 *   trailerField       [3] INTEGER DEFAULT 1
 * }
 *
 * HashAlgorithm  ::=  AlgorithmIdentifier
 *
 * MaskGenAlgorithm  ::=  AlgorithmIdentifier
 *
 * AlgorithmIdentifer ::= SEQUENCE {
 *   algorithm OBJECT IDENTIFIER,
 *   parameters ANY DEFINED BY algorithm OPTIONAL
 * }
 *
 * @param oid The OID specifying the signature algorithm
 * @param obj The ASN.1 structure holding the parameters
 * @param fillDefaults Whether to use return default values where omitted
 * @return signature parameter object
 */ var $928e625c51185ebc$var$_readSignatureParameters = function(oid, obj, fillDefaults) {
    var params = {};
    if (oid !== $928e625c51185ebc$var$oids['RSASSA-PSS']) return params;
    if (fillDefaults) params = {
        hash: {
            algorithmOid: $928e625c51185ebc$var$oids['sha1']
        },
        mgf: {
            algorithmOid: $928e625c51185ebc$var$oids['mgf1'],
            hash: {
                algorithmOid: $928e625c51185ebc$var$oids['sha1']
            }
        },
        saltLength: 20
    };
    var capture = {};
    var errors = [];
    if (!$928e625c51185ebc$var$asn1.validate(obj, $928e625c51185ebc$var$rsassaPssParameterValidator, capture, errors)) {
        var error = new Error('Cannot read RSASSA-PSS parameter block.');
        error.errors = errors;
        throw error;
    }
    if (capture.hashOid !== undefined) {
        params.hash = params.hash || {};
        params.hash.algorithmOid = $928e625c51185ebc$var$asn1.derToOid(capture.hashOid);
    }
    if (capture.maskGenOid !== undefined) {
        params.mgf = params.mgf || {};
        params.mgf.algorithmOid = $928e625c51185ebc$var$asn1.derToOid(capture.maskGenOid);
        params.mgf.hash = params.mgf.hash || {};
        params.mgf.hash.algorithmOid = $928e625c51185ebc$var$asn1.derToOid(capture.maskGenHashOid);
    }
    if (capture.saltLength !== undefined) params.saltLength = capture.saltLength.charCodeAt(0);
    return params;
};
/**
 * Create signature digest for OID.
 *
 * @param options
 *   signatureOid: the OID specifying the signature algorithm.
 *   type: a human readable type for error messages
 * @return a created md instance. throws if unknown oid.
 */ var $928e625c51185ebc$var$_createSignatureDigest = function(options) {
    switch($928e625c51185ebc$var$oids[options.signatureOid]){
        case 'sha1WithRSAEncryption':
        // deprecated alias
        case 'sha1WithRSASignature':
            return $cLQG7.md.sha1.create();
        case 'md5WithRSAEncryption':
            return $cLQG7.md.md5.create();
        case 'sha256WithRSAEncryption':
            return $cLQG7.md.sha256.create();
        case 'sha384WithRSAEncryption':
            return $cLQG7.md.sha384.create();
        case 'sha512WithRSAEncryption':
            return $cLQG7.md.sha512.create();
        case 'RSASSA-PSS':
            return $cLQG7.md.sha256.create();
        default:
            var error = new Error('Could not compute ' + options.type + ' digest. ' + 'Unknown signature OID.');
            error.signatureOid = options.signatureOid;
            throw error;
    }
};
/**
 * Verify signature on certificate or CSR.
 *
 * @param options:
 *   certificate the certificate or CSR to verify.
 *   md the signature digest.
 *   signature the signature
 * @return a created md instance. throws if unknown oid.
 */ var $928e625c51185ebc$var$_verifySignature = function(options) {
    var cert = options.certificate;
    var scheme;
    switch(cert.signatureOid){
        case $928e625c51185ebc$var$oids.sha1WithRSAEncryption:
        // deprecated alias
        case $928e625c51185ebc$var$oids.sha1WithRSASignature:
            break;
        case $928e625c51185ebc$var$oids['RSASSA-PSS']:
            var hash, mgf;
            /* initialize mgf */ hash = $928e625c51185ebc$var$oids[cert.signatureParameters.mgf.hash.algorithmOid];
            if (hash === undefined || $cLQG7.md[hash] === undefined) {
                var error = new Error('Unsupported MGF hash function.');
                error.oid = cert.signatureParameters.mgf.hash.algorithmOid;
                error.name = hash;
                throw error;
            }
            mgf = $928e625c51185ebc$var$oids[cert.signatureParameters.mgf.algorithmOid];
            if (mgf === undefined || $cLQG7.mgf[mgf] === undefined) {
                var error = new Error('Unsupported MGF function.');
                error.oid = cert.signatureParameters.mgf.algorithmOid;
                error.name = mgf;
                throw error;
            }
            mgf = $cLQG7.mgf[mgf].create($cLQG7.md[hash].create());
            /* initialize hash function */ hash = $928e625c51185ebc$var$oids[cert.signatureParameters.hash.algorithmOid];
            if (hash === undefined || $cLQG7.md[hash] === undefined) {
                var error = new Error('Unsupported RSASSA-PSS hash function.');
                error.oid = cert.signatureParameters.hash.algorithmOid;
                error.name = hash;
                throw error;
            }
            scheme = $cLQG7.pss.create($cLQG7.md[hash].create(), mgf, cert.signatureParameters.saltLength);
            break;
    }
    // verify signature on cert using public key
    return cert.publicKey.verify(options.md.digest().getBytes(), options.signature, scheme);
};
/**
 * Converts an X.509 certificate from PEM format.
 *
 * Note: If the certificate is to be verified then compute hash should
 * be set to true. This will scan the TBSCertificate part of the ASN.1
 * object while it is converted so it doesn't need to be converted back
 * to ASN.1-DER-encoding later.
 *
 * @param pem the PEM-formatted certificate.
 * @param computeHash true to compute the hash for verification.
 * @param strict true to be strict when checking ASN.1 value lengths, false to
 *          allow truncated values (default: true).
 *
 * @return the certificate.
 */ $928e625c51185ebc$var$pki.certificateFromPem = function(pem, computeHash, strict) {
    var msg = $cLQG7.pem.decode(pem)[0];
    if (msg.type !== 'CERTIFICATE' && msg.type !== 'X509 CERTIFICATE' && msg.type !== 'TRUSTED CERTIFICATE') {
        var error = new Error('Could not convert certificate from PEM; PEM header type is not "CERTIFICATE", "X509 CERTIFICATE", or "TRUSTED CERTIFICATE".');
        error.headerType = msg.type;
        throw error;
    }
    if (msg.procType && msg.procType.type === 'ENCRYPTED') throw new Error('Could not convert certificate from PEM; PEM is encrypted.');
    // convert DER to ASN.1 object
    var obj = $928e625c51185ebc$var$asn1.fromDer(msg.body, strict);
    return $928e625c51185ebc$var$pki.certificateFromAsn1(obj, computeHash);
};
/**
 * Converts an X.509 certificate to PEM format.
 *
 * @param cert the certificate.
 * @param maxline the maximum characters per line, defaults to 64.
 *
 * @return the PEM-formatted certificate.
 */ $928e625c51185ebc$var$pki.certificateToPem = function(cert, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var msg = {
        type: 'CERTIFICATE',
        body: $928e625c51185ebc$var$asn1.toDer($928e625c51185ebc$var$pki.certificateToAsn1(cert)).getBytes()
    };
    return $cLQG7.pem.encode(msg, {
        maxline: maxline
    });
};
/**
 * Converts an RSA public key from PEM format.
 *
 * @param pem the PEM-formatted public key.
 *
 * @return the public key.
 */ $928e625c51185ebc$var$pki.publicKeyFromPem = function(pem) {
    var msg = $cLQG7.pem.decode(pem)[0];
    if (msg.type !== 'PUBLIC KEY' && msg.type !== 'RSA PUBLIC KEY') {
        var error = new Error('Could not convert public key from PEM; PEM header type is not "PUBLIC KEY" or "RSA PUBLIC KEY".');
        error.headerType = msg.type;
        throw error;
    }
    if (msg.procType && msg.procType.type === 'ENCRYPTED') throw new Error('Could not convert public key from PEM; PEM is encrypted.');
    // convert DER to ASN.1 object
    var obj = $928e625c51185ebc$var$asn1.fromDer(msg.body);
    return $928e625c51185ebc$var$pki.publicKeyFromAsn1(obj);
};
/**
 * Converts an RSA public key to PEM format (using a SubjectPublicKeyInfo).
 *
 * @param key the public key.
 * @param maxline the maximum characters per line, defaults to 64.
 *
 * @return the PEM-formatted public key.
 */ $928e625c51185ebc$var$pki.publicKeyToPem = function(key, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var msg = {
        type: 'PUBLIC KEY',
        body: $928e625c51185ebc$var$asn1.toDer($928e625c51185ebc$var$pki.publicKeyToAsn1(key)).getBytes()
    };
    return $cLQG7.pem.encode(msg, {
        maxline: maxline
    });
};
/**
 * Converts an RSA public key to PEM format (using an RSAPublicKey).
 *
 * @param key the public key.
 * @param maxline the maximum characters per line, defaults to 64.
 *
 * @return the PEM-formatted public key.
 */ $928e625c51185ebc$var$pki.publicKeyToRSAPublicKeyPem = function(key, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var msg = {
        type: 'RSA PUBLIC KEY',
        body: $928e625c51185ebc$var$asn1.toDer($928e625c51185ebc$var$pki.publicKeyToRSAPublicKey(key)).getBytes()
    };
    return $cLQG7.pem.encode(msg, {
        maxline: maxline
    });
};
/**
 * Gets a fingerprint for the given public key.
 *
 * @param options the options to use.
 *          [md] the message digest object to use (defaults to forge.md.sha1).
 *          [type] the type of fingerprint, such as 'RSAPublicKey',
 *            'SubjectPublicKeyInfo' (defaults to 'RSAPublicKey').
 *          [encoding] an alternative output encoding, such as 'hex'
 *            (defaults to none, outputs a byte buffer).
 *          [delimiter] the delimiter to use between bytes for 'hex' encoded
 *            output, eg: ':' (defaults to none).
 *
 * @return the fingerprint as a byte buffer or other encoding based on options.
 */ $928e625c51185ebc$var$pki.getPublicKeyFingerprint = function(key, options) {
    options = options || {};
    var md = options.md || $cLQG7.md.sha1.create();
    var type = options.type || 'RSAPublicKey';
    var bytes;
    switch(type){
        case 'RSAPublicKey':
            bytes = $928e625c51185ebc$var$asn1.toDer($928e625c51185ebc$var$pki.publicKeyToRSAPublicKey(key)).getBytes();
            break;
        case 'SubjectPublicKeyInfo':
            bytes = $928e625c51185ebc$var$asn1.toDer($928e625c51185ebc$var$pki.publicKeyToAsn1(key)).getBytes();
            break;
        default:
            throw new Error('Unknown fingerprint type "' + options.type + '".');
    }
    // hash public key bytes
    md.start();
    md.update(bytes);
    var digest = md.digest();
    if (options.encoding === 'hex') {
        var hex = digest.toHex();
        if (options.delimiter) return hex.match(/.{2}/g).join(options.delimiter);
        return hex;
    } else if (options.encoding === 'binary') return digest.getBytes();
    else if (options.encoding) throw new Error('Unknown encoding "' + options.encoding + '".');
    return digest;
};
/**
 * Converts a PKCS#10 certification request (CSR) from PEM format.
 *
 * Note: If the certification request is to be verified then compute hash
 * should be set to true. This will scan the CertificationRequestInfo part of
 * the ASN.1 object while it is converted so it doesn't need to be converted
 * back to ASN.1-DER-encoding later.
 *
 * @param pem the PEM-formatted certificate.
 * @param computeHash true to compute the hash for verification.
 * @param strict true to be strict when checking ASN.1 value lengths, false to
 *          allow truncated values (default: true).
 *
 * @return the certification request (CSR).
 */ $928e625c51185ebc$var$pki.certificationRequestFromPem = function(pem, computeHash, strict) {
    var msg = $cLQG7.pem.decode(pem)[0];
    if (msg.type !== 'CERTIFICATE REQUEST') {
        var error = new Error('Could not convert certification request from PEM; PEM header type is not "CERTIFICATE REQUEST".');
        error.headerType = msg.type;
        throw error;
    }
    if (msg.procType && msg.procType.type === 'ENCRYPTED') throw new Error("Could not convert certification request from PEM; PEM is encrypted.");
    // convert DER to ASN.1 object
    var obj = $928e625c51185ebc$var$asn1.fromDer(msg.body, strict);
    return $928e625c51185ebc$var$pki.certificationRequestFromAsn1(obj, computeHash);
};
/**
 * Converts a PKCS#10 certification request (CSR) to PEM format.
 *
 * @param csr the certification request.
 * @param maxline the maximum characters per line, defaults to 64.
 *
 * @return the PEM-formatted certification request.
 */ $928e625c51185ebc$var$pki.certificationRequestToPem = function(csr, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var msg = {
        type: 'CERTIFICATE REQUEST',
        body: $928e625c51185ebc$var$asn1.toDer($928e625c51185ebc$var$pki.certificationRequestToAsn1(csr)).getBytes()
    };
    return $cLQG7.pem.encode(msg, {
        maxline: maxline
    });
};
/**
 * Creates an empty X.509v3 RSA certificate.
 *
 * @return the certificate.
 */ $928e625c51185ebc$var$pki.createCertificate = function() {
    var cert = {};
    cert.version = 0x02;
    cert.serialNumber = '00';
    cert.signatureOid = null;
    cert.signature = null;
    cert.siginfo = {};
    cert.siginfo.algorithmOid = null;
    cert.validity = {};
    cert.validity.notBefore = new Date();
    cert.validity.notAfter = new Date();
    cert.issuer = {};
    cert.issuer.getField = function(sn) {
        return $928e625c51185ebc$var$_getAttribute(cert.issuer, sn);
    };
    cert.issuer.addField = function(attr) {
        $928e625c51185ebc$var$_fillMissingFields([
            attr
        ]);
        cert.issuer.attributes.push(attr);
    };
    cert.issuer.attributes = [];
    cert.issuer.hash = null;
    cert.subject = {};
    cert.subject.getField = function(sn) {
        return $928e625c51185ebc$var$_getAttribute(cert.subject, sn);
    };
    cert.subject.addField = function(attr) {
        $928e625c51185ebc$var$_fillMissingFields([
            attr
        ]);
        cert.subject.attributes.push(attr);
    };
    cert.subject.attributes = [];
    cert.subject.hash = null;
    cert.extensions = [];
    cert.publicKey = null;
    cert.md = null;
    /**
   * Sets the subject of this certificate.
   *
   * @param attrs the array of subject attributes to use.
   * @param uniqueId an optional a unique ID to use.
   */ cert.setSubject = function(attrs, uniqueId) {
        // set new attributes, clear hash
        $928e625c51185ebc$var$_fillMissingFields(attrs);
        cert.subject.attributes = attrs;
        delete cert.subject.uniqueId;
        if (uniqueId) // TODO: support arbitrary bit length ids
        cert.subject.uniqueId = uniqueId;
        cert.subject.hash = null;
    };
    /**
   * Sets the issuer of this certificate.
   *
   * @param attrs the array of issuer attributes to use.
   * @param uniqueId an optional a unique ID to use.
   */ cert.setIssuer = function(attrs, uniqueId) {
        // set new attributes, clear hash
        $928e625c51185ebc$var$_fillMissingFields(attrs);
        cert.issuer.attributes = attrs;
        delete cert.issuer.uniqueId;
        if (uniqueId) // TODO: support arbitrary bit length ids
        cert.issuer.uniqueId = uniqueId;
        cert.issuer.hash = null;
    };
    /**
   * Sets the extensions of this certificate.
   *
   * @param exts the array of extensions to use.
   */ cert.setExtensions = function(exts) {
        for(var i = 0; i < exts.length; ++i)$928e625c51185ebc$var$_fillMissingExtensionFields(exts[i], {
            cert: cert
        });
        // set new extensions
        cert.extensions = exts;
    };
    /**
   * Gets an extension by its name or id.
   *
   * @param options the name to use or an object with:
   *          name the name to use.
   *          id the id to use.
   *
   * @return the extension or null if not found.
   */ cert.getExtension = function(options) {
        if (typeof options === 'string') options = {
            name: options
        };
        var rval = null;
        var ext;
        for(var i = 0; rval === null && i < cert.extensions.length; ++i){
            ext = cert.extensions[i];
            if (options.id && ext.id === options.id) rval = ext;
            else if (options.name && ext.name === options.name) rval = ext;
        }
        return rval;
    };
    /**
   * Signs this certificate using the given private key.
   *
   * @param key the private key to sign with.
   * @param md the message digest object to use (defaults to forge.md.sha1).
   */ cert.sign = function(key, md) {
        // TODO: get signature OID from private key
        cert.md = md || $cLQG7.md.sha1.create();
        var algorithmOid = $928e625c51185ebc$var$oids[cert.md.algorithm + 'WithRSAEncryption'];
        if (!algorithmOid) {
            var error = new Error("Could not compute certificate digest. Unknown message digest algorithm OID.");
            error.algorithm = cert.md.algorithm;
            throw error;
        }
        cert.signatureOid = cert.siginfo.algorithmOid = algorithmOid;
        // get TBSCertificate, convert to DER
        cert.tbsCertificate = $928e625c51185ebc$var$pki.getTBSCertificate(cert);
        var bytes = $928e625c51185ebc$var$asn1.toDer(cert.tbsCertificate);
        // digest and sign
        cert.md.update(bytes.getBytes());
        cert.signature = key.sign(cert.md);
    };
    /**
   * Attempts verify the signature on the passed certificate using this
   * certificate's public key.
   *
   * @param child the certificate to verify.
   *
   * @return true if verified, false if not.
   */ cert.verify = function(child) {
        var rval = false;
        if (!cert.issued(child)) {
            var issuer = child.issuer;
            var subject = cert.subject;
            var error = new Error("The parent certificate did not issue the given child certificate; the child certificate's issuer does not match the parent's subject.");
            error.expectedIssuer = subject.attributes;
            error.actualIssuer = issuer.attributes;
            throw error;
        }
        var md = child.md;
        if (md === null) {
            // create digest for OID signature types
            md = $928e625c51185ebc$var$_createSignatureDigest({
                signatureOid: child.signatureOid,
                type: 'certificate'
            });
            // produce DER formatted TBSCertificate and digest it
            var tbsCertificate = child.tbsCertificate || $928e625c51185ebc$var$pki.getTBSCertificate(child);
            var bytes = $928e625c51185ebc$var$asn1.toDer(tbsCertificate);
            md.update(bytes.getBytes());
        }
        if (md !== null) rval = $928e625c51185ebc$var$_verifySignature({
            certificate: cert,
            md: md,
            signature: child.signature
        });
        return rval;
    };
    /**
   * Returns true if this certificate's issuer matches the passed
   * certificate's subject. Note that no signature check is performed.
   *
   * @param parent the certificate to check.
   *
   * @return true if this certificate's issuer matches the passed certificate's
   *         subject.
   */ cert.isIssuer = function(parent) {
        var rval = false;
        var i = cert.issuer;
        var s = parent.subject;
        // compare hashes if present
        if (i.hash && s.hash) rval = i.hash === s.hash;
        else if (i.attributes.length === s.attributes.length) {
            // all attributes are the same so issuer matches subject
            rval = true;
            var iattr, sattr;
            for(var n = 0; rval && n < i.attributes.length; ++n){
                iattr = i.attributes[n];
                sattr = s.attributes[n];
                if (iattr.type !== sattr.type || iattr.value !== sattr.value) // attribute mismatch
                rval = false;
            }
        }
        return rval;
    };
    /**
   * Returns true if this certificate's subject matches the issuer of the
   * given certificate). Note that not signature check is performed.
   *
   * @param child the certificate to check.
   *
   * @return true if this certificate's subject matches the passed
   *         certificate's issuer.
   */ cert.issued = function(child) {
        return child.isIssuer(cert);
    };
    /**
   * Generates the subjectKeyIdentifier for this certificate as byte buffer.
   *
   * @return the subjectKeyIdentifier for this certificate as byte buffer.
   */ cert.generateSubjectKeyIdentifier = function() {
        /* See: 4.2.1.2 section of the the RFC3280, keyIdentifier is either:

      (1) The keyIdentifier is composed of the 160-bit SHA-1 hash of the
        value of the BIT STRING subjectPublicKey (excluding the tag,
        length, and number of unused bits).

      (2) The keyIdentifier is composed of a four bit type field with
        the value 0100 followed by the least significant 60 bits of the
        SHA-1 hash of the value of the BIT STRING subjectPublicKey
        (excluding the tag, length, and number of unused bit string bits).
    */ // skipping the tag, length, and number of unused bits is the same
        // as just using the RSAPublicKey (for RSA keys, which are the
        // only ones supported)
        return $928e625c51185ebc$var$pki.getPublicKeyFingerprint(cert.publicKey, {
            type: 'RSAPublicKey'
        });
    };
    /**
   * Verifies the subjectKeyIdentifier extension value for this certificate
   * against its public key. If no extension is found, false will be
   * returned.
   *
   * @return true if verified, false if not.
   */ cert.verifySubjectKeyIdentifier = function() {
        var oid = $928e625c51185ebc$var$oids['subjectKeyIdentifier'];
        for(var i = 0; i < cert.extensions.length; ++i){
            var ext = cert.extensions[i];
            if (ext.id === oid) {
                var ski = cert.generateSubjectKeyIdentifier().getBytes();
                return $cLQG7.util.hexToBytes(ext.subjectKeyIdentifier) === ski;
            }
        }
        return false;
    };
    return cert;
};
/**
 * Converts an X.509v3 RSA certificate from an ASN.1 object.
 *
 * Note: If the certificate is to be verified then compute hash should
 * be set to true. There is currently no implementation for converting
 * a certificate back to ASN.1 so the TBSCertificate part of the ASN.1
 * object needs to be scanned before the cert object is created.
 *
 * @param obj the asn1 representation of an X.509v3 RSA certificate.
 * @param computeHash true to compute the hash for verification.
 *
 * @return the certificate.
 */ $928e625c51185ebc$var$pki.certificateFromAsn1 = function(obj, computeHash) {
    // validate certificate and capture data
    var capture = {};
    var errors = [];
    if (!$928e625c51185ebc$var$asn1.validate(obj, $928e625c51185ebc$var$x509CertificateValidator, capture, errors)) {
        var error = new Error("Cannot read X.509 certificate. ASN.1 object is not an X509v3 Certificate.");
        error.errors = errors;
        throw error;
    }
    // get oid
    var oid = $928e625c51185ebc$var$asn1.derToOid(capture.publicKeyOid);
    if (oid !== $928e625c51185ebc$var$pki.oids.rsaEncryption) throw new Error('Cannot read public key. OID is not RSA.');
    // create certificate
    var cert = $928e625c51185ebc$var$pki.createCertificate();
    cert.version = capture.certVersion ? capture.certVersion.charCodeAt(0) : 0;
    var serial = $cLQG7.util.createBuffer(capture.certSerialNumber);
    cert.serialNumber = serial.toHex();
    cert.signatureOid = $cLQG7.asn1.derToOid(capture.certSignatureOid);
    cert.signatureParameters = $928e625c51185ebc$var$_readSignatureParameters(cert.signatureOid, capture.certSignatureParams, true);
    cert.siginfo.algorithmOid = $cLQG7.asn1.derToOid(capture.certinfoSignatureOid);
    cert.siginfo.parameters = $928e625c51185ebc$var$_readSignatureParameters(cert.siginfo.algorithmOid, capture.certinfoSignatureParams, false);
    cert.signature = capture.certSignature;
    var validity = [];
    if (capture.certValidity1UTCTime !== undefined) validity.push($928e625c51185ebc$var$asn1.utcTimeToDate(capture.certValidity1UTCTime));
    if (capture.certValidity2GeneralizedTime !== undefined) validity.push($928e625c51185ebc$var$asn1.generalizedTimeToDate(capture.certValidity2GeneralizedTime));
    if (capture.certValidity3UTCTime !== undefined) validity.push($928e625c51185ebc$var$asn1.utcTimeToDate(capture.certValidity3UTCTime));
    if (capture.certValidity4GeneralizedTime !== undefined) validity.push($928e625c51185ebc$var$asn1.generalizedTimeToDate(capture.certValidity4GeneralizedTime));
    if (validity.length > 2) throw new Error("Cannot read notBefore/notAfter validity times; more than two times were provided in the certificate.");
    if (validity.length < 2) throw new Error("Cannot read notBefore/notAfter validity times; they were not provided as either UTCTime or GeneralizedTime.");
    cert.validity.notBefore = validity[0];
    cert.validity.notAfter = validity[1];
    // keep TBSCertificate to preserve signature when exporting
    cert.tbsCertificate = capture.tbsCertificate;
    if (computeHash) {
        // create digest for OID signature type
        cert.md = $928e625c51185ebc$var$_createSignatureDigest({
            signatureOid: cert.signatureOid,
            type: 'certificate'
        });
        // produce DER formatted TBSCertificate and digest it
        var bytes = $928e625c51185ebc$var$asn1.toDer(cert.tbsCertificate);
        cert.md.update(bytes.getBytes());
    }
    // handle issuer, build issuer message digest
    var imd = $cLQG7.md.sha1.create();
    var ibytes = $928e625c51185ebc$var$asn1.toDer(capture.certIssuer);
    imd.update(ibytes.getBytes());
    cert.issuer.getField = function(sn) {
        return $928e625c51185ebc$var$_getAttribute(cert.issuer, sn);
    };
    cert.issuer.addField = function(attr) {
        $928e625c51185ebc$var$_fillMissingFields([
            attr
        ]);
        cert.issuer.attributes.push(attr);
    };
    cert.issuer.attributes = $928e625c51185ebc$var$pki.RDNAttributesAsArray(capture.certIssuer);
    if (capture.certIssuerUniqueId) cert.issuer.uniqueId = capture.certIssuerUniqueId;
    cert.issuer.hash = imd.digest().toHex();
    // handle subject, build subject message digest
    var smd = $cLQG7.md.sha1.create();
    var sbytes = $928e625c51185ebc$var$asn1.toDer(capture.certSubject);
    smd.update(sbytes.getBytes());
    cert.subject.getField = function(sn) {
        return $928e625c51185ebc$var$_getAttribute(cert.subject, sn);
    };
    cert.subject.addField = function(attr) {
        $928e625c51185ebc$var$_fillMissingFields([
            attr
        ]);
        cert.subject.attributes.push(attr);
    };
    cert.subject.attributes = $928e625c51185ebc$var$pki.RDNAttributesAsArray(capture.certSubject);
    if (capture.certSubjectUniqueId) cert.subject.uniqueId = capture.certSubjectUniqueId;
    cert.subject.hash = smd.digest().toHex();
    // handle extensions
    if (capture.certExtensions) cert.extensions = $928e625c51185ebc$var$pki.certificateExtensionsFromAsn1(capture.certExtensions);
    else cert.extensions = [];
    // convert RSA public key from ASN.1
    cert.publicKey = $928e625c51185ebc$var$pki.publicKeyFromAsn1(capture.subjectPublicKeyInfo);
    return cert;
};
/**
 * Converts an ASN.1 extensions object (with extension sequences as its
 * values) into an array of extension objects with types and values.
 *
 * Supported extensions:
 *
 * id-ce-keyUsage OBJECT IDENTIFIER ::=  { id-ce 15 }
 * KeyUsage ::= BIT STRING {
 *   digitalSignature        (0),
 *   nonRepudiation          (1),
 *   keyEncipherment         (2),
 *   dataEncipherment        (3),
 *   keyAgreement            (4),
 *   keyCertSign             (5),
 *   cRLSign                 (6),
 *   encipherOnly            (7),
 *   decipherOnly            (8)
 * }
 *
 * id-ce-basicConstraints OBJECT IDENTIFIER ::=  { id-ce 19 }
 * BasicConstraints ::= SEQUENCE {
 *   cA                      BOOLEAN DEFAULT FALSE,
 *   pathLenConstraint       INTEGER (0..MAX) OPTIONAL
 * }
 *
 * subjectAltName EXTENSION ::= {
 *   SYNTAX GeneralNames
 *   IDENTIFIED BY id-ce-subjectAltName
 * }
 *
 * GeneralNames ::= SEQUENCE SIZE (1..MAX) OF GeneralName
 *
 * GeneralName ::= CHOICE {
 *   otherName      [0] INSTANCE OF OTHER-NAME,
 *   rfc822Name     [1] IA5String,
 *   dNSName        [2] IA5String,
 *   x400Address    [3] ORAddress,
 *   directoryName  [4] Name,
 *   ediPartyName   [5] EDIPartyName,
 *   uniformResourceIdentifier [6] IA5String,
 *   IPAddress      [7] OCTET STRING,
 *   registeredID   [8] OBJECT IDENTIFIER
 * }
 *
 * OTHER-NAME ::= TYPE-IDENTIFIER
 *
 * EDIPartyName ::= SEQUENCE {
 *   nameAssigner [0] DirectoryString {ub-name} OPTIONAL,
 *   partyName    [1] DirectoryString {ub-name}
 * }
 *
 * @param exts the extensions ASN.1 with extension sequences to parse.
 *
 * @return the array.
 */ $928e625c51185ebc$var$pki.certificateExtensionsFromAsn1 = function(exts) {
    var rval = [];
    for(var i = 0; i < exts.value.length; ++i){
        // get extension sequence
        var extseq = exts.value[i];
        for(var ei = 0; ei < extseq.value.length; ++ei)rval.push($928e625c51185ebc$var$pki.certificateExtensionFromAsn1(extseq.value[ei]));
    }
    return rval;
};
/**
 * Parses a single certificate extension from ASN.1.
 *
 * @param ext the extension in ASN.1 format.
 *
 * @return the parsed extension as an object.
 */ $928e625c51185ebc$var$pki.certificateExtensionFromAsn1 = function(ext) {
    // an extension has:
    // [0] extnID      OBJECT IDENTIFIER
    // [1] critical    BOOLEAN DEFAULT FALSE
    // [2] extnValue   OCTET STRING
    var e = {};
    e.id = $928e625c51185ebc$var$asn1.derToOid(ext.value[0].value);
    e.critical = false;
    if (ext.value[1].type === $928e625c51185ebc$var$asn1.Type.BOOLEAN) {
        e.critical = ext.value[1].value.charCodeAt(0) !== 0x00;
        e.value = ext.value[2].value;
    } else e.value = ext.value[1].value;
    // if the oid is known, get its name
    if (e.id in $928e625c51185ebc$var$oids) {
        e.name = $928e625c51185ebc$var$oids[e.id];
        // handle key usage
        if (e.name === 'keyUsage') {
            // get value as BIT STRING
            var ev = $928e625c51185ebc$var$asn1.fromDer(e.value);
            var b2 = 0x00;
            var b3 = 0x00;
            if (ev.value.length > 1) {
                // skip first byte, just indicates unused bits which
                // will be padded with 0s anyway
                // get bytes with flag bits
                b2 = ev.value.charCodeAt(1);
                b3 = ev.value.length > 2 ? ev.value.charCodeAt(2) : 0;
            }
            // set flags
            e.digitalSignature = (b2 & 0x80) === 0x80;
            e.nonRepudiation = (b2 & 0x40) === 0x40;
            e.keyEncipherment = (b2 & 0x20) === 0x20;
            e.dataEncipherment = (b2 & 0x10) === 0x10;
            e.keyAgreement = (b2 & 0x08) === 0x08;
            e.keyCertSign = (b2 & 0x04) === 0x04;
            e.cRLSign = (b2 & 0x02) === 0x02;
            e.encipherOnly = (b2 & 0x01) === 0x01;
            e.decipherOnly = (b3 & 0x80) === 0x80;
        } else if (e.name === 'basicConstraints') {
            // handle basic constraints
            // get value as SEQUENCE
            var ev = $928e625c51185ebc$var$asn1.fromDer(e.value);
            // get cA BOOLEAN flag (defaults to false)
            if (ev.value.length > 0 && ev.value[0].type === $928e625c51185ebc$var$asn1.Type.BOOLEAN) e.cA = ev.value[0].value.charCodeAt(0) !== 0x00;
            else e.cA = false;
            // get path length constraint
            var value = null;
            if (ev.value.length > 0 && ev.value[0].type === $928e625c51185ebc$var$asn1.Type.INTEGER) value = ev.value[0].value;
            else if (ev.value.length > 1) value = ev.value[1].value;
            if (value !== null) e.pathLenConstraint = $928e625c51185ebc$var$asn1.derToInteger(value);
        } else if (e.name === 'extKeyUsage') {
            // handle extKeyUsage
            // value is a SEQUENCE of OIDs
            var ev = $928e625c51185ebc$var$asn1.fromDer(e.value);
            for(var vi = 0; vi < ev.value.length; ++vi){
                var oid = $928e625c51185ebc$var$asn1.derToOid(ev.value[vi].value);
                if (oid in $928e625c51185ebc$var$oids) e[$928e625c51185ebc$var$oids[oid]] = true;
                else e[oid] = true;
            }
        } else if (e.name === 'nsCertType') {
            // handle nsCertType
            // get value as BIT STRING
            var ev = $928e625c51185ebc$var$asn1.fromDer(e.value);
            var b2 = 0x00;
            if (ev.value.length > 1) // skip first byte, just indicates unused bits which
            // will be padded with 0s anyway
            // get bytes with flag bits
            b2 = ev.value.charCodeAt(1);
            // set flags
            e.client = (b2 & 0x80) === 0x80;
            e.server = (b2 & 0x40) === 0x40;
            e.email = (b2 & 0x20) === 0x20;
            e.objsign = (b2 & 0x10) === 0x10;
            e.reserved = (b2 & 0x08) === 0x08;
            e.sslCA = (b2 & 0x04) === 0x04;
            e.emailCA = (b2 & 0x02) === 0x02;
            e.objCA = (b2 & 0x01) === 0x01;
        } else if (e.name === 'subjectAltName' || e.name === 'issuerAltName') {
            // handle subjectAltName/issuerAltName
            e.altNames = [];
            // ev is a SYNTAX SEQUENCE
            var gn;
            var ev = $928e625c51185ebc$var$asn1.fromDer(e.value);
            for(var n = 0; n < ev.value.length; ++n){
                // get GeneralName
                gn = ev.value[n];
                var altName = {
                    type: gn.type,
                    value: gn.value
                };
                e.altNames.push(altName);
                // Note: Support for types 1,2,6,7,8
                switch(gn.type){
                    // rfc822Name
                    case 1:
                    // dNSName
                    case 2:
                    // uniformResourceIdentifier (URI)
                    case 6:
                        break;
                    // IPAddress
                    case 7:
                        // convert to IPv4/IPv6 string representation
                        altName.ip = $cLQG7.util.bytesToIP(gn.value);
                        break;
                    // registeredID
                    case 8:
                        altName.oid = $928e625c51185ebc$var$asn1.derToOid(gn.value);
                        break;
                    default:
                }
            }
        } else if (e.name === 'subjectKeyIdentifier') {
            // value is an OCTETSTRING w/the hash of the key-type specific
            // public key structure (eg: RSAPublicKey)
            var ev = $928e625c51185ebc$var$asn1.fromDer(e.value);
            e.subjectKeyIdentifier = $cLQG7.util.bytesToHex(ev.value);
        }
    }
    return e;
};
/**
 * Converts a PKCS#10 certification request (CSR) from an ASN.1 object.
 *
 * Note: If the certification request is to be verified then compute hash
 * should be set to true. There is currently no implementation for converting
 * a certificate back to ASN.1 so the CertificationRequestInfo part of the
 * ASN.1 object needs to be scanned before the csr object is created.
 *
 * @param obj the asn1 representation of a PKCS#10 certification request (CSR).
 * @param computeHash true to compute the hash for verification.
 *
 * @return the certification request (CSR).
 */ $928e625c51185ebc$var$pki.certificationRequestFromAsn1 = function(obj, computeHash) {
    // validate certification request and capture data
    var capture = {};
    var errors = [];
    if (!$928e625c51185ebc$var$asn1.validate(obj, $928e625c51185ebc$var$certificationRequestValidator, capture, errors)) {
        var error = new Error("Cannot read PKCS#10 certificate request. ASN.1 object is not a PKCS#10 CertificationRequest.");
        error.errors = errors;
        throw error;
    }
    // get oid
    var oid = $928e625c51185ebc$var$asn1.derToOid(capture.publicKeyOid);
    if (oid !== $928e625c51185ebc$var$pki.oids.rsaEncryption) throw new Error('Cannot read public key. OID is not RSA.');
    // create certification request
    var csr = $928e625c51185ebc$var$pki.createCertificationRequest();
    csr.version = capture.csrVersion ? capture.csrVersion.charCodeAt(0) : 0;
    csr.signatureOid = $cLQG7.asn1.derToOid(capture.csrSignatureOid);
    csr.signatureParameters = $928e625c51185ebc$var$_readSignatureParameters(csr.signatureOid, capture.csrSignatureParams, true);
    csr.siginfo.algorithmOid = $cLQG7.asn1.derToOid(capture.csrSignatureOid);
    csr.siginfo.parameters = $928e625c51185ebc$var$_readSignatureParameters(csr.siginfo.algorithmOid, capture.csrSignatureParams, false);
    csr.signature = capture.csrSignature;
    // keep CertificationRequestInfo to preserve signature when exporting
    csr.certificationRequestInfo = capture.certificationRequestInfo;
    if (computeHash) {
        // create digest for OID signature type
        csr.md = $928e625c51185ebc$var$_createSignatureDigest({
            signatureOid: csr.signatureOid,
            type: 'certification request'
        });
        // produce DER formatted CertificationRequestInfo and digest it
        var bytes = $928e625c51185ebc$var$asn1.toDer(csr.certificationRequestInfo);
        csr.md.update(bytes.getBytes());
    }
    // handle subject, build subject message digest
    var smd = $cLQG7.md.sha1.create();
    csr.subject.getField = function(sn) {
        return $928e625c51185ebc$var$_getAttribute(csr.subject, sn);
    };
    csr.subject.addField = function(attr) {
        $928e625c51185ebc$var$_fillMissingFields([
            attr
        ]);
        csr.subject.attributes.push(attr);
    };
    csr.subject.attributes = $928e625c51185ebc$var$pki.RDNAttributesAsArray(capture.certificationRequestInfoSubject, smd);
    csr.subject.hash = smd.digest().toHex();
    // convert RSA public key from ASN.1
    csr.publicKey = $928e625c51185ebc$var$pki.publicKeyFromAsn1(capture.subjectPublicKeyInfo);
    // convert attributes from ASN.1
    csr.getAttribute = function(sn) {
        return $928e625c51185ebc$var$_getAttribute(csr, sn);
    };
    csr.addAttribute = function(attr) {
        $928e625c51185ebc$var$_fillMissingFields([
            attr
        ]);
        csr.attributes.push(attr);
    };
    csr.attributes = $928e625c51185ebc$var$pki.CRIAttributesAsArray(capture.certificationRequestInfoAttributes || []);
    return csr;
};
/**
 * Creates an empty certification request (a CSR or certificate signing
 * request). Once created, its public key and attributes can be set and then
 * it can be signed.
 *
 * @return the empty certification request.
 */ $928e625c51185ebc$var$pki.createCertificationRequest = function() {
    var csr = {};
    csr.version = 0x00;
    csr.signatureOid = null;
    csr.signature = null;
    csr.siginfo = {};
    csr.siginfo.algorithmOid = null;
    csr.subject = {};
    csr.subject.getField = function(sn) {
        return $928e625c51185ebc$var$_getAttribute(csr.subject, sn);
    };
    csr.subject.addField = function(attr) {
        $928e625c51185ebc$var$_fillMissingFields([
            attr
        ]);
        csr.subject.attributes.push(attr);
    };
    csr.subject.attributes = [];
    csr.subject.hash = null;
    csr.publicKey = null;
    csr.attributes = [];
    csr.getAttribute = function(sn) {
        return $928e625c51185ebc$var$_getAttribute(csr, sn);
    };
    csr.addAttribute = function(attr) {
        $928e625c51185ebc$var$_fillMissingFields([
            attr
        ]);
        csr.attributes.push(attr);
    };
    csr.md = null;
    /**
   * Sets the subject of this certification request.
   *
   * @param attrs the array of subject attributes to use.
   */ csr.setSubject = function(attrs) {
        // set new attributes
        $928e625c51185ebc$var$_fillMissingFields(attrs);
        csr.subject.attributes = attrs;
        csr.subject.hash = null;
    };
    /**
   * Sets the attributes of this certification request.
   *
   * @param attrs the array of attributes to use.
   */ csr.setAttributes = function(attrs) {
        // set new attributes
        $928e625c51185ebc$var$_fillMissingFields(attrs);
        csr.attributes = attrs;
    };
    /**
   * Signs this certification request using the given private key.
   *
   * @param key the private key to sign with.
   * @param md the message digest object to use (defaults to forge.md.sha1).
   */ csr.sign = function(key, md) {
        // TODO: get signature OID from private key
        csr.md = md || $cLQG7.md.sha1.create();
        var algorithmOid = $928e625c51185ebc$var$oids[csr.md.algorithm + 'WithRSAEncryption'];
        if (!algorithmOid) {
            var error = new Error("Could not compute certification request digest. Unknown message digest algorithm OID.");
            error.algorithm = csr.md.algorithm;
            throw error;
        }
        csr.signatureOid = csr.siginfo.algorithmOid = algorithmOid;
        // get CertificationRequestInfo, convert to DER
        csr.certificationRequestInfo = $928e625c51185ebc$var$pki.getCertificationRequestInfo(csr);
        var bytes = $928e625c51185ebc$var$asn1.toDer(csr.certificationRequestInfo);
        // digest and sign
        csr.md.update(bytes.getBytes());
        csr.signature = key.sign(csr.md);
    };
    /**
   * Attempts verify the signature on the passed certification request using
   * its public key.
   *
   * A CSR that has been exported to a file in PEM format can be verified using
   * OpenSSL using this command:
   *
   * openssl req -in <the-csr-pem-file> -verify -noout -text
   *
   * @return true if verified, false if not.
   */ csr.verify = function() {
        var rval = false;
        var md = csr.md;
        if (md === null) {
            md = $928e625c51185ebc$var$_createSignatureDigest({
                signatureOid: csr.signatureOid,
                type: 'certification request'
            });
            // produce DER formatted CertificationRequestInfo and digest it
            var cri = csr.certificationRequestInfo || $928e625c51185ebc$var$pki.getCertificationRequestInfo(csr);
            var bytes = $928e625c51185ebc$var$asn1.toDer(cri);
            md.update(bytes.getBytes());
        }
        if (md !== null) rval = $928e625c51185ebc$var$_verifySignature({
            certificate: csr,
            md: md,
            signature: csr.signature
        });
        return rval;
    };
    return csr;
};
/**
 * Converts an X.509 subject or issuer to an ASN.1 RDNSequence.
 *
 * @param obj the subject or issuer (distinguished name).
 *
 * @return the ASN.1 RDNSequence.
 */ function $928e625c51185ebc$var$_dnToAsn1(obj) {
    // create an empty RDNSequence
    var rval = $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.SEQUENCE, true, []);
    // iterate over attributes
    var attr, set;
    var attrs = obj.attributes;
    for(var i = 0; i < attrs.length; ++i){
        attr = attrs[i];
        var value = attr.value;
        // reuse tag class for attribute value if available
        var valueTagClass = $928e625c51185ebc$var$asn1.Type.PRINTABLESTRING;
        if ('valueTagClass' in attr) {
            valueTagClass = attr.valueTagClass;
            if (valueTagClass === $928e625c51185ebc$var$asn1.Type.UTF8) value = $cLQG7.util.encodeUtf8(value);
        // FIXME: handle more encodings
        }
        // create a RelativeDistinguishedName set
        // each value in the set is an AttributeTypeAndValue first
        // containing the type (an OID) and second the value
        set = $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.SET, true, [
            $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.SEQUENCE, true, [
                // AttributeType
                $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.OID, false, $928e625c51185ebc$var$asn1.oidToDer(attr.type).getBytes()),
                // AttributeValue
                $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, valueTagClass, false, value)
            ])
        ]);
        rval.value.push(set);
    }
    return rval;
}
/**
 * Gets all printable attributes (typically of an issuer or subject) in a
 * simplified JSON format for display.
 *
 * @param attrs the attributes.
 *
 * @return the JSON for display.
 */ function $928e625c51185ebc$var$_getAttributesAsJson(attrs) {
    var rval = {};
    for(var i = 0; i < attrs.length; ++i){
        var attr = attrs[i];
        if (attr.shortName && (attr.valueTagClass === $928e625c51185ebc$var$asn1.Type.UTF8 || attr.valueTagClass === $928e625c51185ebc$var$asn1.Type.PRINTABLESTRING || attr.valueTagClass === $928e625c51185ebc$var$asn1.Type.IA5STRING)) {
            var value = attr.value;
            if (attr.valueTagClass === $928e625c51185ebc$var$asn1.Type.UTF8) value = $cLQG7.util.encodeUtf8(attr.value);
            if (!(attr.shortName in rval)) rval[attr.shortName] = value;
            else if ($cLQG7.util.isArray(rval[attr.shortName])) rval[attr.shortName].push(value);
            else rval[attr.shortName] = [
                rval[attr.shortName],
                value
            ];
        }
    }
    return rval;
}
/**
 * Fills in missing fields in attributes.
 *
 * @param attrs the attributes to fill missing fields in.
 */ function $928e625c51185ebc$var$_fillMissingFields(attrs) {
    var attr;
    for(var i = 0; i < attrs.length; ++i){
        attr = attrs[i];
        // populate missing name
        if (typeof attr.name === 'undefined') {
            if (attr.type && attr.type in $928e625c51185ebc$var$pki.oids) attr.name = $928e625c51185ebc$var$pki.oids[attr.type];
            else if (attr.shortName && attr.shortName in $928e625c51185ebc$var$_shortNames) attr.name = $928e625c51185ebc$var$pki.oids[$928e625c51185ebc$var$_shortNames[attr.shortName]];
        }
        // populate missing type (OID)
        if (typeof attr.type === 'undefined') {
            if (attr.name && attr.name in $928e625c51185ebc$var$pki.oids) attr.type = $928e625c51185ebc$var$pki.oids[attr.name];
            else {
                var error = new Error('Attribute type not specified.');
                error.attribute = attr;
                throw error;
            }
        }
        // populate missing shortname
        if (typeof attr.shortName === 'undefined') {
            if (attr.name && attr.name in $928e625c51185ebc$var$_shortNames) attr.shortName = $928e625c51185ebc$var$_shortNames[attr.name];
        }
        // convert extensions to value
        if (attr.type === $928e625c51185ebc$var$oids.extensionRequest) {
            attr.valueConstructed = true;
            attr.valueTagClass = $928e625c51185ebc$var$asn1.Type.SEQUENCE;
            if (!attr.value && attr.extensions) {
                attr.value = [];
                for(var ei = 0; ei < attr.extensions.length; ++ei)attr.value.push($928e625c51185ebc$var$pki.certificateExtensionToAsn1($928e625c51185ebc$var$_fillMissingExtensionFields(attr.extensions[ei])));
            }
        }
        if (typeof attr.value === 'undefined') {
            var error = new Error('Attribute value not specified.');
            error.attribute = attr;
            throw error;
        }
    }
}
/**
 * Fills in missing fields in certificate extensions.
 *
 * @param e the extension.
 * @param [options] the options to use.
 *          [cert] the certificate the extensions are for.
 *
 * @return the extension.
 */ function $928e625c51185ebc$var$_fillMissingExtensionFields(e, options) {
    options = options || {};
    // populate missing name
    if (typeof e.name === 'undefined') {
        if (e.id && e.id in $928e625c51185ebc$var$pki.oids) e.name = $928e625c51185ebc$var$pki.oids[e.id];
    }
    // populate missing id
    if (typeof e.id === 'undefined') {
        if (e.name && e.name in $928e625c51185ebc$var$pki.oids) e.id = $928e625c51185ebc$var$pki.oids[e.name];
        else {
            var error = new Error('Extension ID not specified.');
            error.extension = e;
            throw error;
        }
    }
    if (typeof e.value !== 'undefined') return e;
    // handle missing value:
    // value is a BIT STRING
    if (e.name === 'keyUsage') {
        // build flags
        var unused = 0;
        var b2 = 0x00;
        var b3 = 0x00;
        if (e.digitalSignature) {
            b2 |= 0x80;
            unused = 7;
        }
        if (e.nonRepudiation) {
            b2 |= 0x40;
            unused = 6;
        }
        if (e.keyEncipherment) {
            b2 |= 0x20;
            unused = 5;
        }
        if (e.dataEncipherment) {
            b2 |= 0x10;
            unused = 4;
        }
        if (e.keyAgreement) {
            b2 |= 0x08;
            unused = 3;
        }
        if (e.keyCertSign) {
            b2 |= 0x04;
            unused = 2;
        }
        if (e.cRLSign) {
            b2 |= 0x02;
            unused = 1;
        }
        if (e.encipherOnly) {
            b2 |= 0x01;
            unused = 0;
        }
        if (e.decipherOnly) {
            b3 |= 0x80;
            unused = 7;
        }
        // create bit string
        var value = String.fromCharCode(unused);
        if (b3 !== 0) value += String.fromCharCode(b2) + String.fromCharCode(b3);
        else if (b2 !== 0) value += String.fromCharCode(b2);
        e.value = $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.BITSTRING, false, value);
    } else if (e.name === 'basicConstraints') {
        // basicConstraints is a SEQUENCE
        e.value = $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.SEQUENCE, true, []);
        // cA BOOLEAN flag defaults to false
        if (e.cA) e.value.value.push($928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.BOOLEAN, false, String.fromCharCode(0xFF)));
        if ('pathLenConstraint' in e) e.value.value.push($928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.INTEGER, false, $928e625c51185ebc$var$asn1.integerToDer(e.pathLenConstraint).getBytes()));
    } else if (e.name === 'extKeyUsage') {
        // extKeyUsage is a SEQUENCE of OIDs
        e.value = $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.SEQUENCE, true, []);
        var seq = e.value.value;
        for(var key in e){
            if (e[key] !== true) continue;
            // key is name in OID map
            if (key in $928e625c51185ebc$var$oids) seq.push($928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.OID, false, $928e625c51185ebc$var$asn1.oidToDer($928e625c51185ebc$var$oids[key]).getBytes()));
            else if (key.indexOf('.') !== -1) // assume key is an OID
            seq.push($928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.OID, false, $928e625c51185ebc$var$asn1.oidToDer(key).getBytes()));
        }
    } else if (e.name === 'nsCertType') {
        // nsCertType is a BIT STRING
        // build flags
        var unused = 0;
        var b2 = 0x00;
        if (e.client) {
            b2 |= 0x80;
            unused = 7;
        }
        if (e.server) {
            b2 |= 0x40;
            unused = 6;
        }
        if (e.email) {
            b2 |= 0x20;
            unused = 5;
        }
        if (e.objsign) {
            b2 |= 0x10;
            unused = 4;
        }
        if (e.reserved) {
            b2 |= 0x08;
            unused = 3;
        }
        if (e.sslCA) {
            b2 |= 0x04;
            unused = 2;
        }
        if (e.emailCA) {
            b2 |= 0x02;
            unused = 1;
        }
        if (e.objCA) {
            b2 |= 0x01;
            unused = 0;
        }
        // create bit string
        var value = String.fromCharCode(unused);
        if (b2 !== 0) value += String.fromCharCode(b2);
        e.value = $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.BITSTRING, false, value);
    } else if (e.name === 'subjectAltName' || e.name === 'issuerAltName') {
        // SYNTAX SEQUENCE
        e.value = $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.SEQUENCE, true, []);
        var altName;
        for(var n = 0; n < e.altNames.length; ++n){
            altName = e.altNames[n];
            var value = altName.value;
            // handle IP
            if (altName.type === 7 && altName.ip) {
                value = $cLQG7.util.bytesFromIP(altName.ip);
                if (value === null) {
                    var error = new Error('Extension "ip" value is not a valid IPv4 or IPv6 address.');
                    error.extension = e;
                    throw error;
                }
            } else if (altName.type === 8) {
                // handle OID
                if (altName.oid) value = $928e625c51185ebc$var$asn1.oidToDer($928e625c51185ebc$var$asn1.oidToDer(altName.oid));
                else // deprecated ... convert value to OID
                value = $928e625c51185ebc$var$asn1.oidToDer(value);
            }
            e.value.value.push($928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.CONTEXT_SPECIFIC, altName.type, false, value));
        }
    } else if (e.name === 'nsComment' && options.cert) {
        // sanity check value is ASCII (req'd) and not too big
        if (!/^[\x00-\x7F]*$/.test(e.comment) || e.comment.length < 1 || e.comment.length > 128) throw new Error('Invalid "nsComment" content.');
        // IA5STRING opaque comment
        e.value = $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.IA5STRING, false, e.comment);
    } else if (e.name === 'subjectKeyIdentifier' && options.cert) {
        var ski = options.cert.generateSubjectKeyIdentifier();
        e.subjectKeyIdentifier = ski.toHex();
        // OCTETSTRING w/digest
        e.value = $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.OCTETSTRING, false, ski.getBytes());
    } else if (e.name === 'authorityKeyIdentifier' && options.cert) {
        // SYNTAX SEQUENCE
        e.value = $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.SEQUENCE, true, []);
        var seq = e.value.value;
        if (e.keyIdentifier) {
            var keyIdentifier = e.keyIdentifier === true ? options.cert.generateSubjectKeyIdentifier().getBytes() : e.keyIdentifier;
            seq.push($928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.CONTEXT_SPECIFIC, 0, false, keyIdentifier));
        }
        if (e.authorityCertIssuer) {
            var authorityCertIssuer = [
                $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.CONTEXT_SPECIFIC, 4, true, [
                    $928e625c51185ebc$var$_dnToAsn1(e.authorityCertIssuer === true ? options.cert.issuer : e.authorityCertIssuer)
                ])
            ];
            seq.push($928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.CONTEXT_SPECIFIC, 1, true, authorityCertIssuer));
        }
        if (e.serialNumber) {
            var serialNumber = $cLQG7.util.hexToBytes(e.serialNumber === true ? options.cert.serialNumber : e.serialNumber);
            seq.push($928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.CONTEXT_SPECIFIC, 2, false, serialNumber));
        }
    } else if (e.name === 'cRLDistributionPoints') {
        e.value = $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.SEQUENCE, true, []);
        var seq = e.value.value;
        // Create sub SEQUENCE of DistributionPointName
        var subSeq = $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.SEQUENCE, true, []);
        // Create fullName CHOICE
        var fullNameGeneralNames = $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, []);
        var altName;
        for(var n = 0; n < e.altNames.length; ++n){
            altName = e.altNames[n];
            var value = altName.value;
            // handle IP
            if (altName.type === 7 && altName.ip) {
                value = $cLQG7.util.bytesFromIP(altName.ip);
                if (value === null) {
                    var error = new Error('Extension "ip" value is not a valid IPv4 or IPv6 address.');
                    error.extension = e;
                    throw error;
                }
            } else if (altName.type === 8) {
                // handle OID
                if (altName.oid) value = $928e625c51185ebc$var$asn1.oidToDer($928e625c51185ebc$var$asn1.oidToDer(altName.oid));
                else // deprecated ... convert value to OID
                value = $928e625c51185ebc$var$asn1.oidToDer(value);
            }
            fullNameGeneralNames.value.push($928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.CONTEXT_SPECIFIC, altName.type, false, value));
        }
        // Add to the parent SEQUENCE
        subSeq.value.push($928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
            fullNameGeneralNames
        ]));
        seq.push(subSeq);
    }
    // ensure value has been defined by now
    if (typeof e.value === 'undefined') {
        var error = new Error('Extension value not specified.');
        error.extension = e;
        throw error;
    }
    return e;
}
/**
 * Convert signature parameters object to ASN.1
 *
 * @param {String} oid Signature algorithm OID
 * @param params The signature parametrs object
 * @return ASN.1 object representing signature parameters
 */ function $928e625c51185ebc$var$_signatureParametersToAsn1(oid, params) {
    switch(oid){
        case $928e625c51185ebc$var$oids['RSASSA-PSS']:
            var parts = [];
            if (params.hash.algorithmOid !== undefined) parts.push($928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.SEQUENCE, true, [
                    $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.OID, false, $928e625c51185ebc$var$asn1.oidToDer(params.hash.algorithmOid).getBytes()),
                    $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.NULL, false, '')
                ])
            ]));
            if (params.mgf.algorithmOid !== undefined) parts.push($928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.CONTEXT_SPECIFIC, 1, true, [
                $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.SEQUENCE, true, [
                    $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.OID, false, $928e625c51185ebc$var$asn1.oidToDer(params.mgf.algorithmOid).getBytes()),
                    $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.SEQUENCE, true, [
                        $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.OID, false, $928e625c51185ebc$var$asn1.oidToDer(params.mgf.hash.algorithmOid).getBytes()),
                        $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.NULL, false, '')
                    ])
                ])
            ]));
            if (params.saltLength !== undefined) parts.push($928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.CONTEXT_SPECIFIC, 2, true, [
                $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.INTEGER, false, $928e625c51185ebc$var$asn1.integerToDer(params.saltLength).getBytes())
            ]));
            return $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.SEQUENCE, true, parts);
        default:
            return $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.NULL, false, '');
    }
}
/**
 * Converts a certification request's attributes to an ASN.1 set of
 * CRIAttributes.
 *
 * @param csr certification request.
 *
 * @return the ASN.1 set of CRIAttributes.
 */ function $928e625c51185ebc$var$_CRIAttributesToAsn1(csr) {
    // create an empty context-specific container
    var rval = $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, []);
    // no attributes, return empty container
    if (csr.attributes.length === 0) return rval;
    // each attribute has a sequence with a type and a set of values
    var attrs = csr.attributes;
    for(var i = 0; i < attrs.length; ++i){
        var attr = attrs[i];
        var value = attr.value;
        // reuse tag class for attribute value if available
        var valueTagClass = $928e625c51185ebc$var$asn1.Type.UTF8;
        if ('valueTagClass' in attr) valueTagClass = attr.valueTagClass;
        if (valueTagClass === $928e625c51185ebc$var$asn1.Type.UTF8) value = $cLQG7.util.encodeUtf8(value);
        var valueConstructed = false;
        if ('valueConstructed' in attr) valueConstructed = attr.valueConstructed;
        // FIXME: handle more encodings
        // create a RelativeDistinguishedName set
        // each value in the set is an AttributeTypeAndValue first
        // containing the type (an OID) and second the value
        var seq = $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.SEQUENCE, true, [
            // AttributeType
            $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.OID, false, $928e625c51185ebc$var$asn1.oidToDer(attr.type).getBytes()),
            $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.SET, true, [
                // AttributeValue
                $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, valueTagClass, valueConstructed, value)
            ])
        ]);
        rval.value.push(seq);
    }
    return rval;
}
var $928e625c51185ebc$var$jan_1_1950 = new Date('1950-01-01T00:00:00Z');
var $928e625c51185ebc$var$jan_1_2050 = new Date('2050-01-01T00:00:00Z');
/**
 * Converts a Date object to ASN.1
 * Handles the different format before and after 1st January 2050
 *
 * @param date date object.
 *
 * @return the ASN.1 object representing the date.
 */ function $928e625c51185ebc$var$_dateToAsn1(date) {
    if (date >= $928e625c51185ebc$var$jan_1_1950 && date < $928e625c51185ebc$var$jan_1_2050) return $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.UTCTIME, false, $928e625c51185ebc$var$asn1.dateToUtcTime(date));
    else return $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.GENERALIZEDTIME, false, $928e625c51185ebc$var$asn1.dateToGeneralizedTime(date));
}
/**
 * Gets the ASN.1 TBSCertificate part of an X.509v3 certificate.
 *
 * @param cert the certificate.
 *
 * @return the asn1 TBSCertificate.
 */ $928e625c51185ebc$var$pki.getTBSCertificate = function(cert) {
    // TBSCertificate
    var notBefore = $928e625c51185ebc$var$_dateToAsn1(cert.validity.notBefore);
    var notAfter = $928e625c51185ebc$var$_dateToAsn1(cert.validity.notAfter);
    var tbs = $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.SEQUENCE, true, [
        // version
        $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
            // integer
            $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.INTEGER, false, $928e625c51185ebc$var$asn1.integerToDer(cert.version).getBytes())
        ]),
        // serialNumber
        $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.INTEGER, false, $cLQG7.util.hexToBytes(cert.serialNumber)),
        // signature
        $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.SEQUENCE, true, [
            // algorithm
            $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.OID, false, $928e625c51185ebc$var$asn1.oidToDer(cert.siginfo.algorithmOid).getBytes()),
            // parameters
            $928e625c51185ebc$var$_signatureParametersToAsn1(cert.siginfo.algorithmOid, cert.siginfo.parameters)
        ]),
        // issuer
        $928e625c51185ebc$var$_dnToAsn1(cert.issuer),
        // validity
        $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.SEQUENCE, true, [
            notBefore,
            notAfter
        ]),
        // subject
        $928e625c51185ebc$var$_dnToAsn1(cert.subject),
        // SubjectPublicKeyInfo
        $928e625c51185ebc$var$pki.publicKeyToAsn1(cert.publicKey)
    ]);
    if (cert.issuer.uniqueId) // issuerUniqueID (optional)
    tbs.value.push($928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.CONTEXT_SPECIFIC, 1, true, [
        $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.BITSTRING, false, // TODO: support arbitrary bit length ids
        String.fromCharCode(0x00) + cert.issuer.uniqueId)
    ]));
    if (cert.subject.uniqueId) // subjectUniqueID (optional)
    tbs.value.push($928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.CONTEXT_SPECIFIC, 2, true, [
        $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.BITSTRING, false, // TODO: support arbitrary bit length ids
        String.fromCharCode(0x00) + cert.subject.uniqueId)
    ]));
    if (cert.extensions.length > 0) // extensions (optional)
    tbs.value.push($928e625c51185ebc$var$pki.certificateExtensionsToAsn1(cert.extensions));
    return tbs;
};
/**
 * Gets the ASN.1 CertificationRequestInfo part of a
 * PKCS#10 CertificationRequest.
 *
 * @param csr the certification request.
 *
 * @return the asn1 CertificationRequestInfo.
 */ $928e625c51185ebc$var$pki.getCertificationRequestInfo = function(csr) {
    // CertificationRequestInfo
    var cri = $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.SEQUENCE, true, [
        // version
        $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.INTEGER, false, $928e625c51185ebc$var$asn1.integerToDer(csr.version).getBytes()),
        // subject
        $928e625c51185ebc$var$_dnToAsn1(csr.subject),
        // SubjectPublicKeyInfo
        $928e625c51185ebc$var$pki.publicKeyToAsn1(csr.publicKey),
        // attributes
        $928e625c51185ebc$var$_CRIAttributesToAsn1(csr)
    ]);
    return cri;
};
/**
 * Converts a DistinguishedName (subject or issuer) to an ASN.1 object.
 *
 * @param dn the DistinguishedName.
 *
 * @return the asn1 representation of a DistinguishedName.
 */ $928e625c51185ebc$var$pki.distinguishedNameToAsn1 = function(dn) {
    return $928e625c51185ebc$var$_dnToAsn1(dn);
};
/**
 * Converts an X.509v3 RSA certificate to an ASN.1 object.
 *
 * @param cert the certificate.
 *
 * @return the asn1 representation of an X.509v3 RSA certificate.
 */ $928e625c51185ebc$var$pki.certificateToAsn1 = function(cert) {
    // prefer cached TBSCertificate over generating one
    var tbsCertificate = cert.tbsCertificate || $928e625c51185ebc$var$pki.getTBSCertificate(cert);
    // Certificate
    return $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.SEQUENCE, true, [
        // TBSCertificate
        tbsCertificate,
        // AlgorithmIdentifier (signature algorithm)
        $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.SEQUENCE, true, [
            // algorithm
            $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.OID, false, $928e625c51185ebc$var$asn1.oidToDer(cert.signatureOid).getBytes()),
            // parameters
            $928e625c51185ebc$var$_signatureParametersToAsn1(cert.signatureOid, cert.signatureParameters)
        ]),
        // SignatureValue
        $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.BITSTRING, false, String.fromCharCode(0x00) + cert.signature)
    ]);
};
/**
 * Converts X.509v3 certificate extensions to ASN.1.
 *
 * @param exts the extensions to convert.
 *
 * @return the extensions in ASN.1 format.
 */ $928e625c51185ebc$var$pki.certificateExtensionsToAsn1 = function(exts) {
    // create top-level extension container
    var rval = $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.CONTEXT_SPECIFIC, 3, true, []);
    // create extension sequence (stores a sequence for each extension)
    var seq = $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.SEQUENCE, true, []);
    rval.value.push(seq);
    for(var i = 0; i < exts.length; ++i)seq.value.push($928e625c51185ebc$var$pki.certificateExtensionToAsn1(exts[i]));
    return rval;
};
/**
 * Converts a single certificate extension to ASN.1.
 *
 * @param ext the extension to convert.
 *
 * @return the extension in ASN.1 format.
 */ $928e625c51185ebc$var$pki.certificateExtensionToAsn1 = function(ext) {
    // create a sequence for each extension
    var extseq = $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.SEQUENCE, true, []);
    // extnID (OID)
    extseq.value.push($928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.OID, false, $928e625c51185ebc$var$asn1.oidToDer(ext.id).getBytes()));
    // critical defaults to false
    if (ext.critical) // critical BOOLEAN DEFAULT FALSE
    extseq.value.push($928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.BOOLEAN, false, String.fromCharCode(0xFF)));
    var value = ext.value;
    if (typeof ext.value !== 'string') // value is asn.1
    value = $928e625c51185ebc$var$asn1.toDer(value).getBytes();
    // extnValue (OCTET STRING)
    extseq.value.push($928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.OCTETSTRING, false, value));
    return extseq;
};
/**
 * Converts a PKCS#10 certification request to an ASN.1 object.
 *
 * @param csr the certification request.
 *
 * @return the asn1 representation of a certification request.
 */ $928e625c51185ebc$var$pki.certificationRequestToAsn1 = function(csr) {
    // prefer cached CertificationRequestInfo over generating one
    var cri = csr.certificationRequestInfo || $928e625c51185ebc$var$pki.getCertificationRequestInfo(csr);
    // Certificate
    return $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.SEQUENCE, true, [
        // CertificationRequestInfo
        cri,
        // AlgorithmIdentifier (signature algorithm)
        $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.SEQUENCE, true, [
            // algorithm
            $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.OID, false, $928e625c51185ebc$var$asn1.oidToDer(csr.signatureOid).getBytes()),
            // parameters
            $928e625c51185ebc$var$_signatureParametersToAsn1(csr.signatureOid, csr.signatureParameters)
        ]),
        // signature
        $928e625c51185ebc$var$asn1.create($928e625c51185ebc$var$asn1.Class.UNIVERSAL, $928e625c51185ebc$var$asn1.Type.BITSTRING, false, String.fromCharCode(0x00) + csr.signature)
    ]);
};
/**
 * Creates a CA store.
 *
 * @param certs an optional array of certificate objects or PEM-formatted
 *          certificate strings to add to the CA store.
 *
 * @return the CA store.
 */ $928e625c51185ebc$var$pki.createCaStore = function(certs) {
    // create CA store
    var caStore = {
        // stored certificates
        certs: {}
    };
    /**
   * Gets the certificate that issued the passed certificate or its
   * 'parent'.
   *
   * @param cert the certificate to get the parent for.
   *
   * @return the parent certificate or null if none was found.
   */ caStore.getIssuer = function(cert) {
        var rval = getBySubject(cert.issuer);
        // see if there are multiple matches
        /*if(forge.util.isArray(rval)) {
      // TODO: resolve multiple matches by checking
      // authorityKey/subjectKey/issuerUniqueID/other identifiers, etc.
      // FIXME: or alternatively do authority key mapping
      // if possible (X.509v1 certs can't work?)
      throw new Error('Resolving multiple issuer matches not implemented yet.');
    }*/ return rval;
    };
    /**
   * Adds a trusted certificate to the store.
   *
   * @param cert the certificate to add as a trusted certificate (either a
   *          pki.certificate object or a PEM-formatted certificate).
   */ caStore.addCertificate = function(cert) {
        // convert from pem if necessary
        if (typeof cert === 'string') cert = $cLQG7.pki.certificateFromPem(cert);
        ensureSubjectHasHash(cert.subject);
        if (!caStore.hasCertificate(cert)) {
            if (cert.subject.hash in caStore.certs) {
                // subject hash already exists, append to array
                var tmp = caStore.certs[cert.subject.hash];
                if (!$cLQG7.util.isArray(tmp)) tmp = [
                    tmp
                ];
                tmp.push(cert);
                caStore.certs[cert.subject.hash] = tmp;
            } else caStore.certs[cert.subject.hash] = cert;
        }
    };
    /**
   * Checks to see if the given certificate is in the store.
   *
   * @param cert the certificate to check (either a pki.certificate or a
   *          PEM-formatted certificate).
   *
   * @return true if the certificate is in the store, false if not.
   */ caStore.hasCertificate = function(cert) {
        // convert from pem if necessary
        if (typeof cert === 'string') cert = $cLQG7.pki.certificateFromPem(cert);
        var match = getBySubject(cert.subject);
        if (!match) return false;
        if (!$cLQG7.util.isArray(match)) match = [
            match
        ];
        // compare DER-encoding of certificates
        var der1 = $928e625c51185ebc$var$asn1.toDer($928e625c51185ebc$var$pki.certificateToAsn1(cert)).getBytes();
        for(var i = 0; i < match.length; ++i){
            var der2 = $928e625c51185ebc$var$asn1.toDer($928e625c51185ebc$var$pki.certificateToAsn1(match[i])).getBytes();
            if (der1 === der2) return true;
        }
        return false;
    };
    /**
   * Lists all of the certificates kept in the store.
   *
   * @return an array of all of the pki.certificate objects in the store.
   */ caStore.listAllCertificates = function() {
        var certList = [];
        for(var hash in caStore.certs)if (caStore.certs.hasOwnProperty(hash)) {
            var value = caStore.certs[hash];
            if (!$cLQG7.util.isArray(value)) certList.push(value);
            else for(var i = 0; i < value.length; ++i)certList.push(value[i]);
        }
        return certList;
    };
    /**
   * Removes a certificate from the store.
   *
   * @param cert the certificate to remove (either a pki.certificate or a
   *          PEM-formatted certificate).
   *
   * @return the certificate that was removed or null if the certificate
   *           wasn't in store.
   */ caStore.removeCertificate = function(cert) {
        var result;
        // convert from pem if necessary
        if (typeof cert === 'string') cert = $cLQG7.pki.certificateFromPem(cert);
        ensureSubjectHasHash(cert.subject);
        if (!caStore.hasCertificate(cert)) return null;
        var match = getBySubject(cert.subject);
        if (!$cLQG7.util.isArray(match)) {
            result = caStore.certs[cert.subject.hash];
            delete caStore.certs[cert.subject.hash];
            return result;
        }
        // compare DER-encoding of certificates
        var der1 = $928e625c51185ebc$var$asn1.toDer($928e625c51185ebc$var$pki.certificateToAsn1(cert)).getBytes();
        for(var i = 0; i < match.length; ++i){
            var der2 = $928e625c51185ebc$var$asn1.toDer($928e625c51185ebc$var$pki.certificateToAsn1(match[i])).getBytes();
            if (der1 === der2) {
                result = match[i];
                match.splice(i, 1);
            }
        }
        if (match.length === 0) delete caStore.certs[cert.subject.hash];
        return result;
    };
    function getBySubject(subject) {
        ensureSubjectHasHash(subject);
        return caStore.certs[subject.hash] || null;
    }
    function ensureSubjectHasHash(subject) {
        // produce subject hash if it doesn't exist
        if (!subject.hash) {
            var md = $cLQG7.md.sha1.create();
            subject.attributes = $928e625c51185ebc$var$pki.RDNAttributesAsArray($928e625c51185ebc$var$_dnToAsn1(subject), md);
            subject.hash = md.digest().toHex();
        }
    }
    // auto-add passed in certs
    if (certs) // parse PEM-formatted certificates as necessary
    for(var i = 0; i < certs.length; ++i){
        var cert = certs[i];
        caStore.addCertificate(cert);
    }
    return caStore;
};
/**
 * Certificate verification errors, based on TLS.
 */ $928e625c51185ebc$var$pki.certificateError = {
    bad_certificate: 'forge.pki.BadCertificate',
    unsupported_certificate: 'forge.pki.UnsupportedCertificate',
    certificate_revoked: 'forge.pki.CertificateRevoked',
    certificate_expired: 'forge.pki.CertificateExpired',
    certificate_unknown: 'forge.pki.CertificateUnknown',
    unknown_ca: 'forge.pki.UnknownCertificateAuthority'
};
/**
 * Verifies a certificate chain against the given Certificate Authority store
 * with an optional custom verify callback.
 *
 * @param caStore a certificate store to verify against.
 * @param chain the certificate chain to verify, with the root or highest
 *          authority at the end (an array of certificates).
 * @param options a callback to be called for every certificate in the chain or
 *                  an object with:
 *                  verify a callback to be called for every certificate in the
 *                    chain
 *                  validityCheckDate the date against which the certificate
 *                    validity period should be checked. Pass null to not check
 *                    the validity period. By default, the current date is used.
 *
 * The verify callback has the following signature:
 *
 * verified - Set to true if certificate was verified, otherwise the
 *   pki.certificateError for why the certificate failed.
 * depth - The current index in the chain, where 0 is the end point's cert.
 * certs - The certificate chain, *NOTE* an empty chain indicates an anonymous
 *   end point.
 *
 * The function returns true on success and on failure either the appropriate
 * pki.certificateError or an object with 'error' set to the appropriate
 * pki.certificateError and 'message' set to a custom error message.
 *
 * @return true if successful, error thrown if not.
 */ $928e625c51185ebc$var$pki.verifyCertificateChain = function(caStore, chain, options) {
    /* From: RFC3280 - Internet X.509 Public Key Infrastructure Certificate
    Section 6: Certification Path Validation
    See inline parentheticals related to this particular implementation.

    The primary goal of path validation is to verify the binding between
    a subject distinguished name or a subject alternative name and subject
    public key, as represented in the end entity certificate, based on the
    public key of the trust anchor. This requires obtaining a sequence of
    certificates that support that binding. That sequence should be provided
    in the passed 'chain'. The trust anchor should be in the given CA
    store. The 'end entity' certificate is the certificate provided by the
    end point (typically a server) and is the first in the chain.

    To meet this goal, the path validation process verifies, among other
    things, that a prospective certification path (a sequence of n
    certificates or a 'chain') satisfies the following conditions:

    (a) for all x in {1, ..., n-1}, the subject of certificate x is
          the issuer of certificate x+1;

    (b) certificate 1 is issued by the trust anchor;

    (c) certificate n is the certificate to be validated; and

    (d) for all x in {1, ..., n}, the certificate was valid at the
          time in question.

    Note that here 'n' is index 0 in the chain and 1 is the last certificate
    in the chain and it must be signed by a certificate in the connection's
    CA store.

    The path validation process also determines the set of certificate
    policies that are valid for this path, based on the certificate policies
    extension, policy mapping extension, policy constraints extension, and
    inhibit any-policy extension.

    Note: Policy mapping extension not supported (Not Required).

    Note: If the certificate has an unsupported critical extension, then it
    must be rejected.

    Note: A certificate is self-issued if the DNs that appear in the subject
    and issuer fields are identical and are not empty.

    The path validation algorithm assumes the following seven inputs are
    provided to the path processing logic. What this specific implementation
    will use is provided parenthetically:

    (a) a prospective certification path of length n (the 'chain')
    (b) the current date/time: ('now').
    (c) user-initial-policy-set: A set of certificate policy identifiers
          naming the policies that are acceptable to the certificate user.
          The user-initial-policy-set contains the special value any-policy
          if the user is not concerned about certificate policy
          (Not implemented. Any policy is accepted).
    (d) trust anchor information, describing a CA that serves as a trust
          anchor for the certification path. The trust anchor information
          includes:

      (1)  the trusted issuer name,
      (2)  the trusted public key algorithm,
      (3)  the trusted public key, and
      (4)  optionally, the trusted public key parameters associated
             with the public key.

      (Trust anchors are provided via certificates in the CA store).

      The trust anchor information may be provided to the path processing
      procedure in the form of a self-signed certificate. The trusted anchor
      information is trusted because it was delivered to the path processing
      procedure by some trustworthy out-of-band procedure. If the trusted
      public key algorithm requires parameters, then the parameters are
      provided along with the trusted public key (No parameters used in this
      implementation).

    (e) initial-policy-mapping-inhibit, which indicates if policy mapping is
          allowed in the certification path.
          (Not implemented, no policy checking)

    (f) initial-explicit-policy, which indicates if the path must be valid
          for at least one of the certificate policies in the user-initial-
          policy-set.
          (Not implemented, no policy checking)

    (g) initial-any-policy-inhibit, which indicates whether the
          anyPolicy OID should be processed if it is included in a
          certificate.
          (Not implemented, so any policy is valid provided that it is
          not marked as critical) */ /* Basic Path Processing:

    For each certificate in the 'chain', the following is checked:

    1. The certificate validity period includes the current time.
    2. The certificate was signed by its parent (where the parent is either
       the next in the chain or from the CA store). Allow processing to
       continue to the next step if no parent is found but the certificate is
       in the CA store.
    3. TODO: The certificate has not been revoked.
    4. The certificate issuer name matches the parent's subject name.
    5. TODO: If the certificate is self-issued and not the final certificate
       in the chain, skip this step, otherwise verify that the subject name
       is within one of the permitted subtrees of X.500 distinguished names
       and that each of the alternative names in the subjectAltName extension
       (critical or non-critical) is within one of the permitted subtrees for
       that name type.
    6. TODO: If the certificate is self-issued and not the final certificate
       in the chain, skip this step, otherwise verify that the subject name
       is not within one of the excluded subtrees for X.500 distinguished
       names and none of the subjectAltName extension names are excluded for
       that name type.
    7. The other steps in the algorithm for basic path processing involve
       handling the policy extension which is not presently supported in this
       implementation. Instead, if a critical policy extension is found, the
       certificate is rejected as not supported.
    8. If the certificate is not the first or if its the only certificate in
       the chain (having no parent from the CA store or is self-signed) and it
       has a critical key usage extension, verify that the keyCertSign bit is
       set. If the key usage extension exists, verify that the basic
       constraints extension exists. If the basic constraints extension exists,
       verify that the cA flag is set. If pathLenConstraint is set, ensure that
       the number of certificates that precede in the chain (come earlier
       in the chain as implemented below), excluding the very first in the
       chain (typically the end-entity one), isn't greater than the
       pathLenConstraint. This constraint limits the number of intermediate
       CAs that may appear below a CA before only end-entity certificates
       may be issued. */ // if a verify callback is passed as the third parameter, package it within
    // the options object. This is to support a legacy function signature that
    // expected the verify callback as the third parameter.
    if (typeof options === 'function') options = {
        verify: options
    };
    options = options || {};
    // copy cert chain references to another array to protect against changes
    // in verify callback
    chain = chain.slice(0);
    var certs = chain.slice(0);
    var validityCheckDate = options.validityCheckDate;
    // if no validityCheckDate is specified, default to the current date. Make
    // sure to maintain the value null because it indicates that the validity
    // period should not be checked.
    if (typeof validityCheckDate === 'undefined') validityCheckDate = new Date();
    // verify each cert in the chain using its parent, where the parent
    // is either the next in the chain or from the CA store
    var first = true;
    var error = null;
    var depth = 0;
    do {
        var cert = chain.shift();
        var parent = null;
        var selfSigned = false;
        if (validityCheckDate) // 1. check valid time
        {
            if (validityCheckDate < cert.validity.notBefore || validityCheckDate > cert.validity.notAfter) error = {
                message: 'Certificate is not valid yet or has expired.',
                error: $928e625c51185ebc$var$pki.certificateError.certificate_expired,
                notBefore: cert.validity.notBefore,
                notAfter: cert.validity.notAfter,
                // TODO: we might want to reconsider renaming 'now' to
                // 'validityCheckDate' should this API be changed in the future.
                now: validityCheckDate
            };
        }
        // 2. verify with parent from chain or CA store
        if (error === null) {
            parent = chain[0] || caStore.getIssuer(cert);
            if (parent === null) // check for self-signed cert
            {
                if (cert.isIssuer(cert)) {
                    selfSigned = true;
                    parent = cert;
                }
            }
            if (parent) {
                // FIXME: current CA store implementation might have multiple
                // certificates where the issuer can't be determined from the
                // certificate (happens rarely with, eg: old certificates) so normalize
                // by always putting parents into an array
                // TODO: there's may be an extreme degenerate case currently uncovered
                // where an old intermediate certificate seems to have a matching parent
                // but none of the parents actually verify ... but the intermediate
                // is in the CA and it should pass this check; needs investigation
                var parents = parent;
                if (!$cLQG7.util.isArray(parents)) parents = [
                    parents
                ];
                // try to verify with each possible parent (typically only one)
                var verified = false;
                while(!verified && parents.length > 0){
                    parent = parents.shift();
                    try {
                        verified = parent.verify(cert);
                    } catch (ex) {
                    // failure to verify, don't care why, try next one
                    }
                }
                if (!verified) error = {
                    message: 'Certificate signature is invalid.',
                    error: $928e625c51185ebc$var$pki.certificateError.bad_certificate
                };
            }
            if (error === null && (!parent || selfSigned) && !caStore.hasCertificate(cert)) // no parent issuer and certificate itself is not trusted
            error = {
                message: 'Certificate is not trusted.',
                error: $928e625c51185ebc$var$pki.certificateError.unknown_ca
            };
        }
        // TODO: 3. check revoked
        // 4. check for matching issuer/subject
        if (error === null && parent && !cert.isIssuer(parent)) // parent is not issuer
        error = {
            message: 'Certificate issuer is invalid.',
            error: $928e625c51185ebc$var$pki.certificateError.bad_certificate
        };
        // 5. TODO: check names with permitted names tree
        // 6. TODO: check names against excluded names tree
        // 7. check for unsupported critical extensions
        if (error === null) {
            // supported extensions
            var se = {
                keyUsage: true,
                basicConstraints: true
            };
            for(var i = 0; error === null && i < cert.extensions.length; ++i){
                var ext = cert.extensions[i];
                if (ext.critical && !(ext.name in se)) error = {
                    message: 'Certificate has an unsupported critical extension.',
                    error: $928e625c51185ebc$var$pki.certificateError.unsupported_certificate
                };
            }
        }
        // 8. check for CA if cert is not first or is the only certificate
        // remaining in chain with no parent or is self-signed
        if (error === null && (!first || chain.length === 0 && (!parent || selfSigned))) {
            // first check keyUsage extension and then basic constraints
            var bcExt = cert.getExtension('basicConstraints');
            var keyUsageExt = cert.getExtension('keyUsage');
            if (keyUsageExt !== null) // keyCertSign must be true and there must be a basic
            // constraints extension
            {
                if (!keyUsageExt.keyCertSign || bcExt === null) // bad certificate
                error = {
                    message: "Certificate keyUsage or basicConstraints conflict or indicate that the certificate is not a CA. If the certificate is the only one in the chain or isn't the first then the certificate must be a valid CA.",
                    error: $928e625c51185ebc$var$pki.certificateError.bad_certificate
                };
            }
            // basic constraints cA flag must be set
            if (error === null && bcExt !== null && !bcExt.cA) // bad certificate
            error = {
                message: "Certificate basicConstraints indicates the certificate is not a CA.",
                error: $928e625c51185ebc$var$pki.certificateError.bad_certificate
            };
            // if error is not null and keyUsage is available, then we know it
            // has keyCertSign and there is a basic constraints extension too,
            // which means we can check pathLenConstraint (if it exists)
            if (error === null && keyUsageExt !== null && 'pathLenConstraint' in bcExt) {
                // pathLen is the maximum # of intermediate CA certs that can be
                // found between the current certificate and the end-entity (depth 0)
                // certificate; this number does not include the end-entity (depth 0,
                // last in the chain) even if it happens to be a CA certificate itself
                var pathLen = depth - 1;
                if (pathLen > bcExt.pathLenConstraint) // pathLenConstraint violated, bad certificate
                error = {
                    message: 'Certificate basicConstraints pathLenConstraint violated.',
                    error: $928e625c51185ebc$var$pki.certificateError.bad_certificate
                };
            }
        }
        // call application callback
        var vfd = error === null ? true : error.error;
        var ret = options.verify ? options.verify(vfd, depth, certs) : vfd;
        if (ret === true) // clear any set error
        error = null;
        else {
            // if passed basic tests, set default message and alert
            if (vfd === true) error = {
                message: 'The application rejected the certificate.',
                error: $928e625c51185ebc$var$pki.certificateError.bad_certificate
            };
            // check for custom error info
            if (ret || ret === 0) {
                // set custom message and error
                if (typeof ret === 'object' && !$cLQG7.util.isArray(ret)) {
                    if (ret.message) error.message = ret.message;
                    if (ret.error) error.error = ret.error;
                } else if (typeof ret === 'string') // set custom error
                error.error = ret;
            }
            // throw error
            throw error;
        }
        // no longer first cert in chain
        first = false;
        ++depth;
    }while (chain.length > 0);
    return true;
};


// shortcut for asn.1 & PKI API
var $655e13cc55a41c6e$var$asn1 = $cLQG7.asn1;
var $655e13cc55a41c6e$var$pki = $cLQG7.pki;
// shortcut for PKCS#12 API
var $655e13cc55a41c6e$var$p12 = $655e13cc55a41c6e$exports = $cLQG7.pkcs12 = $cLQG7.pkcs12 || {};
var $655e13cc55a41c6e$var$contentInfoValidator = {
    name: 'ContentInfo',
    tagClass: $655e13cc55a41c6e$var$asn1.Class.UNIVERSAL,
    type: $655e13cc55a41c6e$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: 'ContentInfo.contentType',
            tagClass: $655e13cc55a41c6e$var$asn1.Class.UNIVERSAL,
            type: $655e13cc55a41c6e$var$asn1.Type.OID,
            constructed: false,
            capture: 'contentType'
        },
        {
            name: 'ContentInfo.content',
            tagClass: $655e13cc55a41c6e$var$asn1.Class.CONTEXT_SPECIFIC,
            constructed: true,
            captureAsn1: 'content'
        }
    ]
};
var $655e13cc55a41c6e$var$pfxValidator = {
    name: 'PFX',
    tagClass: $655e13cc55a41c6e$var$asn1.Class.UNIVERSAL,
    type: $655e13cc55a41c6e$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: 'PFX.version',
            tagClass: $655e13cc55a41c6e$var$asn1.Class.UNIVERSAL,
            type: $655e13cc55a41c6e$var$asn1.Type.INTEGER,
            constructed: false,
            capture: 'version'
        },
        $655e13cc55a41c6e$var$contentInfoValidator,
        {
            name: 'PFX.macData',
            tagClass: $655e13cc55a41c6e$var$asn1.Class.UNIVERSAL,
            type: $655e13cc55a41c6e$var$asn1.Type.SEQUENCE,
            constructed: true,
            optional: true,
            captureAsn1: 'mac',
            value: [
                {
                    name: 'PFX.macData.mac',
                    tagClass: $655e13cc55a41c6e$var$asn1.Class.UNIVERSAL,
                    type: $655e13cc55a41c6e$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    value: [
                        {
                            name: 'PFX.macData.mac.digestAlgorithm',
                            tagClass: $655e13cc55a41c6e$var$asn1.Class.UNIVERSAL,
                            type: $655e13cc55a41c6e$var$asn1.Type.SEQUENCE,
                            constructed: true,
                            value: [
                                {
                                    name: 'PFX.macData.mac.digestAlgorithm.algorithm',
                                    tagClass: $655e13cc55a41c6e$var$asn1.Class.UNIVERSAL,
                                    type: $655e13cc55a41c6e$var$asn1.Type.OID,
                                    constructed: false,
                                    capture: 'macAlgorithm'
                                },
                                {
                                    name: 'PFX.macData.mac.digestAlgorithm.parameters',
                                    tagClass: $655e13cc55a41c6e$var$asn1.Class.UNIVERSAL,
                                    captureAsn1: 'macAlgorithmParameters'
                                }
                            ]
                        },
                        {
                            name: 'PFX.macData.mac.digest',
                            tagClass: $655e13cc55a41c6e$var$asn1.Class.UNIVERSAL,
                            type: $655e13cc55a41c6e$var$asn1.Type.OCTETSTRING,
                            constructed: false,
                            capture: 'macDigest'
                        }
                    ]
                },
                {
                    name: 'PFX.macData.macSalt',
                    tagClass: $655e13cc55a41c6e$var$asn1.Class.UNIVERSAL,
                    type: $655e13cc55a41c6e$var$asn1.Type.OCTETSTRING,
                    constructed: false,
                    capture: 'macSalt'
                },
                {
                    name: 'PFX.macData.iterations',
                    tagClass: $655e13cc55a41c6e$var$asn1.Class.UNIVERSAL,
                    type: $655e13cc55a41c6e$var$asn1.Type.INTEGER,
                    constructed: false,
                    optional: true,
                    capture: 'macIterations'
                }
            ]
        }
    ]
};
var $655e13cc55a41c6e$var$safeBagValidator = {
    name: 'SafeBag',
    tagClass: $655e13cc55a41c6e$var$asn1.Class.UNIVERSAL,
    type: $655e13cc55a41c6e$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: 'SafeBag.bagId',
            tagClass: $655e13cc55a41c6e$var$asn1.Class.UNIVERSAL,
            type: $655e13cc55a41c6e$var$asn1.Type.OID,
            constructed: false,
            capture: 'bagId'
        },
        {
            name: 'SafeBag.bagValue',
            tagClass: $655e13cc55a41c6e$var$asn1.Class.CONTEXT_SPECIFIC,
            constructed: true,
            captureAsn1: 'bagValue'
        },
        {
            name: 'SafeBag.bagAttributes',
            tagClass: $655e13cc55a41c6e$var$asn1.Class.UNIVERSAL,
            type: $655e13cc55a41c6e$var$asn1.Type.SET,
            constructed: true,
            optional: true,
            capture: 'bagAttributes'
        }
    ]
};
var $655e13cc55a41c6e$var$attributeValidator = {
    name: 'Attribute',
    tagClass: $655e13cc55a41c6e$var$asn1.Class.UNIVERSAL,
    type: $655e13cc55a41c6e$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: 'Attribute.attrId',
            tagClass: $655e13cc55a41c6e$var$asn1.Class.UNIVERSAL,
            type: $655e13cc55a41c6e$var$asn1.Type.OID,
            constructed: false,
            capture: 'oid'
        },
        {
            name: 'Attribute.attrValues',
            tagClass: $655e13cc55a41c6e$var$asn1.Class.UNIVERSAL,
            type: $655e13cc55a41c6e$var$asn1.Type.SET,
            constructed: true,
            capture: 'values'
        }
    ]
};
var $655e13cc55a41c6e$var$certBagValidator = {
    name: 'CertBag',
    tagClass: $655e13cc55a41c6e$var$asn1.Class.UNIVERSAL,
    type: $655e13cc55a41c6e$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: 'CertBag.certId',
            tagClass: $655e13cc55a41c6e$var$asn1.Class.UNIVERSAL,
            type: $655e13cc55a41c6e$var$asn1.Type.OID,
            constructed: false,
            capture: 'certId'
        },
        {
            name: 'CertBag.certValue',
            tagClass: $655e13cc55a41c6e$var$asn1.Class.CONTEXT_SPECIFIC,
            constructed: true,
            /* So far we only support X.509 certificates (which are wrapped in
       an OCTET STRING, hence hard code that here). */ value: [
                {
                    name: 'CertBag.certValue[0]',
                    tagClass: $655e13cc55a41c6e$var$asn1.Class.UNIVERSAL,
                    type: $655e13cc55a41c6e$var$asn1.Class.OCTETSTRING,
                    constructed: false,
                    capture: 'cert'
                }
            ]
        }
    ]
};
/**
 * Search SafeContents structure for bags with matching attributes.
 *
 * The search can optionally be narrowed by a certain bag type.
 *
 * @param safeContents the SafeContents structure to search in.
 * @param attrName the name of the attribute to compare against.
 * @param attrValue the attribute value to search for.
 * @param [bagType] bag type to narrow search by.
 *
 * @return an array of matching bags.
 */ function $655e13cc55a41c6e$var$_getBagsByAttribute(safeContents, attrName, attrValue, bagType) {
    var result = [];
    for(var i = 0; i < safeContents.length; i++)for(var j = 0; j < safeContents[i].safeBags.length; j++){
        var bag = safeContents[i].safeBags[j];
        if (bagType !== undefined && bag.type !== bagType) continue;
        // only filter by bag type, no attribute specified
        if (attrName === null) {
            result.push(bag);
            continue;
        }
        if (bag.attributes[attrName] !== undefined && bag.attributes[attrName].indexOf(attrValue) >= 0) result.push(bag);
    }
    return result;
}
/**
 * Converts a PKCS#12 PFX in ASN.1 notation into a PFX object.
 *
 * @param obj The PKCS#12 PFX in ASN.1 notation.
 * @param strict true to use strict DER decoding, false not to (default: true).
 * @param {String} password Password to decrypt with (optional).
 *
 * @return PKCS#12 PFX object.
 */ $655e13cc55a41c6e$var$p12.pkcs12FromAsn1 = function(obj, strict, password) {
    // handle args
    if (typeof strict === 'string') {
        password = strict;
        strict = true;
    } else if (strict === undefined) strict = true;
    // validate PFX and capture data
    var capture = {};
    var errors = [];
    if (!$655e13cc55a41c6e$var$asn1.validate(obj, $655e13cc55a41c6e$var$pfxValidator, capture, errors)) {
        var error = new Error("Cannot read PKCS#12 PFX. ASN.1 object is not an PKCS#12 PFX.");
        error.errors = error;
        throw error;
    }
    var pfx = {
        version: capture.version.charCodeAt(0),
        safeContents: [],
        /**
     * Gets bags with matching attributes.
     *
     * @param filter the attributes to filter by:
     *          [localKeyId] the localKeyId to search for.
     *          [localKeyIdHex] the localKeyId in hex to search for.
     *          [friendlyName] the friendly name to search for.
     *          [bagType] bag type to narrow each attribute search by.
     *
     * @return a map of attribute type to an array of matching bags or, if no
     *           attribute was given but a bag type, the map key will be the
     *           bag type.
     */ getBags: function(filter) {
            var rval = {};
            var localKeyId;
            if ('localKeyId' in filter) localKeyId = filter.localKeyId;
            else if ('localKeyIdHex' in filter) localKeyId = $cLQG7.util.hexToBytes(filter.localKeyIdHex);
            // filter on bagType only
            if (localKeyId === undefined && !('friendlyName' in filter) && 'bagType' in filter) rval[filter.bagType] = $655e13cc55a41c6e$var$_getBagsByAttribute(pfx.safeContents, null, null, filter.bagType);
            if (localKeyId !== undefined) rval.localKeyId = $655e13cc55a41c6e$var$_getBagsByAttribute(pfx.safeContents, 'localKeyId', localKeyId, filter.bagType);
            if ('friendlyName' in filter) rval.friendlyName = $655e13cc55a41c6e$var$_getBagsByAttribute(pfx.safeContents, 'friendlyName', filter.friendlyName, filter.bagType);
            return rval;
        },
        /**
     * DEPRECATED: use getBags() instead.
     *
     * Get bags with matching friendlyName attribute.
     *
     * @param friendlyName the friendly name to search for.
     * @param [bagType] bag type to narrow search by.
     *
     * @return an array of bags with matching friendlyName attribute.
     */ getBagsByFriendlyName: function(friendlyName, bagType) {
            return $655e13cc55a41c6e$var$_getBagsByAttribute(pfx.safeContents, 'friendlyName', friendlyName, bagType);
        },
        /**
     * DEPRECATED: use getBags() instead.
     *
     * Get bags with matching localKeyId attribute.
     *
     * @param localKeyId the localKeyId to search for.
     * @param [bagType] bag type to narrow search by.
     *
     * @return an array of bags with matching localKeyId attribute.
     */ getBagsByLocalKeyId: function(localKeyId, bagType) {
            return $655e13cc55a41c6e$var$_getBagsByAttribute(pfx.safeContents, 'localKeyId', localKeyId, bagType);
        }
    };
    if (capture.version.charCodeAt(0) !== 3) {
        var error = new Error('PKCS#12 PFX of version other than 3 not supported.');
        error.version = capture.version.charCodeAt(0);
        throw error;
    }
    if ($655e13cc55a41c6e$var$asn1.derToOid(capture.contentType) !== $655e13cc55a41c6e$var$pki.oids.data) {
        var error = new Error('Only PKCS#12 PFX in password integrity mode supported.');
        error.oid = $655e13cc55a41c6e$var$asn1.derToOid(capture.contentType);
        throw error;
    }
    var data = capture.content.value[0];
    if (data.tagClass !== $655e13cc55a41c6e$var$asn1.Class.UNIVERSAL || data.type !== $655e13cc55a41c6e$var$asn1.Type.OCTETSTRING) throw new Error('PKCS#12 authSafe content data is not an OCTET STRING.');
    data = $655e13cc55a41c6e$var$_decodePkcs7Data(data);
    // check for MAC
    if (capture.mac) {
        var md = null;
        var macKeyBytes = 0;
        var macAlgorithm = $655e13cc55a41c6e$var$asn1.derToOid(capture.macAlgorithm);
        switch(macAlgorithm){
            case $655e13cc55a41c6e$var$pki.oids.sha1:
                md = $cLQG7.md.sha1.create();
                macKeyBytes = 20;
                break;
            case $655e13cc55a41c6e$var$pki.oids.sha256:
                md = $cLQG7.md.sha256.create();
                macKeyBytes = 32;
                break;
            case $655e13cc55a41c6e$var$pki.oids.sha384:
                md = $cLQG7.md.sha384.create();
                macKeyBytes = 48;
                break;
            case $655e13cc55a41c6e$var$pki.oids.sha512:
                md = $cLQG7.md.sha512.create();
                macKeyBytes = 64;
                break;
            case $655e13cc55a41c6e$var$pki.oids.md5:
                md = $cLQG7.md.md5.create();
                macKeyBytes = 16;
                break;
        }
        if (md === null) throw new Error('PKCS#12 uses unsupported MAC algorithm: ' + macAlgorithm);
        // verify MAC (iterations default to 1)
        var macSalt = new $cLQG7.util.ByteBuffer(capture.macSalt);
        var macIterations = 'macIterations' in capture ? parseInt($cLQG7.util.bytesToHex(capture.macIterations), 16) : 1;
        var macKey = $655e13cc55a41c6e$var$p12.generateKey(password, macSalt, 3, macIterations, macKeyBytes, md);
        var mac = $cLQG7.hmac.create();
        mac.start(md, macKey);
        mac.update(data.value);
        var macValue = mac.getMac();
        if (macValue.getBytes() !== capture.macDigest) throw new Error('PKCS#12 MAC could not be verified. Invalid password?');
    }
    $655e13cc55a41c6e$var$_decodeAuthenticatedSafe(pfx, data.value, strict, password);
    return pfx;
};
/**
 * Decodes PKCS#7 Data. PKCS#7 (RFC 2315) defines "Data" as an OCTET STRING,
 * but it is sometimes an OCTET STRING that is composed/constructed of chunks,
 * each its own OCTET STRING. This is BER-encoding vs. DER-encoding. This
 * function transforms this corner-case into the usual simple,
 * non-composed/constructed OCTET STRING.
 *
 * This function may be moved to ASN.1 at some point to better deal with
 * more BER-encoding issues, should they arise.
 *
 * @param data the ASN.1 Data object to transform.
 */ function $655e13cc55a41c6e$var$_decodePkcs7Data(data) {
    // handle special case of "chunked" data content: an octet string composed
    // of other octet strings
    if (data.composed || data.constructed) {
        var value = $cLQG7.util.createBuffer();
        for(var i = 0; i < data.value.length; ++i)value.putBytes(data.value[i].value);
        data.composed = data.constructed = false;
        data.value = value.getBytes();
    }
    return data;
}
/**
 * Decode PKCS#12 AuthenticatedSafe (BER encoded) into PFX object.
 *
 * The AuthenticatedSafe is a BER-encoded SEQUENCE OF ContentInfo.
 *
 * @param pfx The PKCS#12 PFX object to fill.
 * @param {String} authSafe BER-encoded AuthenticatedSafe.
 * @param strict true to use strict DER decoding, false not to.
 * @param {String} password Password to decrypt with (optional).
 */ function $655e13cc55a41c6e$var$_decodeAuthenticatedSafe(pfx, authSafe, strict, password) {
    authSafe = $655e13cc55a41c6e$var$asn1.fromDer(authSafe, strict); /* actually it's BER encoded */ 
    if (authSafe.tagClass !== $655e13cc55a41c6e$var$asn1.Class.UNIVERSAL || authSafe.type !== $655e13cc55a41c6e$var$asn1.Type.SEQUENCE || authSafe.constructed !== true) throw new Error("PKCS#12 AuthenticatedSafe expected to be a SEQUENCE OF ContentInfo");
    for(var i = 0; i < authSafe.value.length; i++){
        var contentInfo = authSafe.value[i];
        // validate contentInfo and capture data
        var capture = {};
        var errors = [];
        if (!$655e13cc55a41c6e$var$asn1.validate(contentInfo, $655e13cc55a41c6e$var$contentInfoValidator, capture, errors)) {
            var error = new Error('Cannot read ContentInfo.');
            error.errors = errors;
            throw error;
        }
        var obj = {
            encrypted: false
        };
        var safeContents = null;
        var data = capture.content.value[0];
        switch($655e13cc55a41c6e$var$asn1.derToOid(capture.contentType)){
            case $655e13cc55a41c6e$var$pki.oids.data:
                if (data.tagClass !== $655e13cc55a41c6e$var$asn1.Class.UNIVERSAL || data.type !== $655e13cc55a41c6e$var$asn1.Type.OCTETSTRING) throw new Error('PKCS#12 SafeContents Data is not an OCTET STRING.');
                safeContents = $655e13cc55a41c6e$var$_decodePkcs7Data(data).value;
                break;
            case $655e13cc55a41c6e$var$pki.oids.encryptedData:
                safeContents = $655e13cc55a41c6e$var$_decryptSafeContents(data, password);
                obj.encrypted = true;
                break;
            default:
                var error = new Error('Unsupported PKCS#12 contentType.');
                error.contentType = $655e13cc55a41c6e$var$asn1.derToOid(capture.contentType);
                throw error;
        }
        obj.safeBags = $655e13cc55a41c6e$var$_decodeSafeContents(safeContents, strict, password);
        pfx.safeContents.push(obj);
    }
}
/**
 * Decrypt PKCS#7 EncryptedData structure.
 *
 * @param data ASN.1 encoded EncryptedContentInfo object.
 * @param password The user-provided password.
 *
 * @return The decrypted SafeContents (ASN.1 object).
 */ function $655e13cc55a41c6e$var$_decryptSafeContents(data, password) {
    var capture = {};
    var errors = [];
    if (!$655e13cc55a41c6e$var$asn1.validate(data, $cLQG7.pkcs7.asn1.encryptedDataValidator, capture, errors)) {
        var error = new Error('Cannot read EncryptedContentInfo.');
        error.errors = errors;
        throw error;
    }
    var oid = $655e13cc55a41c6e$var$asn1.derToOid(capture.contentType);
    if (oid !== $655e13cc55a41c6e$var$pki.oids.data) {
        var error = new Error('PKCS#12 EncryptedContentInfo ContentType is not Data.');
        error.oid = oid;
        throw error;
    }
    // get cipher
    oid = $655e13cc55a41c6e$var$asn1.derToOid(capture.encAlgorithm);
    var cipher = $655e13cc55a41c6e$var$pki.pbe.getCipher(oid, capture.encParameter, password);
    // get encrypted data
    var encryptedContentAsn1 = $655e13cc55a41c6e$var$_decodePkcs7Data(capture.encryptedContentAsn1);
    var encrypted = $cLQG7.util.createBuffer(encryptedContentAsn1.value);
    cipher.update(encrypted);
    if (!cipher.finish()) throw new Error('Failed to decrypt PKCS#12 SafeContents.');
    return cipher.output.getBytes();
}
/**
 * Decode PKCS#12 SafeContents (BER-encoded) into array of Bag objects.
 *
 * The safeContents is a BER-encoded SEQUENCE OF SafeBag.
 *
 * @param {String} safeContents BER-encoded safeContents.
 * @param strict true to use strict DER decoding, false not to.
 * @param {String} password Password to decrypt with (optional).
 *
 * @return {Array} Array of Bag objects.
 */ function $655e13cc55a41c6e$var$_decodeSafeContents(safeContents, strict, password) {
    // if strict and no safe contents, return empty safes
    if (!strict && safeContents.length === 0) return [];
    // actually it's BER-encoded
    safeContents = $655e13cc55a41c6e$var$asn1.fromDer(safeContents, strict);
    if (safeContents.tagClass !== $655e13cc55a41c6e$var$asn1.Class.UNIVERSAL || safeContents.type !== $655e13cc55a41c6e$var$asn1.Type.SEQUENCE || safeContents.constructed !== true) throw new Error('PKCS#12 SafeContents expected to be a SEQUENCE OF SafeBag.');
    var res = [];
    for(var i = 0; i < safeContents.value.length; i++){
        var safeBag = safeContents.value[i];
        // validate SafeBag and capture data
        var capture = {};
        var errors = [];
        if (!$655e13cc55a41c6e$var$asn1.validate(safeBag, $655e13cc55a41c6e$var$safeBagValidator, capture, errors)) {
            var error = new Error('Cannot read SafeBag.');
            error.errors = errors;
            throw error;
        }
        /* Create bag object and push to result array. */ var bag = {
            type: $655e13cc55a41c6e$var$asn1.derToOid(capture.bagId),
            attributes: $655e13cc55a41c6e$var$_decodeBagAttributes(capture.bagAttributes)
        };
        res.push(bag);
        var validator, decoder;
        var bagAsn1 = capture.bagValue.value[0];
        switch(bag.type){
            case $655e13cc55a41c6e$var$pki.oids.pkcs8ShroudedKeyBag:
                /* bagAsn1 has a EncryptedPrivateKeyInfo, which we need to decrypt.
           Afterwards we can handle it like a keyBag,
           which is a PrivateKeyInfo. */ bagAsn1 = $655e13cc55a41c6e$var$pki.decryptPrivateKeyInfo(bagAsn1, password);
                if (bagAsn1 === null) throw new Error('Unable to decrypt PKCS#8 ShroudedKeyBag, wrong password?');
            /* fall through */ case $655e13cc55a41c6e$var$pki.oids.keyBag:
                /* A PKCS#12 keyBag is a simple PrivateKeyInfo as understood by our
           PKI module, hence we don't have to do validation/capturing here,
           just pass what we already got. */ try {
                    bag.key = $655e13cc55a41c6e$var$pki.privateKeyFromAsn1(bagAsn1);
                } catch (e) {
                    // ignore unknown key type, pass asn1 value
                    bag.key = null;
                    bag.asn1 = bagAsn1;
                }
                continue; /* Nothing more to do. */ 
            case $655e13cc55a41c6e$var$pki.oids.certBag:
                /* A PKCS#12 certBag can wrap both X.509 and sdsi certificates.
           Therefore put the SafeBag content through another validator to
           capture the fields.  Afterwards check & store the results. */ validator = $655e13cc55a41c6e$var$certBagValidator;
                decoder = function() {
                    if ($655e13cc55a41c6e$var$asn1.derToOid(capture.certId) !== $655e13cc55a41c6e$var$pki.oids.x509Certificate) {
                        var error = new Error('Unsupported certificate type, only X.509 supported.');
                        error.oid = $655e13cc55a41c6e$var$asn1.derToOid(capture.certId);
                        throw error;
                    }
                    // true=produce cert hash
                    var certAsn1 = $655e13cc55a41c6e$var$asn1.fromDer(capture.cert, strict);
                    try {
                        bag.cert = $655e13cc55a41c6e$var$pki.certificateFromAsn1(certAsn1, true);
                    } catch (e) {
                        // ignore unknown cert type, pass asn1 value
                        bag.cert = null;
                        bag.asn1 = certAsn1;
                    }
                };
                break;
            default:
                var error = new Error('Unsupported PKCS#12 SafeBag type.');
                error.oid = bag.type;
                throw error;
        }
        /* Validate SafeBag value (i.e. CertBag, etc.) and capture data if needed. */ if (validator !== undefined && !$655e13cc55a41c6e$var$asn1.validate(bagAsn1, validator, capture, errors)) {
            var error = new Error('Cannot read PKCS#12 ' + validator.name);
            error.errors = errors;
            throw error;
        }
        /* Call decoder function from above to store the results. */ decoder();
    }
    return res;
}
/**
 * Decode PKCS#12 SET OF PKCS12Attribute into JavaScript object.
 *
 * @param attributes SET OF PKCS12Attribute (ASN.1 object).
 *
 * @return the decoded attributes.
 */ function $655e13cc55a41c6e$var$_decodeBagAttributes(attributes) {
    var decodedAttrs = {};
    if (attributes !== undefined) for(var i = 0; i < attributes.length; ++i){
        var capture = {};
        var errors = [];
        if (!$655e13cc55a41c6e$var$asn1.validate(attributes[i], $655e13cc55a41c6e$var$attributeValidator, capture, errors)) {
            var error = new Error('Cannot read PKCS#12 BagAttribute.');
            error.errors = errors;
            throw error;
        }
        var oid = $655e13cc55a41c6e$var$asn1.derToOid(capture.oid);
        if ($655e13cc55a41c6e$var$pki.oids[oid] === undefined) continue;
        decodedAttrs[$655e13cc55a41c6e$var$pki.oids[oid]] = [];
        for(var j = 0; j < capture.values.length; ++j)decodedAttrs[$655e13cc55a41c6e$var$pki.oids[oid]].push(capture.values[j].value);
    }
    return decodedAttrs;
}
/**
 * Wraps a private key and certificate in a PKCS#12 PFX wrapper. If a
 * password is provided then the private key will be encrypted.
 *
 * An entire certificate chain may also be included. To do this, pass
 * an array for the "cert" parameter where the first certificate is
 * the one that is paired with the private key and each subsequent one
 * verifies the previous one. The certificates may be in PEM format or
 * have been already parsed by Forge.
 *
 * @todo implement password-based-encryption for the whole package
 *
 * @param key the private key.
 * @param cert the certificate (may be an array of certificates in order
 *          to specify a certificate chain).
 * @param password the password to use, null for none.
 * @param options:
 *          algorithm the encryption algorithm to use
 *            ('aes128', 'aes192', 'aes256', '3des'), defaults to 'aes128'.
 *          count the iteration count to use.
 *          saltSize the salt size to use.
 *          useMac true to include a MAC, false not to, defaults to true.
 *          localKeyId the local key ID to use, in hex.
 *          friendlyName the friendly name to use.
 *          generateLocalKeyId true to generate a random local key ID,
 *            false not to, defaults to true.
 *
 * @return the PKCS#12 PFX ASN.1 object.
 */ $655e13cc55a41c6e$var$p12.toPkcs12Asn1 = function(key, cert, password, options) {
    // set default options
    options = options || {};
    options.saltSize = options.saltSize || 8;
    options.count = options.count || 2048;
    options.algorithm = options.algorithm || options.encAlgorithm || 'aes128';
    if (!('useMac' in options)) options.useMac = true;
    if (!('localKeyId' in options)) options.localKeyId = null;
    if (!('generateLocalKeyId' in options)) options.generateLocalKeyId = true;
    var localKeyId = options.localKeyId;
    var bagAttrs;
    if (localKeyId !== null) localKeyId = $cLQG7.util.hexToBytes(localKeyId);
    else if (options.generateLocalKeyId) {
        // use SHA-1 of paired cert, if available
        if (cert) {
            var pairedCert = $cLQG7.util.isArray(cert) ? cert[0] : cert;
            if (typeof pairedCert === 'string') pairedCert = $655e13cc55a41c6e$var$pki.certificateFromPem(pairedCert);
            var sha1 = $cLQG7.md.sha1.create();
            sha1.update($655e13cc55a41c6e$var$asn1.toDer($655e13cc55a41c6e$var$pki.certificateToAsn1(pairedCert)).getBytes());
            localKeyId = sha1.digest().getBytes();
        } else // FIXME: consider using SHA-1 of public key (which can be generated
        // from private key components), see: cert.generateSubjectKeyIdentifier
        // generate random bytes
        localKeyId = $cLQG7.random.getBytes(20);
    }
    var attrs = [];
    if (localKeyId !== null) attrs.push(// localKeyID
    $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.SEQUENCE, true, [
        // attrId
        $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.OID, false, $655e13cc55a41c6e$var$asn1.oidToDer($655e13cc55a41c6e$var$pki.oids.localKeyId).getBytes()),
        // attrValues
        $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.SET, true, [
            $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.OCTETSTRING, false, localKeyId)
        ])
    ]));
    if ('friendlyName' in options) attrs.push(// friendlyName
    $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.SEQUENCE, true, [
        // attrId
        $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.OID, false, $655e13cc55a41c6e$var$asn1.oidToDer($655e13cc55a41c6e$var$pki.oids.friendlyName).getBytes()),
        // attrValues
        $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.SET, true, [
            $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.BMPSTRING, false, options.friendlyName)
        ])
    ]));
    if (attrs.length > 0) bagAttrs = $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.SET, true, attrs);
    // collect contents for AuthenticatedSafe
    var contents = [];
    // create safe bag(s) for certificate chain
    var chain = [];
    if (cert !== null) {
        if ($cLQG7.util.isArray(cert)) chain = cert;
        else chain = [
            cert
        ];
    }
    var certSafeBags = [];
    for(var i = 0; i < chain.length; ++i){
        // convert cert from PEM as necessary
        cert = chain[i];
        if (typeof cert === 'string') cert = $655e13cc55a41c6e$var$pki.certificateFromPem(cert);
        // SafeBag
        var certBagAttrs = i === 0 ? bagAttrs : undefined;
        var certAsn1 = $655e13cc55a41c6e$var$pki.certificateToAsn1(cert);
        var certSafeBag = $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.SEQUENCE, true, [
            // bagId
            $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.OID, false, $655e13cc55a41c6e$var$asn1.oidToDer($655e13cc55a41c6e$var$pki.oids.certBag).getBytes()),
            // bagValue
            $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                // CertBag
                $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.SEQUENCE, true, [
                    // certId
                    $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.OID, false, $655e13cc55a41c6e$var$asn1.oidToDer($655e13cc55a41c6e$var$pki.oids.x509Certificate).getBytes()),
                    // certValue (x509Certificate)
                    $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                        $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.OCTETSTRING, false, $655e13cc55a41c6e$var$asn1.toDer(certAsn1).getBytes())
                    ])
                ])
            ]),
            // bagAttributes (OPTIONAL)
            certBagAttrs
        ]);
        certSafeBags.push(certSafeBag);
    }
    if (certSafeBags.length > 0) {
        // SafeContents
        var certSafeContents = $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.SEQUENCE, true, certSafeBags);
        // ContentInfo
        var certCI = // PKCS#7 ContentInfo
        $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.SEQUENCE, true, [
            // contentType
            $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.OID, false, // OID for the content type is 'data'
            $655e13cc55a41c6e$var$asn1.oidToDer($655e13cc55a41c6e$var$pki.oids.data).getBytes()),
            // content
            $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.OCTETSTRING, false, $655e13cc55a41c6e$var$asn1.toDer(certSafeContents).getBytes())
            ])
        ]);
        contents.push(certCI);
    }
    // create safe contents for private key
    var keyBag = null;
    if (key !== null) {
        // SafeBag
        var pkAsn1 = $655e13cc55a41c6e$var$pki.wrapRsaPrivateKey($655e13cc55a41c6e$var$pki.privateKeyToAsn1(key));
        if (password === null) // no encryption
        keyBag = $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.SEQUENCE, true, [
            // bagId
            $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.OID, false, $655e13cc55a41c6e$var$asn1.oidToDer($655e13cc55a41c6e$var$pki.oids.keyBag).getBytes()),
            // bagValue
            $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                // PrivateKeyInfo
                pkAsn1
            ]),
            // bagAttributes (OPTIONAL)
            bagAttrs
        ]);
        else // encrypted PrivateKeyInfo
        keyBag = $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.SEQUENCE, true, [
            // bagId
            $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.OID, false, $655e13cc55a41c6e$var$asn1.oidToDer($655e13cc55a41c6e$var$pki.oids.pkcs8ShroudedKeyBag).getBytes()),
            // bagValue
            $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                // EncryptedPrivateKeyInfo
                $655e13cc55a41c6e$var$pki.encryptPrivateKeyInfo(pkAsn1, password, options)
            ]),
            // bagAttributes (OPTIONAL)
            bagAttrs
        ]);
        // SafeContents
        var keySafeContents = $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.SEQUENCE, true, [
            keyBag
        ]);
        // ContentInfo
        var keyCI = // PKCS#7 ContentInfo
        $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.SEQUENCE, true, [
            // contentType
            $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.OID, false, // OID for the content type is 'data'
            $655e13cc55a41c6e$var$asn1.oidToDer($655e13cc55a41c6e$var$pki.oids.data).getBytes()),
            // content
            $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.OCTETSTRING, false, $655e13cc55a41c6e$var$asn1.toDer(keySafeContents).getBytes())
            ])
        ]);
        contents.push(keyCI);
    }
    // create AuthenticatedSafe by stringing together the contents
    var safe = $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.SEQUENCE, true, contents);
    var macData;
    if (options.useMac) {
        // MacData
        var sha1 = $cLQG7.md.sha1.create();
        var macSalt = new $cLQG7.util.ByteBuffer($cLQG7.random.getBytes(options.saltSize));
        var count = options.count;
        // 160-bit key
        var key = $655e13cc55a41c6e$var$p12.generateKey(password, macSalt, 3, count, 20);
        var mac = $cLQG7.hmac.create();
        mac.start(sha1, key);
        mac.update($655e13cc55a41c6e$var$asn1.toDer(safe).getBytes());
        var macValue = mac.getMac();
        macData = $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.SEQUENCE, true, [
            // mac DigestInfo
            $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.SEQUENCE, true, [
                // digestAlgorithm
                $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.SEQUENCE, true, [
                    // algorithm = SHA-1
                    $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.OID, false, $655e13cc55a41c6e$var$asn1.oidToDer($655e13cc55a41c6e$var$pki.oids.sha1).getBytes()),
                    // parameters = Null
                    $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.NULL, false, '')
                ]),
                // digest
                $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.OCTETSTRING, false, macValue.getBytes())
            ]),
            // macSalt OCTET STRING
            $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.OCTETSTRING, false, macSalt.getBytes()),
            // iterations INTEGER (XXX: Only support count < 65536)
            $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.INTEGER, false, $655e13cc55a41c6e$var$asn1.integerToDer(count).getBytes())
        ]);
    }
    // PFX
    return $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.SEQUENCE, true, [
        // version (3)
        $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.INTEGER, false, $655e13cc55a41c6e$var$asn1.integerToDer(3).getBytes()),
        // PKCS#7 ContentInfo
        $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.SEQUENCE, true, [
            // contentType
            $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.OID, false, // OID for the content type is 'data'
            $655e13cc55a41c6e$var$asn1.oidToDer($655e13cc55a41c6e$var$pki.oids.data).getBytes()),
            // content
            $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                $655e13cc55a41c6e$var$asn1.create($655e13cc55a41c6e$var$asn1.Class.UNIVERSAL, $655e13cc55a41c6e$var$asn1.Type.OCTETSTRING, false, $655e13cc55a41c6e$var$asn1.toDer(safe).getBytes())
            ])
        ]),
        macData
    ]);
};
/**
 * Derives a PKCS#12 key.
 *
 * @param password the password to derive the key material from, null or
 *          undefined for none.
 * @param salt the salt, as a ByteBuffer, to use.
 * @param id the PKCS#12 ID byte (1 = key material, 2 = IV, 3 = MAC).
 * @param iter the iteration count.
 * @param n the number of bytes to derive from the password.
 * @param md the message digest to use, defaults to SHA-1.
 *
 * @return a ByteBuffer with the bytes derived from the password.
 */ $655e13cc55a41c6e$var$p12.generateKey = $cLQG7.pbe.generatePkcs12Key;






// shortcut for asn.1 API
var $6bd7e8fcd58ea02f$var$asn1 = $cLQG7.asn1;
/* Public Key Infrastructure (PKI) implementation. */ var $6bd7e8fcd58ea02f$var$pki = $6bd7e8fcd58ea02f$exports = $cLQG7.pki = $cLQG7.pki || {};
/**
 * NOTE: THIS METHOD IS DEPRECATED. Use pem.decode() instead.
 *
 * Converts PEM-formatted data to DER.
 *
 * @param pem the PEM-formatted data.
 *
 * @return the DER-formatted data.
 */ $6bd7e8fcd58ea02f$var$pki.pemToDer = function(pem) {
    var msg = $cLQG7.pem.decode(pem)[0];
    if (msg.procType && msg.procType.type === 'ENCRYPTED') throw new Error('Could not convert PEM to DER; PEM is encrypted.');
    return $cLQG7.util.createBuffer(msg.body);
};
/**
 * Converts an RSA private key from PEM format.
 *
 * @param pem the PEM-formatted private key.
 *
 * @return the private key.
 */ $6bd7e8fcd58ea02f$var$pki.privateKeyFromPem = function(pem) {
    var msg = $cLQG7.pem.decode(pem)[0];
    if (msg.type !== 'PRIVATE KEY' && msg.type !== 'RSA PRIVATE KEY') {
        var error = new Error('Could not convert private key from PEM; PEM header type is not "PRIVATE KEY" or "RSA PRIVATE KEY".');
        error.headerType = msg.type;
        throw error;
    }
    if (msg.procType && msg.procType.type === 'ENCRYPTED') throw new Error('Could not convert private key from PEM; PEM is encrypted.');
    // convert DER to ASN.1 object
    var obj = $6bd7e8fcd58ea02f$var$asn1.fromDer(msg.body);
    return $6bd7e8fcd58ea02f$var$pki.privateKeyFromAsn1(obj);
};
/**
 * Converts an RSA private key to PEM format.
 *
 * @param key the private key.
 * @param maxline the maximum characters per line, defaults to 64.
 *
 * @return the PEM-formatted private key.
 */ $6bd7e8fcd58ea02f$var$pki.privateKeyToPem = function(key, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var msg = {
        type: 'RSA PRIVATE KEY',
        body: $6bd7e8fcd58ea02f$var$asn1.toDer($6bd7e8fcd58ea02f$var$pki.privateKeyToAsn1(key)).getBytes()
    };
    return $cLQG7.pem.encode(msg, {
        maxline: maxline
    });
};
/**
 * Converts a PrivateKeyInfo to PEM format.
 *
 * @param pki the PrivateKeyInfo.
 * @param maxline the maximum characters per line, defaults to 64.
 *
 * @return the PEM-formatted private key.
 */ $6bd7e8fcd58ea02f$var$pki.privateKeyInfoToPem = function(pki, maxline) {
    // convert to DER, then PEM-encode
    var msg = {
        type: 'PRIVATE KEY',
        body: $6bd7e8fcd58ea02f$var$asn1.toDer(pki).getBytes()
    };
    return $cLQG7.pem.encode(msg, {
        maxline: maxline
    });
};





/**
 * Generates pseudo random bytes by mixing the result of two hash functions,
 * MD5 and SHA-1.
 *
 * prf_TLS1(secret, label, seed) =
 *   P_MD5(S1, label + seed) XOR P_SHA-1(S2, label + seed);
 *
 * Each P_hash function functions as follows:
 *
 * P_hash(secret, seed) = HMAC_hash(secret, A(1) + seed) +
 *                        HMAC_hash(secret, A(2) + seed) +
 *                        HMAC_hash(secret, A(3) + seed) + ...
 * A() is defined as:
 *   A(0) = seed
 *   A(i) = HMAC_hash(secret, A(i-1))
 *
 * The '+' operator denotes concatenation.
 *
 * As many iterations A(N) as are needed are performed to generate enough
 * pseudo random byte output. If an iteration creates more data than is
 * necessary, then it is truncated.
 *
 * Therefore:
 * A(1) = HMAC_hash(secret, A(0))
 *      = HMAC_hash(secret, seed)
 * A(2) = HMAC_hash(secret, A(1))
 *      = HMAC_hash(secret, HMAC_hash(secret, seed))
 *
 * Therefore:
 * P_hash(secret, seed) =
 *   HMAC_hash(secret, HMAC_hash(secret, A(0)) + seed) +
 *   HMAC_hash(secret, HMAC_hash(secret, A(1)) + seed) +
 *   ...
 *
 * Therefore:
 * P_hash(secret, seed) =
 *   HMAC_hash(secret, HMAC_hash(secret, seed) + seed) +
 *   HMAC_hash(secret, HMAC_hash(secret, HMAC_hash(secret, seed)) + seed) +
 *   ...
 *
 * @param secret the secret to use.
 * @param label the label to use.
 * @param seed the seed value to use.
 * @param length the number of bytes to generate.
 *
 * @return the pseudo random bytes in a byte buffer.
 */ var $087e807083257150$var$prf_TLS1 = function(secret, label, seed, length) {
    var rval = $cLQG7.util.createBuffer();
    /* For TLS 1.0, the secret is split in half, into two secrets of equal
    length. If the secret has an odd length then the last byte of the first
    half will be the same as the first byte of the second. The length of the
    two secrets is half of the secret rounded up. */ var idx = secret.length >> 1;
    var slen = idx + (secret.length & 1);
    var s1 = secret.substr(0, slen);
    var s2 = secret.substr(idx, slen);
    var ai = $cLQG7.util.createBuffer();
    var hmac = $cLQG7.hmac.create();
    seed = label + seed;
    // determine the number of iterations that must be performed to generate
    // enough output bytes, md5 creates 16 byte hashes, sha1 creates 20
    var md5itr = Math.ceil(length / 16);
    var sha1itr = Math.ceil(length / 20);
    // do md5 iterations
    hmac.start('MD5', s1);
    var md5bytes = $cLQG7.util.createBuffer();
    ai.putBytes(seed);
    for(var i = 0; i < md5itr; ++i){
        // HMAC_hash(secret, A(i-1))
        hmac.start(null, null);
        hmac.update(ai.getBytes());
        ai.putBuffer(hmac.digest());
        // HMAC_hash(secret, A(i) + seed)
        hmac.start(null, null);
        hmac.update(ai.bytes() + seed);
        md5bytes.putBuffer(hmac.digest());
    }
    // do sha1 iterations
    hmac.start('SHA1', s2);
    var sha1bytes = $cLQG7.util.createBuffer();
    ai.clear();
    ai.putBytes(seed);
    for(var i = 0; i < sha1itr; ++i){
        // HMAC_hash(secret, A(i-1))
        hmac.start(null, null);
        hmac.update(ai.getBytes());
        ai.putBuffer(hmac.digest());
        // HMAC_hash(secret, A(i) + seed)
        hmac.start(null, null);
        hmac.update(ai.bytes() + seed);
        sha1bytes.putBuffer(hmac.digest());
    }
    // XOR the md5 bytes with the sha1 bytes
    rval.putBytes($cLQG7.util.xorBytes(md5bytes.getBytes(), sha1bytes.getBytes(), length));
    return rval;
};
/**
 * Generates pseudo random bytes using a SHA256 algorithm. For TLS 1.2.
 *
 * @param secret the secret to use.
 * @param label the label to use.
 * @param seed the seed value to use.
 * @param length the number of bytes to generate.
 *
 * @return the pseudo random bytes in a byte buffer.
 */ var $087e807083257150$var$prf_sha256 = function(secret, label, seed, length) {
// FIXME: implement me for TLS 1.2
};
/**
 * Gets a MAC for a record using the SHA-1 hash algorithm.
 *
 * @param key the mac key.
 * @param state the sequence number (array of two 32-bit integers).
 * @param record the record.
 *
 * @return the sha-1 hash (20 bytes) for the given record.
 */ var $087e807083257150$var$hmac_sha1 = function(key, seqNum, record) {
    /* MAC is computed like so:
  HMAC_hash(
    key, seqNum +
      TLSCompressed.type +
      TLSCompressed.version +
      TLSCompressed.length +
      TLSCompressed.fragment)
  */ var hmac = $cLQG7.hmac.create();
    hmac.start('SHA1', key);
    var b = $cLQG7.util.createBuffer();
    b.putInt32(seqNum[0]);
    b.putInt32(seqNum[1]);
    b.putByte(record.type);
    b.putByte(record.version.major);
    b.putByte(record.version.minor);
    b.putInt16(record.length);
    b.putBytes(record.fragment.bytes());
    hmac.update(b.getBytes());
    return hmac.digest().getBytes();
};
/**
 * Compresses the TLSPlaintext record into a TLSCompressed record using the
 * deflate algorithm.
 *
 * @param c the TLS connection.
 * @param record the TLSPlaintext record to compress.
 * @param s the ConnectionState to use.
 *
 * @return true on success, false on failure.
 */ var $087e807083257150$var$deflate = function(c, record, s) {
    var rval = false;
    try {
        var bytes = c.deflate(record.fragment.getBytes());
        record.fragment = $cLQG7.util.createBuffer(bytes);
        record.length = bytes.length;
        rval = true;
    } catch (ex) {
    // deflate error, fail out
    }
    return rval;
};
/**
 * Decompresses the TLSCompressed record into a TLSPlaintext record using the
 * deflate algorithm.
 *
 * @param c the TLS connection.
 * @param record the TLSCompressed record to decompress.
 * @param s the ConnectionState to use.
 *
 * @return true on success, false on failure.
 */ var $087e807083257150$var$inflate = function(c, record, s) {
    var rval = false;
    try {
        var bytes = c.inflate(record.fragment.getBytes());
        record.fragment = $cLQG7.util.createBuffer(bytes);
        record.length = bytes.length;
        rval = true;
    } catch (ex) {
    // inflate error, fail out
    }
    return rval;
};
/**
 * Reads a TLS variable-length vector from a byte buffer.
 *
 * Variable-length vectors are defined by specifying a subrange of legal
 * lengths, inclusively, using the notation <floor..ceiling>. When these are
 * encoded, the actual length precedes the vector's contents in the byte
 * stream. The length will be in the form of a number consuming as many bytes
 * as required to hold the vector's specified maximum (ceiling) length. A
 * variable-length vector with an actual length field of zero is referred to
 * as an empty vector.
 *
 * @param b the byte buffer.
 * @param lenBytes the number of bytes required to store the length.
 *
 * @return the resulting byte buffer.
 */ var $087e807083257150$var$readVector = function(b, lenBytes) {
    var len = 0;
    switch(lenBytes){
        case 1:
            len = b.getByte();
            break;
        case 2:
            len = b.getInt16();
            break;
        case 3:
            len = b.getInt24();
            break;
        case 4:
            len = b.getInt32();
            break;
    }
    // read vector bytes into a new buffer
    return $cLQG7.util.createBuffer(b.getBytes(len));
};
/**
 * Writes a TLS variable-length vector to a byte buffer.
 *
 * @param b the byte buffer.
 * @param lenBytes the number of bytes required to store the length.
 * @param v the byte buffer vector.
 */ var $087e807083257150$var$writeVector = function(b, lenBytes, v) {
    // encode length at the start of the vector, where the number of bytes for
    // the length is the maximum number of bytes it would take to encode the
    // vector's ceiling
    b.putInt(v.length(), lenBytes << 3);
    b.putBuffer(v);
};
/**
 * The tls implementation.
 */ var $087e807083257150$var$tls = {};
/**
 * Version: TLS 1.2 = 3.3, TLS 1.1 = 3.2, TLS 1.0 = 3.1. Both TLS 1.1 and
 * TLS 1.2 were still too new (ie: openSSL didn't implement them) at the time
 * of this implementation so TLS 1.0 was implemented instead.
 */ $087e807083257150$var$tls.Versions = {
    TLS_1_0: {
        major: 3,
        minor: 1
    },
    TLS_1_1: {
        major: 3,
        minor: 2
    },
    TLS_1_2: {
        major: 3,
        minor: 3
    }
};
$087e807083257150$var$tls.SupportedVersions = [
    $087e807083257150$var$tls.Versions.TLS_1_1,
    $087e807083257150$var$tls.Versions.TLS_1_0
];
$087e807083257150$var$tls.Version = $087e807083257150$var$tls.SupportedVersions[0];
/**
 * Maximum fragment size. True maximum is 16384, but we fragment before that
 * to allow for unusual small increases during compression.
 */ $087e807083257150$var$tls.MaxFragment = 15360;
/**
 * Whether this entity is considered the "client" or "server".
 * enum { server, client } ConnectionEnd;
 */ $087e807083257150$var$tls.ConnectionEnd = {
    server: 0,
    client: 1
};
/**
 * Pseudo-random function algorithm used to generate keys from the master
 * secret.
 * enum { tls_prf_sha256 } PRFAlgorithm;
 */ $087e807083257150$var$tls.PRFAlgorithm = {
    tls_prf_sha256: 0
};
/**
 * Bulk encryption algorithms.
 * enum { null, rc4, des3, aes } BulkCipherAlgorithm;
 */ $087e807083257150$var$tls.BulkCipherAlgorithm = {
    none: null,
    rc4: 0,
    des3: 1,
    aes: 2
};
/**
 * Cipher types.
 * enum { stream, block, aead } CipherType;
 */ $087e807083257150$var$tls.CipherType = {
    stream: 0,
    block: 1,
    aead: 2
};
/**
 * MAC (Message Authentication Code) algorithms.
 * enum { null, hmac_md5, hmac_sha1, hmac_sha256,
 *   hmac_sha384, hmac_sha512} MACAlgorithm;
 */ $087e807083257150$var$tls.MACAlgorithm = {
    none: null,
    hmac_md5: 0,
    hmac_sha1: 1,
    hmac_sha256: 2,
    hmac_sha384: 3,
    hmac_sha512: 4
};
/**
 * Compression algorithms.
 * enum { null(0), deflate(1), (255) } CompressionMethod;
 */ $087e807083257150$var$tls.CompressionMethod = {
    none: 0,
    deflate: 1
};
/**
 * TLS record content types.
 * enum {
 *   change_cipher_spec(20), alert(21), handshake(22),
 *   application_data(23), (255)
 * } ContentType;
 */ $087e807083257150$var$tls.ContentType = {
    change_cipher_spec: 20,
    alert: 21,
    handshake: 22,
    application_data: 23,
    heartbeat: 24
};
/**
 * TLS handshake types.
 * enum {
 *   hello_request(0), client_hello(1), server_hello(2),
 *   certificate(11), server_key_exchange (12),
 *   certificate_request(13), server_hello_done(14),
 *   certificate_verify(15), client_key_exchange(16),
 *   finished(20), (255)
 * } HandshakeType;
 */ $087e807083257150$var$tls.HandshakeType = {
    hello_request: 0,
    client_hello: 1,
    server_hello: 2,
    certificate: 11,
    server_key_exchange: 12,
    certificate_request: 13,
    server_hello_done: 14,
    certificate_verify: 15,
    client_key_exchange: 16,
    finished: 20
};
/**
 * TLS Alert Protocol.
 *
 * enum { warning(1), fatal(2), (255) } AlertLevel;
 *
 * enum {
 *   close_notify(0),
 *   unexpected_message(10),
 *   bad_record_mac(20),
 *   decryption_failed(21),
 *   record_overflow(22),
 *   decompression_failure(30),
 *   handshake_failure(40),
 *   bad_certificate(42),
 *   unsupported_certificate(43),
 *   certificate_revoked(44),
 *   certificate_expired(45),
 *   certificate_unknown(46),
 *   illegal_parameter(47),
 *   unknown_ca(48),
 *   access_denied(49),
 *   decode_error(50),
 *   decrypt_error(51),
 *   export_restriction(60),
 *   protocol_version(70),
 *   insufficient_security(71),
 *   internal_error(80),
 *   user_canceled(90),
 *   no_renegotiation(100),
 *   (255)
 * } AlertDescription;
 *
 * struct {
 *   AlertLevel level;
 *   AlertDescription description;
 * } Alert;
 */ $087e807083257150$var$tls.Alert = {};
$087e807083257150$var$tls.Alert.Level = {
    warning: 1,
    fatal: 2
};
$087e807083257150$var$tls.Alert.Description = {
    close_notify: 0,
    unexpected_message: 10,
    bad_record_mac: 20,
    decryption_failed: 21,
    record_overflow: 22,
    decompression_failure: 30,
    handshake_failure: 40,
    bad_certificate: 42,
    unsupported_certificate: 43,
    certificate_revoked: 44,
    certificate_expired: 45,
    certificate_unknown: 46,
    illegal_parameter: 47,
    unknown_ca: 48,
    access_denied: 49,
    decode_error: 50,
    decrypt_error: 51,
    export_restriction: 60,
    protocol_version: 70,
    insufficient_security: 71,
    internal_error: 80,
    user_canceled: 90,
    no_renegotiation: 100
};
/**
 * TLS Heartbeat Message types.
 * enum {
 *   heartbeat_request(1),
 *   heartbeat_response(2),
 *   (255)
 * } HeartbeatMessageType;
 */ $087e807083257150$var$tls.HeartbeatMessageType = {
    heartbeat_request: 1,
    heartbeat_response: 2
};
/**
 * Supported cipher suites.
 */ $087e807083257150$var$tls.CipherSuites = {};
/**
 * Gets a supported cipher suite from its 2 byte ID.
 *
 * @param twoBytes two bytes in a string.
 *
 * @return the matching supported cipher suite or null.
 */ $087e807083257150$var$tls.getCipherSuite = function(twoBytes) {
    var rval = null;
    for(var key in $087e807083257150$var$tls.CipherSuites){
        var cs = $087e807083257150$var$tls.CipherSuites[key];
        if (cs.id[0] === twoBytes.charCodeAt(0) && cs.id[1] === twoBytes.charCodeAt(1)) {
            rval = cs;
            break;
        }
    }
    return rval;
};
/**
 * Called when an unexpected record is encountered.
 *
 * @param c the connection.
 * @param record the record.
 */ $087e807083257150$var$tls.handleUnexpected = function(c, record) {
    // if connection is client and closed, ignore unexpected messages
    var ignore = !c.open && c.entity === $087e807083257150$var$tls.ConnectionEnd.client;
    if (!ignore) c.error(c, {
        message: 'Unexpected message. Received TLS record out of order.',
        send: true,
        alert: {
            level: $087e807083257150$var$tls.Alert.Level.fatal,
            description: $087e807083257150$var$tls.Alert.Description.unexpected_message
        }
    });
};
/**
 * Called when a client receives a HelloRequest record.
 *
 * @param c the connection.
 * @param record the record.
 * @param length the length of the handshake message.
 */ $087e807083257150$var$tls.handleHelloRequest = function(c, record, length) {
    // ignore renegotiation requests from the server during a handshake, but
    // if handshaking, send a warning alert that renegotation is denied
    if (!c.handshaking && c.handshakes > 0) {
        // send alert warning
        $087e807083257150$var$tls.queue(c, $087e807083257150$var$tls.createAlert(c, {
            level: $087e807083257150$var$tls.Alert.Level.warning,
            description: $087e807083257150$var$tls.Alert.Description.no_renegotiation
        }));
        $087e807083257150$var$tls.flush(c);
    }
    // continue
    c.process();
};
/**
 * Parses a hello message from a ClientHello or ServerHello record.
 *
 * @param record the record to parse.
 *
 * @return the parsed message.
 */ $087e807083257150$var$tls.parseHelloMessage = function(c, record, length) {
    var msg = null;
    var client = c.entity === $087e807083257150$var$tls.ConnectionEnd.client;
    // minimum of 38 bytes in message
    if (length < 38) c.error(c, {
        message: client ? 'Invalid ServerHello message. Message too short.' : 'Invalid ClientHello message. Message too short.',
        send: true,
        alert: {
            level: $087e807083257150$var$tls.Alert.Level.fatal,
            description: $087e807083257150$var$tls.Alert.Description.illegal_parameter
        }
    });
    else {
        // use 'remaining' to calculate # of remaining bytes in the message
        var b = record.fragment;
        var remaining = b.length();
        msg = {
            version: {
                major: b.getByte(),
                minor: b.getByte()
            },
            random: $cLQG7.util.createBuffer(b.getBytes(32)),
            session_id: $087e807083257150$var$readVector(b, 1),
            extensions: []
        };
        if (client) {
            msg.cipher_suite = b.getBytes(2);
            msg.compression_method = b.getByte();
        } else {
            msg.cipher_suites = $087e807083257150$var$readVector(b, 2);
            msg.compression_methods = $087e807083257150$var$readVector(b, 1);
        }
        // read extensions if there are any bytes left in the message
        remaining = length - (remaining - b.length());
        if (remaining > 0) {
            // parse extensions
            var exts = $087e807083257150$var$readVector(b, 2);
            while(exts.length() > 0)msg.extensions.push({
                type: [
                    exts.getByte(),
                    exts.getByte()
                ],
                data: $087e807083257150$var$readVector(exts, 2)
            });
            // TODO: make extension support modular
            if (!client) for(var i = 0; i < msg.extensions.length; ++i){
                var ext = msg.extensions[i];
                // support SNI extension
                if (ext.type[0] === 0x00 && ext.type[1] === 0x00) {
                    // get server name list
                    var snl = $087e807083257150$var$readVector(ext.data, 2);
                    while(snl.length() > 0){
                        // read server name type
                        var snType = snl.getByte();
                        // only HostName type (0x00) is known, break out if
                        // another type is detected
                        if (snType !== 0x00) break;
                        // add host name to server name list
                        c.session.extensions.server_name.serverNameList.push($087e807083257150$var$readVector(snl, 2).getBytes());
                    }
                }
            }
        }
        // version already set, do not allow version change
        if (c.session.version) {
            if (msg.version.major !== c.session.version.major || msg.version.minor !== c.session.version.minor) return c.error(c, {
                message: 'TLS version change is disallowed during renegotiation.',
                send: true,
                alert: {
                    level: $087e807083257150$var$tls.Alert.Level.fatal,
                    description: $087e807083257150$var$tls.Alert.Description.protocol_version
                }
            });
        }
        // get the chosen (ServerHello) cipher suite
        if (client) // FIXME: should be checking configured acceptable cipher suites
        c.session.cipherSuite = $087e807083257150$var$tls.getCipherSuite(msg.cipher_suite);
        else {
            // get a supported preferred (ClientHello) cipher suite
            // choose the first supported cipher suite
            var tmp = $cLQG7.util.createBuffer(msg.cipher_suites.bytes());
            while(tmp.length() > 0){
                // FIXME: should be checking configured acceptable suites
                // cipher suites take up 2 bytes
                c.session.cipherSuite = $087e807083257150$var$tls.getCipherSuite(tmp.getBytes(2));
                if (c.session.cipherSuite !== null) break;
            }
        }
        // cipher suite not supported
        if (c.session.cipherSuite === null) return c.error(c, {
            message: 'No cipher suites in common.',
            send: true,
            alert: {
                level: $087e807083257150$var$tls.Alert.Level.fatal,
                description: $087e807083257150$var$tls.Alert.Description.handshake_failure
            },
            cipherSuite: $cLQG7.util.bytesToHex(msg.cipher_suite)
        });
        // TODO: handle compression methods
        if (client) c.session.compressionMethod = msg.compression_method;
        else // no compression
        c.session.compressionMethod = $087e807083257150$var$tls.CompressionMethod.none;
    }
    return msg;
};
/**
 * Creates security parameters for the given connection based on the given
 * hello message.
 *
 * @param c the TLS connection.
 * @param msg the hello message.
 */ $087e807083257150$var$tls.createSecurityParameters = function(c, msg) {
    /* Note: security params are from TLS 1.2, some values like prf_algorithm
  are ignored for TLS 1.0/1.1 and the builtin as specified in the spec is
  used. */ // TODO: handle other options from server when more supported
    // get client and server randoms
    var client = c.entity === $087e807083257150$var$tls.ConnectionEnd.client;
    var msgRandom = msg.random.bytes();
    var cRandom = client ? c.session.sp.client_random : msgRandom;
    var sRandom = client ? msgRandom : $087e807083257150$var$tls.createRandom().getBytes();
    // create new security parameters
    c.session.sp = {
        entity: c.entity,
        prf_algorithm: $087e807083257150$var$tls.PRFAlgorithm.tls_prf_sha256,
        bulk_cipher_algorithm: null,
        cipher_type: null,
        enc_key_length: null,
        block_length: null,
        fixed_iv_length: null,
        record_iv_length: null,
        mac_algorithm: null,
        mac_length: null,
        mac_key_length: null,
        compression_algorithm: c.session.compressionMethod,
        pre_master_secret: null,
        master_secret: null,
        client_random: cRandom,
        server_random: sRandom
    };
};
/**
 * Called when a client receives a ServerHello record.
 *
 * When a ServerHello message will be sent:
 *   The server will send this message in response to a client hello message
 *   when it was able to find an acceptable set of algorithms. If it cannot
 *   find such a match, it will respond with a handshake failure alert.
 *
 * uint24 length;
 * struct {
 *   ProtocolVersion server_version;
 *   Random random;
 *   SessionID session_id;
 *   CipherSuite cipher_suite;
 *   CompressionMethod compression_method;
 *   select(extensions_present) {
 *     case false:
 *       struct {};
 *     case true:
 *       Extension extensions<0..2^16-1>;
 *   };
 * } ServerHello;
 *
 * @param c the connection.
 * @param record the record.
 * @param length the length of the handshake message.
 */ $087e807083257150$var$tls.handleServerHello = function(c, record, length) {
    var msg = $087e807083257150$var$tls.parseHelloMessage(c, record, length);
    if (c.fail) return;
    // ensure server version is compatible
    if (msg.version.minor <= c.version.minor) c.version.minor = msg.version.minor;
    else return c.error(c, {
        message: 'Incompatible TLS version.',
        send: true,
        alert: {
            level: $087e807083257150$var$tls.Alert.Level.fatal,
            description: $087e807083257150$var$tls.Alert.Description.protocol_version
        }
    });
    // indicate session version has been set
    c.session.version = c.version;
    // get the session ID from the message
    var sessionId = msg.session_id.bytes();
    // if the session ID is not blank and matches the cached one, resume
    // the session
    if (sessionId.length > 0 && sessionId === c.session.id) {
        // resuming session, expect a ChangeCipherSpec next
        c.expect = $087e807083257150$var$SCC;
        c.session.resuming = true;
        // get new server random
        c.session.sp.server_random = msg.random.bytes();
    } else {
        // not resuming, expect a server Certificate message next
        c.expect = $087e807083257150$var$SCE;
        c.session.resuming = false;
        // create new security parameters
        $087e807083257150$var$tls.createSecurityParameters(c, msg);
    }
    // set new session ID
    c.session.id = sessionId;
    // continue
    c.process();
};
/**
 * Called when a server receives a ClientHello record.
 *
 * When a ClientHello message will be sent:
 *   When a client first connects to a server it is required to send the
 *   client hello as its first message. The client can also send a client
 *   hello in response to a hello request or on its own initiative in order
 *   to renegotiate the security parameters in an existing connection.
 *
 * @param c the connection.
 * @param record the record.
 * @param length the length of the handshake message.
 */ $087e807083257150$var$tls.handleClientHello = function(c, record, length) {
    var msg = $087e807083257150$var$tls.parseHelloMessage(c, record, length);
    if (c.fail) return;
    // get the session ID from the message
    var sessionId = msg.session_id.bytes();
    // see if the given session ID is in the cache
    var session = null;
    if (c.sessionCache) {
        session = c.sessionCache.getSession(sessionId);
        if (session === null) // session ID not found
        sessionId = '';
        else if (session.version.major !== msg.version.major || session.version.minor > msg.version.minor) {
            // if session version is incompatible with client version, do not resume
            session = null;
            sessionId = '';
        }
    }
    // no session found to resume, generate a new session ID
    if (sessionId.length === 0) sessionId = $cLQG7.random.getBytes(32);
    // update session
    c.session.id = sessionId;
    c.session.clientHelloVersion = msg.version;
    c.session.sp = {};
    if (session) {
        // use version and security parameters from resumed session
        c.version = c.session.version = session.version;
        c.session.sp = session.sp;
    } else {
        // use highest compatible minor version
        var version;
        for(var i = 1; i < $087e807083257150$var$tls.SupportedVersions.length; ++i){
            version = $087e807083257150$var$tls.SupportedVersions[i];
            if (version.minor <= msg.version.minor) break;
        }
        c.version = {
            major: version.major,
            minor: version.minor
        };
        c.session.version = c.version;
    }
    // if a session is set, resume it
    if (session !== null) {
        // resuming session, expect a ChangeCipherSpec next
        c.expect = $087e807083257150$var$CCC;
        c.session.resuming = true;
        // get new client random
        c.session.sp.client_random = msg.random.bytes();
    } else {
        // not resuming, expect a Certificate or ClientKeyExchange
        c.expect = c.verifyClient !== false ? $087e807083257150$var$CCE : $087e807083257150$var$CKE;
        c.session.resuming = false;
        // create new security parameters
        $087e807083257150$var$tls.createSecurityParameters(c, msg);
    }
    // connection now open
    c.open = true;
    // queue server hello
    $087e807083257150$var$tls.queue(c, $087e807083257150$var$tls.createRecord(c, {
        type: $087e807083257150$var$tls.ContentType.handshake,
        data: $087e807083257150$var$tls.createServerHello(c)
    }));
    if (c.session.resuming) {
        // queue change cipher spec message
        $087e807083257150$var$tls.queue(c, $087e807083257150$var$tls.createRecord(c, {
            type: $087e807083257150$var$tls.ContentType.change_cipher_spec,
            data: $087e807083257150$var$tls.createChangeCipherSpec()
        }));
        // create pending state
        c.state.pending = $087e807083257150$var$tls.createConnectionState(c);
        // change current write state to pending write state
        c.state.current.write = c.state.pending.write;
        // queue finished
        $087e807083257150$var$tls.queue(c, $087e807083257150$var$tls.createRecord(c, {
            type: $087e807083257150$var$tls.ContentType.handshake,
            data: $087e807083257150$var$tls.createFinished(c)
        }));
    } else {
        // queue server certificate
        $087e807083257150$var$tls.queue(c, $087e807083257150$var$tls.createRecord(c, {
            type: $087e807083257150$var$tls.ContentType.handshake,
            data: $087e807083257150$var$tls.createCertificate(c)
        }));
        if (!c.fail) {
            // queue server key exchange
            $087e807083257150$var$tls.queue(c, $087e807083257150$var$tls.createRecord(c, {
                type: $087e807083257150$var$tls.ContentType.handshake,
                data: $087e807083257150$var$tls.createServerKeyExchange(c)
            }));
            // request client certificate if set
            if (c.verifyClient !== false) // queue certificate request
            $087e807083257150$var$tls.queue(c, $087e807083257150$var$tls.createRecord(c, {
                type: $087e807083257150$var$tls.ContentType.handshake,
                data: $087e807083257150$var$tls.createCertificateRequest(c)
            }));
            // queue server hello done
            $087e807083257150$var$tls.queue(c, $087e807083257150$var$tls.createRecord(c, {
                type: $087e807083257150$var$tls.ContentType.handshake,
                data: $087e807083257150$var$tls.createServerHelloDone(c)
            }));
        }
    }
    // send records
    $087e807083257150$var$tls.flush(c);
    // continue
    c.process();
};
/**
 * Called when a client receives a Certificate record.
 *
 * When this message will be sent:
 *   The server must send a certificate whenever the agreed-upon key exchange
 *   method is not an anonymous one. This message will always immediately
 *   follow the server hello message.
 *
 * Meaning of this message:
 *   The certificate type must be appropriate for the selected cipher suite's
 *   key exchange algorithm, and is generally an X.509v3 certificate. It must
 *   contain a key which matches the key exchange method, as follows. Unless
 *   otherwise specified, the signing algorithm for the certificate must be
 *   the same as the algorithm for the certificate key. Unless otherwise
 *   specified, the public key may be of any length.
 *
 * opaque ASN.1Cert<1..2^24-1>;
 * struct {
 *   ASN.1Cert certificate_list<1..2^24-1>;
 * } Certificate;
 *
 * @param c the connection.
 * @param record the record.
 * @param length the length of the handshake message.
 */ $087e807083257150$var$tls.handleCertificate = function(c, record, length) {
    // minimum of 3 bytes in message
    if (length < 3) return c.error(c, {
        message: 'Invalid Certificate message. Message too short.',
        send: true,
        alert: {
            level: $087e807083257150$var$tls.Alert.Level.fatal,
            description: $087e807083257150$var$tls.Alert.Description.illegal_parameter
        }
    });
    var b = record.fragment;
    var msg = {
        certificate_list: $087e807083257150$var$readVector(b, 3)
    };
    /* The sender's certificate will be first in the list (chain), each
    subsequent one that follows will certify the previous one, but root
    certificates (self-signed) that specify the certificate authority may
    be omitted under the assumption that clients must already possess it. */ var cert, asn1;
    var certs = [];
    try {
        while(msg.certificate_list.length() > 0){
            // each entry in msg.certificate_list is a vector with 3 len bytes
            cert = $087e807083257150$var$readVector(msg.certificate_list, 3);
            asn1 = $cLQG7.asn1.fromDer(cert);
            cert = $cLQG7.pki.certificateFromAsn1(asn1, true);
            certs.push(cert);
        }
    } catch (ex) {
        return c.error(c, {
            message: 'Could not parse certificate list.',
            cause: ex,
            send: true,
            alert: {
                level: $087e807083257150$var$tls.Alert.Level.fatal,
                description: $087e807083257150$var$tls.Alert.Description.bad_certificate
            }
        });
    }
    // ensure at least 1 certificate was provided if in client-mode
    // or if verifyClient was set to true to require a certificate
    // (as opposed to 'optional')
    var client = c.entity === $087e807083257150$var$tls.ConnectionEnd.client;
    if ((client || c.verifyClient === true) && certs.length === 0) // error, no certificate
    c.error(c, {
        message: client ? 'No server certificate provided.' : 'No client certificate provided.',
        send: true,
        alert: {
            level: $087e807083257150$var$tls.Alert.Level.fatal,
            description: $087e807083257150$var$tls.Alert.Description.illegal_parameter
        }
    });
    else if (certs.length === 0) // no certs to verify
    // expect a ServerKeyExchange or ClientKeyExchange message next
    c.expect = client ? $087e807083257150$var$SKE : $087e807083257150$var$CKE;
    else {
        // save certificate in session
        if (client) c.session.serverCertificate = certs[0];
        else c.session.clientCertificate = certs[0];
        if ($087e807083257150$var$tls.verifyCertificateChain(c, certs)) // expect a ServerKeyExchange or ClientKeyExchange message next
        c.expect = client ? $087e807083257150$var$SKE : $087e807083257150$var$CKE;
    }
    // continue
    c.process();
};
/**
 * Called when a client receives a ServerKeyExchange record.
 *
 * When this message will be sent:
 *   This message will be sent immediately after the server certificate
 *   message (or the server hello message, if this is an anonymous
 *   negotiation).
 *
 *   The server key exchange message is sent by the server only when the
 *   server certificate message (if sent) does not contain enough data to
 *   allow the client to exchange a premaster secret.
 *
 * Meaning of this message:
 *   This message conveys cryptographic information to allow the client to
 *   communicate the premaster secret: either an RSA public key to encrypt
 *   the premaster secret with, or a Diffie-Hellman public key with which the
 *   client can complete a key exchange (with the result being the premaster
 *   secret.)
 *
 * enum {
 *   dhe_dss, dhe_rsa, dh_anon, rsa, dh_dss, dh_rsa
 * } KeyExchangeAlgorithm;
 *
 * struct {
 *   opaque dh_p<1..2^16-1>;
 *   opaque dh_g<1..2^16-1>;
 *   opaque dh_Ys<1..2^16-1>;
 * } ServerDHParams;
 *
 * struct {
 *   select(KeyExchangeAlgorithm) {
 *     case dh_anon:
 *       ServerDHParams params;
 *     case dhe_dss:
 *     case dhe_rsa:
 *       ServerDHParams params;
 *       digitally-signed struct {
 *         opaque client_random[32];
 *         opaque server_random[32];
 *         ServerDHParams params;
 *       } signed_params;
 *     case rsa:
 *     case dh_dss:
 *     case dh_rsa:
 *       struct {};
 *   };
 * } ServerKeyExchange;
 *
 * @param c the connection.
 * @param record the record.
 * @param length the length of the handshake message.
 */ $087e807083257150$var$tls.handleServerKeyExchange = function(c, record, length) {
    // this implementation only supports RSA, no Diffie-Hellman support
    // so any length > 0 is invalid
    if (length > 0) return c.error(c, {
        message: 'Invalid key parameters. Only RSA is supported.',
        send: true,
        alert: {
            level: $087e807083257150$var$tls.Alert.Level.fatal,
            description: $087e807083257150$var$tls.Alert.Description.unsupported_certificate
        }
    });
    // expect an optional CertificateRequest message next
    c.expect = $087e807083257150$var$SCR;
    // continue
    c.process();
};
/**
 * Called when a client receives a ClientKeyExchange record.
 *
 * @param c the connection.
 * @param record the record.
 * @param length the length of the handshake message.
 */ $087e807083257150$var$tls.handleClientKeyExchange = function(c, record, length) {
    // this implementation only supports RSA, no Diffie-Hellman support
    // so any length < 48 is invalid
    if (length < 48) return c.error(c, {
        message: 'Invalid key parameters. Only RSA is supported.',
        send: true,
        alert: {
            level: $087e807083257150$var$tls.Alert.Level.fatal,
            description: $087e807083257150$var$tls.Alert.Description.unsupported_certificate
        }
    });
    var b = record.fragment;
    var msg = {
        enc_pre_master_secret: $087e807083257150$var$readVector(b, 2).getBytes()
    };
    // do rsa decryption
    var privateKey = null;
    if (c.getPrivateKey) try {
        privateKey = c.getPrivateKey(c, c.session.serverCertificate);
        privateKey = $cLQG7.pki.privateKeyFromPem(privateKey);
    } catch (ex) {
        c.error(c, {
            message: 'Could not get private key.',
            cause: ex,
            send: true,
            alert: {
                level: $087e807083257150$var$tls.Alert.Level.fatal,
                description: $087e807083257150$var$tls.Alert.Description.internal_error
            }
        });
    }
    if (privateKey === null) return c.error(c, {
        message: 'No private key set.',
        send: true,
        alert: {
            level: $087e807083257150$var$tls.Alert.Level.fatal,
            description: $087e807083257150$var$tls.Alert.Description.internal_error
        }
    });
    try {
        // decrypt 48-byte pre-master secret
        var sp = c.session.sp;
        sp.pre_master_secret = privateKey.decrypt(msg.enc_pre_master_secret);
        // ensure client hello version matches first 2 bytes
        var version = c.session.clientHelloVersion;
        if (version.major !== sp.pre_master_secret.charCodeAt(0) || version.minor !== sp.pre_master_secret.charCodeAt(1)) // error, do not send alert (see BLEI attack below)
        throw new Error('TLS version rollback attack detected.');
    } catch (ex) {
        /* Note: Daniel Bleichenbacher [BLEI] can be used to attack a
      TLS server which is using PKCS#1 encoded RSA, so instead of
      failing here, we generate 48 random bytes and use that as
      the pre-master secret. */ sp.pre_master_secret = $cLQG7.random.getBytes(48);
    }
    // expect a CertificateVerify message if a Certificate was received that
    // does not have fixed Diffie-Hellman params, otherwise expect
    // ChangeCipherSpec
    c.expect = $087e807083257150$var$CCC;
    if (c.session.clientCertificate !== null) // only RSA support, so expect CertificateVerify
    // TODO: support Diffie-Hellman
    c.expect = $087e807083257150$var$CCV;
    // continue
    c.process();
};
/**
 * Called when a client receives a CertificateRequest record.
 *
 * When this message will be sent:
 *   A non-anonymous server can optionally request a certificate from the
 *   client, if appropriate for the selected cipher suite. This message, if
 *   sent, will immediately follow the Server Key Exchange message (if it is
 *   sent; otherwise, the Server Certificate message).
 *
 * enum {
 *   rsa_sign(1), dss_sign(2), rsa_fixed_dh(3), dss_fixed_dh(4),
 *   rsa_ephemeral_dh_RESERVED(5), dss_ephemeral_dh_RESERVED(6),
 *   fortezza_dms_RESERVED(20), (255)
 * } ClientCertificateType;
 *
 * opaque DistinguishedName<1..2^16-1>;
 *
 * struct {
 *   ClientCertificateType certificate_types<1..2^8-1>;
 *   SignatureAndHashAlgorithm supported_signature_algorithms<2^16-1>;
 *   DistinguishedName certificate_authorities<0..2^16-1>;
 * } CertificateRequest;
 *
 * @param c the connection.
 * @param record the record.
 * @param length the length of the handshake message.
 */ $087e807083257150$var$tls.handleCertificateRequest = function(c, record, length) {
    // minimum of 3 bytes in message
    if (length < 3) return c.error(c, {
        message: 'Invalid CertificateRequest. Message too short.',
        send: true,
        alert: {
            level: $087e807083257150$var$tls.Alert.Level.fatal,
            description: $087e807083257150$var$tls.Alert.Description.illegal_parameter
        }
    });
    // TODO: TLS 1.2+ has different format including
    // SignatureAndHashAlgorithm after cert types
    var b = record.fragment;
    var msg = {
        certificate_types: $087e807083257150$var$readVector(b, 1),
        certificate_authorities: $087e807083257150$var$readVector(b, 2)
    };
    // save certificate request in session
    c.session.certificateRequest = msg;
    // expect a ServerHelloDone message next
    c.expect = $087e807083257150$var$SHD;
    // continue
    c.process();
};
/**
 * Called when a server receives a CertificateVerify record.
 *
 * @param c the connection.
 * @param record the record.
 * @param length the length of the handshake message.
 */ $087e807083257150$var$tls.handleCertificateVerify = function(c, record, length) {
    if (length < 2) return c.error(c, {
        message: 'Invalid CertificateVerify. Message too short.',
        send: true,
        alert: {
            level: $087e807083257150$var$tls.Alert.Level.fatal,
            description: $087e807083257150$var$tls.Alert.Description.illegal_parameter
        }
    });
    // rewind to get full bytes for message so it can be manually
    // digested below (special case for CertificateVerify messages because
    // they must be digested *after* handling as opposed to all others)
    var b = record.fragment;
    b.read -= 4;
    var msgBytes = b.bytes();
    b.read += 4;
    var msg = {
        signature: $087e807083257150$var$readVector(b, 2).getBytes()
    };
    // TODO: add support for DSA
    // generate data to verify
    var verify = $cLQG7.util.createBuffer();
    verify.putBuffer(c.session.md5.digest());
    verify.putBuffer(c.session.sha1.digest());
    verify = verify.getBytes();
    try {
        var cert = c.session.clientCertificate;
        /*b = forge.pki.rsa.decrypt(
      msg.signature, cert.publicKey, true, verify.length);
    if(b !== verify) {*/ if (!cert.publicKey.verify(verify, msg.signature, 'NONE')) throw new Error('CertificateVerify signature does not match.');
        // digest message now that it has been handled
        c.session.md5.update(msgBytes);
        c.session.sha1.update(msgBytes);
    } catch (ex) {
        return c.error(c, {
            message: 'Bad signature in CertificateVerify.',
            send: true,
            alert: {
                level: $087e807083257150$var$tls.Alert.Level.fatal,
                description: $087e807083257150$var$tls.Alert.Description.handshake_failure
            }
        });
    }
    // expect ChangeCipherSpec
    c.expect = $087e807083257150$var$CCC;
    // continue
    c.process();
};
/**
 * Called when a client receives a ServerHelloDone record.
 *
 * When this message will be sent:
 *   The server hello done message is sent by the server to indicate the end
 *   of the server hello and associated messages. After sending this message
 *   the server will wait for a client response.
 *
 * Meaning of this message:
 *   This message means that the server is done sending messages to support
 *   the key exchange, and the client can proceed with its phase of the key
 *   exchange.
 *
 *   Upon receipt of the server hello done message the client should verify
 *   that the server provided a valid certificate if required and check that
 *   the server hello parameters are acceptable.
 *
 * struct {} ServerHelloDone;
 *
 * @param c the connection.
 * @param record the record.
 * @param length the length of the handshake message.
 */ $087e807083257150$var$tls.handleServerHelloDone = function(c, record, length) {
    // len must be 0 bytes
    if (length > 0) return c.error(c, {
        message: 'Invalid ServerHelloDone message. Invalid length.',
        send: true,
        alert: {
            level: $087e807083257150$var$tls.Alert.Level.fatal,
            description: $087e807083257150$var$tls.Alert.Description.record_overflow
        }
    });
    if (c.serverCertificate === null) {
        // no server certificate was provided
        var error = {
            message: 'No server certificate provided. Not enough security.',
            send: true,
            alert: {
                level: $087e807083257150$var$tls.Alert.Level.fatal,
                description: $087e807083257150$var$tls.Alert.Description.insufficient_security
            }
        };
        // call application callback
        var depth = 0;
        var ret = c.verify(c, error.alert.description, depth, []);
        if (ret !== true) {
            // check for custom alert info
            if (ret || ret === 0) {
                // set custom message and alert description
                if (typeof ret === 'object' && !$cLQG7.util.isArray(ret)) {
                    if (ret.message) error.message = ret.message;
                    if (ret.alert) error.alert.description = ret.alert;
                } else if (typeof ret === 'number') // set custom alert description
                error.alert.description = ret;
            }
            // send error
            return c.error(c, error);
        }
    }
    // create client certificate message if requested
    if (c.session.certificateRequest !== null) {
        record = $087e807083257150$var$tls.createRecord(c, {
            type: $087e807083257150$var$tls.ContentType.handshake,
            data: $087e807083257150$var$tls.createCertificate(c)
        });
        $087e807083257150$var$tls.queue(c, record);
    }
    // create client key exchange message
    record = $087e807083257150$var$tls.createRecord(c, {
        type: $087e807083257150$var$tls.ContentType.handshake,
        data: $087e807083257150$var$tls.createClientKeyExchange(c)
    });
    $087e807083257150$var$tls.queue(c, record);
    // expect no messages until the following callback has been called
    c.expect = $087e807083257150$var$SER;
    // create callback to handle client signature (for client-certs)
    var callback = function(c, signature) {
        if (c.session.certificateRequest !== null && c.session.clientCertificate !== null) // create certificate verify message
        $087e807083257150$var$tls.queue(c, $087e807083257150$var$tls.createRecord(c, {
            type: $087e807083257150$var$tls.ContentType.handshake,
            data: $087e807083257150$var$tls.createCertificateVerify(c, signature)
        }));
        // create change cipher spec message
        $087e807083257150$var$tls.queue(c, $087e807083257150$var$tls.createRecord(c, {
            type: $087e807083257150$var$tls.ContentType.change_cipher_spec,
            data: $087e807083257150$var$tls.createChangeCipherSpec()
        }));
        // create pending state
        c.state.pending = $087e807083257150$var$tls.createConnectionState(c);
        // change current write state to pending write state
        c.state.current.write = c.state.pending.write;
        // create finished message
        $087e807083257150$var$tls.queue(c, $087e807083257150$var$tls.createRecord(c, {
            type: $087e807083257150$var$tls.ContentType.handshake,
            data: $087e807083257150$var$tls.createFinished(c)
        }));
        // expect a server ChangeCipherSpec message next
        c.expect = $087e807083257150$var$SCC;
        // send records
        $087e807083257150$var$tls.flush(c);
        // continue
        c.process();
    };
    // if there is no certificate request or no client certificate, do
    // callback immediately
    if (c.session.certificateRequest === null || c.session.clientCertificate === null) return callback(c, null);
    // otherwise get the client signature
    $087e807083257150$var$tls.getClientSignature(c, callback);
};
/**
 * Called when a ChangeCipherSpec record is received.
 *
 * @param c the connection.
 * @param record the record.
 */ $087e807083257150$var$tls.handleChangeCipherSpec = function(c, record) {
    if (record.fragment.getByte() !== 0x01) return c.error(c, {
        message: 'Invalid ChangeCipherSpec message received.',
        send: true,
        alert: {
            level: $087e807083257150$var$tls.Alert.Level.fatal,
            description: $087e807083257150$var$tls.Alert.Description.illegal_parameter
        }
    });
    // create pending state if:
    // 1. Resuming session in client mode OR
    // 2. NOT resuming session in server mode
    var client = c.entity === $087e807083257150$var$tls.ConnectionEnd.client;
    if (c.session.resuming && client || !c.session.resuming && !client) c.state.pending = $087e807083257150$var$tls.createConnectionState(c);
    // change current read state to pending read state
    c.state.current.read = c.state.pending.read;
    // clear pending state if:
    // 1. NOT resuming session in client mode OR
    // 2. resuming a session in server mode
    if (!c.session.resuming && client || c.session.resuming && !client) c.state.pending = null;
    // expect a Finished record next
    c.expect = client ? $087e807083257150$var$SFI : $087e807083257150$var$CFI;
    // continue
    c.process();
};
/**
 * Called when a Finished record is received.
 *
 * When this message will be sent:
 *   A finished message is always sent immediately after a change
 *   cipher spec message to verify that the key exchange and
 *   authentication processes were successful. It is essential that a
 *   change cipher spec message be received between the other
 *   handshake messages and the Finished message.
 *
 * Meaning of this message:
 *   The finished message is the first protected with the just-
 *   negotiated algorithms, keys, and secrets. Recipients of finished
 *   messages must verify that the contents are correct.  Once a side
 *   has sent its Finished message and received and validated the
 *   Finished message from its peer, it may begin to send and receive
 *   application data over the connection.
 *
 * struct {
 *   opaque verify_data[verify_data_length];
 * } Finished;
 *
 * verify_data
 *   PRF(master_secret, finished_label, Hash(handshake_messages))
 *     [0..verify_data_length-1];
 *
 * finished_label
 *   For Finished messages sent by the client, the string
 *   "client finished". For Finished messages sent by the server, the
 *   string "server finished".
 *
 * verify_data_length depends on the cipher suite. If it is not specified
 * by the cipher suite, then it is 12. Versions of TLS < 1.2 always used
 * 12 bytes.
 *
 * @param c the connection.
 * @param record the record.
 * @param length the length of the handshake message.
 */ $087e807083257150$var$tls.handleFinished = function(c, record, length) {
    // rewind to get full bytes for message so it can be manually
    // digested below (special case for Finished messages because they
    // must be digested *after* handling as opposed to all others)
    var b = record.fragment;
    b.read -= 4;
    var msgBytes = b.bytes();
    b.read += 4;
    // message contains only verify_data
    var vd = record.fragment.getBytes();
    // ensure verify data is correct
    b = $cLQG7.util.createBuffer();
    b.putBuffer(c.session.md5.digest());
    b.putBuffer(c.session.sha1.digest());
    // set label based on entity type
    var client = c.entity === $087e807083257150$var$tls.ConnectionEnd.client;
    var label = client ? 'server finished' : 'client finished';
    // TODO: determine prf function and verify length for TLS 1.2
    var sp = c.session.sp;
    var vdl = 12;
    var prf = $087e807083257150$var$prf_TLS1;
    b = prf(sp.master_secret, label, b.getBytes(), vdl);
    if (b.getBytes() !== vd) return c.error(c, {
        message: 'Invalid verify_data in Finished message.',
        send: true,
        alert: {
            level: $087e807083257150$var$tls.Alert.Level.fatal,
            description: $087e807083257150$var$tls.Alert.Description.decrypt_error
        }
    });
    // digest finished message now that it has been handled
    c.session.md5.update(msgBytes);
    c.session.sha1.update(msgBytes);
    // resuming session as client or NOT resuming session as server
    if (c.session.resuming && client || !c.session.resuming && !client) {
        // create change cipher spec message
        $087e807083257150$var$tls.queue(c, $087e807083257150$var$tls.createRecord(c, {
            type: $087e807083257150$var$tls.ContentType.change_cipher_spec,
            data: $087e807083257150$var$tls.createChangeCipherSpec()
        }));
        // change current write state to pending write state, clear pending
        c.state.current.write = c.state.pending.write;
        c.state.pending = null;
        // create finished message
        $087e807083257150$var$tls.queue(c, $087e807083257150$var$tls.createRecord(c, {
            type: $087e807083257150$var$tls.ContentType.handshake,
            data: $087e807083257150$var$tls.createFinished(c)
        }));
    }
    // expect application data next
    c.expect = client ? $087e807083257150$var$SAD : $087e807083257150$var$CAD;
    // handshake complete
    c.handshaking = false;
    ++c.handshakes;
    // save access to peer certificate
    c.peerCertificate = client ? c.session.serverCertificate : c.session.clientCertificate;
    // send records
    $087e807083257150$var$tls.flush(c);
    // now connected
    c.isConnected = true;
    c.connected(c);
    // continue
    c.process();
};
/**
 * Called when an Alert record is received.
 *
 * @param c the connection.
 * @param record the record.
 */ $087e807083257150$var$tls.handleAlert = function(c, record) {
    // read alert
    var b = record.fragment;
    var alert = {
        level: b.getByte(),
        description: b.getByte()
    };
    // TODO: consider using a table?
    // get appropriate message
    var msg;
    switch(alert.description){
        case $087e807083257150$var$tls.Alert.Description.close_notify:
            msg = 'Connection closed.';
            break;
        case $087e807083257150$var$tls.Alert.Description.unexpected_message:
            msg = 'Unexpected message.';
            break;
        case $087e807083257150$var$tls.Alert.Description.bad_record_mac:
            msg = 'Bad record MAC.';
            break;
        case $087e807083257150$var$tls.Alert.Description.decryption_failed:
            msg = 'Decryption failed.';
            break;
        case $087e807083257150$var$tls.Alert.Description.record_overflow:
            msg = 'Record overflow.';
            break;
        case $087e807083257150$var$tls.Alert.Description.decompression_failure:
            msg = 'Decompression failed.';
            break;
        case $087e807083257150$var$tls.Alert.Description.handshake_failure:
            msg = 'Handshake failure.';
            break;
        case $087e807083257150$var$tls.Alert.Description.bad_certificate:
            msg = 'Bad certificate.';
            break;
        case $087e807083257150$var$tls.Alert.Description.unsupported_certificate:
            msg = 'Unsupported certificate.';
            break;
        case $087e807083257150$var$tls.Alert.Description.certificate_revoked:
            msg = 'Certificate revoked.';
            break;
        case $087e807083257150$var$tls.Alert.Description.certificate_expired:
            msg = 'Certificate expired.';
            break;
        case $087e807083257150$var$tls.Alert.Description.certificate_unknown:
            msg = 'Certificate unknown.';
            break;
        case $087e807083257150$var$tls.Alert.Description.illegal_parameter:
            msg = 'Illegal parameter.';
            break;
        case $087e807083257150$var$tls.Alert.Description.unknown_ca:
            msg = 'Unknown certificate authority.';
            break;
        case $087e807083257150$var$tls.Alert.Description.access_denied:
            msg = 'Access denied.';
            break;
        case $087e807083257150$var$tls.Alert.Description.decode_error:
            msg = 'Decode error.';
            break;
        case $087e807083257150$var$tls.Alert.Description.decrypt_error:
            msg = 'Decrypt error.';
            break;
        case $087e807083257150$var$tls.Alert.Description.export_restriction:
            msg = 'Export restriction.';
            break;
        case $087e807083257150$var$tls.Alert.Description.protocol_version:
            msg = 'Unsupported protocol version.';
            break;
        case $087e807083257150$var$tls.Alert.Description.insufficient_security:
            msg = 'Insufficient security.';
            break;
        case $087e807083257150$var$tls.Alert.Description.internal_error:
            msg = 'Internal error.';
            break;
        case $087e807083257150$var$tls.Alert.Description.user_canceled:
            msg = 'User canceled.';
            break;
        case $087e807083257150$var$tls.Alert.Description.no_renegotiation:
            msg = 'Renegotiation not supported.';
            break;
        default:
            msg = 'Unknown error.';
            break;
    }
    // close connection on close_notify, not an error
    if (alert.description === $087e807083257150$var$tls.Alert.Description.close_notify) return c.close();
    // call error handler
    c.error(c, {
        message: msg,
        send: false,
        // origin is the opposite end
        origin: c.entity === $087e807083257150$var$tls.ConnectionEnd.client ? 'server' : 'client',
        alert: alert
    });
    // continue
    c.process();
};
/**
 * Called when a Handshake record is received.
 *
 * @param c the connection.
 * @param record the record.
 */ $087e807083257150$var$tls.handleHandshake = function(c, record) {
    // get the handshake type and message length
    var b = record.fragment;
    var type = b.getByte();
    var length = b.getInt24();
    // see if the record fragment doesn't yet contain the full message
    if (length > b.length()) {
        // cache the record, clear its fragment, and reset the buffer read
        // pointer before the type and length were read
        c.fragmented = record;
        record.fragment = $cLQG7.util.createBuffer();
        b.read -= 4;
        // continue
        return c.process();
    }
    // full message now available, clear cache, reset read pointer to
    // before type and length
    c.fragmented = null;
    b.read -= 4;
    // save the handshake bytes for digestion after handler is found
    // (include type and length of handshake msg)
    var bytes = b.bytes(length + 4);
    // restore read pointer
    b.read += 4;
    // handle expected message
    if (type in $087e807083257150$var$hsTable[c.entity][c.expect]) {
        // initialize server session
        if (c.entity === $087e807083257150$var$tls.ConnectionEnd.server && !c.open && !c.fail) {
            c.handshaking = true;
            c.session = {
                version: null,
                extensions: {
                    server_name: {
                        serverNameList: []
                    }
                },
                cipherSuite: null,
                compressionMethod: null,
                serverCertificate: null,
                clientCertificate: null,
                md5: $cLQG7.md.md5.create(),
                sha1: $cLQG7.md.sha1.create()
            };
        }
        /* Update handshake messages digest. Finished and CertificateVerify
      messages are not digested here. They can't be digested as part of
      the verify_data that they contain. These messages are manually
      digested in their handlers. HelloRequest messages are simply never
      included in the handshake message digest according to spec. */ if (type !== $087e807083257150$var$tls.HandshakeType.hello_request && type !== $087e807083257150$var$tls.HandshakeType.certificate_verify && type !== $087e807083257150$var$tls.HandshakeType.finished) {
            c.session.md5.update(bytes);
            c.session.sha1.update(bytes);
        }
        // handle specific handshake type record
        $087e807083257150$var$hsTable[c.entity][c.expect][type](c, record, length);
    } else // unexpected record
    $087e807083257150$var$tls.handleUnexpected(c, record);
};
/**
 * Called when an ApplicationData record is received.
 *
 * @param c the connection.
 * @param record the record.
 */ $087e807083257150$var$tls.handleApplicationData = function(c, record) {
    // buffer data, notify that its ready
    c.data.putBuffer(record.fragment);
    c.dataReady(c);
    // continue
    c.process();
};
/**
 * Called when a Heartbeat record is received.
 *
 * @param c the connection.
 * @param record the record.
 */ $087e807083257150$var$tls.handleHeartbeat = function(c, record) {
    // get the heartbeat type and payload
    var b = record.fragment;
    var type = b.getByte();
    var length = b.getInt16();
    var payload = b.getBytes(length);
    if (type === $087e807083257150$var$tls.HeartbeatMessageType.heartbeat_request) {
        // discard request during handshake or if length is too large
        if (c.handshaking || length > payload.length) // continue
        return c.process();
        // retransmit payload
        $087e807083257150$var$tls.queue(c, $087e807083257150$var$tls.createRecord(c, {
            type: $087e807083257150$var$tls.ContentType.heartbeat,
            data: $087e807083257150$var$tls.createHeartbeat($087e807083257150$var$tls.HeartbeatMessageType.heartbeat_response, payload)
        }));
        $087e807083257150$var$tls.flush(c);
    } else if (type === $087e807083257150$var$tls.HeartbeatMessageType.heartbeat_response) {
        // check payload against expected payload, discard heartbeat if no match
        if (payload !== c.expectedHeartbeatPayload) // continue
        return c.process();
        // notify that a valid heartbeat was received
        if (c.heartbeatReceived) c.heartbeatReceived(c, $cLQG7.util.createBuffer(payload));
    }
    // continue
    c.process();
};
/**
 * The transistional state tables for receiving TLS records. It maps the
 * current TLS engine state and a received record to a function to handle the
 * record and update the state.
 *
 * For instance, if the current state is SHE, then the TLS engine is expecting
 * a ServerHello record. Once a record is received, the handler function is
 * looked up using the state SHE and the record's content type.
 *
 * The resulting function will either be an error handler or a record handler.
 * The function will take whatever action is appropriate and update the state
 * for the next record.
 *
 * The states are all based on possible server record types. Note that the
 * client will never specifically expect to receive a HelloRequest or an alert
 * from the server so there is no state that reflects this. These messages may
 * occur at any time.
 *
 * There are two tables for mapping states because there is a second tier of
 * types for handshake messages. Once a record with a content type of handshake
 * is received, the handshake record handler will look up the handshake type in
 * the secondary map to get its appropriate handler.
 *
 * Valid message orders are as follows:
 *
 * =======================FULL HANDSHAKE======================
 * Client                                               Server
 *
 * ClientHello                  -------->
 *                                                 ServerHello
 *                                                Certificate*
 *                                          ServerKeyExchange*
 *                                         CertificateRequest*
 *                              <--------      ServerHelloDone
 * Certificate*
 * ClientKeyExchange
 * CertificateVerify*
 * [ChangeCipherSpec]
 * Finished                     -------->
 *                                          [ChangeCipherSpec]
 *                              <--------             Finished
 * Application Data             <------->     Application Data
 *
 * =====================SESSION RESUMPTION=====================
 * Client                                                Server
 *
 * ClientHello                   -------->
 *                                                  ServerHello
 *                                           [ChangeCipherSpec]
 *                               <--------             Finished
 * [ChangeCipherSpec]
 * Finished                      -------->
 * Application Data              <------->     Application Data
 */ // client expect states (indicate which records are expected to be received)
var $087e807083257150$var$SHE = 0; // rcv server hello
var $087e807083257150$var$SCE = 1; // rcv server certificate
var $087e807083257150$var$SKE = 2; // rcv server key exchange
var $087e807083257150$var$SCR = 3; // rcv certificate request
var $087e807083257150$var$SHD = 4; // rcv server hello done
var $087e807083257150$var$SCC = 5; // rcv change cipher spec
var $087e807083257150$var$SFI = 6; // rcv finished
var $087e807083257150$var$SAD = 7; // rcv application data
var $087e807083257150$var$SER = 8; // not expecting any messages at this point
// server expect states
var $087e807083257150$var$CHE = 0; // rcv client hello
var $087e807083257150$var$CCE = 1; // rcv client certificate
var $087e807083257150$var$CKE = 2; // rcv client key exchange
var $087e807083257150$var$CCV = 3; // rcv certificate verify
var $087e807083257150$var$CCC = 4; // rcv change cipher spec
var $087e807083257150$var$CFI = 5; // rcv finished
var $087e807083257150$var$CAD = 6; // rcv application data
var $087e807083257150$var$CER = 7; // not expecting any messages at this point
// map client current expect state and content type to function
var $087e807083257150$var$__ = $087e807083257150$var$tls.handleUnexpected;
var $087e807083257150$var$R0 = $087e807083257150$var$tls.handleChangeCipherSpec;
var $087e807083257150$var$R1 = $087e807083257150$var$tls.handleAlert;
var $087e807083257150$var$R2 = $087e807083257150$var$tls.handleHandshake;
var $087e807083257150$var$R3 = $087e807083257150$var$tls.handleApplicationData;
var $087e807083257150$var$R4 = $087e807083257150$var$tls.handleHeartbeat;
var $087e807083257150$var$ctTable = [];
$087e807083257150$var$ctTable[$087e807083257150$var$tls.ConnectionEnd.client] = [
    //      CC,AL,HS,AD,HB
    /*SHE*/ [
        $087e807083257150$var$__,
        $087e807083257150$var$R1,
        $087e807083257150$var$R2,
        $087e807083257150$var$__,
        $087e807083257150$var$R4
    ],
    /*SCE*/ [
        $087e807083257150$var$__,
        $087e807083257150$var$R1,
        $087e807083257150$var$R2,
        $087e807083257150$var$__,
        $087e807083257150$var$R4
    ],
    /*SKE*/ [
        $087e807083257150$var$__,
        $087e807083257150$var$R1,
        $087e807083257150$var$R2,
        $087e807083257150$var$__,
        $087e807083257150$var$R4
    ],
    /*SCR*/ [
        $087e807083257150$var$__,
        $087e807083257150$var$R1,
        $087e807083257150$var$R2,
        $087e807083257150$var$__,
        $087e807083257150$var$R4
    ],
    /*SHD*/ [
        $087e807083257150$var$__,
        $087e807083257150$var$R1,
        $087e807083257150$var$R2,
        $087e807083257150$var$__,
        $087e807083257150$var$R4
    ],
    /*SCC*/ [
        $087e807083257150$var$R0,
        $087e807083257150$var$R1,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$R4
    ],
    /*SFI*/ [
        $087e807083257150$var$__,
        $087e807083257150$var$R1,
        $087e807083257150$var$R2,
        $087e807083257150$var$__,
        $087e807083257150$var$R4
    ],
    /*SAD*/ [
        $087e807083257150$var$__,
        $087e807083257150$var$R1,
        $087e807083257150$var$R2,
        $087e807083257150$var$R3,
        $087e807083257150$var$R4
    ],
    /*SER*/ [
        $087e807083257150$var$__,
        $087e807083257150$var$R1,
        $087e807083257150$var$R2,
        $087e807083257150$var$__,
        $087e807083257150$var$R4
    ]
];
// map server current expect state and content type to function
$087e807083257150$var$ctTable[$087e807083257150$var$tls.ConnectionEnd.server] = [
    //      CC,AL,HS,AD
    /*CHE*/ [
        $087e807083257150$var$__,
        $087e807083257150$var$R1,
        $087e807083257150$var$R2,
        $087e807083257150$var$__,
        $087e807083257150$var$R4
    ],
    /*CCE*/ [
        $087e807083257150$var$__,
        $087e807083257150$var$R1,
        $087e807083257150$var$R2,
        $087e807083257150$var$__,
        $087e807083257150$var$R4
    ],
    /*CKE*/ [
        $087e807083257150$var$__,
        $087e807083257150$var$R1,
        $087e807083257150$var$R2,
        $087e807083257150$var$__,
        $087e807083257150$var$R4
    ],
    /*CCV*/ [
        $087e807083257150$var$__,
        $087e807083257150$var$R1,
        $087e807083257150$var$R2,
        $087e807083257150$var$__,
        $087e807083257150$var$R4
    ],
    /*CCC*/ [
        $087e807083257150$var$R0,
        $087e807083257150$var$R1,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$R4
    ],
    /*CFI*/ [
        $087e807083257150$var$__,
        $087e807083257150$var$R1,
        $087e807083257150$var$R2,
        $087e807083257150$var$__,
        $087e807083257150$var$R4
    ],
    /*CAD*/ [
        $087e807083257150$var$__,
        $087e807083257150$var$R1,
        $087e807083257150$var$R2,
        $087e807083257150$var$R3,
        $087e807083257150$var$R4
    ],
    /*CER*/ [
        $087e807083257150$var$__,
        $087e807083257150$var$R1,
        $087e807083257150$var$R2,
        $087e807083257150$var$__,
        $087e807083257150$var$R4
    ]
];
// map client current expect state and handshake type to function
var $087e807083257150$var$H0 = $087e807083257150$var$tls.handleHelloRequest;
var $087e807083257150$var$H1 = $087e807083257150$var$tls.handleServerHello;
var $087e807083257150$var$H2 = $087e807083257150$var$tls.handleCertificate;
var $087e807083257150$var$H3 = $087e807083257150$var$tls.handleServerKeyExchange;
var $087e807083257150$var$H4 = $087e807083257150$var$tls.handleCertificateRequest;
var $087e807083257150$var$H5 = $087e807083257150$var$tls.handleServerHelloDone;
var $087e807083257150$var$H6 = $087e807083257150$var$tls.handleFinished;
var $087e807083257150$var$hsTable = [];
$087e807083257150$var$hsTable[$087e807083257150$var$tls.ConnectionEnd.client] = [
    //      HR,01,SH,03,04,05,06,07,08,09,10,SC,SK,CR,HD,15,CK,17,18,19,FI
    /*SHE*/ [
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$H1,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__
    ],
    /*SCE*/ [
        $087e807083257150$var$H0,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$H2,
        $087e807083257150$var$H3,
        $087e807083257150$var$H4,
        $087e807083257150$var$H5,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__
    ],
    /*SKE*/ [
        $087e807083257150$var$H0,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$H3,
        $087e807083257150$var$H4,
        $087e807083257150$var$H5,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__
    ],
    /*SCR*/ [
        $087e807083257150$var$H0,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$H4,
        $087e807083257150$var$H5,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__
    ],
    /*SHD*/ [
        $087e807083257150$var$H0,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$H5,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__
    ],
    /*SCC*/ [
        $087e807083257150$var$H0,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__
    ],
    /*SFI*/ [
        $087e807083257150$var$H0,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$H6
    ],
    /*SAD*/ [
        $087e807083257150$var$H0,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__
    ],
    /*SER*/ [
        $087e807083257150$var$H0,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__
    ]
];
// map server current expect state and handshake type to function
// Note: CAD[CH] does not map to FB because renegotation is prohibited
var $087e807083257150$var$H7 = $087e807083257150$var$tls.handleClientHello;
var $087e807083257150$var$H8 = $087e807083257150$var$tls.handleClientKeyExchange;
var $087e807083257150$var$H9 = $087e807083257150$var$tls.handleCertificateVerify;
$087e807083257150$var$hsTable[$087e807083257150$var$tls.ConnectionEnd.server] = [
    //      01,CH,02,03,04,05,06,07,08,09,10,CC,12,13,14,CV,CK,17,18,19,FI
    /*CHE*/ [
        $087e807083257150$var$__,
        $087e807083257150$var$H7,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__
    ],
    /*CCE*/ [
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$H2,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__
    ],
    /*CKE*/ [
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$H8,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__
    ],
    /*CCV*/ [
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$H9,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__
    ],
    /*CCC*/ [
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__
    ],
    /*CFI*/ [
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$H6
    ],
    /*CAD*/ [
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__
    ],
    /*CER*/ [
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__,
        $087e807083257150$var$__
    ]
];
/**
 * Generates the master_secret and keys using the given security parameters.
 *
 * The security parameters for a TLS connection state are defined as such:
 *
 * struct {
 *   ConnectionEnd          entity;
 *   PRFAlgorithm           prf_algorithm;
 *   BulkCipherAlgorithm    bulk_cipher_algorithm;
 *   CipherType             cipher_type;
 *   uint8                  enc_key_length;
 *   uint8                  block_length;
 *   uint8                  fixed_iv_length;
 *   uint8                  record_iv_length;
 *   MACAlgorithm           mac_algorithm;
 *   uint8                  mac_length;
 *   uint8                  mac_key_length;
 *   CompressionMethod      compression_algorithm;
 *   opaque                 master_secret[48];
 *   opaque                 client_random[32];
 *   opaque                 server_random[32];
 * } SecurityParameters;
 *
 * Note that this definition is from TLS 1.2. In TLS 1.0 some of these
 * parameters are ignored because, for instance, the PRFAlgorithm is a
 * builtin-fixed algorithm combining iterations of MD5 and SHA-1 in TLS 1.0.
 *
 * The Record Protocol requires an algorithm to generate keys required by the
 * current connection state.
 *
 * The master secret is expanded into a sequence of secure bytes, which is then
 * split to a client write MAC key, a server write MAC key, a client write
 * encryption key, and a server write encryption key. In TLS 1.0 a client write
 * IV and server write IV are also generated. Each of these is generated from
 * the byte sequence in that order. Unused values are empty. In TLS 1.2, some
 * AEAD ciphers may additionally require a client write IV and a server write
 * IV (see Section 6.2.3.3).
 *
 * When keys, MAC keys, and IVs are generated, the master secret is used as an
 * entropy source.
 *
 * To generate the key material, compute:
 *
 * master_secret = PRF(pre_master_secret, "master secret",
 *                     ClientHello.random + ServerHello.random)
 *
 * key_block = PRF(SecurityParameters.master_secret,
 *                 "key expansion",
 *                 SecurityParameters.server_random +
 *                 SecurityParameters.client_random);
 *
 * until enough output has been generated. Then, the key_block is
 * partitioned as follows:
 *
 * client_write_MAC_key[SecurityParameters.mac_key_length]
 * server_write_MAC_key[SecurityParameters.mac_key_length]
 * client_write_key[SecurityParameters.enc_key_length]
 * server_write_key[SecurityParameters.enc_key_length]
 * client_write_IV[SecurityParameters.fixed_iv_length]
 * server_write_IV[SecurityParameters.fixed_iv_length]
 *
 * In TLS 1.2, the client_write_IV and server_write_IV are only generated for
 * implicit nonce techniques as described in Section 3.2.1 of [AEAD]. This
 * implementation uses TLS 1.0 so IVs are generated.
 *
 * Implementation note: The currently defined cipher suite which requires the
 * most material is AES_256_CBC_SHA256. It requires 2 x 32 byte keys and 2 x 32
 * byte MAC keys, for a total 128 bytes of key material. In TLS 1.0 it also
 * requires 2 x 16 byte IVs, so it actually takes 160 bytes of key material.
 *
 * @param c the connection.
 * @param sp the security parameters to use.
 *
 * @return the security keys.
 */ $087e807083257150$var$tls.generateKeys = function(c, sp) {
    // TLS_RSA_WITH_AES_128_CBC_SHA (required to be compliant with TLS 1.2) &
    // TLS_RSA_WITH_AES_256_CBC_SHA are the only cipher suites implemented
    // at present
    // TLS_DHE_DSS_WITH_3DES_EDE_CBC_SHA is required to be compliant with
    // TLS 1.0 but we don't care right now because AES is better and we have
    // an implementation for it
    // TODO: TLS 1.2 implementation
    /*
  // determine the PRF
  var prf;
  switch(sp.prf_algorithm) {
  case tls.PRFAlgorithm.tls_prf_sha256:
    prf = prf_sha256;
    break;
  default:
    // should never happen
    throw new Error('Invalid PRF');
  }
  */ // TLS 1.0/1.1 implementation
    var prf = $087e807083257150$var$prf_TLS1;
    // concatenate server and client random
    var random = sp.client_random + sp.server_random;
    // only create master secret if session is new
    if (!c.session.resuming) {
        // create master secret, clean up pre-master secret
        sp.master_secret = prf(sp.pre_master_secret, 'master secret', random, 48).bytes();
        sp.pre_master_secret = null;
    }
    // generate the amount of key material needed
    random = sp.server_random + sp.client_random;
    var length = 2 * sp.mac_key_length + 2 * sp.enc_key_length;
    // include IV for TLS/1.0
    var tls10 = c.version.major === $087e807083257150$var$tls.Versions.TLS_1_0.major && c.version.minor === $087e807083257150$var$tls.Versions.TLS_1_0.minor;
    if (tls10) length += 2 * sp.fixed_iv_length;
    var km = prf(sp.master_secret, 'key expansion', random, length);
    // split the key material into the MAC and encryption keys
    var rval = {
        client_write_MAC_key: km.getBytes(sp.mac_key_length),
        server_write_MAC_key: km.getBytes(sp.mac_key_length),
        client_write_key: km.getBytes(sp.enc_key_length),
        server_write_key: km.getBytes(sp.enc_key_length)
    };
    // include TLS 1.0 IVs
    if (tls10) {
        rval.client_write_IV = km.getBytes(sp.fixed_iv_length);
        rval.server_write_IV = km.getBytes(sp.fixed_iv_length);
    }
    return rval;
};
/**
 * Creates a new initialized TLS connection state. A connection state has
 * a read mode and a write mode.
 *
 * compression state:
 *   The current state of the compression algorithm.
 *
 * cipher state:
 *   The current state of the encryption algorithm. This will consist of the
 *   scheduled key for that connection. For stream ciphers, this will also
 *   contain whatever state information is necessary to allow the stream to
 *   continue to encrypt or decrypt data.
 *
 * MAC key:
 *   The MAC key for the connection.
 *
 * sequence number:
 *   Each connection state contains a sequence number, which is maintained
 *   separately for read and write states. The sequence number MUST be set to
 *   zero whenever a connection state is made the active state. Sequence
 *   numbers are of type uint64 and may not exceed 2^64-1. Sequence numbers do
 *   not wrap. If a TLS implementation would need to wrap a sequence number,
 *   it must renegotiate instead. A sequence number is incremented after each
 *   record: specifically, the first record transmitted under a particular
 *   connection state MUST use sequence number 0.
 *
 * @param c the connection.
 *
 * @return the new initialized TLS connection state.
 */ $087e807083257150$var$tls.createConnectionState = function(c) {
    var client = c.entity === $087e807083257150$var$tls.ConnectionEnd.client;
    var createMode = function() {
        var mode = {
            // two 32-bit numbers, first is most significant
            sequenceNumber: [
                0,
                0
            ],
            macKey: null,
            macLength: 0,
            macFunction: null,
            cipherState: null,
            cipherFunction: function(record) {
                return true;
            },
            compressionState: null,
            compressFunction: function(record) {
                return true;
            },
            updateSequenceNumber: function() {
                if (mode.sequenceNumber[1] === 0xFFFFFFFF) {
                    mode.sequenceNumber[1] = 0;
                    ++mode.sequenceNumber[0];
                } else ++mode.sequenceNumber[1];
            }
        };
        return mode;
    };
    var state = {
        read: createMode(),
        write: createMode()
    };
    // update function in read mode will decrypt then decompress a record
    state.read.update = function(c, record) {
        if (!state.read.cipherFunction(record, state.read)) c.error(c, {
            message: 'Could not decrypt record or bad MAC.',
            send: true,
            alert: {
                level: $087e807083257150$var$tls.Alert.Level.fatal,
                // doesn't matter if decryption failed or MAC was
                // invalid, return the same error so as not to reveal
                // which one occurred
                description: $087e807083257150$var$tls.Alert.Description.bad_record_mac
            }
        });
        else if (!state.read.compressFunction(c, record, state.read)) c.error(c, {
            message: 'Could not decompress record.',
            send: true,
            alert: {
                level: $087e807083257150$var$tls.Alert.Level.fatal,
                description: $087e807083257150$var$tls.Alert.Description.decompression_failure
            }
        });
        return !c.fail;
    };
    // update function in write mode will compress then encrypt a record
    state.write.update = function(c, record) {
        if (!state.write.compressFunction(c, record, state.write)) // error, but do not send alert since it would require
        // compression as well
        c.error(c, {
            message: 'Could not compress record.',
            send: false,
            alert: {
                level: $087e807083257150$var$tls.Alert.Level.fatal,
                description: $087e807083257150$var$tls.Alert.Description.internal_error
            }
        });
        else if (!state.write.cipherFunction(record, state.write)) // error, but do not send alert since it would require
        // encryption as well
        c.error(c, {
            message: 'Could not encrypt record.',
            send: false,
            alert: {
                level: $087e807083257150$var$tls.Alert.Level.fatal,
                description: $087e807083257150$var$tls.Alert.Description.internal_error
            }
        });
        return !c.fail;
    };
    // handle security parameters
    if (c.session) {
        var sp = c.session.sp;
        c.session.cipherSuite.initSecurityParameters(sp);
        // generate keys
        sp.keys = $087e807083257150$var$tls.generateKeys(c, sp);
        state.read.macKey = client ? sp.keys.server_write_MAC_key : sp.keys.client_write_MAC_key;
        state.write.macKey = client ? sp.keys.client_write_MAC_key : sp.keys.server_write_MAC_key;
        // cipher suite setup
        c.session.cipherSuite.initConnectionState(state, c, sp);
        // compression setup
        switch(sp.compression_algorithm){
            case $087e807083257150$var$tls.CompressionMethod.none:
                break;
            case $087e807083257150$var$tls.CompressionMethod.deflate:
                state.read.compressFunction = $087e807083257150$var$inflate;
                state.write.compressFunction = $087e807083257150$var$deflate;
                break;
            default:
                throw new Error('Unsupported compression algorithm.');
        }
    }
    return state;
};
/**
 * Creates a Random structure.
 *
 * struct {
 *   uint32 gmt_unix_time;
 *   opaque random_bytes[28];
 * } Random;
 *
 * gmt_unix_time:
 *   The current time and date in standard UNIX 32-bit format (seconds since
 *   the midnight starting Jan 1, 1970, UTC, ignoring leap seconds) according
 *   to the sender's internal clock. Clocks are not required to be set
 *   correctly by the basic TLS protocol; higher-level or application
 *   protocols may define additional requirements. Note that, for historical
 *   reasons, the data element is named using GMT, the predecessor of the
 *   current worldwide time base, UTC.
 * random_bytes:
 *   28 bytes generated by a secure random number generator.
 *
 * @return the Random structure as a byte array.
 */ $087e807083257150$var$tls.createRandom = function() {
    // get UTC milliseconds
    var d = new Date();
    var utc = +d + d.getTimezoneOffset() * 60000;
    var rval = $cLQG7.util.createBuffer();
    rval.putInt32(utc);
    rval.putBytes($cLQG7.random.getBytes(28));
    return rval;
};
/**
 * Creates a TLS record with the given type and data.
 *
 * @param c the connection.
 * @param options:
 *   type: the record type.
 *   data: the plain text data in a byte buffer.
 *
 * @return the created record.
 */ $087e807083257150$var$tls.createRecord = function(c, options) {
    if (!options.data) return null;
    var record = {
        type: options.type,
        version: {
            major: c.version.major,
            minor: c.version.minor
        },
        length: options.data.length(),
        fragment: options.data
    };
    return record;
};
/**
 * Creates a TLS alert record.
 *
 * @param c the connection.
 * @param alert:
 *   level: the TLS alert level.
 *   description: the TLS alert description.
 *
 * @return the created alert record.
 */ $087e807083257150$var$tls.createAlert = function(c, alert) {
    var b = $cLQG7.util.createBuffer();
    b.putByte(alert.level);
    b.putByte(alert.description);
    return $087e807083257150$var$tls.createRecord(c, {
        type: $087e807083257150$var$tls.ContentType.alert,
        data: b
    });
};
/* The structure of a TLS handshake message.
 *
 * struct {
 *    HandshakeType msg_type;    // handshake type
 *    uint24 length;             // bytes in message
 *    select(HandshakeType) {
 *       case hello_request:       HelloRequest;
 *       case client_hello:        ClientHello;
 *       case server_hello:        ServerHello;
 *       case certificate:         Certificate;
 *       case server_key_exchange: ServerKeyExchange;
 *       case certificate_request: CertificateRequest;
 *       case server_hello_done:   ServerHelloDone;
 *       case certificate_verify:  CertificateVerify;
 *       case client_key_exchange: ClientKeyExchange;
 *       case finished:            Finished;
 *    } body;
 * } Handshake;
 */ /**
 * Creates a ClientHello message.
 *
 * opaque SessionID<0..32>;
 * enum { null(0), deflate(1), (255) } CompressionMethod;
 * uint8 CipherSuite[2];
 *
 * struct {
 *   ProtocolVersion client_version;
 *   Random random;
 *   SessionID session_id;
 *   CipherSuite cipher_suites<2..2^16-2>;
 *   CompressionMethod compression_methods<1..2^8-1>;
 *   select(extensions_present) {
 *     case false:
 *       struct {};
 *     case true:
 *       Extension extensions<0..2^16-1>;
 *   };
 * } ClientHello;
 *
 * The extension format for extended client hellos and server hellos is:
 *
 * struct {
 *   ExtensionType extension_type;
 *   opaque extension_data<0..2^16-1>;
 * } Extension;
 *
 * Here:
 *
 * - "extension_type" identifies the particular extension type.
 * - "extension_data" contains information specific to the particular
 * extension type.
 *
 * The extension types defined in this document are:
 *
 * enum {
 *   server_name(0), max_fragment_length(1),
 *   client_certificate_url(2), trusted_ca_keys(3),
 *   truncated_hmac(4), status_request(5), (65535)
 * } ExtensionType;
 *
 * @param c the connection.
 *
 * @return the ClientHello byte buffer.
 */ $087e807083257150$var$tls.createClientHello = function(c) {
    // save hello version
    c.session.clientHelloVersion = {
        major: c.version.major,
        minor: c.version.minor
    };
    // create supported cipher suites
    var cipherSuites = $cLQG7.util.createBuffer();
    for(var i = 0; i < c.cipherSuites.length; ++i){
        var cs = c.cipherSuites[i];
        cipherSuites.putByte(cs.id[0]);
        cipherSuites.putByte(cs.id[1]);
    }
    var cSuites = cipherSuites.length();
    // create supported compression methods, null always supported, but
    // also support deflate if connection has inflate and deflate methods
    var compressionMethods = $cLQG7.util.createBuffer();
    compressionMethods.putByte($087e807083257150$var$tls.CompressionMethod.none);
    // FIXME: deflate support disabled until issues with raw deflate data
    // without zlib headers are resolved
    /*
  if(c.inflate !== null && c.deflate !== null) {
    compressionMethods.putByte(tls.CompressionMethod.deflate);
  }
  */ var cMethods = compressionMethods.length();
    // create TLS SNI (server name indication) extension if virtual host
    // has been specified, see RFC 3546
    var extensions = $cLQG7.util.createBuffer();
    if (c.virtualHost) {
        // create extension struct
        var ext = $cLQG7.util.createBuffer();
        ext.putByte(0x00); // type server_name (ExtensionType is 2 bytes)
        ext.putByte(0x00);
        /* In order to provide the server name, clients MAY include an
     * extension of type "server_name" in the (extended) client hello.
     * The "extension_data" field of this extension SHALL contain
     * "ServerNameList" where:
     *
     * struct {
     *   NameType name_type;
     *   select(name_type) {
     *     case host_name: HostName;
     *   } name;
     * } ServerName;
     *
     * enum {
     *   host_name(0), (255)
     * } NameType;
     *
     * opaque HostName<1..2^16-1>;
     *
     * struct {
     *   ServerName server_name_list<1..2^16-1>
     * } ServerNameList;
     */ var serverName = $cLQG7.util.createBuffer();
        serverName.putByte(0x00); // type host_name
        $087e807083257150$var$writeVector(serverName, 2, $cLQG7.util.createBuffer(c.virtualHost));
        // ServerNameList is in extension_data
        var snList = $cLQG7.util.createBuffer();
        $087e807083257150$var$writeVector(snList, 2, serverName);
        $087e807083257150$var$writeVector(ext, 2, snList);
        extensions.putBuffer(ext);
    }
    var extLength = extensions.length();
    if (extLength > 0) // add extension vector length
    extLength += 2;
    // determine length of the handshake message
    // cipher suites and compression methods size will need to be
    // updated if more get added to the list
    var sessionId = c.session.id;
    var length = sessionId.length + 1 + // session ID vector
    2 + // version (major + minor)
    4 + 28 + // random time and random bytes
    2 + cSuites + // cipher suites vector
    1 + cMethods + // compression methods vector
    extLength; // extensions vector
    // build record fragment
    var rval = $cLQG7.util.createBuffer();
    rval.putByte($087e807083257150$var$tls.HandshakeType.client_hello);
    rval.putInt24(length); // handshake length
    rval.putByte(c.version.major); // major version
    rval.putByte(c.version.minor); // minor version
    rval.putBytes(c.session.sp.client_random); // random time + bytes
    $087e807083257150$var$writeVector(rval, 1, $cLQG7.util.createBuffer(sessionId));
    $087e807083257150$var$writeVector(rval, 2, cipherSuites);
    $087e807083257150$var$writeVector(rval, 1, compressionMethods);
    if (extLength > 0) $087e807083257150$var$writeVector(rval, 2, extensions);
    return rval;
};
/**
 * Creates a ServerHello message.
 *
 * @param c the connection.
 *
 * @return the ServerHello byte buffer.
 */ $087e807083257150$var$tls.createServerHello = function(c) {
    // determine length of the handshake message
    var sessionId = c.session.id;
    var length = sessionId.length + 1 + // session ID vector
    2 + // version (major + minor)
    4 + 28 + // random time and random bytes
    2 + // chosen cipher suite
    1; // chosen compression method
    // build record fragment
    var rval = $cLQG7.util.createBuffer();
    rval.putByte($087e807083257150$var$tls.HandshakeType.server_hello);
    rval.putInt24(length); // handshake length
    rval.putByte(c.version.major); // major version
    rval.putByte(c.version.minor); // minor version
    rval.putBytes(c.session.sp.server_random); // random time + bytes
    $087e807083257150$var$writeVector(rval, 1, $cLQG7.util.createBuffer(sessionId));
    rval.putByte(c.session.cipherSuite.id[0]);
    rval.putByte(c.session.cipherSuite.id[1]);
    rval.putByte(c.session.compressionMethod);
    return rval;
};
/**
 * Creates a Certificate message.
 *
 * When this message will be sent:
 *   This is the first message the client can send after receiving a server
 *   hello done message and the first message the server can send after
 *   sending a ServerHello. This client message is only sent if the server
 *   requests a certificate. If no suitable certificate is available, the
 *   client should send a certificate message containing no certificates. If
 *   client authentication is required by the server for the handshake to
 *   continue, it may respond with a fatal handshake failure alert.
 *
 * opaque ASN.1Cert<1..2^24-1>;
 *
 * struct {
 *   ASN.1Cert certificate_list<0..2^24-1>;
 * } Certificate;
 *
 * @param c the connection.
 *
 * @return the Certificate byte buffer.
 */ $087e807083257150$var$tls.createCertificate = function(c) {
    // TODO: check certificate request to ensure types are supported
    // get a certificate (a certificate as a PEM string)
    var client = c.entity === $087e807083257150$var$tls.ConnectionEnd.client;
    var cert = null;
    if (c.getCertificate) {
        var hint;
        if (client) hint = c.session.certificateRequest;
        else hint = c.session.extensions.server_name.serverNameList;
        cert = c.getCertificate(c, hint);
    }
    // buffer to hold certificate list
    var certList = $cLQG7.util.createBuffer();
    if (cert !== null) try {
        // normalize cert to a chain of certificates
        if (!$cLQG7.util.isArray(cert)) cert = [
            cert
        ];
        var asn1 = null;
        for(var i = 0; i < cert.length; ++i){
            var msg = $cLQG7.pem.decode(cert[i])[0];
            if (msg.type !== 'CERTIFICATE' && msg.type !== 'X509 CERTIFICATE' && msg.type !== 'TRUSTED CERTIFICATE') {
                var error = new Error('Could not convert certificate from PEM; PEM header type is not "CERTIFICATE", "X509 CERTIFICATE", or "TRUSTED CERTIFICATE".');
                error.headerType = msg.type;
                throw error;
            }
            if (msg.procType && msg.procType.type === 'ENCRYPTED') throw new Error('Could not convert certificate from PEM; PEM is encrypted.');
            var der = $cLQG7.util.createBuffer(msg.body);
            if (asn1 === null) asn1 = $cLQG7.asn1.fromDer(der.bytes(), false);
            // certificate entry is itself a vector with 3 length bytes
            var certBuffer = $cLQG7.util.createBuffer();
            $087e807083257150$var$writeVector(certBuffer, 3, der);
            // add cert vector to cert list vector
            certList.putBuffer(certBuffer);
        }
        // save certificate
        cert = $cLQG7.pki.certificateFromAsn1(asn1);
        if (client) c.session.clientCertificate = cert;
        else c.session.serverCertificate = cert;
    } catch (ex) {
        return c.error(c, {
            message: 'Could not send certificate list.',
            cause: ex,
            send: true,
            alert: {
                level: $087e807083257150$var$tls.Alert.Level.fatal,
                description: $087e807083257150$var$tls.Alert.Description.bad_certificate
            }
        });
    }
    // determine length of the handshake message
    var length = 3 + certList.length(); // cert list vector
    // build record fragment
    var rval = $cLQG7.util.createBuffer();
    rval.putByte($087e807083257150$var$tls.HandshakeType.certificate);
    rval.putInt24(length);
    $087e807083257150$var$writeVector(rval, 3, certList);
    return rval;
};
/**
 * Creates a ClientKeyExchange message.
 *
 * When this message will be sent:
 *   This message is always sent by the client. It will immediately follow the
 *   client certificate message, if it is sent. Otherwise it will be the first
 *   message sent by the client after it receives the server hello done
 *   message.
 *
 * Meaning of this message:
 *   With this message, the premaster secret is set, either though direct
 *   transmission of the RSA-encrypted secret, or by the transmission of
 *   Diffie-Hellman parameters which will allow each side to agree upon the
 *   same premaster secret. When the key exchange method is DH_RSA or DH_DSS,
 *   client certification has been requested, and the client was able to
 *   respond with a certificate which contained a Diffie-Hellman public key
 *   whose parameters (group and generator) matched those specified by the
 *   server in its certificate, this message will not contain any data.
 *
 * Meaning of this message:
 *   If RSA is being used for key agreement and authentication, the client
 *   generates a 48-byte premaster secret, encrypts it using the public key
 *   from the server's certificate or the temporary RSA key provided in a
 *   server key exchange message, and sends the result in an encrypted
 *   premaster secret message. This structure is a variant of the client
 *   key exchange message, not a message in itself.
 *
 * struct {
 *   select(KeyExchangeAlgorithm) {
 *     case rsa: EncryptedPreMasterSecret;
 *     case diffie_hellman: ClientDiffieHellmanPublic;
 *   } exchange_keys;
 * } ClientKeyExchange;
 *
 * struct {
 *   ProtocolVersion client_version;
 *   opaque random[46];
 * } PreMasterSecret;
 *
 * struct {
 *   public-key-encrypted PreMasterSecret pre_master_secret;
 * } EncryptedPreMasterSecret;
 *
 * A public-key-encrypted element is encoded as a vector <0..2^16-1>.
 *
 * @param c the connection.
 *
 * @return the ClientKeyExchange byte buffer.
 */ $087e807083257150$var$tls.createClientKeyExchange = function(c) {
    // create buffer to encrypt
    var b = $cLQG7.util.createBuffer();
    // add highest client-supported protocol to help server avoid version
    // rollback attacks
    b.putByte(c.session.clientHelloVersion.major);
    b.putByte(c.session.clientHelloVersion.minor);
    // generate and add 46 random bytes
    b.putBytes($cLQG7.random.getBytes(46));
    // save pre-master secret
    var sp = c.session.sp;
    sp.pre_master_secret = b.getBytes();
    // RSA-encrypt the pre-master secret
    var key = c.session.serverCertificate.publicKey;
    b = key.encrypt(sp.pre_master_secret);
    /* Note: The encrypted pre-master secret will be stored in a
    public-key-encrypted opaque vector that has the length prefixed using
    2 bytes, so include those 2 bytes in the handshake message length. This
    is done as a minor optimization instead of calling writeVector(). */ // determine length of the handshake message
    var length = b.length + 2;
    // build record fragment
    var rval = $cLQG7.util.createBuffer();
    rval.putByte($087e807083257150$var$tls.HandshakeType.client_key_exchange);
    rval.putInt24(length);
    // add vector length bytes
    rval.putInt16(b.length);
    rval.putBytes(b);
    return rval;
};
/**
 * Creates a ServerKeyExchange message.
 *
 * @param c the connection.
 *
 * @return the ServerKeyExchange byte buffer.
 */ $087e807083257150$var$tls.createServerKeyExchange = function(c) {
    // this implementation only supports RSA, no Diffie-Hellman support,
    // so this record is empty
    // determine length of the handshake message
    var length = 0;
    // build record fragment
    var rval = $cLQG7.util.createBuffer();
    if (length > 0) {
        rval.putByte($087e807083257150$var$tls.HandshakeType.server_key_exchange);
        rval.putInt24(length);
    }
    return rval;
};
/**
 * Gets the signed data used to verify a client-side certificate. See
 * tls.createCertificateVerify() for details.
 *
 * @param c the connection.
 * @param callback the callback to call once the signed data is ready.
 */ $087e807083257150$var$tls.getClientSignature = function(c, callback) {
    // generate data to RSA encrypt
    var b = $cLQG7.util.createBuffer();
    b.putBuffer(c.session.md5.digest());
    b.putBuffer(c.session.sha1.digest());
    b = b.getBytes();
    // create default signing function as necessary
    c.getSignature = c.getSignature || function(c, b, callback) {
        // do rsa encryption, call callback
        var privateKey = null;
        if (c.getPrivateKey) try {
            privateKey = c.getPrivateKey(c, c.session.clientCertificate);
            privateKey = $cLQG7.pki.privateKeyFromPem(privateKey);
        } catch (ex) {
            c.error(c, {
                message: 'Could not get private key.',
                cause: ex,
                send: true,
                alert: {
                    level: $087e807083257150$var$tls.Alert.Level.fatal,
                    description: $087e807083257150$var$tls.Alert.Description.internal_error
                }
            });
        }
        if (privateKey === null) c.error(c, {
            message: 'No private key set.',
            send: true,
            alert: {
                level: $087e807083257150$var$tls.Alert.Level.fatal,
                description: $087e807083257150$var$tls.Alert.Description.internal_error
            }
        });
        else b = privateKey.sign(b, null);
        callback(c, b);
    };
    // get client signature
    c.getSignature(c, b, callback);
};
/**
 * Creates a CertificateVerify message.
 *
 * Meaning of this message:
 *   This structure conveys the client's Diffie-Hellman public value
 *   (Yc) if it was not already included in the client's certificate.
 *   The encoding used for Yc is determined by the enumerated
 *   PublicValueEncoding. This structure is a variant of the client
 *   key exchange message, not a message in itself.
 *
 * When this message will be sent:
 *   This message is used to provide explicit verification of a client
 *   certificate. This message is only sent following a client
 *   certificate that has signing capability (i.e. all certificates
 *   except those containing fixed Diffie-Hellman parameters). When
 *   sent, it will immediately follow the client key exchange message.
 *
 * struct {
 *   Signature signature;
 * } CertificateVerify;
 *
 * CertificateVerify.signature.md5_hash
 *   MD5(handshake_messages);
 *
 * Certificate.signature.sha_hash
 *   SHA(handshake_messages);
 *
 * Here handshake_messages refers to all handshake messages sent or
 * received starting at client hello up to but not including this
 * message, including the type and length fields of the handshake
 * messages.
 *
 * select(SignatureAlgorithm) {
 *   case anonymous: struct { };
 *   case rsa:
 *     digitally-signed struct {
 *       opaque md5_hash[16];
 *       opaque sha_hash[20];
 *     };
 *   case dsa:
 *     digitally-signed struct {
 *       opaque sha_hash[20];
 *     };
 * } Signature;
 *
 * In digital signing, one-way hash functions are used as input for a
 * signing algorithm. A digitally-signed element is encoded as an opaque
 * vector <0..2^16-1>, where the length is specified by the signing
 * algorithm and key.
 *
 * In RSA signing, a 36-byte structure of two hashes (one SHA and one
 * MD5) is signed (encrypted with the private key). It is encoded with
 * PKCS #1 block type 0 or type 1 as described in [PKCS1].
 *
 * In DSS, the 20 bytes of the SHA hash are run directly through the
 * Digital Signing Algorithm with no additional hashing.
 *
 * @param c the connection.
 * @param signature the signature to include in the message.
 *
 * @return the CertificateVerify byte buffer.
 */ $087e807083257150$var$tls.createCertificateVerify = function(c, signature) {
    /* Note: The signature will be stored in a "digitally-signed" opaque
    vector that has the length prefixed using 2 bytes, so include those
    2 bytes in the handshake message length. This is done as a minor
    optimization instead of calling writeVector(). */ // determine length of the handshake message
    var length = signature.length + 2;
    // build record fragment
    var rval = $cLQG7.util.createBuffer();
    rval.putByte($087e807083257150$var$tls.HandshakeType.certificate_verify);
    rval.putInt24(length);
    // add vector length bytes
    rval.putInt16(signature.length);
    rval.putBytes(signature);
    return rval;
};
/**
 * Creates a CertificateRequest message.
 *
 * @param c the connection.
 *
 * @return the CertificateRequest byte buffer.
 */ $087e807083257150$var$tls.createCertificateRequest = function(c) {
    // TODO: support other certificate types
    var certTypes = $cLQG7.util.createBuffer();
    // common RSA certificate type
    certTypes.putByte(0x01);
    // add distinguished names from CA store
    var cAs = $cLQG7.util.createBuffer();
    for(var key in c.caStore.certs){
        var cert = c.caStore.certs[key];
        var dn = $cLQG7.pki.distinguishedNameToAsn1(cert.subject);
        var byteBuffer = $cLQG7.asn1.toDer(dn);
        cAs.putInt16(byteBuffer.length());
        cAs.putBuffer(byteBuffer);
    }
    // TODO: TLS 1.2+ has a different format
    // determine length of the handshake message
    var length = 1 + certTypes.length() + 2 + cAs.length();
    // build record fragment
    var rval = $cLQG7.util.createBuffer();
    rval.putByte($087e807083257150$var$tls.HandshakeType.certificate_request);
    rval.putInt24(length);
    $087e807083257150$var$writeVector(rval, 1, certTypes);
    $087e807083257150$var$writeVector(rval, 2, cAs);
    return rval;
};
/**
 * Creates a ServerHelloDone message.
 *
 * @param c the connection.
 *
 * @return the ServerHelloDone byte buffer.
 */ $087e807083257150$var$tls.createServerHelloDone = function(c) {
    // build record fragment
    var rval = $cLQG7.util.createBuffer();
    rval.putByte($087e807083257150$var$tls.HandshakeType.server_hello_done);
    rval.putInt24(0);
    return rval;
};
/**
 * Creates a ChangeCipherSpec message.
 *
 * The change cipher spec protocol exists to signal transitions in
 * ciphering strategies. The protocol consists of a single message,
 * which is encrypted and compressed under the current (not the pending)
 * connection state. The message consists of a single byte of value 1.
 *
 * struct {
 *   enum { change_cipher_spec(1), (255) } type;
 * } ChangeCipherSpec;
 *
 * @return the ChangeCipherSpec byte buffer.
 */ $087e807083257150$var$tls.createChangeCipherSpec = function() {
    var rval = $cLQG7.util.createBuffer();
    rval.putByte(0x01);
    return rval;
};
/**
 * Creates a Finished message.
 *
 * struct {
 *   opaque verify_data[12];
 * } Finished;
 *
 * verify_data
 *   PRF(master_secret, finished_label, MD5(handshake_messages) +
 *   SHA-1(handshake_messages)) [0..11];
 *
 * finished_label
 *   For Finished messages sent by the client, the string "client
 *   finished". For Finished messages sent by the server, the
 *   string "server finished".
 *
 * handshake_messages
 *   All of the data from all handshake messages up to but not
 *   including this message. This is only data visible at the
 *   handshake layer and does not include record layer headers.
 *   This is the concatenation of all the Handshake structures as
 *   defined in 7.4 exchanged thus far.
 *
 * @param c the connection.
 *
 * @return the Finished byte buffer.
 */ $087e807083257150$var$tls.createFinished = function(c) {
    // generate verify_data
    var b = $cLQG7.util.createBuffer();
    b.putBuffer(c.session.md5.digest());
    b.putBuffer(c.session.sha1.digest());
    // TODO: determine prf function and verify length for TLS 1.2
    var client = c.entity === $087e807083257150$var$tls.ConnectionEnd.client;
    var sp = c.session.sp;
    var vdl = 12;
    var prf = $087e807083257150$var$prf_TLS1;
    var label = client ? 'client finished' : 'server finished';
    b = prf(sp.master_secret, label, b.getBytes(), vdl);
    // build record fragment
    var rval = $cLQG7.util.createBuffer();
    rval.putByte($087e807083257150$var$tls.HandshakeType.finished);
    rval.putInt24(b.length());
    rval.putBuffer(b);
    return rval;
};
/**
 * Creates a HeartbeatMessage (See RFC 6520).
 *
 * struct {
 *   HeartbeatMessageType type;
 *   uint16 payload_length;
 *   opaque payload[HeartbeatMessage.payload_length];
 *   opaque padding[padding_length];
 * } HeartbeatMessage;
 *
 * The total length of a HeartbeatMessage MUST NOT exceed 2^14 or
 * max_fragment_length when negotiated as defined in [RFC6066].
 *
 * type: The message type, either heartbeat_request or heartbeat_response.
 *
 * payload_length: The length of the payload.
 *
 * payload: The payload consists of arbitrary content.
 *
 * padding: The padding is random content that MUST be ignored by the
 *   receiver. The length of a HeartbeatMessage is TLSPlaintext.length
 *   for TLS and DTLSPlaintext.length for DTLS. Furthermore, the
 *   length of the type field is 1 byte, and the length of the
 *   payload_length is 2. Therefore, the padding_length is
 *   TLSPlaintext.length - payload_length - 3 for TLS and
 *   DTLSPlaintext.length - payload_length - 3 for DTLS. The
 *   padding_length MUST be at least 16.
 *
 * The sender of a HeartbeatMessage MUST use a random padding of at
 * least 16 bytes. The padding of a received HeartbeatMessage message
 * MUST be ignored.
 *
 * If the payload_length of a received HeartbeatMessage is too large,
 * the received HeartbeatMessage MUST be discarded silently.
 *
 * @param c the connection.
 * @param type the tls.HeartbeatMessageType.
 * @param payload the heartbeat data to send as the payload.
 * @param [payloadLength] the payload length to use, defaults to the
 *          actual payload length.
 *
 * @return the HeartbeatRequest byte buffer.
 */ $087e807083257150$var$tls.createHeartbeat = function(type, payload, payloadLength) {
    if (typeof payloadLength === 'undefined') payloadLength = payload.length;
    // build record fragment
    var rval = $cLQG7.util.createBuffer();
    rval.putByte(type); // heartbeat message type
    rval.putInt16(payloadLength); // payload length
    rval.putBytes(payload); // payload
    // padding
    var plaintextLength = rval.length();
    var paddingLength = Math.max(16, plaintextLength - payloadLength - 3);
    rval.putBytes($cLQG7.random.getBytes(paddingLength));
    return rval;
};
/**
 * Fragments, compresses, encrypts, and queues a record for delivery.
 *
 * @param c the connection.
 * @param record the record to queue.
 */ $087e807083257150$var$tls.queue = function(c, record) {
    // error during record creation
    if (!record) return;
    if (record.fragment.length() === 0) {
        if (record.type === $087e807083257150$var$tls.ContentType.handshake || record.type === $087e807083257150$var$tls.ContentType.alert || record.type === $087e807083257150$var$tls.ContentType.change_cipher_spec) // Empty handshake, alert of change cipher spec messages are not allowed per the TLS specification and should not be sent.
        return;
    }
    // if the record is a handshake record, update handshake hashes
    if (record.type === $087e807083257150$var$tls.ContentType.handshake) {
        var bytes = record.fragment.bytes();
        c.session.md5.update(bytes);
        c.session.sha1.update(bytes);
        bytes = null;
    }
    // handle record fragmentation
    var records;
    if (record.fragment.length() <= $087e807083257150$var$tls.MaxFragment) records = [
        record
    ];
    else {
        // fragment data as long as it is too long
        records = [];
        var data = record.fragment.bytes();
        while(data.length > $087e807083257150$var$tls.MaxFragment){
            records.push($087e807083257150$var$tls.createRecord(c, {
                type: record.type,
                data: $cLQG7.util.createBuffer(data.slice(0, $087e807083257150$var$tls.MaxFragment))
            }));
            data = data.slice($087e807083257150$var$tls.MaxFragment);
        }
        // add last record
        if (data.length > 0) records.push($087e807083257150$var$tls.createRecord(c, {
            type: record.type,
            data: $cLQG7.util.createBuffer(data)
        }));
    }
    // compress and encrypt all fragmented records
    for(var i = 0; i < records.length && !c.fail; ++i){
        // update the record using current write state
        var rec = records[i];
        var s = c.state.current.write;
        if (s.update(c, rec)) // store record
        c.records.push(rec);
    }
};
/**
 * Flushes all queued records to the output buffer and calls the
 * tlsDataReady() handler on the given connection.
 *
 * @param c the connection.
 *
 * @return true on success, false on failure.
 */ $087e807083257150$var$tls.flush = function(c) {
    for(var i = 0; i < c.records.length; ++i){
        var record = c.records[i];
        // add record header and fragment
        c.tlsData.putByte(record.type);
        c.tlsData.putByte(record.version.major);
        c.tlsData.putByte(record.version.minor);
        c.tlsData.putInt16(record.fragment.length());
        c.tlsData.putBuffer(c.records[i].fragment);
    }
    c.records = [];
    return c.tlsDataReady(c);
};
/**
 * Maps a pki.certificateError to a tls.Alert.Description.
 *
 * @param error the error to map.
 *
 * @return the alert description.
 */ var $087e807083257150$var$_certErrorToAlertDesc = function(error) {
    switch(error){
        case true:
            return true;
        case $cLQG7.pki.certificateError.bad_certificate:
            return $087e807083257150$var$tls.Alert.Description.bad_certificate;
        case $cLQG7.pki.certificateError.unsupported_certificate:
            return $087e807083257150$var$tls.Alert.Description.unsupported_certificate;
        case $cLQG7.pki.certificateError.certificate_revoked:
            return $087e807083257150$var$tls.Alert.Description.certificate_revoked;
        case $cLQG7.pki.certificateError.certificate_expired:
            return $087e807083257150$var$tls.Alert.Description.certificate_expired;
        case $cLQG7.pki.certificateError.certificate_unknown:
            return $087e807083257150$var$tls.Alert.Description.certificate_unknown;
        case $cLQG7.pki.certificateError.unknown_ca:
            return $087e807083257150$var$tls.Alert.Description.unknown_ca;
        default:
            return $087e807083257150$var$tls.Alert.Description.bad_certificate;
    }
};
/**
 * Maps a tls.Alert.Description to a pki.certificateError.
 *
 * @param desc the alert description.
 *
 * @return the certificate error.
 */ var $087e807083257150$var$_alertDescToCertError = function(desc) {
    switch(desc){
        case true:
            return true;
        case $087e807083257150$var$tls.Alert.Description.bad_certificate:
            return $cLQG7.pki.certificateError.bad_certificate;
        case $087e807083257150$var$tls.Alert.Description.unsupported_certificate:
            return $cLQG7.pki.certificateError.unsupported_certificate;
        case $087e807083257150$var$tls.Alert.Description.certificate_revoked:
            return $cLQG7.pki.certificateError.certificate_revoked;
        case $087e807083257150$var$tls.Alert.Description.certificate_expired:
            return $cLQG7.pki.certificateError.certificate_expired;
        case $087e807083257150$var$tls.Alert.Description.certificate_unknown:
            return $cLQG7.pki.certificateError.certificate_unknown;
        case $087e807083257150$var$tls.Alert.Description.unknown_ca:
            return $cLQG7.pki.certificateError.unknown_ca;
        default:
            return $cLQG7.pki.certificateError.bad_certificate;
    }
};
/**
 * Verifies a certificate chain against the given connection's
 * Certificate Authority store.
 *
 * @param c the TLS connection.
 * @param chain the certificate chain to verify, with the root or highest
 *          authority at the end.
 *
 * @return true if successful, false if not.
 */ $087e807083257150$var$tls.verifyCertificateChain = function(c, chain) {
    try {
        // Make a copy of c.verifyOptions so that we can modify options.verify
        // without modifying c.verifyOptions.
        var options = {};
        for(var key in c.verifyOptions)options[key] = c.verifyOptions[key];
        options.verify = function(vfd, depth, chain) {
            // convert pki.certificateError to tls alert description
            var desc = $087e807083257150$var$_certErrorToAlertDesc(vfd);
            // call application callback
            var ret = c.verify(c, vfd, depth, chain);
            if (ret !== true) {
                if (typeof ret === 'object' && !$cLQG7.util.isArray(ret)) {
                    // throw custom error
                    var error = new Error('The application rejected the certificate.');
                    error.send = true;
                    error.alert = {
                        level: $087e807083257150$var$tls.Alert.Level.fatal,
                        description: $087e807083257150$var$tls.Alert.Description.bad_certificate
                    };
                    if (ret.message) error.message = ret.message;
                    if (ret.alert) error.alert.description = ret.alert;
                    throw error;
                }
                // convert tls alert description to pki.certificateError
                if (ret !== vfd) ret = $087e807083257150$var$_alertDescToCertError(ret);
            }
            return ret;
        };
        // verify chain
        $cLQG7.pki.verifyCertificateChain(c.caStore, chain, options);
    } catch (ex) {
        // build tls error if not already customized
        var err = ex;
        if (typeof err !== 'object' || $cLQG7.util.isArray(err)) err = {
            send: true,
            alert: {
                level: $087e807083257150$var$tls.Alert.Level.fatal,
                description: $087e807083257150$var$_certErrorToAlertDesc(ex)
            }
        };
        if (!('send' in err)) err.send = true;
        if (!('alert' in err)) err.alert = {
            level: $087e807083257150$var$tls.Alert.Level.fatal,
            description: $087e807083257150$var$_certErrorToAlertDesc(err.error)
        };
        // send error
        c.error(c, err);
    }
    return !c.fail;
};
/**
 * Creates a new TLS session cache.
 *
 * @param cache optional map of session ID to cached session.
 * @param capacity the maximum size for the cache (default: 100).
 *
 * @return the new TLS session cache.
 */ $087e807083257150$var$tls.createSessionCache = function(cache, capacity) {
    var rval = null;
    // assume input is already a session cache object
    if (cache && cache.getSession && cache.setSession && cache.order) rval = cache;
    else {
        // create cache
        rval = {};
        rval.cache = cache || {};
        rval.capacity = Math.max(capacity || 100, 1);
        rval.order = [];
        // store order for sessions, delete session overflow
        for(var key in cache)if (rval.order.length <= capacity) rval.order.push(key);
        else delete cache[key];
        // get a session from a session ID (or get any session)
        rval.getSession = function(sessionId) {
            var session = null;
            var key = null;
            // if session ID provided, use it
            if (sessionId) key = $cLQG7.util.bytesToHex(sessionId);
            else if (rval.order.length > 0) // get first session from cache
            key = rval.order[0];
            if (key !== null && key in rval.cache) {
                // get cached session and remove from cache
                session = rval.cache[key];
                delete rval.cache[key];
                for(var i in rval.order)if (rval.order[i] === key) {
                    rval.order.splice(i, 1);
                    break;
                }
            }
            return session;
        };
        // set a session in the cache
        rval.setSession = function(sessionId, session) {
            // remove session from cache if at capacity
            if (rval.order.length === rval.capacity) {
                var key = rval.order.shift();
                delete rval.cache[key];
            }
            // add session to cache
            var key = $cLQG7.util.bytesToHex(sessionId);
            rval.order.push(key);
            rval.cache[key] = session;
        };
    }
    return rval;
};
/**
 * Creates a new TLS connection.
 *
 * See public createConnection() docs for more details.
 *
 * @param options the options for this connection.
 *
 * @return the new TLS connection.
 */ $087e807083257150$var$tls.createConnection = function(options) {
    var caStore = null;
    if (options.caStore) {
        // if CA store is an array, convert it to a CA store object
        if ($cLQG7.util.isArray(options.caStore)) caStore = $cLQG7.pki.createCaStore(options.caStore);
        else caStore = options.caStore;
    } else // create empty CA store
    caStore = $cLQG7.pki.createCaStore();
    // setup default cipher suites
    var cipherSuites = options.cipherSuites || null;
    if (cipherSuites === null) {
        cipherSuites = [];
        for(var key in $087e807083257150$var$tls.CipherSuites)cipherSuites.push($087e807083257150$var$tls.CipherSuites[key]);
    }
    // set default entity
    var entity = options.server || false ? $087e807083257150$var$tls.ConnectionEnd.server : $087e807083257150$var$tls.ConnectionEnd.client;
    // create session cache if requested
    var sessionCache = options.sessionCache ? $087e807083257150$var$tls.createSessionCache(options.sessionCache) : null;
    // create TLS connection
    var c = {
        version: {
            major: $087e807083257150$var$tls.Version.major,
            minor: $087e807083257150$var$tls.Version.minor
        },
        entity: entity,
        sessionId: options.sessionId,
        caStore: caStore,
        sessionCache: sessionCache,
        cipherSuites: cipherSuites,
        connected: options.connected,
        virtualHost: options.virtualHost || null,
        verifyClient: options.verifyClient || false,
        verify: options.verify || function(cn, vfd, dpth, cts) {
            return vfd;
        },
        verifyOptions: options.verifyOptions || {},
        getCertificate: options.getCertificate || null,
        getPrivateKey: options.getPrivateKey || null,
        getSignature: options.getSignature || null,
        input: $cLQG7.util.createBuffer(),
        tlsData: $cLQG7.util.createBuffer(),
        data: $cLQG7.util.createBuffer(),
        tlsDataReady: options.tlsDataReady,
        dataReady: options.dataReady,
        heartbeatReceived: options.heartbeatReceived,
        closed: options.closed,
        error: function(c, ex) {
            // set origin if not set
            ex.origin = ex.origin || (c.entity === $087e807083257150$var$tls.ConnectionEnd.client ? 'client' : 'server');
            // send TLS alert
            if (ex.send) {
                $087e807083257150$var$tls.queue(c, $087e807083257150$var$tls.createAlert(c, ex.alert));
                $087e807083257150$var$tls.flush(c);
            }
            // error is fatal by default
            var fatal = ex.fatal !== false;
            if (fatal) // set fail flag
            c.fail = true;
            // call error handler first
            options.error(c, ex);
            if (fatal) // fatal error, close connection, do not clear fail
            c.close(false);
        },
        deflate: options.deflate || null,
        inflate: options.inflate || null
    };
    /**
   * Resets a closed TLS connection for reuse. Called in c.close().
   *
   * @param clearFail true to clear the fail flag (default: true).
   */ c.reset = function(clearFail) {
        c.version = {
            major: $087e807083257150$var$tls.Version.major,
            minor: $087e807083257150$var$tls.Version.minor
        };
        c.record = null;
        c.session = null;
        c.peerCertificate = null;
        c.state = {
            pending: null,
            current: null
        };
        c.expect = c.entity === $087e807083257150$var$tls.ConnectionEnd.client ? $087e807083257150$var$SHE : $087e807083257150$var$CHE;
        c.fragmented = null;
        c.records = [];
        c.open = false;
        c.handshakes = 0;
        c.handshaking = false;
        c.isConnected = false;
        c.fail = !(clearFail || typeof clearFail === 'undefined');
        c.input.clear();
        c.tlsData.clear();
        c.data.clear();
        c.state.current = $087e807083257150$var$tls.createConnectionState(c);
    };
    // do initial reset of connection
    c.reset();
    /**
   * Updates the current TLS engine state based on the given record.
   *
   * @param c the TLS connection.
   * @param record the TLS record to act on.
   */ var _update = function(c, record) {
        // get record handler (align type in table by subtracting lowest)
        var aligned = record.type - $087e807083257150$var$tls.ContentType.change_cipher_spec;
        var handlers = $087e807083257150$var$ctTable[c.entity][c.expect];
        if (aligned in handlers) handlers[aligned](c, record);
        else // unexpected record
        $087e807083257150$var$tls.handleUnexpected(c, record);
    };
    /**
   * Reads the record header and initializes the next record on the given
   * connection.
   *
   * @param c the TLS connection with the next record.
   *
   * @return 0 if the input data could be processed, otherwise the
   *         number of bytes required for data to be processed.
   */ var _readRecordHeader = function(c) {
        var rval = 0;
        // get input buffer and its length
        var b = c.input;
        var len = b.length();
        // need at least 5 bytes to initialize a record
        if (len < 5) rval = 5 - len;
        else {
            // enough bytes for header
            // initialize record
            c.record = {
                type: b.getByte(),
                version: {
                    major: b.getByte(),
                    minor: b.getByte()
                },
                length: b.getInt16(),
                fragment: $cLQG7.util.createBuffer(),
                ready: false
            };
            // check record version
            var compatibleVersion = c.record.version.major === c.version.major;
            if (compatibleVersion && c.session && c.session.version) // session version already set, require same minor version
            compatibleVersion = c.record.version.minor === c.version.minor;
            if (!compatibleVersion) c.error(c, {
                message: 'Incompatible TLS version.',
                send: true,
                alert: {
                    level: $087e807083257150$var$tls.Alert.Level.fatal,
                    description: $087e807083257150$var$tls.Alert.Description.protocol_version
                }
            });
        }
        return rval;
    };
    /**
   * Reads the next record's contents and appends its message to any
   * previously fragmented message.
   *
   * @param c the TLS connection with the next record.
   *
   * @return 0 if the input data could be processed, otherwise the
   *         number of bytes required for data to be processed.
   */ var _readRecord = function(c) {
        var rval = 0;
        // ensure there is enough input data to get the entire record
        var b = c.input;
        var len = b.length();
        if (len < c.record.length) // not enough data yet, return how much is required
        rval = c.record.length - len;
        else {
            // there is enough data to parse the pending record
            // fill record fragment and compact input buffer
            c.record.fragment.putBytes(b.getBytes(c.record.length));
            b.compact();
            // update record using current read state
            var s = c.state.current.read;
            if (s.update(c, c.record)) {
                // see if there is a previously fragmented message that the
                // new record's message fragment should be appended to
                if (c.fragmented !== null) {
                    // if the record type matches a previously fragmented
                    // record, append the record fragment to it
                    if (c.fragmented.type === c.record.type) {
                        // concatenate record fragments
                        c.fragmented.fragment.putBuffer(c.record.fragment);
                        c.record = c.fragmented;
                    } else // error, invalid fragmented record
                    c.error(c, {
                        message: 'Invalid fragmented record.',
                        send: true,
                        alert: {
                            level: $087e807083257150$var$tls.Alert.Level.fatal,
                            description: $087e807083257150$var$tls.Alert.Description.unexpected_message
                        }
                    });
                }
                // record is now ready
                c.record.ready = true;
            }
        }
        return rval;
    };
    /**
   * Performs a handshake using the TLS Handshake Protocol, as a client.
   *
   * This method should only be called if the connection is in client mode.
   *
   * @param sessionId the session ID to use, null to start a new one.
   */ c.handshake = function(sessionId) {
        // error to call this in non-client mode
        if (c.entity !== $087e807083257150$var$tls.ConnectionEnd.client) // not fatal error
        c.error(c, {
            message: 'Cannot initiate handshake as a server.',
            fatal: false
        });
        else if (c.handshaking) // handshake is already in progress, fail but not fatal error
        c.error(c, {
            message: 'Handshake already in progress.',
            fatal: false
        });
        else {
            // clear fail flag on reuse
            if (c.fail && !c.open && c.handshakes === 0) c.fail = false;
            // now handshaking
            c.handshaking = true;
            // default to blank (new session)
            sessionId = sessionId || '';
            // if a session ID was specified, try to find it in the cache
            var session = null;
            if (sessionId.length > 0) {
                if (c.sessionCache) session = c.sessionCache.getSession(sessionId);
                // matching session not found in cache, clear session ID
                if (session === null) sessionId = '';
            }
            // no session given, grab a session from the cache, if available
            if (sessionId.length === 0 && c.sessionCache) {
                session = c.sessionCache.getSession();
                if (session !== null) sessionId = session.id;
            }
            // set up session
            c.session = {
                id: sessionId,
                version: null,
                cipherSuite: null,
                compressionMethod: null,
                serverCertificate: null,
                certificateRequest: null,
                clientCertificate: null,
                sp: {},
                md5: $cLQG7.md.md5.create(),
                sha1: $cLQG7.md.sha1.create()
            };
            // use existing session information
            if (session) {
                // only update version on connection, session version not yet set
                c.version = session.version;
                c.session.sp = session.sp;
            }
            // generate new client random
            c.session.sp.client_random = $087e807083257150$var$tls.createRandom().getBytes();
            // connection now open
            c.open = true;
            // send hello
            $087e807083257150$var$tls.queue(c, $087e807083257150$var$tls.createRecord(c, {
                type: $087e807083257150$var$tls.ContentType.handshake,
                data: $087e807083257150$var$tls.createClientHello(c)
            }));
            $087e807083257150$var$tls.flush(c);
        }
    };
    /**
   * Called when TLS protocol data has been received from somewhere and should
   * be processed by the TLS engine.
   *
   * @param data the TLS protocol data, as a string, to process.
   *
   * @return 0 if the data could be processed, otherwise the number of bytes
   *         required for data to be processed.
   */ c.process = function(data) {
        var rval = 0;
        // buffer input data
        if (data) c.input.putBytes(data);
        // process next record if no failure, process will be called after
        // each record is handled (since handling can be asynchronous)
        if (!c.fail) {
            // reset record if ready and now empty
            if (c.record !== null && c.record.ready && c.record.fragment.isEmpty()) c.record = null;
            // if there is no pending record, try to read record header
            if (c.record === null) rval = _readRecordHeader(c);
            // read the next record (if record not yet ready)
            if (!c.fail && c.record !== null && !c.record.ready) rval = _readRecord(c);
            // record ready to be handled, update engine state
            if (!c.fail && c.record !== null && c.record.ready) _update(c, c.record);
        }
        return rval;
    };
    /**
   * Requests that application data be packaged into a TLS record. The
   * tlsDataReady handler will be called when the TLS record(s) have been
   * prepared.
   *
   * @param data the application data, as a raw 'binary' encoded string, to
   *          be sent; to send utf-16/utf-8 string data, use the return value
   *          of util.encodeUtf8(str).
   *
   * @return true on success, false on failure.
   */ c.prepare = function(data) {
        $087e807083257150$var$tls.queue(c, $087e807083257150$var$tls.createRecord(c, {
            type: $087e807083257150$var$tls.ContentType.application_data,
            data: $cLQG7.util.createBuffer(data)
        }));
        return $087e807083257150$var$tls.flush(c);
    };
    /**
   * Requests that a heartbeat request be packaged into a TLS record for
   * transmission. The tlsDataReady handler will be called when TLS record(s)
   * have been prepared.
   *
   * When a heartbeat response has been received, the heartbeatReceived
   * handler will be called with the matching payload. This handler can
   * be used to clear a retransmission timer, etc.
   *
   * @param payload the heartbeat data to send as the payload in the message.
   * @param [payloadLength] the payload length to use, defaults to the
   *          actual payload length.
   *
   * @return true on success, false on failure.
   */ c.prepareHeartbeatRequest = function(payload, payloadLength) {
        if (payload instanceof $cLQG7.util.ByteBuffer) payload = payload.bytes();
        if (typeof payloadLength === 'undefined') payloadLength = payload.length;
        c.expectedHeartbeatPayload = payload;
        $087e807083257150$var$tls.queue(c, $087e807083257150$var$tls.createRecord(c, {
            type: $087e807083257150$var$tls.ContentType.heartbeat,
            data: $087e807083257150$var$tls.createHeartbeat($087e807083257150$var$tls.HeartbeatMessageType.heartbeat_request, payload, payloadLength)
        }));
        return $087e807083257150$var$tls.flush(c);
    };
    /**
   * Closes the connection (sends a close_notify alert).
   *
   * @param clearFail true to clear the fail flag (default: true).
   */ c.close = function(clearFail) {
        // save session if connection didn't fail
        if (!c.fail && c.sessionCache && c.session) {
            // only need to preserve session ID, version, and security params
            var session = {
                id: c.session.id,
                version: c.session.version,
                sp: c.session.sp
            };
            session.sp.keys = null;
            c.sessionCache.setSession(session.id, session);
        }
        if (c.open) {
            // connection no longer open, clear input
            c.open = false;
            c.input.clear();
            // if connected or handshaking, send an alert
            if (c.isConnected || c.handshaking) {
                c.isConnected = c.handshaking = false;
                // send close_notify alert
                $087e807083257150$var$tls.queue(c, $087e807083257150$var$tls.createAlert(c, {
                    level: $087e807083257150$var$tls.Alert.Level.warning,
                    description: $087e807083257150$var$tls.Alert.Description.close_notify
                }));
                $087e807083257150$var$tls.flush(c);
            }
            // call handler
            c.closed(c);
        }
        // reset TLS connection, do not clear fail flag
        c.reset(clearFail);
    };
    return c;
};
/* TLS API */ $087e807083257150$exports = $cLQG7.tls = $cLQG7.tls || {};
// expose non-functions
for(var $087e807083257150$var$key in $087e807083257150$var$tls)if (typeof $087e807083257150$var$tls[$087e807083257150$var$key] !== 'function') $cLQG7.tls[$087e807083257150$var$key] = $087e807083257150$var$tls[$087e807083257150$var$key];
// expose prf_tls1 for testing
$cLQG7.tls.prf_tls1 = $087e807083257150$var$prf_TLS1;
// expose sha1 hmac method
$cLQG7.tls.hmac_sha1 = $087e807083257150$var$hmac_sha1;
// expose session cache creation
$cLQG7.tls.createSessionCache = $087e807083257150$var$tls.createSessionCache;
/**
 * Creates a new TLS connection. This does not make any assumptions about the
 * transport layer that TLS is working on top of, ie: it does not assume there
 * is a TCP/IP connection or establish one. A TLS connection is totally
 * abstracted away from the layer is runs on top of, it merely establishes a
 * secure channel between a client" and a "server".
 *
 * A TLS connection contains 4 connection states: pending read and write, and
 * current read and write.
 *
 * At initialization, the current read and write states will be null. Only once
 * the security parameters have been set and the keys have been generated can
 * the pending states be converted into current states. Current states will be
 * updated for each record processed.
 *
 * A custom certificate verify callback may be provided to check information
 * like the common name on the server's certificate. It will be called for
 * every certificate in the chain. It has the following signature:
 *
 * variable func(c, certs, index, preVerify)
 * Where:
 * c         The TLS connection
 * verified  Set to true if certificate was verified, otherwise the alert
 *           tls.Alert.Description for why the certificate failed.
 * depth     The current index in the chain, where 0 is the server's cert.
 * certs     The certificate chain, *NOTE* if the server was anonymous then
 *           the chain will be empty.
 *
 * The function returns true on success and on failure either the appropriate
 * tls.Alert.Description or an object with 'alert' set to the appropriate
 * tls.Alert.Description and 'message' set to a custom error message. If true
 * is not returned then the connection will abort using, in order of
 * availability, first the returned alert description, second the preVerify
 * alert description, and lastly the default 'bad_certificate'.
 *
 * There are three callbacks that can be used to make use of client-side
 * certificates where each takes the TLS connection as the first parameter:
 *
 * getCertificate(conn, hint)
 *   The second parameter is a hint as to which certificate should be
 *   returned. If the connection entity is a client, then the hint will be
 *   the CertificateRequest message from the server that is part of the
 *   TLS protocol. If the connection entity is a server, then it will be
 *   the servername list provided via an SNI extension the ClientHello, if
 *   one was provided (empty array if not). The hint can be examined to
 *   determine which certificate to use (advanced). Most implementations
 *   will just return a certificate. The return value must be a
 *   PEM-formatted certificate or an array of PEM-formatted certificates
 *   that constitute a certificate chain, with the first in the array/chain
 *   being the client's certificate.
 * getPrivateKey(conn, certificate)
 *   The second parameter is an forge.pki X.509 certificate object that
 *   is associated with the requested private key. The return value must
 *   be a PEM-formatted private key.
 * getSignature(conn, bytes, callback)
 *   This callback can be used instead of getPrivateKey if the private key
 *   is not directly accessible in javascript or should not be. For
 *   instance, a secure external web service could provide the signature
 *   in exchange for appropriate credentials. The second parameter is a
 *   string of bytes to be signed that are part of the TLS protocol. These
 *   bytes are used to verify that the private key for the previously
 *   provided client-side certificate is accessible to the client. The
 *   callback is a function that takes 2 parameters, the TLS connection
 *   and the RSA encrypted (signed) bytes as a string. This callback must
 *   be called once the signature is ready.
 *
 * @param options the options for this connection:
 *   server: true if the connection is server-side, false for client.
 *   sessionId: a session ID to reuse, null for a new connection.
 *   caStore: an array of certificates to trust.
 *   sessionCache: a session cache to use.
 *   cipherSuites: an optional array of cipher suites to use,
 *     see tls.CipherSuites.
 *   connected: function(conn) called when the first handshake completes.
 *   virtualHost: the virtual server name to use in a TLS SNI extension.
 *   verifyClient: true to require a client certificate in server mode,
 *     'optional' to request one, false not to (default: false).
 *   verify: a handler used to custom verify certificates in the chain.
 *   verifyOptions: an object with options for the certificate chain validation.
 *     See documentation of pki.verifyCertificateChain for possible options.
 *     verifyOptions.verify is ignored. If you wish to specify a verify handler
 *     use the verify key.
 *   getCertificate: an optional callback used to get a certificate or
 *     a chain of certificates (as an array).
 *   getPrivateKey: an optional callback used to get a private key.
 *   getSignature: an optional callback used to get a signature.
 *   tlsDataReady: function(conn) called when TLS protocol data has been
 *     prepared and is ready to be used (typically sent over a socket
 *     connection to its destination), read from conn.tlsData buffer.
 *   dataReady: function(conn) called when application data has
 *     been parsed from a TLS record and should be consumed by the
 *     application, read from conn.data buffer.
 *   closed: function(conn) called when the connection has been closed.
 *   error: function(conn, error) called when there was an error.
 *   deflate: function(inBytes) if provided, will deflate TLS records using
 *     the deflate algorithm if the server supports it.
 *   inflate: function(inBytes) if provided, will inflate TLS records using
 *     the deflate algorithm if the server supports it.
 *
 * @return the new TLS connection.
 */ $cLQG7.tls.createConnection = $087e807083257150$var$tls.createConnection;


var $437b300329bdbf9c$var$tls = $437b300329bdbf9c$exports = $cLQG7.tls;
/**
 * Supported cipher suites.
 */ $437b300329bdbf9c$var$tls.CipherSuites['TLS_RSA_WITH_AES_128_CBC_SHA'] = {
    id: [
        0x00,
        0x2f
    ],
    name: 'TLS_RSA_WITH_AES_128_CBC_SHA',
    initSecurityParameters: function(sp) {
        sp.bulk_cipher_algorithm = $437b300329bdbf9c$var$tls.BulkCipherAlgorithm.aes;
        sp.cipher_type = $437b300329bdbf9c$var$tls.CipherType.block;
        sp.enc_key_length = 16;
        sp.block_length = 16;
        sp.fixed_iv_length = 16;
        sp.record_iv_length = 16;
        sp.mac_algorithm = $437b300329bdbf9c$var$tls.MACAlgorithm.hmac_sha1;
        sp.mac_length = 20;
        sp.mac_key_length = 20;
    },
    initConnectionState: $437b300329bdbf9c$var$initConnectionState
};
$437b300329bdbf9c$var$tls.CipherSuites['TLS_RSA_WITH_AES_256_CBC_SHA'] = {
    id: [
        0x00,
        0x35
    ],
    name: 'TLS_RSA_WITH_AES_256_CBC_SHA',
    initSecurityParameters: function(sp) {
        sp.bulk_cipher_algorithm = $437b300329bdbf9c$var$tls.BulkCipherAlgorithm.aes;
        sp.cipher_type = $437b300329bdbf9c$var$tls.CipherType.block;
        sp.enc_key_length = 32;
        sp.block_length = 16;
        sp.fixed_iv_length = 16;
        sp.record_iv_length = 16;
        sp.mac_algorithm = $437b300329bdbf9c$var$tls.MACAlgorithm.hmac_sha1;
        sp.mac_length = 20;
        sp.mac_key_length = 20;
    },
    initConnectionState: $437b300329bdbf9c$var$initConnectionState
};
function $437b300329bdbf9c$var$initConnectionState(state, c, sp) {
    var client = c.entity === $cLQG7.tls.ConnectionEnd.client;
    // cipher setup
    state.read.cipherState = {
        init: false,
        cipher: $cLQG7.cipher.createDecipher('AES-CBC', client ? sp.keys.server_write_key : sp.keys.client_write_key),
        iv: client ? sp.keys.server_write_IV : sp.keys.client_write_IV
    };
    state.write.cipherState = {
        init: false,
        cipher: $cLQG7.cipher.createCipher('AES-CBC', client ? sp.keys.client_write_key : sp.keys.server_write_key),
        iv: client ? sp.keys.client_write_IV : sp.keys.server_write_IV
    };
    state.read.cipherFunction = $437b300329bdbf9c$var$decrypt_aes_cbc_sha1;
    state.write.cipherFunction = $437b300329bdbf9c$var$encrypt_aes_cbc_sha1;
    // MAC setup
    state.read.macLength = state.write.macLength = sp.mac_length;
    state.read.macFunction = state.write.macFunction = $437b300329bdbf9c$var$tls.hmac_sha1;
}
/**
 * Encrypts the TLSCompressed record into a TLSCipherText record using AES
 * in CBC mode.
 *
 * @param record the TLSCompressed record to encrypt.
 * @param s the ConnectionState to use.
 *
 * @return true on success, false on failure.
 */ function $437b300329bdbf9c$var$encrypt_aes_cbc_sha1(record, s) {
    var rval = false;
    // append MAC to fragment, update sequence number
    var mac = s.macFunction(s.macKey, s.sequenceNumber, record);
    record.fragment.putBytes(mac);
    s.updateSequenceNumber();
    // TLS 1.1+ use an explicit IV every time to protect against CBC attacks
    var iv;
    if (record.version.minor === $437b300329bdbf9c$var$tls.Versions.TLS_1_0.minor) // use the pre-generated IV when initializing for TLS 1.0, otherwise use
    // the residue from the previous encryption
    iv = s.cipherState.init ? null : s.cipherState.iv;
    else iv = $cLQG7.random.getBytesSync(16);
    s.cipherState.init = true;
    // start cipher
    var cipher = s.cipherState.cipher;
    cipher.start({
        iv: iv
    });
    // TLS 1.1+ write IV into output
    if (record.version.minor >= $437b300329bdbf9c$var$tls.Versions.TLS_1_1.minor) cipher.output.putBytes(iv);
    // do encryption (default padding is appropriate)
    cipher.update(record.fragment);
    if (cipher.finish($437b300329bdbf9c$var$encrypt_aes_cbc_sha1_padding)) {
        // set record fragment to encrypted output
        record.fragment = cipher.output;
        record.length = record.fragment.length();
        rval = true;
    }
    return rval;
}
/**
 * Handles padding for aes_cbc_sha1 in encrypt mode.
 *
 * @param blockSize the block size.
 * @param input the input buffer.
 * @param decrypt true in decrypt mode, false in encrypt mode.
 *
 * @return true on success, false on failure.
 */ function $437b300329bdbf9c$var$encrypt_aes_cbc_sha1_padding(blockSize, input, decrypt) {
    /* The encrypted data length (TLSCiphertext.length) is one more than the sum
   of SecurityParameters.block_length, TLSCompressed.length,
   SecurityParameters.mac_length, and padding_length.

   The padding may be any length up to 255 bytes long, as long as it results in
   the TLSCiphertext.length being an integral multiple of the block length.
   Lengths longer than necessary might be desirable to frustrate attacks on a
   protocol based on analysis of the lengths of exchanged messages. Each uint8
   in the padding data vector must be filled with the padding length value.

   The padding length should be such that the total size of the
   GenericBlockCipher structure is a multiple of the cipher's block length.
   Legal values range from zero to 255, inclusive. This length specifies the
   length of the padding field exclusive of the padding_length field itself.

   This is slightly different from PKCS#7 because the padding value is 1
   less than the actual number of padding bytes if you include the
   padding_length uint8 itself as a padding byte. */ if (!decrypt) {
        // get the number of padding bytes required to reach the blockSize and
        // subtract 1 for the padding value (to make room for the padding_length
        // uint8)
        var padding = blockSize - input.length() % blockSize;
        input.fillWithByte(padding - 1, padding);
    }
    return true;
}
/**
 * Handles padding for aes_cbc_sha1 in decrypt mode.
 *
 * @param blockSize the block size.
 * @param output the output buffer.
 * @param decrypt true in decrypt mode, false in encrypt mode.
 *
 * @return true on success, false on failure.
 */ function $437b300329bdbf9c$var$decrypt_aes_cbc_sha1_padding(blockSize, output, decrypt) {
    var rval = true;
    if (decrypt) {
        /* The last byte in the output specifies the number of padding bytes not
      including itself. Each of the padding bytes has the same value as that
      last byte (known as the padding_length). Here we check all padding
      bytes to ensure they have the value of padding_length even if one of
      them is bad in order to ward-off timing attacks. */ var len = output.length();
        var paddingLength = output.last();
        for(var i = len - 1 - paddingLength; i < len - 1; ++i)rval = rval && output.at(i) == paddingLength;
        if (rval) // trim off padding bytes and last padding length byte
        output.truncate(paddingLength + 1);
    }
    return rval;
}
/**
 * Decrypts a TLSCipherText record into a TLSCompressed record using
 * AES in CBC mode.
 *
 * @param record the TLSCipherText record to decrypt.
 * @param s the ConnectionState to use.
 *
 * @return true on success, false on failure.
 */ function $437b300329bdbf9c$var$decrypt_aes_cbc_sha1(record, s) {
    var rval = false;
    var iv;
    if (record.version.minor === $437b300329bdbf9c$var$tls.Versions.TLS_1_0.minor) // use pre-generated IV when initializing for TLS 1.0, otherwise use the
    // residue from the previous decryption
    iv = s.cipherState.init ? null : s.cipherState.iv;
    else // TLS 1.1+ use an explicit IV every time to protect against CBC attacks
    // that is appended to the record fragment
    iv = record.fragment.getBytes(16);
    s.cipherState.init = true;
    // start cipher
    var cipher = s.cipherState.cipher;
    cipher.start({
        iv: iv
    });
    // do decryption
    cipher.update(record.fragment);
    rval = cipher.finish($437b300329bdbf9c$var$decrypt_aes_cbc_sha1_padding);
    // even if decryption fails, keep going to minimize timing attacks
    // decrypted data:
    // first (len - 20) bytes = application data
    // last 20 bytes          = MAC
    var macLen = s.macLength;
    // create a random MAC to check against should the mac length check fail
    // Note: do this regardless of the failure to keep timing consistent
    var mac = $cLQG7.random.getBytesSync(macLen);
    // get fragment and mac
    var len = cipher.output.length();
    if (len >= macLen) {
        record.fragment = cipher.output.getBytes(len - macLen);
        mac = cipher.output.getBytes(macLen);
    } else // bad data, but get bytes anyway to try to keep timing consistent
    record.fragment = cipher.output.getBytes();
    record.fragment = $cLQG7.util.createBuffer(record.fragment);
    record.length = record.fragment.length();
    // see if data integrity checks out, update sequence number
    var mac2 = s.macFunction(s.macKey, s.sequenceNumber, record);
    s.updateSequenceNumber();
    rval = $437b300329bdbf9c$var$compareMacs(s.macKey, mac, mac2) && rval;
    return rval;
}
/**
 * Safely compare two MACs. This function will compare two MACs in a way
 * that protects against timing attacks.
 *
 * TODO: Expose elsewhere as a utility API.
 *
 * See: https://www.nccgroup.trust/us/about-us/newsroom-and-events/blog/2011/february/double-hmac-verification/
 *
 * @param key the MAC key to use.
 * @param mac1 as a binary-encoded string of bytes.
 * @param mac2 as a binary-encoded string of bytes.
 *
 * @return true if the MACs are the same, false if not.
 */ function $437b300329bdbf9c$var$compareMacs(key, mac1, mac2) {
    var hmac = $cLQG7.hmac.create();
    hmac.start('SHA1', key);
    hmac.update(mac1);
    mac1 = hmac.digest().getBytes();
    hmac.start(null, null);
    hmac.update(mac2);
    mac2 = hmac.digest().getBytes();
    return mac1 === mac2;
}





var $02d86399422da001$exports = {};
/**
 * JavaScript implementation of Ed25519.
 *
 * Copyright (c) 2017-2019 Digital Bazaar, Inc.
 *
 * This implementation is based on the most excellent TweetNaCl which is
 * in the public domain. Many thanks to its contributors:
 *
 * https://github.com/dchest/tweetnacl-js
 */ 
var $lbUi1 = parcelRequire("lbUi1");
var $02d86399422da001$require$Buffer = $lbUi1.Buffer;

var $cLQG7 = parcelRequire("cLQG7");


var $17272df373da7935$exports = {};
/**
 * Secure Hash Algorithm with a 1024-bit block size implementation.
 *
 * This includes: SHA-512, SHA-384, SHA-512/224, and SHA-512/256. For
 * SHA-256 (block size 512 bits), see sha256.js.
 *
 * See FIPS 180-4 for details.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2014-2015 Digital Bazaar, Inc.
 */ 
var $cLQG7 = parcelRequire("cLQG7");
parcelRequire("4pr5e");

var $17272df373da7935$var$sha512 = $17272df373da7935$exports = $cLQG7.sha512 = $cLQG7.sha512 || {};
// SHA-512
$cLQG7.md.sha512 = $cLQG7.md.algorithms.sha512 = $17272df373da7935$var$sha512;
// SHA-384
var $17272df373da7935$var$sha384 = $cLQG7.sha384 = $cLQG7.sha512.sha384 = $cLQG7.sha512.sha384 || {};
$17272df373da7935$var$sha384.create = function() {
    return $17272df373da7935$var$sha512.create('SHA-384');
};
$cLQG7.md.sha384 = $cLQG7.md.algorithms.sha384 = $17272df373da7935$var$sha384;
// SHA-512/256
$cLQG7.sha512.sha256 = $cLQG7.sha512.sha256 || {
    create: function() {
        return $17272df373da7935$var$sha512.create('SHA-512/256');
    }
};
$cLQG7.md['sha512/256'] = $cLQG7.md.algorithms['sha512/256'] = $cLQG7.sha512.sha256;
// SHA-512/224
$cLQG7.sha512.sha224 = $cLQG7.sha512.sha224 || {
    create: function() {
        return $17272df373da7935$var$sha512.create('SHA-512/224');
    }
};
$cLQG7.md['sha512/224'] = $cLQG7.md.algorithms['sha512/224'] = $cLQG7.sha512.sha224;
/**
 * Creates a SHA-2 message digest object.
 *
 * @param algorithm the algorithm to use (SHA-512, SHA-384, SHA-512/224,
 *          SHA-512/256).
 *
 * @return a message digest object.
 */ $17272df373da7935$var$sha512.create = function(algorithm) {
    // do initialization as necessary
    if (!$17272df373da7935$var$_initialized) $17272df373da7935$var$_init();
    if (typeof algorithm === 'undefined') algorithm = 'SHA-512';
    if (!(algorithm in $17272df373da7935$var$_states)) throw new Error('Invalid SHA-512 algorithm: ' + algorithm);
    // SHA-512 state contains eight 64-bit integers (each as two 32-bit ints)
    var _state = $17272df373da7935$var$_states[algorithm];
    var _h = null;
    // input buffer
    var _input = $cLQG7.util.createBuffer();
    // used for 64-bit word storage
    var _w = new Array(80);
    for(var wi = 0; wi < 80; ++wi)_w[wi] = new Array(2);
    // determine digest length by algorithm name (default)
    var digestLength = 64;
    switch(algorithm){
        case 'SHA-384':
            digestLength = 48;
            break;
        case 'SHA-512/256':
            digestLength = 32;
            break;
        case 'SHA-512/224':
            digestLength = 28;
            break;
    }
    // message digest object
    var md = {
        // SHA-512 => sha512
        algorithm: algorithm.replace('-', '').toLowerCase(),
        blockLength: 128,
        digestLength: digestLength,
        // 56-bit length of message so far (does not including padding)
        messageLength: 0,
        // true message length
        fullMessageLength: null,
        // size of message length in bytes
        messageLengthSize: 16
    };
    /**
   * Starts the digest.
   *
   * @return this digest object.
   */ md.start = function() {
        // up to 56-bit message length for convenience
        md.messageLength = 0;
        // full message length (set md.messageLength128 for backwards-compatibility)
        md.fullMessageLength = md.messageLength128 = [];
        var int32s = md.messageLengthSize / 4;
        for(var i = 0; i < int32s; ++i)md.fullMessageLength.push(0);
        _input = $cLQG7.util.createBuffer();
        _h = new Array(_state.length);
        for(var i = 0; i < _state.length; ++i)_h[i] = _state[i].slice(0);
        return md;
    };
    // start digest automatically for first time
    md.start();
    /**
   * Updates the digest with the given message input. The given input can
   * treated as raw input (no encoding will be applied) or an encoding of
   * 'utf8' maybe given to encode the input using UTF-8.
   *
   * @param msg the message input to update with.
   * @param encoding the encoding to use (default: 'raw', other: 'utf8').
   *
   * @return this digest object.
   */ md.update = function(msg, encoding) {
        if (encoding === 'utf8') msg = $cLQG7.util.encodeUtf8(msg);
        // update message length
        var len = msg.length;
        md.messageLength += len;
        len = [
            len / 0x100000000 >>> 0,
            len >>> 0
        ];
        for(var i = md.fullMessageLength.length - 1; i >= 0; --i){
            md.fullMessageLength[i] += len[1];
            len[1] = len[0] + (md.fullMessageLength[i] / 0x100000000 >>> 0);
            md.fullMessageLength[i] = md.fullMessageLength[i] >>> 0;
            len[0] = len[1] / 0x100000000 >>> 0;
        }
        // add bytes to input buffer
        _input.putBytes(msg);
        // process bytes
        $17272df373da7935$var$_update(_h, _w, _input);
        // compact input buffer every 2K or if empty
        if (_input.read > 2048 || _input.length() === 0) _input.compact();
        return md;
    };
    /**
   * Produces the digest.
   *
   * @return a byte buffer containing the digest value.
   */ md.digest = function() {
        /* Note: Here we copy the remaining bytes in the input buffer and
    add the appropriate SHA-512 padding. Then we do the final update
    on a copy of the state so that if the user wants to get
    intermediate digests they can do so. */ /* Determine the number of bytes that must be added to the message
    to ensure its length is congruent to 896 mod 1024. In other words,
    the data to be digested must be a multiple of 1024 bits (or 128 bytes).
    This data includes the message, some padding, and the length of the
    message. Since the length of the message will be encoded as 16 bytes (128
    bits), that means that the last segment of the data must have 112 bytes
    (896 bits) of message and padding. Therefore, the length of the message
    plus the padding must be congruent to 896 mod 1024 because
    1024 - 128 = 896.

    In order to fill up the message length it must be filled with
    padding that begins with 1 bit followed by all 0 bits. Padding
    must *always* be present, so if the message length is already
    congruent to 896 mod 1024, then 1024 padding bits must be added. */ var finalBlock = $cLQG7.util.createBuffer();
        finalBlock.putBytes(_input.bytes());
        // compute remaining size to be digested (include message length size)
        var remaining = md.fullMessageLength[md.fullMessageLength.length - 1] + md.messageLengthSize;
        // add padding for overflow blockSize - overflow
        // _padding starts with 1 byte with first bit is set (byte value 128), then
        // there may be up to (blockSize - 1) other pad bytes
        var overflow = remaining & md.blockLength - 1;
        finalBlock.putBytes($17272df373da7935$var$_padding.substr(0, md.blockLength - overflow));
        // serialize message length in bits in big-endian order; since length
        // is stored in bytes we multiply by 8 and add carry from next int
        var next, carry;
        var bits = md.fullMessageLength[0] * 8;
        for(var i = 0; i < md.fullMessageLength.length - 1; ++i){
            next = md.fullMessageLength[i + 1] * 8;
            carry = next / 0x100000000 >>> 0;
            bits += carry;
            finalBlock.putInt32(bits >>> 0);
            bits = next >>> 0;
        }
        finalBlock.putInt32(bits);
        var h = new Array(_h.length);
        for(var i = 0; i < _h.length; ++i)h[i] = _h[i].slice(0);
        $17272df373da7935$var$_update(h, _w, finalBlock);
        var rval = $cLQG7.util.createBuffer();
        var hlen;
        if (algorithm === 'SHA-512') hlen = h.length;
        else if (algorithm === 'SHA-384') hlen = h.length - 2;
        else hlen = h.length - 4;
        for(var i = 0; i < hlen; ++i){
            rval.putInt32(h[i][0]);
            if (i !== hlen - 1 || algorithm !== 'SHA-512/224') rval.putInt32(h[i][1]);
        }
        return rval;
    };
    return md;
};
// sha-512 padding bytes not initialized yet
var $17272df373da7935$var$_padding = null;
var $17272df373da7935$var$_initialized = false;
// table of constants
var $17272df373da7935$var$_k = null;
// initial hash states
var $17272df373da7935$var$_states = null;
/**
 * Initializes the constant tables.
 */ function $17272df373da7935$var$_init() {
    // create padding
    $17272df373da7935$var$_padding = String.fromCharCode(128);
    $17272df373da7935$var$_padding += $cLQG7.util.fillString(String.fromCharCode(0x00), 128);
    // create K table for SHA-512
    $17272df373da7935$var$_k = [
        [
            0x428a2f98,
            0xd728ae22
        ],
        [
            0x71374491,
            0x23ef65cd
        ],
        [
            0xb5c0fbcf,
            0xec4d3b2f
        ],
        [
            0xe9b5dba5,
            0x8189dbbc
        ],
        [
            0x3956c25b,
            0xf348b538
        ],
        [
            0x59f111f1,
            0xb605d019
        ],
        [
            0x923f82a4,
            0xaf194f9b
        ],
        [
            0xab1c5ed5,
            0xda6d8118
        ],
        [
            0xd807aa98,
            0xa3030242
        ],
        [
            0x12835b01,
            0x45706fbe
        ],
        [
            0x243185be,
            0x4ee4b28c
        ],
        [
            0x550c7dc3,
            0xd5ffb4e2
        ],
        [
            0x72be5d74,
            0xf27b896f
        ],
        [
            0x80deb1fe,
            0x3b1696b1
        ],
        [
            0x9bdc06a7,
            0x25c71235
        ],
        [
            0xc19bf174,
            0xcf692694
        ],
        [
            0xe49b69c1,
            0x9ef14ad2
        ],
        [
            0xefbe4786,
            0x384f25e3
        ],
        [
            0x0fc19dc6,
            0x8b8cd5b5
        ],
        [
            0x240ca1cc,
            0x77ac9c65
        ],
        [
            0x2de92c6f,
            0x592b0275
        ],
        [
            0x4a7484aa,
            0x6ea6e483
        ],
        [
            0x5cb0a9dc,
            0xbd41fbd4
        ],
        [
            0x76f988da,
            0x831153b5
        ],
        [
            0x983e5152,
            0xee66dfab
        ],
        [
            0xa831c66d,
            0x2db43210
        ],
        [
            0xb00327c8,
            0x98fb213f
        ],
        [
            0xbf597fc7,
            0xbeef0ee4
        ],
        [
            0xc6e00bf3,
            0x3da88fc2
        ],
        [
            0xd5a79147,
            0x930aa725
        ],
        [
            0x06ca6351,
            0xe003826f
        ],
        [
            0x14292967,
            0x0a0e6e70
        ],
        [
            0x27b70a85,
            0x46d22ffc
        ],
        [
            0x2e1b2138,
            0x5c26c926
        ],
        [
            0x4d2c6dfc,
            0x5ac42aed
        ],
        [
            0x53380d13,
            0x9d95b3df
        ],
        [
            0x650a7354,
            0x8baf63de
        ],
        [
            0x766a0abb,
            0x3c77b2a8
        ],
        [
            0x81c2c92e,
            0x47edaee6
        ],
        [
            0x92722c85,
            0x1482353b
        ],
        [
            0xa2bfe8a1,
            0x4cf10364
        ],
        [
            0xa81a664b,
            0xbc423001
        ],
        [
            0xc24b8b70,
            0xd0f89791
        ],
        [
            0xc76c51a3,
            0x0654be30
        ],
        [
            0xd192e819,
            0xd6ef5218
        ],
        [
            0xd6990624,
            0x5565a910
        ],
        [
            0xf40e3585,
            0x5771202a
        ],
        [
            0x106aa070,
            0x32bbd1b8
        ],
        [
            0x19a4c116,
            0xb8d2d0c8
        ],
        [
            0x1e376c08,
            0x5141ab53
        ],
        [
            0x2748774c,
            0xdf8eeb99
        ],
        [
            0x34b0bcb5,
            0xe19b48a8
        ],
        [
            0x391c0cb3,
            0xc5c95a63
        ],
        [
            0x4ed8aa4a,
            0xe3418acb
        ],
        [
            0x5b9cca4f,
            0x7763e373
        ],
        [
            0x682e6ff3,
            0xd6b2b8a3
        ],
        [
            0x748f82ee,
            0x5defb2fc
        ],
        [
            0x78a5636f,
            0x43172f60
        ],
        [
            0x84c87814,
            0xa1f0ab72
        ],
        [
            0x8cc70208,
            0x1a6439ec
        ],
        [
            0x90befffa,
            0x23631e28
        ],
        [
            0xa4506ceb,
            0xde82bde9
        ],
        [
            0xbef9a3f7,
            0xb2c67915
        ],
        [
            0xc67178f2,
            0xe372532b
        ],
        [
            0xca273ece,
            0xea26619c
        ],
        [
            0xd186b8c7,
            0x21c0c207
        ],
        [
            0xeada7dd6,
            0xcde0eb1e
        ],
        [
            0xf57d4f7f,
            0xee6ed178
        ],
        [
            0x06f067aa,
            0x72176fba
        ],
        [
            0x0a637dc5,
            0xa2c898a6
        ],
        [
            0x113f9804,
            0xbef90dae
        ],
        [
            0x1b710b35,
            0x131c471b
        ],
        [
            0x28db77f5,
            0x23047d84
        ],
        [
            0x32caab7b,
            0x40c72493
        ],
        [
            0x3c9ebe0a,
            0x15c9bebc
        ],
        [
            0x431d67c4,
            0x9c100d4c
        ],
        [
            0x4cc5d4be,
            0xcb3e42b6
        ],
        [
            0x597f299c,
            0xfc657e2a
        ],
        [
            0x5fcb6fab,
            0x3ad6faec
        ],
        [
            0x6c44198c,
            0x4a475817
        ]
    ];
    // initial hash states
    $17272df373da7935$var$_states = {};
    $17272df373da7935$var$_states['SHA-512'] = [
        [
            0x6a09e667,
            0xf3bcc908
        ],
        [
            0xbb67ae85,
            0x84caa73b
        ],
        [
            0x3c6ef372,
            0xfe94f82b
        ],
        [
            0xa54ff53a,
            0x5f1d36f1
        ],
        [
            0x510e527f,
            0xade682d1
        ],
        [
            0x9b05688c,
            0x2b3e6c1f
        ],
        [
            0x1f83d9ab,
            0xfb41bd6b
        ],
        [
            0x5be0cd19,
            0x137e2179
        ]
    ];
    $17272df373da7935$var$_states['SHA-384'] = [
        [
            0xcbbb9d5d,
            0xc1059ed8
        ],
        [
            0x629a292a,
            0x367cd507
        ],
        [
            0x9159015a,
            0x3070dd17
        ],
        [
            0x152fecd8,
            0xf70e5939
        ],
        [
            0x67332667,
            0xffc00b31
        ],
        [
            0x8eb44a87,
            0x68581511
        ],
        [
            0xdb0c2e0d,
            0x64f98fa7
        ],
        [
            0x47b5481d,
            0xbefa4fa4
        ]
    ];
    $17272df373da7935$var$_states['SHA-512/256'] = [
        [
            0x22312194,
            0xFC2BF72C
        ],
        [
            0x9F555FA3,
            0xC84C64C2
        ],
        [
            0x2393B86B,
            0x6F53B151
        ],
        [
            0x96387719,
            0x5940EABD
        ],
        [
            0x96283EE2,
            0xA88EFFE3
        ],
        [
            0xBE5E1E25,
            0x53863992
        ],
        [
            0x2B0199FC,
            0x2C85B8AA
        ],
        [
            0x0EB72DDC,
            0x81C52CA2
        ]
    ];
    $17272df373da7935$var$_states['SHA-512/224'] = [
        [
            0x8C3D37C8,
            0x19544DA2
        ],
        [
            0x73E19966,
            0x89DCD4D6
        ],
        [
            0x1DFAB7AE,
            0x32FF9C82
        ],
        [
            0x679DD514,
            0x582F9FCF
        ],
        [
            0x0F6D2B69,
            0x7BD44DA8
        ],
        [
            0x77E36F73,
            0x04C48942
        ],
        [
            0x3F9D85A8,
            0x6A1D36C8
        ],
        [
            0x1112E6AD,
            0x91D692A1
        ]
    ];
    // now initialized
    $17272df373da7935$var$_initialized = true;
}
/**
 * Updates a SHA-512 state with the given byte buffer.
 *
 * @param s the SHA-512 state to update.
 * @param w the array to use to store words.
 * @param bytes the byte buffer to update with.
 */ function $17272df373da7935$var$_update(s, w, bytes) {
    // consume 512 bit (128 byte) chunks
    var t1_hi, t1_lo;
    var t2_hi, t2_lo;
    var s0_hi, s0_lo;
    var s1_hi, s1_lo;
    var ch_hi, ch_lo;
    var maj_hi, maj_lo;
    var a_hi, a_lo;
    var b_hi, b_lo;
    var c_hi, c_lo;
    var d_hi, d_lo;
    var e_hi, e_lo;
    var f_hi, f_lo;
    var g_hi, g_lo;
    var h_hi, h_lo;
    var i, hi, lo, w2, w7, w15, w16;
    var len = bytes.length();
    while(len >= 128){
        // the w array will be populated with sixteen 64-bit big-endian words
        // and then extended into 64 64-bit words according to SHA-512
        for(i = 0; i < 16; ++i){
            w[i][0] = bytes.getInt32() >>> 0;
            w[i][1] = bytes.getInt32() >>> 0;
        }
        for(; i < 80; ++i){
            // for word 2 words ago: ROTR 19(x) ^ ROTR 61(x) ^ SHR 6(x)
            w2 = w[i - 2];
            hi = w2[0];
            lo = w2[1];
            // high bits
            t1_hi = ((hi >>> 19 | lo << 13) ^ // ROTR 19
            (lo >>> 29 | hi << 3) ^ // ROTR 61/(swap + ROTR 29)
            hi >>> 6) >>> 0; // SHR 6
            // low bits
            t1_lo = ((hi << 13 | lo >>> 19) ^ // ROTR 19
            (lo << 3 | hi >>> 29) ^ // ROTR 61/(swap + ROTR 29)
            (hi << 26 | lo >>> 6)) >>> 0; // SHR 6
            // for word 15 words ago: ROTR 1(x) ^ ROTR 8(x) ^ SHR 7(x)
            w15 = w[i - 15];
            hi = w15[0];
            lo = w15[1];
            // high bits
            t2_hi = ((hi >>> 1 | lo << 31) ^ // ROTR 1
            (hi >>> 8 | lo << 24) ^ // ROTR 8
            hi >>> 7) >>> 0; // SHR 7
            // low bits
            t2_lo = ((hi << 31 | lo >>> 1) ^ // ROTR 1
            (hi << 24 | lo >>> 8) ^ // ROTR 8
            (hi << 25 | lo >>> 7)) >>> 0; // SHR 7
            // sum(t1, word 7 ago, t2, word 16 ago) modulo 2^64 (carry lo overflow)
            w7 = w[i - 7];
            w16 = w[i - 16];
            lo = t1_lo + w7[1] + t2_lo + w16[1];
            w[i][0] = t1_hi + w7[0] + t2_hi + w16[0] + (lo / 0x100000000 >>> 0) >>> 0;
            w[i][1] = lo >>> 0;
        }
        // initialize hash value for this chunk
        a_hi = s[0][0];
        a_lo = s[0][1];
        b_hi = s[1][0];
        b_lo = s[1][1];
        c_hi = s[2][0];
        c_lo = s[2][1];
        d_hi = s[3][0];
        d_lo = s[3][1];
        e_hi = s[4][0];
        e_lo = s[4][1];
        f_hi = s[5][0];
        f_lo = s[5][1];
        g_hi = s[6][0];
        g_lo = s[6][1];
        h_hi = s[7][0];
        h_lo = s[7][1];
        // round function
        for(i = 0; i < 80; ++i){
            // Sum1(e) = ROTR 14(e) ^ ROTR 18(e) ^ ROTR 41(e)
            s1_hi = ((e_hi >>> 14 | e_lo << 18) ^ // ROTR 14
            (e_hi >>> 18 | e_lo << 14) ^ // ROTR 18
            (e_lo >>> 9 | e_hi << 23)) >>> 0; // ROTR 41/(swap + ROTR 9)
            s1_lo = ((e_hi << 18 | e_lo >>> 14) ^ // ROTR 14
            (e_hi << 14 | e_lo >>> 18) ^ // ROTR 18
            (e_lo << 23 | e_hi >>> 9)) >>> 0; // ROTR 41/(swap + ROTR 9)
            // Ch(e, f, g) (optimized the same way as SHA-1)
            ch_hi = (g_hi ^ e_hi & (f_hi ^ g_hi)) >>> 0;
            ch_lo = (g_lo ^ e_lo & (f_lo ^ g_lo)) >>> 0;
            // Sum0(a) = ROTR 28(a) ^ ROTR 34(a) ^ ROTR 39(a)
            s0_hi = ((a_hi >>> 28 | a_lo << 4) ^ // ROTR 28
            (a_lo >>> 2 | a_hi << 30) ^ // ROTR 34/(swap + ROTR 2)
            (a_lo >>> 7 | a_hi << 25)) >>> 0; // ROTR 39/(swap + ROTR 7)
            s0_lo = ((a_hi << 4 | a_lo >>> 28) ^ // ROTR 28
            (a_lo << 30 | a_hi >>> 2) ^ // ROTR 34/(swap + ROTR 2)
            (a_lo << 25 | a_hi >>> 7)) >>> 0; // ROTR 39/(swap + ROTR 7)
            // Maj(a, b, c) (optimized the same way as SHA-1)
            maj_hi = (a_hi & b_hi | c_hi & (a_hi ^ b_hi)) >>> 0;
            maj_lo = (a_lo & b_lo | c_lo & (a_lo ^ b_lo)) >>> 0;
            // main algorithm
            // t1 = (h + s1 + ch + _k[i] + _w[i]) modulo 2^64 (carry lo overflow)
            lo = h_lo + s1_lo + ch_lo + $17272df373da7935$var$_k[i][1] + w[i][1];
            t1_hi = h_hi + s1_hi + ch_hi + $17272df373da7935$var$_k[i][0] + w[i][0] + (lo / 0x100000000 >>> 0) >>> 0;
            t1_lo = lo >>> 0;
            // t2 = s0 + maj modulo 2^64 (carry lo overflow)
            lo = s0_lo + maj_lo;
            t2_hi = s0_hi + maj_hi + (lo / 0x100000000 >>> 0) >>> 0;
            t2_lo = lo >>> 0;
            h_hi = g_hi;
            h_lo = g_lo;
            g_hi = f_hi;
            g_lo = f_lo;
            f_hi = e_hi;
            f_lo = e_lo;
            // e = (d + t1) modulo 2^64 (carry lo overflow)
            lo = d_lo + t1_lo;
            e_hi = d_hi + t1_hi + (lo / 0x100000000 >>> 0) >>> 0;
            e_lo = lo >>> 0;
            d_hi = c_hi;
            d_lo = c_lo;
            c_hi = b_hi;
            c_lo = b_lo;
            b_hi = a_hi;
            b_lo = a_lo;
            // a = (t1 + t2) modulo 2^64 (carry lo overflow)
            lo = t1_lo + t2_lo;
            a_hi = t1_hi + t2_hi + (lo / 0x100000000 >>> 0) >>> 0;
            a_lo = lo >>> 0;
        }
        // update hash state (additional modulo 2^64)
        lo = s[0][1] + a_lo;
        s[0][0] = s[0][0] + a_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[0][1] = lo >>> 0;
        lo = s[1][1] + b_lo;
        s[1][0] = s[1][0] + b_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[1][1] = lo >>> 0;
        lo = s[2][1] + c_lo;
        s[2][0] = s[2][0] + c_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[2][1] = lo >>> 0;
        lo = s[3][1] + d_lo;
        s[3][0] = s[3][0] + d_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[3][1] = lo >>> 0;
        lo = s[4][1] + e_lo;
        s[4][0] = s[4][0] + e_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[4][1] = lo >>> 0;
        lo = s[5][1] + f_lo;
        s[5][0] = s[5][0] + f_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[5][1] = lo >>> 0;
        lo = s[6][1] + g_lo;
        s[6][0] = s[6][0] + g_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[6][1] = lo >>> 0;
        lo = s[7][1] + h_lo;
        s[7][0] = s[7][0] + h_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[7][1] = lo >>> 0;
        len -= 128;
    }
}



/**
 * Copyright (c) 2019 Digital Bazaar, Inc.
 */ var $6dcca70e6e3f65da$export$fed72f95cdc10258;
var $6dcca70e6e3f65da$export$16f1063872153885;

var $cLQG7 = parcelRequire("cLQG7");

var $6dcca70e6e3f65da$var$asn1 = $cLQG7.asn1;
$6dcca70e6e3f65da$export$fed72f95cdc10258 = {
    // PrivateKeyInfo
    name: 'PrivateKeyInfo',
    tagClass: $6dcca70e6e3f65da$var$asn1.Class.UNIVERSAL,
    type: $6dcca70e6e3f65da$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            // Version (INTEGER)
            name: 'PrivateKeyInfo.version',
            tagClass: $6dcca70e6e3f65da$var$asn1.Class.UNIVERSAL,
            type: $6dcca70e6e3f65da$var$asn1.Type.INTEGER,
            constructed: false,
            capture: 'privateKeyVersion'
        },
        {
            // privateKeyAlgorithm
            name: 'PrivateKeyInfo.privateKeyAlgorithm',
            tagClass: $6dcca70e6e3f65da$var$asn1.Class.UNIVERSAL,
            type: $6dcca70e6e3f65da$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: 'AlgorithmIdentifier.algorithm',
                    tagClass: $6dcca70e6e3f65da$var$asn1.Class.UNIVERSAL,
                    type: $6dcca70e6e3f65da$var$asn1.Type.OID,
                    constructed: false,
                    capture: 'privateKeyOid'
                }
            ]
        },
        {
            // PrivateKey
            name: 'PrivateKeyInfo',
            tagClass: $6dcca70e6e3f65da$var$asn1.Class.UNIVERSAL,
            type: $6dcca70e6e3f65da$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: 'privateKey'
        }
    ]
};
$6dcca70e6e3f65da$export$16f1063872153885 = {
    name: 'SubjectPublicKeyInfo',
    tagClass: $6dcca70e6e3f65da$var$asn1.Class.UNIVERSAL,
    type: $6dcca70e6e3f65da$var$asn1.Type.SEQUENCE,
    constructed: true,
    captureAsn1: 'subjectPublicKeyInfo',
    value: [
        {
            name: 'SubjectPublicKeyInfo.AlgorithmIdentifier',
            tagClass: $6dcca70e6e3f65da$var$asn1.Class.UNIVERSAL,
            type: $6dcca70e6e3f65da$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: 'AlgorithmIdentifier.algorithm',
                    tagClass: $6dcca70e6e3f65da$var$asn1.Class.UNIVERSAL,
                    type: $6dcca70e6e3f65da$var$asn1.Type.OID,
                    constructed: false,
                    capture: 'publicKeyOid'
                }
            ]
        },
        // capture group for ed25519PublicKey
        {
            tagClass: $6dcca70e6e3f65da$var$asn1.Class.UNIVERSAL,
            type: $6dcca70e6e3f65da$var$asn1.Type.BITSTRING,
            constructed: false,
            composed: true,
            captureBitStringValue: 'ed25519PublicKey'
        }
    ]
};


var $02d86399422da001$var$publicKeyValidator = $6dcca70e6e3f65da$export$16f1063872153885;
var $02d86399422da001$var$privateKeyValidator = $6dcca70e6e3f65da$export$fed72f95cdc10258;
if (typeof $02d86399422da001$var$BigInteger === 'undefined') var $02d86399422da001$var$BigInteger = $cLQG7.jsbn.BigInteger;
var $02d86399422da001$var$ByteBuffer = $cLQG7.util.ByteBuffer;
var $02d86399422da001$var$NativeBuffer = typeof $02d86399422da001$require$Buffer === 'undefined' ? Uint8Array : $02d86399422da001$require$Buffer;
/*
 * Ed25519 algorithms, see RFC 8032:
 * https://tools.ietf.org/html/rfc8032
 */ $cLQG7.pki = $cLQG7.pki || {};
$02d86399422da001$exports = $cLQG7.pki.ed25519 = $cLQG7.ed25519 = $cLQG7.ed25519 || {};
var $02d86399422da001$var$ed25519 = $cLQG7.ed25519;
$02d86399422da001$var$ed25519.constants = {};
$02d86399422da001$var$ed25519.constants.PUBLIC_KEY_BYTE_LENGTH = 32;
$02d86399422da001$var$ed25519.constants.PRIVATE_KEY_BYTE_LENGTH = 64;
$02d86399422da001$var$ed25519.constants.SEED_BYTE_LENGTH = 32;
$02d86399422da001$var$ed25519.constants.SIGN_BYTE_LENGTH = 64;
$02d86399422da001$var$ed25519.constants.HASH_BYTE_LENGTH = 64;
$02d86399422da001$var$ed25519.generateKeyPair = function(options) {
    options = options || {};
    var seed = options.seed;
    if (seed === undefined) // generate seed
    seed = $cLQG7.random.getBytesSync($02d86399422da001$var$ed25519.constants.SEED_BYTE_LENGTH);
    else if (typeof seed === 'string') {
        if (seed.length !== $02d86399422da001$var$ed25519.constants.SEED_BYTE_LENGTH) throw new TypeError('"seed" must be ' + $02d86399422da001$var$ed25519.constants.SEED_BYTE_LENGTH + ' bytes in length.');
    } else if (!(seed instanceof Uint8Array)) throw new TypeError('"seed" must be a node.js Buffer, Uint8Array, or a binary string.');
    seed = $02d86399422da001$var$messageToNativeBuffer({
        message: seed,
        encoding: 'binary'
    });
    var pk = new $02d86399422da001$var$NativeBuffer($02d86399422da001$var$ed25519.constants.PUBLIC_KEY_BYTE_LENGTH);
    var sk = new $02d86399422da001$var$NativeBuffer($02d86399422da001$var$ed25519.constants.PRIVATE_KEY_BYTE_LENGTH);
    for(var i = 0; i < 32; ++i)sk[i] = seed[i];
    $02d86399422da001$var$crypto_sign_keypair(pk, sk);
    return {
        publicKey: pk,
        privateKey: sk
    };
};
/**
 * Converts a private key from a RFC8410 ASN.1 encoding.
 *
 * @param obj - The asn1 representation of a private key.
 *
 * @returns {Object} keyInfo - The key information.
 * @returns {Buffer|Uint8Array} keyInfo.privateKeyBytes - 32 private key bytes.
 */ $02d86399422da001$var$ed25519.privateKeyFromAsn1 = function(obj) {
    var capture = {};
    var errors = [];
    var valid = $cLQG7.asn1.validate(obj, $02d86399422da001$var$privateKeyValidator, capture, errors);
    if (!valid) {
        var error = new Error('Invalid Key.');
        error.errors = errors;
        throw error;
    }
    var oid = $cLQG7.asn1.derToOid(capture.privateKeyOid);
    var ed25519Oid = $cLQG7.oids.EdDSA25519;
    if (oid !== ed25519Oid) throw new Error('Invalid OID "' + oid + '"; OID must be "' + ed25519Oid + '".');
    var privateKey = capture.privateKey;
    // manually extract the private key bytes from nested octet string, see FIXME:
    // https://github.com/digitalbazaar/forge/blob/master/lib/asn1.js#L542
    var privateKeyBytes = $02d86399422da001$var$messageToNativeBuffer({
        message: $cLQG7.asn1.fromDer(privateKey).value,
        encoding: 'binary'
    });
    // TODO: RFC8410 specifies a format for encoding the public key bytes along
    // with the private key bytes. `publicKeyBytes` can be returned in the
    // future. https://tools.ietf.org/html/rfc8410#section-10.3
    return {
        privateKeyBytes: privateKeyBytes
    };
};
/**
 * Converts a public key from a RFC8410 ASN.1 encoding.
 *
 * @param obj - The asn1 representation of a public key.
 *
 * @return {Buffer|Uint8Array} - 32 public key bytes.
 */ $02d86399422da001$var$ed25519.publicKeyFromAsn1 = function(obj) {
    // get SubjectPublicKeyInfo
    var capture = {};
    var errors = [];
    var valid = $cLQG7.asn1.validate(obj, $02d86399422da001$var$publicKeyValidator, capture, errors);
    if (!valid) {
        var error = new Error('Invalid Key.');
        error.errors = errors;
        throw error;
    }
    var oid = $cLQG7.asn1.derToOid(capture.publicKeyOid);
    var ed25519Oid = $cLQG7.oids.EdDSA25519;
    if (oid !== ed25519Oid) throw new Error('Invalid OID "' + oid + '"; OID must be "' + ed25519Oid + '".');
    var publicKeyBytes = capture.ed25519PublicKey;
    if (publicKeyBytes.length !== $02d86399422da001$var$ed25519.constants.PUBLIC_KEY_BYTE_LENGTH) throw new Error('Key length is invalid.');
    return $02d86399422da001$var$messageToNativeBuffer({
        message: publicKeyBytes,
        encoding: 'binary'
    });
};
$02d86399422da001$var$ed25519.publicKeyFromPrivateKey = function(options) {
    options = options || {};
    var privateKey = $02d86399422da001$var$messageToNativeBuffer({
        message: options.privateKey,
        encoding: 'binary'
    });
    if (privateKey.length !== $02d86399422da001$var$ed25519.constants.PRIVATE_KEY_BYTE_LENGTH) throw new TypeError('"options.privateKey" must have a byte length of ' + $02d86399422da001$var$ed25519.constants.PRIVATE_KEY_BYTE_LENGTH);
    var pk = new $02d86399422da001$var$NativeBuffer($02d86399422da001$var$ed25519.constants.PUBLIC_KEY_BYTE_LENGTH);
    for(var i = 0; i < pk.length; ++i)pk[i] = privateKey[32 + i];
    return pk;
};
$02d86399422da001$var$ed25519.sign = function(options) {
    options = options || {};
    var msg = $02d86399422da001$var$messageToNativeBuffer(options);
    var privateKey = $02d86399422da001$var$messageToNativeBuffer({
        message: options.privateKey,
        encoding: 'binary'
    });
    if (privateKey.length === $02d86399422da001$var$ed25519.constants.SEED_BYTE_LENGTH) {
        var keyPair = $02d86399422da001$var$ed25519.generateKeyPair({
            seed: privateKey
        });
        privateKey = keyPair.privateKey;
    } else if (privateKey.length !== $02d86399422da001$var$ed25519.constants.PRIVATE_KEY_BYTE_LENGTH) throw new TypeError('"options.privateKey" must have a byte length of ' + $02d86399422da001$var$ed25519.constants.SEED_BYTE_LENGTH + ' or ' + $02d86399422da001$var$ed25519.constants.PRIVATE_KEY_BYTE_LENGTH);
    var signedMsg = new $02d86399422da001$var$NativeBuffer($02d86399422da001$var$ed25519.constants.SIGN_BYTE_LENGTH + msg.length);
    $02d86399422da001$var$crypto_sign(signedMsg, msg, msg.length, privateKey);
    var sig = new $02d86399422da001$var$NativeBuffer($02d86399422da001$var$ed25519.constants.SIGN_BYTE_LENGTH);
    for(var i = 0; i < sig.length; ++i)sig[i] = signedMsg[i];
    return sig;
};
$02d86399422da001$var$ed25519.verify = function(options) {
    options = options || {};
    var msg = $02d86399422da001$var$messageToNativeBuffer(options);
    if (options.signature === undefined) throw new TypeError('"options.signature" must be a node.js Buffer, a Uint8Array, a forge ByteBuffer, or a binary string.');
    var sig = $02d86399422da001$var$messageToNativeBuffer({
        message: options.signature,
        encoding: 'binary'
    });
    if (sig.length !== $02d86399422da001$var$ed25519.constants.SIGN_BYTE_LENGTH) throw new TypeError('"options.signature" must have a byte length of ' + $02d86399422da001$var$ed25519.constants.SIGN_BYTE_LENGTH);
    var publicKey = $02d86399422da001$var$messageToNativeBuffer({
        message: options.publicKey,
        encoding: 'binary'
    });
    if (publicKey.length !== $02d86399422da001$var$ed25519.constants.PUBLIC_KEY_BYTE_LENGTH) throw new TypeError('"options.publicKey" must have a byte length of ' + $02d86399422da001$var$ed25519.constants.PUBLIC_KEY_BYTE_LENGTH);
    var sm = new $02d86399422da001$var$NativeBuffer($02d86399422da001$var$ed25519.constants.SIGN_BYTE_LENGTH + msg.length);
    var m = new $02d86399422da001$var$NativeBuffer($02d86399422da001$var$ed25519.constants.SIGN_BYTE_LENGTH + msg.length);
    var i;
    for(i = 0; i < $02d86399422da001$var$ed25519.constants.SIGN_BYTE_LENGTH; ++i)sm[i] = sig[i];
    for(i = 0; i < msg.length; ++i)sm[i + $02d86399422da001$var$ed25519.constants.SIGN_BYTE_LENGTH] = msg[i];
    return $02d86399422da001$var$crypto_sign_open(m, sm, sm.length, publicKey) >= 0;
};
function $02d86399422da001$var$messageToNativeBuffer(options) {
    var message = options.message;
    if (message instanceof Uint8Array || message instanceof $02d86399422da001$var$NativeBuffer) return message;
    var encoding = options.encoding;
    if (message === undefined) {
        if (options.md) {
            // TODO: more rigorous validation that `md` is a MessageDigest
            message = options.md.digest().getBytes();
            encoding = 'binary';
        } else throw new TypeError('"options.message" or "options.md" not specified.');
    }
    if (typeof message === 'string' && !encoding) throw new TypeError('"options.encoding" must be "binary" or "utf8".');
    if (typeof message === 'string') {
        if (typeof $02d86399422da001$require$Buffer !== 'undefined') return $02d86399422da001$require$Buffer.from(message, encoding);
        message = new $02d86399422da001$var$ByteBuffer(message, encoding);
    } else if (!(message instanceof $02d86399422da001$var$ByteBuffer)) throw new TypeError('"options.message" must be a node.js Buffer, a Uint8Array, a forge ByteBuffer, or a string with "options.encoding" specifying its encoding.');
    // convert to native buffer
    var buffer = new $02d86399422da001$var$NativeBuffer(message.length());
    for(var i = 0; i < buffer.length; ++i)buffer[i] = message.at(i);
    return buffer;
}
var $02d86399422da001$var$gf0 = $02d86399422da001$var$gf();
var $02d86399422da001$var$gf1 = $02d86399422da001$var$gf([
    1
]);
var $02d86399422da001$var$D = $02d86399422da001$var$gf([
    0x78a3,
    0x1359,
    0x4dca,
    0x75eb,
    0xd8ab,
    0x4141,
    0x0a4d,
    0x0070,
    0xe898,
    0x7779,
    0x4079,
    0x8cc7,
    0xfe73,
    0x2b6f,
    0x6cee,
    0x5203
]);
var $02d86399422da001$var$D2 = $02d86399422da001$var$gf([
    0xf159,
    0x26b2,
    0x9b94,
    0xebd6,
    0xb156,
    0x8283,
    0x149a,
    0x00e0,
    0xd130,
    0xeef3,
    0x80f2,
    0x198e,
    0xfce7,
    0x56df,
    0xd9dc,
    0x2406
]);
var $02d86399422da001$var$X = $02d86399422da001$var$gf([
    0xd51a,
    0x8f25,
    0x2d60,
    0xc956,
    0xa7b2,
    0x9525,
    0xc760,
    0x692c,
    0xdc5c,
    0xfdd6,
    0xe231,
    0xc0a4,
    0x53fe,
    0xcd6e,
    0x36d3,
    0x2169
]);
var $02d86399422da001$var$Y = $02d86399422da001$var$gf([
    0x6658,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666
]);
var $02d86399422da001$var$L = new Float64Array([
    0xed,
    0xd3,
    0xf5,
    0x5c,
    0x1a,
    0x63,
    0x12,
    0x58,
    0xd6,
    0x9c,
    0xf7,
    0xa2,
    0xde,
    0xf9,
    0xde,
    0x14,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0x10
]);
var $02d86399422da001$var$I = $02d86399422da001$var$gf([
    0xa0b0,
    0x4a0e,
    0x1b27,
    0xc4ee,
    0xe478,
    0xad2f,
    0x1806,
    0x2f43,
    0xd7a7,
    0x3dfb,
    0x0099,
    0x2b4d,
    0xdf0b,
    0x4fc1,
    0x2480,
    0x2b83
]);
// TODO: update forge buffer implementation to use `Buffer` or `Uint8Array`,
// whichever is available, to improve performance
function $02d86399422da001$var$sha512(msg, msgLen) {
    // Note: `out` and `msg` are NativeBuffer
    var md = $cLQG7.md.sha512.create();
    var buffer = new $02d86399422da001$var$ByteBuffer(msg);
    md.update(buffer.getBytes(msgLen), 'binary');
    var hash = md.digest().getBytes();
    if (typeof $02d86399422da001$require$Buffer !== 'undefined') return $02d86399422da001$require$Buffer.from(hash, 'binary');
    var out = new $02d86399422da001$var$NativeBuffer($02d86399422da001$var$ed25519.constants.HASH_BYTE_LENGTH);
    for(var i = 0; i < 64; ++i)out[i] = hash.charCodeAt(i);
    return out;
}
function $02d86399422da001$var$crypto_sign_keypair(pk, sk) {
    var p = [
        $02d86399422da001$var$gf(),
        $02d86399422da001$var$gf(),
        $02d86399422da001$var$gf(),
        $02d86399422da001$var$gf()
    ];
    var i;
    var d = $02d86399422da001$var$sha512(sk, 32);
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    $02d86399422da001$var$scalarbase(p, d);
    $02d86399422da001$var$pack(pk, p);
    for(i = 0; i < 32; ++i)sk[i + 32] = pk[i];
    return 0;
}
// Note: difference from C - smlen returned, not passed as argument.
function $02d86399422da001$var$crypto_sign(sm, m, n, sk) {
    var i, j, x = new Float64Array(64);
    var p = [
        $02d86399422da001$var$gf(),
        $02d86399422da001$var$gf(),
        $02d86399422da001$var$gf(),
        $02d86399422da001$var$gf()
    ];
    var d = $02d86399422da001$var$sha512(sk, 32);
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    var smlen = n + 64;
    for(i = 0; i < n; ++i)sm[64 + i] = m[i];
    for(i = 0; i < 32; ++i)sm[32 + i] = d[32 + i];
    var r = $02d86399422da001$var$sha512(sm.subarray(32), n + 32);
    $02d86399422da001$var$reduce(r);
    $02d86399422da001$var$scalarbase(p, r);
    $02d86399422da001$var$pack(sm, p);
    for(i = 32; i < 64; ++i)sm[i] = sk[i];
    var h = $02d86399422da001$var$sha512(sm, n + 64);
    $02d86399422da001$var$reduce(h);
    for(i = 32; i < 64; ++i)x[i] = 0;
    for(i = 0; i < 32; ++i)x[i] = r[i];
    for(i = 0; i < 32; ++i)for(j = 0; j < 32; j++)x[i + j] += h[i] * d[j];
    $02d86399422da001$var$modL(sm.subarray(32), x);
    return smlen;
}
function $02d86399422da001$var$crypto_sign_open(m, sm, n, pk) {
    var i, mlen;
    var t = new $02d86399422da001$var$NativeBuffer(32);
    var p = [
        $02d86399422da001$var$gf(),
        $02d86399422da001$var$gf(),
        $02d86399422da001$var$gf(),
        $02d86399422da001$var$gf()
    ], q = [
        $02d86399422da001$var$gf(),
        $02d86399422da001$var$gf(),
        $02d86399422da001$var$gf(),
        $02d86399422da001$var$gf()
    ];
    mlen = -1;
    if (n < 64) return -1;
    if ($02d86399422da001$var$unpackneg(q, pk)) return -1;
    for(i = 0; i < n; ++i)m[i] = sm[i];
    for(i = 0; i < 32; ++i)m[i + 32] = pk[i];
    var h = $02d86399422da001$var$sha512(m, n);
    $02d86399422da001$var$reduce(h);
    $02d86399422da001$var$scalarmult(p, q, h);
    $02d86399422da001$var$scalarbase(q, sm.subarray(32));
    $02d86399422da001$var$add(p, q);
    $02d86399422da001$var$pack(t, p);
    n -= 64;
    if ($02d86399422da001$var$crypto_verify_32(sm, 0, t, 0)) {
        for(i = 0; i < n; ++i)m[i] = 0;
        return -1;
    }
    for(i = 0; i < n; ++i)m[i] = sm[i + 64];
    mlen = n;
    return mlen;
}
function $02d86399422da001$var$modL(r, x) {
    var carry, i, j, k;
    for(i = 63; i >= 32; --i){
        carry = 0;
        for(j = i - 32, k = i - 12; j < k; ++j){
            x[j] += carry - 16 * x[i] * $02d86399422da001$var$L[j - (i - 32)];
            carry = x[j] + 128 >> 8;
            x[j] -= carry * 256;
        }
        x[j] += carry;
        x[i] = 0;
    }
    carry = 0;
    for(j = 0; j < 32; ++j){
        x[j] += carry - (x[31] >> 4) * $02d86399422da001$var$L[j];
        carry = x[j] >> 8;
        x[j] &= 255;
    }
    for(j = 0; j < 32; ++j)x[j] -= carry * $02d86399422da001$var$L[j];
    for(i = 0; i < 32; ++i){
        x[i + 1] += x[i] >> 8;
        r[i] = x[i] & 255;
    }
}
function $02d86399422da001$var$reduce(r) {
    var x = new Float64Array(64);
    for(var i = 0; i < 64; ++i){
        x[i] = r[i];
        r[i] = 0;
    }
    $02d86399422da001$var$modL(r, x);
}
function $02d86399422da001$var$add(p, q) {
    var a = $02d86399422da001$var$gf(), b = $02d86399422da001$var$gf(), c = $02d86399422da001$var$gf(), d = $02d86399422da001$var$gf(), e = $02d86399422da001$var$gf(), f = $02d86399422da001$var$gf(), g = $02d86399422da001$var$gf(), h = $02d86399422da001$var$gf(), t = $02d86399422da001$var$gf();
    $02d86399422da001$var$Z(a, p[1], p[0]);
    $02d86399422da001$var$Z(t, q[1], q[0]);
    $02d86399422da001$var$M(a, a, t);
    $02d86399422da001$var$A(b, p[0], p[1]);
    $02d86399422da001$var$A(t, q[0], q[1]);
    $02d86399422da001$var$M(b, b, t);
    $02d86399422da001$var$M(c, p[3], q[3]);
    $02d86399422da001$var$M(c, c, $02d86399422da001$var$D2);
    $02d86399422da001$var$M(d, p[2], q[2]);
    $02d86399422da001$var$A(d, d, d);
    $02d86399422da001$var$Z(e, b, a);
    $02d86399422da001$var$Z(f, d, c);
    $02d86399422da001$var$A(g, d, c);
    $02d86399422da001$var$A(h, b, a);
    $02d86399422da001$var$M(p[0], e, f);
    $02d86399422da001$var$M(p[1], h, g);
    $02d86399422da001$var$M(p[2], g, f);
    $02d86399422da001$var$M(p[3], e, h);
}
function $02d86399422da001$var$cswap(p, q, b) {
    for(var i = 0; i < 4; ++i)$02d86399422da001$var$sel25519(p[i], q[i], b);
}
function $02d86399422da001$var$pack(r, p) {
    var tx = $02d86399422da001$var$gf(), ty = $02d86399422da001$var$gf(), zi = $02d86399422da001$var$gf();
    $02d86399422da001$var$inv25519(zi, p[2]);
    $02d86399422da001$var$M(tx, p[0], zi);
    $02d86399422da001$var$M(ty, p[1], zi);
    $02d86399422da001$var$pack25519(r, ty);
    r[31] ^= $02d86399422da001$var$par25519(tx) << 7;
}
function $02d86399422da001$var$pack25519(o, n) {
    var i, j, b;
    var m = $02d86399422da001$var$gf(), t = $02d86399422da001$var$gf();
    for(i = 0; i < 16; ++i)t[i] = n[i];
    $02d86399422da001$var$car25519(t);
    $02d86399422da001$var$car25519(t);
    $02d86399422da001$var$car25519(t);
    for(j = 0; j < 2; ++j){
        m[0] = t[0] - 0xffed;
        for(i = 1; i < 15; ++i){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $02d86399422da001$var$sel25519(t, m, 1 - b);
    }
    for(i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function $02d86399422da001$var$unpackneg(r, p) {
    var t = $02d86399422da001$var$gf(), chk = $02d86399422da001$var$gf(), num = $02d86399422da001$var$gf(), den = $02d86399422da001$var$gf(), den2 = $02d86399422da001$var$gf(), den4 = $02d86399422da001$var$gf(), den6 = $02d86399422da001$var$gf();
    $02d86399422da001$var$set25519(r[2], $02d86399422da001$var$gf1);
    $02d86399422da001$var$unpack25519(r[1], p);
    $02d86399422da001$var$S(num, r[1]);
    $02d86399422da001$var$M(den, num, $02d86399422da001$var$D);
    $02d86399422da001$var$Z(num, num, r[2]);
    $02d86399422da001$var$A(den, r[2], den);
    $02d86399422da001$var$S(den2, den);
    $02d86399422da001$var$S(den4, den2);
    $02d86399422da001$var$M(den6, den4, den2);
    $02d86399422da001$var$M(t, den6, num);
    $02d86399422da001$var$M(t, t, den);
    $02d86399422da001$var$pow2523(t, t);
    $02d86399422da001$var$M(t, t, num);
    $02d86399422da001$var$M(t, t, den);
    $02d86399422da001$var$M(t, t, den);
    $02d86399422da001$var$M(r[0], t, den);
    $02d86399422da001$var$S(chk, r[0]);
    $02d86399422da001$var$M(chk, chk, den);
    if ($02d86399422da001$var$neq25519(chk, num)) $02d86399422da001$var$M(r[0], r[0], $02d86399422da001$var$I);
    $02d86399422da001$var$S(chk, r[0]);
    $02d86399422da001$var$M(chk, chk, den);
    if ($02d86399422da001$var$neq25519(chk, num)) return -1;
    if ($02d86399422da001$var$par25519(r[0]) === p[31] >> 7) $02d86399422da001$var$Z(r[0], $02d86399422da001$var$gf0, r[0]);
    $02d86399422da001$var$M(r[3], r[0], r[1]);
    return 0;
}
function $02d86399422da001$var$unpack25519(o, n) {
    var i;
    for(i = 0; i < 16; ++i)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $02d86399422da001$var$pow2523(o, i) {
    var c = $02d86399422da001$var$gf();
    var a;
    for(a = 0; a < 16; ++a)c[a] = i[a];
    for(a = 250; a >= 0; --a){
        $02d86399422da001$var$S(c, c);
        if (a !== 1) $02d86399422da001$var$M(c, c, i);
    }
    for(a = 0; a < 16; ++a)o[a] = c[a];
}
function $02d86399422da001$var$neq25519(a, b) {
    var c = new $02d86399422da001$var$NativeBuffer(32);
    var d = new $02d86399422da001$var$NativeBuffer(32);
    $02d86399422da001$var$pack25519(c, a);
    $02d86399422da001$var$pack25519(d, b);
    return $02d86399422da001$var$crypto_verify_32(c, 0, d, 0);
}
function $02d86399422da001$var$crypto_verify_32(x, xi, y, yi) {
    return $02d86399422da001$var$vn(x, xi, y, yi, 32);
}
function $02d86399422da001$var$vn(x, xi, y, yi, n) {
    var i, d = 0;
    for(i = 0; i < n; ++i)d |= x[xi + i] ^ y[yi + i];
    return (1 & d - 1 >>> 8) - 1;
}
function $02d86399422da001$var$par25519(a) {
    var d = new $02d86399422da001$var$NativeBuffer(32);
    $02d86399422da001$var$pack25519(d, a);
    return d[0] & 1;
}
function $02d86399422da001$var$scalarmult(p, q, s) {
    var b, i;
    $02d86399422da001$var$set25519(p[0], $02d86399422da001$var$gf0);
    $02d86399422da001$var$set25519(p[1], $02d86399422da001$var$gf1);
    $02d86399422da001$var$set25519(p[2], $02d86399422da001$var$gf1);
    $02d86399422da001$var$set25519(p[3], $02d86399422da001$var$gf0);
    for(i = 255; i >= 0; --i){
        b = s[i / 8 | 0] >> (i & 7) & 1;
        $02d86399422da001$var$cswap(p, q, b);
        $02d86399422da001$var$add(q, p);
        $02d86399422da001$var$add(p, p);
        $02d86399422da001$var$cswap(p, q, b);
    }
}
function $02d86399422da001$var$scalarbase(p, s) {
    var q = [
        $02d86399422da001$var$gf(),
        $02d86399422da001$var$gf(),
        $02d86399422da001$var$gf(),
        $02d86399422da001$var$gf()
    ];
    $02d86399422da001$var$set25519(q[0], $02d86399422da001$var$X);
    $02d86399422da001$var$set25519(q[1], $02d86399422da001$var$Y);
    $02d86399422da001$var$set25519(q[2], $02d86399422da001$var$gf1);
    $02d86399422da001$var$M(q[3], $02d86399422da001$var$X, $02d86399422da001$var$Y);
    $02d86399422da001$var$scalarmult(p, q, s);
}
function $02d86399422da001$var$set25519(r, a) {
    var i;
    for(i = 0; i < 16; i++)r[i] = a[i] | 0;
}
function $02d86399422da001$var$inv25519(o, i) {
    var c = $02d86399422da001$var$gf();
    var a;
    for(a = 0; a < 16; ++a)c[a] = i[a];
    for(a = 253; a >= 0; --a){
        $02d86399422da001$var$S(c, c);
        if (a !== 2 && a !== 4) $02d86399422da001$var$M(c, c, i);
    }
    for(a = 0; a < 16; ++a)o[a] = c[a];
}
function $02d86399422da001$var$car25519(o) {
    var i, v, c = 1;
    for(i = 0; i < 16; ++i){
        v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $02d86399422da001$var$sel25519(p, q, b) {
    var t, c = ~(b - 1);
    for(var i = 0; i < 16; ++i){
        t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $02d86399422da001$var$gf(init) {
    var i, r = new Float64Array(16);
    if (init) for(i = 0; i < init.length; ++i)r[i] = init[i];
    return r;
}
function $02d86399422da001$var$A(o, a, b) {
    for(var i = 0; i < 16; ++i)o[i] = a[i] + b[i];
}
function $02d86399422da001$var$Z(o, a, b) {
    for(var i = 0; i < 16; ++i)o[i] = a[i] - b[i];
}
function $02d86399422da001$var$S(o, a) {
    $02d86399422da001$var$M(o, a, a);
}
function $02d86399422da001$var$M(o, a, b) {
    var v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}



var $30c66f5e669c27cd$exports = {};
/**
 * Javascript implementation of RSA-KEM.
 *
 * @author Lautaro Cozzani Rodriguez
 * @author Dave Longley
 *
 * Copyright (c) 2014 Lautaro Cozzani <lautaro.cozzani@scytl.com>
 * Copyright (c) 2014 Digital Bazaar, Inc.
 */ 
var $cLQG7 = parcelRequire("cLQG7");



$30c66f5e669c27cd$exports = $cLQG7.kem = $cLQG7.kem || {};
var $30c66f5e669c27cd$var$BigInteger = $cLQG7.jsbn.BigInteger;
/**
 * The API for the RSA Key Encapsulation Mechanism (RSA-KEM) from ISO 18033-2.
 */ $cLQG7.kem.rsa = {};
/**
 * Creates an RSA KEM API object for generating a secret asymmetric key.
 *
 * The symmetric key may be generated via a call to 'encrypt', which will
 * produce a ciphertext to be transmitted to the recipient and a key to be
 * kept secret. The ciphertext is a parameter to be passed to 'decrypt' which
 * will produce the same secret key for the recipient to use to decrypt a
 * message that was encrypted with the secret key.
 *
 * @param kdf the KDF API to use (eg: new forge.kem.kdf1()).
 * @param options the options to use.
 *          [prng] a custom crypto-secure pseudo-random number generator to use,
 *            that must define "getBytesSync".
 */ $cLQG7.kem.rsa.create = function(kdf, options) {
    options = options || {};
    var prng = options.prng || $cLQG7.random;
    var kem = {};
    /**
   * Generates a secret key and its encapsulation.
   *
   * @param publicKey the RSA public key to encrypt with.
   * @param keyLength the length, in bytes, of the secret key to generate.
   *
   * @return an object with:
   *   encapsulation: the ciphertext for generating the secret key, as a
   *     binary-encoded string of bytes.
   *   key: the secret key to use for encrypting a message.
   */ kem.encrypt = function(publicKey, keyLength) {
        // generate a random r where 1 < r < n
        var byteLength = Math.ceil(publicKey.n.bitLength() / 8);
        var r;
        do r = new $30c66f5e669c27cd$var$BigInteger($cLQG7.util.bytesToHex(prng.getBytesSync(byteLength)), 16).mod(publicKey.n);
        while (r.compareTo($30c66f5e669c27cd$var$BigInteger.ONE) <= 0);
        // prepend r with zeros
        r = $cLQG7.util.hexToBytes(r.toString(16));
        var zeros = byteLength - r.length;
        if (zeros > 0) r = $cLQG7.util.fillString(String.fromCharCode(0), zeros) + r;
        // encrypt the random
        var encapsulation = publicKey.encrypt(r, 'NONE');
        // generate the secret key
        var key = kdf.generate(r, keyLength);
        return {
            encapsulation: encapsulation,
            key: key
        };
    };
    /**
   * Decrypts an encapsulated secret key.
   *
   * @param privateKey the RSA private key to decrypt with.
   * @param encapsulation the ciphertext for generating the secret key, as
   *          a binary-encoded string of bytes.
   * @param keyLength the length, in bytes, of the secret key to generate.
   *
   * @return the secret key as a binary-encoded string of bytes.
   */ kem.decrypt = function(privateKey, encapsulation, keyLength) {
        // decrypt the encapsulation and generate the secret key
        var r = privateKey.decrypt(encapsulation, 'NONE');
        return kdf.generate(r, keyLength);
    };
    return kem;
};
// TODO: add forge.kem.kdf.create('KDF1', {md: ..., ...}) API?
/**
 * Creates a key derivation API object that implements KDF1 per ISO 18033-2.
 *
 * @param md the hash API to use.
 * @param [digestLength] an optional digest length that must be positive and
 *          less than or equal to md.digestLength.
 *
 * @return a KDF1 API object.
 */ $cLQG7.kem.kdf1 = function(md, digestLength) {
    $30c66f5e669c27cd$var$_createKDF(this, md, 0, digestLength || md.digestLength);
};
/**
 * Creates a key derivation API object that implements KDF2 per ISO 18033-2.
 *
 * @param md the hash API to use.
 * @param [digestLength] an optional digest length that must be positive and
 *          less than or equal to md.digestLength.
 *
 * @return a KDF2 API object.
 */ $cLQG7.kem.kdf2 = function(md, digestLength) {
    $30c66f5e669c27cd$var$_createKDF(this, md, 1, digestLength || md.digestLength);
};
/**
 * Creates a KDF1 or KDF2 API object.
 *
 * @param md the hash API to use.
 * @param counterStart the starting index for the counter.
 * @param digestLength the digest length to use.
 *
 * @return the KDF API object.
 */ function $30c66f5e669c27cd$var$_createKDF(kdf, md, counterStart, digestLength) {
    /**
   * Generate a key of the specified length.
   *
   * @param x the binary-encoded byte string to generate a key from.
   * @param length the number of bytes to generate (the size of the key).
   *
   * @return the key as a binary-encoded string.
   */ kdf.generate = function(x, length) {
        var key = new $cLQG7.util.ByteBuffer();
        // run counter from counterStart to ceil(length / Hash.len)
        var k = Math.ceil(length / digestLength) + counterStart;
        var c = new $cLQG7.util.ByteBuffer();
        for(var i = counterStart; i < k; ++i){
            // I2OSP(i, 4): convert counter to an octet string of 4 octets
            c.putInt32(i);
            // digest 'x' and the counter and add the result to the key
            md.start();
            md.update(x + c.getBytes());
            var hash = md.digest();
            key.putBytes(hash.getBytes(digestLength));
        }
        // truncate to the correct key length
        key.truncate(key.length() - length);
        return key.getBytes();
    };
}


var $30bd1d91c4c46655$exports = {};
/**
 * Cross-browser support for logging in a web application.
 *
 * @author David I. Lehn <dlehn@digitalbazaar.com>
 *
 * Copyright (c) 2008-2013 Digital Bazaar, Inc.
 */ 
var $cLQG7 = parcelRequire("cLQG7");

/* LOG API */ $30bd1d91c4c46655$exports = $cLQG7.log = $cLQG7.log || {};
/**
 * Application logging system.
 *
 * Each logger level available as it's own function of the form:
 *   forge.log.level(category, args...)
 * The category is an arbitrary string, and the args are the same as
 * Firebug's console.log API. By default the call will be output as:
 *   'LEVEL [category] <args[0]>, args[1], ...'
 * This enables proper % formatting via the first argument.
 * Each category is enabled by default but can be enabled or disabled with
 * the setCategoryEnabled() function.
 */ // list of known levels
$cLQG7.log.levels = [
    'none',
    'error',
    'warning',
    'info',
    'debug',
    'verbose',
    'max'
];
// info on the levels indexed by name:
//   index: level index
//   name: uppercased display name
var $30bd1d91c4c46655$var$sLevelInfo = {};
// list of loggers
var $30bd1d91c4c46655$var$sLoggers = [];
/**
 * Standard console logger. If no console support is enabled this will
 * remain null. Check before using.
 */ var $30bd1d91c4c46655$var$sConsoleLogger = null;
// logger flags
/**
 * Lock the level at the current value. Used in cases where user config may
 * set the level such that only critical messages are seen but more verbose
 * messages are needed for debugging or other purposes.
 */ $cLQG7.log.LEVEL_LOCKED = 2;
/**
 * Always call log function. By default, the logging system will check the
 * message level against logger.level before calling the log function. This
 * flag allows the function to do its own check.
 */ $cLQG7.log.NO_LEVEL_CHECK = 4;
/**
 * Perform message interpolation with the passed arguments. "%" style
 * fields in log messages will be replaced by arguments as needed. Some
 * loggers, such as Firebug, may do this automatically. The original log
 * message will be available as 'message' and the interpolated version will
 * be available as 'fullMessage'.
 */ $cLQG7.log.INTERPOLATE = 8;
// setup each log level
for(var $30bd1d91c4c46655$var$i = 0; $30bd1d91c4c46655$var$i < $cLQG7.log.levels.length; ++$30bd1d91c4c46655$var$i){
    var $30bd1d91c4c46655$var$level = $cLQG7.log.levels[$30bd1d91c4c46655$var$i];
    $30bd1d91c4c46655$var$sLevelInfo[$30bd1d91c4c46655$var$level] = {
        index: $30bd1d91c4c46655$var$i,
        name: $30bd1d91c4c46655$var$level.toUpperCase()
    };
}
/**
 * Message logger. Will dispatch a message to registered loggers as needed.
 *
 * @param message message object
 */ $cLQG7.log.logMessage = function(message) {
    var messageLevelIndex = $30bd1d91c4c46655$var$sLevelInfo[message.level].index;
    for(var i = 0; i < $30bd1d91c4c46655$var$sLoggers.length; ++i){
        var logger = $30bd1d91c4c46655$var$sLoggers[i];
        if (logger.flags & $cLQG7.log.NO_LEVEL_CHECK) logger.f(message);
        else {
            // get logger level
            var loggerLevelIndex = $30bd1d91c4c46655$var$sLevelInfo[logger.level].index;
            // check level
            if (messageLevelIndex <= loggerLevelIndex) // message critical enough, call logger
            logger.f(logger, message);
        }
    }
};
/**
 * Sets the 'standard' key on a message object to:
 * "LEVEL [category] " + message
 *
 * @param message a message log object
 */ $cLQG7.log.prepareStandard = function(message) {
    if (!('standard' in message)) message.standard = $30bd1d91c4c46655$var$sLevelInfo[message.level].name + //' ' + +message.timestamp +
    ' [' + message.category + '] ' + message.message;
};
/**
 * Sets the 'full' key on a message object to the original message
 * interpolated via % formatting with the message arguments.
 *
 * @param message a message log object.
 */ $cLQG7.log.prepareFull = function(message) {
    if (!('full' in message)) {
        // copy args and insert message at the front
        var args = [
            message.message
        ];
        args = args.concat([]);
        // format the message
        message.full = $cLQG7.util.format.apply(this, args);
    }
};
/**
 * Applies both preparseStandard() and prepareFull() to a message object and
 * store result in 'standardFull'.
 *
 * @param message a message log object.
 */ $cLQG7.log.prepareStandardFull = function(message) {
    if (!('standardFull' in message)) {
        // FIXME implement 'standardFull' logging
        $cLQG7.log.prepareStandard(message);
        message.standardFull = message.standard;
    }
};
// levels for which we want functions
var $30bd1d91c4c46655$var$levels = [
    'error',
    'warning',
    'info',
    'debug',
    'verbose'
];
for(var $30bd1d91c4c46655$var$i = 0; $30bd1d91c4c46655$var$i < $30bd1d91c4c46655$var$levels.length; ++$30bd1d91c4c46655$var$i)// wrap in a function to ensure proper level var is passed
(function(level) {
    // create function for this level
    $cLQG7.log[level] = function(category, message /*, args...*/ ) {
        // convert arguments to real array, remove category and message
        var args = Array.prototype.slice.call(arguments).slice(2);
        // create message object
        // Note: interpolation and standard formatting is done lazily
        var msg = {
            timestamp: new Date(),
            level: level,
            category: category,
            message: message,
            'arguments': args
        };
        // process this message
        $cLQG7.log.logMessage(msg);
    };
})($30bd1d91c4c46655$var$levels[$30bd1d91c4c46655$var$i]);
/**
 * Creates a new logger with specified custom logging function.
 *
 * The logging function has a signature of:
 *   function(logger, message)
 * logger: current logger
 * message: object:
 *   level: level id
 *   category: category
 *   message: string message
 *   arguments: Array of extra arguments
 *   fullMessage: interpolated message and arguments if INTERPOLATE flag set
 *
 * @param logFunction a logging function which takes a log message object
 *          as a parameter.
 *
 * @return a logger object.
 */ $cLQG7.log.makeLogger = function(logFunction) {
    var logger = {
        flags: 0,
        f: logFunction
    };
    $cLQG7.log.setLevel(logger, 'none');
    return logger;
};
/**
 * Sets the current log level on a logger.
 *
 * @param logger the target logger.
 * @param level the new maximum log level as a string.
 *
 * @return true if set, false if not.
 */ $cLQG7.log.setLevel = function(logger, level) {
    var rval = false;
    if (logger && !(logger.flags & $cLQG7.log.LEVEL_LOCKED)) for(var i = 0; i < $cLQG7.log.levels.length; ++i){
        var aValidLevel = $cLQG7.log.levels[i];
        if (level == aValidLevel) {
            // set level
            logger.level = level;
            rval = true;
            break;
        }
    }
    return rval;
};
/**
 * Locks the log level at its current value.
 *
 * @param logger the target logger.
 * @param lock boolean lock value, default to true.
 */ $cLQG7.log.lock = function(logger, lock) {
    if (typeof lock === 'undefined' || lock) logger.flags |= $cLQG7.log.LEVEL_LOCKED;
    else logger.flags &= ~$cLQG7.log.LEVEL_LOCKED;
};
/**
 * Adds a logger.
 *
 * @param logger the logger object.
 */ $cLQG7.log.addLogger = function(logger) {
    $30bd1d91c4c46655$var$sLoggers.push(logger);
};
// setup the console logger if possible, else create fake console.log
if (typeof console !== 'undefined' && 'log' in console) {
    var $30bd1d91c4c46655$var$logger;
    if (console.error && console.warn && console.info && console.debug) {
        // looks like Firebug-style logging is available
        // level handlers map
        var $30bd1d91c4c46655$var$levelHandlers = {
            error: console.error,
            warning: console.warn,
            info: console.info,
            debug: console.debug,
            verbose: console.debug
        };
        var $30bd1d91c4c46655$var$f = function(logger, message) {
            $cLQG7.log.prepareStandard(message);
            var handler = $30bd1d91c4c46655$var$levelHandlers[message.level];
            // prepend standard message and concat args
            var args = [
                message.standard
            ];
            args = args.concat(message['arguments'].slice());
            // apply to low-level console function
            handler.apply(console, args);
        };
        $30bd1d91c4c46655$var$logger = $cLQG7.log.makeLogger($30bd1d91c4c46655$var$f);
    } else {
        // only appear to have basic console.log
        var $30bd1d91c4c46655$var$f = function(logger, message) {
            $cLQG7.log.prepareStandardFull(message);
            console.log(message.standardFull);
        };
        $30bd1d91c4c46655$var$logger = $cLQG7.log.makeLogger($30bd1d91c4c46655$var$f);
    }
    $cLQG7.log.setLevel($30bd1d91c4c46655$var$logger, 'debug');
    $cLQG7.log.addLogger($30bd1d91c4c46655$var$logger);
    $30bd1d91c4c46655$var$sConsoleLogger = $30bd1d91c4c46655$var$logger;
} else // define fake console.log to avoid potential script errors on
// browsers that do not have console logging
console = {
    log: function() {}
};
/*
 * Check for logging control query vars in current URL.
 *
 * console.level=<level-name>
 * Set's the console log level by name.  Useful to override defaults and
 * allow more verbose logging before a user config is loaded.
 *
 * console.lock=<true|false>
 * Lock the console log level at whatever level it is set at.  This is run
 * after console.level is processed.  Useful to force a level of verbosity
 * that could otherwise be limited by a user config.
 */ if ($30bd1d91c4c46655$var$sConsoleLogger !== null && typeof window !== 'undefined' && window.location) {
    var $30bd1d91c4c46655$var$query = new URL(window.location.href).searchParams;
    if ($30bd1d91c4c46655$var$query.has('console.level')) // set with last value
    $cLQG7.log.setLevel($30bd1d91c4c46655$var$sConsoleLogger, $30bd1d91c4c46655$var$query.get('console.level').slice(-1)[0]);
    if ($30bd1d91c4c46655$var$query.has('console.lock')) {
        // set with last value
        var $30bd1d91c4c46655$var$lock = $30bd1d91c4c46655$var$query.get('console.lock').slice(-1)[0];
        if ($30bd1d91c4c46655$var$lock == 'true') $cLQG7.log.lock($30bd1d91c4c46655$var$sConsoleLogger);
    }
}
// provide public access to console logger
$cLQG7.log.consoleLogger = $30bd1d91c4c46655$var$sConsoleLogger;


var $d59aa227e7468c15$exports = {};
/**
 * Node.js module for all known Forge message digests.
 *
 * @author Dave Longley
 *
 * Copyright 2011-2017 Digital Bazaar, Inc.
 */ 
$d59aa227e7468c15$exports = (parcelRequire("4pr5e"));











var $18c5bb96a7aaa13d$exports = {};
/**
 * Javascript implementation of PKCS#7 v1.5.
 *
 * @author Stefan Siegl
 * @author Dave Longley
 *
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 * Copyright (c) 2012-2015 Digital Bazaar, Inc.
 *
 * Currently this implementation only supports ContentType of EnvelopedData,
 * EncryptedData, or SignedData at the root level. The top level elements may
 * contain only a ContentInfo of ContentType Data, i.e. plain data. Further
 * nesting is not (yet) supported.
 *
 * The Forge validators for PKCS #7's ASN.1 structures are available from
 * a separate file pkcs7asn1.js, since those are referenced from other
 * PKCS standards like PKCS #12.
 */ 
var $cLQG7 = parcelRequire("cLQG7");









// shortcut for ASN.1 API
var $18c5bb96a7aaa13d$var$asn1 = $cLQG7.asn1;
// shortcut for PKCS#7 API
var $18c5bb96a7aaa13d$var$p7 = $18c5bb96a7aaa13d$exports = $cLQG7.pkcs7 = $cLQG7.pkcs7 || {};
/**
 * Converts a PKCS#7 message from PEM format.
 *
 * @param pem the PEM-formatted PKCS#7 message.
 *
 * @return the PKCS#7 message.
 */ $18c5bb96a7aaa13d$var$p7.messageFromPem = function(pem) {
    var msg = $cLQG7.pem.decode(pem)[0];
    if (msg.type !== 'PKCS7') {
        var error = new Error('Could not convert PKCS#7 message from PEM; PEM header type is not "PKCS#7".');
        error.headerType = msg.type;
        throw error;
    }
    if (msg.procType && msg.procType.type === 'ENCRYPTED') throw new Error('Could not convert PKCS#7 message from PEM; PEM is encrypted.');
    // convert DER to ASN.1 object
    var obj = $18c5bb96a7aaa13d$var$asn1.fromDer(msg.body);
    return $18c5bb96a7aaa13d$var$p7.messageFromAsn1(obj);
};
/**
 * Converts a PKCS#7 message to PEM format.
 *
 * @param msg The PKCS#7 message object
 * @param maxline The maximum characters per line, defaults to 64.
 *
 * @return The PEM-formatted PKCS#7 message.
 */ $18c5bb96a7aaa13d$var$p7.messageToPem = function(msg, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var pemObj = {
        type: 'PKCS7',
        body: $18c5bb96a7aaa13d$var$asn1.toDer(msg.toAsn1()).getBytes()
    };
    return $cLQG7.pem.encode(pemObj, {
        maxline: maxline
    });
};
/**
 * Converts a PKCS#7 message from an ASN.1 object.
 *
 * @param obj the ASN.1 representation of a ContentInfo.
 *
 * @return the PKCS#7 message.
 */ $18c5bb96a7aaa13d$var$p7.messageFromAsn1 = function(obj) {
    // validate root level ContentInfo and capture data
    var capture = {};
    var errors = [];
    if (!$18c5bb96a7aaa13d$var$asn1.validate(obj, $18c5bb96a7aaa13d$var$p7.asn1.contentInfoValidator, capture, errors)) {
        var error = new Error("Cannot read PKCS#7 message. ASN.1 object is not an PKCS#7 ContentInfo.");
        error.errors = errors;
        throw error;
    }
    var contentType = $18c5bb96a7aaa13d$var$asn1.derToOid(capture.contentType);
    var msg;
    switch(contentType){
        case $cLQG7.pki.oids.envelopedData:
            msg = $18c5bb96a7aaa13d$var$p7.createEnvelopedData();
            break;
        case $cLQG7.pki.oids.encryptedData:
            msg = $18c5bb96a7aaa13d$var$p7.createEncryptedData();
            break;
        case $cLQG7.pki.oids.signedData:
            msg = $18c5bb96a7aaa13d$var$p7.createSignedData();
            break;
        default:
            throw new Error('Cannot read PKCS#7 message. ContentType with OID ' + contentType + ' is not (yet) supported.');
    }
    msg.fromAsn1(capture.content.value[0]);
    return msg;
};
$18c5bb96a7aaa13d$var$p7.createSignedData = function() {
    var msg = null;
    msg = {
        type: $cLQG7.pki.oids.signedData,
        version: 1,
        certificates: [],
        crls: [],
        // TODO: add json-formatted signer stuff here?
        signers: [],
        // populated during sign()
        digestAlgorithmIdentifiers: [],
        contentInfo: null,
        signerInfos: [],
        fromAsn1: function(obj) {
            // validate SignedData content block and capture data.
            $18c5bb96a7aaa13d$var$_fromAsn1(msg, obj, $18c5bb96a7aaa13d$var$p7.asn1.signedDataValidator);
            msg.certificates = [];
            msg.crls = [];
            msg.digestAlgorithmIdentifiers = [];
            msg.contentInfo = null;
            msg.signerInfos = [];
            if (msg.rawCapture.certificates) {
                var certs = msg.rawCapture.certificates.value;
                for(var i = 0; i < certs.length; ++i)msg.certificates.push($cLQG7.pki.certificateFromAsn1(certs[i]));
            }
        // TODO: parse crls
        },
        toAsn1: function() {
            // degenerate case with no content
            if (!msg.contentInfo) msg.sign();
            var certs = [];
            for(var i = 0; i < msg.certificates.length; ++i)certs.push($cLQG7.pki.certificateToAsn1(msg.certificates[i]));
            var crls = [];
            // TODO: implement CRLs
            // [0] SignedData
            var signedData = $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.SEQUENCE, true, [
                    // Version
                    $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.INTEGER, false, $18c5bb96a7aaa13d$var$asn1.integerToDer(msg.version).getBytes()),
                    // DigestAlgorithmIdentifiers
                    $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.SET, true, msg.digestAlgorithmIdentifiers),
                    // ContentInfo
                    msg.contentInfo
                ])
            ]);
            if (certs.length > 0) // [0] IMPLICIT ExtendedCertificatesAndCertificates OPTIONAL
            signedData.value[0].value.push($18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, certs));
            if (crls.length > 0) // [1] IMPLICIT CertificateRevocationLists OPTIONAL
            signedData.value[0].value.push($18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.CONTEXT_SPECIFIC, 1, true, crls));
            // SignerInfos
            signedData.value[0].value.push($18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.SET, true, msg.signerInfos));
            // ContentInfo
            return $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.SEQUENCE, true, [
                // ContentType
                $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.OID, false, $18c5bb96a7aaa13d$var$asn1.oidToDer(msg.type).getBytes()),
                // [0] SignedData
                signedData
            ]);
        },
        /**
     * Add (another) entity to list of signers.
     *
     * Note: If authenticatedAttributes are provided, then, per RFC 2315,
     * they must include at least two attributes: content type and
     * message digest. The message digest attribute value will be
     * auto-calculated during signing and will be ignored if provided.
     *
     * Here's an example of providing these two attributes:
     *
     * forge.pkcs7.createSignedData();
     * p7.addSigner({
     *   issuer: cert.issuer.attributes,
     *   serialNumber: cert.serialNumber,
     *   key: privateKey,
     *   digestAlgorithm: forge.pki.oids.sha1,
     *   authenticatedAttributes: [{
     *     type: forge.pki.oids.contentType,
     *     value: forge.pki.oids.data
     *   }, {
     *     type: forge.pki.oids.messageDigest
     *   }]
     * });
     *
     * TODO: Support [subjectKeyIdentifier] as signer's ID.
     *
     * @param signer the signer information:
     *          key the signer's private key.
     *          [certificate] a certificate containing the public key
     *            associated with the signer's private key; use this option as
     *            an alternative to specifying signer.issuer and
     *            signer.serialNumber.
     *          [issuer] the issuer attributes (eg: cert.issuer.attributes).
     *          [serialNumber] the signer's certificate's serial number in
     *           hexadecimal (eg: cert.serialNumber).
     *          [digestAlgorithm] the message digest OID, as a string, to use
     *            (eg: forge.pki.oids.sha1).
     *          [authenticatedAttributes] an optional array of attributes
     *            to also sign along with the content.
     */ addSigner: function(signer) {
            var issuer = signer.issuer;
            var serialNumber = signer.serialNumber;
            if (signer.certificate) {
                var cert = signer.certificate;
                if (typeof cert === 'string') cert = $cLQG7.pki.certificateFromPem(cert);
                issuer = cert.issuer.attributes;
                serialNumber = cert.serialNumber;
            }
            var key = signer.key;
            if (!key) throw new Error('Could not add PKCS#7 signer; no private key specified.');
            if (typeof key === 'string') key = $cLQG7.pki.privateKeyFromPem(key);
            // ensure OID known for digest algorithm
            var digestAlgorithm = signer.digestAlgorithm || $cLQG7.pki.oids.sha1;
            switch(digestAlgorithm){
                case $cLQG7.pki.oids.sha1:
                case $cLQG7.pki.oids.sha256:
                case $cLQG7.pki.oids.sha384:
                case $cLQG7.pki.oids.sha512:
                case $cLQG7.pki.oids.md5:
                    break;
                default:
                    throw new Error('Could not add PKCS#7 signer; unknown message digest algorithm: ' + digestAlgorithm);
            }
            // if authenticatedAttributes is present, then the attributes
            // must contain at least PKCS #9 content-type and message-digest
            var authenticatedAttributes = signer.authenticatedAttributes || [];
            if (authenticatedAttributes.length > 0) {
                var contentType = false;
                var messageDigest = false;
                for(var i = 0; i < authenticatedAttributes.length; ++i){
                    var attr = authenticatedAttributes[i];
                    if (!contentType && attr.type === $cLQG7.pki.oids.contentType) {
                        contentType = true;
                        if (messageDigest) break;
                        continue;
                    }
                    if (!messageDigest && attr.type === $cLQG7.pki.oids.messageDigest) {
                        messageDigest = true;
                        if (contentType) break;
                        continue;
                    }
                }
                if (!contentType || !messageDigest) throw new Error("Invalid signer.authenticatedAttributes. If signer.authenticatedAttributes is specified, then it must contain at least two attributes, PKCS #9 content-type and PKCS #9 message-digest.");
            }
            msg.signers.push({
                key: key,
                version: 1,
                issuer: issuer,
                serialNumber: serialNumber,
                digestAlgorithm: digestAlgorithm,
                signatureAlgorithm: $cLQG7.pki.oids.rsaEncryption,
                signature: null,
                authenticatedAttributes: authenticatedAttributes,
                unauthenticatedAttributes: []
            });
        },
        /**
     * Signs the content.
     * @param options Options to apply when signing:
     *    [detached] boolean. If signing should be done in detached mode. Defaults to false.
     */ sign: function(options) {
            options = options || {};
            // auto-generate content info
            if (typeof msg.content !== 'object' || msg.contentInfo === null) {
                // use Data ContentInfo
                msg.contentInfo = $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.SEQUENCE, true, [
                    // ContentType
                    $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.OID, false, $18c5bb96a7aaa13d$var$asn1.oidToDer($cLQG7.pki.oids.data).getBytes())
                ]);
                // add actual content, if present
                if ('content' in msg) {
                    var content;
                    if (msg.content instanceof $cLQG7.util.ByteBuffer) content = msg.content.bytes();
                    else if (typeof msg.content === 'string') content = $cLQG7.util.encodeUtf8(msg.content);
                    if (options.detached) msg.detachedContent = $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.OCTETSTRING, false, content);
                    else msg.contentInfo.value.push(// [0] EXPLICIT content
                    $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                        $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.OCTETSTRING, false, content)
                    ]));
                }
            }
            // no signers, return early (degenerate case for certificate container)
            if (msg.signers.length === 0) return;
            // generate digest algorithm identifiers
            var mds = addDigestAlgorithmIds();
            // generate signerInfos
            addSignerInfos(mds);
        },
        verify: function() {
            throw new Error('PKCS#7 signature verification not yet implemented.');
        },
        /**
     * Add a certificate.
     *
     * @param cert the certificate to add.
     */ addCertificate: function(cert) {
            // convert from PEM
            if (typeof cert === 'string') cert = $cLQG7.pki.certificateFromPem(cert);
            msg.certificates.push(cert);
        },
        /**
     * Add a certificate revokation list.
     *
     * @param crl the certificate revokation list to add.
     */ addCertificateRevokationList: function(crl) {
            throw new Error('PKCS#7 CRL support not yet implemented.');
        }
    };
    return msg;
    function addDigestAlgorithmIds() {
        var mds = {};
        for(var i = 0; i < msg.signers.length; ++i){
            var signer = msg.signers[i];
            var oid = signer.digestAlgorithm;
            if (!(oid in mds)) // content digest
            mds[oid] = $cLQG7.md[$cLQG7.pki.oids[oid]].create();
            if (signer.authenticatedAttributes.length === 0) // no custom attributes to digest; use content message digest
            signer.md = mds[oid];
            else // custom attributes to be digested; use own message digest
            // TODO: optimize to just copy message digest state if that
            // feature is ever supported with message digests
            signer.md = $cLQG7.md[$cLQG7.pki.oids[oid]].create();
        }
        // add unique digest algorithm identifiers
        msg.digestAlgorithmIdentifiers = [];
        for(var oid in mds)msg.digestAlgorithmIdentifiers.push(// AlgorithmIdentifier
        $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.SEQUENCE, true, [
            // algorithm
            $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.OID, false, $18c5bb96a7aaa13d$var$asn1.oidToDer(oid).getBytes()),
            // parameters (null)
            $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.NULL, false, '')
        ]));
        return mds;
    }
    function addSignerInfos(mds) {
        var content;
        if (msg.detachedContent) // Signature has been made in detached mode.
        content = msg.detachedContent;
        else {
            // Note: ContentInfo is a SEQUENCE with 2 values, second value is
            // the content field and is optional for a ContentInfo but required here
            // since signers are present
            // get ContentInfo content
            content = msg.contentInfo.value[1];
            // skip [0] EXPLICIT content wrapper
            content = content.value[0];
        }
        if (!content) throw new Error('Could not sign PKCS#7 message; there is no content to sign.');
        // get ContentInfo content type
        var contentType = $18c5bb96a7aaa13d$var$asn1.derToOid(msg.contentInfo.value[0].value);
        // serialize content
        var bytes = $18c5bb96a7aaa13d$var$asn1.toDer(content);
        // skip identifier and length per RFC 2315 9.3
        // skip identifier (1 byte)
        bytes.getByte();
        // read and discard length bytes
        $18c5bb96a7aaa13d$var$asn1.getBerValueLength(bytes);
        bytes = bytes.getBytes();
        // digest content DER value bytes
        for(var oid in mds)mds[oid].start().update(bytes);
        // sign content
        var signingTime = new Date();
        for(var i = 0; i < msg.signers.length; ++i){
            var signer = msg.signers[i];
            if (signer.authenticatedAttributes.length === 0) {
                // if ContentInfo content type is not "Data", then
                // authenticatedAttributes must be present per RFC 2315
                if (contentType !== $cLQG7.pki.oids.data) throw new Error("Invalid signer; authenticatedAttributes must be present when the ContentInfo content type is not PKCS#7 Data.");
            } else {
                // process authenticated attributes
                // [0] IMPLICIT
                signer.authenticatedAttributesAsn1 = $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, []);
                // per RFC 2315, attributes are to be digested using a SET container
                // not the above [0] IMPLICIT container
                var attrsAsn1 = $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.SET, true, []);
                for(var ai = 0; ai < signer.authenticatedAttributes.length; ++ai){
                    var attr = signer.authenticatedAttributes[ai];
                    if (attr.type === $cLQG7.pki.oids.messageDigest) // use content message digest as value
                    attr.value = mds[signer.digestAlgorithm].digest();
                    else if (attr.type === $cLQG7.pki.oids.signingTime) // auto-populate signing time if not already set
                    {
                        if (!attr.value) attr.value = signingTime;
                    }
                    // convert to ASN.1 and push onto Attributes SET (for signing) and
                    // onto authenticatedAttributesAsn1 to complete SignedData ASN.1
                    // TODO: optimize away duplication
                    attrsAsn1.value.push($18c5bb96a7aaa13d$var$_attributeToAsn1(attr));
                    signer.authenticatedAttributesAsn1.value.push($18c5bb96a7aaa13d$var$_attributeToAsn1(attr));
                }
                // DER-serialize and digest SET OF attributes only
                bytes = $18c5bb96a7aaa13d$var$asn1.toDer(attrsAsn1).getBytes();
                signer.md.start().update(bytes);
            }
            // sign digest
            signer.signature = signer.key.sign(signer.md, 'RSASSA-PKCS1-V1_5');
        }
        // add signer info
        msg.signerInfos = $18c5bb96a7aaa13d$var$_signersToAsn1(msg.signers);
    }
};
/**
 * Creates an empty PKCS#7 message of type EncryptedData.
 *
 * @return the message.
 */ $18c5bb96a7aaa13d$var$p7.createEncryptedData = function() {
    var msg = null;
    msg = {
        type: $cLQG7.pki.oids.encryptedData,
        version: 0,
        encryptedContent: {
            algorithm: $cLQG7.pki.oids['aes256-CBC']
        },
        /**
     * Reads an EncryptedData content block (in ASN.1 format)
     *
     * @param obj The ASN.1 representation of the EncryptedData content block
     */ fromAsn1: function(obj) {
            // Validate EncryptedData content block and capture data.
            $18c5bb96a7aaa13d$var$_fromAsn1(msg, obj, $18c5bb96a7aaa13d$var$p7.asn1.encryptedDataValidator);
        },
        /**
     * Decrypt encrypted content
     *
     * @param key The (symmetric) key as a byte buffer
     */ decrypt: function(key) {
            if (key !== undefined) msg.encryptedContent.key = key;
            $18c5bb96a7aaa13d$var$_decryptContent(msg);
        }
    };
    return msg;
};
/**
 * Creates an empty PKCS#7 message of type EnvelopedData.
 *
 * @return the message.
 */ $18c5bb96a7aaa13d$var$p7.createEnvelopedData = function() {
    var msg = null;
    msg = {
        type: $cLQG7.pki.oids.envelopedData,
        version: 0,
        recipients: [],
        encryptedContent: {
            algorithm: $cLQG7.pki.oids['aes256-CBC']
        },
        /**
     * Reads an EnvelopedData content block (in ASN.1 format)
     *
     * @param obj the ASN.1 representation of the EnvelopedData content block.
     */ fromAsn1: function(obj) {
            // validate EnvelopedData content block and capture data
            var capture = $18c5bb96a7aaa13d$var$_fromAsn1(msg, obj, $18c5bb96a7aaa13d$var$p7.asn1.envelopedDataValidator);
            msg.recipients = $18c5bb96a7aaa13d$var$_recipientsFromAsn1(capture.recipientInfos.value);
        },
        toAsn1: function() {
            // ContentInfo
            return $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.SEQUENCE, true, [
                // ContentType
                $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.OID, false, $18c5bb96a7aaa13d$var$asn1.oidToDer(msg.type).getBytes()),
                // [0] EnvelopedData
                $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                    $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.SEQUENCE, true, [
                        // Version
                        $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.INTEGER, false, $18c5bb96a7aaa13d$var$asn1.integerToDer(msg.version).getBytes()),
                        // RecipientInfos
                        $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.SET, true, $18c5bb96a7aaa13d$var$_recipientsToAsn1(msg.recipients)),
                        // EncryptedContentInfo
                        $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.SEQUENCE, true, $18c5bb96a7aaa13d$var$_encryptedContentToAsn1(msg.encryptedContent))
                    ])
                ])
            ]);
        },
        /**
     * Find recipient by X.509 certificate's issuer.
     *
     * @param cert the certificate with the issuer to look for.
     *
     * @return the recipient object.
     */ findRecipient: function(cert) {
            var sAttr = cert.issuer.attributes;
            for(var i = 0; i < msg.recipients.length; ++i){
                var r = msg.recipients[i];
                var rAttr = r.issuer;
                if (r.serialNumber !== cert.serialNumber) continue;
                if (rAttr.length !== sAttr.length) continue;
                var match = true;
                for(var j = 0; j < sAttr.length; ++j)if (rAttr[j].type !== sAttr[j].type || rAttr[j].value !== sAttr[j].value) {
                    match = false;
                    break;
                }
                if (match) return r;
            }
            return null;
        },
        /**
     * Decrypt enveloped content
     *
     * @param recipient The recipient object related to the private key
     * @param privKey The (RSA) private key object
     */ decrypt: function(recipient, privKey) {
            if (msg.encryptedContent.key === undefined && recipient !== undefined && privKey !== undefined) switch(recipient.encryptedContent.algorithm){
                case $cLQG7.pki.oids.rsaEncryption:
                case $cLQG7.pki.oids.desCBC:
                    var key = privKey.decrypt(recipient.encryptedContent.content);
                    msg.encryptedContent.key = $cLQG7.util.createBuffer(key);
                    break;
                default:
                    throw new Error("Unsupported asymmetric cipher, OID " + recipient.encryptedContent.algorithm);
            }
            $18c5bb96a7aaa13d$var$_decryptContent(msg);
        },
        /**
     * Add (another) entity to list of recipients.
     *
     * @param cert The certificate of the entity to add.
     */ addRecipient: function(cert) {
            msg.recipients.push({
                version: 0,
                issuer: cert.issuer.attributes,
                serialNumber: cert.serialNumber,
                encryptedContent: {
                    // We simply assume rsaEncryption here, since forge.pki only
                    // supports RSA so far.  If the PKI module supports other
                    // ciphers one day, we need to modify this one as well.
                    algorithm: $cLQG7.pki.oids.rsaEncryption,
                    key: cert.publicKey
                }
            });
        },
        /**
     * Encrypt enveloped content.
     *
     * This function supports two optional arguments, cipher and key, which
     * can be used to influence symmetric encryption.  Unless cipher is
     * provided, the cipher specified in encryptedContent.algorithm is used
     * (defaults to AES-256-CBC).  If no key is provided, encryptedContent.key
     * is (re-)used.  If that one's not set, a random key will be generated
     * automatically.
     *
     * @param [key] The key to be used for symmetric encryption.
     * @param [cipher] The OID of the symmetric cipher to use.
     */ encrypt: function(key, cipher) {
            // Part 1: Symmetric encryption
            if (msg.encryptedContent.content === undefined) {
                cipher = cipher || msg.encryptedContent.algorithm;
                key = key || msg.encryptedContent.key;
                var keyLen, ivLen, ciphFn;
                switch(cipher){
                    case $cLQG7.pki.oids['aes128-CBC']:
                        keyLen = 16;
                        ivLen = 16;
                        ciphFn = $cLQG7.aes.createEncryptionCipher;
                        break;
                    case $cLQG7.pki.oids['aes192-CBC']:
                        keyLen = 24;
                        ivLen = 16;
                        ciphFn = $cLQG7.aes.createEncryptionCipher;
                        break;
                    case $cLQG7.pki.oids['aes256-CBC']:
                        keyLen = 32;
                        ivLen = 16;
                        ciphFn = $cLQG7.aes.createEncryptionCipher;
                        break;
                    case $cLQG7.pki.oids['des-EDE3-CBC']:
                        keyLen = 24;
                        ivLen = 8;
                        ciphFn = $cLQG7.des.createEncryptionCipher;
                        break;
                    default:
                        throw new Error('Unsupported symmetric cipher, OID ' + cipher);
                }
                if (key === undefined) key = $cLQG7.util.createBuffer($cLQG7.random.getBytes(keyLen));
                else if (key.length() != keyLen) throw new Error("Symmetric key has wrong length; got " + key.length() + ' bytes, expected ' + keyLen + '.');
                // Keep a copy of the key & IV in the object, so the caller can
                // use it for whatever reason.
                msg.encryptedContent.algorithm = cipher;
                msg.encryptedContent.key = key;
                msg.encryptedContent.parameter = $cLQG7.util.createBuffer($cLQG7.random.getBytes(ivLen));
                var ciph = ciphFn(key);
                ciph.start(msg.encryptedContent.parameter.copy());
                ciph.update(msg.content);
                // The finish function does PKCS#7 padding by default, therefore
                // no action required by us.
                if (!ciph.finish()) throw new Error('Symmetric encryption failed.');
                msg.encryptedContent.content = ciph.output;
            }
            // Part 2: asymmetric encryption for each recipient
            for(var i = 0; i < msg.recipients.length; ++i){
                var recipient = msg.recipients[i];
                // Nothing to do, encryption already done.
                if (recipient.encryptedContent.content !== undefined) continue;
                switch(recipient.encryptedContent.algorithm){
                    case $cLQG7.pki.oids.rsaEncryption:
                        recipient.encryptedContent.content = recipient.encryptedContent.key.encrypt(msg.encryptedContent.key.data);
                        break;
                    default:
                        throw new Error('Unsupported asymmetric cipher, OID ' + recipient.encryptedContent.algorithm);
                }
            }
        }
    };
    return msg;
};
/**
 * Converts a single recipient from an ASN.1 object.
 *
 * @param obj the ASN.1 RecipientInfo.
 *
 * @return the recipient object.
 */ function $18c5bb96a7aaa13d$var$_recipientFromAsn1(obj) {
    // validate EnvelopedData content block and capture data
    var capture = {};
    var errors = [];
    if (!$18c5bb96a7aaa13d$var$asn1.validate(obj, $18c5bb96a7aaa13d$var$p7.asn1.recipientInfoValidator, capture, errors)) {
        var error = new Error("Cannot read PKCS#7 RecipientInfo. ASN.1 object is not an PKCS#7 RecipientInfo.");
        error.errors = errors;
        throw error;
    }
    return {
        version: capture.version.charCodeAt(0),
        issuer: $cLQG7.pki.RDNAttributesAsArray(capture.issuer),
        serialNumber: $cLQG7.util.createBuffer(capture.serial).toHex(),
        encryptedContent: {
            algorithm: $18c5bb96a7aaa13d$var$asn1.derToOid(capture.encAlgorithm),
            parameter: capture.encParameter ? capture.encParameter.value : undefined,
            content: capture.encKey
        }
    };
}
/**
 * Converts a single recipient object to an ASN.1 object.
 *
 * @param obj the recipient object.
 *
 * @return the ASN.1 RecipientInfo.
 */ function $18c5bb96a7aaa13d$var$_recipientToAsn1(obj) {
    return $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.SEQUENCE, true, [
        // Version
        $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.INTEGER, false, $18c5bb96a7aaa13d$var$asn1.integerToDer(obj.version).getBytes()),
        // IssuerAndSerialNumber
        $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.SEQUENCE, true, [
            // Name
            $cLQG7.pki.distinguishedNameToAsn1({
                attributes: obj.issuer
            }),
            // Serial
            $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.INTEGER, false, $cLQG7.util.hexToBytes(obj.serialNumber))
        ]),
        // KeyEncryptionAlgorithmIdentifier
        $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.SEQUENCE, true, [
            // Algorithm
            $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.OID, false, $18c5bb96a7aaa13d$var$asn1.oidToDer(obj.encryptedContent.algorithm).getBytes()),
            // Parameter, force NULL, only RSA supported for now.
            $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.NULL, false, '')
        ]),
        // EncryptedKey
        $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.OCTETSTRING, false, obj.encryptedContent.content)
    ]);
}
/**
 * Map a set of RecipientInfo ASN.1 objects to recipient objects.
 *
 * @param infos an array of ASN.1 representations RecipientInfo (i.e. SET OF).
 *
 * @return an array of recipient objects.
 */ function $18c5bb96a7aaa13d$var$_recipientsFromAsn1(infos) {
    var ret = [];
    for(var i = 0; i < infos.length; ++i)ret.push($18c5bb96a7aaa13d$var$_recipientFromAsn1(infos[i]));
    return ret;
}
/**
 * Map an array of recipient objects to ASN.1 RecipientInfo objects.
 *
 * @param recipients an array of recipientInfo objects.
 *
 * @return an array of ASN.1 RecipientInfos.
 */ function $18c5bb96a7aaa13d$var$_recipientsToAsn1(recipients) {
    var ret = [];
    for(var i = 0; i < recipients.length; ++i)ret.push($18c5bb96a7aaa13d$var$_recipientToAsn1(recipients[i]));
    return ret;
}
/**
 * Converts a single signer from an ASN.1 object.
 *
 * @param obj the ASN.1 representation of a SignerInfo.
 *
 * @return the signer object.
 */ function $18c5bb96a7aaa13d$var$_signerFromAsn1(obj) {
    // validate EnvelopedData content block and capture data
    var capture = {};
    var errors = [];
    if (!$18c5bb96a7aaa13d$var$asn1.validate(obj, $18c5bb96a7aaa13d$var$p7.asn1.signerInfoValidator, capture, errors)) {
        var error = new Error("Cannot read PKCS#7 SignerInfo. ASN.1 object is not an PKCS#7 SignerInfo.");
        error.errors = errors;
        throw error;
    }
    var rval = {
        version: capture.version.charCodeAt(0),
        issuer: $cLQG7.pki.RDNAttributesAsArray(capture.issuer),
        serialNumber: $cLQG7.util.createBuffer(capture.serial).toHex(),
        digestAlgorithm: $18c5bb96a7aaa13d$var$asn1.derToOid(capture.digestAlgorithm),
        signatureAlgorithm: $18c5bb96a7aaa13d$var$asn1.derToOid(capture.signatureAlgorithm),
        signature: capture.signature,
        authenticatedAttributes: [],
        unauthenticatedAttributes: []
    };
    // TODO: convert attributes
    var authenticatedAttributes = capture.authenticatedAttributes || [];
    var unauthenticatedAttributes = capture.unauthenticatedAttributes || [];
    return rval;
}
/**
 * Converts a single signerInfo object to an ASN.1 object.
 *
 * @param obj the signerInfo object.
 *
 * @return the ASN.1 representation of a SignerInfo.
 */ function $18c5bb96a7aaa13d$var$_signerToAsn1(obj) {
    // SignerInfo
    var rval = $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.SEQUENCE, true, [
        // version
        $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.INTEGER, false, $18c5bb96a7aaa13d$var$asn1.integerToDer(obj.version).getBytes()),
        // issuerAndSerialNumber
        $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.SEQUENCE, true, [
            // name
            $cLQG7.pki.distinguishedNameToAsn1({
                attributes: obj.issuer
            }),
            // serial
            $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.INTEGER, false, $cLQG7.util.hexToBytes(obj.serialNumber))
        ]),
        // digestAlgorithm
        $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.SEQUENCE, true, [
            // algorithm
            $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.OID, false, $18c5bb96a7aaa13d$var$asn1.oidToDer(obj.digestAlgorithm).getBytes()),
            // parameters (null)
            $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.NULL, false, '')
        ])
    ]);
    // authenticatedAttributes (OPTIONAL)
    if (obj.authenticatedAttributesAsn1) // add ASN.1 previously generated during signing
    rval.value.push(obj.authenticatedAttributesAsn1);
    // digestEncryptionAlgorithm
    rval.value.push($18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.SEQUENCE, true, [
        // algorithm
        $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.OID, false, $18c5bb96a7aaa13d$var$asn1.oidToDer(obj.signatureAlgorithm).getBytes()),
        // parameters (null)
        $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.NULL, false, '')
    ]));
    // encryptedDigest
    rval.value.push($18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.OCTETSTRING, false, obj.signature));
    // unauthenticatedAttributes (OPTIONAL)
    if (obj.unauthenticatedAttributes.length > 0) {
        // [1] IMPLICIT
        var attrsAsn1 = $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.CONTEXT_SPECIFIC, 1, true, []);
        for(var i = 0; i < obj.unauthenticatedAttributes.length; ++i){
            var attr = obj.unauthenticatedAttributes[i];
            attrsAsn1.values.push($18c5bb96a7aaa13d$var$_attributeToAsn1(attr));
        }
        rval.value.push(attrsAsn1);
    }
    return rval;
}
/**
 * Map a set of SignerInfo ASN.1 objects to an array of signer objects.
 *
 * @param signerInfoAsn1s an array of ASN.1 SignerInfos (i.e. SET OF).
 *
 * @return an array of signers objects.
 */ function $18c5bb96a7aaa13d$var$_signersFromAsn1(signerInfoAsn1s) {
    var ret = [];
    for(var i = 0; i < signerInfoAsn1s.length; ++i)ret.push($18c5bb96a7aaa13d$var$_signerFromAsn1(signerInfoAsn1s[i]));
    return ret;
}
/**
 * Map an array of signer objects to ASN.1 objects.
 *
 * @param signers an array of signer objects.
 *
 * @return an array of ASN.1 SignerInfos.
 */ function $18c5bb96a7aaa13d$var$_signersToAsn1(signers) {
    var ret = [];
    for(var i = 0; i < signers.length; ++i)ret.push($18c5bb96a7aaa13d$var$_signerToAsn1(signers[i]));
    return ret;
}
/**
 * Convert an attribute object to an ASN.1 Attribute.
 *
 * @param attr the attribute object.
 *
 * @return the ASN.1 Attribute.
 */ function $18c5bb96a7aaa13d$var$_attributeToAsn1(attr) {
    var value;
    // TODO: generalize to support more attributes
    if (attr.type === $cLQG7.pki.oids.contentType) value = $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.OID, false, $18c5bb96a7aaa13d$var$asn1.oidToDer(attr.value).getBytes());
    else if (attr.type === $cLQG7.pki.oids.messageDigest) value = $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.OCTETSTRING, false, attr.value.bytes());
    else if (attr.type === $cLQG7.pki.oids.signingTime) {
        /* Note per RFC 2985: Dates between 1 January 1950 and 31 December 2049
      (inclusive) MUST be encoded as UTCTime. Any dates with year values
      before 1950 or after 2049 MUST be encoded as GeneralizedTime. [Further,]
      UTCTime values MUST be expressed in Greenwich Mean Time (Zulu) and MUST
      include seconds (i.e., times are YYMMDDHHMMSSZ), even where the
      number of seconds is zero.  Midnight (GMT) must be represented as
      "YYMMDD000000Z". */ // TODO: make these module-level constants
        var jan_1_1950 = new Date('1950-01-01T00:00:00Z');
        var jan_1_2050 = new Date('2050-01-01T00:00:00Z');
        var date = attr.value;
        if (typeof date === 'string') {
            // try to parse date
            var timestamp = Date.parse(date);
            if (!isNaN(timestamp)) date = new Date(timestamp);
            else if (date.length === 13) // YYMMDDHHMMSSZ (13 chars for UTCTime)
            date = $18c5bb96a7aaa13d$var$asn1.utcTimeToDate(date);
            else // assume generalized time
            date = $18c5bb96a7aaa13d$var$asn1.generalizedTimeToDate(date);
        }
        if (date >= jan_1_1950 && date < jan_1_2050) value = $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.UTCTIME, false, $18c5bb96a7aaa13d$var$asn1.dateToUtcTime(date));
        else value = $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.GENERALIZEDTIME, false, $18c5bb96a7aaa13d$var$asn1.dateToGeneralizedTime(date));
    }
    // TODO: expose as common API call
    // create a RelativeDistinguishedName set
    // each value in the set is an AttributeTypeAndValue first
    // containing the type (an OID) and second the value
    return $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.SEQUENCE, true, [
        // AttributeType
        $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.OID, false, $18c5bb96a7aaa13d$var$asn1.oidToDer(attr.type).getBytes()),
        $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.SET, true, [
            // AttributeValue
            value
        ])
    ]);
}
/**
 * Map messages encrypted content to ASN.1 objects.
 *
 * @param ec The encryptedContent object of the message.
 *
 * @return ASN.1 representation of the encryptedContent object (SEQUENCE).
 */ function $18c5bb96a7aaa13d$var$_encryptedContentToAsn1(ec) {
    return [
        // ContentType, always Data for the moment
        $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.OID, false, $18c5bb96a7aaa13d$var$asn1.oidToDer($cLQG7.pki.oids.data).getBytes()),
        // ContentEncryptionAlgorithmIdentifier
        $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.SEQUENCE, true, [
            // Algorithm
            $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.OID, false, $18c5bb96a7aaa13d$var$asn1.oidToDer(ec.algorithm).getBytes()),
            // Parameters (IV)
            !ec.parameter ? undefined : $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.OCTETSTRING, false, ec.parameter.getBytes())
        ]),
        // [0] EncryptedContent
        $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
            $18c5bb96a7aaa13d$var$asn1.create($18c5bb96a7aaa13d$var$asn1.Class.UNIVERSAL, $18c5bb96a7aaa13d$var$asn1.Type.OCTETSTRING, false, ec.content.getBytes())
        ])
    ];
}
/**
 * Reads the "common part" of an PKCS#7 content block (in ASN.1 format)
 *
 * This function reads the "common part" of the PKCS#7 content blocks
 * EncryptedData and EnvelopedData, i.e. version number and symmetrically
 * encrypted content block.
 *
 * The result of the ASN.1 validate and capture process is returned
 * to allow the caller to extract further data, e.g. the list of recipients
 * in case of a EnvelopedData object.
 *
 * @param msg the PKCS#7 object to read the data to.
 * @param obj the ASN.1 representation of the content block.
 * @param validator the ASN.1 structure validator object to use.
 *
 * @return the value map captured by validator object.
 */ function $18c5bb96a7aaa13d$var$_fromAsn1(msg, obj, validator) {
    var capture = {};
    var errors = [];
    if (!$18c5bb96a7aaa13d$var$asn1.validate(obj, validator, capture, errors)) {
        var error = new Error("Cannot read PKCS#7 message. ASN.1 object is not a supported PKCS#7 message.");
        error.errors = error;
        throw error;
    }
    // Check contentType, so far we only support (raw) Data.
    var contentType = $18c5bb96a7aaa13d$var$asn1.derToOid(capture.contentType);
    if (contentType !== $cLQG7.pki.oids.data) throw new Error("Unsupported PKCS#7 message. Only wrapped ContentType Data supported.");
    if (capture.encryptedContent) {
        var content = '';
        if ($cLQG7.util.isArray(capture.encryptedContent)) for(var i = 0; i < capture.encryptedContent.length; ++i){
            if (capture.encryptedContent[i].type !== $18c5bb96a7aaa13d$var$asn1.Type.OCTETSTRING) throw new Error("Malformed PKCS#7 message, expecting encrypted content constructed of only OCTET STRING objects.");
            content += capture.encryptedContent[i].value;
        }
        else content = capture.encryptedContent;
        msg.encryptedContent = {
            algorithm: $18c5bb96a7aaa13d$var$asn1.derToOid(capture.encAlgorithm),
            parameter: $cLQG7.util.createBuffer(capture.encParameter.value),
            content: $cLQG7.util.createBuffer(content)
        };
    }
    if (capture.content) {
        var content = '';
        if ($cLQG7.util.isArray(capture.content)) for(var i = 0; i < capture.content.length; ++i){
            if (capture.content[i].type !== $18c5bb96a7aaa13d$var$asn1.Type.OCTETSTRING) throw new Error("Malformed PKCS#7 message, expecting content constructed of only OCTET STRING objects.");
            content += capture.content[i].value;
        }
        else content = capture.content;
        msg.content = $cLQG7.util.createBuffer(content);
    }
    msg.version = capture.version.charCodeAt(0);
    msg.rawCapture = capture;
    return capture;
}
/**
 * Decrypt the symmetrically encrypted content block of the PKCS#7 message.
 *
 * Decryption is skipped in case the PKCS#7 message object already has a
 * (decrypted) content attribute.  The algorithm, key and cipher parameters
 * (probably the iv) are taken from the encryptedContent attribute of the
 * message object.
 *
 * @param The PKCS#7 message object.
 */ function $18c5bb96a7aaa13d$var$_decryptContent(msg) {
    if (msg.encryptedContent.key === undefined) throw new Error('Symmetric key not available.');
    if (msg.content === undefined) {
        var ciph;
        switch(msg.encryptedContent.algorithm){
            case $cLQG7.pki.oids['aes128-CBC']:
            case $cLQG7.pki.oids['aes192-CBC']:
            case $cLQG7.pki.oids['aes256-CBC']:
                ciph = $cLQG7.aes.createDecryptionCipher(msg.encryptedContent.key);
                break;
            case $cLQG7.pki.oids['desCBC']:
            case $cLQG7.pki.oids['des-EDE3-CBC']:
                ciph = $cLQG7.des.createDecryptionCipher(msg.encryptedContent.key);
                break;
            default:
                throw new Error('Unsupported symmetric cipher, OID ' + msg.encryptedContent.algorithm);
        }
        ciph.start(msg.encryptedContent.parameter);
        ciph.update(msg.encryptedContent.content);
        if (!ciph.finish()) throw new Error('Symmetric decryption failed.');
        msg.content = ciph.output;
    }
}








var $83e9ecef59c6add3$exports = {};
/**
 * Functions to output keys in SSH-friendly formats.
 *
 * This is part of the Forge project which may be used under the terms of
 * either the BSD License or the GNU General Public License (GPL) Version 2.
 *
 * See: https://github.com/digitalbazaar/forge/blob/cbebca3780658703d925b61b2caffb1d263a6c1d/LICENSE
 *
 * @author https://github.com/shellac
 */ 
var $cLQG7 = parcelRequire("cLQG7");





var $83e9ecef59c6add3$var$ssh = $83e9ecef59c6add3$exports = $cLQG7.ssh = $cLQG7.ssh || {};
/**
 * Encodes (and optionally encrypts) a private RSA key as a Putty PPK file.
 *
 * @param privateKey the key.
 * @param passphrase a passphrase to protect the key (falsy for no encryption).
 * @param comment a comment to include in the key file.
 *
 * @return the PPK file as a string.
 */ $83e9ecef59c6add3$var$ssh.privateKeyToPutty = function(privateKey, passphrase, comment) {
    comment = comment || '';
    passphrase = passphrase || '';
    var algorithm = 'ssh-rsa';
    var encryptionAlgorithm = passphrase === '' ? 'none' : 'aes256-cbc';
    var ppk = 'PuTTY-User-Key-File-2: ' + algorithm + '\r\n';
    ppk += 'Encryption: ' + encryptionAlgorithm + '\r\n';
    ppk += 'Comment: ' + comment + '\r\n';
    // public key into buffer for ppk
    var pubbuffer = $cLQG7.util.createBuffer();
    $83e9ecef59c6add3$var$_addStringToBuffer(pubbuffer, algorithm);
    $83e9ecef59c6add3$var$_addBigIntegerToBuffer(pubbuffer, privateKey.e);
    $83e9ecef59c6add3$var$_addBigIntegerToBuffer(pubbuffer, privateKey.n);
    // write public key
    var pub = $cLQG7.util.encode64(pubbuffer.bytes(), 64);
    var length = Math.floor(pub.length / 66) + 1; // 66 = 64 + \r\n
    ppk += 'Public-Lines: ' + length + '\r\n';
    ppk += pub;
    // private key into a buffer
    var privbuffer = $cLQG7.util.createBuffer();
    $83e9ecef59c6add3$var$_addBigIntegerToBuffer(privbuffer, privateKey.d);
    $83e9ecef59c6add3$var$_addBigIntegerToBuffer(privbuffer, privateKey.p);
    $83e9ecef59c6add3$var$_addBigIntegerToBuffer(privbuffer, privateKey.q);
    $83e9ecef59c6add3$var$_addBigIntegerToBuffer(privbuffer, privateKey.qInv);
    // optionally encrypt the private key
    var priv;
    if (!passphrase) // use the unencrypted buffer
    priv = $cLQG7.util.encode64(privbuffer.bytes(), 64);
    else {
        // encrypt RSA key using passphrase
        var encLen = privbuffer.length() + 16 - 1;
        encLen -= encLen % 16;
        // pad private key with sha1-d data -- needs to be a multiple of 16
        var padding = $83e9ecef59c6add3$var$_sha1(privbuffer.bytes());
        padding.truncate(padding.length() - encLen + privbuffer.length());
        privbuffer.putBuffer(padding);
        var aeskey = $cLQG7.util.createBuffer();
        aeskey.putBuffer($83e9ecef59c6add3$var$_sha1('\x00\x00\x00\x00', passphrase));
        aeskey.putBuffer($83e9ecef59c6add3$var$_sha1('\x00\x00\x00\x01', passphrase));
        // encrypt some bytes using CBC mode
        // key is 40 bytes, so truncate *by* 8 bytes
        var cipher = $cLQG7.aes.createEncryptionCipher(aeskey.truncate(8), 'CBC');
        cipher.start($cLQG7.util.createBuffer().fillWithByte(0, 16));
        cipher.update(privbuffer.copy());
        cipher.finish();
        var encrypted = cipher.output;
        // Note: this appears to differ from Putty -- is forge wrong, or putty?
        // due to padding we finish as an exact multiple of 16
        encrypted.truncate(16); // all padding
        priv = $cLQG7.util.encode64(encrypted.bytes(), 64);
    }
    // output private key
    length = Math.floor(priv.length / 66) + 1; // 64 + \r\n
    ppk += '\r\nPrivate-Lines: ' + length + '\r\n';
    ppk += priv;
    // MAC
    var mackey = $83e9ecef59c6add3$var$_sha1('putty-private-key-file-mac-key', passphrase);
    var macbuffer = $cLQG7.util.createBuffer();
    $83e9ecef59c6add3$var$_addStringToBuffer(macbuffer, algorithm);
    $83e9ecef59c6add3$var$_addStringToBuffer(macbuffer, encryptionAlgorithm);
    $83e9ecef59c6add3$var$_addStringToBuffer(macbuffer, comment);
    macbuffer.putInt32(pubbuffer.length());
    macbuffer.putBuffer(pubbuffer);
    macbuffer.putInt32(privbuffer.length());
    macbuffer.putBuffer(privbuffer);
    var hmac = $cLQG7.hmac.create();
    hmac.start('sha1', mackey);
    hmac.update(macbuffer.bytes());
    ppk += '\r\nPrivate-MAC: ' + hmac.digest().toHex() + '\r\n';
    return ppk;
};
/**
 * Encodes a public RSA key as an OpenSSH file.
 *
 * @param key the key.
 * @param comment a comment.
 *
 * @return the public key in OpenSSH format.
 */ $83e9ecef59c6add3$var$ssh.publicKeyToOpenSSH = function(key, comment) {
    var type = 'ssh-rsa';
    comment = comment || '';
    var buffer = $cLQG7.util.createBuffer();
    $83e9ecef59c6add3$var$_addStringToBuffer(buffer, type);
    $83e9ecef59c6add3$var$_addBigIntegerToBuffer(buffer, key.e);
    $83e9ecef59c6add3$var$_addBigIntegerToBuffer(buffer, key.n);
    return type + ' ' + $cLQG7.util.encode64(buffer.bytes()) + ' ' + comment;
};
/**
 * Encodes a private RSA key as an OpenSSH file.
 *
 * @param key the key.
 * @param passphrase a passphrase to protect the key (falsy for no encryption).
 *
 * @return the public key in OpenSSH format.
 */ $83e9ecef59c6add3$var$ssh.privateKeyToOpenSSH = function(privateKey, passphrase) {
    if (!passphrase) return $cLQG7.pki.privateKeyToPem(privateKey);
    // OpenSSH private key is just a legacy format, it seems
    return $cLQG7.pki.encryptRsaPrivateKey(privateKey, passphrase, {
        legacy: true,
        algorithm: 'aes128'
    });
};
/**
 * Gets the SSH fingerprint for the given public key.
 *
 * @param options the options to use.
 *          [md] the message digest object to use (defaults to forge.md.md5).
 *          [encoding] an alternative output encoding, such as 'hex'
 *            (defaults to none, outputs a byte buffer).
 *          [delimiter] the delimiter to use between bytes for 'hex' encoded
 *            output, eg: ':' (defaults to none).
 *
 * @return the fingerprint as a byte buffer or other encoding based on options.
 */ $83e9ecef59c6add3$var$ssh.getPublicKeyFingerprint = function(key, options) {
    options = options || {};
    var md = options.md || $cLQG7.md.md5.create();
    var type = 'ssh-rsa';
    var buffer = $cLQG7.util.createBuffer();
    $83e9ecef59c6add3$var$_addStringToBuffer(buffer, type);
    $83e9ecef59c6add3$var$_addBigIntegerToBuffer(buffer, key.e);
    $83e9ecef59c6add3$var$_addBigIntegerToBuffer(buffer, key.n);
    // hash public key bytes
    md.start();
    md.update(buffer.getBytes());
    var digest = md.digest();
    if (options.encoding === 'hex') {
        var hex = digest.toHex();
        if (options.delimiter) return hex.match(/.{2}/g).join(options.delimiter);
        return hex;
    } else if (options.encoding === 'binary') return digest.getBytes();
    else if (options.encoding) throw new Error('Unknown encoding "' + options.encoding + '".');
    return digest;
};
/**
 * Adds len(val) then val to a buffer.
 *
 * @param buffer the buffer to add to.
 * @param val a big integer.
 */ function $83e9ecef59c6add3$var$_addBigIntegerToBuffer(buffer, val) {
    var hexVal = val.toString(16);
    // ensure 2s complement +ve
    if (hexVal[0] >= '8') hexVal = '00' + hexVal;
    var bytes = $cLQG7.util.hexToBytes(hexVal);
    buffer.putInt32(bytes.length);
    buffer.putBytes(bytes);
}
/**
 * Adds len(val) then val to a buffer.
 *
 * @param buffer the buffer to add to.
 * @param val a string.
 */ function $83e9ecef59c6add3$var$_addStringToBuffer(buffer, val) {
    buffer.putInt32(val.length);
    buffer.putString(val);
}
/**
 * Hashes the arguments into one value using SHA-1.
 *
 * @return the sha1 hash of the provided arguments.
 */ function $83e9ecef59c6add3$var$_sha1() {
    var sha = $cLQG7.md.sha1.create();
    var num = arguments.length;
    for(var i = 0; i < num; ++i)sha.update(arguments[i]);
    return sha.digest();
}






let $ffb8a9d70eed30c5$var$_ = (t)=>t, $ffb8a9d70eed30c5$var$t;
const $ffb8a9d70eed30c5$var$Overlay = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($ffb8a9d70eed30c5$var$t || ($ffb8a9d70eed30c5$var$t = $ffb8a9d70eed30c5$var$_`
  position: fixed;
  top: 5%;
  right: 5%;
  z-index: 1000;
  background-color: var(--slate-400);
  padding: 1rem;
  border-radius: 0.5rem;
  border: 1px solid var(--slate-500);
  font-family: monospace;
`));
function $ffb8a9d70eed30c5$var$isAscii(str) {
    return /^[\x20-\x7F]*$/.test(str);
}
function $ffb8a9d70eed30c5$var$startsWithTh(str) {
    return str.startsWith("Th");
}
function $ffb8a9d70eed30c5$var$lengthAtLeast3(str) {
    return str.length >= 3;
}
const $ffb8a9d70eed30c5$var$encryptedBase64 = "U2FsdGVkX19zQCWo/QFwcwv/xn/qeyn6aLGizL9qReGGHNf7J+4+oQOmdnNnY2BmomnJytdKLnuSfLBzNf1Op7mSBSVyNr6ZWiaXnueFojM=";
const $ffb8a9d70eed30c5$var$encryptedData = (0, (/*@__PURE__*/$parcel$interopDefault($0a6ac73f3ed13445$exports))).util.decode64($ffb8a9d70eed30c5$var$encryptedBase64);
function $ffb8a9d70eed30c5$export$b008b3ec6c9c3569() {
    const [status, setStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useState("idle");
    const [decryptedText, setDecryptedText] = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useState(null);
    const tryUUID = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useCallback((uuid)=>{
        setStatus("decrypting");
        try {
            // Check for "Salted__" prefix
            if ($ffb8a9d70eed30c5$var$encryptedData.substring(0, 8) !== "Salted__") throw new Error("Not a valid OpenSSL encrypted file");
            // Extract salt (next 8 bytes)
            const salt = $ffb8a9d70eed30c5$var$encryptedData.substring(8, 16);
            // Derive key and IV (using SHA-256 by default)
            const keySize = 32; // 256 bits
            const ivSize = 16; // 128 bits
            const derivedBytes = (0, (/*@__PURE__*/$parcel$interopDefault($0a6ac73f3ed13445$exports))).pbe.opensslDeriveBytes(uuid, salt, keySize + ivSize, (0, (/*@__PURE__*/$parcel$interopDefault($0a6ac73f3ed13445$exports))).md.sha256.create());
            const key = derivedBytes.substring(0, keySize);
            const iv = derivedBytes.substring(keySize);
            // Create decipher
            const decipher = (0, (/*@__PURE__*/$parcel$interopDefault($0a6ac73f3ed13445$exports))).cipher.createDecipher("AES-CBC", key);
            decipher.start({
                iv: iv
            });
            // Add encrypted data
            decipher.update((0, (/*@__PURE__*/$parcel$interopDefault($0a6ac73f3ed13445$exports))).util.createBuffer($ffb8a9d70eed30c5$var$encryptedData.substring(16)));
            // Finish
            const success = decipher.finish();
            if (success) {
                // Get output
                const decrypted = decipher.output.data;
                if ($ffb8a9d70eed30c5$var$isAscii(decrypted) && $ffb8a9d70eed30c5$var$lengthAtLeast3(decrypted) && $ffb8a9d70eed30c5$var$startsWithTh(decrypted)) {
                    setStatus("success");
                    setDecryptedText(decrypted);
                    return true;
                } else {
                    setDecryptedText("");
                    setStatus("failure");
                    return false;
                }
            } else {
                setDecryptedText("");
                setStatus("failure");
                return false;
            }
        } catch (error) {
            console.error("Decryption error:", error);
            setDecryptedText("");
            setStatus("failure");
            return false;
        }
    }, []);
    return {
        tryUUID: tryUUID,
        status: status,
        decryptedText: decryptedText
    };
}
function $ffb8a9d70eed30c5$var$JokeOverlay({ firstUuid: firstUuid }) {
    const { tryUUID: tryUUID, status: status, decryptedText: decryptedText } = $ffb8a9d70eed30c5$export$b008b3ec6c9c3569();
    (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useEffect(()=>{
        if (firstUuid) tryUUID(firstUuid);
    }, [
        tryUUID,
        firstUuid
    ]);
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($ffb8a9d70eed30c5$var$Overlay, {
        children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("h2", {
                    children: "Find Theo's UUID and Win $1,000!!!"
                }),
                /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)("p", {
                    children: [
                        "Current UUID: ",
                        firstUuid
                    ]
                }),
                /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)("p", {
                    style: {
                        color: status === "success" ? "#016630" : "#fb2c36"
                    },
                    children: [
                        "Decryption Status: ",
                        status
                    ]
                }),
                /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)("p", {
                    children: [
                        "Decrypted Text: ",
                        decryptedText
                    ]
                })
            ]
        })
    });
}
var $ffb8a9d70eed30c5$export$2e2bcd8739ae039 = $ffb8a9d70eed30c5$var$JokeOverlay;


let $9fabe43002b5eff3$var$_ = (t)=>t, $9fabe43002b5eff3$var$t, $9fabe43002b5eff3$var$t1, $9fabe43002b5eff3$var$t2;
const $9fabe43002b5eff3$var$Wrapper = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($9fabe43002b5eff3$var$t || ($9fabe43002b5eff3$var$t = $9fabe43002b5eff3$var$_`
  display: flex;
  flex-direction: row;
  height: 100svh;
  max-height: 100svh;
  height: 100dvh;
  max-height: 100dvh;
  overflow: hidden;
  overscroll-behavior: none;
`));
const $9fabe43002b5eff3$var$HeaderAndContent = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($9fabe43002b5eff3$var$t1 || ($9fabe43002b5eff3$var$t1 = $9fabe43002b5eff3$var$_`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`));
const $9fabe43002b5eff3$var$Content = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($9fabe43002b5eff3$var$t2 || ($9fabe43002b5eff3$var$t2 = $9fabe43002b5eff3$var$_`
  overflow: hidden;
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: 0;
  overscroll-behavior: none;
`));
function $9fabe43002b5eff3$var$App() {
    const [virtualPosition, setVirtualPosition] = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useState(0n);
    const [isAnimating, setIsAnimating] = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useState(false);
    const [targetPosition, setTargetPosition] = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useState(null);
    const [itemsToShow, setItemsToShow] = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useState(40);
    const [search, setSearch] = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useState("");
    const [searchDisplayed, setSearchDisplayed] = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useState(false);
    const [showFavorites, _setShowFavorites] = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useState(false);
    const animationRef = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useRef(null);
    const [favedUUIDs, setFavedUUIDs] = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useState(localStorage.getItem("favedUUIDs") ? JSON.parse(localStorage.getItem("favedUUIDs")) : {});
    const setShowFavorites = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useCallback((value)=>{
        setVirtualPosition(0n);
        _setShowFavorites(value);
    }, [
        _setShowFavorites
    ]);
    const MAX_POSITION = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useMemo(()=>{
        if (showFavorites) {
            const itemsToShowBig = BigInt(itemsToShow);
            const favedUUIDsLength = BigInt(Object.keys(favedUUIDs).length);
            if (favedUUIDsLength > itemsToShowBig) return favedUUIDsLength - itemsToShowBig;
            return 0n;
        } else return (0, $576749860f83a2d7$export$3ee5d4c6315a6ba5) - BigInt(itemsToShow);
    }, [
        itemsToShow,
        showFavorites,
        favedUUIDs
    ]);
    const toggleFavedUUID = (uuid)=>{
        setFavedUUIDs((prev)=>{
            const prevValue = prev[uuid] || false;
            const newValue = !prevValue;
            const newFavedUUIDs = (0, $c28f73f96bffd3b9$export$71511d61b312f219)({}, prev);
            if (newValue) newFavedUUIDs[uuid] = true;
            else delete newFavedUUIDs[uuid];
            localStorage.setItem("favedUUIDs", JSON.stringify(newFavedUUIDs));
            return newFavedUUIDs;
        });
    };
    const animateToPosition = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useCallback((targetPos)=>{
        setTargetPosition(targetPos);
        setIsAnimating(true);
    }, [
        setTargetPosition,
        setIsAnimating
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useEffect(()=>{
        if (isAnimating && targetPosition !== null) {
            const startPosition = virtualPosition;
            const startTime = performance.now();
            const duration = 300;
            const animate = ()=>{
                // we can't use the currentTime provided by animate because it's not guaranteed
                // to be after startTime!
                const currentTime = performance.now();
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const easeProgress = 1 - Math.pow(1 - progress, 4);
                const currentPos = startPosition + (targetPosition - startPosition) * BigInt(Math.floor(easeProgress * 1000)) / 1000n;
                setVirtualPosition(currentPos);
                if (progress < 1) animationRef.current = requestAnimationFrame(animate);
                else {
                    setVirtualPosition(targetPosition);
                    setIsAnimating(false);
                    setTargetPosition(null);
                }
            };
            animationRef.current = requestAnimationFrame(animate);
            return ()=>{
                if (animationRef.current) cancelAnimationFrame(animationRef.current);
            };
        }
    // we intentionally want to save off an "old" copy of virtual position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAnimating,
        targetPosition
    ]);
    const displayedUUIDs = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useMemo(()=>{
        if (showFavorites) {
            const allUUIDs = Object.keys(favedUUIDs).map((uuid)=>{
                const index = (0, $388d8a595f669ae6$export$3f2c080de3c2408d)(uuid);
                if (index === null) {
                    console.error("no index", uuid);
                    return null;
                }
                return {
                    index: index,
                    uuid: uuid
                };
            }).filter((item)=>item !== null).sort((a, b)=>{
                const delta = a.index - b.index;
                if (delta < 0n) return -1;
                if (delta > 0n) return 1;
                return 0;
            });
            let startIndex = virtualPosition;
            let endIndex = startIndex + BigInt(itemsToShow);
            if (startIndex > MAX_POSITION) startIndex = MAX_POSITION;
            return allUUIDs.slice(Number(startIndex), Number(endIndex));
        }
        return Array.from({
            length: itemsToShow
        }, (_, i)=>{
            const index = virtualPosition + BigInt(i);
            if (index < 0n) return null;
            if (index > (0, $576749860f83a2d7$export$3ee5d4c6315a6ba5)) return null;
            const uuid = (0, $388d8a595f669ae6$export$d5290bdca115404)(index);
            if (!uuid) {
                console.error("no uuid", index);
                return null;
            }
            return {
                index: index,
                uuid: uuid
            };
        });
    }, [
        virtualPosition,
        itemsToShow,
        showFavorites,
        favedUUIDs,
        MAX_POSITION
    ]);
    const firstUuid = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useMemo(()=>{
        if (showFavorites) return Object.keys(favedUUIDs)[0];
        return (0, $388d8a595f669ae6$export$d5290bdca115404)(virtualPosition);
    }, [
        virtualPosition,
        showFavorites,
        favedUUIDs
    ]);
    const [browserHash, setBrowserHash] = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useEffect(()=>{
        setBrowserHash(window.location.hash);
        const handleHashChange = ()=>{
            setBrowserHash(window.location.hash);
        };
        window.addEventListener("hashchange", handleHashChange);
        return ()=>{
            window.removeEventListener("hashchange", handleHashChange);
        };
    }, []);
    const hashContainsTheo = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useMemo(()=>{
        if (!browserHash) return false;
        const hash = browserHash.slice(1);
        return hash.includes("theo");
    }, [
        browserHash
    ]);
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)((0, $fe3e626085e1e6b8$exports.Fragment), {
        children: [
            hashContainsTheo && /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $ffb8a9d70eed30c5$export$2e2bcd8739ae039), {
                firstUuid: firstUuid
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $8c61e0cf04238a32$export$2e2bcd8739ae039), {
                animateToPosition: animateToPosition,
                virtualPosition: virtualPosition,
                setVirtualPosition: setVirtualPosition,
                search: search,
                setSearch: setSearch,
                searchDisplayed: searchDisplayed,
                setSearchDisplayed: setSearchDisplayed,
                displayedUUIDs: displayedUUIDs,
                MAX_POSITION: MAX_POSITION
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $5a79d22fa1db84b7$export$2e2bcd8739ae039), {
                setShowFavorites: setShowFavorites,
                isShowingFavorites: showFavorites
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)($9fabe43002b5eff3$var$Wrapper, {
                children: [
                    /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)($9fabe43002b5eff3$var$HeaderAndContent, {
                        children: [
                            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $9af4149271f95228$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($9fabe43002b5eff3$var$Content, {
                                children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $27f2fa6d4ea1c25e$export$2e2bcd8739ae039), {
                                    itemsToShow: itemsToShow,
                                    setItemsToShow: setItemsToShow,
                                    virtualPosition: virtualPosition,
                                    setVirtualPosition: setVirtualPosition,
                                    favedUUIDs: favedUUIDs,
                                    toggleFavedUUID: toggleFavedUUID,
                                    isAnimating: isAnimating,
                                    MAX_POSITION: MAX_POSITION,
                                    animateToPosition: animateToPosition,
                                    search: search,
                                    searchDisplayed: searchDisplayed,
                                    displayedUUIDs: displayedUUIDs
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $bb235d2f1f0411d2$export$2e2bcd8739ae039), {
                        virtualPosition: virtualPosition,
                        MAX_POSITION: MAX_POSITION,
                        animateToPosition: animateToPosition,
                        setVirtualPosition: setVirtualPosition,
                        setIsAnimating: setIsAnimating
                    })
                ]
            })
        ]
    });
}
var $9fabe43002b5eff3$export$2e2bcd8739ae039 = $9fabe43002b5eff3$var$App;




const $a1f42903098844e9$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($8779a10718613263$exports))).createRoot(document.getElementById('root'));
$a1f42903098844e9$var$root.render(/*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $9fabe43002b5eff3$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=index.f53b98a8.js.map
